// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2724%27 viewBox=%270 0 16 24%27><path fill=%27%23ffffff%27 d=%27M16.59,8.59,12,13.17,7.41,8.59,6,10l6,6,6-6Z%27 style=%27transform: rotate%2890deg%29; transform-origin: center center;%27 /></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.icon-key {
    float: left;
    margin-top: 0
}

.key-item {
    margin: 1em 0
}

.key-item span:before {
    font-size: 20px
}


.add-outlook a {
    font-size: 0
}



.add-outlook a::before {
    background: #ffbc00;
    color: #fff;
    font-size: 20px;
    width: 21px;
    height: 21px;
    text-align: center;
    padding-top: 5px;
    margin-right: 5px;
    padding-left: 5px
}

.add-gcal a {
    font-size: 0
}

.add-gcal a::before {
    background: #dd4b39;
    color: #fff;
    font-size: 20px;
    width: 21px;
    height: 21px;
    text-align: center;
    padding-top: 5px;
    margin-right: 5px;
    padding-left: 5px
}


.right-arrow::before {
    font-size: 14px
}

.up-arrow::before {
    font-size: 14px
}

.ndqicon-check-circle::before,.thank-you-page h1::before {
    font-size: 22px
}

a.show-all::after {
    font-size: 14px
}

a.show-all.hide-all::after {
    font-size: 14px
}


.faq-acc-dl dt::before,.faq-acc-dl .acc-title::before,.acc-wrap dt::before,.acc-wrap .acc-title::before {
    color: #fff;
    font-size: 14px
}

.faq-acc-dl dt.opened::before,.faq-acc-dl .acc-title.opened::before,.acc-wrap dt.opened::before,.acc-wrap .acc-title.opened::before {
    color: #fff;
    font-size: 14px
}

.top-link::after {
    font-size: 14px;
    margin-top: -4px
}

.file--mime-application-pdf a,.webcast-link a,.file--mime-application-rtf a,.file--mime-application-vnd-ms-excel a,.html-link a:before,.file--mime-application-xml a,.field--name-field-nir-ext-document a,.file--mime-text-csv a {
    text-decoration: none !important
}

.file--mime-application-pdf a:hover,.webcast-link a:hover,.file--mime-application-rtf a:hover,.file--mime-application-vnd-ms-excel a:hover,.html-link a:hover,.file--mime-application-xml a:hover,.field--name-field-nir-ext-document a:hover,.file--mime-text-csv a:hover {
    text-decoration: none !important
}

.file--mime-application-pdf a span,.webcast-link a span,.file--mime-application-rtf a span,.file--mime-application-vnd-ms-excel a span,.html-link a span,.file--mime-application-xml a span,.field--name-field-nir-ext-document a span,.file--mime-text-csv a span,.file--mime-application-pdf a:hover span,.webcast-link a:hover span,.file--mime-application-rtf a:hover span,.file--mime-application-vnd-ms-excel a:hover span,.html-link a:hover span,.file--mime-application-xml a:hover span,.field--name-field-nir-ext-document a:hover span,.file--mime-text-csv a:hover span {
    text-decoration: none
}

.visually-hidden,.toolbar-bar li>ul,.toolbar-item>ul {
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px)
}

.visually-hidden--off,.toolbar-bar li>ul--off,.toolbar-item>ul--off {
    clip: auto;
    height: auto;
    width: auto;
    overflow: auto
}

.toolbar-bar li>ul.visually-hidden--off,.toolbar-item>ul.visually-hidden--off {
    clip: auto;
    height: auto;
    width: auto;
    overflow: auto
}

.toolbar--wrapper div,.toolbar--wrapper ul,.toolbar--wrapper li,.toolbar--wrapper a {
    font-size: 14px;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important
}

.toolbar--wrapper a:link,.toolbar--wrapper a:visited {
    color: #009ec2;
    font-weight: normal
}

.toolbar--wrapper a:link.bold-link,.toolbar--wrapper a:visited.bold-link {
    font-weight: bold
}

.toolbar-bar {
    background: #1d1e25 !important;
    height: 56px !important
}

.toolbar-bar a:focus {
    text-decoration: none !important
}

.toolbar-bar .nir-menu>li {
    display: inline-block !important;
    padding: 0px !important;
    text-align: left !important;
    margin: 0px !important
}

.toolbar-bar .nir-menu>li.nir-menu-item--expanded>a::after {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: color("white")
}

.toolbar-bar .nir-menu>li.nir-menu-item--expanded>a::after {
    font-size: 16px !important
}

.toolbar-bar .nir-menu>li.nir-menu-item--expanded>a:hover::after {
    color: #00bce3 !important
}

.toolbar-bar .nir-menu>li a {
    color: #fff !important;
    font-size: 1.15em !important;
    line-height: 1 !important;
    padding: 19px 7px !important;
    transition: all .15s ease-in-out !important;
    text-decoration: none !important;
    display: block !important;
    text-align: left !important;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    margin: 0px !important
}

.toolbar-bar .nir-menu>li a:hover {
    color: #00bce3 !important;
    text-decoration: none !important
}

.toolbar-bar .nir-menu>li a.menu-open {
    background-color: #111217 !important;
    color: #00bce3 !important;
    text-decoration: none !important
}

.toolbar-bar .nir-menu>li a.menu-open::after {
    color: #00bce3 !important
}

.toolbar-bar .nir-menu>li ul {
    box-shadow: 0 5px 10px rgba(0,0,0,.2) !important;
    background: #fff !important;
    position: absolute !important;
    padding-top: 3px !important;
    margin: 0px !important;
    width: 200px !important;
    padding-left: 0px !important
}

.toolbar-bar .nir-menu>li ul li {
    float: left !important;
    width: 100% !important;
    margin: 0px !important
}

.toolbar-bar .nir-menu>li ul li:hover {
    background: #459699 !important
}

.toolbar-bar .nir-menu>li ul li:hover a {
    color: #fff !important;
    transition: none !important
}

.toolbar-bar .nir-menu>li ul a {
    color: #333 !important;
    font-size: 14px !important;
    padding: 10px 20px !important
}

.toolbar-bar .nir-menu>li.nir-menu-item--site-status a:hover {
    color: #fff !important
}

.toolbar-bar .nir-menu>li.nir-menu-item--site-status--secondary a {
    color: #000 !important
}

.toolbar-bar>.nir-menu {
    display: inline !important;
    font-size: 14px !important;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    margin: 0 !important;
    line-height: 56px !important;
    float: left !important;
    padding-left: 0 !important
}

.toolbar-bar>.nir-menu>li:first-child a {
    padding-left: 15px !important
}

.nir-toolbar {
    -webkit-font-smoothing: antialiased !important;
    position: relative !important;
    z-index: 2147483647 !important;
    box-shadow: -1px 0 3px 1px rgba(0,0,0,.333) !important;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important
}

.nir-toolbar a.menu-open {
    background-color: #111217 !important;
    color: #00bce3 !important;
    text-decoration: none !important
}

.nir-toolbar a.menu-open::after {
    color: #00bce3 !important
}

.nir-toolbar .toolbar-item {
    position: relative !important;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    float: left !important;
    height: 56px !important;
    padding: 0px !important
}

.nir-toolbar .toolbar-item h2,.nir-toolbar .toolbar-item h3 {
    display: inline-block !important;
    margin: 10px 0 !important
}

.nir-toolbar .toolbar-item>a {
    display: inline-block !important;
    padding: 20px 14px !important;
    color: #fff !important;
    font-size: 1.15em !important;
    font-weight: normal !important;
    line-height: 1 !important;
    transition: all .15s ease-in-out !important
}

.nir-toolbar .toolbar-item>a:hover {
    color: #00bce3 !important;
    text-decoration: none !important
}

.nir-toolbar .toolbar-item ul {
    font-size: 12px !important;
    font-weight: normal !important;
    box-shadow: 0 5px 10px rgba(0,0,0,.2) !important;
    background: #fff !important;
    position: absolute !important;
    right: 0 !important;
    padding-top: 0 !important;
    padding-left: 0 !important;
    margin-top: 1px !important;
    width: 200px !important;
    overflow: hidden !important
}

.nir-toolbar .toolbar-item ul li {
    float: left !important;
    width: 100% !important;
    color: #333 !important
}

.nir-toolbar .toolbar-item ul li .image-style-nir-toolbar-profile {
    float: left !important;
    margin-left: 20px !important
}

.nir-toolbar .toolbar-item ul li .profile-info {
    float: left !important;
    width: 145px !important
}

.nir-toolbar .toolbar-item ul li .profile-info .menu-email {
    font-size: 12px !important
}

.nir-toolbar .toolbar-item ul li .profile-info .user-name {
    font-size: 14px !important;
    margin-bottom: 5px !important
}

.nir-toolbar .toolbar-item ul li a {
    color: #333 !important;
    padding: 10px 20px !important;
    display: block !important
}

.nir-toolbar .toolbar-item ul li:hover {
    background: #459699 !important
}

.nir-toolbar .toolbar-item ul li:hover a {
    color: #fff !important;
    transition: none !important;
    text-decoration: none !important
}

.nir-toolbar .toolbar-item ul .user-profile-item {
    background-color: #eee;
    padding: 20px 0 !important
}

.nir-toolbar .toolbar-item ul .user-profile-item a {
    padding: 0 !important;
    line-height: 13px !important
}

.nir-toolbar .toolbar-item ul .user-profile-item:hover {
    background-color: #eee !important;
    cursor: default !important
}

.nir-toolbar .toolbar-item.user-tab>a {
    padding: 10px 14px !important
}

.nir-toolbar .toolbar-item.user-tab>a .user-name-tab {
    text-indent: -9999px !important
}

.nir-toolbar .toolbar-item.user-tab ul {
    width: 250px !important
}

.nir-toolbar .toolbar-item.user-tab div {
    display: inline-block !important
}

.nir-toolbar .toolbar-item.help-tab>a {
    color: #1d1e25 !important;
    padding: 16px 14px !important;
    border-right: 1px solid #474a53 !important;
    border-left: 1px solid #474a53 !important
}

.nir-toolbar .toolbar-item.help-tab>a:hover {
    color: #3f878a !important
}

.nir-toolbar .toolbar-item.help-tab>a>span {
    border-radius: 50% !important;
    background: #fff !important;
    height: 24px !important;
    width: 24px !important;
    display: block !important;
    padding-left: 2px !important;
    padding-top: 2px !important
}

.nir-toolbar .toolbar-item.help-tab>a>span::after {
    content: "î‚³";
    display: inline-block;
    text-decoration: none;
    color: color("nir_toolbar_grey")
}

.nir-toolbar .toolbar-item.help-tab>a>span:hover::after {
    color: #459699 !important
}

.nir-toolbar .toolbar-item.help-tab>a>span::after {
    font-size: 20px !important
}

.nir-toolbar .toolbar-item.help-tab>a>span span {
    display: none
}

.nir-toolbar .toolbar-item.local-tasks-tab>a {
    color: #1d1e25 !important;
    padding: 0 !important;
    border-right: 1px solid #474a53 !important;
    border-left: 1px solid #474a53 !important
}

.nir-toolbar .toolbar-item.local-tasks-tab>a:hover {
    color: #459699 !important
}

.nir-toolbar .toolbar-item.local-tasks-tab>a.menu-open>span::after {
    color: #3f878a !important;
    transform: rotate(45deg) !important
}

.nir-toolbar .toolbar-item.local-tasks-tab>a>span {
    height: 46px !important;
    width: 54px !important;
    display: block !important
}

.nir-toolbar .toolbar-item.local-tasks-tab>a>span::after {
    content: "âœ";
    display: inline-block;
    text-decoration: none;
    color: color("nir_toolbar_grey")
}

.nir-toolbar .toolbar-item.local-tasks-tab>a>span:hover::after {
    color: #3f878a !important
}

.nir-toolbar .toolbar-item.local-tasks-tab>a>span::after {
    font-size: 40px !important;
    color: #fff !important;
    transform: rotate(-45deg) !important;
    transition: transform .5s;
    margin: 10px 8px 11px 8px !important;
    height: 35px !important;
    line-height: 21px;
    width: 35px !important;
    text-align: center;
    align-items: center;
    margin-top: -9px;
    display: block;
    padding: 0 !important
}

.nir-toolbar .toolbar-item.local-tasks-tab>a>span span {
    display: none !important
}

.nir-toolbar .toolbar-bar .nir-toolbar-tab>.toolbar-item:hover,.nir-toolbar .toolbar-bar .nir-toolbar-tab>.toolbar-item:hover {
    background-color: #111217 !important;
    background-image: none !important
}

.nir-toolbar .site-name-tab {
    border-top-style: solid !important;
    border-top-width: 4px !important
}

.nir-toolbar .site-name-tab.secondary {
    border-top-color: #fd0 !important
}

.nir-toolbar .site-name-tab.primary {
    border-top-color: #19b772 !important
}

.nir-toolbar .site-name-tab.local {
    border-top-color: #da353b
}

.nir-toolbar .site-name-tab>a {
    padding: 16px 4px 19px 10px !important;
    font-size: 1em !important
}

.nir-toolbar .site-name-tab>a::after {
    content: "î€’";
    display: inline-block;
    text-decoration: none;
    color: color("white")
}

.nir-toolbar .site-name-tab>a::after {
    font-size: 14px !important
}

.nir-toolbar .site-name-tab>a:hover::after {
    color: #3f878a !important
}

.local-tasks-sidebar--wrapper {
    position: absolute;
    right: 0;
    width: 200px;
    background: #eee;
    z-index: 100;
    transition-property: width;
    transition-delay: .4s;
    bottom: 0;
    top: 93px
}

.local-tasks-sidebar--wrapper.toolbar--closed {
    top: 0
}

.local-tasks-sidebar--wrapper--closed {
    width: 0
}

.local-tasks-sidebar--wrapper--open {
    box-shadow: -3px 0 3px 1px rgba(0,0,0,.333) !important
}

.local-tasks-sidebar--wrapper .menu-local-tasks--nir {
    padding: 15px
}

.local-tasks-sidebar--wrapper .tabs.primary {
    margin-top: 15px
}

.local-tasks-sidebar--wrapper .tabs.primary a {
    background: none
}

.local-tasks-sidebar--wrapper .tabs.primary .tabs__tab.is-active {
    border-radius: 0
}

.local-tasks-sidebar--wrapper .tabs.primary .tabs__tab.is-active a {
    color: #111217
}

.local-tasks-sidebar--wrapper .tabs.primary .tabs__tab {
    background: #fefefe;
    border: 0;
    margin: 5px 0;
    text-align: center
}



#toolbar-item-administration {
    margin-left: 4px !important;
    border-left: 1px solid #666 !important
}

.image-style-nir-toolbar-profile {
    display: inline-block !important;
    height: 35px !important;
    width: 35px !important;
    margin: 0 4px !important;
    overflow: hidden !important;
    border-radius: 50% !important;
    vertical-align: middle !important
}

.image-style-nir-toolbar-profile.empty-image {
    border: 1px solid #fff !important
}

.image-style-nir-toolbar-profile.empty-image::after {
    content: "î€‹";
    display: inline-block;
    text-decoration: none;
    color: color(blue)
}

.image-style-nir-toolbar-profile.empty-image::after {
    color: #fff !important;
    font-size: 50px !important;
    margin-left: -9px !important;
    margin-top: -6px !important
}

.user-profile-item .image-style-nir-toolbar-profile.empty-image {
    border: 1px solid #ccc !important
}

.user-profile-item .image-style-nir-toolbar-profile::after {
    color: #ccc !important;
    margin-left: -9px !important;
    margin-top: 13px !important
}

.secondary-toolbar {
    padding: 10px !important;
    font-size: 16px !important;
    width: 100% !important;
    position: relative !important;
    right: 0 !important;
    left: 0 !important;
    top: 0 !important;
    z-index: 500 !important;
    height: 37px !important
}

.secondary-toolbar div,.secondary-toolbar span,.secondary-toolbar a {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    font-size: 1em !important
}

.secondary-toolbar .environment {
    float: left !important;
    font-size: 1em !important
}

.secondary-toolbar--local {
    background: #f05b5b !important;
    color: #fff !important
}

.secondary-toolbar--uat {
    background: #37b777 !important;
    color: #fff !important
}

.secondary-toolbar--test {
    background: #459699 !important;
    color: #fff !important
}

.secondary-toolbar--dev {
    background: #c042f8 !important;
    color: #fff !important
}

.secondary-toolbar--nasdaqbeta {
    background: #fecb24 !important
}

@media only screen and (max-width: 500px) {
    .secondary-toolbar .environment {
        display:none !important
    }
}

.nir-menu-item--site-status {
    pointer-events: none !important;
    cursor: default !important
}

.nir-menu-item--site-status--secondary {
    background: #fecb24 !important
}

.nir-menu-item--site-status--primary {
    background: #37b777 !important
}


.secondary-toolbar .nir-notification--text {
    margin-left: 3px !important;
    font-size: .8em !important
}

.nir-notification--text {
    margin-left: 3px !important
}

.nir-notification--status {
    border-radius: 50% !important;
    display: inline-block !important;
    width: 10px !important;
    height: 10px !important;
    border: 1px solid #fff !important;
    margin-left: 3px !important
}

.nir-notification--status--off {
    background: #f05b5b !important
}

.nir-notification--status--on {
    background: #37b777 !important
}

.toolbar--toggle {
    position: absolute !important;
    display: block !important;
    width: 20px !important;
    height: 20px !important;
    background: #000 !important;
    margin: 0 5px !important;
    border-radius: 0 0 3px 3px !important;
    right: 30px
}

.toolbar--toggle--open a::after {
    content: "î’";
    display: inline-block;
    text-decoration: none;
    color: color("white")
}

.toolbar--toggle--closed a::after {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: color("white")
}

.toolbar--toggle a:after {
    color: #fff !important;
    font-size: 20px !important
}

.toolbar--toggle--text {
    display: none !important
}

.local-tasks-sidebar--toggle--text {
    display: none !important
}

@media only screen and (max-width: 363px) {
    .toolbar-item.help-tab {
        display:none !important
    }
}

@media(min-width: 16.5em) {
    .nir-toolbar .toolbar-bar .nir-toolbar-tab,.nir-toolbar .toolbar-tray-horizontal li {
        float:right !important
    }
}

@media only screen and (max-width: 64em) {
    .toolbar-bar .nir-logo {
        background-size:30px !important;
        width: 50px !important
    }

    .toolbar-bar>.nir-menu>li>a {
        background-size: 27px !important;
        background-repeat: no-repeat !important;
        background-position: center center !important;
        text-indent: -9999px !important;
        padding: 19px 21px !important
    }

  

    .toolbar-bar .nir-menu>li ul {
        box-shadow: 0 5px 10px rgba(0,0,0,.2) !important;
        background: #fff !important;
        position: fixed !important;
        padding-top: 3px !important;
        margin-top: 0 !important;
        margin-left: 0 !important;
        width: 200px !important;
        left: 0 !important;
        top: 56px !important
    }

    .toolbar-bar .nir-menu .nir-menu-item--site-status:before {
        display: block !important;
        color: #fff !important;
        font-size: 36px !important;
        margin: 0 !important;
        padding: 0 10px !important
    }

    .toolbar-bar .nir-menu .nir-menu-item--site-status--primary::before {
        content: "P" !important
    }

    .toolbar-bar .nir-menu .nir-menu-item--site-status--secondary::before {
        content: "S" !important;
        color: #000 !important
    }

    .toolbar-bar .nir-menu .nir-menu-item--site-status a {
        display: none !important
    }

    .nir-toolbar .toolbar-item.user-tab>a {
        padding: 10px 5px !important
    }

 
    .nir-toolbar .toolbar-item.site-name-tab>ul {
        position: fixed !important;
        right: 0 !important;
        top: 56px !important
    }
}

.sidr {
    display: block;
    position: fixed;
    top: 0;
    height: 100%;
    z-index: 999999;
    width: 260px;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: "lucida grande",tahoma,verdana,arial,sans-serif;
    font-size: 15px;
    background: #333;
    color: #fff;
    box-shadow: 0 0 5px 5px #222 inset;
}

.sidr .sidr-inner {
    padding: 0 0 15px;
}

.sidr .sidr-inner > p {
    margin-left: 15px;
    margin-right: 15px;
}

.sidr.right {
    left: auto;
    right: -260px;
}

.sidr.left {
    left: -260px;
    right: auto;
}



.sidr p {
    font-size: 13px;
    margin: 0 0 12px;
}

.sidr p a {
    color: rgba(255,255,255,0.9);
}

.sidr > p {
    margin-left: 15px;
    margin-right: 15px;
}

.sidr ul {
    display: block;
    margin: 0 0 15px;
    padding: 0;
    border-top: 1px solid #1a1a1a;
    border-bottom: 1px solid #4d4d4d;
}

.sidr ul li {
    display: block;
    margin: 0;
    line-height: 48px;
    border-top: 1px solid #4d4d4d;
    border-bottom: 1px solid #1a1a1a;
}

.sidr ul li:hover,.sidr ul li.active,.sidr ul li.sidr-class-active {
    border-top: 0;
    line-height: 49px;
}

.sidr ul li:hover > a,.sidr ul li:hover > span,.sidr ul li.active > a,.sidr ul li.active > span,.sidr ul li.sidr-class-active > a,.sidr ul li.sidr-class-active > span {
    box-shadow: 0 0 15px 3px #222 inset;
}

.sidr ul li a,.sidr ul li span {
    padding: 0 15px;
    display: block;
    text-decoration: none;
    color: #fff;
}

.sidr ul li ul {
    border-bottom: 0;
    margin: 0;
}

.sidr ul li ul li {
    line-height: 40px;
    font-size: 13px;
}

.sidr ul li ul li:last-child {
    border-bottom: 0;
}

.sidr ul li ul li:hover,.sidr ul li ul li.active,.sidr ul li ul li.sidr-class-active {
    border-top: 0;
    line-height: 41px;
}

.sidr ul li ul li:hover > a,.sidr ul li ul li:hover > span,.sidr ul li ul li.active > a,.sidr ul li ul li.active > span,.sidr ul li ul li.sidr-class-active > a,.sidr ul li ul li.sidr-class-active > span {
    box-shadow: 0 0 15px 3px #222 inset;
}

.sidr ul li ul li a,.sidr ul li ul li span {
    color: rgba(255,255,255,0.8);
    padding-left: 30px;
}

.sidr form {
    margin: 0 15px;
}

.sidr label {
    font-size: 13px;
}

.sidr input[type="text"],.sidr input[type="password"],.sidr input[type="date"],.sidr input[type="datetime"],.sidr input[type="email"],.sidr input[type="number"],.sidr input[type="search"],.sidr input[type="tel"],.sidr input[type="time"],.sidr input[type="url"],.sidr textarea,.sidr select {
    width: 100%;
    font-size: 13px;
    padding: 5px;
    box-sizing: border-box;
    margin: 0 0 10px;
    border-radius: 2px;
    border: 0;
    background: rgba(0,0,0,0.1);
    color: rgba(255,255,255,0.6);
    display: block;
    clear: both;
}

.sidr input[type=checkbox] {
    width: auto;
    display: inline;
    clear: none;
}

.sidr input[type=button],.sidr input[type=submit] {
    color: #333;
    background: #fff;
}

.sidr input[type=button]:hover,.sidr input[type=submit]:hover {
    background: rgba(255,255,255,0.9);
}

.select2-container--default .select2-results__option.select2-results__option--highlighted[aria-selected] {
    background-color: #2d72e1
}

.select2-container--default .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove {
    color: inherit
}

.select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-selection__choice {
    border-color: #949494
}

.chosen-container {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    -webkit-user-select: none;
    user-select: none;
}

.chosen-container * {
    box-sizing: border-box;
}

.chosen-container .chosen-drop {
    position: absolute;
    top: 100%;
    left: -9999px;
    z-index: 1010;
    width: 100%;
    border: 1px solid #aaa;
    border-top: 0;
    background: #fff;
    box-shadow: 0 4px 5px rgba(0,0,0,0.15);
}

.chosen-container.chosen-with-drop .chosen-drop {
    left: 0;
}

.chosen-container a {
    cursor: pointer;
}

.chosen-container .search-choice .group-name,.chosen-container .chosen-single .group-name {
    margin-right: 4px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: normal;
    color: #999999;
}

.chosen-container .search-choice .group-name:after,.chosen-container .chosen-single .group-name:after {
    content: ":";
    padding-left: 2px;
    vertical-align: top;
}

.chosen-container-single .chosen-single {
    position: relative;
    display: block;
    overflow: hidden;
    padding: 0 0 0 8px;
    height: 25px;
    border: 1px solid #aaa;
    border-radius: 5px;
    background-color: #fff;
    background: linear-gradient(#ffffff 20%,#f6f6f6 50%,#eeeeee 52%,#f4f4f4 100%);
    background-clip: padding-box;
    box-shadow: 0 0 3px white inset,0 1px 1px rgba(0,0,0,0.1);
    color: #444;
    text-decoration: none;
    white-space: nowrap;
    line-height: 24px;
}

.chosen-container-single .chosen-default {
    color: #999;
}

.chosen-container-single .chosen-single span {
    display: block;
    overflow: hidden;
    margin-right: 26px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.chosen-container-single .chosen-single-with-deselect span {
    margin-right: 38px;
}


.chosen-container-single .chosen-single abbr:hover {
    background-position: -42px -10px;
}

.chosen-container-single.chosen-disabled .chosen-single abbr:hover {
    background-position: -42px -10px;
}

.chosen-container-single .chosen-single div {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 18px;
    height: 100%;
}


.chosen-container-single .chosen-search {
    position: relative;
    z-index: 1010;
    margin: 0;
    padding: 3px 4px;
    white-space: nowrap;
}


.chosen-container-single .chosen-drop {
    margin-top: -1px;
    border-radius: 0 0 4px 4px;
    background-clip: padding-box;
}

.chosen-container-single.chosen-container-single-nosearch .chosen-search {
    position: absolute;
    left: -9999px;
}

.chosen-container .chosen-results {
    color: #444;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    margin: 0 4px 4px 0;
    padding: 0 0 0 4px;
    max-height: 240px;
    -webkit-overflow-scrolling: touch;
}

.chosen-container .chosen-results li {
    display: none;
    margin: 0;
    padding: 5px 6px;
    list-style: none;
    line-height: 15px;
    word-wrap: break-word;
    -webkit-touch-callout: none;
}

.chosen-container .chosen-results li.active-result {
    display: list-item;
    cursor: pointer;
}

.chosen-container .chosen-results li.disabled-result {
    display: list-item;
    color: #ccc;
    cursor: default;
}

.chosen-container .chosen-results li.highlighted {
    background-color: #3875d7;
    background-image: linear-gradient(#3875d7 20%,#2a62bc 90%);
    color: #fff;
}

.chosen-container .chosen-results li.no-results {
    color: #777;
    display: list-item;
    background: #f4f4f4;
}

.chosen-container .chosen-results li.group-result {
    display: list-item;
    font-weight: bold;
    cursor: default;
}

.chosen-container .chosen-results li.group-option {
    padding-left: 15px;
}

.chosen-container .chosen-results li em {
    font-style: normal;
    text-decoration: underline;
}

.chosen-container-multi .chosen-choices {
    position: relative;
    overflow: hidden;
    margin: 0;
    padding: 0 5px;
    width: 100%;
    height: auto !important;
    height: 1%;
    border: 1px solid #aaa;
    background-color: #fff;
    background-image: linear-gradient(#eeeeee 1%,#ffffff 15%);
    cursor: text;
}

.chosen-container-multi .chosen-choices li {
    float: left;
    list-style: none;
}

.chosen-container-multi .chosen-choices li.search-field {
    margin: 0;
    padding: 0;
    white-space: nowrap;
}

.chosen-container-multi .chosen-choices li.search-field input[type="text"] {
    margin: 1px 0;
    padding: 0;
    height: 25px;
    outline: 0;
    border: 0 !important;
    background: transparent !important;
    box-shadow: none;
    color: #797676;
    font-size: 100%;
    font-family: sans-serif;
    line-height: normal;
    border-radius: 0;
}

.chosen-container-multi .chosen-choices li.search-choice {
    position: relative;
    margin: 3px 5px 3px 0;
    padding: 3px 20px 3px 5px;
    border: 1px solid #aaa;
    max-width: 100%;
    border-radius: 3px;
    background-color: #eeeeee;
    background-image: linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);
    background-size: 100% 19px;
    background-repeat: repeat-x;
    background-clip: padding-box;
    box-shadow: 0 0 2px white inset,0 1px 0 rgba(0,0,0,0.05);
    color: #333;
    line-height: 13px;
    cursor: default;
}

.chosen-container-multi .chosen-choices li.search-choice span {
    word-wrap: break-word;
}


.chosen-container-multi .chosen-choices li.search-choice .search-choice-close:hover {
    background-position: -42px -10px;
}

.chosen-container-multi .chosen-choices li.search-choice-disabled {
    padding-right: 5px;
    border: 1px solid #ccc;
    background-color: #e4e4e4;
    background-image: linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);
    color: #666;
}

.chosen-container-multi .chosen-choices li.search-choice-focus {
    background: #d4d4d4;
}

.chosen-container-multi .chosen-choices li.search-choice-focus .search-choice-close {
    background-position: -42px -10px;
}

.chosen-container-multi .chosen-results {
    margin: 0;
    padding: 0;
}

.chosen-container-multi .chosen-drop .result-selected {
    display: list-item;
    color: #ccc;
    cursor: default;
}

.chosen-container-active .chosen-single {
    border: 1px solid #5897fb;
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
}

.chosen-container-active.chosen-with-drop .chosen-single {
    border: 1px solid #aaa;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    background-image: linear-gradient(#eeeeee 20%,#ffffff 80%);
    box-shadow: 0 1px 0 #fff inset;
}

.chosen-container-active.chosen-with-drop .chosen-single div {
    border-left: none;
    background: transparent;
}

.chosen-container-active.chosen-with-drop .chosen-single div b {
    background-position: -18px 2px;
}

.chosen-container-active .chosen-choices {
    border: 1px solid #5897fb;
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
}

.chosen-container-active .chosen-choices li.search-field input[type="text"] {
    color: #222 !important;
}

.chosen-disabled {
    opacity: 0.5 !important;
    cursor: default;
}

.chosen-disabled .chosen-single {
    cursor: default;
}

.chosen-disabled .chosen-choices .search-choice .search-choice-close {
    cursor: default;
}

.chosen-rtl {
    text-align: right;
}

.chosen-rtl .chosen-single {
    overflow: visible;
    padding: 0 8px 0 0;
}

.chosen-rtl .chosen-single span {
    margin-right: 0;
    margin-left: 26px;
    direction: rtl;
}

.chosen-rtl .chosen-single-with-deselect span {
    margin-left: 38px;
}

.chosen-rtl .chosen-single div {
    right: auto;
    left: 3px;
}

.chosen-rtl .chosen-single abbr {
    right: auto;
    left: 26px;
}

.chosen-rtl .chosen-choices li {
    float: right;
}

.chosen-rtl .chosen-choices li.search-field input[type="text"] {
    direction: rtl;
}

.chosen-rtl .chosen-choices li.search-choice {
    margin: 3px 5px 3px 0;
    padding: 3px 5px 3px 19px;
}

.chosen-rtl .chosen-choices li.search-choice .search-choice-close {
    right: auto;
    left: 4px;
}

.chosen-rtl.chosen-container-single-nosearch .chosen-search,.chosen-rtl .chosen-drop {
    left: 9999px;
}

.chosen-rtl.chosen-container-single .chosen-results {
    margin: 0 0 4px 4px;
    padding: 0 4px 0 0;
}

.chosen-rtl .chosen-results li.group-option {
    padding-right: 15px;
    padding-left: 0;
}

.chosen-rtl.chosen-container-active.chosen-with-drop .chosen-single div {
    border-right: none;
}



.chosen-rtl.chosen-container-single .chosen-single div b {
    background-position: 6px 2px;
}

.chosen-rtl.chosen-container-single.chosen-with-drop .chosen-single div b {
    background-position: -12px 2px;
}


.ixbrl-link a::before,#ndq-content .ixbrl-link a::before {
    font-family: "ndqfonticons";
    font-size: 26px;
    vertical-align: middle;
    padding-right: 5px;
    font-weight: normal;
    text-decoration: none
}

.ixbrl-link a::before,#ndq-content .ixbrl-link a::before {
    content: "î½";
    display: inline-block;
    text-decoration: none;
    color: #000
}

.nir-sec-header .sec-docs .file-link,.nir-sec-header .sec-docs .field.ixbrl-link,#ndq-content .nir-sec-header .sec-docs .file-link,#ndq-content .nir-sec-header .sec-docs .field.ixbrl-link {
    display: inline-block
}

.nir-sec-header .sec-docs .ixbrl-link a,#ndq-content .nir-sec-header .sec-docs .ixbrl-link a {
    font-size: 0
}

.nir-sec-header,#ndq-content .nir-sec-header {
    box-sizing: border-box
}

p.attribution-legend {
    display: inline-flex
}

p.attribution-legend span {
    padding-top: 10px
}

p.attribution-legend img#lseg-logo {
    width: 88px;
    height: 39px
}

#ndq-content .float-left {
    float: left;
}

#ndq-content .clear-both {
    clear: both;
}

#ndq-content img,#ndq-content legend {
    border: 0;
}

#ndq-content legend,#ndq-content td,#ndq-content th {
    padding: 0;
}

#ndq-content article,#ndq-content aside,#ndq-content details,#ndq-content figcaption,#ndq-content figure,#ndq-content footer,#ndq-content header,#ndq-content hgroup,#ndq-content main,#ndq-content menu,#ndq-content nav,#ndq-content section,#ndq-content summary {
    display: block;
}

#ndq-content audio,#ndq-content canvas,#ndq-content progress,#ndq-content video {
    display: inline-block;
    vertical-align: baseline;
}

#ndq-content audio:not([controls]) {
    display: none;
    height: 0;
}

#ndq-content [hidden],#ndq-content template {
    display: none;
}

#ndq-content abbr[title] {
    border-bottom: 1px dotted;
}

#ndq-content b,#ndq-content optgroup,#ndq-content strong {
    font-weight: 700;
}

#ndq-content dfn {
    font-style: italic;
}

#ndq-content h1 {
    font-size: 2em;
    margin: 0.67em 0;
}

#ndq-content mark {
    background: #ff0;
    color: #000;
}

#ndq-content small {
    font-size: 80%;
}

#ndq-content sub,#ndq-content sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
}

#ndq-content sup {
    top: -0.5em;
}

#ndq-content sub {
    bottom: -0.25em;
}

#ndq-content svg:not(:root) {
    overflow: hidden;
}

#ndq-content figure {
    margin: 1em 40px;
}

#ndq-content hr {
    box-sizing: content-box;
    height: 0;
}

#ndq-content pre,#ndq-content textarea {
    overflow: auto;
}

#ndq-content code,#ndq-content kbd,#ndq-content pre,#ndq-content samp {
    font-family: monospace,monospace;
    font-size: 1em;
}

#ndq-content button,#ndq-content input,#ndq-content optgroup,#ndq-content select,#ndq-content textarea {
    color: inherit;
    font: inherit;
    margin: 0;
}

#ndq-content button::-moz-focus-inner,#ndq-content input::-moz-focus-inner {
    border: 0;
    padding: 0;
}

#ndq-content input {
    line-height: normal;
}

#ndq-content input[type=checkbox],#ndq-content input[type=radio] {
    box-sizing: border-box;
    padding: 0;
}

#ndq-content input[type=number]::-webkit-inner-spin-button,#ndq-content input[type=number]::-webkit-outer-spin-button {
    height: auto;
}



#ndq-content fieldset {
    border: 1px solid silver;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
}

#ndq-content table {
    border-collapse: collapse;
    border-spacing: 0;
}



@media print {
    #ndq-content html {
        font-size: 12pt;
    }
}

#ndq-content body {
    margin: 0;
    padding: 0;
}

#ndq-content * {
    box-sizing: border-box;
}

#ndq-content article,#ndq-content aside,#ndq-content details,#ndq-content figcaption,#ndq-content figure,#ndq-content footer,#ndq-content header,#ndq-content hgroup,#ndq-content main,#ndq-content menu,#ndq-content nav,#ndq-content section,#ndq-content summary {
    display: block;
}


#ndq-content audio:not([controls]) {
    display: none;
    height: 0;
}

#ndq-content [hidden] {
    display: none;
}

#ndq-content template {
    display: none;
}

#ndq-content html,#ndq-content body {
    font-size: 87.5%;
    line-height: 1.42857em;
    min-height: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
}

@media print {
    #ndq-content html,#ndq-content body {
        font-size: 12pt;
    }
}

#ndq-content body {
    background: #f5f5f5;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    word-wrap: break-word;
    color: #333;
}

#ndq-content body .container {
    background: #fff;
    background: rgba(255,255,255,0.9);
}

#ndq-content body .menu-item {
    padding-top: 0;
    margin: 0;
}

#ndq-content a#logo {
    width: 100px;
    display: block;
    padding: 5px;
    float: left;
    margin-bottom: 15px;
}

@media print {
    #ndq-content :link,#ndq-content :visited {
        text-decoration: underline;
    }

    #ndq-content a[href]:after {
        content: " (" attr(href) ")";
        font-weight: normal;
        font-size: 14px;
        text-decoration: none;
    }

    #ndq-content a[href^='javascript:']:after,#ndq-content a[href^='#']:after {
        content: '';
    }
}

#ndq-content img {
    border: 0;
    -ms-interpolation-mode: bicubic;
}

#ndq-content img,#ndq-content svg {
    max-width: 100%;
    height: auto;
    width: auto;
}

#ndq-content svg:not(:root) {
    overflow: hidden;
}

#ndq-content form {
    margin: 0;
}

#ndq-content button,#ndq-content input,#ndq-content optgroup,#ndq-content select,#ndq-content textarea {
    box-sizing: border-box;
    max-width: 100%;
    color: inherit;
    font: inherit;
    margin: 0;
}

#ndq-content button {
    overflow: visible;
}

#ndq-content button,#ndq-content select {
    text-transform: none;
}

#ndq-content button::-moz-focus-inner,#ndq-content input::-moz-focus-inner {
    border: 0;
    padding: 0;
}


#ndq-content input[type="number"]::-webkit-inner-spin-button,#ndq-content input[type="number"]::-webkit-outer-spin-button {
    height: auto;
}


#ndq-content input[type="text"],#ndq-content input[type="search"],#ndq-content input[type="tel"],#ndq-content input[type="url"],#ndq-content input[type="email"],#ndq-content input[type="password"],#ndq-content input[type="date"],#ndq-content input[type="time"],#ndq-content input[type="number"],#ndq-content input[type="datalist"],#ndq-content textarea {
    line-height: inherit;
    display: block;
    width: auto;
    padding: 10px 15px;
    font-size: 14px;
    line-height: 1.42857143;
    margin-top: 5px;
    color: #666;
    border: 1px solid var(--border-color,#cbcbcd);
    border-radius: 4px;
    outline: 0px;
}


#ndq-content fieldset {
    padding: 0.5em 0.89286em 0.92857em;
    border: 1px solid var(--border-color,#cbcbcd);
    margin: 0 2px;
}

#ndq-content fieldset:before {
    content: '';
    display: table;
}

#ndq-content fieldset:after {
    content: '';
    display: table;
    clear: both;
}

#ndq-content legend {
    border: 0;
    margin-left: -5px;
    padding: 0 5px;
   
}

#ndq-content optgroup {
    font-weight: bold;
}

#ndq-content textarea {
    overflow: auto;
}

#ndq-content blockquote {
    margin: 0 2em 1.42857em;
}

#ndq-content figure {
    margin: 0 0 1.42857em;
}

#ndq-content hr {
    box-sizing: content-box;
    height: 0;
}
#ndq-content pre {
    font-family: monospace;
    _font-family: 'courier new',monospace;
    font-size: .8em;
    line-height: 1.45;
}

#ndq-content pre {
    overflow: auto;
}

#ndq-content dl,#ndq-content menu,#ndq-content ol,#ndq-content ul {
    margin: 1em 0;
}

#ndq-content ol ol,#ndq-content ol ul,#ndq-content ul ol,#ndq-content ul ul {
    margin: 0;
}

#ndq-content dd {
    margin: 0 0 0 28px;
}

#ndq-content [dir="rtl"] dd {
    margin: 0 28px 0 0;
}

#ndq-content menu,#ndq-content ol,#ndq-content ul {
    padding: 0 0 0 28px;
}

#ndq-content [dir="rtl"] menu,#ndq-content [dir="rtl"] ol,#ndq-content [dir="rtl"] ul {
    padding: 0 28px 0 0;
}

#ndq-content nav ul,#ndq-content nav ol {
    list-style: none;
    list-style-image: none;
}

#ndq-content h1,#ndq-content #nir-header__site-name {
    font-size: 1.5em;
    line-height: 1.42857em;
    margin-top: 0.66657em;
    margin-bottom: 0.47614em;
}

#ndq-content table.nirtable caption,#ndq-content table.dataTable caption,#ndq-content .block-market-data-block__estimates__all .js-form-type-select label {
    font-size: 1.3em;
    line-height: 1.42857em;
    margin-top: 0.35714em;
    margin-bottom: 0.35714em;
    border-bottom: solid 1px var(--border-color,#cbcbcd);
}

#ndq-content h3 {
    font-size: 1.2em;
    line-height: 1.42857em;
    margin-top: 1em;
    margin-bottom: 1em;
}

#ndq-content h5,#ndq-content h6,#ndq-content .view-nir-media-gallery-items-grid .views-row h2,#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-title {
    font-size: 1.1em;
    line-height: 1.42857em;
    margin-top: 1.42857em;
    margin-bottom: 1.42857em;
}

#ndq-content table.nirtable,#ndq-content table.dataTable {
    margin: 0 0 15px 0;
    border-collapse: separate;
    border-spacing: 0;
    border: 0;
    table-layout: fixed;
    width: 100%;
    word-wrap: normal;
}

#ndq-content table.nirtable caption,#ndq-content table.dataTable caption {
    font-weight: bold;
    text-align: left;
    padding: 5px 0;
}

#ndq-content table.nirtable tbody tr:nth-child(odd),#ndq-content table.dataTable tbody tr:nth-child(odd) {
    background-color: #f5fafa;
}

#ndq-content table.nirtable td,#ndq-content table.nirtable th,#ndq-content table.dataTable td,#ndq-content table.dataTable th {
    padding: 15px;
    border: 0;
}

#ndq-content table.nirtable th,#ndq-content table.nirtable thead td,#ndq-content table.dataTable th,#ndq-content table.dataTable thead td {
    background-color: #666;
    color: #fff;
    text-align: left;
    position: relative;
}

#ndq-content .two-col-node .node-left {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node .node-left {
        width:36.70886%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .two-col-node .node-right {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node .node-right {
        width:62.02532%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .two-col-node-alt1 .node-left {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node-alt1 .node-left {
        width:24.05063%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .two-col-node-alt1 .node-right {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node-alt1 .node-right {
        width:74.68354%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .two-col-node-alt2 .node-left {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node-alt2 .node-left {
        width:36.70886%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .two-col-node-alt2 .node-right {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node-alt2 .node-right {
        width:62.02532%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .two-col-node-alt3 .node-left {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node-alt3 .node-left {
        width:17.72152%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .two-col-node-alt3 .node-right {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-node-alt3 .node-right {
        width:81.01266%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .two-col-half .left-half {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-half .left-half {
        width:49.36709%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .two-col-half .right-half {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .two-col-half .right-half {
        width:49.36709%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .modal-content .node-left {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .modal-content .node-left {
        width:17.72152%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .modal-content .node-right {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .modal-content .node-right {
        width:81.01266%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .split-half {
    float: left;
    margin-bottom: 1em;
    width: 100%;
}

#ndq-content .split-half .left-half {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .split-half .left-half {
        width:49.36709%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .split-half .right-half {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .split-half .right-half {
        width:49.36709%;
        float: right;
        margin-right: 0;
        float: left;
    }
}

#ndq-content .full-width {
    width: 100%;
    float: right;
    margin-right: 0;
}

#ndq-content .container-fluid {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
}

#ndq-content .row:before {
    content: '';
    display: table;
}

#ndq-content .row:after {
    content: '';
    display: table;
    clear: both;
}

#ndq-content .tabledrag-handle .handle,#ndq-content .mceToolbar table td a {
    box-sizing: content-box;
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -o-box-sizing: content-box;
}

#ndq-content .container-fluid .container-fluid {
    width: auto;
    margin-left: -1.69492%;
    margin-right: -1.69492%;
}

@media (min-width: 320px) {
    #ndq-content body.body-sidebars-first aside.sidebar-first {
        width:100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-first aside.sidebar-first > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }

    #ndq-content body.body-sidebars-first section#content {
        width: 100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-first section#content > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }
}

@media (min-width: 769px) {
    #ndq-content body.body-sidebars-first aside.sidebar-first {
        width:24.05063%;
        float: left;
        margin-right: 1.26582%;
    }

    #ndq-content body.body-sidebars-first aside.sidebar-first > * {
        padding-left: 1em;
    }

    #ndq-content body.body-sidebars-first section#content {
        width: 74.68354%;
        float: right;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-first section#content > * {
        padding-right: 1em;
    }
}

@media (min-width: 320px) {
    #ndq-content body.body-sidebars-last aside.sidebar-last {
        width:100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-last aside.sidebar-last > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }

    #ndq-content body.body-sidebars-last section#content {
        width: 100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-last section#content > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }
}

@media (min-width: 769px) {
    #ndq-content body.body-sidebars-last aside.sidebar-last {
        width:24.05063%;
        float: right;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-last aside.sidebar-last > * {
        padding-right: 1em;
    }

    #ndq-content body.body-sidebars-last section#content {
        width: 74.68354%;
        float: left;
        margin-right: 1.26582%;
    }

    #ndq-content body.body-sidebars-last section#content > * {
        padding-left: 1em;
    }
}

@media (min-width: 320px) {
    #ndq-content body.body-sidebars-both aside.sidebar-first {
        width:100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-both aside.sidebar-first > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }

    #ndq-content body.body-sidebars-both aside.sidebar-last {
        width: 100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-both aside.sidebar-last > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }

    #ndq-content body.body-sidebars-both section#content {
        width: 100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-both section#content > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }
}

@media (min-width: 769px) {
    #ndq-content body.body-sidebars-both aside.sidebar-first {
        width:24.05063%;
        float: left;
        margin-right: 1.26582%;
    }

    #ndq-content body.body-sidebars-both aside.sidebar-first > * {
        padding-left: 1em;
    }

    #ndq-content body.body-sidebars-both section#content {
        width: 49.36709%;
        float: left;
        margin-right: 1.26582%;
    }

    #ndq-content body.body-sidebars-both aside.sidebar-last {
        width: 24.05063%;
        float: right;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-both aside.sidebar-last > * {
        padding-right: 1em;
    }
}

@media (min-width: 320px) {
    #ndq-content body.body-sidebars-none section#content {
        width:100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-none section#content > * {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }
}

@media (min-width: 769px) {
    #ndq-content body.body-sidebars-none section#content {
        width:100%;
        float: left;
        margin-left: 0;
        margin-right: 0;
    }

    #ndq-content body.body-sidebars-none section#content > * {
        padding-left: 1em;
        padding-right: 1em;
    }
}

#ndq-content aside.sidebar {
    overflow: hidden;
}

@media (max-width: 769px) {
    #ndq-content body.search #main .container {
        display:flex;
        flex-direction: column;
    }

    #ndq-content body.search #main .container #content {
        order: 2;
    }

    #ndq-content body.search #main .container .sidebar-last {
        order: 1;
    }
}

#ndq-content .views-view-grid.cols-3 .views-col {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
}

#ndq-content .views-view-grid.cols-3 .col-1 {
    width: 100%;
    float: left;
    margin-right: 1.69492%;
}

#ndq-content .views-view-grid.cols-3 .col-3 {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 769px) {
    #ndq-content .views-view-grid.cols-3 .views-col {
        width:32.20339%;
        float: left;
        margin-right: 1.69492%;
    }

    #ndq-content .views-view-grid.cols-3 .col-1 {
        width: 32.20339%;
        float: left;
        margin-right: 1.69492%;
    }

    #ndq-content .views-view-grid.cols-3 .col-3 {
        width: 32.20339%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .hidden,#ndq-content html.js .js-hidden,#ndq-content html.js .element-hidden,#ndq-content html.js .js-hide {
    display: none;
}

#ndq-content .visually-hidden,#ndq-content .visually-hidden--focusable,#ndq-content .element-focusable,#ndq-content .element-invisible,#ndq-content .breadcrumb__title,#ndq-content .main-navigation .block-menu .block__title,#ndq-content .main-navigation .block-menu-block .block__title {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

#ndq-content .visually-hidden--off,#ndq-content .visually-hidden--focusable:active,#ndq-content .visually-hidden--focusable:focus,#ndq-content .element-focusable:active,#ndq-content .element-focusable:focus {
    position: static !important;
    clip: auto;
    height: auto;
    width: auto;
    overflow: auto;
}

#ndq-content .clearfix:before,#ndq-content .tabs:before,#ndq-content .tabs--secondary:before,.block--local-tasks-block .tabs:before,.block--local-tasks-block .tabs--secondary:before,#ndq-content div[class*='view-widget-']:before,#ndq-content #nir-header:before {
    content: '';
    display: table;
}

#ndq-content .clearfix:after,#ndq-content .tabs:after,#ndq-content .tabs--secondary:after,.block--local-tasks-block .tabs:after,.block--local-tasks-block .tabs--secondary:after,#ndq-content div[class*='view-widget-']:after,#ndq-content #nir-header:after {
    content: '';
    display: table;
    clear: both;
}

#ndq-content .ui-dialog-titlebar-close::before,#ndq-content a.summary-toggle::before,#ndq-content a.summary-toggle:hover::before,#ndq-content a.summary-toggle.open::before,#ndq-content a.summary-toggle.open:hover::before,#ndq-content a.nir-widget--person--accordion-toggle::before,#ndq-content a.nir-widget--person--accordion-toggle:hover::before,#ndq-content a.nir-widget--person--accordion-toggle.open::before,#ndq-content a.nir-widget--person--accordion-toggle.open:hover::before,#ndq-content a.nir-widget--news--accordion-toggle::before,#ndq-content a.nir-widget--news--accordion-toggle:hover::before,#ndq-content a.nir-widget--news--accordion-toggle.open::before,#ndq-content a.nir-widget--news--accordion-toggle.open:hover::before,#ndq-content .webcast-link a::before,#ndq-content .normal-webcast-link a::before,#ndq-content .widget-file--html::before,#ndq-content .field--name-field-nir-ext-document a::before,#ndq-content .field--name-field-nir-news-supp-ext-url a::before,#ndq-content .external-link::before,#ndq-content .widget-file--mime-video-x-ms-asf::before,#ndq-content .file--mime-video-x-ms-asf a::before,#ndq-content .widget-file--mime-image-x-ms-bmp::before,#ndq-content .file--mime-image-x-ms-bmp a::before,#ndq-content .widget-file--mime-text-csv::before,#ndq-content .file--mime-text-csv a::before,#ndq-content .file--mime-text-csv.file--text a::before,#ndq-content .market-data-file-download-csv::before,#ndq-content .widget-file--mime-application-msword::before,#ndq-content .file--mime-application-msword a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document a::before,#ndq-content .widget-file--mime-application-postscript::before,#ndq-content .file--mime-application-postscript a::before,#ndq-content .widget-file--mime-application-epub::before,#ndq-content .file--mime-application-epub a::before,#ndq-content .widget-file--fla::before,#ndq-content .file--fla a::before,#ndq-content .widget-file--mime-video-x-flv::before,#ndq-content .file--mime-video-x-flv a::before,#ndq-content .widget-file--mime-image-gif::before,#ndq-content .file--mime-image-gif a::before,#ndq-content .widget-file--ics::before,#ndq-content .file--ics a::before,#ndq-content .widget-file--mime-image-jpeg::before,#ndq-content .widget-file--mime-image-jpg::before,#ndq-content .file--mime-image-jpeg a::before,#ndq-content .file--mime-image-jpg a::before,#ndq-content .widget-file--mime-application-pgp-keys::before,#ndq-content .file--mime-application-pgp-keys a::before,#ndq-content .widget-file--mime-application-x-mobipocket-ebook::before,#ndq-content .file--mime-application-x-mobipocket-ebook a::before,#ndq-content .widget-file--mime-video-quicktime::before,#ndq-content .file--mime-video-quicktime a::before,#ndq-content .widget-file--mime-audio-mpeg::before,#ndq-content .file--mime-audio-mpeg a::before,#ndq-content .widget-file--mpg::before,#ndq-content .file--mpg a::before,#ndq-content .widget-file--odt::before,#ndq-content .file--odt a::before,#ndq-content .widget-file--application-pdf::before,#ndq-content .file--application-pdf a::before,#ndq-content .widget-file--mime-image-png::before,#ndq-content .file--mime-image-png a::before,#ndq-content .widget-file--mime-application-vnd-ms-powerpoint::before,#ndq-content .file--mime-application-vnd-ms-powerpoint a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow a::before,#ndq-content .widget-file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12 a::before,#ndq-content .widget-file--mime-application-rar::before,#ndq-content .file--mime-application-rar a::before,#ndq-content .widget-file--mime-application-rtf::before,#ndq-content .file--mime-application-rtf a::before,#ndq-content .widget-file--rtx::before,#ndq-content .file--rtx a::before,#ndq-content .widget-file--swf::before,#ndq-content .file--swf a::before,#ndq-content .widget-file--mime-image-tiff::before,#ndq-content .file--mime-image-tiff a::before,#ndq-content .widget-file--text::before,#ndq-content .file--text a::before,#ndq-content .widget-file--mime-audio-x-wav::before,#ndq-content .file--mime-audio-x-wav a::before,#ndq-content .widget-file--mime-audio-x-ms-wma::before,#ndq-content .file--mime-audio-x-ms-wma a::before,#ndq-content .widget-file--mime-video-x-ms-wmv::before,#ndq-content .file--mime-video-x-ms-wmv a::before,#ndq-content .widget-file--xls::before,#ndq-content .file--xls a::before,#ndq-content .widget-file--x-office-spreadsheet::before,#ndq-content .file--x-office-spreadsheet a::before,#ndq-content .market-data-file-download-xls::before,#ndq-content .widget-file--mime-application-vnd-ms-excel-sheet-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-excel-sheet-macroEnabled-12 a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet a::before,#ndq-content .widget-file--mime-application-xml::before,#ndq-content .file--mime-application-xml a::before,#ndq-content .widget-file--mime-application-octet-stream::before,#ndq-content .file--mime-application-octet-stream a::before,#ndq-content .widget-file--mime-application-zip::before,#ndq-content .file--mime-application-zip a::before,#ndq-content .ndqicon__chairperson a::before,#ndq-content span.ndqicon__chairperson::before,#ndq-content .ndqicon__chairperson a_after::after,#ndq-content span.ndqicon__chairperson_after::after,#ndq-content .ndqicon__cob a::before,#ndq-content span.ndqicon__cob::before,#ndq-content .ndqicon__cob a_after::after,#ndq-content span.ndqicon__cob_after::after,#ndq-content .ndqicon__vicechair::before,#ndq-content span.ndqicon__vicechair::before,#ndq-content span.ndqicon__vicechair_after::after,#ndq-content .ndqicon__leaddir::before,#ndq-content span.ndqicon__leaddir::before,#ndq-content .ndqicon__leaddir_after::after,#ndq-content span.ndqicon__leaddir_after::after,#ndq-content .ndqicon__chair::before,#ndq-content .ndqicon__chair1::before,#ndq-content .ndqicon__chair2::before,#ndq-content .ndqicon__chair3::before,#ndq-content .ndqicon__member a::before,#ndq-content span.ndqicon__member::before,#ndq-content .ndqicon__download::before,#ndq-content .ndqicon__independent::before,#ndq-content .ndqicon__independent_italic::before,#ndq-content .ndqicon__calculator::before,#ndq-content span.ndqicon__calculator::before,#ndq-content .ndqicon__calculator_after::after,#ndq-content span.ndqicon__calculator_after::after,#ndq-content .ndqicon__calculator1::before,#ndq-content .html-link a::before,#ndq-content .asset-link a::before,#ndq-content .add-outlook a::before,#ndq-content .add-gcal a::before,#ndq-content .right-arrow::before,#ndq-content .up-arrow::before,#ndq-content .ndqicon-check-circle::before,#ndq-content .thank-you-page h1::before,#ndq-content a.show-all::after,#ndq-content a.show-all.hide-all::after,#ndq-content .faq-acc-dl dt::before,#ndq-content .faq-acc-dl .acc-title::before,#ndq-content .acc-wrap dt::before,#ndq-content .acc-wrap .acc-title::before,#ndq-content .faq-acc-dl dt.opened::before,#ndq-content .faq-acc-dl .acc-title.opened::before,#ndq-content .acc-wrap dt.opened::before,#ndq-content .acc-wrap .acc-title.opened::before,#ndq-content .top-link::after,#ndq-content .nir-mean-value-rating .rating-arrow::after,#ndq-content .block-search-form form::after,#ndq-content .view-search form::after,#ndq-content .view-search .inline-asset span.file--application-pdf::before,#ndq-content .field--name-field-nir-committee-link a::before,#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one::before {
    font-family: "ndqfonticons";
    font-size: 26px;
    vertical-align: middle;
    padding-right: 5px;
    font-weight: normal;
    text-decoration: none;
}

#ndq-content .ui-dialog-titlebar-close::before {
    content: "î€“";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ui-dialog-titlebar-close::before {
    color: #666;
    font-size: 20px;
}

#ndq-content .ui-dialog-titlebar-close::before:hover {
    color: #0480a9;
}

#ndq-content a.summary-toggle {
    font-weight: normal;
    cursor: pointer;
}

#ndq-content a.summary-toggle::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.summary-toggle:hover::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.summary-toggle:before,#ndq-content a.summary-toggle:hover:before {
    font-size: 15px;
    line-height: 0;
}

#ndq-content a.summary-toggle span {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

#ndq-content a.summary-toggle.open::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.summary-toggle.open:hover::before {
    content: "îŽ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.summary-toggle.open:before,#ndq-content a.summary-toggle.open:hover:before {
    font-size: 15px;
    line-height: 0;
}

#ndq-content a.nir-widget--person--accordion-toggle {
    font-weight: normal;
    cursor: pointer;
}

#ndq-content a.nir-widget--person--accordion-toggle::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--person--accordion-toggle:hover::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--person--accordion-toggle:before,#ndq-content a.nir-widget--person--accordion-toggle:hover:before {
    font-size: 15px;
    line-height: 0;
}

#ndq-content a.nir-widget--person--accordion-toggle span {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

#ndq-content a.nir-widget--person--accordion-toggle.open::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--person--accordion-toggle.open:hover::before {
    content: "îŽ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--person--accordion-toggle.open:before,#ndq-content a.nir-widget--person--accordion-toggle.open:hover:before {
    font-size: 15px;
    line-height: 0;
}

#ndq-content a.nir-widget--person--accordion-toggle + div {
    display: inline;
}

#ndq-content a.nir-widget--news--accordion-toggle {
    font-weight: normal;
    cursor: pointer;
}

#ndq-content a.nir-widget--news--accordion-toggle::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--news--accordion-toggle:hover::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--news--accordion-toggle:before,#ndq-content a.nir-widget--news--accordion-toggle:hover:before {
    font-size: 15px;
    line-height: 0;
}

#ndq-content a.nir-widget--news--accordion-toggle span {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

#ndq-content a.nir-widget--news--accordion-toggle.open::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--news--accordion-toggle.open:hover::before {
    content: "îŽ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.nir-widget--news--accordion-toggle.open:before,#ndq-content a.nir-widget--news--accordion-toggle.open:hover:before {
    font-size: 15px;
    line-height: 0;
}

#ndq-content .ndqicon-disable-link {
    margin-left: 30px;
}

#ndq-content .ndqicon-disable-link a::before {
    margin-left: -30px;
    cursor: default !important;
    pointer-events: none !important;
}

#ndq-content .ndqicon-hide-icon a::before {
    display: none !important;
}

#ndq-content .summary-hidden {
    display: none;
}

#ndq-content .webcast-link a::before,#ndq-content .normal-webcast-link a::before {
    content: "î€œ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--html::before,#ndq-content .field--name-field-nir-ext-document a::before,#ndq-content .field--name-field-nir-news-supp-ext-url a::before,#ndq-content .external-link::before {
    content: "î·";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-video-x-ms-asf::before,#ndq-content .file--mime-video-x-ms-asf a::before {
    content: "î„ƒ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-image-x-ms-bmp::before,#ndq-content .file--mime-image-x-ms-bmp a::before {
    content: "î„„";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-text-csv::before,#ndq-content .file--mime-text-csv a::before,#ndq-content .file--mime-text-csv.file--text a::before,#ndq-content .market-data-file-download-csv::before {
    content: "î°";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-msword::before,#ndq-content .file--mime-application-msword a::before {
    content: "î²";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document a::before {
    content: "î³";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-postscript::before,#ndq-content .file--mime-application-postscript a::before {
    content: "îƒµ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-epub::before,#ndq-content .file--mime-application-epub a::before {
    content: "îƒ¶";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--fla::before,#ndq-content .file--fla a::before {
    content: "î´";
    display: inline-block;
    text-decoration: none;
    color: #c00;
}

#ndq-content .widget-file--mime-video-x-flv::before,#ndq-content .file--mime-video-x-flv a::before {
    content: "îµ";
    display: inline-block;
    text-decoration: none;
    color: #c00;
}

#ndq-content .widget-file--mime-image-gif::before,#ndq-content .file--mime-image-gif a::before {
    content: "î‚€";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--ics::before,#ndq-content .file--ics a::before {
    content: "îƒ¾";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-image-jpeg::before,#ndq-content .widget-file--mime-image-jpg::before,#ndq-content .file--mime-image-jpeg a::before,#ndq-content .file--mime-image-jpg a::before {
    content: "î¿";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-pgp-keys::before,#ndq-content .file--mime-application-pgp-keys a::before {
    content: "îƒ¿";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-x-mobipocket-ebook::before,#ndq-content .file--mime-application-x-mobipocket-ebook a::before {
    content: "îƒ·";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-video-quicktime::before,#ndq-content .file--mime-video-quicktime a::before {
    content: "îƒ¸";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-audio-mpeg::before,#ndq-content .file--mime-audio-mpeg a::before {
    content: "î‚…";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mpg::before,#ndq-content .file--mpg a::before {
    content: "îƒ¹";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--odt::before,#ndq-content .file--odt a::before {
    content: "îƒ»";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--application-pdf::before,#ndq-content .file--application-pdf a::before {
    content: "î‚ˆ";
    display: inline-block;
    text-decoration: none;
    color: #c00;
}

#ndq-content .widget-file--mime-image-png::before,#ndq-content .file--mime-image-png a::before {
    content: "î‚‚";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-vnd-ms-powerpoint::before,#ndq-content .file--mime-application-vnd-ms-powerpoint a::before {
    content: "î‚‰";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation a::before {
    content: "î‚‹";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow a::before {
    content: "îƒ¼";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-vnd-ms-powerpoint::before,#ndq-content .file--mime-application-vnd-ms-powerpoint a::before {
    content: "î‚Š";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12 a::before {
    content: "îƒ½";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-rar::before,#ndq-content .file--mime-application-rar a::before {
    content: "î„‚";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-application-rtf::before,#ndq-content .file--mime-application-rtf a::before {
    content: "î„€";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--rtx::before,#ndq-content .file--rtx a::before {
    content: "î„";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--swf::before,#ndq-content .file--swf a::before {
    content: "î¶";
    display: inline-block;
    text-decoration: none;
    color: #c00;
}

#ndq-content .widget-file--mime-image-tiff::before,#ndq-content .file--mime-image-tiff a::before {
    content: "î‚";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--text::before,#ndq-content .file--text a::before {
    content: "î‚Œ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-audio-x-wav::before,#ndq-content .file--mime-audio-x-wav a::before {
    content: "î„ˆ";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-audio-x-ms-wma::before,#ndq-content .file--mime-audio-x-ms-wma a::before {
    content: "î„…";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--mime-video-x-ms-wmv::before,#ndq-content .file--mime-video-x-ms-wmv a::before {
    content: "î„†";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .widget-file--xls::before,#ndq-content .file--xls a::before,#ndq-content .widget-file--x-office-spreadsheet::before,#ndq-content .file--x-office-spreadsheet a::before,#ndq-content .market-data-file-download-xls::before {
    content: "î¹";
    display: inline-block;
    text-decoration: none;
    color: #1D6F42;
}

#ndq-content .widget-file--mime-application-vnd-ms-excel-sheet-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-excel-sheet-macroEnabled-12 a::before {
    content: "î€Ÿ";
    display: inline-block;
    text-decoration: none;
    color: #1D6F42;
}

#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet a::before {
    content: "î»";
    display: inline-block;
    text-decoration: none;
    color: #1D6F42;
}

#ndq-content .widget-file--mime-application-xml::before,#ndq-content .file--mime-application-xml a::before {
    content: "î¾";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .node--type-nir-sec-filing .file--mime-application-xsd a:before,#ndq-content .node--type-nir-sec-filing .file--mime-application-xml a:before {
    content: "\\e07d";
    color: #7b41bd;
}

#ndq-content .widget-file--mime-application-zip::before,#ndq-content .file--mime-application-zip a::before {
    content: "î‚";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content [class^="ndqicon__"] a::before {
    font-size: 20px;
}

#ndq-content .ndqicon__chairperson a::before,#ndq-content span.ndqicon__chairperson::before {
    content: "î€‹";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__chairperson a_after::after {
    content: "î€‹";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content span.ndqicon__chairperson_after::after {
    content: "î€‹";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__cob a::before,#ndq-content span.ndqicon__cob::before {
    content: "î€¨";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__cob a_after::after {
    content: "î€¨";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content span.ndqicon__cob_after::after {
    content: "î€¨";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__vicechair::before,#ndq-content span.ndqicon__vicechair::before {
    content: "î€§";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__vicechair:after::after,#ndq-content span.ndqicon__vicechair:after::after {
    content: "î€§";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content span.ndqicon__vicechair_after::after {
    content: "î€§";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__leaddir::before,#ndq-content span.ndqicon__leaddir::before {
    content: "îª";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__leaddir_after::after {
    content: "îª";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content span.ndqicon__leaddir_after::after {
    content: "îª";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__chair::before {
    content: "î€¨";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__chair1::before {
    content: "îª";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__chair2::before {
    content: "î«";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__chair3::before {
    content: "î¬";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__member a::before,#ndq-content span.ndqicon__member::before {
    content: "î€Š";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__download::before {
    content: "î“";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__independent::before {
    content: "î€";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__independent_italic::before {
    content: "î€Ž";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__calculator::before,#ndq-content span.ndqicon__calculator::before {
    content: "î€²";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__calculator_after::after {
    content: "î€²";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content span.ndqicon__calculator_after::after {
    content: "î€²";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon__calculator1::before {
    content: "î€¯";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .icon-key {
    float: left;
    margin-top: 0;
}

#ndq-content .key-item {
    margin: 1em 0;
}

#ndq-content .key-item span:before {
    font-size: 20px;
}

#ndq-content .html-link a::before,#ndq-content .asset-link a::before {
    content: "î·";
    display: inline-block;
    text-decoration: none;
    color: #0472bd;
}

#ndq-content .widget-file--mime-application-octet-stream::before,#ndq-content .file--mime-application-octet-stream a::before,#ndq-content .html-link.xbrl-viewer-lik a::before,#ndq-content .html-link.xbrl-viewer-link a::before {
    content: "î„‡";
    display: inline-block;
    text-decoration: none;
    color: #7b41bd;
}

#ndq-content .add-outlook a {
    font-size: 0;
}

#ndq-content .add-outlook a::before {
    content: "î€¿";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .add-outlook a::before {
    background: #FFBC00;
    color: #fff;
    font-size: 20px;
    width: 21px;
    height: 21px;
    text-align: center;
    padding-top: 5px;
    margin-right: 5px;
    padding-left: 5px;
}

#ndq-content .add-gcal a {
    font-size: 0;
}

#ndq-content .add-gcal a::before {
    content: "î€ž";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .add-gcal a::before {
    background: #dd4b39;
    color: #fff;
    font-size: 20px;
    width: 21px;
    height: 21px;
    text-align: center;
    padding-top: 5px;
    margin-right: 5px;
    padding-left: 5px;
}

#ndq-content .right-arrow::before {
    content: "î„Œ";
    display: inline-block;
    text-decoration: none;
    color: #666;
}

#ndq-content .right-arrow::before {
    font-size: 14px;
}

#ndq-content .up-arrow::before {
    content: "î’";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .up-arrow::before {
    font-size: 14px;
}

#ndq-content .ndqicon-check-circle::before,#ndq-content .thank-you-page h1::before {
    content: "î„–";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .ndqicon-check-circle::before,#ndq-content .thank-you-page h1::before {
    font-size: 22px;
}

#ndq-content a.show-all::after {
    content: "î€’";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.show-all::after {
    font-size: 14px;
}

#ndq-content a.show-all.hide-all::after {
    content: "î€‘";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content a.show-all.hide-all::after {
    font-size: 14px;
}

#ndq-content .faq-acc-dl dt::before,#ndq-content .faq-acc-dl .acc-title::before,#ndq-content .acc-wrap dt::before,#ndq-content .acc-wrap .acc-title::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .faq-acc-dl dt::before,#ndq-content .faq-acc-dl .acc-title::before,#ndq-content .acc-wrap dt::before,#ndq-content .acc-wrap .acc-title::before {
    color: white;
    font-size: 14px;
}

#ndq-content .faq-acc-dl dt.opened::before,#ndq-content .faq-acc-dl .acc-title.opened::before,#ndq-content .acc-wrap dt.opened::before,#ndq-content .acc-wrap .acc-title.opened::before {
    content: "î";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .faq-acc-dl dt.opened::before,#ndq-content .faq-acc-dl .acc-title.opened::before,#ndq-content .acc-wrap dt.opened::before,#ndq-content .acc-wrap .acc-title.opened::before {
    color: white;
    font-size: 14px;
}

#ndq-content .top-link::after {
    content: "î’";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .top-link::after {
    font-size: 14px;
    margin-top: -4px;
}



#ndq-content [dir="rtl"] .autocomplete,#ndq-content [dir="rtl"] html.js input.form-autocomplete,#ndq-content html.js [dir="rtl"] input.form-autocomplete {
    background-position: 0% 2px;
}

#ndq-content .autocomplete.is-throbbing,#ndq-content .autocomplete--is-throbbing,#ndq-content html.js input.is-throbbing.form-autocomplete,#ndq-content html.js input.throbbing {
    background-position: 100% -18px;
}

#ndq-content [dir="rtl"] .autocomplete.is-throbbing,#ndq-content [dir="rtl"] .autocomplete--is-throbbing,#ndq-content [dir="rtl"] html.js input.is-throbbing.form-autocomplete,#ndq-content html.js [dir="rtl"] input.is-throbbing.form-autocomplete,#ndq-content [dir="rtl"] html.js input.throbbing,#ndq-content html.js [dir="rtl"] input.throbbing {
    background-position: 0% -18px;
}

#ndq-content .autocomplete__list-wrapper,#ndq-content #autocomplete {
    border: 1px solid;
    overflow: hidden;
    position: absolute;
    z-index: 100;
}

#ndq-content .autocomplete__list,#ndq-content #autocomplete ul {
    list-style: none;
    list-style-image: none;
    margin: 0;
    padding: 0;
}

#ndq-content .autocomplete__list-item,#ndq-content #autocomplete li {
    background: #fff;
    color: #000;
    cursor: default;
    white-space: pre;
    zoom:1;}

#ndq-content .autocomplete__list-item--is-selected,#ndq-content #autocomplete .selected {
    background: #0480a9;
    color: #fff;
}

#ndq-content .box,#ndq-content .box__right {
    border: 1px solid var(--border-color,#cbcbcd);
    padding: 1em;
}

#ndq-content .box__title {
    margin: 0;
}

#ndq-content .box--highlight {
    border-color: #0480a9;
}

#ndq-content .box__right {
    margin-left: 1.5em !important;
    margin-bottom: 1em;
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
}

@media (min-width: 1024px) {
    #ndq-content .box__right {
        width:30.37975%;
        margin-right: 0;
        float: right;
    }
}

@media print {
    #ndq-content .breadcrumb {
        display: none;
    }
}

#ndq-content .breadcrumb__list {
    margin: 0;
    padding: 0;
}

#ndq-content .breadcrumb__item {
    display: inline;
    list-style-type: none;
    margin: 0;
    padding: 0;
}

#ndq-content .nir-chart {
    margin: 15px;
}

#ndq-content .collapsible-fieldset,#ndq-content .collapsible {
    position: relative;
}

#ndq-content .collapsible-fieldset.is-collapsed,#ndq-content .collapsible-fieldset--is-collapsed,#ndq-content .is-collapsed.collapsible,#ndq-content .collapsible.collapsed {
    border-bottom-width: 0;
    border-left-width: 0;
    border-right-width: 0;
    height: 1em;
}

#ndq-content .is-collapsed .collapsible-fieldset__wrapper,#ndq-content .collapsible-fieldset--is-collapsed__wrapper,#ndq-content .collapsible.collapsed .fieldset-wrapper {
    display: none;
}


#ndq-content [dir="rtl"] .collapsible-fieldset__legend,#ndq-content [dir="rtl"] .collapsible .fieldset-legend,#ndq-content .collapsible [dir="rtl"] .fieldset-legend {
    padding-left: 0;
    padding-right: 15px;
    background-position: 98% 75%;
}



#ndq-content .collapsible-fieldset__summary,#ndq-content .collapsible .fieldset-legend .summary {
    color: #847271;
    font-size: .9em;
    margin-left: 0.5em;
}

#ndq-content .comment__section,#ndq-content .comments {
    margin: 1.42857em 0;
}

#ndq-content .comment__title {
    margin: 0;
}

#ndq-content .comment__permalink {
    text-transform: uppercase;
    font-size: 75%;
}

#ndq-content .comment--preview,#ndq-content .comment-preview {
    background-color: #fffadb;
}

#ndq-content .comment--nested,#ndq-content .indented {
    margin-left: 28px;
}

#ndq-content [dir="rtl"] .comment--nested,#ndq-content [dir="rtl"] .indented {
    margin-left: 0;
    margin-right: 28px;
}

#ndq-content table.dataTable {
    table-layout: auto;
}

#ndq-content table.dataTable thead th,#ndq-content table.dataTable tfoot th {
    font-weight: bold;
}

#ndq-content table.dataTable thead th:active,#ndq-content table.dataTable thead td:active {
    outline: none;
}


#ndq-content table.dataTable thead .sorting,#ndq-content table.dataTable thead .sorting_asc,#ndq-content table.dataTable thead .sorting_desc,#ndq-content table.dataTable thead .sorting_asc_disabled,#ndq-content table.dataTable thead .sorting_desc_disabled {
    background-repeat: no-repeat;
    background-position: center right;
}


#ndq-content table.dataTable tbody tr.selected {
    background-color: #B0BED9;
}

#ndq-content table.dataTable.stripe tbody tr.odd,#ndq-content table.dataTable.display tbody tr.odd {
    background-color: #f9f9f9;
}

#ndq-content table.dataTable.stripe tbody tr.odd.selected,#ndq-content table.dataTable.display tbody tr.odd.selected {
    background-color: #acbad4;
}

#ndq-content table.dataTable.hover tbody tr:hover,#ndq-content table.dataTable.display tbody tr:hover {
    background-color: #f6f6f6;
}

#ndq-content table.dataTable.hover tbody tr:hover.selected,#ndq-content table.dataTable.display tbody tr:hover.selected {
    background-color: #aab7d1;
}

#ndq-content table.dataTable.order-column tbody tr > .sorting_1,#ndq-content table.dataTable.order-column tbody tr > .sorting_2,#ndq-content table.dataTable.order-column tbody tr > .sorting_3,#ndq-content table.dataTable.display tbody tr > .sorting_1,#ndq-content table.dataTable.display tbody tr > .sorting_2,#ndq-content table.dataTable.display tbody tr > .sorting_3 {
    background-color: #fafafa;
}

#ndq-content table.dataTable.order-column tbody tr.selected > .sorting_1,#ndq-content table.dataTable.order-column tbody tr.selected > .sorting_2,#ndq-content table.dataTable.order-column tbody tr.selected > .sorting_3,#ndq-content table.dataTable.display tbody tr.selected > .sorting_1,#ndq-content table.dataTable.display tbody tr.selected > .sorting_2,#ndq-content table.dataTable.display tbody tr.selected > .sorting_3 {
    background-color: #acbad5;
}

#ndq-content table.dataTable.display tbody tr.odd > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.odd > .sorting_1 {
    background-color: #f1f1f1;
}

#ndq-content table.dataTable.display tbody tr.odd > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.odd > .sorting_2 {
    background-color: #f3f3f3;
}

#ndq-content table.dataTable.display tbody tr.odd > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.odd > .sorting_3 {
    background-color: whitesmoke;
}

#ndq-content table.dataTable.display tbody tr.odd.selected > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.odd.selected > .sorting_1 {
    background-color: #a6b4cd;
}

#ndq-content table.dataTable.display tbody tr.odd.selected > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.odd.selected > .sorting_2 {
    background-color: #a8b5cf;
}

#ndq-content table.dataTable.display tbody tr.odd.selected > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.odd.selected > .sorting_3 {
    background-color: #a9b7d1;
}

#ndq-content table.dataTable.display tbody tr.even > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.even > .sorting_1 {
    background-color: #fafafa;
}

#ndq-content table.dataTable.display tbody tr.even > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.even > .sorting_2 {
    background-color: #fcfcfc;
}

#ndq-content table.dataTable.display tbody tr.even > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.even > .sorting_3 {
    background-color: #fefefe;
}

#ndq-content table.dataTable.display tbody tr.even.selected > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.even.selected > .sorting_1 {
    background-color: #acbad5;
}

#ndq-content table.dataTable.display tbody tr.even.selected > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.even.selected > .sorting_2 {
    background-color: #aebcd6;
}

#ndq-content table.dataTable.display tbody tr.even.selected > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.even.selected > .sorting_3 {
    background-color: #afbdd8;
}

#ndq-content table.dataTable.display tbody tr:hover > .sorting_1,#ndq-content table.dataTable.order-column.hover tbody tr:hover > .sorting_1 {
    background-color: #eaeaea;
}

#ndq-content table.dataTable.display tbody tr:hover > .sorting_2,#ndq-content table.dataTable.order-column.hover tbody tr:hover > .sorting_2 {
    background-color: #ececec;
}

#ndq-content table.dataTable.display tbody tr:hover > .sorting_3,#ndq-content table.dataTable.order-column.hover tbody tr:hover > .sorting_3 {
    background-color: #efefef;
}

#ndq-content table.dataTable.display tbody tr:hover.selected > .sorting_1,#ndq-content table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_1 {
    background-color: #a2aec7;
}

#ndq-content table.dataTable.display tbody tr:hover.selected > .sorting_2,#ndq-content table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_2 {
    background-color: #a3b0c9;
}

#ndq-content table.dataTable.display tbody tr:hover.selected > .sorting_3,#ndq-content table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_3 {
    background-color: #a5b2cb;
}

#ndq-content table.dataTable.nowrap th,#ndq-content table.dataTable.nowrap td {
    white-space: nowrap;
}

#ndq-content table.dataTable.compact thead th,#ndq-content table.dataTable.compact thead td {
    padding: 4px 17px 4px 4px;
}

#ndq-content table.dataTable.compact tfoot th,#ndq-content table.dataTable.compact tfoot td {
    padding: 4px;
}

#ndq-content table.dataTable.compact tbody th,#ndq-content table.dataTable.compact tbody td {
    padding: 4px;
}

#ndq-content table.dataTable th.dt-left,#ndq-content table.dataTable td.dt-left {
    text-align: left;
}

#ndq-content table.dataTable th.dt-center,#ndq-content table.dataTable td.dt-center,#ndq-content table.dataTable td.dataTables_empty {
    text-align: center;
}

#ndq-content table.dataTable th.dt-right,#ndq-content table.dataTable td.dt-right {
    text-align: right;
}

#ndq-content table.dataTable th.dt-justify,#ndq-content table.dataTable td.dt-justify {
    text-align: justify;
}

#ndq-content table.dataTable th.dt-nowrap,#ndq-content table.dataTable td.dt-nowrap {
    white-space: nowrap;
}

#ndq-content table.dataTable thead th.dt-head-left,#ndq-content table.dataTable thead td.dt-head-left,#ndq-content table.dataTable tfoot th.dt-head-left,#ndq-content table.dataTable tfoot td.dt-head-left {
    text-align: left;
}

#ndq-content table.dataTable thead th.dt-head-center,#ndq-content table.dataTable thead td.dt-head-center,#ndq-content table.dataTable tfoot th.dt-head-center,#ndq-content table.dataTable tfoot td.dt-head-center {
    text-align: center;
}

#ndq-content table.dataTable thead th.dt-head-right,#ndq-content table.dataTable thead td.dt-head-right,#ndq-content table.dataTable tfoot th.dt-head-right,#ndq-content table.dataTable tfoot td.dt-head-right {
    text-align: right;
}

#ndq-content table.dataTable thead th.dt-head-justify,#ndq-content table.dataTable thead td.dt-head-justify,#ndq-content table.dataTable tfoot th.dt-head-justify,#ndq-content table.dataTable tfoot td.dt-head-justify {
    text-align: justify;
}

#ndq-content table.dataTable thead th.dt-head-nowrap,#ndq-content table.dataTable thead td.dt-head-nowrap,#ndq-content table.dataTable tfoot th.dt-head-nowrap,#ndq-content table.dataTable tfoot td.dt-head-nowrap {
    white-space: nowrap;
}

#ndq-content table.dataTable tbody th.dt-body-left,#ndq-content table.dataTable tbody td.dt-body-left {
    text-align: left;
}

#ndq-content table.dataTable tbody th.dt-body-center,#ndq-content table.dataTable tbody td.dt-body-center {
    text-align: center;
}

#ndq-content table.dataTable tbody th.dt-body-right,#ndq-content table.dataTable tbody td.dt-body-right {
    text-align: right;
}

#ndq-content table.dataTable tbody th.dt-body-justify,#ndq-content table.dataTable tbody td.dt-body-justify {
    text-align: justify;
}

#ndq-content table.dataTable tbody th.dt-body-nowrap,#ndq-content table.dataTable tbody td.dt-body-nowrap {
    white-space: nowrap;
}

#ndq-content table.dataTable,#ndq-content table.dataTable th,#ndq-content table.dataTable td {
    box-sizing: content-box;
}



#ndq-content .dataTables_wrapper .dataTables_length {
    float: left;
}

#ndq-content .dataTables_wrapper .dataTables_filter {
    float: right;
    text-align: left;
}

#ndq-content .dataTables_wrapper .dataTables_filter input {
    margin-bottom: 0.5em;
}

#ndq-content .dataTables_wrapper .dataTables_info {
    clear: both;
    float: left;
    padding-top: 0.755em;
}

#ndq-content .dataTables_wrapper .dataTables_paginate .ellipsis {
    padding: 0 1em;
}

#ndq-content .dataTables_wrapper .dataTables_processing {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 40px;
    margin-left: -50%;
    margin-top: -25px;
    padding-top: 20px;
    text-align: center;
    font-size: 1.2em;
    background-color: white;
    background: linear-gradient(to right,rgba(255,255,255,0) 0%,rgba(255,255,255,0.9) 25%,rgba(255,255,255,0.9) 75%,rgba(255,255,255,0) 100%);
}


#ndq-content .dataTables_wrapper .dataTables_scroll {
    clear: both;
}


#ndq-content .dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody th > div.dataTables_sizing,#ndq-content .dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody td > div.dataTables_sizing {
    height: 0;
    overflow: hidden;
    margin: 0 !important;
    padding: 0 !important;
}

#ndq-content .dataTables_wrapper:after {
    visibility: hidden;
    display: block;
    content: "";
    clear: both;
    height: 0;
}

@media screen and (max-width: 767px) {
    #ndq-content .nir-datatables thead td {
        display:none;
    }

    #ndq-content .dataTables_wrapper .dataTables_info,#ndq-content .dataTables_wrapper .dataTables_paginate {
        float: none;
        text-align: center;
    }

    #ndq-content .dataTables_wrapper .dataTables_paginate {
        margin-top: 0.5em;
    }
}

@media screen and (max-width: 640px) {
    #ndq-content .dataTables_wrapper .dataTables_filter {
        margin-top:0.5em;
    }
}

#ndq-content .dataTables_length select {
    display: inline;
    margin-bottom: 5px;
}

#ndq-content .block-nir-attribution-block {
    float: left;
    padding: 0 1em;
}

#ndq-content .block-nir-attribution-block > p {
    margin-top: 20px;
}

#ndq-content hr,#ndq-content .divider {
    margin: 1.42857em 0;
    border: 0;
    border-bottom: 3px solid #0480a9;
}

#ndq-content hr > :first-child,#ndq-content .divider > :first-child {
    margin-top: 1.42857em;
}

#ndq-content form.views-exposed-form .form-item {
    margin-bottom: 1em;
    float: left;
    margin-right: 12px;
}

#ndq-content form.views-exposed-form .form-actions {
    margin: 38px 0 0 0;
}

@media (max-width: 481px) {
    #ndq-content form.views-exposed-form .form-actions {
        clear:both;
    }
}

#ndq-content form.views-exposed-form .form-item-items-per-page label::after {
    content: ":";
}

#ndq-content .region .block.block-facets {
    padding: 0px;
    margin: 0;
}

#ndq-content .region .block.block-facets h2 {
    display: inline-block;
    font-size: 14px;
    line-height: 1.42857;
    margin: 0;
    border-bottom: 0;
}

#ndq-content .region .block.block-facets ul {
    padding: 0;
    margin: 0;
}

#ndq-content .region .block.block-facets ul li {
    margin: 0.4em 0 0.4em 2em;
}

#ndq-content .field--label-inline {
    display: block;
}

#ndq-content .field--label-inline * {
    display: inline;
}

#ndq-content .field--label-inline .field__label::after {
    content: ":";
}

#ndq-content .full-name {
    font-weight: bold;
}

#ndq-content .field__centered {
    width: 100%;
    text-align: center;
}

#ndq-content .field__light-italic {
    font-style: italic;
    color: #847271;
}

#ndq-content .small-inline-label {
    font-size: 11px;
    float: left;
    margin-right: 0.5em;
}

#ndq-content .form-item {
    margin: 1.42857em 0;
}

#ndq-content .form-item__required::after,#ndq-content .form-required::after {
    content: "*";
    color: #c00;
    display: inline;
    margin: 0 0 0 5px;
}

#ndq-content .form-item__description,#ndq-content .form-item .description {
    font-size: 1.1em;
}

#ndq-content .form-item--inline div,#ndq-content .form-item--inline label,#ndq-content .container-inline .form-item div,#ndq-content .container-inline .form-item label {
    display: inline;
}

#ndq-content .form-item--inline__exception,#ndq-content .container-inline .fieldset-wrapper {
    display: block;
}

#ndq-content .form-item--tight,#ndq-content .form-item--radio,#ndq-content .form-type-radio,#ndq-content .form-type-checkbox,#ndq-content .password-parent,#ndq-content .confirm-parent,#ndq-content table .form-item {
    margin: 0;
}

#ndq-content .form-item--radio__label,#ndq-content .form-item--radio .form-item__label,#ndq-content label.option,#ndq-content .form-type-radio .form-item__label,#ndq-content .form-type-checkbox .form-item__label {
    display: inline;
    font-weight: normal;
}

#ndq-content .form-item--radio__description,#ndq-content .form-item--radio .form-item__description,#ndq-content .form-type-radio .description,#ndq-content .form-type-checkbox .description,#ndq-content .form-type-radio .form-item__description,#ndq-content .form-type-checkbox .form-item__description,#ndq-content .form-item--radio .form-item .description,#ndq-content .form-item .form-item--radio .description,#ndq-content .form-type-radio .form-item .description,#ndq-content .form-item .form-type-radio .description,#ndq-content .form-type-checkbox .form-item .description,#ndq-content .form-item .form-type-checkbox .description {
    margin-left: 1.4em;
}

#ndq-content .form-item.is-error .form-item__widget,#ndq-content .form-item--is-error__widget,#ndq-content .form-item.is-error input,#ndq-content .form-item.is-error textarea,#ndq-content .form-item.is-error select,#ndq-content .form-item--is-error input,#ndq-content .form-item--is-error textarea,#ndq-content .form-item--is-error select,#ndq-content .form-item input.error,#ndq-content .form-item textarea.error,#ndq-content .form-item select.error {
    border: 1px solid #c00;
}

#ndq-content .form-note .form-required::after {
    margin: 0px;
}

#ndq-content .captcha {
    margin-bottom: 1em;
}

#ndq-content .view-nir-glossary .views-row {
    margin-bottom: 20px;
}

#ndq-content .highlight-mark,#ndq-content .new,#ndq-content .update {
    color: #c00;
    background-color: transparent;
}

#ndq-content .inline-links,#ndq-content .inline.links {
    padding: 0;
}

#ndq-content .inline-links__item,#ndq-content .inline.links li {
    display: inline;
    list-style-type: none;
    padding: 0 1em 0 0;
}

#ndq-content [dir="rtl"] .inline-links__item,#ndq-content [dir="rtl"] .inline.links li,#ndq-content .inline.links [dir="rtl"] li {
    display: inline-block;
    padding: 0 0 0 1em;
}

#ndq-content .inline-sibling,#ndq-content span.field-label,#ndq-content .field__label-inline {
    display: inline;
    margin-right: 10px;
}

#ndq-content [dir="rtl"] .inline-sibling,#ndq-content [dir="rtl"] span.field-label,#ndq-content [dir="rtl"] .field__label-inline {
    margin-right: 0;
    margin-left: 10px;
}

#ndq-content .inline-sibling__child,#ndq-content .inline-sibling *,#ndq-content span.field-label *,#ndq-content .field__label-inline * {
    display: inline;
}

#ndq-content .inline-sibling__adjacent,#ndq-content .inline-sibling + *,#ndq-content .inline-sibling + * > *:first-child,#ndq-content .field__items-inline,#ndq-content span.field-label + *,#ndq-content .field__label-inline + *,#ndq-content span.field-label + * > *:first-child,#ndq-content .field__label-inline + * > *:first-child {
    display: inline;
}

#ndq-content .ipe-category-picker-search input[type="text"] {
    display: inline;
    width: 183px;
}

#ndq-content #panels-ipe-tray .ipe-tab-wrapper ul.ipe-tabs li {
    margin: 0px !important;
    padding: 0px !important;
}

#ndq-content #panels-ipe-tray .ipe-tab-wrapper ul.ipe-tabs li.ipe-tab > a:link {
    text-decoration: none !important;
    color: black !important;
}

#ndq-content .ipe-block-plugin-info p {
    padding: 0 10px 10px 10px;
}

#ndq-content .dcsns-content *,#ndq-content .dcsns-toolbar * {
    box-sizing: content-box;
}

#ndq-content .dcsns-content blockquote {
    margin: 0;
}

#ndq-content .stream li.dcsns-tumblr .section-text img {
    max-width: 99%;
}

#ndq-content .dcsns-flickr .stream li .section-title {
    width: 100%;
}

#ndq-content .light_1 .stream li .section-title,#ndq-content .light_2 .stream li .section-title {
    color: #666;
}

#ndq-content .dark_2 .stream li .icon {
    position: absolute;
    left: 4px;
    bottom: 2px;
    z-index: 2;
    width: 22px;
}

#ndq-content .language-switcher-language-url ul {
    float: right;
}

#ndq-content .language-switcher-language-url ul .is-active {
    color: #000;
}

#ndq-content .ui-dialog {
    background: transparent;
    border: 0;
    position: absolute;
    z-index: 1260;
    padding: 0;
}

@media all and (max-width: 48em) {
    #ndq-content .ui-dialog {
        min-width:92%;
        max-width: 92%;
    }
}

#ndq-content .ui-dialog {
    -ms-box-shadow: 0 0 5px #847271;
    -o-box-shadow: 0 0 5px #847271;
    box-shadow: 0 0 5px #847271;
}

#ndq-content .ui-dialog:focus {
    outline: none;
}

#ndq-content .ui-icon,#ndq-content .ui-widget-content .ui-icon {
    background: none;
}

#ndq-content .ui-widget-content {
    border: 0;
}

#ndq-content .ui-widget-header {
    border: 0;
}

#ndq-content .ui-widget {
    font-family: inherit;
    font-size: inherit;
}

#ndq-content .ui-dialog .ui-dialog-titlebar {
    background: #fff;
    border-radius: 0;
    padding: 0;
    height: 0;
}

#ndq-content [dir="rtl"] .ui-dialog .ui-dialog-titlebar {
    padding-left: 49px;
    padding-right: 15px;
}

#ndq-content .ui-dialog .ui-dialog-title {
    font-size: 1.231em;
    font-weight: 600;
    margin: 0;
    color: #ffffff;
    -webkit-font-smoothing: antialiased;
}

#ndq-content .ui-dialog .ui-dialog-titlebar-close {
    border: 0;
    background: none;
    right: 23px;
    top: 5px;
    margin: 0;
    height: 16px;
    width: 16px;
    position: absolute;
}

#ndq-content .ui-dialog .ui-dialog-titlebar-close:before {
    font-size: 35px;
    position: absolute;
}

#ndq-content [dir="rtl"] .ui-dialog .ui-dialog-titlebar-close {
    right: auto;
    left: 20px;
}

#ndq-content .ui-dialog .ui-icon.ui-icon-closethick {
    margin-top: -12px;
}

#ndq-content .ui-dialog .ui-widget-content.ui-dialog-content {
    border-top: 0;
    background: #ffffff;
    overflow: auto;
    padding: 20px;
    font-size: 15px;
}

#ndq-content .views-ui-dialog .ui-widget-content.ui-dialog-content {
    padding: 0;
}

#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane {
    color: #fff;
    padding: 0;
    width: 100%;
    appearance: none;
}

#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button {
    background: #0480a9;
    border: inherit;
    border-radius: 4px;
    color: white;
    margin: 0;
    padding: 10px 15px;
}

#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:hover,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:focus {
    background: #0184A2;
    color: #fff;
}

#ndq-content .ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
    margin: 0 20px 20px 20px;
    padding: 0;
    text-align: center;
    float: none;
}

#ndq-content .ui-dialog .ui-dialog-buttonpane .ui-button-text-only .ui-button-text {
    padding: 0;
}

#ndq-content .ui-dialog .ui-dialog-content {
    position: static;
}

#ndq-content .ui-dialog .ui-dialog-content .form-actions {
    padding: 0;
    margin: 0;
}



#ndq-content [dir="rtl"] .ui-dialog .ajax-progress-throbber {
    left: auto;
    right: 49%;
}

#ndq-content .ui-dialog .ajax-progress-throbber .throbber,#ndq-content .ui-dialog .ajax-progress-throbber .message {
    display: none;
}

#ndq-content .more-link,#ndq-content .more-help-link {
    text-align: right;
}

#ndq-content [dir="rtl"] .more-link,#ndq-content [dir="rtl"] .more-help-link {
    text-align: left;
}



#ndq-content [dir="rtl"] .more-link__help-icon,#ndq-content [dir="rtl"] .more-help-link a,#ndq-content .more-help-link [dir="rtl"] a {
    padding: 1px 20px 1px 0;
    background-position: 100% 50%;
}

#ndq-content #mobile-header {
    position: absolute;
    right: 10px;
    top: 10px;
}

#ndq-content #responsive-menu-button:hover,#ndq-content #responsive-menu-button:focus {
    text-decoration: none;
}

#ndq-content .menu--irhorizontal {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

@media (min-width: 769px) {
    #ndq-content #mobile-header {
        position:absolute !important;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip: rect(1px,1px,1px,1px);
    }

    #ndq-content .menu--irhorizontal {
        position: static !important;
        clip: auto;
        height: auto;
        width: auto;
        overflow: auto;
    }
}

#ndq-content .sidr-class-visually-hidden {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

#ndq-content #header-region {
    position: relative;
}

#ndq-content .toolbar-vertical {
    padding-top: 39px;
}

#ndq-content .navbar,#ndq-content .main-navigation .links,#ndq-content .main-navigation .menu {
    margin: 1em 0;
    padding: 0;
    text-align: left;
}

#ndq-content [dir="rtl"] .navbar,#ndq-content [dir="rtl"] .main-navigation .links,#ndq-content .main-navigation [dir="rtl"] .links,#ndq-content [dir="rtl"] .main-navigation .menu,#ndq-content .main-navigation [dir="rtl"] .menu {
    text-align: right;
}

#ndq-content .navbar__item,#ndq-content .navbar li,#ndq-content .main-navigation .links li,#ndq-content .main-navigation .menu li {
    float: left;
    margin: .4em 2em .4em 2em;
    list-style-type: none;
    list-style-image: none;
}

#ndq-content .navbar__item:hover > ul,#ndq-content .navbar li:hover > ul,#ndq-content .main-navigation .links li:hover > ul,#ndq-content .main-navigation .menu li:hover > ul {
    display: block;
    position: absolute;
    background: #fff;
    background: rgba(255,255,255,0.9);
}

#ndq-content [dir="rtl"] .navbar__item,#ndq-content [dir="rtl"] .navbar li,#ndq-content [dir="rtl"] .main-navigation .links li,#ndq-content .main-navigation [dir="rtl"] .links li,#ndq-content [dir="rtl"] .main-navigation .menu li,#ndq-content .main-navigation [dir="rtl"] .menu li {
    float: right;
    padding: 0 0 0 10px;
}

#ndq-content .navbar__item .menu,#ndq-content .navbar li .menu,#ndq-content .main-navigation .links li .menu,#ndq-content .main-navigation .menu li .menu {
    display: none;
}

#ndq-content .navbar__item .menu li,#ndq-content .navbar li .menu li,#ndq-content .main-navigation .links li .menu li,#ndq-content .main-navigation .menu li .menu li {
    float: none;
    margin-left: 15px;
    font-size: 0.8em;
    line-height: 1.7em;
}

#ndq-content .block-nir-website-notices {
    display: none;
}

#ndq-content .notification-modal .ui-dialog {
    font-size: 1.1em;
    line-height: 1.5em;
}

#ndq-content .pager {
    clear: both;
    padding: 0;
    text-align: center;
}

@media print {
    #ndq-content .pager {
        display: none;
    }
}

#ndq-content .pager__item,#ndq-content .pager__current-item,#ndq-content .pager .is-active,#ndq-content .pager-current,#ndq-content .pager-item,#ndq-content .pager-first,#ndq-content .pager-previous,#ndq-content .pager-next,#ndq-content .pager-last,#ndq-content .pager-ellipsis {
    display: inline-block;
    padding: 5px 8px;
    list-style-type: none;
    background-image: none;
}

#ndq-content .pager__current-item,#ndq-content .pager .is-active,#ndq-content .pager-current {
    font-weight: bold;
    background-color: #0480a9;
    border-radius: 4px;
    padding: 10px 15px;
    color: #fff;
}

#ndq-content .pager__current-item a,#ndq-content .pager .is-active a,#ndq-content .pager-current a {
    color: white;
}

#ndq-content .pager__items {
    float: left;
    width: 100%;
    padding: 0;
}

#ndq-content .results-summary {
    text-align: center;
}

#ndq-content .progress-bar,#ndq-content .progress {
    font-weight: bold;
}

#ndq-content .progress-bar__bar,#ndq-content .progress .bar {
    border-radius: 3px;
    margin: 0 .2em;
    border: 1px solid #666;
    background-color: #ddd;
}


#ndq-content .progress-bar__percentage,#ndq-content .progress .percentage {
    float: right;
}

#ndq-content [dir="rtl"] .progress-bar__percentage,#ndq-content [dir="rtl"] .progress .percentage,#ndq-content .progress [dir="rtl"] .percentage {
    float: left;
}

#ndq-content .progress-bar--inline,#ndq-content .ajax-progress-bar {
    width: 16em;
    display: inline-block;
}

#ndq-content [dir="rtl"] .progress-bar--inline,#ndq-content [dir="rtl"] .ajax-progress-bar {
    float: right;
}

#ndq-content .progress-throbber,#ndq-content .ajax-progress {
    display: inline-block;
}

#ndq-content [dir="rtl"] .progress-throbber,#ndq-content [dir="rtl"] .ajax-progress {
    float: right;
}

#ndq-content [dir="rtl"] .progress-throbber__widget,#ndq-content [dir="rtl"] .ajax-progress .throbber,#ndq-content .ajax-progress [dir="rtl"] .throbber {
    float: right;
}

#ndq-content .progress-throbber__widget-in-tr,#ndq-content tr .ajax-progress .throbber {
    margin: 0 2px;
}

#ndq-content .progress-throbber__message,#ndq-content .ajax-progress .message {
    padding-left: 20px;
}

#ndq-content .nir-mean-value-rating {
    width: 100%;
    padding-top: 70px;
}

#ndq-content .nir-mean-value-rating .rating-box {
    width: 20%;
    height: 16px;
    float: left;
}

#ndq-content .nir-mean-value-rating .sell {
    float: left;
}

#ndq-content .nir-mean-value-rating .strongbuy {
    float: right;
}

#ndq-content .nir-mean-value-rating h3 {
    text-align: center;
}

#ndq-content .nir-mean-value-rating .mean-recommendation {
    text-align: center;
    font-weight: bold;
}

#ndq-content .nir-mean-value-rating .rating {
    position: relative;
    padding: 10px 0 35px;
    width: 85%;
    margin: 0 auto;
    max-width: 135px;
}

#ndq-content .nir-mean-value-rating .rating-arrow {
    display: block;
    height: 10px;
    width: 10px;
    top: -8px;
    position: absolute;
}

#ndq-content .nir-mean-value-rating .rating-arrow::after {
    content: "î€’";
    display: inline-block;
    text-decoration: none;
    color: #000;
}

#ndq-content .nir-mean-value-rating .rating-arrow::after {
    font-size: 16px;
    margin-left: 5px;
}

#ndq-content .nir-mean-value-rating .clearfix {
    clear: both;
    max-width: 230px;
    margin: 0 auto;
}

#ndq-content .block-market-data-block__estimates__analyst-ratings {
    float: left;
    width: 100%;
}

@media (min-width: 1024px) {
    #ndq-content .block-market-data-block__estimates__analyst-ratings > div {
        float:left;
        max-width: 50%;
        margin: 0;
    }
}

#ndq-content .resizable-textarea {
    width: 100%;
    vertical-align: bottom;
}



#ndq-content .responsive-video,#ndq-content .media-youtube-video,#ndq-content .media-vimeo-preview-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
}

#ndq-content .responsive-video__embed,#ndq-content .responsive-video iframe,#ndq-content .media-youtube-video iframe,#ndq-content .media-vimeo-preview-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

#ndq-content .responsive-video--4-3 {
    padding-bottom: 75%;
}

#ndq-content .block-search-form form,#ndq-content .view-search form {
    position: relative;
}

#ndq-content .block-search-form form input[type=search],#ndq-content .block-search-form form input[type=text],#ndq-content .view-search form input[type=search],#ndq-content .view-search form input[type=text] {
    width: 100%;
    box-sizing: border-box;
    margin: 0;
}

#ndq-content .block-search-form form input[type=submit],#ndq-content .view-search form input[type=submit] {
    border: 0;
    background: transparent;
    position: absolute;
    text-indent: -8472719px;
    padding: 10px 25px;
    top: 0;
    right: 0;
    margin: 0;
    z-index: 100;
}

#ndq-content .block-search-form form .form-type-textfield,#ndq-content .view-search form .form-type-textfield {
    width: 100%;
    margin: 0;
}

#ndq-content .block-search-form form::after,#ndq-content .view-search form::after {
    content: "î€¹";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .block-search-form form::after,#ndq-content .view-search form::after {
    position: absolute;
    top: 3px;
    right: 0;
    z-index: 99;
    font-size: 33px;
    padding: 11px 9px;
}

#ndq-content .block-search-form .view-content,#ndq-content .view-search .view-content {
    margin-top: 25px;
}

#ndq-content .search-result {
    margin-bottom: 20px;
}

#ndq-content .search-result:before {
    content: '';
    display: table;
}

#ndq-content .search-result:after {
    content: '';
    display: table;
    clear: both;
}

#ndq-content .search-result-contenttype {
    display: block;
    color: #666;
    font-size: 12px;
}

#ndq-content .search-result-title {
    font-size: 1.2em;
    margin-bottom: 5px;
    margin-top: 0;
}

#ndq-content .search-result-thumbnail {
    float: left;
    width: 24%;
    position: relative;
    overflow: hidden;
    margin-right: 10px;
    margin-top: 4px;
    margin-bottom: 0;
}

#ndq-content .search-result-thumbnail img {
    max-width: 100%;
}

#ndq-content .search-result .external-link h3 {
    display: inline;
}

#ndq-content .search-result h3 {
    margin-bottom: 5px;
    margin-top: 0;
}

#ndq-content .search-result-snippet-wrapper {
    float: left;
    width: 73%;
}

#ndq-content .search-result-snippet-wrapper-full {
    width: 100%;
}

#ndq-content .search-result .item-list {
    display: inline;
}

#ndq-content .search-result .item-list ul {
    margin-top: 0;
    padding: 0;
}

#ndq-content .search-result .item-list ul li {
    list-style-type: none;
}

#ndq-content .search-result-tags {
    font-size: 11px;
    margin-top: 8px;
}

#ndq-content .search-result-tags ul {
    margin: 0;
    padding: 0;
    display: inline;
}

#ndq-content .search-result-tags .item-list {
    display: inline;
}

#ndq-content .search-result-tags li {
    margin: 0 2px 5px 0;
    padding: 0;
    list-style-type: none;
    display: inline-block;
    font-weight: normal;
    color: #fff;
}

#ndq-content .search-result-tags li a {
    background: #ddd;
    padding: 2px 6px;
    border-radius: 3px;
    color: #333;
}

#ndq-content .search-result-tags li a:link,#ndq-content .search-result-tags li a:visited,#ndq-content .search-result-tags li a:hover,#ndq-content .search-result-tags li a:active {
    color: #333;
}

#ndq-content .search-result .file a::before {
    line-height: 26px;
}

#ndq-content .view-search .views-exposed-form label {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

#ndq-content .view-search .inline-asset {
    display: inline-block;
}

#ndq-content .view-search .inline-asset .field__item {
    margin: 0;
    padding: 0;
}

#ndq-content .view-search .inline-asset .filesize {
    display: none;
}

#ndq-content .view-search .inline-asset span.file--application-pdf::before {
    content: "î‚ˆ";
    display: inline-block;
    text-decoration: none;
    color: #c00;
}

#ndq-content .view-search .inline-asset span.file--application-pdf a {
    display: none;
}

#ndq-content .view-search .inline-asset span.file--application-pdf a:hover {
    text-decoration: none;
}

#ndq-content .view-search .inline-asset span.file--application-pdf::before {
    padding: 0;
}

#ndq-content .search-result-snippet-wrapper p:first-child {
    padding-top: 0;
    margin-top: 0;
}

#ndq-content .nir-sec-header {
    font-size: 14px;
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    float: left;
    width: 100%;
    background-color: #fff;
    border-bottom: 1px dotted var(--border-color,#cbcbcd);
    padding: 10px;
    margin-bottom: 10px;
}

#ndq-content .nir-sec-header h1 {
    color: black;
    font-size: 1.5em;
    font-weight: bold;
    float: left;
    line-height: 1.42857em;
    margin: 0;
    padding: 0;
}

#ndq-content .nir-sec-header .logo {
    width: 30px;
    float: left;
    margin-right: 5px;
}

#ndq-content .nir-sec-header .logo img {
    height: 30px;
}

#ndq-content .nir-sec-header .sec-docs {
    float: right;
}

#ndq-content .nir-sec-header .file a {
    font-size: 0px;
    text-decoration: none;
}

#ndq-content .nir-sec-header .file a:hover {
    text-decoration: none;
}

#ndq-content .menu,#ndq-content .side-menu {
    margin: 0;
    padding: 0;
    line-height: 23.8px;
}

#ndq-content .menu__item,#ndq-content .side-menu__item,#ndq-content .side-menu__item {
    list-style-type: none;
}

#ndq-content .menu__item.is-expanded,#ndq-content .menu__item--is-expanded,#ndq-content .side-menu__item.is-expanded,#ndq-content .side-menu__item--is-expanded,#ndq-content .is-expanded.side-menu__item,#ndq-content .side-menu__item.is-expanded {
    list-style-type: none;
}

#ndq-content .menu__item.is-collapsed,#ndq-content .menu__item--is-collapsed,#ndq-content .side-menu__item.is-collapsed,#ndq-content .side-menu__item--is-collapsed,#ndq-content .is-collapsed.side-menu__item,#ndq-content .side-menu__item.is-collapsed {
    list-style-type: none;
}

#ndq-content .menu__item .side-menu,#ndq-content .side-menu__item .side-menu,#ndq-content .side-menu__item .side-menu {
    margin-bottom: 10px;
}

#ndq-content .menu__item .side-menu__item,#ndq-content .side-menu__item .side-menu__item,#ndq-content .side-menu__item .side-menu__item {
    margin-left: 15px;
    font-size: 0.8em;
    line-height: 1.7em;
}

#ndq-content .menu__link.is-active,#ndq-content .menu__link--is-active,#ndq-content .side-menu__link.is-active,#ndq-content .side-menu__link--is-active,#ndq-content .menu a.active {
    color: #000;
}

#ndq-content .skip-link {
    display: block;
    padding: 2px 0 3px;
    text-align: center;
}

#ndq-content .skip-link:link,#ndq-content .skip-link:visited {
    background-color: #666;
    color: #fff;
}

#ndq-content .skip-link__wrapper {
    margin: 0;
}

@media print {
    #ndq-content .skip-link__wrapper {
        display: none;
    }
}

#ndq-content .block-jquery-social-media-tabs * {
    box-sizing: content-box;
}

#ndq-content .sliding {
    z-index: 1000;
}

#ndq-content .quote-wrap {
    border: 1px solid var(--border-color,#cbcbcd);
    float: left;
    position: relative;
    width: 100%;
}

#ndq-content .quote-wrap select {
    color: #333;
    position: absolute;
    padding: 1px 5px;
    appearance: menulist;
    -moz-appearance: menulist;
    -webkit-appearance: menulist;
    top: 15px;
    left: 10px;
}

#ndq-content [class^="stock-quote"] {
    float: left;
    width: 100%;
}

#ndq-content .stock-quote {
    padding: 1em;
    margin-bottom: 1em;
}

#ndq-content .stock-quote dd,#ndq-content .stock-quote dt {
    margin: 0;
    display: inline-block;
}

#ndq-content .stock-quote dd {
    width: 60%;
}

#ndq-content .stock-quote dt {
    width: 40%;
}

#ndq-content .stock-quote .left {
    float: left;
}

#ndq-content .stock-quote .center {
    float: left;
}

#ndq-content .stock-quote .right {
    float: left;
}

#ndq-content .stock-quote time {
    font-size: 0.75em;
}

#ndq-content .stock-quote__short select {
    display: inline;
}

#ndq-content .stock-quote__featured .stock-quote {
    margin-bottom: 0;
}

#ndq-content .stock-quote__featured time {
    float: left;
    margin-top: 0.5em;
}

#ndq-content .stock-quote__featured .quote-price {
    margin-bottom: 1em;
}

#ndq-content .quote-price {
    font-size: 2em;
    line-height: 100%;
}

#ndq-content .price-down {
    color: #d6353a;
}

#ndq-content .price-up {
    color: #228260;
}

#ndq-content .user-toggle-on .stock-quote:nth-of-type(1) {
    display: block;
}

#ndq-content .user-toggle-on .stock-quote,#ndq-content .user-toggle-on .exchange {
    display: none;
}

#ndq-content .user-toggle-on .quote-price {
    margin-top: 35px;
}

@media (max-width: 769px) {
    #ndq-content .stock-quote {
        padding-bottom:2em;
        position: relative;
    }
}

#ndq-content .stock-quote .left-stock {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .stock-quote .left-stock {
        width:100%;
        float: right;
        margin-right: 0;
    }
}

@media (min-width: 769px) {
    #ndq-content .stock-quote .left-stock {
        width:24.05063%;
        float: left;
        margin-right: 1.26582%;
    }
}

@media (max-width: 769px) {
    #ndq-content .stock-quote .left-stock time {
        position:absolute;
        bottom: 0em;
        left: 1em;
    }
}

#ndq-content .stock-quote .center-stock {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .stock-quote .center-stock {
        width:49.36709%;
        float: left;
        margin-right: 1.26582%;
    }
}

@media (min-width: 769px) {
    #ndq-content .stock-quote .center-stock {
        width:36.70886%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .stock-quote .right-stock {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .stock-quote .right-stock {
        width:49.36709%;
        float: right;
        margin-right: 0;
    }
}

@media (min-width: 769px) {
    #ndq-content .stock-quote .right-stock {
        width:36.70886%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .table-drag__wrapper,#ndq-content body.drag {
    cursor: move;
}

#ndq-content .table-drag__item,#ndq-content tr.drag {
    background-color: #fffadb;
}

#ndq-content .table-drag__item-previous,#ndq-content tr.drag-previous {
    background-color: #fff7c2;
}

#ndq-content .table-drag__handle,#ndq-content .tabledrag-handle {
    cursor: move;
    float: left;
    height: 1.7em;
    margin-left: -1em;
    overflow: hidden;
    text-decoration: none;
}

#ndq-content [dir="rtl"] .table-drag__handle,#ndq-content [dir="rtl"] .tabledrag-handle {
    float: right;
    margin-right: -1em;
    margin-left: 0;
}

#ndq-content .table-drag__handle:focus,#ndq-content .table-drag__handle:hover,#ndq-content .tabledrag-handle:focus,#ndq-content .tabledrag-handle:hover {
    text-decoration: none;
}


#ndq-content .table-drag__handle-icon--is-hover,#ndq-content .tabledrag-handle-hover .handle {
    background-position: 6px -11px;
}

#ndq-content .table-drag__toggle-weight-wrapper,#ndq-content .tabledrag-toggle-weight-wrapper {
    text-align: right;
}

#ndq-content [dir="rtl"] .table-drag__toggle-weight-wrapper,#ndq-content [dir="rtl"] .tabledrag-toggle-weight-wrapper {
    text-align: left;
}

#ndq-content .table-drag__toggle-weight,#ndq-content .tabledrag-toggle-weight {
    font-size: 0.9em;
}

#ndq-content .table-drag__indentation,#ndq-content .indentation {
    float: left;
    height: 1.7em;
    margin: -0.4em 0.2em -0.4em -0.4em;
    padding: .42em 0 .42em .6em;
    width: 20px;
}

#ndq-content [dir="rtl"] .table-drag__indentation,#ndq-content [dir="rtl"] .indentation {
    float: right;
    margin: -0.4em -0.4em -0.4em 0.2em;
    padding: 0.42em 0.6em 0.42em 0;
}



#ndq-content [dir="rtl"] .table-drag__tree-child,#ndq-content [dir="rtl"] .table-drag__tree-child-last,#ndq-content [dir="rtl"] .tree-child-last,#ndq-content [dir="rtl"] .table-drag__tree-child-horizontal,#ndq-content [dir="rtl"] .tree-child-horizontal,#ndq-content [dir="rtl"] .tree-child {
    background-position: -65px center;
}



#ndq-content .table-drag__tree-child-horizontal,#ndq-content .tree-child-horizontal {
    background-position: -11px center;
}


#ndq-content .clearfix:before,#ndq-content .tabs:before,#ndq-content .tabs--secondary:before,.block--local-tasks-block .tabs:before,.block--local-tasks-block .tabs--secondary:before,#ndq-content div[class*='view-widget-']:before,#ndq-content #nir-header:before {
    content: '';
    display: table;
}

#ndq-content .clearfix:after,#ndq-content .tabs:after,#ndq-content .tabs--secondary:after,.block--local-tasks-block .tabs:after,.block--local-tasks-block .tabs--secondary:after,#ndq-content div[class*='view-widget-']:after,#ndq-content #nir-header:after {
    content: '';
    display: table;
    clear: both;
}

#ndq-content .tabs,#ndq-content .tabs--secondary,.block--local-tasks-block .tabs,.block--local-tasks-block .tabs--secondary {
    background-image: -owg(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: -webkit(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: -moz(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: -o(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false);
    margin: 1.42857em 0;
    padding: 0 2px;
    list-style: none !important;
    list-style-type: none !important;
    white-space: nowrap
}

@media print {
    #ndq-content .tabs,#ndq-content .tabs--secondary,.block--local-tasks-block .tabs,.block--local-tasks-block .tabs--secondary {
        display: none
    }
}

#ndq-content .tabs__tab,.block--local-tasks-block .tabs__tab {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    text-shadow: compact(compact(1px 1px 0 false #fff),false,false,false,false,false,false,false,false,false);
    float: left;
    margin: 0 3px;
    border: 1px solid #ddd;
    border-bottom-color: transparent;
    list-style-type: none;
    border-bottom: 0 \\0/ie
}

[dir="rtl"] #ndq-content .tabs__tab,[dir="rtl"] .block--local-tasks-block .tabs__tab {
    float: right
}

#ndq-content .tabs__tab.is-active,.block--local-tasks-block .tabs__tab.is-active {
    border-bottom-color: #fff;
}

#ndq-content .tabs__tab-link-common,#ndq-content .tabs a,#ndq-content .tabs--secondary a,#ndq-content .tabs--secondary__tab-link,.block--local-tasks-block .tabs__tab-link-common,.block--local-tasks-block .tabs a,.block--local-tasks-block .tabs--secondary a,.block--local-tasks-block .tabs--secondary__tab-link {
    border: 1px solid var(--border-color,#cbcbcd);
    border-right: 0;
    border-bottom: 0;
    display: block;
    text-decoration: none;
}

#ndq-content .tabs a,#ndq-content .tabs--secondary a,.block--local-tasks-block .tabs a,.block--local-tasks-block .tabs--secondary a {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    transition: compact(background-color 0.3s,false,false,false,false,false,false,false,false,false);
    color: #000;
    background-color: #ddd;
    letter-spacing: 1px;
    padding: 0 1em;
    text-align: center;
}

#ndq-content .tabs a:focus,#ndq-content .tabs a:hover,#ndq-content .tabs--secondary a:focus,#ndq-content .tabs--secondary a:hover,.block--local-tasks-block .tabs a:focus,.block--local-tasks-block .tabs a:hover,.block--local-tasks-block .tabs--secondary a:focus,.block--local-tasks-block .tabs--secondary a:hover {
    background-color: #eaeaea;
    border-color: #f1f1f1;
}



#ndq-content .tabs--secondary,.block--local-tasks-block .tabs--secondary {
    font-size: .9em;
    background-image: none;
}

#ndq-content .tabs + .tabs--secondary,#ndq-content .tabs--secondary + .tabs--secondary,.block--local-tasks-block .tabs + .tabs--secondary,.block--local-tasks-block .tabs--secondary + .tabs--secondary {
    background-image: -owg(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: -webkit(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: -moz(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: -o(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));
    background-image: compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false);
    margin-top: -1.42857em;
}

#ndq-content .tabs--secondary__tab,.block--local-tasks-block .tabs--secondary__tab {
    margin: 0.71429em 0.21429em;
    float: left;
}

#ndq-content [dir="rtl"] .tabs--secondary__tab,.block--local-tasks-block [dir="rtl"] .tabs--secondary__tab {
    float: right;
}

#ndq-content .tabs--secondary__tab-link,.block--local-tasks-block .tabs--secondary__tab-link {
    border-radius: 0.75em;
    transition: compact(background-color 0.3s,false,false,false,false,false,false,false,false,false);
    text-shadow: compact(compact(1px 1px 0 false #fff),false,false,false,false,false,false,false,false,false);
    color: #666;
    background-color: #f1f1f1;
    padding: 0 0.5em;
}

#ndq-content .tabs--secondary__tab-link:focus,#ndq-content .tabs--secondary__tab-link:hover,.block--local-tasks-block .tabs--secondary__tab-link:focus,.block--local-tasks-block .tabs--secondary__tab-link:hover {
    color: #333;
    background-color: #ddd;
    border-color: #847271;
}

#ndq-content .tabs--secondary__tab-link.is-active,#ndq-content .tabs--secondary__tab-link--is-active,#ndq-content .tabs--secondary__tab-link:active,.block--local-tasks-block .tabs--secondary__tab-link.is-active,.block--local-tasks-block .tabs--secondary__tab-link--is-active,.block--local-tasks-block .tabs--secondary__tab-link:active {
    text-shadow: compact(compact(1px 1px 0 false #333),false,false,false,false,false,false,false,false,false);
    color: #fff;
    background-color: #666;
    border-color: #000;
}

#ndq-content .styled-tag {
    background-color: #0480a9;
    border-radius: 3px;
    color: white;
    float: left;
    padding: 5px 10px;
    margin: 0 2px 5px 0;
}

#ndq-content .styled-tag::before {
    content: '#';
}

#ndq-content .styled-tag__small {
    background-color: #ddd;
    border-radius: 3px;
    color: #333;
    float: left;
    font-size: 11px;
    line-height: 15px;
    padding: 2px 6px 4px 6px;
    margin: 0 2px 5px 0;
}

#ndq-content .styled-tag__small a {
    color: white;
}

#ndq-content .styled-tag a {
    color: white;
}

#ndq-content .views-field-field-nir-tags a {
    background-color: #ddd;
    border-radius: 3px;
    color: #333;
    float: left;
    font-size: 0.8em;
    line-height: 1.33929em;
    padding: 4px 6px 4px 6px;
}

#ndq-content .views-field-field-nir-tags .views-label {
    float: left;
}

#ndq-content .field--name-field-nir-media-gallery-tags .field__label,#ndq-content .field--name-field-nir-multimedia-tags .field__label {
    float: left;
    font-size: 11px;
    padding-right: 3px;
}

#ndq-content .field--name-field-nir-media-gallery-tags a,#ndq-content .field--name-field-nir-multimedia-tags a {
    background-color: #ddd;
    color: #333;
}

#ndq-content [role="tooltip"] {
    background: #0480a9;
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    -webkit-opacity: 0;
    opacity: 0;
    font-weight: normal;
    position: absolute;
    margin-right: 20px;
    left: 0px;
    top: -1px;
    color: #fff;
    padding: 10px;
    z-index: -1;
    font-size: 12px;
    border-radius: 3px;
    max-width: 800px;
}

#ndq-content [role="tooltip"]::after {
    position: absolute;
    bottom: -4px;
    left: 20px;
    margin: 0 auto;
    content: '';
    width: 0;
    height: 0;
    border-top: 4px solid #0480a9;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
}

#ndq-content .tool-hide {
    display: none;
}

#ndq-content .tool-show {
    display: block;
}

#ndq-content .watermark {
    display: block;
    height: 0;
    overflow: visible;
    background-color: transparent;
    color: #eee;
    font-size: 75px;
    line-height: 1;
    font-family: Impact,"Arial Narrow",Helvetica,sans-serif;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    text-shadow: 0 0 1px rgba(0,0,0,0.1);
    word-wrap: break-word;
}

#ndq-content .node--view-mode-nir-grid h3 {
    color: #666;
    font-size: 1.1em;
}

#ndq-content .node--view-mode-nir-grid img {
    padding-right: 15px;
}

@media (max-width: 481px) {
    #ndq-content .block-views-blockwidget-assets-widget-assets-grid .views-col {
        width:100% !important;
    }
}

#ndq-content .block-views-blockwidget-assets-widget-assets-ul img {
    margin: 0 2% 2% 0;
}

#ndq-content .block-views-blockwidget-assets-widget-assets-ul .file a:hover {
    text-decoration: underline;
}

#ndq-content div[class*='view-widget-'] .pager {
    float: left;
}

#ndq-content div[class*='view-widget-'] .results-summary {
    float: right;
    padding: 10px 0;
    margin: 1em 0;
}

#ndq-content .nir-widget .field--label-hidden h4 {
    display: none;
}

#ndq-content .nir-widget .nir-widget--field {
    margin: 10px 0px;
}

#ndq-content .nir-widget .nir-widgets--file-list--hide-filesize .filesize {
    display: none;
}

#ndq-content .nir-widget .nir-widgets--file-list--hide-title a {
    height: 0px;
    overflow: hidden;
    display: block;
}

#ndq-content .nir-widget .nir-widgets--file-list--hide-title a::before {
    position: absolute;
    margin-top: -10px;
}

#ndq-content .nir-widget .nir-widget--labeled-field .nir-widget--label,#ndq-content .nir-widget .nir-widget--labeled-field .nir-widget--field {
    display: inline-block;
}

#ndq-content .striped-odd tbody tr:nth-child(odd) {
    background-color: #f5fafa;
}

#ndq-content .striped-even tbody tr:nth-child(even) {
    background-color: #f5fafa;
}

#ndq-content .fundamentals tr td:nth-child(2) {
    text-align: right;
}

#ndq-content .earnings-estimates {
    table-layout: auto;
}

#ndq-content .earnings-estimates tr td:not(:first-child) {
    text-align: right;
}

#ndq-content .earnings-estimates caption {
    text-align: right;
    border-bottom: 0;
    font-size: 1em;
    padding: 15px;
    margin: 0;
    background-color: #666;
    color: #fff;
}

@media (max-width: 769px) {
    #ndq-content .earnings-estimates.estimates-analyst-forecasts thead tr:first-child {
        display:none;
    }
}

#ndq-content .earnings-estimates.estimates-analyst-forecasts thead td {
    background-color: #666;
    color: #fff;
    font-weight: bold;
    text-align: left;
}

#ndq-content .earnings-estimates.estimates-analyst-forecasts caption {
    display: none;
}

#ndq-content .earnings-estimates th {
    text-align: right;
}

#ndq-content .earnings-estimates th:first-child,#ndq-content .earnings-estimates th.caption {
    text-align: left;
}

#ndq-content .block-widget-committee-composition table th a {
    color: #fff;
}

#ndq-content .block-widget-committee-composition table tbody tr td {
    text-align: center;
}

#ndq-content .block-widget-committee-composition table tbody tr td:first-child {
    text-align: left;
}

#ndq-content .block-widget-committee-composition table tbody tr a::before {
    content: none;
}

#ndq-content .block-widget-committee-composition table tbody tr span::before {
    font-size: 20px;
    padding-right: 0;
}

#ndq-content .commitee-key span::before {
    font-size: 20px;
    padding-right: 0;
}

#ndq-content .collapse-table {
    border-collapse: collapse;
}

@media (max-width: 481px) {
    #ndq-content .collapse-table th {
        position:absolute !important;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip: rect(1px,1px,1px,1px);
    }

    #ndq-content .collapse-table tr {
        border: 1px dotted var(--border-color,#cbcbcd);
        margin-bottom: 25px;
        display: block;
        float: left;
        width: 100%;
    }

    #ndq-content .collapse-table tbody tr td,#ndq-content .collapse-table tfoot tr td {
        box-sizing: border-box;
        float: left;
        width: 100%;
        text-align: left !important;
    }

    #ndq-content .collapse-table tbody tr td:empty,#ndq-content .collapse-table tfoot tr td:empty {
        display: none;
    }

    #ndq-content .collapse-table tbody tr td::before,#ndq-content .collapse-table tfoot tr td::before {
        content: attr(data-before);
        font-weight: bold;
        padding-bottom: 7px;
        border-bottom: 1px dotted var(--border-color,#cbcbcd);
        width: 100%;
        float: left;
        margin-bottom: 5px;
    }

    #ndq-content .collapse-table tbody tr td:first-child::before,#ndq-content .collapse-table tfoot tr td:first-child::before {
        border-bottom: 0;
    }

    #ndq-content .collapse-table .table-indent {
        padding-left: 15px;
    }
}

#ndq-content .field--name-field-nir-committee-body {
    float: left;
}

#ndq-content .commiteetable thead span {
    display: none;
}

@media (max-width: 481px) {
    #ndq-content .commiteetable td::before {
        display:none;
    }

    #ndq-content .commiteetable tr {
        border: 0;
        margin-bottom: 0;
    }

    #ndq-content .commiteetable thead {
        display: none;
    }

    #ndq-content .commiteetable thead span {
        display: none;
    }
}

#ndq-content .collapse-table-wide {
    border-collapse: collapse;
}

#ndq-content .collapse-table-wide .desk-absolute {
    position: absolute;
}

@media (max-width: 769px) {
    #ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-rec-date,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-pay-date,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-dec-date,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-type,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-split-numerator {
        display:none;
    }

    #ndq-content .collapse-table-wide .desk-absolute {
        position: relative;
    }

    #ndq-content .collapse-table-wide th {
        position: absolute !important;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip: rect(1px,1px,1px,1px);
    }

    #ndq-content .collapse-table-wide tbody tr {
        border-bottom: 1px solid var(--border-color,#cbcbcd);
        margin-bottom: 25px;
        display: block;
        float: left;
        width: 100%;
    }

    #ndq-content .collapse-table-wide caption {
        background-color: transparent;
        color: #333;
        text-align: left;
        padding-left: 0;
    }

    #ndq-content .collapse-table-wide tbody tr td,#ndq-content .collapse-table-wide tfoot tr td {
        box-sizing: border-box;
        float: left;
        width: 100%;
        text-align: left !important;
        position: relative;
        padding-left: 60%;
        white-space: normal;
        text-align: left;
    }

    #ndq-content .collapse-table-wide tbody tr td:empty,#ndq-content .collapse-table-wide tfoot tr td:empty {
        display: none;
    }

    #ndq-content .collapse-table-wide tbody tr td::before,#ndq-content .collapse-table-wide tfoot tr td::before {
        content: attr(data-before);
        font-weight: bold;
        padding: 0 10px 7px 0;
        margin-bottom: 5px;
        position: absolute;
        left: 6px;
        width: 55%;
        vertical-align: middle;
        white-space: nowrap;
        text-align: left;
    }

    #ndq-content .collapse-table-wide tbody tr td:first-child::before,#ndq-content .collapse-table-wide tfoot tr td:first-child::before {
        border-bottom: 0;
    }

    #ndq-content .collapse-table-wide .table-indent {
        padding-left: 15px;
    }
}

#ndq-content .mobile-show {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px,1px,1px,1px);
}

@media (max-width: 481px) {
    #ndq-content .mobile-show {
        position:static !important;
        clip: auto;
        height: auto;
        width: auto;
        overflow: auto;
    }
}

#ndq-content td.views-field-field-nir-asset-source {
    color: #333;
}

#ndq-content .ndq-source p {
    font-size: 12px;
}

#ndq-content .table-indent {
    padding-left: 30px;
}

#ndq-content tr.detail-level-1 {
    font-weight: bold;
}

#ndq-content table.cash-flow td,#ndq-content table.income-statment td {
    text-align: right;
}

#ndq-content table.cash-flow td:first-child,#ndq-content table.income-statment td:first-child {
    text-align: left;
}

#ndq-content table.cash-flow th,#ndq-content table.income-statment th {
    text-align: right;
}

#ndq-content table.historical-lookup td:nth-child(n+2),#ndq-content table.historical-lookup th:nth-child(n+2),#ndq-content table.ownership td:nth-child(n+2),#ndq-content table.ownership th:nth-child(n+2) {
    text-align: right;
}

#ndq-content table.historical-lookup tr:first-child {
    font-weight: bold;
}

@media (max-width: 769px) {
    #ndq-content table.estimates-reference-information tr {
        margin-bottom:0;
    }

    #ndq-content table.estimates-reference-information td:first-child {
        padding-left: 10px;
        width: 60%;
    }

    #ndq-content table.estimates-reference-information td:last-child {
        padding-left: 0;
        width: 40%;
        float: right;
    }
}

#ndq-content #block-facetbreadbox.block-facet-select-breadbox {
    background-color: #ddd;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
}

#ndq-content #block-facetbreadbox.block-facet-select-breadbox h2 {
    display: inline-block;
    font-size: 14px;
    line-height: 1.42857;
    margin: 0;
    border-bottom: 0;
}

#ndq-content #block-facetbreadbox.block-facet-select-breadbox a {
    font-size: 11px;
    margin-left: 5px;
}

#ndq-content #block-facetbreadbox.block-facet-select-breadbox ul {
    padding: 0;
    margin: 0;
}

#ndq-content #block-facetbreadbox.block-facet-select-breadbox ul li {
    margin: 0.4em 0 0.4em 2em;
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-thumbnail {
    float: left;
    margin-right: 10px;
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-thumbnail {
        width:30.37975%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-body,#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content,#ndq-content .view-widget-bundled-content .views-field-field-nir-tags {
    width: 100%;
    float: right;
    margin-right: 0;
}

@media (min-width: 480px) {
    #ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-body,#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content,#ndq-content .view-widget-bundled-content .views-field-field-nir-tags {
        width:68.35443%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-tags {
    font-size: 11px;
    line-height: 16px;
    margin-top: 1.5em;
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-tags .views-label {
    margin: 0 10px 0 0px;
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content {
    float: left;
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content ul div {
    margin: 0;
    line-height: 1;
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content .webcast-link {
    font-weight: normal;
}

#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-body p {
    margin-top: 0;
}

#ndq-content .acc-title,#ndq-content .view-grouping,#ndq-content .acc-body {
    float: left;
    width: 100%;
}

#ndq-content .acc-body {
    margin-top: 1em;
    margin-bottom: 15px;
}

#ndq-content .block-views-blockwidget-bundled-content-block-1 {
    position: relative;
}

#ndq-content .block-views-blockwidget-bundled-content-block-1 .show-all {
    margin-top: 0;
}

#ndq-content .button,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button,#ndq-content button,#ndq-content [type="button"],#ndq-content [type="reset"],#ndq-content [type="submit"],#ndq-content .market-data-filter-form input {
    appearance: button;
    display: inline-block;
    text-decoration: none;
    color: #fff;
    padding: 10px 15px;
    margin: 5px 0 0 0;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    background-image: none;
    background-color: #0480a9;
    border: 1px solid transparent;
    border-radius: 4px;
    white-space: nowrap;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.42857143;
    -webkit-user-select: none;
    user-select: none;
    transition: all 1s ease;
}

#ndq-content .button:hover,#ndq-content .button:focus,#ndq-content .button:active,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:hover,#ndq-content button:hover,#ndq-content [type="button"]:hover,#ndq-content [type="reset"]:hover,#ndq-content [type="submit"]:hover,#ndq-content .market-data-filter-form input:hover,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:focus,#ndq-content button:focus,#ndq-content [type="button"]:focus,#ndq-content [type="reset"]:focus,#ndq-content [type="submit"]:focus,#ndq-content .market-data-filter-form input:focus,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:active,#ndq-content button:active,#ndq-content [type="button"]:active,#ndq-content [type="reset"]:active,#ndq-content [type="submit"]:active,#ndq-content .market-data-filter-form input:active {
    background-color: #0184A2;
    text-decoration: none;
    color: #fff;
}

#ndq-content .button[disabled],#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button,#ndq-content button[disabled],#ndq-content [disabled][type="button"],#ndq-content [disabled][type="reset"],#ndq-content [disabled][type="submit"],#ndq-content .market-data-filter-form input[disabled] {
    cursor: default;
    color: #847271;
}

#ndq-content .button[disabled]:hover,#ndq-content .button[disabled]:focus,#ndq-content .button[disabled]:active,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button:hover,#ndq-content button[disabled]:hover,#ndq-content [disabled][type="button"]:hover,#ndq-content [disabled][type="reset"]:hover,#ndq-content [disabled][type="submit"]:hover,#ndq-content .market-data-filter-form input[disabled]:hover,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button:focus,#ndq-content button[disabled]:focus,#ndq-content [disabled][type="button"]:focus,#ndq-content [disabled][type="reset"]:focus,#ndq-content [disabled][type="submit"]:focus,#ndq-content .market-data-filter-form input[disabled]:focus,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button:active,#ndq-content button[disabled]:active,#ndq-content [disabled][type="button"]:active,#ndq-content [disabled][type="reset"]:active,#ndq-content [disabled][type="submit"]:active,#ndq-content .market-data-filter-form input[disabled]:active {
    color: #847271;
}

#ndq-content ul.no-list-style,#ndq-content .view-widget-assets .item-list ul,#ndq-content .view-widget-people .item-list > ul,#ndq-content .view-widget-events .item-list ul {
    list-style-type: none;
    padding: 0;
}

#ndq-content .field--name-field-nir-asset-source {
    margin: 1em 0;
    font-size: 12px;
}

#ndq-content .field--name-field-nir-asset-source .field__label {
    font-weight: bold;
}

#ndq-content .view-widget-assets .item-list ul {
    margin: 0;
}

#ndq-content .view-widget-assets .item-list ul li {
    border-bottom: 1px solid #eee;
    float: left;
    margin: 10px 0;
    padding-bottom: 15px;
    width: 100%;
}

#ndq-content .view-widget-assets table td {
    vertical-align: top;
}

#ndq-content .view-widget-assets table td h4 {
    margin: 0 0 8px 0;
}

#ndq-content .view-widget-assets table .field--name-field-nir-ext-document a,#ndq-content .view-widget-assets table .field--name-field-nir-document a {
    line-height: 30px;
}

#ndq-content .view-widget-assets table .item-list ul {
    margin: 5px 0;
}

#ndq-content .view-widget-assets table .item-list ul li {
    border: 0;
    margin: 0;
    padding: 0;
}

#ndq-content .view-widget-assets table .field__label {
    display: none;
}

#ndq-content .view-widget-assets table tbody .views-field-field-nir-asset-date {
    font-style: italic;
    color: #847271;
    font-size: 12px;
}

@media (max-width: 481px) {
    #ndq-content .view-widget-assets table tbody .views-field-field-nir-asset-date {
        font-style:normal;
        font-size: 14px;
        color: #333;
    }

    #ndq-content .view-widget-assets table tbody .views-field-field-nir-asset-date time {
        font-size: 12px;
    }
}

#ndq-content .view-widget-assets .views-col {
    padding: 1%;
}

#ndq-content .view-widget-assets .views-col article {
    border: 1px solid #847271;
    float: left;
    padding: 4%;
    width: 100%;
}

#ndq-content .view-widget-assets .views-col h3 {
    margin: 0;
}

#ndq-content .view-widget-sec-filings table th a {
    color: white;
}

#ndq-content .view-widget-sec-filings table td {
    vertical-align: top;
}

#ndq-content .view-widget-sec-filings table td p {
    margin: 0;
}

#ndq-content .view-widget-sec-filings .html-link,#ndq-content .view-widget-sec-filings .file-link {
    float: left;
}

#ndq-content .view-widget-sec-filings .html-link .filesize,#ndq-content .view-widget-sec-filings .file-link .filesize {
    display: none;
}

#ndq-content .view-widget-sec-filings .html-link a,#ndq-content .view-widget-sec-filings .file-link a {
    font-size: 0;
}

#ndq-content .view-widget-sec-filings .html-link a::before,#ndq-content .view-widget-sec-filings .file-link a::before {
    font-size: 30px;
    line-height: 1em;
}

#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf .filesize {
    display: none;
}

#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf .file--mime-application-xml a:before,#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf .file--mime-application-xsd a:before {
    content: "\\e07d";
    color: #7b41bd;
}

#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf a {
    font-size: 0;
}

#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf a::before {
    font-size: 30px;
    line-height: 1em;
}

#ndq-content .field--name-field-nir-asset-source,#ndq-content .asset-date {
    color: #847271;
    font-style: italic;
}

#ndq-content .asset-date {
    font-size: 12px;
}

#ndq-content .nir-docs {
    margin: 20px 0;
}

#ndq-content .nir-docs a {
    line-height: 30px;
}

#ndq-content .nir-docs a:hover,#ndq-content .nir-docs a:focus {
    text-decoration: none;
}

#ndq-content .field--name-field-nir-ext-document,#ndq-content .field--name-field-nir-document,#ndq-content .field--name-field-nir-ext-document {
    font-weight: bold;
}

#ndq-content .asset-link {
    font-size: 14px;
    font-weight: bold;
    margin: 1em 0;
}

#ndq-content .view-empty {
    margin: 1em 0;
}

#ndq-content .filesize {
    font-style: italic;
    font-weight: normal;
    color: #847271;
}

#ndq-content .file-link .file {
    display: inline-block;
    vertical-align: middle;
}

#ndq-content .view-widget-people .item-list > ul > li {
    border-bottom: 1px solid var(--border-color,#cbcbcd);
    float: left;
    margin: 10px 0;
    padding-bottom: 15px;
    width: 100%;
}

#ndq-content .block-views-blockwidget-people-widget-assets-ul {
    float: left;
    width: 100%;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list {
    margin-bottom: 2em;
    float: left;
    width: 100%;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list ul {
    list-style-type: none;
    padding: 0;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list ul li {
    float: left;
    width: 100%;
    border-bottom: 1px dotted var(--border-color,#cbcbcd);
    list-style-type: none;
    padding: 2em 0;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list ul li:first-child {
    border-top: 1px dotted var(--border-color,#cbcbcd);
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-teaser .field-content {
    margin: 1em 0;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-teaser p {
    margin: 0;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-title h3 {
    margin: 0;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-date {
    width: 100%;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .field--name-field-nir-document {
    font-weight: normal;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .field--name-field-nir-document .field__item {
    margin-top: 0;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-title,#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-title {
    font-weight: bold;
    font-size: 16px;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .field--name-field-nir-tags .field__label {
    font-size: 11px;
    float: left;
    margin-right: 0.5em;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-thumbnail {
    float: left;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-thumbnail img {
    border-left: 8px solid #0480a9;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .col {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(1) {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
}

@media (min-width: 1024px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(1) {
        width:62.02532%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(2) {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
    margin-top: 20px;
}

@media (min-width: 769px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(2) {
        width:81.01266%;
        float: right;
        margin-right: 0;
    }
}

@media (min-width: 1024px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(2) {
        width:36.70886%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail .col:nth-child(1) {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
}

@media (min-width: 769px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail .col:nth-child(1) {
        width:17.72152%;
        float: left;
        margin-right: 1.26582%;
    }
}

@media (min-width: 769px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail .col:nth-child(2) {
        width:81.01266%;
        float: right;
        margin-right: 0;
    }
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(1) {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
}

@media (min-width: 769px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(1) {
        width:17.72152%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(2) {
    margin-top: 0;
}

@media (min-width: 769px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(2) {
        width:81.01266%;
        float: right;
        margin-right: 0;
    }
}

@media (min-width: 1024px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(2) {
        width:43.03797%;
        float: left;
        margin-right: 1.26582%;
    }
}

#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(3) {
    width: 100%;
    float: left;
    margin-left: 0;
    margin-right: 0;
    margin-top: 20px;
}

@media (min-width: 769px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(3) {
        width:81.01266%;
        float: right;
        margin-right: 0;
    }
}

@media (min-width: 1024px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(3) {
        width:36.70886%;
        float: right;
        margin-right: 0;
    }
}

@media (min-width: 1024px) {
    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .views-field-field-nir-news-title {
        margin-bottom:5px;
    }
}

#ndq-content .view-widget-news.view-display-id-table .field--name-field-nir-document .field__item {
    margin-top: 0px;
    margin-bottom: 0px;
}

#ndq-content .view-widget-news.view-display-id-table .html-link,#ndq-content .view-widget-news.view-display-id-table .file-link {
    float: left;
}

#ndq-content .view-widget-news.view-display-id-table .html-link .filesize,#ndq-content .view-widget-news.view-display-id-table .file-link .filesize {
    display: none;
}

#ndq-content .view-widget-news.view-display-id-table .html-link a,#ndq-content .view-widget-news.view-display-id-table .file-link a {
    font-size: 0;
}

#ndq-content .view-widget-news.view-display-id-table .html-link a::before,#ndq-content .view-widget-news.view-display-id-table .file-link a::before {
    font-size: 30px;
    line-height: 1em;
}

#ndq-content .view-widget-news.view-display-id-table table {
    table-layout: initial;
}

#ndq-content .view-widget-news.view-display-id-table table td {
    vertical-align: top;
}

#ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-date {
    width: 200px;
}

@media screen and (max-width: 480px) {
    #ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-date {
        width:initial;
    }
}

#ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-supp-format {
    width: 180px;
}

@media screen and (max-width: 480px) {
    #ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-supp-format {
        width:initial;
    }
}

#ndq-content .block-views {
    float: left;
    width: 100%;
}

#ndq-content .view-widget-events .item-list ul li {
    border-bottom: 1px solid var(--border-color,#cbcbcd);
    float: left;
    margin: 10px 0;
    padding-bottom: 15px;
    width: 100%;
}

#ndq-content .view-widget-events .field--name-field-nir-event-thumbnail img {
    padding-right: 0;
}

#ndq-content .view-widget-events h3 {
    margin-top: 0;
    font-size: 16px;
}

#ndq-content .view-widget-events .field--name-field-nir-event-summary {
    margin-bottom: 1em;
}

#ndq-content .view-widget-events .two-col-half:empty {
    display: none;
}

#ndq-content .view-widget-events .full-width {
    float: none;
    clear: both;
}

#ndq-content .view-widget-events .full-width > div {
    margin-top: 1em;
}

#ndq-content .view-widget-events .left-half,#ndq-content .view-widget-events .right-half {
    margin-bottom: 1em;
}

#ndq-content .view-widget-events .webcast-link {
    margin-top: 0;
}

#ndq-content .view-widget-events.view-display-id-table table {
    table-layout: initial;
}

#ndq-content .view-widget-events.view-display-id-table table td {
    vertical-align: top;
}

#ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-start-date {
    width: 200px;
}

@media screen and (max-width: 480px) {
    #ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-start-date {
        width:initial;
    }
}

#ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-add-calender {
    width: 130px;
}

@media screen and (max-width: 480px) {
    #ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-add-calender {
        width:initial;
    }
}

#ndq-content .view-nir-media-gallery-items-grid .views-row {
    margin-bottom: 30px;
}

#ndq-content .view-nir-media-gallery-items-grid .views-row h2 {
    border-bottom: 0;
    margin: 0;
}

#ndq-content .view-nir-media-gallery-items-grid form.views-exposed-form .form-actions {
    margin: 0;
}

#ndq-content .view-nir-media-gallery-items-grid form.views-exposed-form .form-item {
    margin: 6px 0 16px 0;
}

#ndq-content .view-nir-media-gallery-items-grid form.views-exposed-form input {
    display: none;
}

#ndq-content .gallery-title {
    padding: 5px 0;
    margin-bottom: 20px;
}

#ndq-content .view-nir-media-galleries-widget-grid .view-footer {
    margin: 1em 0;
    width: 100%;
    float: left;
    text-align: left;
    padding: 25px 0;
}

#ndq-content .view-nir-media-galleries-widget-grid .pager {
    margin: 1em 0;
    width: 100%;
    float: left;
    text-align: left;
}

@media (min-width: 480px) {
    #ndq-content .view-nir-media-galleries-widget-grid .view-footer {
        width:50%;
        float: right;
        text-align: right;
    }

    #ndq-content .view-nir-media-galleries-widget-grid .pager {
        width: 50%;
        float: left;
        text-align: left;
    }
}

#ndq-content .faq-dl {
    counter-reset: faq-counter;
}

#ndq-content .faq-dl dt:before {
    content: counter(faq-counter) ".";
    counter-increment: faq-counter;
    padding-right: 0.75em;
    padding-left: 0.5em;
}

#ndq-content .faq-dl dt {
    margin: 1.4em 0 1em 0;
    font-weight: bold;
}

#ndq-content .faq-dl dd {
    margin: 1em 0;
    padding-left: 2.1em;
}

#ndq-content .faq-dl .top-link {
    padding-left: 2.1em;
}

#ndq-content .faq-acc-dl dt,#ndq-content .faq-acc-dl .acc-title,#ndq-content .acc-wrap dt,#ndq-content .acc-wrap .acc-title {
    cursor: pointer;
    line-height: 1.5em;
    border-radius: 3px;
    background: #666;
    color: #fff;
    border-bottom: 1px solid white;
    padding: 15px;
    transition: all 1s ease;
}

#ndq-content .faq-acc-dl dt:hover,#ndq-content .faq-acc-dl .acc-title:hover,#ndq-content .acc-wrap dt:hover,#ndq-content .acc-wrap .acc-title:hover {
    background-color: #0480a9;
}

#ndq-content .faq-acc-dl dt.opened,#ndq-content .faq-acc-dl .acc-title.opened,#ndq-content .acc-wrap dt.opened,#ndq-content .acc-wrap .acc-title.opened {
    background-color: #0480a9;
}

#ndq-content .faq-acc-dl dd,#ndq-content .acc-wrap dd {
    margin: 1em 0;
}

#ndq-content .show-all {
    float: left;
    text-align: right;
    width: 100%;
    margin-top: -25px;
}

#ndq-content .view-grouping {
    margin-bottom: 1em;
}

#ndq-content .form-table__sticky-header,#ndq-content .sticky-header {
    position: fixed;
    visibility: hidden;
    margin-top: 0;
    background-color: #fff;
}

#ndq-content .form-table__sticky-header.is-sticky,#ndq-content .form-table__sticky-header--is-sticky,#ndq-content .is-sticky.sticky-header {
    visibility: visible;
}

#ndq-content .form-table__header,#ndq-content .form-table th,#ndq-content form table th {
    border-bottom: 3px solid var(--border-color,#cbcbcd);
    padding-right: 1em;
    text-align: left;
}

#ndq-content [dir="rtl"] .form-table__header,#ndq-content [dir="rtl"] .form-table th,#ndq-content .form-table [dir="rtl"] th,#ndq-content [dir="rtl"] form table th,#ndq-content form table [dir="rtl"] th {
    text-align: right;
    padding-left: 1em;
    padding-right: 0;
}

#ndq-content .form-table__body,#ndq-content .form-table tbody,#ndq-content form table tbody {
    border-top: 1px solid var(--border-color,#cbcbcd);
}

#ndq-content .form-table__row,#ndq-content .form-table tbody tr,#ndq-content form table tbody tr {
    padding: .1em .6em;
    border-bottom: 1px solid var(--border-color,#cbcbcd);
    background-color: #eee;
}

#ndq-content .form-table__row-even,#ndq-content .form-table tbody tr:nth-child(even),#ndq-content form table tbody tr:nth-child(even) {
    background-color: #fff;
}

#ndq-content .form-table__list,#ndq-content .form-table ul,#ndq-content form table ul {
    margin: 0;
}

#ndq-content .form-table__narrow-column,#ndq-content .form-table th.form-table__narrow-column,#ndq-content form table th.form-table__narrow-column,#ndq-content td .checkbox,#ndq-content th .checkbox {
    width: -webkit-min-content;
    text-align: center;
}

#ndq-content td.active {
    background-color: #ddd;
}

#ndq-content td.menu-disabled {
    background: #ddd;
}

#ndq-content tr.selected td {
    background: #fffadb;
}

#ndq-content #nir-header__logo {
    float: left;
    margin: 0 10px 0 0;
    padding: 0;
}

#ndq-content [dir="rtl"] #nir-header__logo {
    float: right;
    margin: 0 0 0 10px;
}

#ndq-content #nir-header__logo-image {
    vertical-align: bottom;
}

#ndq-content #nir-header__name-and-slogan {
    float: left;
}

#ndq-content #nir-header__site-name {
    margin: 0;
}

#ndq-content #nir-header__site-link:link,#ndq-content #nir-header__site-link:visited {
    color: #000;
    text-decoration: none;
}

#ndq-content #nir-header__site-link:hover,#ndq-content #nir-header__site-link:focus {
    text-decoration: underline;
}

#ndq-content #nir-header__site-slogan {
    margin: 0;
}

#ndq-content #nir-header__secondary-menu {
    float: right;
}

#ndq-content [dir="rtl"] #nir-header__secondary-menu {
    float: left;
}

#ndq-content #nir-header__region {
    clear: both;
}

#ndq-content .messages,#ndq-content .messages--status,#ndq-content .messages--warning,#ndq-content .messages.warning,#ndq-content .messages--error,#ndq-content .messages.error {
    margin: 1.42857em 0;
    position: relative;
    padding: 10px 10px 10px 44px;
    border: 1px solid #0480a9;
    width: 100%;
    float: left;
}

#ndq-content [dir="rtl"] .messages,#ndq-content [dir="rtl"] .messages--status,#ndq-content [dir="rtl"] .messages--warning,#ndq-content [dir="rtl"] .messages.warning,#ndq-content [dir="rtl"] .messages--error,#ndq-content [dir="rtl"] .messages.error {
    padding: 10px 44px 10px 10px;
    background-position: 99% 8px;
}

#ndq-content .messages__icon {
    position: absolute;
    top: 50%;
    left: 10px;
    height: 24px;
    width: 24px;
    margin-top: -12px;
    line-height: 1;
}

#ndq-content [dir="rtl"] .messages__icon {
    left: auto;
    right: 0;
}

#ndq-content .messages__icon path {
    fill: #0480a9;
}

#ndq-content .messages__list {
    margin: 0;
}

#ndq-content .messages__item {
    list-style-image: none;
}

#ndq-content .messages--ok-color,#ndq-content .messages,#ndq-content .messages--status,#ndq-content .messages--warning,#ndq-content .messages.warning,#ndq-content .messages--error,#ndq-content .messages.error,#ndq-content .ok,#ndq-content .revision-current {
    background-color: #fff;
    color: #0480a9;
}

#ndq-content .messages--warning-color,#ndq-content .messages--warning,#ndq-content .messages.warning,#ndq-content .warning {
    background-color: #fffce6;
    color: #000;
}

#ndq-content .messages--error-color,#ndq-content .messages--error,#ndq-content .messages.error,#ndq-content .error {
    background-color: #fff0f0;
    color: #c00;
}

#ndq-content .messages--warning,#ndq-content .messages.warning {
    border-color: #fd0;
}

#ndq-content .messages--warning path,#ndq-content .messages.warning path {
    fill: #fd0;
}

#ndq-content .messages--error,#ndq-content .messages.error {
    border-color: #c00;
}

#ndq-content .messages--error path,#ndq-content .messages.error path {
    fill: #c00;
}

#ndq-content .messages--error__highlighted-text,#ndq-content .messages--error .error,#ndq-content .messages.error .error {
    color: #000;
}

@media print {
    #ndq-content .print-none,#ndq-content .toolbar,#ndq-content .action-links,#ndq-content .links,#ndq-content .book-navigation,#ndq-content .forum-topic-navigation,#ndq-content .feed-icons {
        display: none;
    }
}

#ndq-content .sidebars .block {
    margin: 10px 0;
    padding: 10px 0;
}

#ndq-content #content .block-system-main-block {
    margin: 10px 0;
    clear: both;
}

#ndq-content .node--type-person h3 {
    margin-top: 0;
}

#ndq-content .node--type-person .field--name-field-nir-person-company {
    margin-bottom: 1em;
}

#ndq-content .node--type-person .field--name-field-nir-person-dir-details {
    margin-top: 1em;
}

#ndq-content .node--type-person .field--name-field-nir-person-dir-details .field-item {
    margin-bottom: 5px;
}

#ndq-content .centered-header {
    border-bottom: 1px solid #847271;
    margin-bottom: 10px;
    width: 100%;
    float: right;
    margin-right: 0;
}

#ndq-content .centered-header .field--name-field-nir-committee-charter-date {
    font-weight: bold;
    font-size: smaller;
}

#ndq-content .centered-header .field--name-field-nir-committee-document,#ndq-content .centered-header .field--name-field-nir-asset,#ndq-content .centered-header .field--name-field-nir-committee-link {
    text-align: right;
}

#ndq-content .centered-header .field--name-field-nir-committee-document span a::before,#ndq-content .centered-header .field--name-field-nir-asset span a::before,#ndq-content .centered-header .field--name-field-nir-committee-link span a::before {
    font-size: 20px;
}

#ndq-content .centered-header .field--name-field-nir-asset a {
    font-weight: normal;
}

#ndq-content .field--name-field-nir-committee-link a::before {
    content: "î·";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .field--name-field-nir-committee-member {
    border-top: 1px solid #847271;
    border-bottom: 1px solid #847271;
    float: left;
    width: 100%;
    padding: 8px 0;
    margin: 10px 0 0;
}

#ndq-content .field--name-field-nir-committee-member span::before {
    font-size: 20px;
    padding-right: 0;
}

#ndq-content .commitee_member {
    border-right: 1px solid var(--border-color,#cbcbcd);
    padding-right: 5px;
    margin-right: 5px;
}

#ndq-content .commitee_member:last-child {
    border-right: 0;
}

#ndq-content .commitee_member span::before {
    font-size: 20px;
    padding-right: 0;
}

#ndq-content .add-event {
    margin-bottom: 15px;
}

#ndq-content .field--name-field-nir-event-thumbnail img {
    border-left: 8px solid #0480a9;
    padding-right: 15px;
}

#ndq-content .field--name-field-nir-person-company {
    font-style: italic;
}

#ndq-content .node--view-mode-full .field--name-field-nir-event-summary {
    font-weight: bold;
    color: #666;
}

#ndq-content .node--view-mode-full .field--name-field-nir-event-summary p:first-child {
    margin-top: 0;
}

#ndq-content .node--type-nir-event .node--type-nir-asset .field--name-field-nir-document .field__item,#ndq-content .node--type-nir-event .node--type-nir-asset .field--name-field-nir-ext-document .field__item {
    margin: 1em 0;
}

#ndq-content .node--type-nir-event h4 {
    margin: 0 0 5px 0;
}

#ndq-content .node--type-nir-event .field--label-inline .field__label::after {
    content: '';
}

#ndq-content .node--type-nir-event .field--name-field-nir-event-speaker-name {
    font-weight: bold;
    font-style: italic;
    float: left;
    width: 100%;
}

#ndq-content .node--type-nir-event .field--name-field-nir-event-speaker-co {
    float: left;
}

#ndq-content .node--type-nir-event p.address {
    margin: 0;
}

#ndq-content .node--type-nir-event .location-info {
    font-style: italic;
    color: #666;
}

#ndq-content .node--type-nir-event .field--name-field-nir-event-loc-desc p,#ndq-content .node--type-nir-event .field--name-field-nir-event-rep-dial-notes p {
    margin: 0;
}

#ndq-content .node--type-nir-event .field__item > p {
    margin: 0;
}

#ndq-content .webcast-link {
    font-weight: bold;
    margin: 1em 0;
}

#ndq-content .speaker-name {
    font-weight: bold;
    font-style: italic;
}

#ndq-content .speaker-title .field {
    display: inline-block;
}

#ndq-content .speaker-group {
    float: left;
    margin-bottom: 1em;
    width: 100%;
}

#ndq-content .field--name-field-nir-news-document a {
    font-weight: bold;
}

#ndq-content .field--name-field-nir-document,#ndq-content .field--name-field-nir-news-document,#ndq-content .field--name-field-nir-news-supp-format,#ndq-content .field--name-field-nir-news-supp-references {
    font-weight: bold;
}

#ndq-content .field--name-field-nir-document .field__item,#ndq-content .field--name-field-nir-news-document .field__item,#ndq-content .field--name-field-nir-news-supp-format .field__item,#ndq-content .field--name-field-nir-news-supp-references .field__item {
    margin-top: 5px;
    margin-bottom: 1em;
}

#ndq-content .box__right .field__label {
    margin-bottom: 0.5em;
}

#ndq-content .box__right .field--name-field-nir-tags .field__label {
    font-size: 11px;
    float: left;
    margin-right: 0.5em;
}

#ndq-content .field--name-field-nir-sec-form {
    font-size: 20px;
    line-height: 150%;
}

#ndq-content .detail-group {
    line-height: 175%;
}

#ndq-content .doc-group,#ndq-content .xbrl-group {
    line-height: 200%;
}

#ndq-content .node--type-nir-sec-filing .field--name-field-nir-tags {
    margin: 0.5em 0;
}

#ndq-content .node--type-nir-sec-filing .field--name-field-nir-tags a {
    color: #333;
}

#ndq-content .add-outlook,#ndq-content .add-gcal {
    float: left;
    margin-top: 1em;
}

#ndq-content .media-meta div {
    display: inline-block;
}

#ndq-content .field--name-field-nir-multimedia-tags {
    float: left;
    width: 100%;
    margin-top: 10px;
}

#ndq-content .field--name-field-nir-multimedia-tags .field__label {
    font-size: 11px;
    float: left;
    margin-right: 0.5em;
}

#ndq-content .field--name-field-nir-multimedia-item .file-link,#ndq-content .field--name-field-nir-multimedia-item .media-meta {
   
    display: inline-block;
}

#ndq-content .field--name-field-nir-multimedia-item .filesize {
    padding-right: 5px;
}

#ndq-content .field--name-field-nir-multimedia-item .media-meta {
    font-style: italic;
    font-weight: normal;
    color: #847271;
}

#ndq-content .field.field--name-field-nir-multimedia-item {
    margin: 1em 0;
}

#ndq-content .field.field--name-field-nir-multimedia-item a::before {
    font-size: 30px;
    margin-bottom: 5px;
    float: left;
}

#ndq-content .node--nir-multimedia--full h2 {
    margin-bottom: 0.75em;
}

#ndq-content .node--nir-multimedia--full .two-col-node .node-left {
    max-width: 300px;
    float: left;
}

#ndq-content .node--nir-multimedia--full .two-col-node .node-right {
    float: left;
}

#ndq-content .node--nir-multimedia--full .styled-tag__small a {
    color: #333;
}

#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-tags {
    padding: 1em 0;
}

#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-title {
    font-weight: bold;
    margin: 12px 0;
}

#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-desc p:first-child {
    margin-top: 0;
}

#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-desc p:last-child {
    margin-top: 0;
}

#ndq-content .field--name-field-nir-multimedia-item .filesize {
    display: none;
}

#ndq-content .field--name-field-nir-multimedia-item .file-link {
    padding-right: 5px;
}

#ndq-content .node--type-nir-multimedia .filesize {
    display: none;
}

#ndq-content .view-search .filesize {
    display: none;
}

#ndq-content .field--name-field-nir-multimedia-item .field__label {
    display: none;
}

#ndq-content .historical-price-lookup-form .form-item,#ndq-content .stock-price-calculator-form .form-item {

    display: inline-block;
    margin-right: 20px;
    position: relative;
}

#ndq-content .historical-price-lookup-form .form-item label::after,#ndq-content .stock-price-calculator-form .form-item label::after {
    content: ':';
}

#ndq-content .market-data-filter-form .form-item {
   
    display: inline-block;
    margin-right: 20px;
    position: relative;
}

#ndq-content .market-data-filter-form .form-item label::after {
    content: ':';
}

#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one {
    padding-left: 25px;
}

#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one::before {
    content: "î‚º";
    display: inline-block;
    text-decoration: none;
    color: #0480a9;
}

#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one::before {
    color: #666;
    position: absolute;
    left: 0;
    bottom: 0;
}

#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one label {
    font-size: 75%;
    color: #666;
}

#ndq-content .market-data-filter-form .form-item.form-item-period-compare-two {
    padding-left: 25px;
}

#ndq-content .market-data-filter-form .form-item.form-item-period-compare-two::before {
    color: #666;
    content: 'to';
    font-weight: bold;
    position: absolute;
    left: 0;
    bottom: 0;
}

#ndq-content .market-data-filter-form .form-item.form-item-period-compare-two label {
    font-size: 75%;
    color: #666;
}

#ndq-content .market-data-filter-form input {
    margin: 2.8em 0em 1.42857em 0em;
}

#ndq-content .md-download {
    float: left;
    width: 100%;
    margin: 1em 0;
}

#ndq-content .md-download .filesize {
    margin-left: 0.5em;
}

#ndq-content .historical-price-lookup-form .form-submit,#ndq-content .stock-price-calculator-form .form-submit {
    margin-top: 3.1em;
}

@media (max-width: 481px) {
    #ndq-content .historical-price-lookup-form .form-wrapper {
        display:block;
        clear: both;
    }

    #ndq-content .historical-price-lookup-form .form-item {
        margin-right: 5px;
        margin-bottom: 0;
    }

    #ndq-content .historical-price-lookup-form .form-submit {
        margin-top: 10px;
    }
}

#ndq-content .form-item-symbols-historical {
    max-width: 120px;
}

#ndq-content .form-item-symbols-historical .form-select {
    max-width: 120px;
}

#ndq-content .form-no-label {
    margin-top: 2.8em;
}

#ndq-content .filter-row {
    float: left;
    width: 100%;
}

#ndq-content .captcha-admin-links {
    float: left;
    width: 100%;
}

#ndq-content .form-select {
    width: auto;
}

#ndq-content .contact-form input[type="text"],#ndq-content .contact-form input[type="search"],#ndq-content .contact-form input[type="tel"],#ndq-content .contact-form input[type="url"],#ndq-content .contact-form input[type="email"],#ndq-content .contact-form input[type="password"],#ndq-content .contact-form input[type="date"],#ndq-content .contact-form input[type="time"],#ndq-content .contact-form input[type="number"],#ndq-content .contact-form input[type="datalist"] {
    width: 100%;
}

#ndq-content .contact-form textarea,#ndq-content .contact-form select,#ndq-content .contact-form fieldset,#ndq-content .contact-form .form-select {
    width: 100%;
}

#ndq-content .asterisk::after {
    content: "*";
    color: #c00;
    display: inline;
    margin: 0;
}

#ndq-content .nir-email-alerts-signup-form input[type="text"],#ndq-content .nir-email-alerts-signup-form input[type="search"],#ndq-content .nir-email-alerts-signup-form input[type="tel"],#ndq-content .nir-email-alerts-signup-form input[type="url"],#ndq-content .nir-email-alerts-signup-form input[type="email"],#ndq-content .nir-email-alerts-signup-form input[type="password"],#ndq-content .nir-email-alerts-signup-form input[type="date"],#ndq-content .nir-email-alerts-signup-form input[type="time"],#ndq-content .nir-email-alerts-signup-form input[type="number"],#ndq-content .nir-email-alerts-signup-form input[type="datalist"] {
    width: 100%;
}

#ndq-content .nir-email-alerts-signup-form .form-select {
    width: 100%;
}

#ndq-content .nir-email-alerts-signup-form table {
    table-layout: fixed;
}

#ndq-content .nir-email-alerts-signup-form table th {
    border-bottom: 0;
    color: #333;
    background: #fff;
}

#ndq-content .nir-email-alerts-signup-form table th:first-child::after {
    content: "*";
    color: #c00;
    display: inline;
    margin: 0 0 0 5px;
}

#ndq-content .nir-email-alerts-signup-form table th,#ndq-content .nir-email-alerts-signup-form table td {
    padding: 5px 0;
}

#ndq-content .ipe-block-plugin-form select {
    color: #333;
    padding: 1px 5px;
    appearance: menulist;
    margin-bottom: 0.5em;
    -moz-appearance: menulist;
    -webkit-appearance: menulist;
}

#ndq-content .form-item-nir-email-alerts-unsubscribe-from-all {
    margin: 1em 0;
}

#ndq-content .form-item-nir-email-alerts-unsubscribe-from-all label {
    font-weight: bold;
}

#ndq-content .modal-content .field--name-field-nir-person-company,#ndq-content .modal-content .field--name-field-nir-person-dir-since {
    margin-bottom: 1em;
}

#ndq-content .modal-content .field--name-field-nir-person-dir-details .field__item {
    margin: 0.4em 0;
}

#ndq-content .modal-content .field--name-field-nir-person-dir-details .field__item:before {
    font-size: 22px;
}

#ndq-content .modal-content h3.full-name {
    margin-top: 0;
}

#ndq-content .modal-content a {
    color: #0480a9;
}

#ndq-content .ui-dialog button,#ndq-content .ui-dialog button:hover {
    background: none;
}

#ndq-content .bold-row {
    font-weight: bold;
}

#ndq-content .table-title {
    float: left;
    width: 100%;
}

#ndq-content .form-table,#ndq-content form table {
    table-layout: auto;
}

#ndq-content .form-table tr,#ndq-content form table tr {
    vertical-align: top;
}

#ndq-content .form-table tr:nth-child(odd),#ndq-content .form-table tr:nth-child(even),#ndq-content form table tr:nth-child(odd),#ndq-content form table tr:nth-child(even) {
    background-color: transparent;
}

#ndq-content .form-table tr.field-multiple-drag,#ndq-content form table tr.field-multiple-drag {
    padding: 15px 0 0 0;
}

#ndq-content .form-table td.field-multiple-drag,#ndq-content form table td.field-multiple-drag {
    padding: 15px 0 0 0;
}

#ndq-content .form-table__header,#ndq-content .form-table th,#ndq-content form table th {
    background-color: transparent;
}

#ndq-content .ipe-category-picker-top.active h4 {
    width: 100%;
}


.ui-dialog .ui-dialog-titlebar-close {
    right: 10px;
    top: 10px;
}

.ir-day [class*='block-region-'] {
    margin-bottom: 3em;
}

[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav {
    padding: 0 1em 2em 1em;
    margin-bottom: 1em;
}

[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top {
    background-color: #fff;
}

[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top::after,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top::after {
    content: '';
    width: 100%;
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    border-bottom: 1px var(--border-style,solid) var(--border-color,#cbcbcd);
}

[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li {
    padding: 1em 0;
    flex: 0 0 33.333333%;
    text-align: center;
}

[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li:last-child,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li:last-child {
    padding: 0;
    flex: 0 0 100%;
}

nav.block--system-menu-blockir-day-sub-nav [class*='llf-btn'],nav.block--system-menu-blockir-day-sub-nav [class*='idm-btn'],nav.block--system-menu-blockir-day-sub-nav .button,nav.block--system-menu-blockir-day-sub-nav button,nav.block--system-menu-blockir-day-sub-nav input[type="submit"] {
    --button-display: block;
    display: block;
}

@media screen and (min-width: 768px) {
    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav {
        padding:1em;
        margin-bottom: 1em;
    }

    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul {
        flex-direction: row;
        align-items: center;
    }

    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li {
        flex: 0 0 auto !important;
        text-align: left;
        padding: 1em 1.75em 1em 0;
    }
}

@media screen and (min-width: 992px) {
    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav {
        padding:1em 0 1em 0;
        margin-bottom: 1em;
    }
}

.ir-day .ndm-hero {
    position: relative;
    padding: 3em;
    min-height: 33vw;
    display: flex;
    align-items: center;
}

.ir-day .ndm-full-bg {
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.ir-day .ndm-full-bg::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: .5;
}

.ir-day .ndm-full-bg img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.ir-day .ndm-hero-content {
    position: relative;
}

.ir-day .ndm-modal-bio-portrait {
    height: 0;
    padding-top: 115%;
    position: relative;
    display: block;
    background-color: #ccc;
}

.ir-day .ndm-modal-bio-portrait img,.ir-day .ndm-modal-bio-portrait.bio-no-image:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
}

.ir-day .ndm-modal-bio-portrait.bio-no-image:before {
    display: flex;
    justify-content: center;
    align-items: center;
    content: "Read Bio";
    font-size: 2em;
    color: #fff;
    font-weight: bold;
}

.ir-day-page .bio-dialog-modal .ui-widget-header {
    background: none;
}

.ir-day-page .bio-dialog-modal .ui-widget-content {
    border: 0;
}

.ir-day-page .modalDialog .node--person--full .node__content {
    display: flex;
    justify-content: space-between;
}

.ir-day-page .modalDialog .node--person--full .node__content .node-left {
    flex: 0 0 30%;
    padding-right: 15px;
}

.ir-day-page .modalDialog .node--person--full .node__content .node-right {
    flex: 0 0 65%;
}

#ndq-content .block--assets-starter {
    --image-outline-color: var(--border-color,#cbcbcd);
}

#ndq-content .block--assets-starter .nir-widget--list > article {
    border: 0 !important;
    background-color: transparent !important;
    padding: 0 1rem;
    margin-bottom: 2rem;
}

#ndq-content .block--assets-starter .nir-widget .nir-widget--field {
    margin-bottom: 1rem;
}

#ndq-content .block--assets-starter .nir-widget .nir-widget--field:last-child {
    margin-bottom: 0;
}

#ndq-content .block--assets-starter .nir-widget .nir-widget--field.nir-widgets--asset--title {
    font-size: 1.3em;
    line-height: 1.3em;
    margin: 0 0 .7em 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-document .field__item,#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-news-document .field__item,#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-news-supp-format .field__item,#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-news-supp-references .field__item {
    margin-bottom: 0;
    margin-top: 0;
}

#ndq-content .block--assets-starter .nir-widget .nir-widget--field.nir-widget--asset--thumbnail,#ndq-content .block--assets-starter .nir-widget .nir-widget--asset--thumbnail img {
    width: 100%;
}

#ndq-content .block--assets-starter .nir-widget .nir-widget--asset--thumbnail img {
    border: 1px solid var(--image-outline-color);
}

[class*="block--views-blockwidget-bundled-content-block"] {
    --quarterly-results-boxes: transparent;
    --quarterly-results-box-padding: .3em 0;
    --quarterly-results-boxes-border-top: 0px solid var(--border-color,#cbcbcd);
    --quarterly-results-border-width: 1px 0px 1px 0;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block-1--5986"] .view-filters,#ndq-content [class*="block--views-blockwidget-bundled-content-block-1--5986"] .show-all,#ndq-content [class*="block--views-blockwidget-bundled-content-block-1--5986"] .hide-all {
    display: none !important;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter .acc-title,#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter.view-grouping,#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter .acc-body {
    float: none !important;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter {
    padding: 1em 1em 2em 1em;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter .qrGridContent {
    background-color: var(--quarterly-results-boxes);
    padding: 1em 0;
    margin-bottom: 1rem;
    border-width: var(--quarterly-results-border-width,0);
    border-style: solid;
    border-color: var(--border-color);
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter h2 {
    margin: 0 0 1rem 0 !important;
    padding: 0 !important;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter h3 {
    border-bottom: var(--quarterly-results-boxes-border-top);
    padding: 0 0 .5rem 0 !important;
    margin: 0 !important;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter ul > li {
    padding: var(--quarterly-results-box-padding) !important;
    border: 0 !important;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter .sameH {
    align-content: space-between;
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter .qrGridContent .views-field {
    width: 100%;
    float: none;
}

#ndq-content [class*="block--views-blockwidget-bundled-content-block"] .bundle-grid-starter .qrGridContent .item-list ul > li {
    background-color: transparent !important;
}

:root {
    --border-color: #cbcbcd;
    --title: 1.2rem;
    --title-line-height: inherit;
    --date-time: 1rem;
}

.nir-node--5806 {
    --title: 1rem;
    --date-time: 1rem;
}

#ndq-content .block--events-starter {
    margin-bottom: 3rem;
}

#ndq-content .block--events-starter article.node--nir-event--nir-widget-list {
    border-bottom: 1px solid var(--border-color);
    padding: 1rem 0;
    margin: 0;
}

#ndq-content .block--events-starter article.node--nir-event--nir-widget-list:first-of-type {
    border-top: 1px solid var(--border-color);
}

#ndq-content .block--events-starter .additional-details:not(:empty) {
    margin-top: 1rem;
}

#ndq-content .block--events-starter .field__item {
    margin: 0 0 0.5rem 0 !important;
    padding: 0 !important;
}

#ndq-content .block--events-starter .nir-widget--event--webcast .field__item,#ndq-content .block--events-starter .nir-widget--event--add-to-calendar .field__item,#ndq-content .block--events-starter .nir-widget--event--support-materials .field__item {
    line-height: 1 !important;
}

#ndq-content .block--events-starter .field__item a {
    display: inline-block;
}

#ndq-content .block--events-starter .asset-link {
    font-size: inherit;
    font-weight: inherit;
    margin: 0;
}

#ndq-content .block--events-starter .field--name-field-nir-event-summary {
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
}

#ndq-content .block--events-starter .nir-widgets--event--title,#ndq-content .block--events-starter .nir-widgets--event--title * {
    font-size: var(--title);
    line-height: var(--title-line-height);
}

#ndq-content .block--events-starter .nir-widget--event--date {
    font-size: var(--date-time);
}

#ndq-content .block--events-starter .nir-widget--event--add-to-calendar .nir-widget--field:last-of-type .field__item {
    margin-bottom: 0 !important;
}

#ndq-content .block--events-starter .add-gcal a,#ndq-content .block--events-starter .add-outlook a {
    font-size: inherit;
}

#ndq-content .block--events-starter .add-outlook,#ndq-content .block--events-starter .add-gcal {
    float: none !important;
}

#ndq-content .block--events-starter .add-outlook,#ndq-content .block--events-starter .add-gcal {
    margin: 0;
}

#ndq-content .block--events-starter .supporting-links {
    margin-top: 1rem;
}

@media (min-width: 768px) {
    #ndq-content .block--events-starter .supporting-links {
        margin-top:0;
    }
}

.nir-node--5806 #ndq-content [class*='llf-col-'].full-on-front {
    flex: 0 0 100% !important;
    max-width: 100%;
}

.nir-node--5806 #ndq-content .nir-widget .full-on-front .nir-widget--field {
    margin-bottom: .7rem;
}

.nir-node--5806 #ndq-content .nir-widget .full-on-front .nir-widget--field:last-of-type {
    margin-bottom: 0rem;
}

:root {
    --border-color: #cbcbcd;
    --title: 1.2rem;
    --title-line-height: inherit;
    --date-time: 0.9rem;
}

.nir-node--5806 {
    --title: 1rem;
    --date-time: 1rem;
}

#ndq-content .block--news-list-starter.block-nir-news form .nir-widgets--field-container {
    display: inline-block;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list article {
    clear: both;
    margin-bottom: 1rem !important;
    padding-bottom: 0.625rem !important;
    border-bottom: 1px solid var(--border-color);
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--accordion {
    display: flex;
}

#ndq-content .block--news-list-starter.block-nir-news__widget a.nir-widget--news--accordion-toggle {
    display: flex;
    align-items: baseline;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--teaser {
    margin-left: 1.375rem !important;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time {
    font-size: var(--date-time);
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--supporting-materials {
    width: auto;
    display: inline-block;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--supporting-materials .nir-widgets-file-link:before,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats .nir-widgets-file-link:before {
    content: "|";
    color: inherit;
    padding-left: 0.5rem;
    padding-right: 0.313rem;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats .nir-widgets-file-link a {
    font-size: 0;
    line-height: 0;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats .nir-widgets-file-link a span:before {
    margin-top: -0.5rem;
    line-height: 1;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field.nir-widget--news--teaser {
    margin: 0 !important;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time {
    margin: 0 !important;
    padding: 0 !important;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field.nir-widget--news--teaser:after {
    content: '...';
    left: -5px;
    position: relative;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field {
    margin: 0 0 .7rem;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field:last-of-type {
    margin: 0;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--read-more {
    padding: 0;
    margin: 0;
    line-height: 1;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--headline,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--headline * {
    font-size: var(--title);
    line-height: var(--title-line-height);
}

#ndq-content .block--news-list-starter.block-nir-news__widget #widget-form-base {
    border: 0;
    background-color: transparent;
    margin: 0 0 1rem 0;
    padding: 0 !important;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list > article,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list > article:last-child {
    border-width: 0;
    border-bottom: 1px solid var(--border-color);
    background-color: transparent !important;
    margin: 0 !important;
    padding: 1rem 0 !important;
}

#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list > article:first-of-type {
    border-top: 1px solid var(--border-color);
}

.nir-node--5816 #ndq-content .block--search-form form .button--primary {
    margin: 0 0 2px .8rem !important;
    float: none;
}

.nir-node--5816 #ndq-content .block-search-form form::after {
    content: '';
    display: none;
}

.nir-node--5816 #ndq-content .block-search-form form input[type=submit] {
    position: relative;
    text-indent: 0;
    color: #fff;
    background-color: #4C77A9;
    top: initial;
    right: initial;
}

@media (min-width: 992px) {
    .nir-node--5816 #ndq-content .block-search-form {
        position:absolute;
        right: 1rem;
        margin-top: 1rem;
    }

    .nir-node--5816 #ndq-content .block-search-form form .form-item {
        display: inline-block;
        ;margin-top: 0 !important;
    }
}

:root {
    --border-color: #cbcbcd;
}

#ndq-content .block--analyst-starter .nirtable {
    border-collapse: collapse;
}

#ndq-content .block--analyst-starter .field--name-field-nir-person-company {
    font-style: normal;
    font-weight: bold;
}

@media (max-width: 769px) {
    #ndq-content .block--analyst-starter .nirtable.collapse-table-wide tbody > tr > td {
        padding-left:20%;
    }
}

#ndq-content .block--people-starter.block--nir-people__widget {
    --max-thumbnail-width: 20%;
    --people-starter--icon-size: 26px;
}

@media (min-width: 1920px) {
    #ndq-content .block--people-starter.block--nir-people__widget {
        --max-thumbnail-width:10%;
    }
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--field {
    margin-bottom: 0.7rem;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--field:last-of-type {
    margin-bottom: 0;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--person--name {
    font-size: 1.2em;
    font-weight: 600;
    margin: 0 0 .5rem 0;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--person--title {
    font-size: 1.1em;
    margin: 0 0 .5rem 0;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article {
    background-color: transparent !important;
    border: 1px solid var(--border-color);
    border-width: 0 0 1px 0;
    padding: 1em 0;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article:first-of-type {
    border-top-width: 1px;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] img,#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] source,#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] svg,#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] picture {
    width: 100%;
    padding: 0;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] {
    float: none;
    padding: 0;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col {
    flex: 1 1 100% !important;
    min-width: 100% !important;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col + .llf-col {
    flex: 1 1 100%;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .nir-widget--field.nir-widget--person--dir-details .nir-widget--list-item {
    margin-right: 0.5em;
    display: block;
}

@media (min-width: 576px) {
    #ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col {
        flex:1 1 var(--max-thumbnail-width) !important;
        min-width: var(--max-thumbnail-width) !important;
    }

    #ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col + .llf-col {
        flex: 1 1 auto;
    }

    #ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .nir-widget--field.nir-widget--person--dir-details .nir-widget--list-item {
        display: inline-block;
    }
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='ndqicon__'],#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='ndqicon__']:before {
    line-height: var(--people-starter--icon-size);
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__independent::before {
    margin-top: -4px;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__calculator::before {
    margin-top: -6px;
}

.ndqicon__calculator::before {
    margin-top: -6px;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__vicechair::before {
    margin-top: -1px;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__chair::before {
    margin-top: -1px;
}

#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__leaddir::before {
    margin-top: -4px;
}

@keyframes opacity0to1 {
    0% {
        opacity: 0;
    }

    10% {
        opacity: 0;
    }

    20% {
        opacity: 0;
    }

    30% {
        opacity: 0;
    }

    40% {
        opacity: 0;
    }

    50% {
        opacity: 0;
    }

    60% {
        opacity: 0.2;
    }

    70% {
        opacity: 0.4;
    }

    80% {
        opacity: 0.6;
    }

    90% {
        opacity: 0.8;
    }

    to {
        opacity: 1;
    }
}

html {
    -webkit-text-size-adjust: 100%;
    line-height: 1.15;
}

body {
    margin: 0;
}

main {
    display: block;
}

h1 {
    font-size: 2em;
    margin: 0.67em 0;
}

hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
}


hr {
    border-top-width: 1px;
}

img {
    border-style: solid;
}

textarea {
    resize: vertical;
}

input::placeholder,textarea::placeholder {
    color: #a0aec0;
}

[role="button"],button {
    cursor: pointer;
}

table {
    border-collapse: collapse;
}

h1,h2,h3,h4,h5,h6 {
    font-size: inherit;
    font-weight: inherit;
}

a {
    color: inherit;
    text-decoration: inherit;
}

button,input,optgroup,select,textarea {
    color: inherit;
    line-height: inherit;
    padding: 0;
}

code,kbd,pre,samp {
    font-family: SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;
}

audio,canvas,embed,iframe,img,object,svg,video {
    display: block;
}

img,video {
    height: auto;
    max-width: 100%;
}

.container {
    width: 100%;
}

@media (min-width: 768px) {
    .container {
        max-width:768px;
    }
}

@media (min-width: 960px) {
    .container {
        max-width:960px;
    }
}

@media (min-width: 1200px) {
    .container {
        max-width:1200px;
    }
}

@media (min-width: 1366px) {
    .container {
        max-width:1366px;
    }
}

[data-whatintent="mouse"] :focus,[data-whatintent="touch"] :focus {
    outline: none;
}

.visually-hidden {
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px,1px,1px,1px);
    height: 1px;
    overflow: hidden;
    position: absolute !important;
    white-space: nowrap;
    width: 1px;
}

.block-quote {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: block;
   
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 12px;
    padding-top: 50px;
    position: relative;
}

@media (min-width: 960px) {
    .block-quote {
        margin-bottom:20px;
        padding-top: 70px;
    }
}

.block-quote p {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 22px;
    line-height: 32px;
    text-align: left;
}

@media (min-width: 960px) {
    .block-quote p {
        font-size:38px;
        line-height: 42px;
    }
}

.block-quote:before {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    content: open-quote;
   
    font-size: 98px;
    left: -4px;
    line-height: 30px;
    position: absolute;
    top: 32px;
    width: 100%;
}

@media (min-width: 960px) {
    .block-quote:before {
        font-size:185px;
        left: -15px;
        line-height: 30px;
        top: 50px;
    }
}

.block-quote:after {
    content: close-quote;
    position: absolute;
    visibility: hidden;
}

.block-quote-citation {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: flex;
    flex-direction: column;
    font-style: normal;
}

.block-quote-citation-name {
   
    font-size: 16px;
    line-height: 24px;
}

.block-quote-citation-position {
   
    font-size: 15px;
    line-height: 22px;
}

.favorite-button.halo:after {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0,0,0,var(--bg-opacity));
    border-radius: 100%;
    content: "";
    height: 100%;
    left: 0;
    opacity: 0.13;
    padding: 6px;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
}

.favorite-button svg {
    margin-left: auto;
    margin-right: auto;
}

.favorite-button:not(.full) {
    border-radius: 100%;
    height: 36px;
    width: 36px;
}

.gradient-sky-to-sand {
    background: transparent linear-gradient(180deg,#c6e7fa,#fbf7ed) 0 0 no-repeat padding-box;
}

img.lazy {
    opacity: 0;
    transition: opacity 0.1s ease-out;
}

.lazy {
    background-image: none !important;
    transition: background-image 0.1s ease-out;
}

.lds-ring {
    display: inline-block;
    height: 80px;
    left: calc(50vw - 20px);
    position: absolute;
    top: calc(50vh - 200px);
    width: 80px;
}

.lds-ring > div {
    animation: lds-ring 1.2s cubic-bezier(0.5,0,0.5,1) infinite;
    border: 8px solid transparent;
    border-radius: 50%;
    border-top-color: #f7b22e;
    box-sizing: border-box;
    display: block;
    height: 64px;
    margin: 8px;
    position: absolute;
    width: 64px;
}

.lds-ring > div:first-child {
    animation-delay: -0.45s;
}

.lds-ring > div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring > div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}

.media-full,.media-full > iframe {
    height: 100%;
    width: 100%;
}

.media-full > img {
    height: auto;
    width: 100%;
}

.media-full-height > img {
    height: 100%;
    width: auto;
}

@media (min-width: 768px) {
    .section-container {
        max-width:656px;
        padding: 56px 0;
    }
}


.breadcrumbs li {
    display: none;
}

@media (min-width: 768px) {
    .breadcrumbs li {
        display:inline;
    }

    .breadcrumbs li:before {
        border-right: 1.6px solid;
        content: "";
        display: inline-block;
        height: 0.8em;
        margin-right: 7px;
        transform: rotate(15deg);
    }

    .breadcrumbs li:first-child a:before {
        content: "<";
        display: inline-block;
        padding-right: 8px;
    }
}

.breadcrumbs li:last-of-type {
    display: inline;
}

.breadcrumbs li a:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@media (min-width: 768px) {
    .breadcrumbs li a:before {
        display:none;
    }
}

@media (hover: hover) {
    .breadcrumbs li a:hover {
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .breadcrumbs li a:hover:after {
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (min-width: 1366px) {
    .breadcrumbs {
        margin-left:auto;
        margin-right: auto;
    }
}

.cta-primary-large,.cta-primary-large > a,.cta-primary-large > button {
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 27px;
    font-size: 16px;
    height: 56px;
    line-height: 56px;
    min-width: 196px;
    padding: 0 2rem;
}

@media (hover: hover) {
    .cta-primary-large:hover,.cta-primary-large > a:hover,.cta-primary-large > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-large.dark,.cta-primary-large:active,.cta-primary-large > a.dark,.cta-primary-large > a:active,.cta-primary-large > button.dark,.cta-primary-large > button:active {
    --bg-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
}

@media (hover: hover) {
    .cta-primary-large.dark:hover,.cta-primary-large > a.dark:hover,.cta-primary-large > button.dark:hover {
        --bg-opacity:1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
    }
}

.cta-primary-large.dark:active,.cta-primary-large > a.dark:active,.cta-primary-large > button.dark:active {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
}

.cta-primary-medium,.cta-primary-medium > a,.cta-primary-medium > button {
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 27px;
    height: 48px;
    line-height: 48px;
    min-width: 164px;
    padding: 0 2rem;
}

@media (hover: hover) {
    .cta-primary-medium:hover,.cta-primary-medium > a:hover,.cta-primary-medium > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-medium.dark,.cta-primary-medium:active,.cta-primary-medium > a.dark,.cta-primary-medium > a:active,.cta-primary-medium > button.dark,.cta-primary-medium > button:active {
    --bg-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
}

@media (hover: hover) {
    .cta-primary-medium.dark:hover,.cta-primary-medium > a.dark:hover,.cta-primary-medium > button.dark:hover {
        --bg-opacity:1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
    }
}

.cta-primary-medium.dark:active,.cta-primary-medium > a.dark:active,.cta-primary-medium > button.dark:active {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
}

.cta-primary-small,.cta-primary-small > a,.cta-primary-small > button {
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 27px;
    font-size: 16px;
    height: 32px;
    line-height: 32px;
    min-width: 136px;
    padding: 0 2rem;
}

@media (hover: hover) {
    .cta-primary-small:hover,.cta-primary-small > a:hover,.cta-primary-small > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-small.dark,.cta-primary-small:active,.cta-primary-small > a.dark,.cta-primary-small > a:active,.cta-primary-small > button.dark,.cta-primary-small > button:active {
    --bg-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
}

@media (hover: hover) {
    .cta-primary-small.dark:hover,.cta-primary-small > a.dark:hover,.cta-primary-small > button.dark:hover {
        --bg-opacity:1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
    }
}

.cta-primary-small.dark:active,.cta-primary-small > a.dark:active,.cta-primary-small > button.dark:active {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
}

.bg-black {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0,0,0,var(--bg-opacity));
}

.bg-white {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
}

.bg-gray-200 {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237,242,247,var(--bg-opacity));
}

.bg-gray-800 {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45,55,72,var(--bg-opacity));
}

.bg-green {
    --bg-opacity: 1;
    background-color: #1e7721;
    background-color: rgba(30,119,33,var(--bg-opacity));
}

.bg-teal {
    --bg-opacity: 1;
    background-color: #008b95;
    background-color: rgba(0,139,149,var(--bg-opacity));
}

.bg-purple {
    --bg-opacity: 1;
    background-color: #6639b7;
    background-color: rgba(102,57,183,var(--bg-opacity));
}

.bg-royal {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
}

.bg-royallight {
    --bg-opacity: 1;
    background-color: #1765f4;
    background-color: rgba(23,101,244,var(--bg-opacity));
}

.bg-royaldark {
    --bg-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
}

.bg-lime {
    --bg-opacity: 1;
    background-color: #84c434;
    background-color: rgba(132,196,52,var(--bg-opacity));
}

.bg-limelight {
    --bg-opacity: 1;
    background-color: #91dd33;
    background-color: rgba(145,221,51,var(--bg-opacity));
}

.bg-cerulean {
    --bg-opacity: 1;
    background-color: #7bafd3;
    background-color: rgba(123,175,211,var(--bg-opacity));
}

.bg-chateau {
    --bg-opacity: 1;
    background-color: #1e7721;
    background-color: rgba(30,119,33,var(--bg-opacity));
}

.bg-sky {
    --bg-opacity: 1;
    background-color: #c6e7fa;
    background-color: rgba(198,231,250,var(--bg-opacity));
}

.bg-azure {
    --bg-opacity: 1;
    background-color: #4dbae9;
    background-color: rgba(77,186,233,var(--bg-opacity));
}

.bg-coolgrey {
    --bg-opacity: 1;
    background-color: #dde6ed;
    background-color: rgba(221,230,237,var(--bg-opacity));
}

.bg-sunny {
    --bg-opacity: 1;
    background-color: #f7b22e;
    background-color: rgba(247,178,46,var(--bg-opacity));
}

.bg-sandstone {
    --bg-opacity: 1;
    background-color: #fbf7ed;
    background-color: rgba(251,247,237,var(--bg-opacity));
}

.bg-tertiaryyellow {
    --bg-opacity: 1;
    background-color: #fff5de;
    background-color: rgba(255,245,222,var(--bg-opacity));
}

.bg-olympic {
    --bg-opacity: 1;
    background-color: #2475a5;
    background-color: rgba(36,117,165,var(--bg-opacity));
}

.bg-turquoise {
    --bg-opacity: 1;
    background-color: #27817f;
    background-color: rgba(39,129,127,var(--bg-opacity));
}

.bg-grey-13 {
    --bg-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
}

.bg-grey-27 {
    --bg-opacity: 1;
    background-color: #bbb;
    background-color: rgba(187,187,187,var(--bg-opacity));
}

.bg-grey-50 {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
}

.bg-grey-60 {
    --bg-opacity: 1;
    background-color: #666;
    background-color: rgba(102,102,102,var(--bg-opacity));
}

.bg-grey-73 {
    --bg-opacity: 1;
    background-color: #444;
    background-color: rgba(68,68,68,var(--bg-opacity));
}

.bg-grey-93 {
    --bg-opacity: 1;
    background-color: #131313;
    background-color: rgba(19,19,19,var(--bg-opacity));
}

.bg-grey-07 {
    --bg-opacity: 1;
    background-color: #eee;
    background-color: rgba(238,238,238,var(--bg-opacity));
}

.bg-grey-03 {
    --bg-opacity: 1;
    background-color: #f9f9f9;
    background-color: rgba(249,249,249,var(--bg-opacity));
}

.bg-primarygrey {
    --bg-opacity: 1;
    background-color: #4a4a4a;
    background-color: rgba(74,74,74,var(--bg-opacity));
}

.bg-secondaryblue {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
}

.bg-primaryblue {
    --bg-opacity: 1;
    background-color: #003876;
    background-color: rgba(0,56,118,var(--bg-opacity));
}

.bg-crisisred {
    --bg-opacity: 1;
    background-color: #f34436;
    background-color: rgba(243,68,54,var(--bg-opacity));
}

.bg-errorred {
    --bg-opacity: 1;
    background-color: #b0001f;
    background-color: rgba(176,0,31,var(--bg-opacity));
}

.bg-midnightblue {
    --bg-opacity: 1;
    background-color: #003c69;
    background-color: rgba(0,60,105,var(--bg-opacity));
}

.bg-marineblue {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
}

.bg-skyblue {
    --bg-opacity: 1;
    background-color: #0098db;
    background-color: rgba(0,152,219,var(--bg-opacity));
}

.bg-mossgreen {
    --bg-opacity: 1;
    background-color: #34b233;
    background-color: rgba(52,178,51,var(--bg-opacity));
}

.bg-highlightblue {
    --bg-opacity: 1;
    background-color: #a5e3ff;
    background-color: rgba(165,227,255,var(--bg-opacity));
}

.bg-lightestblue {
    --bg-opacity: 1;
    background-color: #f2fafe;
    background-color: rgba(242,250,254,var(--bg-opacity));
}

.bg-darkgradient,.bg-lightgradient {
    --bg-opacity: 1;
    background-color: #d00;
    background-color: rgba(221,0,0,var(--bg-opacity));
}

.bg-secondaryorange {
    --bg-opacity: 1;
    background-color: #f90;
    background-color: rgba(255,153,0,var(--bg-opacity));
}

.border-gray-200 {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237,242,247,var(--border-opacity));
}

.border-grey-27 {
    --border-opacity: 1;
    border-color: #bbb;
    border-color: rgba(187,187,187,var(--border-opacity));
}

.rounded-sm {
    border-radius: 8px;
}

.rounded {
    border-radius: 27px;
}

.border-solid {
    border-style: solid;
}

.border-4 {
    border-width: 4px;
}

.border {
    border-width: 1px;
}

.border-r-2 {
    border-right-width: 2px;
}

.border-b-2 {
    border-bottom-width: 2px;
}

.border-t-4 {
    border-top-width: 4px;
}

.block {
    display: block;
}

.inline {
    display: inline;
}

.flex {
    display: flex;
}

.table {
    display: table;
}

.grid {
    display: grid;
}

.hidden {
    display: none;
}

.flex-row {
    flex-direction: row;
}

.flex-row,.flex-row-reverse {
    -webkit-box-orient: horizontal;
}

.flex-row-reverse {
    flex-direction: row-reverse;
}

.flex-col {
    flex-direction: column;
}

.flex-wrap {
    flex-wrap: wrap;
}

.items-start {
    align-items: flex-start;
}

.items-center {
    align-items: center;
}

.justify-start {
    justify-content: flex-start;
}

.justify-end {
    justify-content: flex-end;
}

.justify-center {
    justify-content: center;
}

.justify-between {
    justify-content: space-between;
}

.flex-initial {
    flex: 0 1 auto;
}

.flex-grow {
    flex-grow: 1;
}

.font-semibold {
    font-weight: 600;
}

.font-bold {
    font-weight: 700;
}

.h-6 {
    height: 24px;
}

.h-8 {
    height: 32px;
}

.h-15 {
    height: 60px;
}

.h-50 {
    height: 200px;
}

.h-full {
    height: 100%;
}

.h-screen {
    height: 100vh;
}

.text-h1lg {
    font-size: 56px;
    line-height: 60px;
}

.text-h2lg {
    font-size: 48px;
    line-height: 52px;
}

.text-bodysmall {
    font-size: 14px;
    line-height: 22px;
}

.leading-6 {
    line-height: 1.5rem;
}

.m-6 {
    margin: 24px;
}

.my-2 {
    margin-bottom: 8px;
    margin-top: 8px;
}

.mx-2 {
    margin-left: 8px;
    margin-right: 8px;
}

.my-3 {
    margin-bottom: 12px;
    margin-top: 12px;
}

.my-4 {
    margin-bottom: 16px;
    margin-top: 16px;
}

.mx-4 {
    margin-left: 16px;
    margin-right: 16px;
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

.-mx-5 {
    margin-left: -20px;
    margin-right: -20px;
}

.mb-0 {
    margin-bottom: 0;
}

.mt-1 {
    margin-top: 4px;
}

.mr-1 {
    margin-right: 4px;
}

.mb-1 {
    margin-bottom: 4px;
}

.ml-1 {
    margin-left: 4px;
}

.mt-2 {
    margin-top: 8px;
}

.mr-2 {
    margin-right: 8px;
}

.mb-2 {
    margin-bottom: 8px;
}

.ml-2 {
    margin-left: 8px;
}

.mt-3 {
    margin-top: 12px;
}

.mr-3 {
    margin-right: 12px;
}

.mb-3 {
    margin-bottom: 12px;
}

.ml-3 {
    margin-left: 12px;
}

.mt-4 {
    margin-top: 16px;
}

.mr-4 {
    margin-right: 16px;
}

.mb-4 {
    margin-bottom: 16px;
}

.ml-4 {
    margin-left: 16px;
}

.mt-5 {
    margin-top: 20px;
}

.mr-5 {
    margin-right: 20px;
}

.mb-5 {
    margin-bottom: 20px;
}

.mt-6 {
    margin-top: 24px;
}

.mr-6 {
    margin-right: 24px;
}

.mb-6 {
    margin-bottom: 24px;
}

.ml-6 {
    margin-left: 24px;
}

.mr-7 {
    margin-right: 28px;
}

.mb-7 {
    margin-bottom: 28px;
}

.mt-8 {
    margin-top: 32px;
}

.mb-8 {
    margin-bottom: 32px;
}

.mb-9 {
    margin-bottom: 36px;
}

.mt-10 {
    margin-top: 40px;
}

.mr-10 {
    margin-right: 40px;
}

.mt-11 {
    margin-top: 44px;
}

.ml-12 {
    margin-left: 48px;
}

.mb-14 {
    margin-bottom: 56px;
}

.mb-50 {
    margin-bottom: 200px;
}

.max-w-mobile {
    max-width: calc(100% - 30px);
}

.min-w-full {
    min-width: 100%;
}

.overflow-hidden {
    overflow: hidden;
}

.p-0 {
    padding: 0;
}

.p-1 {
    padding: 4px;
}

.p-2 {
    padding: 8px;
}

.p-3 {
    padding: 12px;
}

.p-4 {
    padding: 16px;
}

.p-6 {
    padding: 24px;
}

.px-0 {
    padding-left: 0;
    padding-right: 0;
}

.py-1 {
    padding-bottom: 4px;
    padding-top: 4px;
}

.px-1 {
    padding-left: 4px;
    padding-right: 4px;
}

.py-2 {
    padding-bottom: 8px;
    padding-top: 8px;
}

.py-3 {
    padding-bottom: 12px;
    padding-top: 12px;
}

.px-3 {
    padding-left: 12px;
    padding-right: 12px;
}

.py-4 {
    padding-bottom: 16px;
    padding-top: 16px;
}

.px-4 {
    padding-left: 16px;
    padding-right: 16px;
}

.px-5 {
    padding-left: 20px;
    padding-right: 20px;
}

.py-6 {
    padding-bottom: 24px;
    padding-top: 24px;
}

.px-6 {
    padding-left: 24px;
    padding-right: 24px;
}

.py-8 {
    padding-bottom: 32px;
    padding-top: 32px;
}

.px-8 {
    padding-left: 32px;
    padding-right: 32px;
}

.px-16 {
    padding-left: 64px;
    padding-right: 64px;
}

.pt-0 {
    padding-top: 0;
}

.pr-0 {
    padding-right: 0;
}

.pb-0 {
    padding-bottom: 0;
}

.pt-1 {
    padding-top: 4px;
}

.pb-1 {
    padding-bottom: 4px;
}

.pl-1 {
    padding-left: 4px;
}

.pt-2 {
    padding-top: 8px;
}

.pb-2 {
    padding-bottom: 8px;
}

.pl-2 {
    padding-left: 8px;
}

.pt-3 {
    padding-top: 12px;
}

.pr-3 {
    padding-right: 12px;
}

.pb-3 {
    padding-bottom: 12px;
}

.pl-3 {
    padding-left: 12px;
}

.pt-4 {
    padding-top: 16px;
}

.pr-4 {
    padding-right: 16px;
}

.pb-4 {
    padding-bottom: 16px;
}

.pl-4 {
    padding-left: 16px;
}

.pr-5 {
    padding-right: 20px;
}

.pb-5 {
    padding-bottom: 20px;
}

.pt-6 {
    padding-top: 24px;
}

.pr-6 {
    padding-right: 24px;
}

.pb-6 {
    padding-bottom: 24px;
}

.pl-6 {
    padding-left: 24px;
}

.pt-7 {
    padding-top: 28px;
}

.pb-7 {
    padding-bottom: 28px;
}

.pt-8 {
    padding-top: 32px;
}

.pr-8 {
    padding-right: 32px;
}

.pb-8 {
    padding-bottom: 32px;
}

.pl-8 {
    padding-left: 32px;
}

.pt-9 {
    padding-top: 36px;
}

.pr-9 {
    padding-right: 36px;
}

.pb-10 {
    padding-bottom: 40px;
}

.pt-12 {
    padding-top: 48px;
}

.pb-13 {
    padding-bottom: 52px;
}

.pb-15 {
    padding-bottom: 60px;
}

.pt-20 {
    padding-top: 80px;
}

.pt-25 {
    padding-top: 100px;
}

.pb-30 {
    padding-bottom: 120px;
}

.pb-50 {
    padding-bottom: 200px;
}

.static {
    position: static;
}

.fixed {
    position: fixed;
}

.absolute {
    position: absolute;
}

.relative {
    position: relative;
}

.top-0 {
    top: 0;
}

.right-0 {
    right: 0;
}

.bottom-0 {
    bottom: 0;
}

.left-0 {
    left: 0;
}

.resize {
    resize: both;
}

.table-auto {
    table-layout: auto;
}

.text-left {
    text-align: left;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.text-black {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
}

.text-white {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.text-gray-300 {
    --text-opacity: 1;
    color: #e2e8f0;
    color: rgba(226,232,240,var(--text-opacity));
}

.text-gray-500 {
    --text-opacity: 1;
    color: #a0aec0;
    color: rgba(160,174,192,var(--text-opacity));
}

.text-royaldark {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

.text-chateau {
    --text-opacity: 1;
    color: #1e7721;
    color: rgba(30,119,33,var(--text-opacity));
}

.text-grey-50 {
    --text-opacity: 1;
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
}

.text-grey-60 {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
}

.text-grey-73 {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
}

.text-grey-93 {
    --text-opacity: 1;
    color: #131313;
    color: rgba(19,19,19,var(--text-opacity));
}

.text-secondaryblue {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.text-pomegranate {
    --text-opacity: 1;
    color: #f34436;
    color: rgba(243,68,54,var(--text-opacity));
}

.select-none {
    -webkit-user-select: none;
    user-select: none;
}

.invisible {
    visibility: hidden;
}

.whitespace-pre-line {
    white-space: pre-line;
}

.w-3 {
    width: 12px;
}

.w-6 {
    width: 24px;
}

.w-17 {
    width: 68px;
}

.w-sidebar {
    width: 296px;
}

.w-2\\/5 {
    width: 40%;
}

.w-full {
    width: 100%;
}

.z-0 {
    z-index: 0;
}

.gap-0 {
    grid-gap: 0;
    gap: 0;
}

.gap-1 {
    grid-gap: 4px;
    gap: 4px;
}

.gap-3 {
    grid-gap: 12px;
    gap: 12px;
}

.gap-4 {
    grid-gap: 16px;
    gap: 16px;
}

.col-gap-4 {
    grid-column-gap: 16px;
    column-gap: 16px;
}

.row-gap-6 {
    grid-row-gap: 24px;
    row-gap: 24px;
}

.grid-cols-1 {
    grid-template-columns: repeat(1,minmax(0,1fr));
}

.grid-cols-2 {
    grid-template-columns: repeat(2,minmax(0,1fr));
}

.grid-cols-3 {
    grid-template-columns: repeat(3,minmax(0,1fr));
}

.grid-cols-6 {
    grid-template-columns: repeat(6,minmax(0,1fr));
}

.grid-cols-10 {
    grid-template-columns: repeat(10,minmax(0,1fr));
}

.grid-cols-12 {
    grid-template-columns: repeat(12,minmax(0,1fr));
}

.col-span-2 {
    grid-column: span 2 / span 2;
}

.col-span-3 {
    grid-column: span 3 / span 3;
}

.col-span-4 {
    grid-column: span 4 / span 4;
}

.col-span-6 {
    grid-column: span 6 / span 6;
}

.col-span-10 {
    grid-column: span 10 / span 10;
}

.col-span-12 {
    grid-column: span 12 / span 12;
}

.col-start-9 {
    grid-column-start: 9;
}

.col-start-11 {
    grid-column-start: 11;
}

.grid-rows-2 {
    grid-template-rows: repeat(2,minmax(0,1fr));
}

.transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
}

@keyframes spin {
    to {
        transform: rotate(1turn);
    }
}

@keyframes ping {
    75%,to {
        opacity: 0;
        transform: scale(2);
    }
}

@keyframes pulse {
    50% {
        opacity: 0.5;
    }
}

@keyframes bounce {
    0%,to {
        animation-timing-function: cubic-bezier(0.8,0,1,1);
        transform: translateY(-25%);
    }

    50% {
        animation-timing-function: cubic-bezier(0,0,0.2,1);
        transform: none;
    }
}

.cta-secondary-large,.cta-secondary-large > a,.cta-secondary-large > button {
    --text-opacity: 1;
    border-radius: 27px;
    box-shadow: inset 0 0 0 3px #1765f4;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    display: inline-block;
   
    font-size: 16px;
    height: 54px;
    letter-spacing: 0.16px;
    line-height: 54px;
    min-width: 196px;
    padding: 0 2rem;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-secondary-large:hover,.cta-secondary-large > a:hover,.cta-secondary-large > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-secondary-large > a > span,.cta-secondary-large > a i,.cta-secondary-large > a svg,.cta-secondary-large > button > span,.cta-secondary-large > button i,.cta-secondary-large > button svg,.cta-secondary-large > span,.cta-secondary-large i,.cta-secondary-large svg {
    display: inline;
}

.cta-secondary-large > a svg,.cta-secondary-large > button svg,.cta-secondary-large svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-secondary-large:active,.cta-secondary-large > a:active,.cta-secondary-large > button:active {
    --bg-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
    box-shadow: inset 0 0 0 3px #062c57;
}

.cta-secondary-large.inverted,.cta-secondary-large > a.inverted,.cta-secondary-large > button.inverted {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #fff;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

@media (hover: hover) {
    .cta-secondary-large.inverted:hover,.cta-secondary-large > a.inverted:hover,.cta-secondary-large > button.inverted:hover {
        box-shadow: inset 0 0 0 3px #1765f4;
    }

    .cta-secondary-large.inverted:hover:disabled,.cta-secondary-large > a.inverted:hover:disabled,.cta-secondary-large > button.inverted:hover:disabled {
        box-shadow: inset 0 0 0 3px #bbb;
    }
}

.cta-secondary-large.inverted:active,.cta-secondary-large > a.inverted:active,.cta-secondary-large > button.inverted:active {
    box-shadow: inset 0 0 0 3px #062c57;
}

.cta-secondary-large:disabled,.cta-secondary-large > a:disabled,.cta-secondary-large > button:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-secondary-large:disabled:hover,.cta-secondary-large > a:disabled:hover,.cta-secondary-large > button:disabled:hover {
        background-color:transparent;
    }
}

.cta-secondary-large.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-secondary-medium,.cta-secondary-medium > a,.cta-secondary-medium > button {
    --text-opacity: 1;
    border-radius: 27px;
    box-shadow: inset 0 0 0 3px #1765f4;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    display: inline-block;
   
    font-size: 16px;
    height: 44px;
    letter-spacing: 0.16px;
    line-height: 44px;
    min-width: 164px;
    padding: 0 2rem;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-secondary-medium:hover,.cta-secondary-medium > a:hover,.cta-secondary-medium > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-secondary-medium > a > span,.cta-secondary-medium > a i,.cta-secondary-medium > a svg,.cta-secondary-medium > button > span,.cta-secondary-medium > button i,.cta-secondary-medium > button svg,.cta-secondary-medium > span,.cta-secondary-medium i,.cta-secondary-medium svg {
    display: inline;
}

.cta-secondary-medium > a svg,.cta-secondary-medium > button svg,.cta-secondary-medium svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-secondary-medium:active,.cta-secondary-medium > a:active,.cta-secondary-medium > button:active {
    --bg-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
    box-shadow: inset 0 0 0 3px #062c57;
}

.cta-secondary-medium.inverted,.cta-secondary-medium > a.inverted,.cta-secondary-medium > button.inverted {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #fff;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

@media (hover: hover) {
    .cta-secondary-medium.inverted:hover,.cta-secondary-medium > a.inverted:hover,.cta-secondary-medium > button.inverted:hover {
        box-shadow: inset 0 0 0 3px #1765f4;
    }

    .cta-secondary-medium.inverted:hover:disabled,.cta-secondary-medium > a.inverted:hover:disabled,.cta-secondary-medium > button.inverted:hover:disabled {
        box-shadow: inset 0 0 0 3px #bbb;
    }
}

.cta-secondary-medium.inverted:active,.cta-secondary-medium > a.inverted:active,.cta-secondary-medium > button.inverted:active {
    box-shadow: inset 0 0 0 3px #062c57;
}

.cta-secondary-medium:disabled,.cta-secondary-medium > a:disabled,.cta-secondary-medium > button:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-secondary-medium:disabled:hover,.cta-secondary-medium > a:disabled:hover,.cta-secondary-medium > button:disabled:hover {
        background-color:transparent;
    }
}

.cta-secondary-medium.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-secondary-small,.cta-secondary-small > a,.cta-secondary-small > button {
    --text-opacity: 1;
    border-radius: 27px;
    box-shadow: inset 0 0 0 3px #1765f4;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    display: inline-block;
   
    font-size: 16px;
    height: 36px;
    letter-spacing: 0.16px;
    line-height: 36px;
    min-width: 136px;
    padding: 0 2rem;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-secondary-small:hover,.cta-secondary-small > a:hover,.cta-secondary-small > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-secondary-small > a > span,.cta-secondary-small > a i,.cta-secondary-small > a svg,.cta-secondary-small > button > span,.cta-secondary-small > button i,.cta-secondary-small > button svg,.cta-secondary-small > span,.cta-secondary-small i,.cta-secondary-small svg {
    display: inline;
}

.cta-secondary-small > a svg,.cta-secondary-small > button svg,.cta-secondary-small svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-secondary-small:active,.cta-secondary-small > a:active,.cta-secondary-small > button:active {
    --bg-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
    box-shadow: inset 0 0 0 3px #062c57;
}

.cta-secondary-small.inverted,.cta-secondary-small > a.inverted,.cta-secondary-small > button.inverted {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #fff;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

@media (hover: hover) {
    .cta-secondary-small.inverted:hover,.cta-secondary-small > a.inverted:hover,.cta-secondary-small > button.inverted:hover {
        box-shadow: inset 0 0 0 3px #1765f4;
    }

    .cta-secondary-small.inverted:hover:disabled,.cta-secondary-small > a.inverted:hover:disabled,.cta-secondary-small > button.inverted:hover:disabled {
        box-shadow: inset 0 0 0 3px #bbb;
    }
}

.cta-secondary-small.inverted:active,.cta-secondary-small > a.inverted:active,.cta-secondary-small > button.inverted:active {
    box-shadow: inset 0 0 0 3px #062c57;
}

.cta-secondary-small:disabled,.cta-secondary-small > a:disabled,.cta-secondary-small > button:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-secondary-small:disabled:hover,.cta-secondary-small > a:disabled:hover,.cta-secondary-small > button:disabled:hover {
        background-color:transparent;
    }
}

.cta-secondary-small.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.link-large:not(.flex),.link-large > a,.link-large button {
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.link-large:not(.flex):after,.link-large > a:after,.link-large button:after {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

@media (hover: hover) {
    .link-large:not(.flex):hover,.link-large > a:hover,.link-large button:hover {
        --text-opacity:1;
        color: #1765f4;
        color: rgba(23,101,244,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-large:not(.flex):hover:after,.link-large > a:hover:after,.link-large button:hover:after {
        --bg-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-standard:not(.flex),.link-standard > a,.link-standard button {
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.link-standard:not(.flex):after,.link-standard > a:after,.link-standard button:after {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

@media (hover: hover) {
    .link-standard:not(.flex):hover,.link-standard > a:hover,.link-standard button:hover {
        --text-opacity:1;
        color: #1765f4;
        color: rgba(23,101,244,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-standard:not(.flex):hover:after,.link-standard > a:hover:after,.link-standard button:hover:after {
        --bg-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-small:not(.flex),.link-small > a,.link-small button {
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.link-small:not(.flex):after,.link-small > a:after,.link-small button:after {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

@media (hover: hover) {
    .link-small:not(.flex):hover,.link-small > a:hover,.link-small button:hover {
        --text-opacity:1;
        color: #1765f4;
        color: rgba(23,101,244,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-small:not(.flex):hover:after,.link-small > a:hover:after,.link-small button:hover:after {
        --bg-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.heading-one,h1,h1 > p {
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
}

@media (min-width: 768px) {
    .heading-one,h1,h1 > p {
        font-size:40px;
        line-height: 48px;
    }
}

.heading-two,h2,h2 > p {
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));

}

@media (min-width: 768px) {
    .heading-two,h2,h2 > p {
        font-size:40px;
        line-height: 48px;
    }
}

.heading-three,h3,h3 > p {
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
}

@media (min-width: 768px) {
    .heading-three,h3,h3 > p {
        font-size:24px;
        line-height: 36px;
    }
}

.heading-four,h4,h4 > p {
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
}

@media (min-width: 1366px) {
    .heading-four,h4,h4 > p {
        letter-spacing:1.96px;
    }
}

.heading-five,.heading-six,h5,h5 > p,h6,h6 > p {
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
}

.display-one-home {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

    font-size: 32px;
    line-height: 40px;
}

@media (min-width: 768px) {
    .display-one-home {
        font-size:52px;
        line-height: 44px;
    }
}

@media (min-width: 1366px) {
    .display-one-home {
        font-size:60px;
        line-height: 52px;
    }
}

.display-two-home {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
   
    font-size: 72px;
    line-height: 56px;
}

@media (min-width: 768px) {
    .display-two-home {
        font-size:76px;
        line-height: 68px;
    }
}

@media (min-width: 1366px) {
    .display-two-home {
        font-size:80px;
        line-height: 72px;
    }
}

.display-one {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 24px;
    line-height: 32px;
}

@media (min-width: 768px) {
    .display-one {
        font-size:40px;
        line-height: 42px;
    }
}

@media (min-width: 1366px) {
    .display-one {
        font-size:40px;
        line-height: 48px;
    }
}

.display-two {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 72px;
    line-height: 48px;
}

@media (min-width: 768px) {
    .display-two {
        font-size:124px;
        line-height: 80px;
    }
}

@media (min-width: 1366px) {
    .display-two {
        font-size:136px;
        line-height: 88px;
    }
}

.hero-one {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 26px;
    line-height: 32px;
}

@media (min-width: 1366px) {
    .hero-one {
        font-size:44px;
        line-height: 48px;
    }
}

.hero-two {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 72px;
    line-height: 48px;
}

@media (min-width: 1366px) {
    .hero-two {
        font-size:138px;
        line-height: 138px;
    }
}

.standard-heading-one {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

    font-size: 32px;
    line-height: 40px;
    text-align: left;
}

@media (min-width: 1366px) {
    .standard-heading-one {
        font-size:60px;
        line-height: 68px;
    }
}

.standard-heading-one h1,.standard-heading-one h2,.standard-heading-one h3,.standard-heading-one h4,.standard-heading-one p {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

    font-size: 32px;
    line-height: 40px;
    text-align: left;
}

@media (min-width: 1366px) {
    .standard-heading-one h1,.standard-heading-one h2,.standard-heading-one h3,.standard-heading-one h4,.standard-heading-one p {
        font-size:60px;
        line-height: 68px;
    }
}

.standard-heading-two {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 32px;
    line-height: 40px;
    text-align: center;
}

@media (min-width: 1366px) {
    .standard-heading-two {
        font-size:60px;
        line-height: 68px;
    }
}

.standard-heading-two h1,.standard-heading-two h2,.standard-heading-two h3,.standard-heading-two h4,.standard-heading-two p {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 32px;
    line-height: 40px;
    text-align: center;
}

@media (min-width: 1366px) {
    .standard-heading-two h1,.standard-heading-two h2,.standard-heading-two h3,.standard-heading-two h4,.standard-heading-two p {
        font-size:60px;
        line-height: 68px;
    }
}

ol li,ul li {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 16px;
    line-height: 24px;
}

.subtitle-one {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));

    font-size: 24px;
    letter-spacing: 0.19px;
    line-height: 34px;
}

.subtitle-two {
   
    font-size: 20px;
    letter-spacing: 0.16px;
    line-height: 28px;
}

.body-large,.subtitle-two {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
}

.body-large {
   
    letter-spacing: -0.28px;
}

.body-standard-16,p {
    letter-spacing: 0.08px;
}

.body-bold-large {
    letter-spacing: -0.28px;
}

.quote {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 28px;
    line-height: 34px;
}

@media (min-width: 1366px) {
    .quote {
        font-size:38px;
        line-height: 61px;
    }
}

.style-title {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 88px;
    line-height: 68px;
}

@media (min-width: 768px) {
    .style-title {
        font-size:80px;
        line-height: 56px;
    }
}

.caption {
    font-size: 14px;
    letter-spacing: 0.06px;
}

.caption,.caption-small {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    line-height: 14px;
}

.caption-small {
    font-size: 12px;
}

.overline,.overline-article,.overline-article-dark,.overline-small {
   
    font-size: 14px;
    line-height: 14px;
    text-transform: uppercase;
}

.overline {
    letter-spacing: 0.96px;
}

.overline,.overline-small {
    --text-opacity: 1;
    color: #1765f4;
    color: rgba(23,101,244,var(--text-opacity));
}

.overline-small {
    font-size: 12px;
    line-height: 16px;
}

.overline-article {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    letter-spacing: 0.38px;
}

.button-link,.button-link-large,.button-link-large-white,.button-link-small,.button-link-white,.subtle-link {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
   
    font-size: 16px;
    line-height: 22px;
}

.button-link-small {
    font-size: 14px;
    line-height: 34px;
}

.button-link-large {
    font-size: 18px;
    line-height: 22px;
}

.button-link-large-white,.button-link-white {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.button-link-large-white {
    font-size: 18px;
    line-height: 22px;
}

.subtle-link {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
}

.overline-crisis {
    font-size: 14px;
    line-height: 14px;
}

.overline-crisis,.overline-crisis-small {
    --text-opacity: 1;
    color: #f34436;
    color: rgba(243,68,54,var(--text-opacity));
   
    text-transform: uppercase;
}

.overline-crisis-small {
    font-size: 12px;
    line-height: 16px;
}

.salary {
    --text-opacity: 1;
    color: #84c434;
    color: rgba(132,196,52,var(--text-opacity));
   
    font-size: 24px;
    line-height: 14px;
}

@media (min-width: 1366px) {
    .salary {
        font-size:18px;
        line-height: 14px;
    }
}

.salary-large {
    --text-opacity: 1;
    color: #84c434;
    color: rgba(132,196,52,var(--text-opacity));
   
    font-size: 24px;
    line-height: 14px;
}

@media (min-width: 1366px) {
    .salary-large {
        font-size:20px;
        line-height: 14px;
    }
}

.job-title-small {
    font-size: 18px;
    line-height: 20px;
}

.job-title-medium,.job-title-small {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
}

.job-title-medium {
    font-size: 20px;
    line-height: 24px;
}

.job-title-large {
    font-size: 22px;
    line-height: 26px;
}

.job-title-large,.job-title-xlarge {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
}

.job-title-xlarge {
    font-size: 24px;
    line-height: 32px;
}

.blog-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));

    font-size: 22px;
    line-height: 28px;
}

@media (min-width: 768px) {
    .blog-title {
        font-size:26px;
        line-height: 32px;
    }
}

.blog-title-large {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));

    font-size: 22px;
    font-size: 24px;
    line-height: 28px;
    line-height: 30px;
}

@media (min-width: 768px) {
    .blog-title-large {
        font-size:26px;
        font-size: 30px;
        line-height: 32px;
        line-height: 38px;
    }
}

.blog-title-grey {
   
    font-size: 26px;
    line-height: 32px;
}

@media (min-width: 768px) {
    .blog-title-grey {
        font-size:30px;
        line-height: 44px;
    }
}

@media (min-width: 1366px) {
    .blog-title-grey {
        font-size:36px;
        line-height: 40px;
    }
}

.blog-title-large-grey {
   
    font-size: 32px;
    line-height: 40px;
}

@media (min-width: 768px) {
    .blog-title-large-grey {
        font-size:34px;
        line-height: 40px;
    }
}

@media (min-width: 1366px) {
    .blog-title-large-grey {
        font-size:42px;
        line-height: 56px;
    }
}

.blog-overline {
    --text-opacity: 1;
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
   
    font-size: 14px;
    line-height: 28px;
}

.form-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 26px;
    line-height: 32px;
}

@media (min-width: 768px) {
    .form-title {
        font-size:24px;
        line-height: 28px;
    }
}

@media (min-width: 1366px) {
    .form-title {
        font-size:32px;
        line-height: 44px;
    }
}

.form-label-top-min {
    color: #131313;
    color: rgba(19,19,19,var(--text-opacity));
}

.form-label-error,.form-label-top-min {
    --text-opacity: 1;
    font-size: 12px;
    line-height: 16px;
}

.form-label-error {
    color: #b0001f;
    color: rgba(176,0,31,var(--text-opacity));
}

.form-label-min-default {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    font-size: 12px;
    line-height: 14px;
}

.form-label-inactive {
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
}

.form-label-entry,.form-label-inactive {
    --text-opacity: 1;
    font-size: 16px;
    line-height: 16px;
}

.form-label-entry {
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
}

.form-label-default {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    font-size: 16px;
    line-height: 16px;
}

.job-card-tag {
    --text-opacity: 1;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 10px;
    line-height: 12px;
    padding: 3px 10px;
    right: 35px;
    text-transform: uppercase;
    top: 0;
}

@media (min-width: 1366px) {
    .job-card-tag {
        font-size:12px;
        line-height: 15px;
        padding: 7px 15px 8px;
        right: 70px;
    }

    .job-card-tag-feature,.job-card-tag-hot {
        right: 30px;
    }
}

.job-card-tag-locum {
    background-color: #0895a3;
}

.job-card-tag-perm {
    background-color: #4eaef2;
}

.job-card-tag-remote {
    background-color: #0895a3;
}

.job-card-tag-recent-view {
    padding: 2px 10px;
    right: 30px;
    top: -16px;
}

/* .fa {
    font-family: Font Awesome\\6 Pro;
    font-family: var(--fa-style-family,"Font Awesome 6 Pro");
    font-weight: 900;
    font-weight: var(--fa-style,900);
} */

.checkedList li:before,.fa,.fa-brands,.fa-duotone,.fa-light,.fa-regular,.fa-solid,.fa-thin,.fab,.fad,.fal,.far,.fas,.fat,.news-content-main-set ul li:before,.rich-text ul li:before {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-feature-settings: normal;
    text-rendering: auto;
    display: inline-block;
    display: var(--fa-display,inline-block);
    font-style: normal;
    font-variant: normal;
    line-height: 1;
}

.fa-1x {
    font-size: 1em;
}

.fa-2x {
    font-size: 2em;
}

.fa-3x {
    font-size: 3em;
}

.fa-4x {
    font-size: 4em;
}

.fa-5x {
    font-size: 5em;
}

.fa-6x {
    font-size: 6em;
}

.fa-7x {
    font-size: 7em;
}

.fa-8x {
    font-size: 8em;
}

.fa-9x {
    font-size: 9em;
}

.fa-10x {
    font-size: 10em;
}

.fa-2xs {
    font-size: 0.625em;
    line-height: 0.1em;
    vertical-align: 0.225em;
}

.fa-xs {
    font-size: 0.75em;
    line-height: 0.0833333333em;
    vertical-align: 0.125em;
}

.fa-sm {
    font-size: 0.875em;
    line-height: 0.0714285714em;
    vertical-align: 0.0535714286em;
}

.fa-lg {
    font-size: 1.25em;
    line-height: 0.05em;
    vertical-align: -0.075em;
}

.fa-xl {
    font-size: 1.5em;
    line-height: 0.0416666667em;
    vertical-align: -0.125em;
}

.fa-2xl {
    font-size: 2em;
    line-height: 0.03125em;
    vertical-align: -0.1875em;
}

.fa-fw {
    text-align: center;
    width: 1.25em;
}

.fa-ul {
    list-style-type: none;
    margin-left: 2.5em;
    margin-left: var(--fa-li-margin,2.5em);
    padding-left: 0;
}

.fa-ul > li {
    position: relative;
}

.fa-li {
    left: -2em;
    left: calc(var(--fa-li-width,2em) * -1);
    line-height: inherit;
    position: absolute;
    text-align: center;
    width: 2em;
    width: var(--fa-li-width,2em);
}

.fa-border {
    border: 0.08em solid #eee;
    border: var(--fa-border-width,0.08em) var(--fa-border-style,solid) var(--fa-border-color,#eee);
    border-radius: 0.1em;
    border-radius: var(--fa-border-radius,0.1em);
    padding: 0.2em 0.25em 0.15em;
    padding: var(--fa-border-padding,0.2em 0.25em 0.15em);
}

.fa-pull-left {
    float: left;
    margin-right: 0.3em;
    margin-right: var(--fa-pull-margin,0.3em);
}

.fa-pull-right {
    float: right;
    margin-left: 0.3em;
    margin-left: var(--fa-pull-margin,0.3em);
}

.fa-beat {
    animation-delay: 0;
    animation-delay: var(--fa-animation-delay,0);
    animation-direction: normal;
    animation-direction: var(--fa-animation-direction,normal);
    animation-duration: 1s;
    animation-duration: var(--fa-animation-duration,1s);
    animation-iteration-count: infinite;
    animation-iteration-count: var(--fa-animation-iteration-count,infinite);
    animation-name: fa-beat;
    animation-timing-function: ease-in-out;
    animation-timing-function: var(--fa-animation-timing,ease-in-out);
}

.fa-fade {
    animation-iteration-count: infinite;
    animation-iteration-count: var(--fa-animation-iteration-count,infinite);
    animation-name: fa-fade;
    animation-timing-function: cubic-bezier(0.4,0,0.6,1);
    animation-timing-function: var(--fa-animation-timing,cubic-bezier(0.4,0,0.6,1));
}

.fa-fade,.fa-flash {
    animation-delay: 0;
    animation-delay: var(--fa-animation-delay,0);
    animation-direction: normal;
    animation-direction: var(--fa-animation-direction,normal);
    animation-duration: 1s;
    animation-duration: var(--fa-animation-duration,1s);
}

.fa-flash {
    animation-iteration-count: infinite;
    animation-iteration-count: var(--fa-animation-iteration-count,infinite);
    animation-name: fa-flash;
    animation-timing-function: cubic-bezier(0.4,0,0.6,1);
    animation-timing-function: var(--fa-animation-timing,cubic-bezier(0.4,0,0.6,1));
}

.fa-flip {
    animation-delay: 0;
    animation-delay: var(--fa-animation-delay,0);
    animation-direction: normal;
    animation-direction: var(--fa-animation-direction,normal);
    animation-duration: 1s;
    animation-duration: var(--fa-animation-duration,1s);
    animation-iteration-count: infinite;
    animation-iteration-count: var(--fa-animation-iteration-count,infinite);
    animation-name: fa-flip;
    animation-timing-function: ease-in-out;
    animation-timing-function: var(--fa-animation-timing,ease-in-out);
}

.fa-spin {
    animation-delay: 0;
    animation-delay: var(--fa-animation-delay,0);
    animation-direction: normal;
    animation-direction: var(--fa-animation-direction,normal);
    animation-duration: 2s;
    animation-duration: var(--fa-animation-duration,2s);
    animation-iteration-count: infinite;
    animation-iteration-count: var(--fa-animation-iteration-count,infinite);
    animation-name: fa-spin;
    animation-timing-function: linear;
    animation-timing-function: var(--fa-animation-timing,linear);
}

.fa-spin-reverse {
    --fa-animation-direction: reverse;
}

.fa-pulse,.fa-spin-pulse {
    animation-direction: normal;
    animation-direction: var(--fa-animation-direction,normal);
    animation-duration: 1s;
    animation-duration: var(--fa-animation-duration,1s);
    animation-iteration-count: infinite;
    animation-iteration-count: var(--fa-animation-iteration-count,infinite);
    animation-name: fa-spin;
    animation-timing-function: steps(8);
    animation-timing-function: var(--fa-animation-timing,steps(8));
}

@media (prefers-reduced-motion:reduce) {
    .fa-beat,.fa-fade,.fa-flash,.fa-flip,.fa-pulse,.fa-spin,.fa-spin-pulse {
        animation-delay: -1ms;
        animation-duration: 1ms;
        animation-iteration-count: 1;
        transition-delay: 0s;
        transition-duration: 0s;
    }
}

@keyframes fa-beat {
    0%,90% {
        transform: scale(1);
    }

    45% {
        transform: scale(1.25);
        transform: scale(var(--fa-beat-scale,1.25));
    }
}

@keyframes fa-fade {
    50% {
        opacity: 0.4;
        opacity: var(--fa-fade-opacity,0.4);
    }
}

@keyframes fa-flash {
    0%,to {
        opacity: 0.4;
        opacity: var(--fa-flash-opacity,0.4);
        transform: scale(1);
    }

    50% {
        opacity: 1;
        transform: scale(1.125);
        transform: scale(var(--fa-flash-scale,1.125));
    }
}

@keyframes fa-flip {
    50% {
        transform: rotateY(-180deg);
        transform: rotate3d(var(--fa-flip-x,0),var(--fa-flip-y,1),var(--fa-flip-z,0),var(--fa-flip-angle,-180deg));
    }
}

@keyframes fa-spin {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}

.fa-rotate-90 {
    transform: rotate(90deg);
}

.fa-rotate-180 {
    transform: rotate(180deg);
}

.fa-rotate-270 {
    transform: rotate(270deg);
}

.fa-flip-horizontal {
    transform: scaleX(-1);
}

.fa-flip-vertical {
    transform: scaleY(-1);
}

.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical {
    transform: scale(-1);
}

.fa-rotate-by {
    transform: rotate(none);
    transform: rotate(var(--fa-rotate-angle,none));
}

.fa-stack {
    display: inline-block;
    height: 2em;
    line-height: 2em;
    position: relative;
    vertical-align: middle;
    width: 2.5em;
}

.fa-stack-1x,.fa-stack-2x {
    left: 0;
    position: absolute;
    text-align: center;
    width: 100%;
    z-index: auto;
    z-index: var(--fa-stack-z-index,auto);
}

.fa-stack-1x {
    line-height: inherit;
}

.fa-stack-2x {
    font-size: 2em;
}

.fa-inverse {
    color: #fff;
    color: var(--fa-inverse,#fff);
}


.breadcrumbs li {
    display: inline;
   
    font-size: 16px;
    line-height: 32px;
    margin-right: 4px;
}

.breadcrumbs li:before {
    border-right: 1.6px solid;
    content: "";
    display: inline-block;
    height: 0.8em;
    margin-right: 7px;
    transform: rotate(15deg);
}

.breadcrumbs li:first-of-type:before {
    display: none;
}

.breadcrumbs li a {
    display: inline-block;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.breadcrumbs li a:after {
    background-color: currentColor;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transform: translateY(-5px);
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.breadcrumbs li a:hover {
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.breadcrumbs li a:hover:after {
    opacity: 1;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.breadcrumbs li {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

.breadcrumbs li:last-of-type {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.breadcrumbs--light li {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.breadcrumbs--light li:last-of-type {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.cta-primary-large {
    padding-bottom: 12px;
    padding-top: 12px;
}

.cta-primary-large,.cta-primary-large > a,.cta-primary-large > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 24px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding-left: 32px;
    padding-right: 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-primary-large:hover,.cta-primary-large > a:hover,.cta-primary-large > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-large > a > span,.cta-primary-large > a i,.cta-primary-large > a svg,.cta-primary-large > button > span,.cta-primary-large > button i,.cta-primary-large > button svg,.cta-primary-large > span,.cta-primary-large i,.cta-primary-large svg {
    display: inline;
}

.cta-primary-large > a svg,.cta-primary-large > button svg,.cta-primary-large svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-primary-large:disabled,.cta-primary-large > a:disabled,.cta-primary-large > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-primary-large:disabled:hover:disabled,.cta-primary-large > a:disabled:hover:disabled,.cta-primary-large > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.cta-primary-large.inverted,.cta-primary-large > a.inverted,.cta-primary-large > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .cta-primary-large.inverted:hover,.cta-primary-large > a.inverted:hover,.cta-primary-large > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.cta-primary-large.inverted:active,.cta-primary-large > a.inverted:active,.cta-primary-large > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.cta-primary-large.inverted:disabled,.cta-primary-large > a.inverted:disabled,.cta-primary-large > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .cta-primary-large.inverted:disabled:hover,.cta-primary-large > a.inverted:disabled:hover,.cta-primary-large > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.cta-primary-large.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-medium,.cta-primary-medium > a,.cta-primary-medium > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 16px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-primary-medium:hover,.cta-primary-medium > a:hover,.cta-primary-medium > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-medium > a > span,.cta-primary-medium > a i,.cta-primary-medium > a svg,.cta-primary-medium > button > span,.cta-primary-medium > button i,.cta-primary-medium > button svg,.cta-primary-medium > span,.cta-primary-medium i,.cta-primary-medium svg {
    display: inline;
}

.cta-primary-medium > a svg,.cta-primary-medium > button svg,.cta-primary-medium svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-primary-medium:disabled,.cta-primary-medium > a:disabled,.cta-primary-medium > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-primary-medium:disabled:hover:disabled,.cta-primary-medium > a:disabled:hover:disabled,.cta-primary-medium > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.cta-primary-medium.inverted,.cta-primary-medium > a.inverted,.cta-primary-medium > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .cta-primary-medium.inverted:hover,.cta-primary-medium > a.inverted:hover,.cta-primary-medium > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.cta-primary-medium.inverted:active,.cta-primary-medium > a.inverted:active,.cta-primary-medium > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.cta-primary-medium.inverted:disabled,.cta-primary-medium > a.inverted:disabled,.cta-primary-medium > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .cta-primary-medium.inverted:disabled:hover,.cta-primary-medium > a.inverted:disabled:hover,.cta-primary-medium > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.cta-primary-medium.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-small,.cta-primary-small > a,.cta-primary-small > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 14px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    padding: 10px 24px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-primary-small:hover,.cta-primary-small > a:hover,.cta-primary-small > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-small > a > span,.cta-primary-small > a i,.cta-primary-small > a svg,.cta-primary-small > button > span,.cta-primary-small > button i,.cta-primary-small > button svg,.cta-primary-small > span,.cta-primary-small i,.cta-primary-small svg {
    display: inline;
}

.cta-primary-small > a svg,.cta-primary-small > button svg,.cta-primary-small svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-primary-small:disabled,.cta-primary-small > a:disabled,.cta-primary-small > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-primary-small:disabled:hover:disabled,.cta-primary-small > a:disabled:hover:disabled,.cta-primary-small > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.cta-primary-small.inverted,.cta-primary-small > a.inverted,.cta-primary-small > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .cta-primary-small.inverted:hover,.cta-primary-small > a.inverted:hover,.cta-primary-small > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.cta-primary-small.inverted:active,.cta-primary-small > a.inverted:active,.cta-primary-small > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.cta-primary-small.inverted:disabled,.cta-primary-small > a.inverted:disabled,.cta-primary-small > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .cta-primary-small.inverted:disabled:hover,.cta-primary-small > a.inverted:disabled:hover,.cta-primary-small > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.cta-primary-small.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-icon-large,.cta-primary-icon-large > a,.cta-primary-icon-large > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 24px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding: 12px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-primary-icon-large:hover,.cta-primary-icon-large > a:hover,.cta-primary-icon-large > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-icon-large > a > span,.cta-primary-icon-large > a i,.cta-primary-icon-large > a svg,.cta-primary-icon-large > button > span,.cta-primary-icon-large > button i,.cta-primary-icon-large > button svg,.cta-primary-icon-large > span,.cta-primary-icon-large i,.cta-primary-icon-large svg {
    display: inline;
}

.cta-primary-icon-large > a svg,.cta-primary-icon-large > button svg,.cta-primary-icon-large svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-primary-icon-large:disabled,.cta-primary-icon-large > a:disabled,.cta-primary-icon-large > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-primary-icon-large:disabled:hover:disabled,.cta-primary-icon-large > a:disabled:hover:disabled,.cta-primary-icon-large > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.cta-primary-icon-large.inverted,.cta-primary-icon-large > a.inverted,.cta-primary-icon-large > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .cta-primary-icon-large.inverted:hover,.cta-primary-icon-large > a.inverted:hover,.cta-primary-icon-large > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.cta-primary-icon-large.inverted:active,.cta-primary-icon-large > a.inverted:active,.cta-primary-icon-large > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.cta-primary-icon-large.inverted:disabled,.cta-primary-icon-large > a.inverted:disabled,.cta-primary-icon-large > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .cta-primary-icon-large.inverted:disabled:hover,.cta-primary-icon-large > a.inverted:disabled:hover,.cta-primary-icon-large > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.cta-primary-icon-large:after,.cta-primary-icon-large > a:after,.cta-primary-icon-large > button:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 12px;
    position: relative;
}

.cta-primary-icon-large.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-icon-medium,.cta-primary-icon-medium > a,.cta-primary-icon-medium > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 16px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-primary-icon-medium:hover,.cta-primary-icon-medium > a:hover,.cta-primary-icon-medium > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-icon-medium > a > span,.cta-primary-icon-medium > a i,.cta-primary-icon-medium > a svg,.cta-primary-icon-medium > button > span,.cta-primary-icon-medium > button i,.cta-primary-icon-medium > button svg,.cta-primary-icon-medium > span,.cta-primary-icon-medium i,.cta-primary-icon-medium svg {
    display: inline;
}

.cta-primary-icon-medium > a svg,.cta-primary-icon-medium > button svg,.cta-primary-icon-medium svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-primary-icon-medium:disabled,.cta-primary-icon-medium > a:disabled,.cta-primary-icon-medium > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-primary-icon-medium:disabled:hover:disabled,.cta-primary-icon-medium > a:disabled:hover:disabled,.cta-primary-icon-medium > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.cta-primary-icon-medium.inverted,.cta-primary-icon-medium > a.inverted,.cta-primary-icon-medium > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .cta-primary-icon-medium.inverted:hover,.cta-primary-icon-medium > a.inverted:hover,.cta-primary-icon-medium > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.cta-primary-icon-medium.inverted:active,.cta-primary-icon-medium > a.inverted:active,.cta-primary-icon-medium > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.cta-primary-icon-medium.inverted:disabled,.cta-primary-icon-medium > a.inverted:disabled,.cta-primary-icon-medium > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .cta-primary-icon-medium.inverted:disabled:hover,.cta-primary-icon-medium > a.inverted:disabled:hover,.cta-primary-icon-medium > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.cta-primary-icon-medium:after,.cta-primary-icon-medium > a:after,.cta-primary-icon-medium > button:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 8px;
    position: relative;
}

.cta-primary-icon-medium.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-icon-small,.cta-primary-icon-small > a,.cta-primary-icon-small > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 14px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    padding: 10px 24px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-primary-icon-small:hover,.cta-primary-icon-small > a:hover,.cta-primary-icon-small > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-primary-icon-small > a > span,.cta-primary-icon-small > a i,.cta-primary-icon-small > a svg,.cta-primary-icon-small > button > span,.cta-primary-icon-small > button i,.cta-primary-icon-small > button svg,.cta-primary-icon-small > span,.cta-primary-icon-small i,.cta-primary-icon-small svg {
    display: inline;
}

.cta-primary-icon-small > a svg,.cta-primary-icon-small > button svg,.cta-primary-icon-small svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.cta-primary-icon-small:disabled,.cta-primary-icon-small > a:disabled,.cta-primary-icon-small > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-primary-icon-small:disabled:hover:disabled,.cta-primary-icon-small > a:disabled:hover:disabled,.cta-primary-icon-small > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.cta-primary-icon-small.inverted,.cta-primary-icon-small > a.inverted,.cta-primary-icon-small > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .cta-primary-icon-small.inverted:hover,.cta-primary-icon-small > a.inverted:hover,.cta-primary-icon-small > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.cta-primary-icon-small.inverted:active,.cta-primary-icon-small > a.inverted:active,.cta-primary-icon-small > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.cta-primary-icon-small.inverted:disabled,.cta-primary-icon-small > a.inverted:disabled,.cta-primary-icon-small > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .cta-primary-icon-small.inverted:disabled:hover,.cta-primary-icon-small > a.inverted:disabled:hover,.cta-primary-icon-small > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.cta-primary-icon-small:after,.cta-primary-icon-small > a:after,.cta-primary-icon-small > button:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 8px;
    position: relative;
}

.cta-primary-icon-small.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-underlined,.cta-primary-underlined > a,.cta-primary-underlined > button {
    --text-opacity: 1;
    color: #6639b7;
    color: rgba(102,57,183,var(--text-opacity));
    display: block;
    font-size: 24px;
    height: auto;
    position: relative;
    text-align: left;
    width: fit-content;
}

.cta-primary-underlined:before,.cta-primary-underlined > a:before,.cta-primary-underlined > button:before {
    content: "ïŒ‹";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    position: absolute;
    right: -50px;
}

.cta-primary-underlined.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-underlined:after {
    --bg-opacity: 1;
    background-color: #6639b7;
    background-color: rgba(102,57,183,var(--bg-opacity));
    content: "";
    display: block;
    height: 5px;
    opacity: 1;
    position: relative;
    width: 110%;
    width: calc(100% + 50px);
}

@media (hover: hover) {
    .cta-primary-underlined:hover:after {
        opacity:0;
        transition: opacity 0.2s ease-in-out;
    }
}

.cta-primary-underlined-blue,.cta-primary-underlined-blue > a,.cta-primary-underlined-blue > button {
    color: #6639b7;
    color: rgba(102,57,183,var(--text-opacity));
    display: block;
    font-size: 24px;
    height: auto;
    position: relative;
    text-align: left;
    width: fit-content;
}

.cta-primary-underlined-blue:before,.cta-primary-underlined-blue > a:before,.cta-primary-underlined-blue > button:before {
    content: "ïŒ‹";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    position: absolute;
    right: -50px;
}

.cta-primary-underlined-blue.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-underlined-blue:after {
    --bg-opacity: 1;
    background-color: #6639b7;
    background-color: rgba(102,57,183,var(--bg-opacity));
    content: "";
    display: block;
    height: 5px;
    opacity: 1;
    position: relative;
    width: 110%;
    width: calc(100% + 50px);
}

@media (hover: hover) {
    .cta-primary-underlined-blue:hover:after {
        opacity:0;
        transition: opacity 0.2s ease-in-out;
    }
}

.cta-primary-underlined-blue,.cta-primary-underlined-blue > a,.cta-primary-underlined-blue > button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
}

.cta-primary-underlined-blue:after,.cta-primary-underlined-blue > a:after,.cta-primary-underlined-blue > button:after {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
}

.cta-primary-underlined-navy,.cta-primary-underlined-navy > a,.cta-primary-underlined-navy > button {
    color: #6639b7;
    color: rgba(102,57,183,var(--text-opacity));
    display: block;
    font-size: 24px;
    height: auto;
    position: relative;
    text-align: left;
    width: fit-content;
}

.cta-primary-underlined-navy:before,.cta-primary-underlined-navy > a:before,.cta-primary-underlined-navy > button:before {
    content: "ïŒ‹";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    position: absolute;
    right: -50px;
}

.cta-primary-underlined-navy.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.cta-primary-underlined-navy:after {
    --bg-opacity: 1;
    background-color: #6639b7;
    background-color: rgba(102,57,183,var(--bg-opacity));
    content: "";
    display: block;
    height: 5px;
    opacity: 1;
    position: relative;
    width: 110%;
    width: calc(100% + 50px);
}

@media (hover: hover) {
    .cta-primary-underlined-navy:hover:after {
        opacity:0;
        transition: opacity 0.2s ease-in-out;
    }
}

.cta-primary-underlined-navy,.cta-primary-underlined-navy > a,.cta-primary-underlined-navy > button {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
}

.cta-primary-underlined-navy:after,.cta-primary-underlined-navy > a:after,.cta-primary-underlined-navy > button:after {
    --bg-opacity: 1;
    background-color: #003c69;
    background-color: rgba(0,60,105,var(--bg-opacity));
}

.cta-secondary-large {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: none;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: inline-block;
    font-size: 24px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding: 12px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-secondary-large:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-secondary-large > span,.cta-secondary-large i,.cta-secondary-large svg {
    display: inline;
}

.cta-secondary-large svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .cta-secondary-large:hover {
        --bg-opacity:1;
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
    }
}

.cta-secondary-large:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-secondary-large:disabled:hover {
        background-color:transparent;
    }
}

.cta-secondary-large:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 12px;
    position: relative;
}

.cta-secondary-medium {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: none;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: inline-block;
    
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 16px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-secondary-medium:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-secondary-medium > span,.cta-secondary-medium i,.cta-secondary-medium svg {
    display: inline;
}

.cta-secondary-medium svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .cta-secondary-medium:hover {
        --bg-opacity:1;
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
    }
}

.cta-secondary-medium:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-secondary-medium:disabled:hover {
        background-color:transparent;
    }
}

.cta-secondary-medium:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 8px;
    position: relative;
}

.cta-secondary-small {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: none;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: inline-block;
    
    font-size: 14px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    padding: 10px 24px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .cta-secondary-small:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.cta-secondary-small > span,.cta-secondary-small i,.cta-secondary-small svg {
    display: inline;
}

.cta-secondary-small svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .cta-secondary-small:hover {
        --bg-opacity:1;
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
    }
}

.cta-secondary-small:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .cta-secondary-small:disabled:hover {
        background-color:transparent;
    }
}

.cta-secondary-small:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 8px;
    position: relative;
}

.ghost-button {
    border: 2px solid #0094d9;
    border-radius: 8px;
    color: #0065c0 !important;
    display: inline-block;
    
    font-size: 14px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    min-width: 144px;
    padding: 10px 24px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .ghost-button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.ghost-button > span,.ghost-button i,.ghost-button svg {
    display: inline;
}

.ghost-button svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.ghost-button:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 8px;
    position: relative;
}

@media (hover: hover) {
    .ghost-button:hover {
        background-color:#0094d9;
        color: #fff !important;
    }
}

.blog-tag {
    border: 2px solid #0098db;
    border-radius: 8px;
    color: #005bbb !important;
    display: inline-block;
    
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 6px 16px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .blog-tag:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.blog-tag > span,.blog-tag i,.blog-tag svg {
    display: inline;
}

.blog-tag svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .blog-tag:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
    }
}

.blog-tag-link {
    border: 2px solid #0098db;
    border-radius: 8px;
    color: #005bbb !important;
    display: inline-block;
    
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 6px 16px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .blog-tag-link:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.blog-tag-link > span,.blog-tag-link i,.blog-tag-link svg {
    display: inline;
}

.blog-tag-link svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .blog-tag-link:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        color: #fff !important;
    }
}

.tag-button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
    
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 8px 16px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .tag-button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.tag-button > span,.tag-button i,.tag-button svg {
    display: inline;
}

.tag-button svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.tag-button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .tag-button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.tag-button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .tag-button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.tag-button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.tag-button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .tag-button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

@media (hover: hover) {
    .tag-button:hover {
        --bg-opacity:1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
    }
}

@media (min-width: 1366px) {
    .tag-button {
        height:auto;
        padding: 16px 32px;
    }
}

.favorite-button {
    border-color: #0977a9;
}

.link-large:not(.flex),.link-large > a,.link-large button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
    
    font-size: 18px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.link-large:not(.flex):before,.link-large > a:before,.link-large button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.link-large:not(.flex):after,.link-large > a:after,.link-large button:after {
    display: none;
}

@media (hover: hover) {
    .link-large:not(.flex):hover,.link-large > a:hover,.link-large button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-large:not(.flex):hover:before,.link-large > a:hover:before,.link-large button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-large:not(.flex).wrapper:after,.link-large > a.wrapper:after,.link-large button.wrapper:after {
    width: 0;
}

.link-large.inline {
    display: inline-block;
}

.link-standard:not(.flex),.link-standard > a,.link-standard button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 16px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.link-standard:not(.flex):before,.link-standard > a:before,.link-standard button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.link-standard:not(.flex):after,.link-standard > a:after,.link-standard button:after {
    display: none;
}

@media (hover: hover) {
    .link-standard:not(.flex):hover,.link-standard > a:hover,.link-standard button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-standard:not(.flex):hover:before,.link-standard > a:hover:before,.link-standard button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-standard:not(.flex).wrapper:after,.link-standard > a.wrapper:after,.link-standard button.wrapper:after {
    width: 0;
}

.link-standard.inline {
    display: inline-block;
}

.link-small:not(.flex),.link-small > a,.link-small button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 14px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.link-small:not(.flex):before,.link-small > a:before,.link-small button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.link-small:not(.flex):after,.link-small > a:after,.link-small button:after {
    display: none;
}

@media (hover: hover) {
    .link-small:not(.flex):hover,.link-small > a:hover,.link-small button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-small:not(.flex):hover:before,.link-small > a:hover:before,.link-small button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-small:not(.flex).wrapper:after,.link-small > a.wrapper:after,.link-small button.wrapper:after {
    width: 0;
}

.link-small.inline {
    display: inline-block;
}

.link-large-caret:not(.flex),.link-large-caret button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.link-large-caret:not(.flex):before,.link-large-caret button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.link-large-caret:not(.flex):after,.link-large-caret button:after {
    display: none;
}

@media (hover: hover) {
    .link-large-caret:not(.flex):hover,.link-large-caret button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-large-caret:not(.flex):hover:before,.link-large-caret button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-large-caret:not(.flex).wrapper:after,.link-large-caret button.wrapper:after {
    width: 0;
}

.link-large-caret:not(.flex):after,.link-large-caret button:after {
    content: "âŒª";
    display: inline-block;
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    padding-left: 4px;
    position: relative;
}

.link-large-caret.inline {
    display: inline-block;
}

.link-standard-caret:not(.flex),.link-standard-caret button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 16px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.link-standard-caret:not(.flex):before,.link-standard-caret button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.link-standard-caret:not(.flex):after,.link-standard-caret button:after {
    display: none;
}

@media (hover: hover) {
    .link-standard-caret:not(.flex):hover,.link-standard-caret button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-standard-caret:not(.flex):hover:before,.link-standard-caret button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-standard-caret:not(.flex).wrapper:after,.link-standard-caret button.wrapper:after {
    width: 0;
}

.link-standard-caret:not(.flex):after,.link-standard-caret button:after {
    content: "âŒª";
    display: inline-block;
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    padding-left: 4px;
    position: relative;
}

.link-standard-caret.inline {
    display: inline-block;
}

.link-small-caret:not(.flex),.link-small-caret button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 14px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.link-small-caret:not(.flex):before,.link-small-caret button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.link-small-caret:not(.flex):after,.link-small-caret button:after {
    display: none;
}

@media (hover: hover) {
    .link-small-caret:not(.flex):hover,.link-small-caret button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .link-small-caret:not(.flex):hover:before,.link-small-caret button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.link-small-caret:not(.flex).wrapper:after,.link-small-caret button.wrapper:after {
    width: 0;
}

.link-small-caret:not(.flex):after,.link-small-caret button:after {
    content: "âŒª";
    display: inline-block;
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    padding-left: 4px;
    position: relative;
}

.link-small-caret.inline {
    display: inline-block;
}

html {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
}

.section-container {
    margin: 0 auto;
    padding: 24px 12px;
    width: 100%;
}

@media (min-width: 768px) {
    .section-container {
        margin:0 auto;
        max-width: 90%;
        padding: 24px 12px;
    }
}

@media (min-width: 1366px) {
    .section-container {
        max-width:1328px;
        padding: 0px 0;
    }
}

.heading-one,h1,h1 > p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

    font-size: 40px;
    line-height: 44px;
}

@media (min-width: 1366px) {
    .heading-one,h1,h1 > p {
        font-size:56px;
        line-height: 60px;
    }
}

.heading-two,h2,h2 > p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

    font-size: 32px;
    line-height: 36px;
}

@media (min-width: 1366px) {
    .heading-two,h2,h2 > p {
        font-size:48px;
        line-height: 52px;
    }
}

.heading-three,h3,h3 > p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

    font-size: 24px;
    line-height: 28px;
}

@media (min-width: 1366px) {
    .heading-three,h3,h3 > p {
        font-size:40px;
        line-height: 44px;
    }
}

.heading-four,h4,h4 > p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
    font-size: 16px;
    line-height: 20px;
}

@media (min-width: 1366px) {
    .heading-four,h4,h4 > p {
        font-size:32px;
        line-height: 36px;
    }
}

.heading-five,h5,h5 > p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
    font-size: 16px;
    line-height: 20px;
}

@media (min-width: 1366px) {
    .heading-five,h5,h5 > p {
        font-size:24px;
        line-height: 28px;
    }
}

.heading-six,h6,h6 > p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
    font-size: 16px;
    line-height: 20px;
}

@media (min-width: 1366px) {
    .heading-six,h6,h6 > p {
        font-size:20px;
        line-height: 24px;
    }
}



.eyebrow {
    --text-opacity: 1;
    color: #0098db;
    color: rgba(0,152,219,var(--text-opacity));
    font-size: 14px;
    letter-spacing: 1.4px;
    line-height: 14px;
    text-transform: uppercase;
}

.checkedList {
    padding-left: 28px;
}

.checkedList li {
    align-items: baseline;
    font-size: 16px;
    line-height: 24px;
}

.checkedList li:before {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: normal;
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    content: "ï˜";
    display: inline-block;
    font-size: 20px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    left: -8px;
    line-height: 1;
    line-height: 21px;
    margin-left: 8px;
    margin-top: 2px;
    position: relative;
}

.search-primary.news-search-box-container input {
    --text-opacity: 1;
    box-shadow: none;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
   
    font-size: 16px;
    font-size: 20px;
    font-style: italic;
    line-height: 24px;
    line-height: 28px;
    padding-left: 52px;
}

.search-primary.news-search-box-container input::placeholder {
    opacity: 0.5;
}

.search-secondary .news-search-box-container {
    align-items: flex-end;
    border-bottom: 1px solid #75787b;
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 12px;
    margin-left: 12px;
    margin-right: 12px;
    padding-bottom: 0;
}

@media (min-width: 1366px) {
    .search-secondary .news-search-box-container {
        margin-left:0;
        margin-right: 0;
    }
}

.search-secondary .news-search-box-container input {
    --text-opacity: 1;
    border: none;
    border-radius: 0;
    box-shadow: none;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
   
    font-size: 16px;
    font-style: italic;
    height: auto;
    line-height: 24px;
    padding-bottom: 8px;
    padding-left: 32px;
}

.search-secondary .news-search-box-container input::placeholder {
    --text-opacity: 1;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
    opacity: 0.5;
}

.search-secondary .news-search-box-container button {
    align-self: center;
    display: flex;
    left: 20px;
    margin-left: 0;
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    position: relative;
    top: unset;
}

.search-secondary .news-search-box-container i svg {
    fill: #005bbb;
    height: 18px;
    width: 18px;
}

.news {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
}

@media (min-width: 1366px) {
    .news {
        grid-template-columns:repeat(12,minmax(0,1fr));
    }
}

.news .news-content {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-column: span 6 / span 6;
    grid-template-columns: repeat(6,minmax(0,1fr));
}

@media (min-width: 1366px) {
    .news .news-content {
        grid-column:span 12 / span 12;
        grid-template-columns: repeat(12,minmax(0,1fr));
    }
}

.news .news-content .gated-download {
    background: #f0f0f0 0 0 no-repeat padding-box;
    border-radius: 8px;
    padding: 25px;
    text-align: center;
}

.news .news-content .gated-download .download-circle-icon {
    float: right;
    padding-top: 5px;
}

.news .news-content .gated-download img {
    margin-left: 10px;
    margin-right: 10px;
}

.news .news-content .gated-download h5 {
    color: #005bbb;
    font: normal normal normal 24px/32px Helvetica Now Display Bold;
    letter-spacing: 0;
    margin: auto;
    padding-bottom: 15px;
    width: 100%;
}

.news .news-content .gated-download p {
    background: #fff 0 0 no-repeat padding-box;
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);
    line-height: 55px;
    margin: auto;
    padding: 20px 0;
    width: 100%;
}

.news .news-content .gated-download p a {
    font: normal normal 700 24px/26px Helvetica Now Display bold;
    letter-spacing: 0;
    line-height: 50px;
}

.news .news-content-main {
    grid-column: span 6 / span 6;
}

.news .news-content-main .news-under-hero-above-content {
    display: none;
}

@media (max-width: 767px) {
    .news .news-content-main .news-under-hero-above-content {
        display:unset;
    }
}

@media (min-width: 1366px) {
    .news .news-content-main {
        grid-column:span 8 / span 8;
    }
}

.news .news-content-side {
    grid-column: span 6 / span 6;
}

@media (min-width: 1366px) {
    .news .news-content-side {
        grid-column:span 4 / span 4;
    }
}

@media (max-width: 767px) {
    .news .news-content-side .gated-download {
        display:none;
    }
}

.news .news-content-side > div:first-child {
    padding: 0 12px 12px;
}

@media (min-width: 768px) {
    .news .news-content-side > div:first-child {
        padding:0 24px 12px;
    }
}

.news .news-content-bottom {
    grid-column: span 6 / span 6;
}

@media (min-width: 1366px) {
    .news .news-content-bottom {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 375px) {
    .news .news-content h2 {
        font-size:32px;
        line-height: 36px;
        margin-bottom: 16px;
    }
}

@media (min-width: 768px) {
    .news .news-content h2 {
        font-size:40px;
        line-height: 48px;
        margin-bottom: 16px;
    }
}

@media (min-width: 1366px) {
    .news .news-content h2 {
        font-size:48px;
        line-height: 52px;
        margin-bottom: 16px;
    }
}

.news .breadcrumbs {
    grid-column: span 6 / span 6;
    margin-left: 0;
    padding-left: 8px;
}

@media (min-width: 768px) {
    .news .breadcrumbs {
        padding-left:24px;
    }
}

@media (min-width: 1366px) {
    .news {
        max-width:1366px;
    }

    .news .breadcrumbs {
        grid-column: span 12 / span 12;
        padding-right: 24px;
    }
}

.news-hero {
    align-items: center;
    display: flex;
    height: 265px;
    position: relative;
    width: 100%;
}

.news-hero-image {
    height: 100%;
    width: 100%;
}

.news-hero-image img {
    height: 265px;
    object-fit: cover;
    width: 100%;
}

@media (min-width: 1366px) {
    .news-hero-image img {
        border-radius:8px;
        height: 380px;
    }
}

.news-heading-title {
    font-size: 32px;
    line-height: 36px;
    margin-bottom: 12px;
}

@media (min-width: 1366px) {
    .news-heading-title {
        font-size:48px;
        line-height: 52px;
        margin-bottom: 16px;
    }
}

.news-heading-date {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 12px;
}

@media (min-width: 1366px) {
    .news-heading-date {
        font-size:18px;
        line-height: 20px;
        margin-bottom: 16px;
    }
}

.news-heading-subtitle {
    --text-opacity: 1;
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
   
    font-size: 22px;
}

@media (min-width: 1366px) {
    .news-heading-subtitle {
        font-size:16px;
        line-height: 20px;
    }
}

.news-container {
    padding-left: 12px;
    padding-right: 12px;
}

@media (min-width: 768px) {
    .news-container {
        padding-left:24px;
        padding-right: 24px;
    }
}

@media (min-width: 1366px) {
    .news-container {
        padding-left:0;
        padding-right: 0;
    }
}

.news-content {
    display: flex;
    flex-direction: column;
   
    font-size: 16px;
}

@media (min-width: 1366px) {
    .news-content {
        flex-direction: row;
        font-size: 16px;
    }

    .news-content-main {
        margin-left: 0;
        min-width: 800px;
        padding-left: 24px;
        padding-right: 24px;
    }
}

.news-content-main .subheading {
    font-size: 36px;
    line-height: 36px;
}

.news-content-main-set {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    line-height: 26px;
    margin-bottom: 32px;
}

.news-content-main-set h2 {
    font-size: 32px;
    line-height: 36px;
    margin-bottom: 24px;
}

.news-content-main-set p {
   
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 24px;
    text-align: left;
}

@media (min-width: 1366px) {
    .news-content-main-set p {
        font-size:16px;
    }
}

.news-content-main-set-image {
    height: 100%;
    width: 100%;
}

.news-content-main-set-image img {
    border-radius: 8px;
    height: 100%;
    width: 100%;
}

.news-content-main-set figure.image {
    width: fit-content;
}

.news-content-main-set figcaption {
    font-size: 12px;
    margin-bottom: 12px;
    margin-top: 12px;
    text-align: center;
}

@media (min-width: 1366px) {
    .news-content-main-set figcaption {
        font-size:14px;
    }

    .news-content-side {
        margin-left: 0;
        margin-right: 0;
    }
}

.news-content-side .section-container {
    padding: 12px;
}

@media (min-width: 768px) {
    .news-content-side .section-container {
        padding:24px;
    }
}

.news-content-side > div:first-child {
    padding-bottom: 12px;
}

@media (min-width: 768px) {
    .news-content-side > div:first-child {
        padding-bottom:12px;
    }
}

.news-landing .breadcrumbs {
    margin-left: 0;
    padding-left: 8px;
}

.news-landing h1 {
    padding-bottom: 8px;
    padding-left: 24px;
}

.news-landing .breadcrumbs {
    margin-bottom: 0;
    padding-bottom: 0;
    padding-top: 22px;
}

@media (min-width: 1366px) {
    .news-landing {
        max-width:1366px;
    }

    .news-landing .breadcrumbs {
        padding-left: 24px;
        padding-right: 24px;
    }
}

.news-landing-featured {
    padding: 0;
}

@media (min-width: 1366px) {
    .news-landing-featured {
        padding-left:24px;
        padding-right: 24px;
    }
}

.news-landing-hero {
    align-items: center;
    display: flex;
    position: relative;
    width: 100%;
}

.news-landing-hero-image {
    height: 100%;
    width: 100%;
}

.news-landing-hero-image img {
    height: 220px;
    object-fit: cover;
    width: 100%;
}

@media (min-width: 1366px) {
    .news-landing-hero-image img {
        border-radius:8px;
        height: 470px;
    }
}

.news-landing-meta-category {
    font-size: 14px;
    text-transform: uppercase;
}

@media (min-width: 1366px) {
    .news-landing-meta-category {
        font-size:20px;
    }
}

.news-landing-meta-seperator {
    --text-opacity: 1;
    border-right: 1px solid #979797;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    margin-left: 12px;
}

.news-landing-meta-date {
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    text-transform: uppercase;
}

@media (min-width: 1366px) {
    .news-landing-meta-date {
        font-size:20px;
        margin-left: 8px;
    }
}

.news-landing-heading {
    margin-left: 12px;
    margin-right: 12px;
}

@media (min-width: 1366px) {
    .news-landing-heading {
        margin-left:0;
        margin-right: 0;
    }
}

.news-landing-heading-title {
    font-size: 32px;
    line-height: 36px;
    margin-bottom: 12px;
}

@media (min-width: 1366px) {
    .news-landing-heading-title {
        font-size:48px;
        line-height: 52px;
        margin-bottom: 16px;
    }
}

@media (min-width: 768px) {
    .news-landing-heading-title {
        font-size:40px;
        line-height: 48px;
        margin-bottom: 16px;
    }
}

@media (min-width: 375px) {
    .news-landing-heading-title {
        font-size:32px;
        line-height: 36px;
        margin-bottom: 16px;
    }
}

.news-landing-heading-date {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 12px;
}

@media (min-width: 1366px) {
    .news-landing-heading-date {
        font-size:18px;
        line-height: 20px;
        margin-bottom: 16px;
    }
}

.news-landing-heading-summary {
   
    font-size: 16px;
    text-align: left;
}

@media (min-width: 1366px) {
    .news-landing-heading-summary {
        line-height:26px;
    }
}

.news-landing-heading-summary p {
    line-height: 26px;
    text-align: left;
}

.news-landing-content {
    display: flex;
    flex-direction: column;
   
    font-size: 16px;
}

@media (min-width: 1366px) {
    .news-landing-content {
        flex-direction: row;
        font-size: 15px;
    }
}

.news-landing-content-main {
    margin-bottom: 32px;
}

@media (min-width: 1366px) {
    .news-landing-content-main {
        min-width:700px;
    }

    .news-landing-content-side {
        margin-left: 0;
        margin-right: 0;
        min-width: 455px;
    }
}

.news-landing-content-side .section-container {
    padding: 12px;
}

@media (min-width: 768px) {
    .news-landing-content-side .section-container {
        padding:24px;
    }
}

.news-landing-content-side > div:first-child {
    padding: 0 12px 12px;
}

@media (min-width: 768px) {
    .news-landing-content-side > div:first-child {
        padding:0 24px 12px;
    }
}

.news-landing-bottom {
    padding-left: 24px;
    padding-right: 24px;
}

@media (min-width: 1366px) {
    .news-landing-bottom {
        margin-left:0;
        margin-right: 0;
    }
}

.section-homepage {
    align-items: center;
}

.section-homepage,.section-homepage-hero {
    display: flex;
    flex-direction: column;
    position: relative;
}

.section-homepage-hero {
    width: 100%;
}

.section-homepage-hero-image,.section-homepage-hero-image-mobile {
    height: 200px;
    width: 100%;
}

@media (min-width: 768px) {
    .section-homepage-hero-image,.section-homepage-hero-image-mobile {
        height:284px;
    }
}

@media (min-width: 1366px) {
    .section-homepage-hero-image,.section-homepage-hero-image-mobile {
        height:360px;
    }
}

.section-homepage-hero-image-mobile img,.section-homepage-hero-image img {
    height: 100%;
    object-fit: cover;
    width: 100%;
    z-index: -1;
}

.section-homepage-hero-image-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    left: 50%;
    max-height: 100%;
    transform: translateX(-50%);
    z-index: 0;
}

@media (min-width: 768px) {
    .section-homepage-hero-image-content {
        padding-bottom:32px;
        padding-top: 32px;
    }
}

@media (min-width: 1366px) {
    .section-homepage-hero-image-content {
        padding-bottom:48px;
        padding-top: 48px;
    }
}

.section-homepage-hero-image-content.hero-left {
    align-items: flex-start;
    text-align: left;
}

.section-homepage-hero-image-content.hero-right {
    align-items: flex-end;
    text-align: left;
}

@media (min-width: 1366px) {
    .section-homepage-hero-image-content {
        min-height:250px;
    }
}

.section-homepage-hero-image-content-heading > span {
    display: block;
    text-shadow: 0 3px 40px rgba(0,0,0,0.23137);
}

.section-homepage-hero-image-content-heading.hero-left {
    align-items: flex-start;
    text-align: left;
}

.section-homepage-hero-image-content-heading.hero-right {
    align-items: flex-end;
    text-align: right;
}

.section-homepage-hero-image-content-heading .top {
    font-size: 32px;
    line-height: 36px;
    line-height: 32px;
    padding-top: 8px;
}

@media (min-width: 768px) {
    .section-homepage-hero-image-content-heading .top {
        font-size:40px;
        line-height: 48px;
        line-height: 53px;
    }
}

@media (min-width: 1366px) {
    .section-homepage-hero-image-content-heading .top {
        font-size:40px;
        line-height: 48px;
    }
}

.section-homepage-hero-image-content-heading .bottom {
    font-size: 56px;
    line-height: 56px;
}

@media (min-width: 768px) {
    .section-homepage-hero-image-content-heading .bottom {
        font-size:76px;
        line-height: 68px;
        line-height: 99px;
    }
}

@media (min-width: 1366px) {
    .section-homepage-hero-image-content-heading .bottom {
        font-size:136px;
        line-height: 167px;
    }
}

.section-homepage .breadcrumbs {
   
    font-size: 14px;
    left: 0;
    line-height: 32px;
    padding-bottom: 0;
    padding-top: 0;
    position: absolute;
    right: 0;
    width: 100%;
    z-index: 1;
}

.section-homepage .breadcrumbs li:before {
    border-color: #fff;
}

.section-homepage .breadcrumbs a {
    color: #fff !important;
}

.section-homepage .breadcrumbs a:before {
    position: relative;
    top: 2px;
}

.section-homepage-content {
    margin-top: -24px;
    text-align: center;
    width: calc(100% - 24px);
    z-index: 1;
}

.section-homepage-content .solo .cta-primary-large,.section-homepage-content .solo h2,.section-homepage-content .solo p {
    margin-left: 0;
}

@media (min-width: 1366px) {
    .section-homepage-content .solo {
        height:200px;
        margin-top: -240px;
        max-width: 1400px;
        white-space: nowrap;
    }
}

.section-homepage-content-intro {
    -webkit-box-align: center;
    -ms-flex-align: center;
    --bg-opacity: 1;
    align-items: center;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.10196);
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
    overflow: hidden;
    padding: 24px 16px;
    width: 100%;
}

@media (min-width: 768px) {
    .section-homepage-content-intro {
        padding:32px 24px;
    }
}

@media (max-width: 1199px) {
    .section-homepage-content-intro .tablet\\:grid {
        display:block;
    }

    .section-homepage-content-intro .promo-callout-media {
        padding: 0;
    }

    .section-homepage-content-intro .promo-callout-media-wrapper.media-full img {
        width: 100%;
    }

    .section-homepage-content-intro .promo-callout-content p {
        max-width: none;
    }
}

@media (min-width: 1366px) {
    .section-homepage-content-intro {
        padding:48px 56px;
    }
}

.section-homepage-content-intro .rich-text p:last-of-type {
    margin-bottom: 0;
}

.section-homepage-content-intro .section-container {
    padding: 0;
}

.section-homepage-content-intro .callout {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0;
    max-width: 960px;
}

.section-homepage-content-intro .callout img {
    display: none;
}

.section-homepage-content-intro .callout h3 {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
}

@media (min-width: 1366px) {
    .section-homepage-content-intro .callout h3 {
        font-size:48px;
        line-height: 58px;
    }
}

.section-homepage-content-intro .callout-cta {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    margin-top: 20px;
    width: fit-content;
}

.section-homepage-content-intro .callout-cta:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .section-homepage-content-intro .callout-cta:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.section-homepage-content-intro .callout-cta.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .section-homepage-content-intro .callout-cta.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.section-homepage-content-intro .callout-cta.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.section-homepage-content-intro .callout-cta.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .section-homepage-content-intro .callout-cta.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.section-homepage-content-intro .callout-cta,.section-homepage-content-intro .callout-cta > a,.section-homepage-content-intro .callout-cta > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    height: 44px;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 44px;
    padding-left: 32px;
    padding-right: 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .section-homepage-content-intro .callout-cta:hover,.section-homepage-content-intro .callout-cta > a:hover,.section-homepage-content-intro .callout-cta > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.section-homepage-content-intro .callout-cta > a > span,.section-homepage-content-intro .callout-cta > a i,.section-homepage-content-intro .callout-cta > a svg,.section-homepage-content-intro .callout-cta > button > span,.section-homepage-content-intro .callout-cta > button i,.section-homepage-content-intro .callout-cta > button svg,.section-homepage-content-intro .callout-cta > span,.section-homepage-content-intro .callout-cta i,.section-homepage-content-intro .callout-cta svg {
    display: inline;
}

.section-homepage-content-intro .callout-cta > a svg,.section-homepage-content-intro .callout-cta > button svg,.section-homepage-content-intro .callout-cta svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.section-homepage-content-intro .callout-cta:disabled,.section-homepage-content-intro .callout-cta > a:disabled,.section-homepage-content-intro .callout-cta > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .section-homepage-content-intro .callout-cta:disabled:hover:disabled,.section-homepage-content-intro .callout-cta > a:disabled:hover:disabled,.section-homepage-content-intro .callout-cta > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.section-homepage-content-intro .callout-cta.inverted,.section-homepage-content-intro .callout-cta > a.inverted,.section-homepage-content-intro .callout-cta > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .section-homepage-content-intro .callout-cta.inverted:hover,.section-homepage-content-intro .callout-cta > a.inverted:hover,.section-homepage-content-intro .callout-cta > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.section-homepage-content-intro .callout-cta.inverted:active,.section-homepage-content-intro .callout-cta > a.inverted:active,.section-homepage-content-intro .callout-cta > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.section-homepage-content-intro .callout-cta.inverted:disabled,.section-homepage-content-intro .callout-cta > a.inverted:disabled,.section-homepage-content-intro .callout-cta > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .section-homepage-content-intro .callout-cta.inverted:disabled:hover,.section-homepage-content-intro .callout-cta > a.inverted:disabled:hover,.section-homepage-content-intro .callout-cta > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.section-homepage-content-intro .callout-cta:after,.section-homepage-content-intro .callout-cta > a:after,.section-homepage-content-intro .callout-cta > button:after {
    display: none;
}

.section-homepage-content-intro .callout-cta.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.section-homepage-content-intro .promo-callout {
    background-color: #fff;
}

.section-homepage-content-intro .promo-callout-media-wrapper {
    padding: 0;
}

.section-homepage-content-intro .promo-callout-media-wrapper img {
    margin-left: auto;
    margin-right: auto;
    width: auto;
}

.section-homepage-content-intro .promo-callout-content {
    padding: 30px 15px;
}

@media (min-width: 1366px) {
    .section-homepage-content-intro .promo-callout-content {
        padding-right:12px;
    }
}

.section-homepage-content-intro .promo-callout-content .heading-two,.section-homepage-content-intro .promo-callout-content h2 {
    margin-bottom: 8px;
}

.section-homepage-content-intro .promo-callout-content .heading-two p,.section-homepage-content-intro .promo-callout-content h2 p {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    text-align: center;
}

.section-homepage-content-intro .enhanced-form-color {
    padding-bottom: 0;
    padding-top: 0;
}

.section-homepage-content-intro .enhanced-form-color .enhanced-form {
    box-shadow: none !important;
}

@media (min-width: 1366px) {
    .section-homepage-content-intro .enhanced-form-color .enhanced-form {
        width:1318px;
    }

    .section-homepage-content-intro .enhanced-form-color .enhanced-form .enhanced-form {
        width: unset;
    }
}

@media (min-width: 768px) {
    .section-homepage-content {
        margin-top:-48px;
        max-width: 1318px;
        width: calc(100% - 48px);
    }
}

.scPage {
    grid-row-gap: 0;
    display: grid;
    grid-template-columns: repeat(6,minmax(0,1fr));
    row-gap: 0;
}

@media (min-width: 768px) {
    .scPage {
        grid-template-columns:repeat(12,minmax(0,1fr));
    }
}

.scPage .breadcrumbs {
    grid-column: span 6 / span 6;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    padding-right: 0;
    width: 368px;
}

@media (min-width: 768px) {
    .scPage .breadcrumbs {
        grid-column:span 12 / span 12;
        margin-left: auto;
        margin-right: auto;
        width: 656px;
    }
}

@media (min-width: 1366px) {
    .scPage .breadcrumbs {
        margin-left:auto;
        margin-right: auto;
        width: 1366px;
    }
}

.scPage .breadcrumbs.section-container {
    padding-left: 0;
    padding-right: 0;
}

.scPage-hero {
    align-items: center;
    display: flex;
    grid-column: span 6 / span 6;
    height: 220px;
    position: relative;
    width: 100%;
}

@media (min-width: 768px) {
    .scPage-hero {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .scPage-hero {
        height:380px;
    }
}

.scPage-hero.section-container {
    margin-bottom: 16px;
    margin-top: 0;
    padding: 0;
}

.scPage-hero-image {
    height: 100%;
    width: 100%;
}

.scPage-hero-image img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

@media (min-width: 1366px) {
    .scPage-hero-image img {
        border-radius:8px;
    }
}

.scPage-hero-heading,.scPage-hero h1 {
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    max-width: 547px;
    position: absolute;
}

@media (min-width: 1366px) {
    .scPage-hero-heading,.scPage-hero h1 {
        margin-left:28px;
        margin-right: 28px;
    }
}

.scPage-hero .right {
    right: 0;
}

.scPage-content {
    display: grid;
    grid-column: span 6 / span 6;
    grid-template-columns: 1fr;
    padding: 16px 12px;
}

@media (min-width: 768px) {
    .scPage-content {
        grid-column:span 12 / span 12;
        grid-template-columns: 1fr;
        padding-left: 24px;
        padding-right: 24px;
    }
}

@media (min-width: 1366px) {
    .scPage-content {
        grid-template-columns:1fr fit-content(200px);
    }
}

.scPage-content.section-container {
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-top: 0;
}

.scPage-content-main .subheading {
    font-size: 36px;
    line-height: 36px;
}

.scPage-content-main-set {
    margin-bottom: 32px;
}

.scPage-content-main-set h2 {
    font-size: 44px;
    line-height: 48px;
    margin-bottom: 24px;
}

.scPage-content-main-set p {
    margin-bottom: 20px;
    text-align: left;
}

.scPage-content-main-set-image {
    height: 100%;
    width: 100%;
}

.scPage-content-main-set-image img {
    border-radius: 8px;
    height: 100%;
    width: 100%;
}

.scPage-content-main-quote {
    border-bottom: 1px solid gray;
    border-top: 1px solid gray;
    height: 700px;
    width: 100%;
}

.scPage-content-side {
    width: 100%;
}

@media (min-width: 768px) {
    .scPage-content-side {
        min-width:416px;
    }
}

@media (min-width: 1366px) {
    .scPage-content-side {
        margin-left:32px;
        max-width: 420px;
    }
}

.scPage-content-side .placeholderBox {
    border: 1px solid gray;
    height: 350px;
}

@media (min-width: 1366px) {
    .scPage-content-side .placeholderBox {
        width:380px;
    }
}

.scPage-bottom {
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .scPage-bottom {
        grid-column:span 12 / span 12;
    }
}

.start-page section:nth-child(2) > div {
    padding-top: 74px;
}

@media (min-width: 768px) {
    .start-page section:nth-child(2) > div {
        padding-top:94px;
    }
}

@media (min-width: 1366px) {
    .start-page section:nth-child(2) > div {
        padding-top:94px;
    }
}

.faq {
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
}

.faq-wrapper {
    --bg-opacity: 1;
    background-color: #fff5de;
    background-color: rgba(255,245,222,var(--bg-opacity));
}

.faq .breadcrumbs {
    left: 0;
    padding-bottom: 0;
    padding-top: 0;
    position: absolute;
    right: 0;
    width: 100%;
}

.faq .breadcrumbs li:before {
    border-color: #fff;
}

.faq .breadcrumbs a {
    color: #fff !important;
}

.faq .breadcrumbs a:before {
    position: relative;
    top: 2px;
}

.faq-hero {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
}

.faq-hero-image,.faq-hero-image-mobile {
    height: 220px;
    width: 100%;
}

@media (min-width: 1366px) {
    .faq-hero-image,.faq-hero-image-mobile {
        min-height:350px;
    }
}

.faq-hero-image-mobile img,.faq-hero-image img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.faq-hero .hero-cta {
    height: 400px;
}

.faq-intro {
    max-width: 368px;
    text-align: center;
    width: 100%;
    z-index: 1;
}

@media (min-width: 768px) {
    .faq-intro {
        max-width:656px;
    }
}

@media (min-width: 1366px) {
    .faq-intro {
        max-width:1328px;
        text-align: left;
    }
}

.faq-intro-hero {
    height: 120px;
    margin-left: auto;
    margin-right: auto;
    margin-top: -160px;
    padding-left: 12px;
    padding-right: 12px;
    z-index: 2;
}

@media (min-width: 768px) {
    .faq-intro-hero {
        padding-left:24px;
        padding-right: 24px;
    }
}

@media (min-width: 1366px) {
    .faq-intro-hero {
        height:250px;
        margin-left: auto;
        margin-right: auto;
        margin-top: -290px;
        max-width: 1366px;
    }
}

.faq-intro-hero-heading,.faq-intro-hero h1 {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    font-size: 29px;
    margin-bottom: 8px;
    margin-left: 20px;
    margin-right: 40px;
    text-align: left;
}

@media (min-width: 1366px) {
    .faq-intro-hero-heading,.faq-intro-hero h1 {
        font-size:58px;
        margin-left: 90px;
        text-align: left;
    }
}

.faq-intro-hero-style p {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 72px;
    line-height: 48px;
    margin-left: -20px;
    text-align: left;
    text-shadow: 0 3px 40px rgba(0,0,0,0.23137);
}

@media (min-width: 1366px) {
    .faq-intro-hero-style p {
        font-size:138px;
        line-height: 80px;
        margin-left: -90px;
    }
}

.faq-intro-content {
    --bg-opacity: 1;
    align-items: center;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.10196);
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    width: calc(100% - 24px);
}

@media (min-width: 1366px) {
    .faq-intro-content {
        padding:32px 140px;
    }
}

.faq-intro-content-text {
    max-width: 800px;
}

.faq-intro-content-text .heading-two,.faq-intro-content-text h2 {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));

    margin-bottom: 8px;
    text-align: center;
}

.faq-intro-content-text .heading-two p,.faq-intro-content-text h2 p {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    font-size: 58px;
    line-height: 63px;
    text-align: center;
}

@media (min-width: 1366px) {
    .faq-intro-content-text .heading-two,.faq-intro-content-text h2 {
        margin-bottom:40px;
        text-align: center;
    }
}

.faq-intro-content-text .lower-text {
    margin-bottom: 32px;
}

@media (min-width: 1366px) {
    .faq-intro-content-text .lower-text {
        margin-bottom:48px;
        text-align: center;
    }
}

.faq-intro-content-icons {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
}

@media (min-width: 1366px) {
    .faq-intro-content-icons {
        justify-content: space-between;
        max-width: 800px;
    }
}

.faq-intro-content-icons a {
    width: 50%;
}

@media (min-width: 1366px) {
    .faq-intro-content-icons a {
        width:auto;
    }
}

.faq-intro-content-icons-set {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    margin-left: auto;
    margin-right: auto;
    width: 125px;
}

@media (min-width: 1366px) {
    .faq-intro-content-icons-set {
        width:150px;
    }
}

.faq-intro-content-icons-set-image {
    height: 75px;
    margin-bottom: 8px;
    width: 75px;
}

@media (min-width: 1366px) {
    .faq-intro-content-icons-set-image {
        margin-bottom:20px;
    }
}

.faq-intro-content-icons-set-image img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.faq-intro-content-icons-set p {
    text-align: center;
}

.faq-content {
    --bg-opacity: 1;
    background-color: #fbf7ed;
    background-color: rgba(251,247,237,var(--bg-opacity));
    padding-bottom: 24px;
    width: 100%;
}

@media (min-width: 1366px) {
    .faq-content {
        padding-bottom:32px;
    }
}

.faq-content .faq-content {
    padding: 0;
}

.faq-content-entry[open] .faq-content-entry-summary {
    padding-bottom: 24px;
}

@media (min-width: 1366px) {
    .faq-content-entry[open] .faq-content-entry-summary {
        padding-bottom:32px;
    }
}

.faq-content-entry[open] .faq-content-entry-title-wrapper-icon:before {
    content: "âˆ’";
}

.faq-content-entry .faq-content-entry-title-wrapper-icon:before {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    content: "+";
   
    font-size: 36px;
    line-height: 30px;
    transition: all 0.3s ease-out;
}

.faq-content-entry {
    cursor: pointer;
    scroll-margin-top: 200px;
}

.faq-content-entry .focus-visible {
    border: 2px solid;
    border-radius: 7px;
}

.faq-content-entry :focus-visible {
    border: 2px solid;
    border-radius: 7px;
}

.faq-content-entry summary::marker {
    display: none;
}

.faq-content-entry summary::-webkit-details-marker {
    display: none;
}

.faq-content-entry summary {
    display: inline;
    outline: none;
    width: 100%;
}

.faq-content-entry-subentry:after {
    border-bottom: 1px solid #b8babc;
    content: "";
    display: block;
    margin: auto;
    max-width: 368px;
}

@media (min-width: 768px) {
    .faq-content-entry-subentry:after {
        max-width:656px;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry:after {
        max-width:1104px;
    }
}

.faq-content-entry-subentry .faq-content-entry-subentry-title-wrapper-icon:after {
    content: "+";
    font-size: 34px;
    line-height: 21px;
    transition: all 0.3s ease-out;
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry .faq-content-entry-subentry-title-wrapper-icon:after {
        line-height:30px;
    }
}

.faq-content-entry-subentry[open] .faq-content-entry-subentry-title-wrapper-icon:after {
    content: "âˆ’";
}

.faq-content-entry-subentry[open] {
    --bg-opacity: 1;
    background-color: #fcfaf5;
    background-color: rgba(252,250,245,var(--bg-opacity));
}

.faq-content-entry-title-wrapper {
    grid-gap: 16px;
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: grid;
   
    font-size: 24px;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    letter-spacing: 0;
    line-height: 32px;
    margin: auto;
    max-width: 368px;
    text-align: left;
}

@media (min-width: 768px) {
    .faq-content-entry-title-wrapper {
        grid-column:span 12 / span 12;
        grid-template-columns: repeat(12,minmax(0,1fr));
        max-width: 656px;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-title-wrapper {
        max-width:1328px;
    }
}

.faq-content-entry-title-wrapper-text {
    grid-column: span 5 / span 5;
    grid-column-start: 2;
}

@media (min-width: 768px) {
    .faq-content-entry-title-wrapper-text {
        grid-column:span 11 / span 11;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-title-wrapper-text {
        grid-column:span 9 / span 9;
        grid-column-start: 3;
    }
}

.faq-content-entry-title-wrapper-icon {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    grid-column-start: 1;
    grid-column: span 1 / span 1;
    justify-content: center;
}

@media (min-width: 1366px) {
    .faq-content-entry-title-wrapper-icon {
        grid-column-start:2;
    }
}

.faq-content-entry-subentry {
    text-align: left;
}

.faq-content-entry-subentry-title-wrapper {
    grid-gap: 16px;
    --text-opacity: 1;
    color: #4a4a4a;
    color: rgba(74,74,74,var(--text-opacity));
    display: grid;
   
    font-size: 18px;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    letter-spacing: 0;
    line-height: 22px;
    margin: auto;
    max-width: 368px;
    padding-left: 12px;
    padding-right: 12px;
    text-align: left;
}

@media (min-width: 768px) {
    .faq-content-entry-subentry-title-wrapper {
        grid-column:span 12 / span 12;
        grid-template-columns: repeat(12,minmax(0,1fr));
        max-width: 656px;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry-title-wrapper {
        font-size:16px;
        line-height: 20px;
        max-width: 1328px;
    }
}

.faq-content-entry-subentry-title-wrapper-text {
    grid-column: span 5 / span 5;
    grid-column-start: 1;
}

@media (min-width: 768px) {
    .faq-content-entry-subentry-title-wrapper-text {
        grid-column:span 11 / span 11;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry-title-wrapper-text {
        grid-column:span 9 / span 9;
        grid-column-start: 2;
    }
}

.faq-content-entry-subentry-title-wrapper-icon {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
}

.faq-content-entry-subentry > div.rich-text {
    grid-gap: 16px;
    --bg-opacity: 1;
    background-color: #fcfaf5;
    background-color: rgba(252,250,245,var(--bg-opacity));
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    letter-spacing: 0;
    margin: auto;
    max-width: 368px;
    padding-bottom: 40px;
}

@media (min-width: 768px) {
    .faq-content-entry-subentry > div.rich-text {
        grid-template-columns:repeat(12,minmax(0,1fr));
        max-width: 656px;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry > div.rich-text {
        grid-template-columns:repeat(12,minmax(0,1fr));
        max-width: 1328px;
        padding-bottom: 72px;
    }
}

.faq-content-entry-subentry > div.rich-text ol {
    grid-column: span 6 / span 6;
    padding-left: 12px;
    padding-right: 12px;
}

@media (min-width: 768px) {
    .faq-content-entry-subentry > div.rich-text ol {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry > div.rich-text ol {
        grid-column:span 9 / span 9;
        grid-column-start: 2;
    }
}

.faq-content-entry-subentry p {
    grid-column: span 6 / span 6;
    padding-left: 12px;
    padding-right: 12px;
}

@media (min-width: 768px) {
    .faq-content-entry-subentry p {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry p {
        grid-column:span 9 / span 9;
        grid-column-start: 2;
    }
}

.faq-content-entry-subentry summary {
    grid-column: span 5 / span 5;
    outline: none;
    padding-bottom: 16px;
    padding-top: 16px;
}

@media (min-width: 1366px) {
    .faq-content-entry-subentry summary {
        padding-bottom:24px;
        padding-top: 24px;
    }
}

.faq-content-entry-summary {
    padding-top: 24px;
}

@media (min-width: 1366px) {
    .faq-content-entry-summary {
        padding-top:32px;
    }
}

.imagebackground-page {
    position: relative;
}

.imagebackground-page-hero-image {
    bottom: 0;
    left: 0;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    width: 100vw;
    z-index: 0;
}

.imagebackground-page-hero-image picture {
    display: flex;
    height: 220px;
    object-fit: cover;
}

@media (min-width: 1366px) {
    .imagebackground-page-hero-image picture {
        height:100%;
    }
}

.imagebackground-page-hero-image picture img {
    filter: brightness(0.7);
    object-fit: cover;
    width: 100%;
}

@media (min-width: 1366px) {
    .imagebackground-page-hero-image picture img {
        filter: none;
    }
}

.imagebackground-page-wrapper {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: flex;
    flex-direction: column-reverse;
    padding: 32px 16px 56px;
    position: relative;
    z-index: 0;
}

@media (min-width: 1366px) {
    .imagebackground-page-wrapper {
        align-items: flex-start;
        flex-direction: row;
    }
}

.imagebackground-page-content {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.10196);
    margin-right: 12px;
    min-height: 500px;
}

.imagebackground-page-content .enhanced-form-color {
    padding-bottom: 16px;
    padding-top: 16px;
}

.imagebackground-page-content .enhanced-form-color .enhanced-form:first-of-type {
    box-shadow: none;
}

@media (min-width: 1366px) {
    .imagebackground-page-content {
        box-shadow: none;
        width: 50%;
    }
}

.imagebackground-page-headers {
    margin-left: 12px;
    width: 100%;
}

@media (min-width: 1366px) {
    .imagebackground-page-headers {
        width:50%;
    }
}

.imagebackground-page-headers .hero-text {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
}

@media (min-width: 1366px) {
    .imagebackground-page-headers .hero-text {
        margin-bottom:0;
    }
}

.imagebackground-page-headers .hero-text .hero-one {
    font-size: 32px;
    line-height: 38px;
}

@media (min-width: 1366px) {
    .imagebackground-page-headers .hero-text .hero-one {
        font-size:40px;
        line-height: 46px;
    }
}

.imagebackground-page-headers .hero-text .hero-two {
    font-size: 44px;
    line-height: 39px;
}

@media (min-width: 1366px) {
    .imagebackground-page-headers .hero-text .hero-two {
        font-size:80px;
        line-height: 94px;
    }
}

.imagebackground-page-headers h4 {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    text-transform: none;
}

.imagebackground-page-headers h4 .alternate-text {
    bottom: -12px;
   
    font-size: 56px;
    line-height: 12px;
    position: relative;
}

.imagebackground-page-headers-content {
    display: none;
}

@media (min-width: 1366px) {
    .imagebackground-page-headers-content {
        display:block;
    }
}

.news-search-page {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
}

@media (min-width: 1366px) {
    .news-search-page {
        grid-template-columns:repeat(12,minmax(0,1fr));
    }
}

.news-search-page .news-search-top {
    grid-column: span 6 / span 6;
}

@media (min-width: 1366px) {
    .news-search-page .news-search-top {
        grid-column:span 12 / span 12;
    }
}

.news-search-page .news-search-results {
    grid-column: span 6 / span 6;
}

@media (min-width: 1366px) {
    .news-search-page .news-search-results {
        grid-column:span 12 / span 12;
    }

    .main,main {
        padding-top: 106px;
    }
}

.body,body {
    overflow-x: hidden;
    width: 100vw;
}

.block-wrapper {
    margin: 0 auto;
    max-width: 1200px;
}

.block-wrapper p {
    margin-bottom: 20px;
}

@media (min-width: 1366px) {
    .header-wrapper {
        margin:0 auto;
        max-width: 1328px;
    }

    .header .brand {
        display: block;
    }

    .header .brand img {
        max-height: 68px;
        width: auto;
    }
}

.header-nav-utility {
    display: flex;
}

@media (min-width: 1366px) {
    .header-nav-utility {
        --bg-opacity:1;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        height: 88px;
        justify-content: flex-start;
    }
}

.header-nav-utility-row {
    justify-content: flex-end;
}

@media (min-width: 1366px) {
    .header-nav-utility-row {
        justify-content: flex-start;
        width: 33.3333333333%;
    }

    .header-nav-utility-row:last-of-type {
        justify-content: flex-end;
        width: 66.6666666667%;
    }
}

.header-nav-utility-row .brand {
    height: 55px;
}

@-moz-document url-prefix() {
    .header-nav-utility-row .brand svg {
        width: auto;
    }
}

@media (min-width: 1366px) {
    .utility-nav-item-link-icon svg {
        height:24px;
        margin-right: 15px;
        width: 24px;
    }
}

.utility-nav-item-link-lead {
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    font-size: 16px;
    line-height: 24px;
}

@media (min-width: 1366px) {
    .utility-nav-item-link-lead {
        font-size:14px;
        line-height: 24px;
        margin: 0;
    }
}

.utility-nav-item-link-content {
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    font-size: 18px;
}

@media (min-width: 1366px) {
    .utility-nav-item-link-content {
        font-family:Helvetica Now Display Medium;
        font-size: 16px;
        line-height: 24px;
    }

    .utility-nav-item-link {
        align-items: center;
        border-right: 1px solid rgba(117,120,123,0.15);
        margin-right: 30px;
        position: relative;
    }
}

@media (min-width: 1366px) {
    .utility-nav-item-link:not(:last-of-type):after {
        background:#75787b;
        border-radius: 5px;
        content: "";
        height: 100%;
        opacity: 0.15;
        position: absolute;
        right: -30px;
        top: 0;
        width: 2px;
    }

    .utility-nav-item-link-icon,.utility-nav-item-link-lead {
        display: block;
    }
}

@media (max-width: 1365px) {
    .utility-nav-item {
        width:100%;
    }

    .utility-nav-item div:first-of-type {
        display: block;
        margin-left: auto;
    }

    .utility-nav-item div:nth-child(2) {
        order: -1;
    }

    .utility-nav-item [aria-label="Call Us"] .utility-nav-item-link-lead {
        display: none;
    }

    .utility-nav-item [aria-label="Call Us"] .utility-nav-item-link-content {
        padding-left: 10px;
    }

    .hide-small {
        display: none;
    }
}

.main-navigation-mobile {
    height: 56px;
}

.main-navigation-mobile-menu {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    --bg-opacity: 1;
    align-items: center;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    box-shadow: 0 3px 6px rgba(0,28,59,0.16078);
    display: flex;
    height: 100%;
    justify-content: space-between;
    padding-bottom: 0;
    padding-top: 0;
    position: relative;
    z-index: 90;
}

.main-navigation-mobile-menu > * {
    margin-right: 16px;
}

.main-navigation-mobile-menu > :last-child {
    margin-right: 0;
}

.main-navigation-mobile-drawer {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    max-height: calc(100vh - 98px);
    overflow: auto;
    padding-bottom: 12px;
    z-index: 9;
}

@supports (background: -webkit-named-image(i)) {
    .main-navigation-mobile-drawer {
        margin-top:-98px;
        min-height: -webkit-fill-available;
        padding-top: 98px;
    }
}

@media (min-width: 1366px) {
    .main-navigation-mobile-drawer {
        z-index:auto;
    }
}

.main-navigation-mobile-drawer ul {
    list-style: none;
    padding: 48px 0 0;
}

@media (min-width: 1366px) {
    .main-navigation-mobile-drawer ul {
        padding:0;
    }
}

.main-navigation-mobile-drawer ul li {
    font-size: 20px;
    line-height: 24px;
    padding-bottom: 40px;
}

.main-navigation-mobile.mini {
    background-color: #fff;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
}

.main-navigation-mobile.mini .job-cart-alert {
    top: 56px;
}

.main-navigation-mobile .mobile-brand {
    margin-right: auto;
    padding-right: 16px;
}

.main-navigation-mobile .mobile-brand img {
    height: 44px;
    width: auto;
}

.main-navigation-mobile svg {
    fill: #002146;
    height: 24px;
    width: 24px;
}

.main-navigation-mobile .nav-link {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
}

@media (min-width: 768px) {
    .main-navigation-mobile .nav-link {
        padding:0 56px;
    }
}

.main-navigation-mobile .footer-link {
    position: relative;
}

.main-navigation-mobile .footer-link:before {
    background-color: #ddd;
    content: "";
    height: 1px;
    left: 30px;
    position: absolute;
    width: calc(100% - 60px);
}

.main-navigation-mobile .sub-nav-trigger {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    --text-opacity: 1;
    align-items: center;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: flex;
   
    justify-content: space-between;
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
}

@media (min-width: 768px) {
    .main-navigation-mobile .sub-nav-trigger {
        padding:0 56px;
    }
}

.main-navigation-mobile .sub-nav-trigger svg {
    fill: #002146;
    height: 16px;
    transform: rotate(90deg);
    width: 18px;
}

.main-navigation-mobile .sub-nav-trigger.open {
    padding-bottom: 24px;
}

.main-navigation-mobile .sub-nav-trigger.open svg {
    fill: #d00;
    transform: rotate(270deg);
}

.main-navigation-mobile .sub-nav-drawer {
    background-color: #eff5fa;
    padding-top: 40px;
}

.main-navigation-mobile .sub-nav-link {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: block;
   
    padding-left: 48px;
    padding-right: 48px;
}

@media (min-width: 768px) {
    .main-navigation-mobile .sub-nav-link {
        padding:0 72px;
    }
}

.main-navigation-desktop .section-container {
    padding: 0;
}

.main-navigation-desktop .nav-item-panel {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    background-color: #fff;
    border-radius: 0 8px 0 0;
    box-shadow: 0 10px 10px rgba(0,0,0,0.10196);
    display: flex;
    justify-content: space-between;
    left: -20px;
    padding: 32px 48px 48px 32px;
    top: 43px;
    width: 672px;
}

.main-navigation-desktop .nav-item-panel ul {
    padding-top: 4px;
}

.main-navigation-desktop .nav-item-panel.nav-item-panel-right {
    border-radius: 8px 0 0 0;
    left: auto;
    right: -13px;
}

.main-navigation-desktop-wrapper {
    align-items: center;
    display: flex;
    height: 100%;
    list-style: none;
    padding-bottom: 0;
    padding-top: 0;
}

.main-navigation-desktop-wrapper ul {
    list-style: none;
}

.main-navigation-desktop-min {
    --bg-opacity: 1;
    background-color: #dde6ed;
    background-color: rgba(221,230,237,var(--bg-opacity));
    box-shadow: 0 3px 6px rgba(0,28,59,0.16078);
    height: 64px;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
}

.main-navigation-desktop-min .logo-brand {
    margin-right: 60px;
}

.main-navigation-desktop-min .logo-brand img {
    height: 50px;
    width: auto;
}

.main-navigation-desktop-min .nav-item-panel {
    top: 36px;
}

.main-navigation-desktop-max {
    background-color: #dde6ed;
    background-color: rgba(221,230,237,var(--bg-opacity));
    box-shadow: 0 3px 6px rgba(0,28,59,0.16078);
    height: 64px;
    position: relative;
    width: 100%;
    z-index: 2;
}

.main-navigation-desktop .nav-item {
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    line-height: 22px;
    margin-right: 36px;
    position: relative;
    z-index: 2;
}

.main-navigation-desktop .nav-item button {
    align-items: center;
    display: flex;
}

.main-navigation-desktop .nav-item button svg {
    fill: #002146;
    height: 20px;
    margin-left: 6px;
    transform: rotate(90deg);
    width: 12px;
}

.main-navigation-desktop .nav-item--open:before {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    content: "";
    height: 55px;
    left: -20px;
    position: absolute;
    top: -10px;
    width: calc(100% + 33px);
    z-index: -1;
}

.main-navigation-desktop .nav-item--open button svg {
    transform: rotate(270deg);
}

.main-navigation-desktop .sub-nav-item {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: block;
   
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 24px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.main-navigation-desktop .sub-nav-item:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.main-navigation-desktop .sub-nav-item:after {
    display: none;
}

@media (hover: hover) {
    .main-navigation-desktop .sub-nav-item:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .main-navigation-desktop .sub-nav-item:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.main-navigation-desktop .sub-nav-item.wrapper:after {
    width: 0;
}

.main-navigation-desktop .sub-nav-item:hover:after {
    margin-top: 8px;
}

.main-navigation-desktop .nav-item-callout {
    max-width: 224px;
    padding-top: 0;
}

.main-navigation-desktop .nav-item-callout img {
    border-radius: 10px;
    height: 160px;
    margin-bottom: 16px;
    width: 100%;
}

.main-navigation-desktop .nav-item-callout a {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 24px;
    letter-spacing: -0.4px;
    line-height: 30px;
    margin-bottom: 16px;
}

.main-navigation-desktop .nav-item-callout p {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 14px;
    letter-spacing: -0.3px;
    line-height: 16px;
    padding-top: 16px;
}

.menu-overlay.open {
    background: #000 0 0 no-repeat padding-box;
    height: 101vh;
    opacity: 0.25;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: -1;
}

.job-search.mini {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    position: fixed;
    top: 51px;
    width: 100%;
}

.job-search.mini.mobile {
    top: 56px;
}

.job-search .job-see-all {
    line-height: 0;
    margin-bottom: 20px;
    margin-left: 750px;
}

.job-search-button {
    -webkit-box-align: center;
    -ms-flex-align: center;
    --bg-opacity: 1;
    --text-opacity: 1;
    align-items: center;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: inline-block;
    display: flex;
   
   
    height: 48px;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    margin: 0;
    min-width: 196px;
    padding-left: 32px;
    padding-right: 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .job-search-button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.job-search-button > span,.job-search-button i,.job-search-button svg {
    display: inline;
}

.job-search-button svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.job-search-button i,.job-search-button svg {
    fill: #002146;
    height: 16px;
    margin-right: 8px;
    transform: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 16px;
}

.job-search-button > span,.job-search-button i,.job-search-button svg {
    display: block;
}

@media (hover: hover) {
    .job-search-button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        color: #002146;
        color: rgba(0,33,70,var(--text-opacity));
    }

    .job-search-button:hover svg {
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.job-search-button.open {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #f7b22e;
    background-color: rgba(247,178,46,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.job-search-button.open svg {
    fill: #fff;
}

.header-navigation {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    position: relative;
    z-index: 2;
}


.featured-jobs-heading {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 32px;
    line-height: 40px;
}

@media (min-width: 768px) {
    .featured-jobs-heading {
        font-size:34px;
        line-height: 40px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs-heading {
        font-size:42px;
        line-height: 56px;
    }
}

.featured-jobs-hero {
    height: 100%;
    left: 0;
    overflow: hidden;
    top: 0;
    width: 100%;
    z-index: -1;
}

.featured-jobs-hero img {
    height: 100%;
    object-fit: cover;
    width: auto;
}

@media (min-width: 1366px) {
    .featured-jobs-hero img {
        min-height:450px;
    }
}

.featured-jobs .section-container {
    padding-bottom: 24px;
    padding-top: 24px;
}

@media (min-width: 1366px) {
    .featured-jobs .section-container {
        padding-bottom:32px;
        padding-top: 32px;
    }
}

.featured-jobs .swiper-wrapper {
    margin-left: -12px;
    margin-right: -12px;
    overflow-x: hidden;
}

.featured-jobs .mobile-swiper {
    padding-left: 32px;
    padding-right: 32px;
}

.featured-jobs .mobile-swiper-container {
    overflow-y: visible;
    padding-left: 0;
}

.featured-jobs .mobile-swiper-slide {
    margin: 0;
    padding: 0 8px;
    width: 100%;
}

.featured-jobs .mobile-swiper-slide .featured-jobs-card {
    margin-left: 0;
    margin-right: 0;
}

.featured-jobs .large-grid {
    margin-bottom: 0;
    margin-top: 0;
}

@media (min-width: 768px) {
    .featured-jobs .large-grid {
        margin-bottom:24px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs .large-grid {
        margin-bottom:32px;
    }
}

.featured-jobs .large-grid .featured-jobs-card:nth-child(odd) {
    margin: 0 0 0 auto;
}

@media (min-width: 1366px) {
    .featured-jobs .large-grid .featured-jobs-card:nth-child(odd) {
        margin:0 auto;
    }
}

.featured-jobs .large-grid .featured-jobs-card:nth-child(2n) {
    margin: 0 auto 0 0;
}

@media (min-width: 1366px) {
    .featured-jobs .large-grid .featured-jobs-card:nth-child(2n) {
        margin:0 auto;
    }
}

.featured-jobs-grid p.subtitle-two {
    --text-opacity: 1;
    color: #131313;
    color: rgba(19,19,19,var(--text-opacity));
}

.featured-jobs-card {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);
    display: block;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-left: 24px;
    margin-right: 24px;
    overflow: hidden;
}

.featured-jobs-card-container {
    height: 408px;
}

@media (min-width: 768px) {
    .featured-jobs-card-container {
        height:320px;
        padding-left: 16px;
        padding-right: 16px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs-card-container {
        height:337px;
        padding-left: 24px;
        padding-right: 24px;
    }
}

.featured-jobs-card .sticker {
    border-radius: 3px;
    width: 60%;
}

.featured-jobs-card .crisis-response {
    --text-opacity: 1;
    color: #f34436;
    color: rgba(243,68,54,var(--text-opacity));
}

.featured-jobs-card .favorite-button {
    z-index: 1;
}

.featured-jobs-card .favorite-button svg {
    height: 24px;
    width: 24px;
}

.featured-jobs-card-img {
    align-self: start;
    height: 168px;
    overflow: hidden;
    width: 100%;
}

@media (min-width: 768px) {
    .featured-jobs-card-img {
        height:137px;
    }
}

.featured-jobs-card-img img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.featured-jobs-card-content {
    --bg-opacity: 1;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 16px;
    position: relative;
}

.featured-jobs-card-content-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 20px;
    line-height: 24px;
}

.featured-jobs-card-content-title:after {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: -140px;
}

.featured-jobs-card-content-location {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 16px;
    line-height: 14px;
}

.featured-jobs-card-content-salary {
    align-self: end;
    margin-top: auto;
}

.featured-jobs-card-content-salary-content {
    --text-opacity: 1;
    color: #1e7721;
    color: rgba(30,119,33,var(--text-opacity));
   
    font-size: 20px;
    line-height: 14px;
}

.featured-jobs-card .favorite-button {
    right: 8px;
    top: 8px;
}

.featured-jobs-card .favorite-button svg .stroke {
    fill: #2257b8;
}

@media (min-width: 1366px) {
    .featured-jobs-card {
        margin:0;
    }
}

.featured-jobs-row {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);
    display: block;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

@media (min-width: 768px) {
    .featured-jobs-row-container {
        padding-left:16px;
        padding-right: 16px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs-row-container {
        padding-left:24px;
        padding-right: 24px;
    }
}

.featured-jobs-row .sticker {
    border-radius: 3px;
    font-size: 12px;
    margin-left: 10px;
    width: 120px;
}

.featured-jobs-row .crisis-response {
    --text-opacity: 1;
    color: #f34436;
    color: rgba(243,68,54,var(--text-opacity));
}

.featured-jobs-row .favorite-button {
    z-index: 1;
}

.featured-jobs-row .favorite-button svg {
    height: 18px;
    width: 18px;
}

@media (min-width: 768px) {
    .featured-jobs-row .favorite-button svg {
        height:24px;
        width: 24px;
    }
}

.featured-jobs-row-detail {
    align-self: start;
    display: flex;
    margin-bottom: 5px;
    overflow: hidden;
    width: 100%;
}

.featured-jobs-row-detail-title {
    flex: 70% 1;
}

.featured-jobs-row-detail-title-text {
    float: left;
    margin-right: 5px;
}

.featured-jobs-row-detail-jobid {
    flex: 30% 1;
    padding-right: 30px;
}

.featured-jobs-row-detail-jobid p {
    font-size: 13px;
}

.featured-jobs-row-detail img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.featured-jobs-row-detail-grid {
    font-size: 13px;
}

.featured-jobs-row-detail-grid .subtitle-two {
    font-size: 13px;
    font-weight: 700;
}

@media (min-width: 768px) {
    .featured-jobs-row-detail-grid .subtitle-two {
        font-size:14px;
    }
}

.featured-jobs-row-detail-grid .body-small {
    font-size: 13px;
}

@media (min-width: 768px) {
    .featured-jobs-row-detail-grid .body-small {
        font-size:14px;
    }
}

.featured-jobs-row-content {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    display: flex;
    flex-direction: row;
    padding: 16px;
    position: relative;
}

.featured-jobs-row-content-title {
    flex: 40% 1;
   
}

.featured-jobs-row-content-title,.featured-jobs-row-content-title-btn {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    line-height: 24px;
}

.featured-jobs-row-content-title-btn {
    display: block;
   
    font-size: 13px;
    margin-bottom: 4px;
    margin-right: 20px;
    margin-top: 4px;
    text-align: left;
}

@media (min-width: 768px) {
    .featured-jobs-row-content-title-btn {
        font-size:16px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs-row-content-title-btn {
        font-size:20px;
        line-height: 22px;
        margin-bottom: 24px;
    }
}

.featured-jobs-row-content-title-btn:after {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}

.featured-jobs-row-content-title-btn-detail {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: block;
   
    font-size: 13px;
    line-height: 24px;
    margin-bottom: 4px;
    margin-right: 20px;
    margin-top: 4px;
    text-align: left;
}

@media (min-width: 768px) {
    .featured-jobs-row-content-title-btn-detail {
        font-size:16px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs-row-content-title-btn-detail {
        font-size:20px;
        line-height: 22px;
        margin-bottom: 24px;
    }
}

.featured-jobs-row-content-location {
    --text-opacity: 1;
    -webkit-box-flex: 20%;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    flex: 20% 1;
   
    font-size: 12px;
    line-height: 24px;
}

@media (min-width: 768px) {
    .featured-jobs-row-content-location {
        font-size:16px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs-row-content-location {
        font-size:20px;
    }
}

.featured-jobs-row-content-salary {
    flex: 30% 1;
    line-height: 24px;
    padding-right: 30px;
}

.featured-jobs-row-content-salary-content {
    --text-opacity: 1;
    color: #1e7721;
    color: rgba(30,119,33,var(--text-opacity));
   
    font-size: 12px;
}

.featured-jobs-row-content-salary-content .call-details-link {
    position: relative;
    z-index: 1;
}

@media (min-width: 768px) {
    .featured-jobs-row-content-salary-content {
        font-size:16px;
    }
}

@media (min-width: 1366px) {
    .featured-jobs-row-content-salary-content {
        font-size:20px;
    }
}

.featured-jobs-row-overview .more-detail-link {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    font-size: 16px;
    font-weight: 700;
    padding-left: 20px;
}

.featured-jobs-row .favorite-button {
    right: 8px;
    top: 8px;
}

.featured-jobs-row .favorite-button svg .stroke {
    fill: #2257b8;
}

@media (min-width: 1366px) {
    .featured-jobs-row {
        margin:0;
    }
}

.auto-complete .option {
    --text-opacity: 1;
    border-bottom: 1px solid #ddd;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.auto-complete .option-link {
    align-items: center;
    display: flex;
    height: 100%;
    padding-bottom: 8px;
    padding-right: 8px;
    padding-top: 8px;
    text-align: left;
    width: 100%;
}

.auto-complete .option svg {
    fill: #131313;
    transform: translateY(6px);
}

@media (hover: hover) {
    .auto-complete .option:hover {
        --bg-opacity:1;
        background-color: #eee;
        background-color: rgba(238,238,238,var(--bg-opacity));
    }
}

.auto-complete .option-active {
    --bg-opacity: 1;
    background-color: #eee;
    background-color: rgba(238,238,238,var(--bg-opacity));
}

.auto-complete-container {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 4px;
    box-shadow: 0 1px 15px rgba(185,187,188,0.25098);
    left: 0;
    top: 100%;
    width: 100%;
    z-index: 2;
}

@media (min-width: 1200px) {
    .auto-complete-container {
        top:calc(100% + 2px);
        width: 381px;
    }
}

.auto-complete .search-heading {
   
    font-size: 16px;
    line-height: 14px;
    margin-bottom: 8px;
}

.auto-complete .clear-button {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
   
    font-size: 16px;
    line-height: 14px;
    margin-bottom: 8px;
}

.auto-complete .empty-search {
    right: 20px;
    top: 33%;
}

@media (min-width: 1200px) {
    .auto-complete .empty-search {
        top:50%;
    }
}

.auto-complete .search-suggestion {
    --text-opacity: 1;
    border: 1px solid #ddd;
    border-radius: 10px;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 8px;
    margin-right: 15px;
    padding: 7px 5px 9px;
}

.job-search-form {
    width: 100%;
}

@media (min-width: 1366px) {
    .job-search-form {
        margin:0 auto;
        max-width: 475px;
    }
}

.job-search-form label {
    position: relative;
    width: 100%;
}

@media (min-width: 1366px) {
    .job-search-form label {
        max-width:475px;
    }
}

.job-search-form label input {
    border-radius: 6px;
    height: 56px;
    margin-bottom: 12px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 48px;
    width: 100%;
}

@media (min-width: 1366px) {
    .job-search-form label input {
        margin-bottom:24px;
    }
}

.job-search-form label i {
    height: 24px;
    left: 12px;
    position: absolute;
    top: 28%;
    width: 24px;
}

@media (min-width: 768px) {
    .job-search-form label i {
        left:42px;
        top: 23%;
    }
}

@media (min-width: 1366px) {
    .job-search-form label i {
        left:38px;
        top: 28%;
    }
}

.job-search-form label i svg,.job-search-form label i svg .stroke {
    fill: #002146;
}

@media (min-width: 768px) {
    .job-search-form label i svg,.job-search-form label i svg .stroke {
        height:16px;
        width: 16px;
    }
}

@media (min-width: 1366px) {
    .job-search-form label i svg,.job-search-form label i svg .stroke {
        height:24px;
        width: 24px;
    }
}

.job-search-form .auto-complete .empty-search {
    right: 20px;
    top: 18px;
}

@media (min-width: 768px) {
    .job-search-form .auto-complete .empty-search {
        right:36px;
        top: 5px;
    }
}

@media (min-width: 1366px) {
    .job-search-form .auto-complete .empty-search {
        right:36px;
        top: 19px;
    }
}

.job-search-form .auto-complete-container {
    top: 56px;
    width: 324px;
}

@media (min-width: 1366px) {
    .job-search-form .auto-complete-container {
        width:475px;
    }
}

.discipline-search-form-job {
    max-width: 400px;
}

.discipline-search-form-job input {
    border-radius: 5px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);
    color: #000;
    font-size: 18px;
    padding: 20px 64px 20px 28px;
}

.discipline-search-form-job .empty-search {
    display: none;
}

.discipline-search-form-job button {
    border-radius: 50px;
    min-width: auto;
    padding: 27px;
    position: absolute;
    right: 6px;
    top: 6px;
}

.discipline-search-form-job button i {
    left: 16px;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 10px;
}

.discipline-search-form-job button i svg {
    height: 24px;
    width: 24px;
}

.job-search {
    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);
}

@media (min-width: 1366px) {
    .job-search {
        --bg-opacity:1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        height: 152px;
        position: relative;
        z-index: 2;
    }
}

.job-search-form--desktop {
    border: 2px solid #ddddde;
    border-radius: 8px;
    height: 88px;
    width: 880px;
}

.job-search-form--desktop label {
   
    font-size: 16px;
    letter-spacing: -0.45px;
    line-height: 24px;
}

.job-search-form--desktop input {
   
    font-size: 14px;
    line-height: 20px;
}

.job-search-form--desktop input:active,.job-search-form--desktop input:focus {
    outline: none;
}

.job-search-form--mobile {
    z-index: 9;
}

.job-search-form--mobile label {
    position: relative;
}

.job-search-form--mobile label svg {
    height: 20px;
    left: 20px;
    position: absolute;
    top: calc(50% - 10px);
    width: 20px;
}

.job-search-form--mobile input {
    border-radius: 7px;
    font-size: 18px;
    height: 56px;
    line-height: 22px;
    line-height: 26px;
    padding-left: 48px;
    padding-right: 48px;
}

.job-search .all-jobs-link {
    align-items: center;
    display: flex;
    position: relative;
}

@media (hover: hover) {
    .job-search .all-jobs-link:hover:after {
        display:none;
    }
}

.job-search .all-jobs-link.hidden {
    display: none !important;
}

.job-search .all-jobs-link svg {
    fill: #666;
    height: 24px;
    position: absolute;
    right: -26px;
    top: 0;
    width: 24px;
}

@media (min-width: 1366px) {
    .job-search .all-jobs-link svg {
        top:-11px;
    }
}

.job-search .all-jobs-link.desktop {
    display: none;
}

@media (min-width: 1366px) {
    .job-search .all-jobs-link.desktop {
        display: flex;
        transform: translateY(22px);
    }
}

.results-list-heading {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 18px;
    line-height: 32px;
}

@media (min-width: 1200px) {
    .results-list-heading {
        font-size:24px;
        line-height: 36px;
    }
}

.results-list-heading .emphasis {
   
    font-size: 24px;
}

@media (min-width: 1200px) {
    .results-list-heading .emphasis {
        font-size:32px;
    }
}

.results-list .sort-btn {
    --text-opacity: 1;
    color: #131313;
    color: rgba(19,19,19,var(--text-opacity));
   
    font-size: 18px;
}

.results-list .sort-btn.active {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.results-list .filter-modal-trigger {
    max-width: 300px;
}

.results-list .filter-modal-trigger svg {
    height: 18px;
    width: 18px;
}

.results-list .filter-modal-trigger svg .stroke {
    fill: #fff;
}

@media (min-width: 768px) {
    .results-list .job-search-results {
        order: 2;
    }
}

.mobile-sort {
    border: 2px solid #ddddde;
    border-radius: 4px;
    padding: 7px 25px 7px 16px;
}

.mobile-sort-wrapper {
    display: inline-block;
    position: relative;
}

.mobile-sort-wrapper:after {
    content: "âˆ¨";
    font-size: 18px;
    font-weight: 700;
    height: 0;
    padding: 7px 0 0 8px;
    pointer-events: none;
    position: absolute;
    right: 6px;
    top: -1px;
}

.below-job-results {
    animation-duration: 2s;
    animation-iteration-count: 1;
    animation-name: opacity0to1;
    animation-timing-function: linear;
}

.result-card {
    border-radius: 7px;
    box-shadow: 0 1px 15px rgba(185,187,188,0.25098);
    overflow: hidden;
}

.result-card .favorite-button {
    right: 8px;
    top: 8px;
    z-index: 1;
}

@media (min-width: 1200px) {
    .result-card .favorite-button {
        right:12px;
        top: 12px;
    }
}

.result-card .favorite-button svg {
    height: 20px;
    width: 20px;
}

.result-card .favorite-button svg .stroke {
    fill: #2257b8;
}

.result-card .sticker {
    position: absolute;
    width: 100%;
}

.result-card .call-details-link {
    position: relative;
    z-index: 1;
}

.result-card-img {
    overflow: hidden;
    position: relative;
    width: 95px;
}

.result-card-img img {
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: auto;
    z-index: 0;
}

@media (min-width: 1200px) {
    .result-card-img {
        width:20%;
    }
}

.result-card-img-locum {
    border-radius: 10px;
    margin-left: 8px;
    margin-top: 8px;
}

@media (min-width: 1200px) {
    .result-card-img-locum {
        margin-left:16px;
        margin-top: 16px;
    }
}

.result-card-content-critical p {
    --text-opacity: 1;
    color: #f34436;
    color: rgba(243,68,54,var(--text-opacity));
   
    font-size: 14px;
    line-height: 19px;
    text-align: left;
    text-transform: uppercase;
}

.result-card-content-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: block;
   
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 4px;
    margin-right: 20px;
    margin-top: 4px;
}

@media (min-width: 1200px) {
    .result-card-content-title {
        font-size:24px;
        line-height: 22px;
        margin-bottom: 24px;
    }
}

.result-card-content-title:after {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}

.result-card-content-location {
    font-size: 16px;
}

.result-card-content-details,.result-card-content-location {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    line-height: 14px;
}

.result-card-content-details {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    align-items: center;
    font-size: 14px;
    justify-content: space-between;
    width: 95%;
}

.result-card-content-details .salary {
    --text-opacity: 1;
    color: #1e7721;
    color: rgba(30,119,33,var(--text-opacity));
   
    font-size: 18px;
}

.result-card-content-pricing-salary {
    --text-opacity: 1;
    color: #1e7721;
    color: rgba(30,119,33,var(--text-opacity));
   
    font-size: 24px;
    line-height: 24px;
}

.result-card-content-feature {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    font-size: 16px;
    line-height: 22px;
}

.result-card-content-feature svg {
    fill: #666;
    height: 15px;
    margin-right: 4px;
    transform: translateY(4px);
    width: 15px;
}

.result-card-content-feature p {
    line-height: normal;
}

.searchCard {
    display: flex;
}

.searchCard .card-content-box {
    width: 80%;
}

.searchCard .result-card-content {
    padding: 12px;
}

.searchCard .result-card-content-details {
    margin-bottom: 4px;
}

.searchCard .result-card-content-location {
    margin-bottom: 12px;
}

.searchCard .bottom-wrapper .result-card-content-details {
    margin-bottom: 0;
}

.pagination-btn {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 1px solid #979797;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    display: block;
    font-size: 18px;
    height: 100%;
    line-height: 38px;
    margin-right: 12px;
    min-width: 33px;
    text-align: center;
}

.pagination-btn.active {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    cursor: not-allowed;
}

.pagination-btn:disabled {
    cursor: not-allowed;
}

.pagination-nav-btn svg {
    height: 40px;
    width: 40px;
}

.pagination-nav-btn svg .stroke {
    fill: #002146;
}

.pagination-nav-btn:first-of-type {
    margin-right: 12px;
}

.pagination-nav-btn:disabled {
    cursor: not-allowed;
}

.pagination-nav-btn:disabled .stroke {
    fill: #bbb;
}

.filters {
    align-self: flex-start;
    border: 1px solid #ddddde;
    width: 530px;
}

.filters .filter-sections .leading-6 {
    width: 90%;
}

.filters .filter-sections .filterSubSpec {
    line-height: 1.5rem;
    padding: 5px 0;
    width: 90%;
}

.filters-title {
   
    font-size: 20px;
    line-height: 22px;
}

.filters-applied-label {
   
    font-size: 16px;
}

.filters-applied-list-item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    --text-opacity: 1;
    align-items: center;
    border: 2px solid #bbb;
    border-radius: 19px;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    display: flex;
   
    font-size: 14px;
    margin: 0 8px 8px 0;
    padding: 7.54px 11.25px;
}

.filters-applied-list-item span {
    margin-right: 4px;
}

.filters-applied-list-item svg .stroke {
    fill: #bbb;
}

.filters-exclusive {
    border-radius: 6px;
}

@media (min-width: 768px) {
    .filters {
        -webkit-box-ordinal-group:2;
        -ms-flex-order: 1;
        margin-right: 64px;
        order: 1;
    }
}

.filter-section {
    border-bottom: 2px solid #ccc;
}

.filter-section-description {
    font-size: 16px;
    line-height: 24px;
}

.filter-section-input {
    border: 2px solid #ccc;
    border-radius: 5px;
    height: 44px;
    padding-left: 12px;
    padding-right: 12px;
    width: 100%;
}

.filter-section-facet {
    --text-opacity: 1;
    align-items: center;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    display: flex;
   
    font-size: 16px;
    line-height: 38px;
}

.filter-section-facet-count {
    --text-opacity: 1;
    --bg-opacity: 1;
    align-self: center;
    background-color: #c6e7fa;
    background-color: rgba(198,231,250,var(--bg-opacity));
    border-radius: 4px;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    line-height: 24px;
    padding-left: 4px;
    padding-right: 4px;
}

.filter-section-facet input[type="checkbox"] {
    height: 20px;
    width: 20px;
}

.filter-section .empty-search {
    bottom: 0;
    right: 5px;
}

.toggle {
    display: inline-block;
    height: 13px;
    position: relative;
    width: 30px;
}

.toggle input {
    height: 0;
    opacity: 0;
    width: 0;
}

.toggle input:checked + .toggle-slider {
    background-color: #358437;
}

.toggle input:checked + .toggle-slider:before {
    transform: translateX(15px);
}

.toggle-slider {
    background-color: #ccc;
    border-radius: 19px;
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.4s;
}

.toggle-slider:before {
    background-color: #fff;
    border: 1px solid #999;
    border-radius: 100%;
    bottom: -2px;
    content: "";
    height: 17px;
    position: absolute;
    transition: 0.4s;
    width: 17px;
}

.no-results {
    border-radius: 10px;
    padding: 12px 16px 40px;
    width: 100%;
}

.no-results-img {
    width: 100%;
}

.no-results-img img {
    height: auto;
    width: 100%;
}

.no-results-content {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (min-width: 1200px) {
    .no-results {
        align-self: flex-start;
        margin-left: auto;
        margin-right: 40px;
        max-width: 1366px;
        padding: 32px 0;
    }

    .no-results-img {
        width: 300px;
    }

    .no-results-content {
        width: 60%;
    }
}

.no-results .emphasis {
   
    font-size: 24px;
}

@media (min-width: 1200px) {
    .no-results .emphasis {
        font-size:32px;
    }
}

.no-results h2 {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

.mobile-modal {
    height: 100vh;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    top: 0;
    width: 100vw;
    z-index: 9999;
}

.mobile-modal-header {
    border-bottom: 1px solid #707070;
    border-top: 2px solid #707070;
}

.mobile-modal-close {
    right: 30px;
}

.mobile-modal-footer {
    border: 1px solid #ddd;
    z-index: 999;
}

.mobile-modal-footer button {
    display: block;
    margin: 0 auto;
}

.hot-jobs {
    overflow-x: hidden;
}

.hot-jobs-heading {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 32px;
    line-height: 40px;
}

@media (min-width: 768px) {
    .hot-jobs-heading {
        font-size:34px;
        line-height: 40px;
    }
}

@media (min-width: 1366px) {
    .hot-jobs-heading {
        font-size:42px;
        line-height: 56px;
    }
}

.hot-jobs-hero {
    height: 100%;
    left: 0;
    overflow: hidden;
    top: 0;
    width: 100%;
    z-index: -1;
}

.hot-jobs-hero img {
    height: 100%;
    object-fit: cover;
    width: auto;
}

@media (min-width: 1366px) {
    .hot-jobs-hero img {
        min-height:450px;
    }
}

.hot-jobs .section-container {
    padding-bottom: 24px;
    padding-top: 24px;
}

@media (min-width: 1366px) {
    .hot-jobs .section-container {
        padding-bottom:32px;
        padding-top: 32px;
    }
}

.hot-jobs .swiper-wrapper {
    margin-left: -24px;
    margin-right: -24px;
    overflow-x: hidden;
}

.hot-jobs .mobile-swiper {
    padding-left: 32px;
    padding-right: 32px;
}

.hot-jobs .mobile-swiper-container {
    overflow-y: visible;
    padding-left: 0;
}

.hot-jobs .mobile-swiper-slide {
    margin: 0;
    padding: 0 8px;
    width: 100%;
}

.hot-jobs .mobile-swiper-slide .hot-jobs-card {
    margin-left: 0;
    margin-right: 0;
}

.hot-jobs .mobile-swiper .dot-navigation {
    margin-top: 32px;
}

.hot-jobs .large-grid {
    margin-bottom: 0;
    margin-top: 0;
}

@media (min-width: 768px) {
    .hot-jobs .large-grid {
        margin-bottom:24px;
    }
}

@media (min-width: 1366px) {
    .hot-jobs .large-grid {
        margin-bottom:32px;
    }
}

.hot-jobs .large-grid .hot-jobs-card:nth-child(odd) {
    margin: 0 0 0 auto;
}

@media (min-width: 1366px) {
    .hot-jobs .large-grid .hot-jobs-card:nth-child(odd) {
        margin:0 auto;
    }
}

.hot-jobs .large-grid .hot-jobs-card:nth-child(2n) {
    margin: 0 auto 0 0;
}

@media (min-width: 1366px) {
    .hot-jobs .large-grid .hot-jobs-card:nth-child(2n) {
        margin:0 auto;
    }
}

.hot-jobs-card {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);
    display: block;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-left: 24px;
    margin-right: 24px;
    overflow: hidden;
}

.hot-jobs-card-container {
    height: 312px;
}

@media (min-width: 768px) {
    .hot-jobs-card-container {
        height:281px;
        padding-left: 16px;
        padding-right: 16px;
    }
}

@media (min-width: 1366px) {
    .hot-jobs-card-container {
        height:280px;
        padding-left: 24px;
        padding-right: 24px;
    }
}

.hot-jobs-card .sticker {
    border-radius: 3px;
    width: 60%;
}

.hot-jobs-card .crisis-response {
    --text-opacity: 1;
    color: #f34436;
    color: rgba(243,68,54,var(--text-opacity));
}

.hot-jobs-card .favorite-button {
    z-index: 1;
}

.hot-jobs-card .favorite-button svg {
    height: 24px;
    width: 24px;
}

.hot-jobs-card-img {
    align-self: start;
    height: 168px;
    overflow: hidden;
    width: 100%;
}

@media (min-width: 768px) {
    .hot-jobs-card-img {
        height:137px;
    }
}

.hot-jobs-card-img img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.hot-jobs-card-content {
    --bg-opacity: 1;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 16px;
    position: relative;
}

.hot-jobs-card-content-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 20px;
    line-height: 24px;
}

.hot-jobs-card-content-title:after {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: -140px;
}

.hot-jobs-card-content-location {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 16px;
    line-height: 14px;
}

.hot-jobs-card-content-salary {
    align-self: end;
    margin-top: auto;
}

.hot-jobs-card-content-salary .call-details-link {
    position: relative;
    z-index: 1;
}

.hot-jobs-card-content-salary-content {
    --text-opacity: 1;
    color: #1e7721;
    color: rgba(30,119,33,var(--text-opacity));
   
    font-size: 20px;
    line-height: 14px;
}

.hot-jobs-card .favorite-button {
    right: 8px;
    top: 8px;
}

.hot-jobs-card .favorite-button svg .stroke {
    fill: #fff;
}

@media (min-width: 1366px) {
    .hot-jobs-card {
        margin:0;
    }
}

.map-tile-map {
    border-radius: 7px;
    height: 290px;
    width: 100%;
}

@media (min-width: 768px) {
    .map-tile-map {
        height:450px;
        width: 400px;
    }
}

.job-details-title {
    font-size: 26px;
}

@media (min-width: 1200px) {
    .job-details-title {
        font-size:38px;
    }
}

.job-details-body-disclaimer p {
    font-size: 14px;
    font-style: italic;
    line-height: 22px;
    text-align: left;
}

.job-details-hero {
    height: 170px;
    overflow: hidden;
    width: 100%;
}

.job-details-hero img {
    height: auto;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

@media (min-width: 1200px) {
    .job-details-hero {
        height:190px;
    }
}

.job-details-sidebar {
    align-self: flex-start;
    border: 2px solid #ddd;
    min-width: 390px;
}

.job-details-sidebar,.job-details-slide-nav {
    position: sticky;
    top: 51px;
}

.job-details-slide-nav {
    border-bottom: 1px solid #ddd;
    border-top: 2px solid #ddd;
    z-index: 1;
}

.job-details-slide-nav-item,.job-details-slide-nav-item--active {
    margin-right: 24px;
    padding-bottom: 8px;
    padding-left: 12px;
    padding-right: 12px;
}

.job-details-slide-nav-item--active {
    --text-opacity: 1;
    border-bottom: 5px solid #2257b8;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

@media (hover: hover) {
    .job-details-slide-nav-item:hover {
        --text-opacity:1;
        color: #2257b8;
        color: rgba(34,87,184,var(--text-opacity));
    }
}

.job-details-slide-nav-item button {
    height: 100%;
    width: 100%;
}

.job-details-mobile-apply {
    border: 1px solid #ddd;
    z-index: 999;
}

.job-details .icon-style {
    transform: translateY(3px);
}

.job-details .icon-style svg {
    height: 16px;
    width: 16px;
}

.job-details .icon-style svg .stroke {
    fill: #2257b8;
}

.job-details .favorite-button {
    position: static;
}

.job-details .favorite-button i,.job-details .favorite-button svg {
    height: 18.35px;
    width: 20px;
}

.job-details .favorite-button i .stroke,.job-details .favorite-button svg .stroke {
    fill: #2257b8;
}

.job-details .sticker {
    border-radius: 3px;
}

.nav-article {
    border-top: 1px solid #ddd;
}

.nav-article ul {
    list-style: disc none outside;
    list-style: initial;
    padding-left: 28px;
}

.job-cart-item {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    align-items: flex-start;
    border-top: 1px solid #ccc;
    justify-content: space-between;
}

.job-cart-item-img {
    max-height: 90px;
    min-width: 120px;
    object-fit: cover;
    width: 120px;
}

.job-cart-item-details {
    max-width: 54%;
    width: 54%;
}

.job-cart-item-details .job-link {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    display: inline-block;
   
    font-size: 16px;
    line-height: 22px;
    line-height: 18px;
}

.job-cart-item-details .job-link img {
    object-fit: cover;
}

.job-cart-item-details .job-link:after {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}

.job-cart-item-details p {
    line-height: 1;
}

.job-cart-item-remove {
    height: 24px;
    padding: 4px;
    width: 24px;
    z-index: 3;
}

.job-cart-item-remove svg {
    height: 12px;
    width: 12px;
}

.job-cart-alert {
    background-color: #fff;
    border: solid #c4cace;
    border-radius: 3px;
    box-shadow: 0 0 6px rgba(0,0,0,0.12157);
    left: 0;
    padding: 20px;
    position: fixed;
    top: 88px;
    width: 100%;
}

.job-cart-alert .job-cart-alert-text {
    font-size: 18px;
    font-weight: 700;
}

.job-cart-alert a,.job-cart-alert button {
    margin-top: 15px;
    padding: 0 1rem;
    width: 100%;
}

@media (max-width: 767px) {
    .job-cart-alert button {
        margin-bottom:25px;
    }
}

.job-cart-alert .arrow-up {
    border-bottom: 15px solid #fff;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    height: 0;
    right: 98px;
    top: -14px;
    width: 0;
    z-index: 2;
}

@media (min-width: 768px) {
    .job-cart-alert .arrow-up {
        right:37%;
    }
}

.job-cart-alert .arrow-up-border {
    border-bottom: 15px solid #c4cace;
    top: -18px;
    z-index: 1;
}

@media (min-width: 768px) {
    .job-cart-alert {
        border-radius:3px;
        left: -250%;
        padding: 15px;
        position: absolute;
        top: 116%;
        width: 220px;
    }

    .job-cart-alert button.job-cart-alert-dismiss {
        margin: unset;
        margin-top: 20px;
        width: unset;
    }
}

@media (min-width: 1366px) {
    .job-cart-alert {
        border-radius:3px;
        left: unset;
        padding: 15px;
        position: absolute;
        right: 10%;
        top: 145%;
        width: 225px;
    }
}

.job-cart-alert button.job-cart-alert-dismiss {
    cursor: pointer;
    height: 12.5px;
    right: 16px;
    top: 8px;
    width: 12.5px;
    z-index: 1;
}

.job-cart-alert button.job-cart-alert-dismiss svg {
    fill: #75787b;
    height: 12.5px;
    width: 12.5px;
}

.job-cart-count-0 {
    display: none;
}

.job-cart {
    align-items: center;
    display: flex;
    height: 100%;
}

@media (min-width: 1366px) {
    .job-cart {
        padding-right:32px;
    }
}

@media (max-width: 1365px) {
    .job-cart-apply-btn {
        display:inline !important;
        font-size: 14px;
        height: 40px;
        line-height: 1;
        max-width: 100px;
        min-width: 128px;
        padding: 12px 10px;
        text-align: center;
    }
}

.job-cart-trigger.open {
    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);
}

.job-cart-trigger svg {
    height: 30px;
    width: 32.86px;
}

.job-cart-trigger svg .stroke {
    fill: #d00;
}

.job-cart-trigger-badge svg .stroke {
    fill: #2257b8;
}

.job-cart-trigger-count {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    left: 50%;
    top: 55%;
    transform: translate(-50%,-60%);
}

.job-cart-trigger-count.open {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.job-cart-text {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.job-cart-chevron svg .stroke {
    fill: #2257b8;
}

.job-cart-summary {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 10px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);
    left: -242px;
    max-width: 500px;
    min-width: 375px;
    top: 45px;
    z-index: 9;
}

.job-cart-summary-footer {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    border-top: 1px solid #ccc;
    justify-content: space-between;
}

.job-cart-list {
    list-style: none;
    max-height: 336px;
    overflow-y: auto;
    padding: 0;
}

@media (min-width: 1366px) {
    .job-cart {
        position:relative;
    }

    .job-cart-trigger-count {
        left: 40%;
    }

    .job-cart-summary {
        left: auto;
        right: 0;
        top: 45px;
        width: 450px;
    }
}

.section-container {
    padding-top: 24px;
}

@media (min-width: 1366px) {
    .section-container {
        padding-top:32px;
    }
}

.section-wrapper {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}

.recently-viewed {
    animation-duration: 2s;
    animation-iteration-count: 1;
    animation-name: opacity0to1;
    animation-timing-function: linear;
}

.recently-viewed .result-card {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.10196);
    height: auto;
    max-width: 452px;
}

@media (min-width: 768px) {
    .recently-viewed .result-card {
        height:193px;
        margin-left: 8px;
        margin-right: 8px;
        width: 304px;
    }
}

@media (min-width: 1366px) {
    .recently-viewed .result-card {
        height:auto;
        margin-left: 16px;
        margin-right: 16px;
        width: 400px;
    }
}

.recently-viewed .title {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
}

@media (min-width: 768px) {
    .recently-viewed .title {
        font-size:34px;
        line-height: 40px;
        margin-bottom: 32px;
    }
}

@media (min-width: 1366px) {
    .recently-viewed .title {
        font-size:42px;
        line-height: 56px;
        line-height: 68px;
    }
}

.recently-viewed ul {
    padding: unset;
}

.recently-viewed .mobile-swiper-slide {
    margin-left: 0;
    margin-right: 0;
}

.recently-viewed .result-card-img {
    height: 100%;
    width: 88px;
}

@media (min-width: 768px) {
    .recently-viewed .result-card-img {
        width:72px;
    }
}

@media (min-width: 1366px) {
    .recently-viewed .result-card-img {
        width:88px;
    }
}

.recently-viewed .dot-navigation {
    margin-bottom: 32px;
    margin-top: 24px;
}

.recently-viewed .sticker {
   
    opacity: 1;
}

@media (min-width: 768px) {
    .recently-viewed .sticker {
        font-size:10px;
        padding-bottom: 4px;
        padding-top: 4px;
    }
}

@media (min-width: 1366px) {
    .recently-viewed .sticker {
        font-size:12px;
        line-height: 16px;
    }
}

.recently-viewed .result-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: calc(100% - 16px);
}

.recently-viewed .result-card-content-title {
   
    margin: 0;
}

@media (min-width: 768px) {
    .recently-viewed .result-card-content-title {
        font-size:18px;
        line-height: 20px;
        margin: 0;
    }
}

@media (min-width: 1366px) {
    .recently-viewed .result-card-content-title {
        font-size:20px;
        line-height: 24px;
    }
}

.recently-viewed .salary {
    font-size: 20px;
    line-height: 28px;
}

@media (min-width: 768px) {
    .recently-viewed .salary {
        font-size:24px;
        line-height: 30px;
    }
}

@media (min-width: 1366px) {
    .recently-viewed .salary {
        font-size:20px;
        line-height: 28px;
    }
}

.recently-viewed .weekly {
    --text-opacity: 1;
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
   
}

.recently-viewed .result-card-content-location {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    line-height: 24px;
}

@media (min-width: 768px) {
    .recently-viewed .result-card-content-location {
        font-size:14px;
        line-height: 22px;
        margin: 0;
    }
}

.recently-viewed .result-card-content-details {
    --text-opacity: 1;
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    font-size: 12px;
    line-height: 16px;
    width: 100%;
}

.recently-viewed .result-card-content-details span {
    font-weight: 400;
}

.recently-viewed .card-content-box {
    left: -40px;
    margin-left: 16px;
    margin-right: 16px;
    padding-bottom: 16px;
    padding-top: 16px;
    position: relative;
    width: 248px;
}

@media (min-width: 768px) {
    .recently-viewed .card-content-box {
        left:-32px;
        margin-left: 0;
        margin-right: 8px;
        padding-left: 8px;
        width: 224px;
    }
}

@media (min-width: 1366px) {
    .recently-viewed .card-content-box {
        left:-16px;
        margin-right: 0;
        padding-left: 16px;
        width: 296px;
    }

    .recently-viewed .card-content-box-locum {
        left: 0;
    }
}

.recently-viewed .favorite-button {
    margin-right: 16px;
    margin-top: 16px;
    right: 0;
    top: 0;
}

@media (min-width: 768px) {
    .recently-viewed .favorite-button {
        margin-right:16px;
    }
}

.recently-viewed .favorite-button svg {
    height: 24px;
    margin: 0;
    width: 24px;
}

.recently-viewed .favorite-button svg .stroke {
    fill: #002146;
}

.recently-viewed .favorite-button:not(.full) {
    height: 24px;
    width: 24px;
}

.recently-viewed .result-card-content-critical p {
   
    font-size: 12px;
    line-height: 16px;
}

.recently-viewed .bottom-wrapper {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    height: 100%;
    justify-content: flex-end;
}

.favorite-modal-body,.recently-viewed .bottom-wrapper {
    display: flex;
    flex-direction: column;
}

.favorite-modal-body {
    background: #fff;
    border: 1px solid #f5f6f8;
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.25098);
    float: left;
    left: 50%;
    max-width: 335px;
    opacity: 1;
    position: fixed;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 95%;
}

.favorite-modal-body .favorite-modal-content {
    padding: 30px;
}

.favorite-modal-body .favorite-modal-content-details {
    float: left;
    max-width: 65%;
    padding-left: 20px;
}

.favorite-modal-body img {
    border-radius: 4px;
    float: left;
    margin-bottom: 15px;
    max-height: 90px;
}

.favorite-modal-body a,.favorite-modal-body button {
    margin-top: 15px;
    width: 100%;
}

@media (min-width: 768px) {
    .favorite-modal-body {
        max-width:480px;
    }

    .favorite-modal-body img {
        max-height: 90px;
    }
}

button.job-cart-alert-dismiss {
    right: 20px;
    top: 1px;
    width: 12.5px;
}

button.job-cart-alert-dismiss svg {
    fill: #75787b;
}

.favorite-modal-overlay {
    background-color: #000;
    bottom: 0;
    left: 0;
    opacity: 0.25;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 0.2s;
}

.overlay .cancel {
    cursor: default;
    height: 100%;
    position: absolute;
    width: 100%;
}

.overlay:target {
    opacity: 1;
    visibility: visible;
}

.callout {
    margin: 0 auto;
    max-width: 384px;
    padding-bottom: 16px;
}

@media (min-width: 768px) {
    .callout {
        margin:initial;
        max-width: none;
    }
}

.callout-img {
    height: 160px;
    margin: 16px auto;
    width: 160px;
}

.callout-img img,.callout-img svg {
    height: 100%;
    object-fit: contain;
    width: 100%;
}

@media (min-width: 1366px) {
    .callout-img {
        height:136px;
        margin-bottom: 16px;
        width: 136px;
    }

    .callout--left .callout-img {
        margin-left: 0;
        margin-right: 0;
    }
}

.callout-heading {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
    text-align: center;
}

@media (min-width: 1366px) {
    .callout--left .callout-heading {
        text-align:left;
    }
}

.callout-content {
    padding-bottom: 16px;
    padding-left: 8px;
    padding-right: 8px;
    text-align: left;
    text-align: center;
}

@media (min-width: 1366px) {
    .callout--left .callout-content {
        text-align:left;
    }
}

.callout-content p,.callout-cta {
    text-align: center;
}

.callout-cta {
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
}

@media (min-width: 1366px) {
    .callout--left .callout-cta {
        margin-left:0;
        margin-right: auto;
        text-align: left;
    }
}

.callout-row-subtitle p {
    text-align: center;
}

.callout-row-bg .background,.callout-row-bg .background img,.callout-row-bg img {
    height: 100%;
    width: 100%;
}

.callout-row div.cta-primary-medium {
    margin-bottom: 32px;
    padding: 0;
}

@media (min-width: 768px) {
    .callout-row div.cta-primary-medium {
        margin-bottom:0;
    }
}

@media (min-width: 1366px) {
    .callout-row div.cta-primary-medium {
        margin-bottom:8px;
    }
}

.callout-row ul {
    padding-left: 0;
}

.callout-row .cta-text {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
}

.callout-row .statistics-callout-item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -ms-flex-item-align: center;
    align-items: center;
    align-self: center;
    border-radius: 100%;
    display: flex;
    flex-direction: column;
    height: 320px;
    justify-content: center;
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
    width: 320px;
}

@media (min-width: 768px) {
    .callout-row .statistics-callout-item {
        margin-bottom:0;
    }
}

@media (min-width: 1366px) {
    .callout-row .statistics-callout-item {
        -webkit-box-pack:center;
        -ms-flex-pack: center;
        grid-column: unset;
        height: 320px;
        justify-content: center;
        width: 320px;
    }
}

.callout-row .statistics-callout-item .item-contents {
    align-items: center;
    display: flex;
    flex-direction: column;
}

@media (min-width: 1366px) {
    .callout-row .statistics-callout-item .item-contents {
        padding-left:20px;
        padding-right: 20px;
    }
}

.callout-row .statistics-callout-item p {
    color: #005bbb;
    text-align: center;
}

.callout-row .statistics-callout-item .icon-img {
    height: auto;
    max-width: 100px;
    padding-bottom: 8px;
}

.callout-row .statistics-callout-item .icon-img img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.callout-row .statistics-callout-item .title {
   
    font-size: 42px;
    line-height: 62px;
}

@media (min-width: 1366px) {
    .callout-row .statistics-callout-item .title {
        font-size:46px;
        line-height: 68px;
    }
}

.callout-row .statistics-callout-item .description {
   
    font-size: 14px;
    line-height: 20px;
}

@media (min-width: 768px) {
    .callout-row .statistics-callout-item .description {
        padding-left:20px;
        padding-right: 20px;
    }
}

@media (min-width: 1366px) {
    .callout-row .statistics-callout-item .description {
        font-size:16px;
        line-height: 24px;
    }
}

.generic-row-wrapper {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    max-width: unset !important;
}

@media (min-width: 1366px) {
    .generic-row-wrapper {
        grid-template-columns:repeat(12,minmax(0,1fr));
    }
}

.generic-row-wrapper .generic-row {
    grid-gap: 16px;
    grid-row-gap: 24px;
    display: grid;
    gap: 16px;
    grid-column: span 6 / span 6;
    grid-template-columns: repeat(6,minmax(0,1fr));
    row-gap: 24px;
}

@media (min-width: 1366px) {
    .generic-row-wrapper .generic-row {
        grid-row-gap:16px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        grid-auto-flow: column;
        grid-column: span 12 / span 12;
        grid-template-columns: unset;
        justify-content: center;
        row-gap: 16px;
    }
}

.generic-row-wrapper .generic-row .callout-item {
    grid-column: span 3 / span 3;
}

.generic-row-wrapper .generic-row .callout-item .statistics-callout-item {
    height: unset;
    margin-left: auto;
    margin-right: auto;
    width: unset;
}

@media (max-width: 767px) {
    .generic-row-wrapper .generic-row .callout-item .statistics-callout-item {
        background-color:unset !important;
    }
}

@media (min-width: 768px) {
    .generic-row-wrapper .generic-row .callout-item .statistics-callout-item {
        height:320px;
        width: 320px;
    }
}

@media (min-width: 1366px) {
    .callout-row .callout-row-wrapper {
        -webkit-box-pack:center;
        -ms-flex-pack: center;
        grid-gap: 8px;
        display: flex;
        flex-wrap: wrap;
        grid-template-columns: unset;
        justify-content: center;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item {
        flex: unset;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2) ~ .mobile-swiper-item {
        margin-left: 0;
        margin-right: 0;
        width: 49%;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3) ~ .mobile-swiper-item {
        margin-left: 0;
        margin-right: 0;
        width: 32%;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4) ~ .mobile-swiper-item {
        margin-left: 0;
        margin-right: 0;
        width: 24%;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5) ~ .mobile-swiper-item {
        margin-left: 0;
        margin-right: 0;
        width: 32%;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6) ~ .mobile-swiper-item {
        margin-left: 0;
        margin-right: 0;
        width: 32%;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7) ~ .mobile-swiper-item {
        margin-left: 0;
        margin-right: 0;
        width: 24%;
    }

    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8) ~ .mobile-swiper-item {
        margin-left: 0;
        margin-right: 0;
        width: 24%;
    }
}

@media (min-width: 1366px) and (min-width:1366px) {
    .callout-row {
        grid-gap:16px;
        gap: 16px;
    }

    .callout-row .callout--left .callout-content {
        padding-left: 0;
        padding-right: 0;
    }

    .callout-row .callout--left .callout-content .rich-text p {
        text-align: left !important;
    }

    .callout-row .callout--left .callout-contentp {
        text-align: left;
    }

    .callout-row .callout--left .callout-cta {
        margin-left: 0;
        text-align: left;
    }
}

.cardGridBlockSearch {
    --bg-opacity: 1;
    background-color: #f9f9f9;
    background-color: rgba(249,249,249,var(--bg-opacity));
    padding-top: 20px;
    text-align: center;
    z-index: 1;
}

.cardGridBlockSearchwrapper {
    display: block;
    position: relative;
}

.cardGridBlockSearch-header {
    --bg-opacity: 1;
    background-color: #f9f9f9;
    background-color: rgba(249,249,249,var(--bg-opacity));
    color: #0b2c57;
   
    font-size: 22px;
    line-height: 28px;
    text-align: center;
}

@media (min-width: 768px) {
    .cardGridBlockSearch-header {
        font-size:28px;
        line-height: 56px;
    }
}

@media (min-width: 1200px) {
    .cardGridBlockSearch-header {
        font-size:42px;
        line-height: 56px;
    }
}

.cardGridBlockSearch-icon {
    margin-left: 20px;
    margin-top: 20px;
    position: absolute;
}

.cardGridBlockSearch-icon svg {
    fill: #2257b8;
    height: 18px;
    width: 17px;
}

@media (min-width: 1200px) {
    .cardGridBlockSearch-icon svg {
        height:22px;
        width: 21px;
    }
}

.cardGridBlockSearch .advancedSearchTextbox {
    background: #fff 0 0 no-repeat padding-box;
    border: 1px solid #c6c6c6;
    border-radius: 40px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.07843);
    color: #000;
    height: 54px;
    opacity: 1;
    padding-left: 40px;
    width: 335px;
}

@media (min-width: 768px) {
    .cardGridBlockSearch .advancedSearchTextbox {
        width:600px;
    }
}

@media (min-width: 1200px) {
    .cardGridBlockSearch .advancedSearchTextbox {
        height:60px;
        padding-left: 50px;
        width: 768px;
    }
}

.cardGridBlockSearch .searchButton {
    background: transparent;
    border: none;
    margin-right: 12px;
    opacity: 0;
    outline: none;
}

.cardGridBlockSearch .searchButton img {
    height: 22px;
    object-fit: cover;
    width: 22px;
}

.card-carousel {
    --n: 1;
    --i: 0;
    --u: 4;
    --neg: -100%;
    --mobile-peek: 65px;
    align-items: center;
    margin: 0 auto;
    position: relative;
}

.card-carousel,.card-carousel-container {
    display: flex;
    width: 100%;
}

.card-carousel-container {
    overflow: hidden;
    transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--mobile-peek)));
    transition: transform 0.5s ease-out;
    width: calc(var(--n) * 100%);
}

@media (min-width: 768px) {
    .card-carousel-container {
        transform: translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));
    }
}

.card-carousel-container.paged {
    transform: translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));
}

.card-carousel .smooth {
    transition: transform calc(var(--f) * 0.5s) ease-out;
}

.card-carousel-mask {
    overflow-x: hidden;
}

.card-carousel-mask ul {
    list-style: none;
    padding-left: 0;
}

.card-carousel-slide {
    width: 100%;
    width: calc(100% / var(--n) - var(--mobile-peek));
}

@media (min-width: 768px) {
    .card-carousel-slide {
        width:calc(100% / var(--n) / var(--u) + 1px);
    }
}

.card-carousel-slide.paged {
    width: calc(100% / var(--n) / var(--u) + 1px);
}

.card-carousel-btn {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    display: none;
}

@media (min-width: 768px) {
    .card-carousel-btn {
        border-radius:100%;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16078);
        display: block;
        height: 30px;
        min-width: 30px;
        position: absolute;
        right: 12px;
        top: calc(50% - 30px);
        width: 30px;
        z-index: 2;
    }

    .card-carousel-btn svg {
        fill: #d00;
        height: 100%;
        width: 100%;
    }
}

.card-carousel-btn.prev {
    left: 12px;
    margin-right: 24px;
}

.card-carousel-btn.next svg {
    transform: rotate(180deg);
}

.carousel {
    --n: 1;
    --i: 0;
    --neg: -100%;
    margin: 0 auto;
    position: relative;
    width: 100%;
}

.carousel-container {
    align-items: center;
    display: flex;
    overflow-y: hidden;
    transform: translate(calc(var(--i) / var(--n) * var(--neg)));
    transition: transform 0.5s ease-out;
    width: 100%;
    width: calc(var(--n) * 100%);
}

.carousel-mask {
    overflow-x: hidden;
    padding-bottom: 4px;
}

.carousel-button {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    border: 1px solid #707070;
    border-radius: 100%;
    bottom: -65px;
    display: flex;
    height: 65px;
    justify-content: center;
    position: absolute;
    width: 65px;
}

.carousel-button svg {
    fill: #707070;
    height: 65px;
    width: 65px;
}

.carousel-button--prev {
    left: calc(50% - 129px);
}

.carousel-button--next {
    left: calc(50% + 20px);
}

.carousel-counter {
    bottom: -48.75px;
    left: calc(50% - 44px);
    position: absolute;
    text-align: center;
    width: 44px;
}

.carousel-slide {
    display: block;
    height: 100%;
    width: 100%;
    width: calc(100% / var(--n));
}

.carousel-slide > div {
    margin: 0 auto;
}

.carousel .dot-navigation {
    margin-top: 32px;
}

.cutout-block {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
}

.cutout-block-mask {
    overflow-x: hidden;
    width: 100%;
}

@media (min-width: 768px) {
    .cutout-block-mask {
        overflow-x:visible;
        width: 768px;
    }
}

@media (min-width: 1366px) {
    .cutout-block-mask {
        width:908px;
    }
}

.cutout-block .mobile-swiper {
    overflow-x: unset;
}

@media (min-width: 768px) {
    .cutout-block .mobile-swiper {
        min-height:593px;
    }
}

.cutout-block .mobile-swiper-item {
    height: 100%;
    margin: 0;
}

.cutout-block .mobile-swiper-slide {
    margin: 0;
    overflow: visible;
}

.cutout-block .mobile-swiper-container {
    overflow-x: hidden;
}

@media (min-width: 768px) {
    .cutout-block .mobile-swiper-container {
        overflow:visible;
    }
}

.cutout-block .cutout-slide {
    background-color: transparent;
    height: 100%;
    margin-bottom: 100px;
    margin-top: 100px;
}

@media (min-width: 1366px) {
    .cutout-block .cutout-slide {
        padding-left:64px;
        padding-right: 64px;
    }
}

.cutout-block .cutout-slide q:before {
    content: "";
    display: none;
}

.cutout-block .cutout-slide q:after {
    content: "";
    display: none;
}

.cutout-block .cutout-slide-mask {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 13px 39px rgba(0,0,0,0.16078);
    display: flex;
    height: 395px;
    justify-content: flex-end;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 56px;
    padding-left: 24px;
    padding-top: 56px;
    position: relative;
    width: 95%;
}

@media (min-width: 768px) {
    .cutout-block .cutout-slide-mask {
        padding-left:24px;
        padding-right: 24px;
        width: 668px;
    }
}

@media (min-width: 1366px) {
    .cutout-block .cutout-slide-mask {
        padding:64px;
        width: 880px;
    }
}

.cutout-block .cutout-slide-mask .cutout-slide-media {
    bottom: 0;
    height: 85%;
    left: 56%;
    position: absolute;
    width: auto;
}

@media (min-width: 768px) {
    .cutout-block .cutout-slide-mask .cutout-slide-media {
        height:342px;
        left: unset;
        right: 0;
        width: 310px;
    }
}

@media (min-width: 1366px) {
    .cutout-block .cutout-slide-mask .cutout-slide-media {
        height:442px;
        width: 410px;
    }
}

.cutout-block .cutout-slide-mask .cutout-slide-media img {
    border-bottom-right-radius: 8px;
    height: 100%;
    object-fit: cover;
    object-position: left;
    width: 100%;
}

.cutout-block .cutout-slide-mask .cutout-slide-content {
    max-width: 60%;
}

@media (min-width: 768px) {
    .cutout-block .cutout-slide-mask .cutout-slide-content {
        max-width:55%;
    }
}

@media (min-width: 1366px) {
    .cutout-block .cutout-slide-mask .cutout-slide-content {
        max-width:419px;
    }
}

.cutout-block .cutout-slide-mask .cutout-slide-content h6 {
    color: #003c69;
    line-height: 24px;
    margin-bottom: 16px;
}

@media (min-width: 768px) {
    .cutout-block .cutout-slide-mask .cutout-slide-content h6 {
        line-height:36px;
    }
}

.cutout-block .cutout-slide-mask .cutout-quote-citation {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-style: normal;
    line-height: 24px;
    margin-bottom: 16px;
    margin-top: 16px;
}

.cutout-block .cutout-slide-mask .cutout-quote-citation-name {
    color: #005bbb;
   
    font-weight: 700;
}

.cutout-block .cutout-slide-mask button {
    margin-top: 24px;
}

.cutout-block .swiper-buttons {
    bottom: 0;
    display: block;
    height: 60px;
    left: 50%;
    margin-left: -77px;
    top: unset;
    width: 144px;
}

.cutout-block .swiper-buttons-backwards {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 2px solid #0098db;
    height: 60px;
    margin-bottom: 0;
    width: 60px;
}

.cutout-block .swiper-buttons-backwards i {
    display: none;
}

.cutout-block .swiper-buttons-forwards {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 2px solid #0098db;
    height: 60px;
    margin-bottom: 0;
    width: 60px;
}

.cutout-block .dot-navigation,.cutout-block .swiper-buttons-forwards i {
    display: none;
}

.image-carousel {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 120px;
}

.image-carousel-title {
    font-size: 40px;
    line-height: 44px;
    line-height: 52px;
    margin-bottom: 24px;
}

@media (min-width: 768px) {
    .image-carousel-title {
        margin-bottom:32px;
    }
}

.image-carousel-mask {
    position: relative;
}

.image-carousel-mask .card-carousel-btn {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 1px solid #0098db;
    border-radius: 100%;
    bottom: -80px;
    box-shadow: none;
    display: block;
    height: 60px;
    margin-bottom: 0;
    position: absolute;
    top: unset;
    width: 60px;
    z-index: 1;
}

@media (min-width: 768px) {
    .image-carousel-mask .card-carousel-btn {
        bottom:-100px;
    }
}

.image-carousel-mask .card-carousel-btn .stroke,.image-carousel-mask .card-carousel-btn svg {
    fill: #003c69;
    height: 100%;
    width: 100%;
}

.image-carousel-mask .card-carousel-btn.next {
    left: 50%;
}

.image-carousel-mask .card-carousel-btn.prev {
    left: unset;
    right: 50%;
}

.image-carousel-mask .card-carousel-slide .image-slide-mask {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
    padding-left: 16px;
    padding-right: 16px;
}

.category-block {
    --bg-opacity: 1;
    background-color: #f9f9f9;
    background-color: rgba(249,249,249,var(--bg-opacity));
}

@media (min-width: 1200px) {
    .category-block {
        padding:50px 0;
    }
}

.category-block-wrapper {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.category-block-entries {
    grid-gap: 28px;
    display: grid;
    grid-template-columns: 100%;
}

@media (min-width: 1200px) {
    .category-block-entries {
        -webkit-box-pack:center;
        -ms-flex-pack: center;
        grid-template-columns: repeat(auto-fit,420px);
        justify-content: center;
    }
}

.category-block-entry {
    -ms-flex-pack: distribute;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0,0,0,0.05098);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 38px 28px 20px;
    position: relative;
    width: 100%;
}

@media (min-width: 1200px) {
    .category-block-entry {
        padding:32px 28px 16px;
        width: 420px;
    }
}

.category-block-entry.tag2 .category-block-entry-tags-tag2,.category-block-entry.tag .category-block-entry-tags-tag {
    display: block;
}

.category-block-entry-tags {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    display: flex;
    justify-content: space-between;
    left: 0;
    padding-left: 24px;
    padding-right: 24px;
    position: absolute;
    top: 0;
    width: 100%;
}

.category-block-entry-tags-tag,.category-block-entry-tags-tag2 {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 4px 8px;
}

.category-block-entry-tags-tag-color {
    background-color: rgba(132,196,52,0.2);
}

.category-block-entry-tags-tag p {
    color: #1e7721;
}

.category-block-entry-tags-tag2 {
    background-color: #1e7721;
}

.category-block-entry-tags-tag2 p {
    color: #fff;
}

.category-block-entry-content {
    display: flex;
    flex-direction: column;
}

.category-block-entry-content p {
    padding-bottom: 4px;
}

@media (min-width: 1200px) {
    .category-block-entry-content p {
        padding-bottom:8px;
    }
}

.category-block-entry-content-title {
    font-size: 32px;
    line-height: 38px;
}

.category-block-entry-content-row {
    align-items: flex-end;
    display: flex;
    flex-direction: row;
}

.category-block-entry-content-row-primary {
    color: #1e7721;
}

.category-block-entry-content-row-secondary {
    padding-bottom: 10px !important;
    padding-left: 8px;
}

.category-block-entry-links {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    display: flex;
    justify-content: space-between;
}

.category-block-dropdown .category-block-dropdown-summary:after {
    font-size: 54px;
    left: 0;
}

.category-block-dropdown {
    border-bottom: 1px solid rgba(68,68,68,0.15);
    outline: none;
}

@media (min-width: 1200px) {
    .category-block-dropdown {
        border:none;
    }
}

.category-block-dropdown summary {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    list-style-type: none;
    outline: none;
    padding-right: 40px;
    pointer-events: none;
    position: relative;
}

.category-block-dropdown summary-title,.category-block-dropdown summary p {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    margin-bottom: 8px;
    padding-left: 8px;
}

@media (min-width: 1200px) {
    .category-block-dropdown summary-title,.category-block-dropdown summary p {
        --text-opacity:1;
        color: #2257b8;
        color: rgba(34,87,184,var(--text-opacity));
        margin-bottom: 24px;
    }
}

.category-block-dropdown summary::marker {
    display: none;
}

.category-block-dropdown summary::-webkit-details-marker {
    display: none;
}

.css-zy4qjm.webchat__send-box-text-box .webchat__send-box-text-box__input,.css-zy4qjm.webchat__send-box-text-box .webchat__send-box-text-box__text-area-box,[data-css-zy4qjm].webchat__send-box-text-box .webchat__send-box-text-box__input,[data-css-zy4qjm].webchat__send-box-text-box .webchat__send-box-text-box__text-area-box {
    flex: 1 1;
}

.css-zy4qjm.webchat__send-box-text-box,[data-css-zy4qjm].webchat__send-box-text-box {
    display: flex;
}

.css-1fe8kfc,[data-css-1fe8kfc] {
    flex: 10000 1;
}

.css-eycyw2 > .main,[data-css-eycyw2] > .main {
    align-items: stretch;
    background-color: #fff;
    border-top: 1px solid #e6e6e6;
    min-height: 40px;
}

.css-1882x3w > .main,.css-ca0rlf,[data-css-1882x3w] > .main,[data-css-ca0rlf] {
    display: flex;
}

.css-ca0rlf,[data-css-ca0rlf] {
    flex-direction: column;
}

.css-y1c0xs,[data-css-y1c0xs] {
    height: 100%;
    overflow-y: auto;
    width: 100%;
}

.css-mfy564,[data-css-mfy564] {
    flex: 1 1;
}

.css-gtdio3,[data-css-gtdio3] {
    overflow: hidden;
    position: relative;
}

.css-13t1vy4,[data-css-13t1vy4] {
    background-color: #fff;
    height: 100%;
    width: 100%;
    z-index: 0;
}

.css-1t62idy,[data-css-1t62idy] {
    display: flex;
    flex-direction: column;
}

.css-9ohtah,[data-css-9ohtah] {
    color: transparent;
    height: 1px;
    overflow: hidden;
    position: absolute;
    top: 0;
    white-space: nowrap;
    width: 1px;
}

.chat-opener {
    align-items: center;
    border-radius: 100%;
    bottom: 25px;
    box-shadow: 0 4px 12px #bcbcbc;
    color: #fff;
    flex-direction: column;
    font-size: 16px;
    font-weight: 700;
    padding: 18px;
    position: fixed;
    right: 15px;
    text-align: center;
    width: 75px;
    z-index: 99;
}

.chat-opener svg {
    filter: drop-shadow(0 3px 6px rgba(0,61,93,0.48627));
}

.chat-opener.active {
    display: flex;
}

.chat-opener a {
    color: #fff;
    display: block;
    margin-bottom: -4px;
}

.chat-opener a img.avatar {
    border-radius: 100%;
    width: 60px;
}

.chat-opener .bottip {
    background-color: #222;
    border-radius: 3px;
    color: #fff;
    font-size: 12px;
    padding: 6px 10px;
    position: absolute;
    right: 75px;
    top: 20px;
    white-space: nowrap;
}

.chat-opener-message {
    background: #f8f8f8;
    border: 1px solid rgba(117,120,123,0.15);
    border-radius: 10px;
    bottom: 40px;
    box-shadow: 0 4px 12px #bcbcbc;
    color: #050f38;
   
    max-width: 300px;
    padding: 9px 40px 11px 14px;
    position: fixed;
    right: 100px;
    z-index: 99;
}

.chat-opener-message-dismiss {
    position: absolute;
    right: 9px;
    top: 10px;
}

.chat-opener-message svg .stroke {
    fill: #868686;
}

.chat-window {
    background-color: #fff;
    bottom: 0;
    box-shadow: 0 0 12px #000;
    max-width: 380px;
    padding: 0;
    position: fixed;
    right: 0;
    width: 380px;
    width: 100%;
    z-index: 99;
}

.chat-window,.chat-window .heading {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.chat-window .heading {
    background-color: #222;
    color: #fff;
    display: flex;
    font-size: 18px;
    padding: 8px 5px 5px 12px;
    position: relative;
}

.chat-window .heading svg,.chat-window .heading svg .stroke {
    fill: #fff;
}

.chat-window .chatTitle {
    flex-grow: 1;
}

.chat-window .heading a {
    color: #fff;
    display: inline-block;
    padding: 0 5px;
}

.chat-window #bot {
    height: 80vh;
    padding-bottom: 8px;
    position: relative;
}

.chat-window #bot .wc-textbox {
    left: 5px;
}

.chat-window #bot .wc-header {
    display: none;
}

.chat-window #bot .wc-adaptive-card {
    width: auto;
}

.chat-window #bot .wc-message-groups {
    top: 0;
}

.chat-window #bot .main {
    padding-top: 0;
}

.chat-window #bot a {
    color: #0977a9;
}

.css-bo8nme {
    overflow: visible;
}

.css-1g3yky9 {
    margin-top: 10px;
}

.ac-pushButton > div {
    white-space: normal !important;
}

@media (min-width: 768px) {
    .dropdown-cta .title {
        line-height:46px;
    }
}

@media (min-width: 1366px) {
    .dropdown-cta .title {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
    
        font-size: 32px;
        line-height: 36px;
    }
}

@media (min-width: 1366px) and (min-width:1366px) {
    .dropdown-cta .title {
        font-size:48px;
        line-height: 52px;
    }
}

.dropdown-cta-top {
    display: flex;
    flex-direction: column;
}

@media (min-width: 1200px) {
    .dropdown-cta-top {
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        flex-direction: row;
        justify-content: space-between;
    }
}

.dropdown-cta-top-dropdown {
    position: relative;
    width: 100%;
}

@media (min-width: 1200px) {
    .dropdown-cta-top-dropdown {
        max-width:400px;
    }
}

.dropdown-cta-top-dropdown select {
    --text-opacity: 1;
    appearance: none;
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 18px;
    height: 56px;
    line-height: 20px;
    line-height: 17px;
    width: 100%;
}

.dropdown-cta-top-dropdown:after {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    content: "â€º";
    font-size: 35px;
    height: 34px;
    pointer-events: none;
    position: absolute;
    right: 5px;
    top: 20%;
    transform: rotate(90deg);
}

@media (min-width: 1200px) {
    .dropdown-cta-top-dropdown {
        height: fit-content;
        margin-top: 0;
    }
}

.dropdown-cta-top-button {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

@media (min-width: 768px) {
    .dropdown-cta-top-button {
        max-width:100%;
    }
}

@media (min-width: 1366px) {
    .dropdown-cta-top-button button {
        font-family:Helvetica Now Display Medium;
    }
}

.dropdown-cta-bottom-card {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    display: flex;
    width: 100%;
}

.dropdown-cta-bottom-card-image {
    height: 80px;
    margin: 16px 8px;
    width: 80px;
}

@media (min-width: 1200px) {
    .dropdown-cta-bottom-card-image {
        height:112px;
        width: 112px;
    }
}

.dropdown-cta-bottom-card-image img {
    border-radius: 100%;
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.dropdown-cta-bottom-card-content-primary {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 18px;
    line-height: 20px;
    line-height: 18px;
}

@media (min-width: 768px) {
    .dropdown-cta-bottom-card-content-primary {
        font-size:18px;
        line-height: 20px;
    }
}

@media (min-width: 1366px) {
    .dropdown-cta-bottom-card-content-primary {
        font-size:16px;
        line-height: 20px;
    }
}

.dropdown-cta-bottom-card-content-secondary {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
   
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
}

@media (min-width: 1366px) {
    .dropdown-cta-bottom-card-content-secondary {
        font-size:18px;
        line-height: 14px;
    }
}

.dropdown-cta-bottom-cta {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
}

.dropdown-cta-bottom-cta p {
    --text-opacity: 1;
    color: #1765f4;
    color: rgba(23,101,244,var(--text-opacity));
   
    font-size: 16px;
    line-height: 22px;
}

@media (min-width: 768px) {
    .dynamic-faq {
        padding:24px 0;
    }
}

@media (min-width: 1366px) {
    .dynamic-faq {
        padding:32px 0;
    }
}

.dynamic-faq-content {
    max-width: 100%;
}

.dynamic-faq-content-heading-eyebrow {
    margin-bottom: 16px;
}

@media (min-width: 768px) {
    .dynamic-faq-content-heading-eyebrow {
        color:#00304e;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1.26px;
        line-height: 48px;
        text-transform: uppercase;
    }
}

@media (min-width: 1366px) {
    .dynamic-faq-content-heading-eyebrow {
        color:#444;
        font-size: 16px;
        margin-bottom: 24px;
        margin-top: 32px;
    }
}

.dynamic-faq-content-heading-header {
    margin-bottom: 24px;
}

@media (min-width: 768px) {
    .dynamic-faq-content-heading-header {
        font-size:32px;
        line-height: 40px;
    }
}

@media (min-width: 1366px) {
    .dynamic-faq-content-heading-header {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
    
        font-size: 32px;
        line-height: 36px;
        margin-bottom: 48px;
    }
}

@media (min-width: 1366px) and (min-width:1366px) {
    .dynamic-faq-content-heading-header {
        font-size:48px;
        line-height: 52px;
    }
}

.dynamic-faq-content-image {
    border-radius: 8px;
    display: block;
    margin-bottom: 24px;
    width: 100%;
}

.dynamic-faq-content-image img {
    border-radius: 8px;
    height: 200px;
    object-fit: cover;
    object-position: top;
    width: 100%;
}

@media (min-width: 768px) {
    .dynamic-faq-content-image img {
        height:357px;
    }
}

@media (min-width: 1366px) {
    .dynamic-faq-content-image {
        display:none;
    }
}

.dynamic-faq-content-faq {
    margin-bottom: 24px;
}

@media (min-width: 1366px) {
    .dynamic-faq-content-faq {
        margin-bottom:32px;
    }
}

.dynamic-faq-content-faq-entry[open] .dynamic-faq-content-faq-entry-summary:after {
    content: "âˆ’";
}

.dynamic-faq-content-faq-entry[close] {
    background-color: red;
}

.dynamic-faq-content-faq-entry {
    border-top: 1px solid #eee;
    padding-bottom: 16px;
    padding-top: 16px;
}

@media (min-width: 1366px) {
    .dynamic-faq-content-faq-entry {
        padding-bottom:24px;
        padding-top: 24px;
    }
}

.dynamic-faq-content-faq-entry:last-child {
    border-bottom: 1px solid #eee;
}

.dynamic-faq-content-faq-entry summary {
    color: #131313;
    list-style-type: none;
    outline: none;
    padding-right: 40px;
    position: relative;
}

.dynamic-faq-content-faq-entry summary::marker {
    display: none;
}

.dynamic-faq-content-faq-entry summary::-webkit-details-marker {
    display: none;
}

.dynamic-faq-content-faq-entry summary:after {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    content: "+";
    font-size: 34px;
    height: 34px;
    position: absolute;
    right: 0;
    top: 25%;
    transition: all 0.3s ease-out;
    width: 34px;
}

@media (min-width: 1366px) {
    .dynamic-faq-content-faq-entry summary:after {
        top:0;
    }
}

.dynamic-faq-content-faq-entry p {
    color: #666;
    line-height: 22px;
    margin-top: 16px;
    padding-bottom: 56px;
    padding-right: 40px;
}

@media (min-width: 1366px) {
    .dynamic-faq-content-faq-entry p {
        color:#4a4a4a;
        line-height: 24px;
        margin-top: 24px;
        padding-bottom: 72px;
    }
}

.dynamic-faq-content-cta {
    display: flex;
    position: relative;
    width: fit-content;
}

.dynamic-faq-content-cta a {
    color: #2257b8;
    line-height: 26px;
}

@media (min-width: 1366px) {
    .dynamic-faq-content-cta a {
        font-size:23px;
        line-height: 34px;
    }
}

.dynamic-faq-desktop {
    margin-top: 4px;
}

@media (min-width: 1366px) {
    .dynamic-faq-desktop {
        grid-column:8/13;
        margin-top: 80px;
    }
}

.dynamic-faq-desktop-image {
    display: none;
}

@media (min-width: 1366px) {
    .dynamic-faq-desktop-image {
        display:block;
        height: 497px;
        width: 100%;
    }
}

.dynamic-faq-desktop-image img {
    border-radius: 8px;
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.reverse-col {
    display: flex;
    flex-direction: row-reverse;
}

.enhanced-form {
    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);
    max-width: 100%;
}

@media (max-width: 1365px) {
    .enhanced-form {
        padding:0 24px;
    }
}

.enhanced-form-content {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
}

@media (min-width: 1366px) {
    .enhanced-form-content {
        grid-column:2/5;
        margin-bottom: 40px;
    }
}

.enhanced-form-content p {
    text-align: center;
}

.enhanced-form-content-eyebrow {
    display: none;
}

@media (min-width: 1366px) {
    .enhanced-form-content-eyebrow {
        display:block;
    }
}

.enhanced-form-content-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 32px;
    line-height: 38px;
    text-align: center;
}

@media (min-width: 768px) {
    .enhanced-form-content-title {
        font-size:44px;
        line-height: 48px;
    }
}

@media (min-width: 1366px) {
    .enhanced-form-content-title {
        font-size:56px;
        line-height: 60px;
    }
}

.enhanced-form-container,.enhanced-form .layout-container {
    margin: 0 auto;
    max-width: 100%;
    width: 100%;
}

@media (min-width: 768px) {
    .enhanced-form-container,.enhanced-form .layout-container {
        width:100%;
    }
}

@media (min-width: 1366px) {
    .enhanced-form-container,.enhanced-form .layout-container {
        grid-column:6/12;
        width: unset;
    }
}

.enhanced-form .Form__Title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 26px;
    line-height: 32px;
    margin-bottom: 32px;
    text-align: center;
}

@media (min-width: 768px) {
    .enhanced-form .Form__Title {
        font-size:24px;
        line-height: 28px;
        margin-bottom: 48px;
    }
}

@media (min-width: 1366px) {
    .enhanced-form .Form__Title {
        font-size:32px;
        line-height: 38px;
        margin-bottom: 48px;
    }
}

.scPage-content-side .EPiServerForms {
    box-shadow: 0 10px 20px rgba(0,0,0,0.16078);
}

.news-content-side .enhanced-form,.news-landing-content-side .enhanced-form,.scPage-content-side .enhanced-form,.sidebar .enhanced-form {
    border-radius: 10px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.16078);
    display: flex !important;
    flex-direction: column;
    padding: 32px 24px 32px 30px;
    width: 100%;
}

@media (min-width: 1366px) {
    .news-content-side .enhanced-form,.news-landing-content-side .enhanced-form,.scPage-content-side .enhanced-form,.sidebar .enhanced-form {
        width:420px;
    }
}

.news-content-side .enhanced-form-content,.news-landing-content-side .enhanced-form-content,.scPage-content-side .enhanced-form-content,.sidebar .enhanced-form-content {
    margin-bottom: 0;
    width: 100%;
}

.news-content-side .enhanced-form-content-eyebrow,.news-landing-content-side .enhanced-form-content-eyebrow,.scPage-content-side .enhanced-form-content-eyebrow,.sidebar .enhanced-form-content-eyebrow {
    display: none;
}

.news-content-side .enhanced-form-container,.news-landing-content-side .enhanced-form-container,.scPage-content-side .enhanced-form-container,.sidebar .enhanced-form-container {
    width: unset;
}

.news-content-side .EPiServerForms,.news-landing-content-side .EPiServerForms,.scPage-content-side .EPiServerForms,.sidebar .EPiServerForms {
    box-shadow: none;
    width: 100%;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormTextbox,.scPage-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.scPage-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.scPage-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.scPage-content-side .EPiServerForms .Form__MainBody section .FormRange,.scPage-content-side .EPiServerForms .Form__MainBody section .FormSelection,.scPage-content-side .EPiServerForms .Form__MainBody section .FormTextbox,.sidebar .EPiServerForms .Form__MainBody section .FormCaptcha,.sidebar .EPiServerForms .Form__MainBody section .FormDateTime,.sidebar .EPiServerForms .Form__MainBody section .FormFileUpload,.sidebar .EPiServerForms .Form__MainBody section .FormRange,.sidebar .EPiServerForms .Form__MainBody section .FormSelection,.sidebar .EPiServerForms .Form__MainBody section .FormTextbox {
    width: 100%;
}

.news-content-side .EPiServerForms .Form__MainBody button,.news-landing-content-side .EPiServerForms .Form__MainBody button,.scPage-content-side .EPiServerForms .Form__MainBody button,.sidebar .EPiServerForms .Form__MainBody button {
    margin: 0;
    width: 100%;
}

.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData,.news-landing-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData,.scPage-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData,.sidebar .EPiServerForms .FormParagraphText.Form__Element--NonData {
    width: 100%;
}

.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData h3,.news-landing-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData h3,.scPage-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData h3,.sidebar .EPiServerForms .FormParagraphText.Form__Element--NonData h3 {
   
    text-align: center;
}

.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p,.news-landing-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p,.scPage-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p,.sidebar .EPiServerForms .FormParagraphText.Form__Element--NonData p {
   
    font-size: 14px;
    line-height: 22px;
}

.imagebackground-page-content .enhanced-form {
    display: flex !important;
    flex-direction: column;
    padding: 0 !important;
    width: 100%;
}

.imagebackground-page-content .enhanced-form-color {
    border-radius: 8px;
}

.imagebackground-page-content .enhanced-form-content {
    margin-bottom: 0;
    padding-left: 32px;
    padding-right: 32px;
    width: 100%;
}

.imagebackground-page-content .enhanced-form-content-eyebrow {
    display: none;
}

.imagebackground-page-content .EPiServerForms {
    box-shadow: none;
    padding: 0 32px;
    width: 100%;
}

@media (min-width: 1366px) {
    .imagebackground-page-content .EPiServerForms .Form__MainBody section .FormCaptcha,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormDateTime,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormFileUpload,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormRange,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormSelection,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormTextbox {
        width:49%;
    }
}

.imagebackground-page-content .EPiServerForms .Form__MainBody button {
    margin: 0;
}

.imagebackground-page-content .EPiServerForms .FormParagraphText.Form__Element--NonData {
    width: 100%;
}

.imagebackground-page-content .EPiServerForms .FormParagraphText.Form__Element--NonData h3 {
   
    text-align: center;
}

.imagebackground-page-content .EPiServerForms .FormParagraphText.Form__Element--NonData p {
   
    font-size: 14px;
    line-height: 22px;
}

.enhanced-form-color {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    padding-bottom: 20px;
    padding-top: 32px;
}

@media (min-width: 768px) {
    .enhanced-form-color {
        padding-bottom:120px;
    }
}

@media (min-width: 1366px) {
    .enhanced-form-color {
        padding-bottom:140px;
    }
}

.enhanced-form-color .enhanced-form:first-of-type {
    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);
}

.enhanced-form-color .enhanced-form {
    border-radius: 10px;
    padding-top: 32px;
}

.enhanced-form-color .enhanced-form,.enhanced-form-color .enhanced-form .enhanced-form {
    box-shadow: none;
}

.enhanced-form-color .enhanced-form-color,.enhanced-form-color .layout-container {
    padding: 0;
}

.FormSubmitModal {
    background: rgba(255,255,255,0.8) url("") 50% 50% no-repeat;
    display: none;
    height: 100%;
    left: 0;
    margin: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999;
}

.FormSubmitLoading .FormSubmitModal {
    display: block;
    overflow: hidden;
}

.ui-datepicker .ui-button:focus .ui-icon,.ui-datepicker .ui-button:hover .ui-icon,.ui-datepicker .ui-state-focus .ui-icon,.ui-datepicker .ui-state-hover .ui-icon,.ui-datepicker .ui-widget-header .ui-icon {
    background-image: url("");
}

.form-layout-block .enhanced-form-container .Form__Title {
    display: none;
}

.form-layout-block .enhanced-form-content {
    padding-left: 24px;
    padding-right: 24px;
}

@media (min-width: 1366px) {
    .form-layout-block .enhanced-form-content {
        padding-left:0;
        padding-right: 0;
    }

    .form-layout-block .layout-container {
        padding-top: 30px;
    }
}

@media (min-width: 960px) {
    .form-layout-block .layout-container {
        padding-bottom:0;
        padding-top: 0;
    }
}

.form-layout-block .layout-container .enhanced-form {
    display: block;
    grid: none;
    padding: 0 24px;
}

@media (min-width: 1366px) {
    .form-layout-block .layout-container .enhanced-form {
        padding-left:0;
        padding-right: 0;
    }
}

.form-layout-block .layout-container .enhanced-form-content {
    display: none;
}

.form-layout-block .layout-container .enhanced-form-container {
    grid-column: none;
}

.form-layout-block .layout-container form {
    padding-bottom: 0;
    padding-top: 0;
}

#recaptchaLegal {
    display: none;
}

.grecaptcha-badge {
    visibility: hidden;
}

@media (max-width: 1365px) {
    .form-anchor {
        position:relative;
        top: -87px;
    }
}

.EPiServerForms {
    border-radius: 10px;
    margin-left: auto;
    margin-right: auto;
    max-width: 720px;
    width: 100%;
}

.EPiServerForms .hide {
    display: none !important;
}

.EPiServerForms .Form__Status div {
    margin: 0;
    padding: 0;
}

.EPiServerForms .Form__MainBody section {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 8px;
    position: relative;
    width: 100%;
}

.EPiServerForms .Form__MainBody section .Form__Element {
    margin-bottom: 16px;
}

.EPiServerForms .Form__MainBody section input,.EPiServerForms .Form__MainBody section select,.EPiServerForms .Form__MainBody section textarea {
    border: 1px solid #bbb;
    border-radius: 5px;
    color: inherit;
    height: 50px;
    line-height: inherit;
    padding: 0 20px;
    width: 100%;
}

.EPiServerForms .Form__MainBody section input::placeholder,.EPiServerForms .Form__MainBody section select::placeholder,.EPiServerForms .Form__MainBody section textarea::placeholder {
    color: #666;
    opacity: 0;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #c6e7fa;
    background-color: rgba(198,231,250,var(--bg-opacity));
    border-radius: 8px;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    display: block;
    height: auto;
    margin-bottom: 20px;
    opacity: 1;
    padding: 16px;
    transition-duration: 0.5s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4,0,0.2,1);
    width: 100%;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart:not(.take-over) {
    padding-left: 52px;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    align-items: center;
    bottom: -4px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    left: 0;
    padding-bottom: 32px;
    padding-top: 24px;
    position: relative;
    right: 0;
    text-align: center;
    top: -4px;
    z-index: 1;
}

@media (min-width: 1366px) {
    .EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over {
        justify-content: center;
        padding-bottom: 48px;
        padding-top: 32px;
    }
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .take-over-icon {
    display: block;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .small-icon {
    display: none;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .message {
    margin-bottom: 32px;
    margin-top: 24px;
    max-width: 456px;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .link-start-over {
    margin-top: 16px;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.hidden {
    display: none;
    height: 0;
    opacity: 0;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .take-over-icon,.EPiServerForms .Form__MainBody section .FormApplicationQuickStart a.hidden {
    display: none;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .small-icon {
    left: 16px;
    position: absolute;
    top: 20px;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .small-icon svg {
    fill: #003876;
}

.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .message {
    margin-bottom: 16px;
}

.EPiServerForms .Form__MainBody section .FormCaptcha,.EPiServerForms .Form__MainBody section .FormDateTime,.EPiServerForms .Form__MainBody section .FormFileUpload,.EPiServerForms .Form__MainBody section .FormRange,.EPiServerForms .Form__MainBody section .FormSelection,.EPiServerForms .Form__MainBody section .FormTextbox {
    position: relative;
    width: 100%;
}

@media (min-width: 1366px) {
    .EPiServerForms .Form__MainBody section .FormCaptcha,.EPiServerForms .Form__MainBody section .FormDateTime,.EPiServerForms .Form__MainBody section .FormFileUpload,.EPiServerForms .Form__MainBody section .FormRange,.EPiServerForms .Form__MainBody section .FormSelection,.EPiServerForms .Form__MainBody section .FormTextbox {
        width:320px;
    }
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select {
    border: 1px solid red;
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select::placeholder {
    color: red;
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select {
    color: rgba(0,0,0,0);
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select:focus {
    color: red;
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select option:not(:first-of-type) {
    color: #000;
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail .Form__Element__ValidationError {
    color: red;
   
    font-size: 14px;
    line-height: 14px;
    padding-left: 12px;
    padding-right: 12px;
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail label,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail label,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail label,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail label,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail label,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail label {
    color: red;
}

.EPiServerForms .Form__MainBody section .FormCaptcha label,.EPiServerForms .Form__MainBody section .FormDateTime label,.EPiServerForms .Form__MainBody section .FormFileUpload label,.EPiServerForms .Form__MainBody section .FormRange label,.EPiServerForms .Form__MainBody section .FormSelection label,.EPiServerForms .Form__MainBody section .FormTextbox label {
    font-size: 12px;
    font-size: 16px;
    text-align: left;
    top: 12px;
}

.EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.EPiServerForms .Form__MainBody section .FormRange label.has-data,.EPiServerForms .Form__MainBody section .FormSelection label.has-data,.EPiServerForms .Form__MainBody section .FormTextbox label.has-data {
    font-size: 12px;
}

.EPiServerForms .Form__MainBody section .FormCaptcha[focus-within] label,.EPiServerForms .Form__MainBody section .FormDateTime[focus-within] label,.EPiServerForms .Form__MainBody section .FormFileUpload[focus-within] label,.EPiServerForms .Form__MainBody section .FormRange[focus-within] label,.EPiServerForms .Form__MainBody section .FormSelection[focus-within] label,.EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label {
    background-color: #fff;
    color: #2257b8;
    font-size: 12px;
    top: -11px;
}

.EPiServerForms .Form__MainBody section .FormCaptcha:focus-within label,.EPiServerForms .Form__MainBody section .FormDateTime:focus-within label,.EPiServerForms .Form__MainBody section .FormFileUpload:focus-within label,.EPiServerForms .Form__MainBody section .FormRange:focus-within label,.EPiServerForms .Form__MainBody section .FormSelection:focus-within label,.EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {
    background-color: #fff;
    color: #2257b8;
    font-size: 12px;
    top: -11px;
}

.EPiServerForms .Form__MainBody section .FormFileUpload {
    width: 100%;
}

.EPiServerForms .Form__MainBody section .FormFileUpload label {
    background-color: #fff;
    font-size: 12px;
    top: -11px;
}

.EPiServerForms .Form__MainBody section .FormFileUpload input {
    overflow: hidden;
    padding-bottom: 8px;
    padding-top: 8px;
}

.EPiServerForms .Form__MainBody section .FormDateTime label {
    background-color: #fff;
    font-size: 12px;
    top: -11px;
}

.EPiServerForms .Form__MainBody section .FormDateTime input {
    width: 100%;
}

.EPiServerForms .Form__MainBody section .FormDateTime input::placeholder {
    opacity: 1;
}

.EPiServerForms .Form__MainBody section .FormCaptcha button {
    background-color: #2257b8 !important;
    height: 35px;
    margin-bottom: 4px;
    width: 200px;
}

.EPiServerForms .Form__MainBody section .FormCaptcha img {
    margin-bottom: 4px;
}

.EPiServerForms .Form__MainBody section .FormCaptcha label {
    background-color: #fff;
    color: #2257b8;
    display: none;
    font-size: 12px;
    left: 10px;
    padding: 0 10px;
    position: absolute;
    top: -21px;
    z-index: 0;
}


.EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 27px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 16px;
    height: 56px;
    letter-spacing: 0.16px;
    margin-left: auto;
    min-width: 196px;
    padding: 0 2rem;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

@media (min-width: 1366px) {
    .EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section button {
        width:320px;
    }
}

.EPiServerForms .Form__MainBody section a.button {
    padding-top: 16px;
}

.EPiServerForms .Form__MainBody section a.button:after {
    display: none;
}

.EPiServerForms.form-take-over .Form__Element:not(.FormStep) {
    display: none;
}

.EPiServerForms .FormParagraphText.Form__Element--NonData {
    width: 100%;
}

.EPiServerForms .FormParagraphText.Form__Element--NonData p {
   
    font-size: 14px;
    line-height: 22px;
}

.EPiServerForms a {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
    display: inline-block;
   
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.EPiServerForms a:before {
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    opacity: 0;
}

.EPiServerForms a:after {
    display: none;
}

@media (hover: hover) {
    .EPiServerForms a:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .EPiServerForms a:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.EPiServerForms a.wrapper:after {
    width: 0;
}

.EPiServerForms a.disclaimer-hide,.EPiServerForms span.disclaimer-more {
    display: none;
}

.destinations-grid-wrapper,.generic-grid-wrapper {
    word-wrap: anywhere;
}

.destinations-grid-content .text-content,.generic-grid-content .text-content {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
}

@media (min-width: 768px) {
    .destinations-grid-content .text-content,.generic-grid-content .text-content {
        --text-opacity:1;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
    }

    .destinations-grid-content .title,.generic-grid-content .title {
        --text-opacity: 1;
        color: #003876;
        color: rgba(0,56,118,var(--text-opacity));
    }
}

.destinations-grid-content-overline,.generic-grid-content-overline {
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    letter-spacing: 1.26px;
}

@media (min-width: 768px) {
    .destinations-grid-content-overline,.generic-grid-content-overline {
        font-size:16px;
        line-height: 16px;
    }
}

.destinations-grid-content p,.generic-grid-content p {
    text-align: left;
}

.destinations-grid-content-link,.generic-grid-content-link {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    padding-right: 15px;
    position: relative;
    width: fit-content;
}

.destinations-grid-content-link:before,.generic-grid-content-link:before {
    content: "â€º";
    font-size: 25px;
    line-height: 20px;
    position: absolute;
    right: 0;
}

.destinations-grid-media,.generic-grid-media {
    margin: 0 auto;
    opacity: 0.85;
    width: 100%;
}

.destinations-grid-media-text,.generic-grid-media-text {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    padding: 16px;
    position: absolute;
    text-align: center;
}

.destinations-grid-media-subtext,.generic-grid-media-subtext {
    --text-opacity: 1;
    bottom: 0;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    padding: 2%;
    position: absolute;
    right: 0;
}

.destinations-grid-media-large,.generic-grid-media-large {
    margin-bottom: 8px;
    position: relative;
}

.destinations-grid-media-large img,.generic-grid-media-large img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

@media (min-width: 1366px) {
    .destinations-grid-media-large img,.generic-grid-media-large img {
        height:608px;
    }
}

.destinations-grid-media-large .destinations-grid-media-text,.destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .destinations-grid-media-text,.generic-grid-media-large .generic-grid-media-text {
    -ms-flex-item-align: center;
    -ms-flex-pack: distribute;
    align-items: center;
    align-self: center;
    display: flex;
   
    font-size: 56px;
    height: 100%;
    justify-content: space-around;
    line-height: 56px;
    text-align: center;
    width: 100%;
}

@media (min-width: 768px) {
    .destinations-grid-media-large .destinations-grid-media-text,.destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .destinations-grid-media-text,.generic-grid-media-large .generic-grid-media-text {
        font-size:60px;
        line-height: 52px;
    }
}

.destinations-grid-media-large .destinations-grid-media-text,.generic-grid-media-large .destinations-grid-media-text {
    bottom: 30%;
}

.destinations-grid-media-grid,.generic-grid-media-grid {
    grid-template-rows: repeat(2,minmax(0,auto));
}

.destinations-grid-media-grid .two-image,.generic-grid-media-grid .two-image {
    max-height: 176px;
}

@media (min-width: 768px) {
    .destinations-grid-media-grid .two-image,.generic-grid-media-grid .two-image {
        max-height:320px;
    }
}

.destinations-grid-media-grid .three-image,.generic-grid-media-grid .three-image {
    max-height: 176px;
}

@media (min-width: 768px) {
    .destinations-grid-media-grid .three-image,.generic-grid-media-grid .three-image {
        max-height:320px;
    }
}

@media (min-width: 1366px) {
    .destinations-grid-media-grid,.generic-grid-media-grid {
        height:608px;
    }
}

.destinations-grid-media-grid .generic-grid-media-text,.generic-grid-media-grid .generic-grid-media-text {
    padding-bottom: 24px;
}

@media (min-width: 1366px) {
    .destinations-grid-media-grid .generic-grid-media-text,.generic-grid-media-grid .generic-grid-media-text {
        padding-bottom:16px;
        padding-right: 24px;
    }
}

.destinations-grid-media-grid-row,.generic-grid-media-grid-row {
    height: 50%;
}

.destinations-grid-media-grid-row-image,.generic-grid-media-grid-row-image {
    position: relative;
}

.destinations-grid-media-grid-row-image img,.generic-grid-media-grid-row-image img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.destinations-grid-media-grid-row-image .destinations-grid-media-text,.destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .destinations-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {
    -ms-flex-item-align: center;
    -ms-flex-pack: distribute;
    align-items: center;
    align-self: center;
    display: flex;
   
    font-size: 22px;
    height: 100%;
    justify-content: space-around;
    line-height: 24px;
    text-shadow: 0 3px 6px #000029;
    width: 100%;
}

@media (min-width: 768px) {
    .destinations-grid-media-grid-row-image .destinations-grid-media-text,.destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .destinations-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {
        font-size:32px;
        line-height: 40px;
    }
}

.destinations-grid-media-grid-row-image .destinations-grid-media-text,.generic-grid-media-grid-row-image .destinations-grid-media-text {
    bottom: 30%;
}

.hero-banner {
    height: 460px;
    position: relative;
}

.hero-banner.auto-height {
    height: auto;
}

@media (min-width: 768px) {
    .hero-banner.auto-height {
        height:auto;
    }

    .hero-banner {
        height: 288px;
    }
}

@media (min-width: 1366px) {
    .hero-banner {
        height:472px;
    }
}

.hero-banner-image-mask {
    height: 100%;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100vw;
    z-index: 0;
}

.hero-banner-image-mask picture {
    display: flex;
    height: 100%;
    object-fit: cover;
}

.hero-banner-image-mask picture img {
    height: auto;
    object-fit: cover;
    width: 100%;
}

.hero-banner-form {
    background-color: #1f95cb;
    display: flex;
    flex-direction: column;
    height: fit-content;
    height: 336px;
    padding: 16px;
    position: relative;
    top: 160px;
    width: 100%;
    z-index: 1;
}

.hero-banner-form input::-webkit-input-placeholder {
    line-height: normal !important;
}

@media (min-width: 768px) {
    .hero-banner-form {
        height:320px;
        margin: 0;
        max-width: 546px;
        padding: 24px;
        position: absolute;
        right: 0;
        top: 33px;
        width: 320px;
    }
}

@media (min-width: 1366px) {
    .hero-banner-form {
        height:511px;
        max-width: 656px;
        padding-top: 32px;
        top: 24px;
        width: 656px;
    }
}

.hero-banner-form-mask {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    display: flex;
    height: 100%;
    justify-content: flex-end;
    position: relative;
    width: 100%;
}

@media (min-width: 768px) {
    .hero-banner-form-mask {
        height:100%;
    }
}

.hero-banner-form .hero-text {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
}

@media (min-width: 1366px) {
    .hero-banner-form .hero-text {
        margin-bottom:24px;
    }
}

.hero-banner-form .hero-text-top {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

    font-size: 24px;
    line-height: 30px;
    text-align: center;
}

@media (min-width: 768px) {
    .hero-banner-form .hero-text-top {
        font-size:32px;
        line-height: 36px;
        line-height: 32px;
    }
}

@media (min-width: 1366px) {
    .hero-banner-form .hero-text-top {
        font-size:40px;
        line-height: 42px;
    }
}

.hero-banner-form .hero-text-bottom {
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
   
    font-size: 56px;
    line-height: 60px;
    text-align: center;
}

@media (min-width: 768px) {
    .hero-banner-form .hero-text-bottom {
        font-size:36px;
        line-height: 40px;
    }
}

@media (min-width: 1366px) {
    .hero-banner-form .hero-text-bottom {
        font-size:48px;
        font-size: 56px;
        line-height: 52px;
    }
}

.hero-banner-form .hero-text {
    overflow: hidden;
}

.hero-banner-form-controls {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
    margin-top: 8px;
    overflow: hidden;
}

@media (min-width: 1366px) {
    .hero-banner-form-controls {
        justify-content: flex-start;
        margin-left: 36px;
        margin-top: 32px;
    }

    .hero-banner-form-controls button {
        --bg-opacity: 1;
        --text-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        border-radius: 8px;
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        display: inline-block;
       
        height: 48px;
        letter-spacing: 0.16px;
        line-height: 20px;
        line-height: 48px;
        min-width: 164px;
        padding-left: 32px;
        padding-right: 32px;
        text-align: center;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (min-width: 1366px) and (hover:hover) {
    .hero-banner-form-controls button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (min-width: 1366px) {
    .hero-banner-form-controls button > span,.hero-banner-form-controls button i,.hero-banner-form-controls button svg {
        display:inline;
    }

    .hero-banner-form-controls button svg {
        fill: #fff;
        height: 20px;
        margin-right: 4px;
        transform: translateY(-2.5px);
        width: 20px;
    }
}

@media (min-width: 1366px) {
    .hero-banner-form-controls button:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

@media (min-width: 1366px) and (hover:hover) {
    .hero-banner-form-controls button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

@media (min-width: 1366px) {
    .hero-banner-form-controls button.inverted {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        color: #002146;
        color: rgba(0,33,70,var(--text-opacity));
    }
}

@media (min-width: 1366px) and (hover:hover) {
    .hero-banner-form-controls button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

@media (min-width: 1366px) {
    .hero-banner-form-controls button.inverted:active {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #2257b8;
        background-color: rgba(34,87,184,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

@media (min-width: 1366px) {
    .hero-banner-form-controls button.inverted:disabled {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

@media (min-width: 1366px) and (hover:hover) {
    .hero-banner-form-controls button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.hero-banner-form-background {
    bottom: 20px;
    height: 80px;
    position: absolute;
    right: 12px;
    width: 140px;
    z-index: -1;
}

@media (min-width: 768px) {
    .hero-banner-form-background {
        height:80px;
        width: 134px;
    }
}

@media (min-width: 1366px) {
    .hero-banner-form-background {
        height:162px;
        width: 278px;
    }
}

.hero-banner-form-background img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.hero-banner-form .job-search-form input {
    border-radius: 6px;
    height: 56px;
    margin-bottom: 8px;
    padding-left: 48px;
    width: 100%;
}

@media (min-width: 768px) {
    .hero-banner-form .job-search-form input {
        height:32px;
        padding-bottom: 4px;
        padding-left: 32px;
        width: 208px;
    }
}

@media (min-width: 1366px) {
    .hero-banner-form .job-search-form input {
        height:64px;
        padding-bottom: 4px;
        padding-left: 48px;
        width: 432px;
    }
}

.hero-banner-form .job-search-form input::placeholder {
    color: #999;
   
    font-size: 16px;
    letter-spacing: 0.18px;
    line-height: 56px;
}

@media (min-width: 768px) {

    .hero-banner-form .job-search-form input::placeholder {
        font-size: 11px;
    }
}

@media (min-width: 1366px) {

    .hero-banner-form .job-search-form input::placeholder {
        font-size: 18px;
    }
}

.hero-banner-strike {
    --text-opacity: 1;
    -webkit-box-flex: 0;
    --bg-opacity: 1;
    background-color: #003876;
    background-color: rgba(0,56,118,var(--bg-opacity));
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
    display: flex;
    flex: none;
    flex-direction: column;
    margin-bottom: -36px;
    margin-left: 16px;
    margin-right: 16px;
    padding: 32px;
    position: relative;
    z-index: 1;
}

@media (min-width: 1200px) {
    .hero-banner-strike {
        margin-left:120px;
        min-height: 424px;
        width: 545px;
    }
}

.hero-banner-strike-mask {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    max-width: 1365px;
}

@media (min-width: 1200px) {
    .hero-banner-strike-mask {
        flex-direction: row;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 28px;
    }
}

.hero-banner-strike-header {
    --text-opacity: 1;
    -webkit-box-flex: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    flex: 1 1;
    margin: 44px 36px 20px;
    z-index: 1;
}

@media (min-width: 1200px) {
    .hero-banner-strike-header {
        margin-left:0;
        margin-right: 0;
        margin-top: 36px;
    }
}

.hero-banner-strike-header h1 {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    font-size: 40px;
    line-height: 44px;
}

@media (min-width: 1200px) {
    .hero-banner-strike-header h1 {
        font-size:56px;
        line-height: 60px;
    }
}

.hero-banner-strike-header .hero-description {
    font-size: 18px;
    line-height: 28px;
}

.hero-banner-strike-card-header {
    --text-opacity: 1;
    color: #c6e7fa;
    color: rgba(198,231,250,var(--text-opacity));
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 20px;
    position: relative;
    text-transform: uppercase;
}

.hero-banner-strike-card-header:after {
    --bg-opacity: 1;
    background-color: #c6e7fa;
    background-color: rgba(198,231,250,var(--bg-opacity));
    bottom: -4px;
    content: "";
    height: 4px;
    left: 0;
    position: absolute;
    width: 28px;
}

.hero-banner-cta {
    --text-opacity: 1;
    -webkit-box-flex: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    flex: 1 1;
    padding-bottom: 104px;
    padding-left: 32px;
    padding-top: 216px;
    position: relative;
    z-index: 1;
}

@media (min-width: 1200px) {
    .hero-banner-cta {
        padding-left:0;
        padding-top: 132px;
    }
}

.hero-banner-cta h1 {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: flex;
    flex-direction: column;
    margin-bottom: 22px;
}

@media (min-width: 1200px) {
    .hero-banner-cta h1 .hero-text {
        margin-bottom:12px;
    }
}

.hero-banner-cta h1 .hero-text-top {
   
    font-size: 28px;
    line-height: 32px;
    min-height: auto;
    padding-bottom: 8px;
}

@media (min-width: 1200px) {
    .hero-banner-cta h1 .hero-text-top {
        font-size:48px;
        line-height: 48px;
    }
}

.hero-banner-cta h1 .hero-text-bottom {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 58px;
    line-height: 63px;
}

@media (min-width: 1200px) {
    .hero-banner-cta h1 .hero-text-bottom {
        font-size:96px;
        line-height: 96px;
    }
}

.hero-banner-cta .cta-primary-large,.hero-banner-cta .cta-primary-large > a,.hero-banner-cta .cta-primary-large > button {
    background-color: #ff6319;
}

.hero-banner .img-gradient:after {
    background: transparent linear-gradient(90deg,#000,rgba(0,0,0,0)) 0 0 no-repeat padding-box;
    content: "";
    display: inline-block;
    height: 100%;
    left: 0;
    opacity: 0.4;
    position: absolute;
    top: 0;
    width: 100%;
}

.input-text {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
    max-width: 475px;
    position: relative;
    width: 100%;
}

@media (min-width: 1366px) {
    .input-text {
        margin-bottom:8px;
        margin-left: auto;
        margin-right: auto;
    }
}

.input-text input {
    border-radius: 6px;
    height: 56px;
    margin-bottom: 8px;
    padding-left: 48px;
    width: 100%;
}

@media (min-width: 768px) {
    .input-text input {
        height:32px;
        padding-bottom: 4px;
        padding-left: 32px;
        width: 208px;
    }
}

@media (min-width: 1366px) {
    .input-text input {
        height:64px;
        padding-bottom: 4px;
        padding-left: 48px;
        width: 432px;
    }
}

.input-text input::placeholder {
    color: #999;
   
    font-size: 18px;
    letter-spacing: 0.18px;
    line-height: 56px;
}

@media (min-width: 768px) {

    .input-text input::placeholder {
        font-size: 11px;
    }
}

@media (min-width: 1366px) {

    .input-text input::placeholder {
        font-size: 18px;
    }
}

.input-text-icon {
    height: 24px;
    left: 16px;
    position: absolute;
    top: 25%;
    width: 24px;
}

@media (min-width: 768px) {
    .input-text-icon {
        left:40px;
        top: 15%;
    }
}

@media (min-width: 1366px) {
    .input-text-icon {
        left:40px;
        top: 23%;
    }
}

.input-text-icon svg {
    fill: #d00;
}

.header-filler {
    height: 64px;
}

@media (min-width: 1366px) {
    .header-filler {
        height:126px;
    }
}

.igFeed-content {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
}

.igFeed-content-heading {
    --text-opacity: 1;
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
    margin-left: 12px;
    margin-right: 12px;
}

.igFeed-content-logo {
    display: none;
    height: 100px;
}

@media (min-width: 1200px) {
    .igFeed-content-logo {
        display: flex;
        height: 100px;
        width: 200px;
    }
}

.igFeed-content-logo img {
    height: 100%;
    object-fit: contain;
    width: 100%;
}

.igFeed-card {
    aspect-ratio: 1/1;
    height: 100%;
    width: 100%;
}

.igFeed-card img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.igFeed-card-image-thumbnail img {
    object-fit: contain;
}

.interactive-ux-container {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

@media (max-width: 767px) {
    .interactive-ux-container {
        display:none;
    }
}

.interactive-ux-container-column {
    background: inherit;
    display: flex;
}

@media (min-width: 768px) {
    .interactive-ux-container-column {
        max-width:33%;
    }
}

@media (max-width: 374px) {
    .interactive-ux-container-column {
        max-width:100%;
    }
}

.interactive-ux-container-column .interactive-ux-item-card {
    height: 110px;
    margin-bottom: 45px;
    max-width: 400px;
}

@media (max-width: 1365px) {
    .interactive-ux-container-column .interactive-ux-item-card {
        max-width:340px;
    }
}

.interactive-ux-container-column .interactive-ux-item-card-text {
    width: 70%;
}

.interactive-ux-container-column .interactive-ux-item-card-text-title {
    color: var(--interactive-ux-svg-color);
    letter-spacing: 0;
    text-align: right;
    width: 100%;
}

.interactive-ux-container-column .interactive-ux-item-card-text-description {
    color: #333;
    letter-spacing: 0;
    max-width: 300px;
    text-align: right;
    width: unset;
}

@media (max-width: 1199px) {
    .interactive-ux-container-column .interactive-ux-item-card-text-description {
        max-width:290px;
    }
}

@media (max-width: 767px) {
    .interactive-ux-container-column .interactive-ux-item-card-text-description {
        max-width:250px;
    }
}

.interactive-ux-container-column .interactive-ux-item-card-0 {
    margin-top: 150px;
}

.interactive-ux-container-column .interactive-ux-item-card-icon {
    border: 2px solid var(--interactive-ux-svg-color);
    border-radius: 70px;
    float: left;
    height: 70px;
    width: 70px;
}

@media (max-width: 1365px) {
    .interactive-ux-container-column .interactive-ux-item-card-icon {
        border-radius:62px;
        height: 62px;
        width: 62px;
    }
}

.interactive-ux-container-column .interactive-ux-item-card-icon svg {
    height: 70px;
    margin: auto;
}

@media (max-width: 1365px) {
    .interactive-ux-container-column .interactive-ux-item-card-icon svg {
        height:62px;
    }
}

.interactive-ux-container-column .interactive-ux-item-card-icon svg path,.interactive-ux-container-column .interactive-ux-item-card-icon svg rect {
    fill: var(--interactive-ux-svg-color);
    stroke: #fff;
}

.interactive-ux-container-column .interactive-ux-item-card-icon:hover {
    background-color: var(--interactive-ux-svg-color);
}

.interactive-ux-container-column .interactive-ux-item-card-icon:hover svg path,.interactive-ux-container-column .interactive-ux-item-card-icon:hover svg rect {
    stroke: unset;
    fill: var(--interactive-ux-svg-hover-color);
}

.interactive-ux-container-column-right .interactive-ux-item-card-text {
    float: right;
    margin-left: 20px;
}

@media (max-width: 959px) {
    .interactive-ux-container-column-right .interactive-ux-item-card-text {
        margin-left:10px;
    }
}

@media (max-width: 767px) {
    .interactive-ux-container-column-right .interactive-ux-item-card-text {
        margin-left:0;
    }
}

.interactive-ux-container-column-right .interactive-ux-item-card-text-description,.interactive-ux-container-column-right .interactive-ux-item-card-text-title {
    text-align: left;
}

.interactive-ux-container-column-right .interactive-ux-item-card-icon {
    float: left;
}

.interactive-ux-container-column-left .interactive-ux-item-card-text {
    float: left;
    margin-right: 20px;
}

@media (max-width: 959px) {
    .interactive-ux-container-column-left .interactive-ux-item-card-text {
        margin-right:10px;
    }
}

@media (max-width: 767px) {
    .interactive-ux-container-column-left .interactive-ux-item-card-text {
        margin-right:0;
    }
}

.interactive-ux-container-column-left .interactive-ux-item-card-text-description,.interactive-ux-container-column-left .interactive-ux-item-card-text-title {
    text-align: right;
}

.interactive-ux-container-column-left .interactive-ux-item-card-icon {
    float: right;
}

.interactive-ux-container-column-image img {
    margin: auto;
    max-width: 400px;
}

@media (max-width: 959px) {
    .interactive-ux-container-column-image img {
        max-width:230px;
    }
}

@media (max-width: 374px) {
    .interactive-ux-container-column-image img {
        max-width:100%;
    }
}

.interactive-ux-container-mobile {
    display: unset;
}

@media (min-width: 768px) {
    .interactive-ux-container-mobile {
        display:none;
    }
}

.interactive-ux-container-mobile ul.mobile-swiper-container {
    margin-bottom: 30px;
}

@media (max-width: 959px) {
    .interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item > div {
        display:inline;
        display: initial;
    }
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card {
    margin: auto;
    width: 85%;
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-text {
    float: left;
    width: 75%;
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-text-title {
    color: var(--interactive-ux-svg-color);
    letter-spacing: 0;
    text-align: left;
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-text-description {
    color: #333;
    letter-spacing: 0;
    max-width: 230px;
    text-align: left;
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon {
    border: 2px solid var(--interactive-ux-svg-color);
    border-radius: 50px;
    float: left;
    height: 50px;
    margin-right: 15px;
    width: 50px;
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon svg {
    height: 50px;
    margin: auto;
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon svg path,.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon svg rect {
    fill: var(--interactive-ux-svg-color);
    stroke: unset;
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon:hover {
    background-color: var(--interactive-ux-svg-color);
}

.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon:hover svg path,.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon:hover svg rect {
    stroke: unset;
    fill: var(--interactive-ux-svg-hover-color);
}

.interactive-ux h1.interactive-ux-title {
    color: #003c69;
    letter-spacing: 0;
    text-align: center;
}

.interactive-ux p.interactive-ux-subtitle {
    color: #333;
    letter-spacing: 0;
    text-align: center;
}

.intercept-survey-banner {
    --bg-opacity: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    background-image: url("");
    background-repeat: no-repeat;
    border-radius: 25px 25px 0 0;
    bottom: 0;
    display: none;
    height: 150px;
    justify-content: center;
    position: fixed;
    width: 100%;
    z-index: 9999;
}

@media (min-width: 1366px) {
    .intercept-survey-banner {
        background-image:url("");
        height: 162px;
    }
}

.intercept-survey-banner-content-text {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

    font-size: 24px;
    line-height: 42px;
    margin: 10px 0 0 -10px;
    padding: 0 16px;
    text-align: center;
}

@media (min-width: 1366px) {
    .intercept-survey-banner-content-text {
        font-size:38px;
        line-height: 42px;
        margin: 40px 0 0 120px;
        padding: 0 16px;
        text-align: left;
    }
}

.intercept-survey-banner-content-subHeader {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 14px;
    line-height: 21px;
    margin: 0 0 0 10px;
    padding: 0 16px;
    text-align: center;
}

@media (min-width: 1366px) {
    .intercept-survey-banner-content-subHeader {
        font-size:20px;
        line-height: 29px;
        margin: 10px 0 0 120px;
        padding: 0 16px;
        text-align: left;
    }
}

.intercept-survey-banner-content-actions {
    align-content: center;
    font-size: 18px;
    padding: 20px 0 0 30px;
}

@media (min-width: 1366px) {
    .intercept-survey-banner-content-actions {
        margin-right:80px;
        padding: 48px 0 48px 20px;
    }
}

.intercept-survey-banner-content-actions-buttontext {
    display: block;
    margin-left: 5px;
    margin-top: 5px;
}

@media (min-width: 1366px) {
    .intercept-survey-banner-content-actions-buttontext {
        margin-left:15px;
        margin-top: 0;
    }
}

.intercept-survey-banner-content-actions .cta-primary-small {
    background-color: #fff;
    height: 48px;
}

@media (min-width: 1366px) {
    .intercept-survey-banner-content-actions .cta-primary-small {
        height:56px;
        line-height: 56px;
        min-width: 196px;
    }
}

.intercept-survey-banner-content-actions-image {
    margin-top: 10px;
}

@media (min-width: 1366px) {
    .intercept-survey-banner-content-actions-image {
        margin-left:15px;
        margin-top: 15px;
    }
}

.intercept-survey-banner-content-actions-yes.cta-primary-small {
    color: #005d70;
}

.intercept-survey-banner-content-actions-no.cta-primary-small {
    color: #75787b;
}

@media (min-width: 960px) {
    .intercept-survey-banner-content {
        padding:0;
    }
}

.intercept-survey-confirm {
    background-color: #005d70;
    border-radius: 15px 15px 15px 15px;
    display: inline-flex;
    height: 194px;
    left: 50%;
    overflow: auto;
    position: fixed;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 345px;
    z-index: 5;
}

@media (min-width: 960px) {
    .intercept-survey-confirm {
        height:249px;
        width: 530px;
    }
}

.intercept-survey-confirm .cta-primary-small {
    --text-opacity: 1;
    background-color: #005d70;
    border: #fff;
    border-style: solid;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    cursor: pointer;
    font-size: 18px;
    height: 48px;
    padding-top: 3px;
}

@media (min-width: 1366px) {
    .intercept-survey-confirm .cta-primary-small {
        height:60px;
        line-height: 56px;
        min-width: 196px;
        padding-top: 0;
    }
}

.intercept-survey-confirm-wrapper {
    display: none;
}

.intercept-survey-confirm-text {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

    font-size: 26px;
    line-height: 30px;
    padding: 30px 25px;
    text-align: center;
}

@media (min-width: 960px) {
    .intercept-survey-confirm-text {
        font-size:38px;
        line-height: 42px;
        padding: 40px 50px 30px;
    }
}

.intercept-survey-confirm-overlay {
    background: rgba(0,0,0,0.26667);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 4;
}

.internal-widget-wrapper {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    background-color: #f9f9f9;
    background-color: rgba(249,249,249,var(--bg-opacity));
    justify-content: center;
}

.internal-widget-card,.internal-widget-wrapper {
    --bg-opacity: 1;
    display: flex;
}

.internal-widget-card {
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 5px 10px rgba(0,0,0,0.05098);
    flex-direction: column;
    margin-bottom: 16px;
    padding: 24px 16px 16px;
    width: 100%;
}

@media (min-width: 768px) {
    .internal-widget-card {
        margin-bottom:48px;
    }
}

@media (min-width: 1366px) {
    .internal-widget-card {
        margin-bottom:40px;
        margin-left: 0;
        margin-right: 0;
        padding: 32px 16px;
        width: 435px;
    }
}

.internal-widget-card-title {
    margin-bottom: 16px;
    text-align: center;
}

@media (min-width: 768px) {
    .internal-widget-card-title {
        margin-bottom:24px;
    }
}

.internal-widget-card-profile {
    align-items: center;
    display: flex;
    margin-top: 16px;
}

.internal-widget-card-profile-image {
    height: 40px;
    margin-right: 12px;
    width: 40px;
}

.internal-widget-card-profile-image img {
    border-radius: 100%;
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.internal-widget-card-profile-title {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
}



.internal-widget-card-image {
    margin-bottom: 16px;
    width: 100%;
}

@media (min-width: 1366px) {
    .internal-widget-card-image {
        margin-bottom:24px;
    }
}

.internal-widget-card-image img {
    border-radius: 6px;
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.internal-widget-card-content {
    font-size: 14px;
    line-height: 21px;
    text-align: left;
}

@media (min-width: 768px) {
    .internal-widget-card-content {
        font-size:16px;
        line-height: 24px;
    }
}

.internal-widget-card.hidden {
    display: none;
}

@media (min-width: 768px) {
    .internal-widget-card.hidden {
        display: flex;
    }
}

.internal-widget-load-more {
    margin-left: auto;
    margin-right: auto;
}

.internal-widget-load-more p {
    color: #fff;
    text-align: center;
}

@media (min-width: 768px) {
    .internal-widget-load-more {
        display:none;
    }
}

.license-map {
    margin-left: auto;
    margin-right: auto;
    max-width: 1365px;
}

.license-map-wrapper {
    background-color: #fff;
}

.license-map-image {
    height: 210px;
    margin: 32px auto;
    width: 100%;
}

@media (min-width: 768px) {
    .license-map-image {
        height:367px;
        margin-bottom: 40px;
        margin-top: 40px;
    }
}

@media (min-width: 1366px) {
    .license-map-image {
        height:492px;
    }
}

.license-map-image img {
    height: 100%;
    object-fit: contain;
    width: 100%;
}

.license-map-legend {
    justify-content: center;
    margin-bottom: 32px;
    margin-left: 24px;
    margin-right: 24px;
}

@media (min-width: 768px) {
    .license-map-legend {
        margin-bottom:8px;
        margin-left: 0;
        margin-right: 0;
    }
}

@media (min-width: 1366px) {
    .license-map-legend {
        margin-bottom:16px;
    }
}

.license-map-legend-entry {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    align-items: center;
    display: flex;
    justify-content: flex-start;
}

@media (min-width: 1366px) {
    .license-map-legend-entry {
        flex-direction: row;
    }
}

.license-map-legend-entry-icon {
    background-color: gray;
    height: 40px;
    margin-right: 20px;
    min-width: 40px;
}

@media (min-width: 768px) {
    .license-map-legend-entry-icon {
        height:48px;
        min-width: 48px;
    }
}

.license-map-legend-entry-label {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 24px;
    letter-spacing: -0.28px;
    line-height: 30px;
    max-width: 300px;
}

.hot-locations {
    height: 100%;
    overflow-x: hidden;
}

.hot-locations-heading {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 32px;
    line-height: 40px;
}

@media (min-width: 768px) {
    .hot-locations-heading {
        font-size:34px;
        line-height: 40px;
    }
}

@media (min-width: 1366px) {
    .hot-locations-heading {
        font-size:42px;
        line-height: 56px;
    }
}

.hot-locations-hero {
    left: 0;
    overflow: hidden;
    top: 0;
    width: 100%;
}

.hot-locations-hero img {
    height: 100%;
    object-fit: cover;
    width: auto;
}

@media (min-width: 1366px) {
    .hot-locations-hero img {
        height:200px;
    }
}

.hot-locations .section-container {
    padding-bottom: 24px;
    padding-top: 24px;
}

@media (min-width: 1366px) {
    .hot-locations .section-container {
        padding-bottom:32px;
        padding-top: 230px;
    }
}

.hot-locations .large-grid {
    margin-bottom: 0;
    margin-top: 0;
}

@media (min-width: 768px) {
    .hot-locations .large-grid {
        margin-bottom:24px;
    }
}

@media (min-width: 1366px) {
    .hot-locations .large-grid {
        margin-bottom:32px;
    }
}

.hot-locations .large-grid .hot-locations-card:nth-child(odd) {
    margin: 0 0 0 auto;
}

@media (min-width: 1366px) {
    .hot-locations .large-grid .hot-locations-card:nth-child(odd) {
        margin:0 auto;
    }
}

.hot-locations .large-grid .hot-locations-card:nth-child(2n) {
    margin: 0 auto 0 0;
}

@media (min-width: 1366px) {
    .hot-locations .large-grid .hot-locations-card:nth-child(2n) {
        margin:0 auto;
    }
}

.detail-grid-content .title {
    padding-bottom: 25px;
    text-align: center;
}

.hot-locations-card {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);
    display: block;
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-left: 24px;
    margin-right: 24px;
    overflow: hidden;
}

@media (min-width: 1366px) {
    .hot-locations-card-container {
        height:628px;
    }
}

.hot-locations-card .teaser-title {
   
    font-size: 38px;
    line-height: 40px;
    padding-bottom: 12px;
    padding-top: 12px;
}

@media (max-width: 767px) {
    .hot-locations-card .teaser-title {
        font-size:24px;
        line-height: 30px;
    }
}

.hot-locations-card .teaser-text {
    font-size: 16px;
    padding: 16px 0 25px;
}

@media (max-width: 1365px) {
    .hot-locations-card .teaser-text {
        font-size:16px;
    }
}

@media (min-width: 1366px) {
    .hot-locations-card .teaser-text {
        min-height:110px;
    }
}

.hot-locations-card-image {
    height: 230px;
}

@media (min-width: 1366px) {
    .hot-locations-card-image {
        height:316px;
    }
}

.hot-locations-card-image img {
    height: inherit;
}

.hot-locations-card-content {
    --bg-opacity: 1;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 16px 50px;
    position: relative;
}

@media (max-width: 767px) {
    .hot-locations-card-content {
        padding-left:30px;
        padding-right: 30px;
    }
}

.hot-locations-card-content-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 20px;
    line-height: 24px;
}

.hot-locations-card-content-title:after {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: -140px;
}

.hot-locations-card-content-location {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 16px;
    line-height: 14px;
}

.hot-locations-card-links {
    padding-bottom: 20px;
    padding-left: 50px;
    padding-right: 50px;
}

@media (max-width: 767px) {
    .hot-locations-card-links {
        padding-bottom:25px;
        padding-left: 30px;
        padding-right: 30px;
    }
}

@media (min-width: 1366px) {
    .hot-locations-card {
        margin:0;
    }
}

@media (max-width: 767px) {
    .hot-locations-card .link-large > a {
        font-size:16px;
    }
}

.small-card .link-large > a {
    font-size: 16px;
}

.small-card .teaser-title {
    font-size: 28px;
    line-height: 30px;
    padding-bottom: 12px;
    padding-top: 10px;
}

.small-card .teaser-text {
    display: none;
}

.small-card .teaser-text .rich-text {
    padding: 0;
}

@media (min-width: 1366px) {
    .small-card .hot-locations-card-container {
        height:306px;
        padding-left: 16px;
    }
}

.small-card .hot-locations-card-image {
    height: 179px;
}

.small-card .hot-locations-card-content {
    padding-left: 30px;
    padding-right: 30px;
}

@media (min-width: 768px) {
    .small-card .third-card-mobile {
        display:none;
    }
}

.small-card .third-card-mobile .teaser-text {
    display: block;
}

@media (max-width: 767px) {
    .small-card .third-card-desktop {
        display:none;
    }
}

.small-card .third-card-desktop .hot-locations-card-content {
    height: 250px;
    padding-left: 30px;
    padding-right: 30px;
}

.small-card .third-card-desktop .hot-locations-card-content .teaser-title {
    padding-top: 25px;
}

.small-card .third-card-desktop .hot-locations-card-content .teaser-text {
    display: block;
}

.small-card .third-card-desktop .hot-locations-card-content .hot-locations-card-links {
    padding-left: 0;
    padding-right: 0;
}

.small-card .third-card-desktop .hot-locations-card-image {
    float: left;
    height: 306px;
    width: 293px;
}

.small-card .hot-locations-card-links {
    padding-left: 30px;
    padding-right: 30px;
}

.location-categories {
    margin-bottom: 16px;
}

.location-categories-title {
    --text-opacity: 1;
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
   
    font-size: 20px;
}

@media (min-width: 1200px) {
    .location-categories-title {
        font-size:24px;
    }
}

.location-categories-item {
    width: 100%;
}

.location-categories-item-link {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: block;
   
    font-size: 22px;
    margin-bottom: 12px;
    padding: 12px 24px;
    text-transform: uppercase;
    width: 100%;
}

.location-categories-item-selected {
   
    font-size: 24px;
}

.location-categories-mobile-header {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 6px 10px rgba(0,0,0,0.10196);
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    height: 50px;
    padding: 8px 24px 12px;
    width: 100%;
}

.location-categories-mobile-header-selected {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.location-categories-mobile-header-selected i .stroke {
    fill: #fff;
}

.location-categories-mobile-header-title {
    float: left;
}

.location-categories-mobile-header i {
    float: right;
}

.location-categories-mobile .location-categories-item-link {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 0;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    margin-bottom: 0;
    padding: 8px 24px;
    text-transform: uppercase;
    width: 100%;
}

.location-category-chips {
    margin-bottom: -100px;
}

.location-category-chips-wrapper {
    --bg-opacity: 1;
    background-color: #f9f9f9;
    background-color: rgba(249,249,249,var(--bg-opacity));
    padding-top: 40px;
}

.location-category-chips-item,.location-category-chips-wrapper {
    justify-content: center;
}

.location-category-chips-item {
    align-items: center;
    margin: 4px;
    padding: 4px 16px;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.location-category-chips-item-wrapper {
    border-width: 2px;
}

.location-category-chips-item a {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
    opacity: 1;
}

.media-callout-wrapper-top-content {
    height: auto;
    max-width: 1550px;
    padding-bottom: 200px;
}

@media (min-width: 1200px) {
    .media-callout-wrapper-top-content {
        padding-bottom:300px;
    }
}

.media-callout-wrapper-top-content .text-wrapper label {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    margin-left: 20px;
    width: fit-content;
}

.media-callout-wrapper-top-content .text-wrapper .right-column {
    height: auto;
    overflow: hidden;
}

.media-callout-wrapper-top-content .text-wrapper .right-column-content {
    margin-top: -100%;
    transition: all 0.5s ease-in;
}

.media-callout-wrapper-top-content .text-wrapper #readmore:checked + .right-column .right-column-content {
    margin-top: 0;
}

@media (min-width: 1200px) {
    .media-callout-wrapper-top-content .text-wrapper {
        width:1130px;
    }

    .media-callout-wrapper-top-content .text-wrapper .right-column-content {
        margin-top: 0;
    }
}

.media-callout-wrapper-top-content .text-wrapper p {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    line-height: 30px;
}

.media-callout-wrapper-top-content .text-wrapper .read-more p:after {
    display: none;
}

.media-callout-wrapper-top-content h1:first-of-type {
    color: #fff;
}

.media-callout-wrapper-top-content-media {
    bottom: -100px;
}

.media-callout-wrapper-top-content-media section {
    display: contents;
}

.media-callout-wrapper-top-content-media section:last-of-type {
    display: none;
}

@media (min-width: 1200px) {
    .media-callout-wrapper-top-content-media section:last-of-type {
        display:contents;
    }
}

.media-callout-wrapper-top-content-media-container {
    height: 250px;
    width: 100%;
}

@media (min-width: 1200px) {
    .media-callout-wrapper-top-content-media-container {
        height:450px;
        width: 50%;
    }
}

.media-callout-wrapper-top-content-media-image {
    height: 250px;
    width: 100%;
}

@media (min-width: 1200px) {
    .media-callout-wrapper-top-content-media-image {
        height:auto;
        width: 50%;
    }
}

.media-callout-wrapper-top-content-media img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.media-callout-wrapper-top-content-media iframe {
    height: 100%;
    width: 100%;
}

@media (min-width: 1200px) {
    .media-callout-wrapper-top-content-media {
        bottom:-225px;
        max-width: 1454px;
    }
}

.media-callout-wrapper-bottom {
    background: transparent linear-gradient(180deg,#f2f2f0,#f8f5ed) 0 0 no-repeat padding-box;
}

.media-callout-wrapper-bottom-content {
    max-width: 1550px;
}

.media-callout-wrapper-bottom-content .media-callout-card {
    max-width: 475px;
}

.media-callout-wrapper-bottom-content .media-callout-card h1 {
    font-size: 32px;
}

@media (min-width: 1200px) {
    .media-callout-wrapper-bottom-content .media-callout-card h1 {
        font-size:42px;
    }
}

@media (min-width: 768px) {
    .media-combo.section-container {
        padding-bottom:24px;
        padding-top: 24px;
    }
}

@media (min-width: 1366px) {
    .media-combo.section-container {
        padding-bottom:32px;
        padding-top: 32px;
    }
}

.media-combo .promo-callout {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    padding-bottom: 24px;
}

@media (min-width: 768px) {
    .media-combo .promo-callout {
        padding-bottom:0;
    }
}

.media-combo .promo-callout .section-container {
    padding-bottom: 0;
    padding-top: 0;
}

@media (min-width: 768px) {
    .media-combo .promo-callout .section-container {
        padding-bottom:24px;
        padding-top: 0;
    }
}

@media (min-width: 1366px) {
    .media-combo .promo-callout .section-container {
        padding-bottom:64px;
    }
}

.media-combo .mobile-swiper-item {
    margin-left: auto;
    margin-right: auto;
}

@media (min-width: 1366px) {
    .media-combo .mobile-swiper-item {
        padding-bottom:32px;
    }
}

.media-combo .mobile-swiper-item .callout {
    padding-bottom: 32px;
    padding-top: 16px;
}

@media (min-width: 1366px) {
    .media-combo .mobile-swiper-item .callout {
        padding-top:24px;
    }
}

.media-combo .dot-navigation {
    margin-bottom: 24px;
    margin-top: 24px;
}

.news-categories {
    margin-bottom: 16px;
}

.news-categories-title {
    --text-opacity: 1;
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
   
    font-size: 20px;
}

@media (min-width: 1200px) {
    .news-categories-title {
        font-size:24px;
    }
}

.news-categories-item {
    width: 100%;
}

.news-categories-item-link {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: block;
   
    font-size: 22px;
    margin-bottom: 12px;
    padding: 12px 24px;
    text-transform: uppercase;
    width: 100%;
}

.news-categories-item-selected {
   
    font-size: 24px;
}

.news-categories-mobile-header {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 6px 10px rgba(0,0,0,0.10196);
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    height: 50px;
    padding: 8px 24px 12px;
    width: 100%;
}

.news-categories-mobile-header-selected {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.news-categories-mobile-header-selected i .stroke {
    fill: #fff;
}

.news-categories-mobile-header-title {
    float: left;
}

.news-categories-mobile-header i {
    float: right;
}

.news-categories-mobile .news-categories-item-link {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    border-radius: 0;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    margin-bottom: 0;
    padding: 8px 24px;
    text-transform: uppercase;
    width: 100%;
}

.news-category-chips-wrapper {
    justify-content: center;
}

@media (min-width: 960px) {
    .news-category-chips-wrapper {
        justify-content: flex-start;
    }
}

.news-category-chips-item {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    justify-content: center;
    margin: 4px;
    padding: 4px 16px;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.news-category-chips-item-wrapper {
    border-width: 2px;
}

.news-category-chips-item a {
    opacity: 1;
}

@media (min-width: 1200px) {
    .news-results {
        margin-left:auto;
        margin-right: auto;
        max-width: 1366px;
    }
}

.news-results-heading {
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
   
    font-size: 22px;
    margin-bottom: 16px;
}

@media (min-width: 1200px) {
    .news-results-heading {
        font-size:48px;
        margin-bottom: 20px;
    }
}

.news-results-item {
    margin-bottom: 40px;
}

.news-results-item-image img {
    border-radius: 8px;
    height: 220px;
    max-height: 220px;
    object-fit: cover;
    width: 100%;
}

@media (min-width: 1200px) {
    .news-results-item-image img {
        height:265px;
        max-height: 265px;
    }
}

.news-results-item-meta {
    margin-bottom: 8px;
}

.news-results-item-meta-category {
   
    font-size: 13px;
    text-transform: uppercase;
}

@media (min-width: 1200px) {
    .news-results-item-meta-category {
        font-size:16px;
    }
}

.news-results-item-meta-seperator {
    --text-opacity: 1;
    border-right: 1px solid #979797;
    display: inline;
   
}

.news-results-item-meta-date,.news-results-item-meta-seperator {
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    margin-left: 8px;
}

.news-results-item-meta-date {
   
    font-size: 13px;
    text-transform: uppercase;
}

@media (min-width: 1200px) {
    .news-results-item-meta-date {
        font-size:16px;
    }
}

.news-results-item-title {
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
   
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 8px;
}

@media (min-width: 1200px) {
    .news-results-item-title {
        
        font-size: 24px;
        font-size: 32px;
        line-height: 34px;
    }
}

.news-results-item-summary,.news-results-item-summary p {
    --text-opacity: 1;
    color: #4a4a4a;
    color: rgba(74,74,74,var(--text-opacity));
   
    font-size: 16px;
    text-align: left;
}

.news-results-pager {
    margin: auto;
}

.news-results-pager .pagination-btn.active {
    background: #0977a9;
    border: 1px solid #0098db;
}

.news-results-content {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    width: 100%;
}

.news-results-content p {
    text-align: center;
}

.news-results-loading {
    display: block;
    margin-top: 100px;
    text-align: center;
    width: 100%;
}

.news-results-loading .lds-ring {
    position: inherit;
}

.news-search {
    padding-top: 0;
}

@media (min-width: 1366px) {
    .news-search {
        grid-column:span 12 / span 12;
        margin-left: auto;
        margin-right: auto;
        max-width: 1366px;
    }
}

.news-search-count {
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
   
    font-size: 20px;
}

.news-search-count .bold {
    font-size: 30px;
}

@media (min-width: 1366px) {
    .news-search-count .bold {
        font-size:32px;
    }
}

.news-search-results-title {
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
   
    font-size: 30px;
}

@media (min-width: 1366px) {
    .news-search-results-title {
        font-size:48px;
    }
}

.news-search-results .body-standard-18,.news-search-results .body-standard-18 p {
    --text-opacity: 1;
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
}

.news-search-box {
    margin-left: 16px;
    margin-right: 16px;
    padding-bottom: 12px;
}

@media (min-width: 1200px) {
    .news-search-box {
        margin-left:auto;
        margin-right: auto;
        max-width: 1366px;
    }
}

.news-search-box-container {
    --text-opacity: 1;
    color: #718096;
    color: rgba(113,128,150,var(--text-opacity));
    margin-bottom: 24px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}

.news-search-box-container-left {
    margin-left: 0;
    margin-right: 0;
}

.news-search-box-container input {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    box-shadow: 0 6px 10px rgba(0,0,0,0.05098);
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
    font-size: 15px;
    height: 40px;
    height: 50px;
    padding-left: 52px;
    padding-right: 16px;
    width: 100%;
}

@media (min-width: 1200px) {
    .news-search-box-container input {
        font-size:18px;
        height: 70px;
    }
}

.news-search-box-container button {
    margin-top: 15px;
}

@media (min-width: 1200px) {
    .news-search-box-container button {
        margin-top:25px;
    }
}

.news-search-box-container svg {
    fill: #002146;
}

@media (min-width: 768px) {
    .nurse-zone {
        padding-bottom:24px;
        padding-top: 24px;
    }
}

@media (min-width: 1366px) {
    .nurse-zone {
        padding-bottom:32px;
        padding-top: 32px;
    }
}

@media (min-width: 768px) {
    .nurse-zone .title {
        line-height:46px;
    }
}

@media (min-width: 1366px) {
    .nurse-zone .title {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
    
        font-size: 32px;
        line-height: 36px;
    }
}

@media (min-width: 1366px) and (min-width:1366px) {
    .nurse-zone .title {
        font-size:48px;
        line-height: 52px;
    }
}

.nurse-zone-top-content a {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    padding-left: 2px;
}

.nurse-zone-bottom {
    justify-content: space-between;
    margin-bottom: 16px;
    width: 100%;
}

.nurse-zone-card:first-child {
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .nurse-zone-card:first-child {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .nurse-zone-card:first-child {
        grid-column:span 4 / span 4;
    }
}

.nurse-zone-card:first-child .card-image img {
    height: 160px;
}

@media (min-width: 768px) {
    .nurse-zone-card:first-child .card-image img {
        height:248px;
    }
}

@media (min-width: 1366px) {
    .nurse-zone-card:first-child .card-image img {
        height:248px;
    }
}

.nurse-zone-card:first-child .card-subtitle {
    font-size: 22px;
    line-height: 28px;
}

@media (min-width: 768px) {
    .nurse-zone-card:first-child .card-subtitle {
        --text-opacity:1;
        color: #002146;
        color: rgba(0,33,70,var(--text-opacity));
    
        font-size: 22px;
        font-size: 24px;
        line-height: 28px;
        line-height: 30px;
    }
}

@media (min-width: 768px) and (min-width:768px) {
    .nurse-zone-card:first-child .card-subtitle {
        font-size:26px;
        font-size: 30px;
        line-height: 32px;
        line-height: 38px;
    }
}

.nurse-zone-card:not(:first-child) {
    grid-column: span 3 / span 3;
}

@media (min-width: 768px) {
    .nurse-zone-card:not(:first-child) {
        grid-column:span 6 / span 6;
    }
}

@media (min-width: 1366px) {
    .nurse-zone-card:not(:first-child) {
        grid-column:span 4 / span 4;
    }
}

.nurse-zone-card:not(:first-child) .card-overline {
    font-size: 12px;
    line-height: 16px;
}

@media (min-width: 768px) {
    .nurse-zone-card:not(:first-child) .card-overline {
        font-size:14px;
        line-height: 14px;
    }
}

.nurse-zone-card:not(:first-child) .card-image img {
    height: 120px;
}

@media (min-width: 768px) {
    .nurse-zone-card:not(:first-child) .card-image img {
        height:160px;
    }
}

@media (min-width: 1366px) {
    .nurse-zone-card:not(:first-child) .card-image img {
        height:248px;
    }
}

.nurse-zone-card:not(:first-child) .card-subtitle {
    font-size: 22px;
    line-height: 28px;
}

@media (min-width: 768px) {
    .nurse-zone-card:not(:first-child) .card-subtitle {
        --text-opacity:1;
        color: #002146;
        color: rgba(0,33,70,var(--text-opacity));
    
        font-size: 22px;
        font-size: 24px;
        line-height: 28px;
        line-height: 30px;
    }
}

@media (min-width: 768px) and (min-width:768px) {
    .nurse-zone-card:not(:first-child) .card-subtitle {
        font-size:26px;
        line-height: 32px;
    }
}

@media (min-width: 768px) and (min-width:768px) {
    .nurse-zone-card:not(:first-child) .card-subtitle {
        font-size:30px;
        line-height: 38px;
    }
}

.nurse-zone-card {
    margin-bottom: 24px;
}

.nurse-zone-card-image {
    border-radius: 27px;
    margin-bottom: 16px;
    width: 100%;
}

.nurse-zone-card-image img {
    border-radius: 8px;
    object-fit: cover;
    width: 100%;
}

.nurse-zone-card-body {
    text-align: left;
}

.nurse-zone-card-body > .rich-text,.nurse-zone-card-body > .rich-text > p {
    line-height: 24px;
}

.nurse-zone-card-cta {
    display: none;
}

.nurse-zone-card-eyebrow {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.physician-cost-calculator {
    display: flex;
    flex-direction: column;
    margin: 28px 0 24px;
}

@media (min-width: 1366px) {
    .physician-cost-calculator {
        flex-direction: row;
    }
}

.physician-cost-calculator-wrapper {
    margin: 0 auto;
    max-width: 1064px;
    padding: 72px 24px 60px;
    text-align: center;
}

.physician-cost-calculator-wrapper p {
    text-align: center;
}

.physician-cost-calculator-header {
    color: #003c69;
    font-size: 22px;
    line-height: 32px;
    padding-bottom: 12px;
    text-align: left;
}

@media (min-width: 1366px) {
    .physician-cost-calculator-header {
        font-size:40px;
        line-height: 64px;
        padding-bottom: 32px;
        text-align: center;
    }
}

.physician-cost-calculator-description {
    padding-bottom: 40px;
}

.physician-cost-calculator-description p {
    text-align: left;
}

@media (min-width: 1366px) {
    .physician-cost-calculator-description p {
        text-align:center;
    }
}

.physician-cost-calculator-select {
    position: relative;
}

@media (min-width: 1366px) {
    .physician-cost-calculator-select {
        display:inline-block;
    }
}

.physician-cost-calculator-select-label {
    color: #003976;
    display: block;

    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    padding-bottom: 12px;
}

.physician-cost-calculator-select select {
    appearance: none;
    border: 1px solid #9a9a9a;
    border-radius: 8px;
    padding: 16px 52px 16px 24px;
    width: 100%;
}

.physician-cost-calculator-select:after {
    --text-opacity: 1;
    color: #444;
    content: "â€º";
    font-size: 35px;
    height: 34px;
    pointer-events: none;
    position: absolute;
    right: 5px;
    top: 20%;
    transform: rotate(90deg);
}

.physician-cost-calculator-tile {
    border-radius: 8px;
    font-size: 28px;
    margin: 5px 0;
    padding: 20px 28px;
    text-align: center;
}

@media (min-width: 1366px) {
    .physician-cost-calculator-tile {
        font-size:22px;
        height: 180px;
        margin: 0 10px;
        padding: 24px 16px;
        width: 200px;
    }
}

.physician-cost-calculator-tile-header {
    color: #003c69;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding-bottom: 10px;
    text-transform: uppercase;
}

@media (min-width: 1366px) {
    .physician-cost-calculator-tile-header {
        min-height:64px;
        padding-bottom: 24px;
    }
}

.physician-cost-calculator-tile:first-child {
    background-color: rgba(132,195,70,0.10196);
    color: #84c346;
}

.physician-cost-calculator-tile:nth-child(2) {
    background-color: rgba(74,186,235,0.10196);
    color: #4abaeb;
}

.physician-cost-calculator-tile:nth-child(3) {
    background-color: rgba(83,66,153,0.10196);
    color: #534299;
}

.physician-cost-calculator-tile:nth-child(4) {
    background-color: rgba(55,179,74,0.10196);
    color: #37b34a;
}

.physician-cost-calculator-tile:nth-child(5) {
    background-color: rgba(0,150,165,0.10196);
    color: #0096a5;
}

.physician-cost-calculator-more-information {
    margin: auto;
    max-width: 700px;
}

.physician-cost-calculator-more-information p {
    color: #75787b;
    font-size: 14px;
    line-height: 20px;
}

.physician-cost-calculator-more-information .rich-text a {
    color: #003c69;
    font-weight: 700;
}

.physician-cost-calculator-sources-title {
    color: #003976;
    font-size: 20px;
    line-height: 32px;
    padding: 20px 0 12px;
}

.physician-cost-calculator-sources-description p {
    color: #444;
    font-size: 14px;
    line-height: 21px;
}

.cookie-banner {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    background-color: #dde6ed;
    background-color: rgba(221,230,237,var(--bg-opacity));
    bottom: 0;
    box-shadow: 0 0 2px 1px rgba(0,0,0,0.2);
    font-size: 13px;
    height: auto;
    justify-content: center;
    line-height: 1.5;
    position: fixed;
    text-align: center;
    width: 100%;
    z-index: 9999;
}

@media (min-width: 768px) {
    .cookie-banner .mobile {
        display:none;
    }
}

@media (max-width: 767px) {
    .cookie-banner .desktop {
        display:none;
    }
}

.cookie-banner .privacy-read-more {
    display: none;
}

@media (max-width: 767px) {
    .cookie-banner .privacy-read-more {
        display:inline;
    }

    .cookie-banner .privacy-read-more-text {
        display: none;
    }
}

.cookie-banner .hide {
    display: none;
}

.cookie-banner .expand {
    display: inline;
}

.cookie-banner-content-text {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    font-size: 14px;
    justify-content: center;
    line-height: 19px;
    margin: 0 0 10px;
    padding: 0 16px;
    text-align: center;
}

.cookie-banner-content-close {
    padding: 0 0 10px;
}

@media (min-width: 960px) {
    .cookie-banner {
        padding:12px 24px;
    }
}

.promo-callout .reverse-promo {
    grid-auto-flow: column;
}

@media (min-width: 768px) {
    .promo-callout .reverse-promo .promo-callout-media {
        grid-column:7/13;
    }
}

@media (min-width: 1366px) {
    .promo-callout .reverse-promo .promo-callout-media {
        grid-column:7/13;
        padding-left: 24px;
    }
}

@media (min-width: 768px) {
    .promo-callout .reverse-promo .promo-callout-content {
        grid-column:1/7;
    }
}

@media (min-width: 1366px) {
    .promo-callout .reverse-promo .promo-callout-content {
        grid-column:1/7;
        padding-right: 24px;
    }
}

.promo-callout-media {
    padding-bottom: 24px;
}

@media (min-width: 768px) {
    .promo-callout-media {
        grid-column:1/7;
        padding: 24px 20px;
    }
}

@media (min-width: 1366px) {
    .promo-callout-media {
        grid-column:1/7;
        height: auto;
        padding-bottom: 28px;
        padding-right: 24px;
        padding-top: 24px;
    }
}

.promo-callout-media-wrapper img {
    border-radius: 8px;
    height: auto;
    object-fit: cover;
}

.promo-callout-media-wrapper .video-wrapper .video-youtube {
    border-radius: 10px;
}

.promo-callout-media-wrapper .video-wrapper .video-youtube img {
    top: -16.65%;
}

@media (min-width: 768px) {
    .promo-callout-media-wrapper .video-wrapper .video-youtube img {
        height:240px;
        top: -18.82%;
    }
}

@media (min-width: 1366px) {
    .promo-callout-media-wrapper .video-wrapper .video-youtube img {
        height:342px;
        top: 0;
    }
}

.promo-callout-content {
    text-align: left;
}

@media (min-width: 768px) {
    .promo-callout-content {
        grid-column:7/13;
        padding-top: 24px;
    }
}

@media (min-width: 1366px) {
    .promo-callout-content {
        align-self:flex-start;
        grid-column: 7/13;
        padding-left: 24px;
    }
}

.promo-callout-content div.rich-text {
    padding-left: 0;
}

.promo-callout-content-cta .wrapper {
    min-width: 192px;
    width: auto;
}

.promo-callout-content-cta .wrapper a {
    width: 100%;
}

.promo-callout-content-cta .cta-primary-wrapper {
    margin-bottom: 32px;
}

.promo-callout-content-cta .cta-primary-medium > a {
    background-color: #2257b8;
}

.promo-callout-content .promo-eyebrow {
    color: #0098db;
    font-size: 24px;
    line-height: 32px;
}

.promo-callout li {
    line-height: 26px;
    margin-left: 15px;
}

.promo-callout-tile {
    display: none;
}

.promo-callout-tile .callout-container-icon {
    height: 56px;
}

.promo-callout-tile .tile-text {
    min-width: 70px;
}

@media (max-width: 1365px) {
    .promo-callout-tile {
        display: flex;
    }

    .promo-callout-tile .promo-callout-content {
        margin: auto;
        width: 720px;
    }
}

@media (max-width: 767px) {
    .promo-callout-tile .promo-callout-content {
        margin:auto;
        width: 362px;
    }
}

@media (max-width: 374px) {
    .promo-callout-tile .promo-callout-content {
        margin:auto;
        width: 244px;
    }
}

.rich-text {
    word-wrap: break-word;
    line-height: 18px;
    word-break: break-word;
}

.rich-text .cta-primary-large,.rich-text .cta-primary-medium,.rich-text .cta-primary-small {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.rich-text .cta-primary-large:visited,.rich-text .cta-primary-medium:visited,.rich-text .cta-primary-small:visited {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    text-decoration: none;
}

@media (hover: hover) {
    .rich-text .cta-primary-large:hover,.rich-text .cta-primary-medium:hover,.rich-text .cta-primary-small:hover,.rich-text .cta-secondary-large:hover,.rich-text .cta-secondary-medium:hover,.rich-text .cta-secondary-small:hover {
        --text-opacity:1;
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        text-decoration: none;
    }
}

.rich-text ol {
    --text-opacity: 1;
    color: #4a4a4a;
    color: rgba(74,74,74,var(--text-opacity));
   
    font-size: 16px;
    line-height: 26px;
    padding-left: 22px;
}

.rich-text ol li {
    list-style: decimal;
}

.rich-text img {
    display: inline;
    display: initial;
}

.rich-text a,.rich-text a:visited {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
}

.rich-text a:hover {
    --text-opacity: 1;
    color: #1765f4;
    color: rgba(23,101,244,var(--text-opacity));
    text-decoration: underline;
}

.rich-text ul {
    --text-opacity: 1;
    color: #4a4a4a;
    color: rgba(74,74,74,var(--text-opacity));
   
    font-size: 16px;
    line-height: 26px;
    list-style: none;
    margin: 24px 0 0;
    padding-left: 20px;
}

.rich-text ul li {
    margin-bottom: 16px;
    text-align: left;
}

.rich-text ul li:before {
    color: #4a4a4a;
    color: rgba(74,74,74,var(--text-opacity));
    content: "â‹…";
    font-size: 48px;
    font-weight: 700;
    margin-left: -20px;
    margin-top: -4px;
    vertical-align: top;
    width: 20px;
}

.rich-text ul ul {
    margin: 0;
}

.section-container .rich-text {
    padding-left: 8px;
    padding-right: 8px;
}

.see-country-link a {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    line-height: 22px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.see-country-link a:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.see-country-link a:after {
    display: none;
}

@media (hover: hover) {
    .see-country-link a:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .see-country-link a:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.see-country-link a.wrapper:after {
    width: 0;
}

@media (min-width: 1366px) {
    .see-country-link a {
        margin:0;
    }
}

.city-card {
    height: 423px;
    min-height: 423px;
}

@media (min-width: 1366px) {
    .city-card {
        height:459px;
        min-height: 459px;
    }
}

.city-card-background {
    width: 100%;
    z-index: -1;
}

.city-card-background img {
    border-radius: 27px;
    object-fit: cover;
    width: 100%;
}

.city-card-content {
    overflow: hidden;
    padding: 0 40px;
}

.city-card-content-heading > p {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
   
    font-size: 80px;
    line-height: 56px;
    text-align: center;
    text-shadow: 0 3px 45px rgba(0,0,0,0.92157);
}

@media (min-width: 1366px) {
    .city-card-content-heading > p {
        font-size:80px;
        line-height: 56px;
    }
}

#svgStateMap,.svgStateMap {
    margin: auto;
    pointer-events: none;
    touch-action: auto;
    width: 100%;
}

#svgStateMap .map-background,#svgStateMap path,.svgStateMap .map-background,.svgStateMap path {
    pointer-events: auto;
}

#svgStateMap path.map-state,.svgStateMap path.map-state {
    stroke: #fff;
    fill: var(--color);
}

#svgStateMap path.map-state:hover,.svgStateMap path.map-state:hover {
    stroke-width: 1;
    fill: var(--hover-color);
}

.state-license-map .state-license-map-legend {
    float: right;
    margin-right: 40%;
    width: 150px;
}

.state-license-map .state-license-map-legend div {
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05882);
    color: #fff;
    font: normal normal 700 12px/17px Helvetica Now Display;
    padding: 7px;
    text-align: center;
    width: 150px;
}

.state-map-modal {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.2);
    display: block;
    max-height: 500px;
    padding: 30px;
    position: absolute;
    width: 450px;
}

.state-map-modal.hidden {
    display: none;
}

.state-map-modal h2 {
    font: normal normal 700 18px/26px Helvetica Now Display;
}

.state-map-modal p {
    font: normal normal normal 14px/21px Helvetica Now Text;
}

.state-map-modal a:not(.cta-primary-medium) {
    font: normal normal normal 14px/26px Helvetica Now Text;
    letter-spacing: 0;
    text-decoration: underline;
}

.state-map-modal a.cta-primary-medium {
    margin-top: 20px;
}

.state-map-modal .map-modal-dismiss {
    height: 10px;
    right: 10px;
    top: 10px;
    width: 10px;
}

@media (min-width: 768px) {
    .state-map-modal .arrow-side {
        border-bottom:15px solid #fff;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        height: 0;
        right: -15px;
        top: 85px;
        transform: rotate(90deg);
        width: 0;
        z-index: 2;
    }

    .state-map-modal .arrow-side-border {
        border-bottom: 15px solid #c4cace;
        right: -18px;
        z-index: 1;
    }
}

@media (max-width: 1199px) {
    .state-map-modal {
        bottom:0;
        left: unset !important;
        max-height: unset;
        position: fixed;
        right: unset !important;
        top: unset !important;
        width: 100%;
    }

    .state-map-modal h2 {
        font: normal normal 700 14px/18px Helvetica Now Display;
        letter-spacing: 0;
        text-align: left;
    }

    .state-map-modal p {
        font: normal normal normal 12px/17px Helvetica Now Text;
        letter-spacing: 0;
        text-align: left;
    }

    .state-map-modal a:not(.cta-primary-medium) {
        font: normal normal normal 14px/26px Helvetica Now Text;
        letter-spacing: 0;
        text-decoration: underline;
    }

    .state-map-modal .map-modal-dismiss {
        height: 20px;
        right: 15px;
        top: 15px;
        width: 20px;
    }
}

body.state-map {
    touch-action: none;
}

body.state-map-page {
    touch-action: pan-y;
}

.strike-card {
    -webkit-box-flex: 1;
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);
    display: flex;
    flex: 1 1;
    flex-direction: column;
    height: 465px;
    margin-bottom: 4px;
    padding: 36px 28px;
    position: relative;
}

@media (min-width: 1200px) {
    .strike-card {
        box-shadow: none;
        height: 440px;
        padding: 24px 24px 36px;
    }
}

.callout-row .strike-card {
    flex: none;
}

.strike-card.tag2 .strike-card-tags-tag2,.strike-card.tag .strike-card-tags-tag {
    display: block;
}

.strike-card-tags {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    display: flex;
    justify-content: space-between;
    left: 0;
    padding-left: 24px;
    padding-right: 24px;
    position: absolute;
    top: 0;
    width: 100%;
}

.strike-card-tags-tag,.strike-card-tags-tag2 {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 4px 8px;
}

.strike-card-tags-tag-color {
    background-color: rgba(132,196,52,0.2);
}

.strike-card-tags-tag p {
    color: #1e7721;
}

.strike-card-tags-tag2 {
    --bg-opacity: 1;
    background-color: #b0001f;
    background-color: rgba(176,0,31,var(--bg-opacity));
}

.strike-card-tags-tag2 p {
    color: #fff;
}

.strike-card-title {
    color: #f7b22e;
    color: rgba(247,178,46,var(--text-opacity));
}

.strike-card-location,.strike-card-title {
    --text-opacity: 1;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
}

.strike-card-location {
    align-items: flex-end;
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
    display: flex;
    margin-bottom: 12px;
}

.strike-card-location svg {
    height: 20px;
    padding-left: 4px;
    width: 20px;
}

.strike-card-location svg .stroke {
    fill: #062c57;
}

.strike-card-description {
    -webkit-box-flex: 1;
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    flex: 1 1;
}

.strike-card .rich-text ul {
    padding-bottom: 16px;
}

.strike-card .rich-text ul li {
    margin-bottom: 8px;
}

.strike-list .strike-card {
    --bg-opacity: 1;
    background-color: #eee;
    background-color: rgba(238,238,238,var(--bg-opacity));
    position: relative;
}

.hero-banner .strike-card {
    --text-opacity: 1;
    background-color: transparent;
    box-shadow: none;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    height: auto;
    margin-bottom: 0;
    padding: 0;
}

.hero-banner .strike-card-title {
    --text-opacity: 1;
    color: #f7b22e;
    color: rgba(247,178,46,var(--text-opacity));
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 4px;
}

.hero-banner .strike-card-location {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    margin-bottom: 16px;
}

.hero-banner .strike-card-description,.hero-banner .strike-card-details {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    font-size: 18px;
    line-height: 28px;
}

.hero-banner .strike-card-description .rich-text ul li,.hero-banner .strike-card-description .rich-text ul li:before,.hero-banner .strike-card-description p,.hero-banner .strike-card-details .rich-text ul li,.hero-banner .strike-card-details .rich-text ul li:before,.hero-banner .strike-card-details p {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.hero-banner .strike-card a.cta-primary-medium {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .hero-banner .strike-card a.cta-primary-medium:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #002146;
        background-color: rgba(0,33,70,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.hero-banner .strike-card a.cta-primary-medium:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #666;
    background-color: rgba(102,102,102,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.hero-banner .strike-card svg .stroke {
    fill: #fff;
}

.card-carousel .strike-card-details {
    display: none;
}

.mobile-swiper-item .strike-card .rich-text ul {
    padding-left: 20px;
}

.promo-callout-strike .card-carousel-btn.prev {
    margin-right: -40px;
    z-index: 1;
}

.promo-callout-strike .card-carousel-btn.next {
    margin-right: -20px;
    position: relative;
    right: 20px;
}

.promo-callout-strike .link-small:before {
    content: "â€º";
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    right: -12px;
}

.promo-callout-strike a.cta-primary-medium {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
}

.promo-callout-strike a.cta-primary-medium:hover {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #002146;
    background-color: rgba(0,33,70,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.promo-callout-strike a.cta-primary-medium:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #666;
    background-color: rgba(102,102,102,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.promo-callout-strike-row {
    display: flex;
}

.promo-callout-strike-row .callout {
    margin-right: 16px;
}

.promo-callout-strike-row .callout-img {
    height: 24px;
    margin-bottom: 8px;
    width: 24px;
}

@media (min-width: 1200px) {
    .promo-callout-strike-row .callout-img {
        height:24px;
        width: 24px;
    }
}

.promo-callout-strike-row .callout-heading {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    font-size: 14px;
    line-height: 17px;
    word-spacing: 30000px;
}

.mobile-swiper {
    --n: 0;
    --neg: -100%;
    --po: 0px;
    overflow-x: hidden;
    width: 100%;
}

.mobile-swiper-container {
    align-items: stretch;
    display: flex;
    max-height: 100vh;
    overflow-y: hidden;
    transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--po)));
    width: 100%;
    width: calc(var(--n) * 100%);
}

.mobile-swiper .smooth {
    transition: transform calc(var(--f) * 0.5s) ease-out;
}

.mobile-swiper-slide {
    --pr: 0px;
    display: block;
    margin: 0 4px;
    padding-right: var(--pr);
    width: 100%;
    width: calc(100% / var(--n) - var(--po));
    z-index: 2;
}

@media (min-width: 768px) {
    .mobile-swiper-slide {
        margin:0;
    }
}

.mobile-swiper-slide > div {
    margin: 0 auto;
}

.mobile-swiper-item {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    margin-right: 8px;
}

.mobile-swiper-item .rich-text ul {
    padding-left: 0;
}

.dot-navigation {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
}

.dot-navigation-btn {
    --bg-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    border-radius: 100%;
    height: 15px;
    margin-right: 12px;
    width: 15px;
}

.dot-navigation-btn.active {
    --bg-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
}

.swiper-buttons {
    align-items: center;
    display: none;
    height: 100%;
    left: 28px;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: calc(100% - 56px);
}

@media (min-width: 768px) {
    .swiper-buttons {
        display: flex;
    }
}

.swiper-buttons button {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    background-color: #efeeed;
    border-radius: 100%;
    display: flex;
    height: 40px;
    justify-content: center;
    margin-bottom: 48px;
    pointer-events: auto;
    width: 40px;
}

.swiper-buttons button svg {
    fill: #2257b8;
    height: 40px;
    width: 40px;
}

.swiper-buttons-backwards {
    left: 0;
    position: absolute;
}

.swiper-buttons-forwards {
    position: absolute;
    right: 0;
}

.swiper .dot-navigation-btn {
    --bg-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    border: 2px solid #fff;
}

.swiper .dot-navigation-btn.active {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
}

.swiper ul {
    list-style: none;
}

.swiper ul .mobile-swiper-slide {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    display: flex;
    justify-content: center;
}

.testimonial-slide {
    position: relative;
}

@media (min-width: 1366px) {
    .testimonial-slide {
        display: flex;
    }
}

.testimonial-slide-media img {
    height: auto;
    width: 100%;
}

.testimonial-slide-media iframe.videoBlock {
    height: 481px;
}

@media (min-width: 768px) {
    .testimonial-slide-media {
        margin-left:-165px;
        min-width: 50%;
        width: 100%;
    }
}

@media (min-width: 1366px) {
    .testimonial-slide-media {
        max-height:567px;
        position: relative;
    }

    .testimonial-slide-media iframe.videoBlock {
        width: 701px;
    }
}

.testimonial-slide-content {
    --bg-opacity: 1;
    background-color: #84c434;
    background-color: rgba(132,196,52,var(--bg-opacity));
    box-shadow: 5px 1px 6px rgba(0,0,0,0.14902);
    margin: -24px auto 0;
    padding: 12px;
    position: relative;
    width: calc(100% - 24px);
}

@media (min-width: 768px) {
    .testimonial-slide-content {
        max-width:50%;
        min-width: 50%;
        padding: 24px;
        width: 100%;
    }
}

@media (min-width: 1366px) {
    .testimonial-slide-content {
        position:relative;
    }
}

.testimonial-slide-embelishment {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    top: 80%;
    z-index: -1;
}

@media (min-width: 1366px) {
    .testimonial-slide-embelishment {
        overflow:hidden;
        top: 35%;
    }

    .testimonial-slide-embelishment img,.testimonial-slide-embelishment svg {
        height: 360px;
        width: 360px;
    }
}

@media (min-width: 768px) {
    .testimonial-block--card .testimonial-block-container {
        padding-bottom:80px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card .testimonial-block-container {
        padding-bottom:100px;
        padding-top: 140px;
    }
}

.testimonial-block--card .testimonial-slide .rich-text {
    --text-opacity: 1;
    color: #000;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 18px;
    letter-spacing: 0.09px;
    line-height: 28px;
    padding-top: 0;
}

.testimonial-block--card .testimonial-slide-content {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: none;
    display: flex;
    flex-direction: column-reverse;
    margin: 0;
    max-width: none;
    min-width: none;
    padding: 8px 24px 24px;
    width: 100%;
}

@media (min-width: 768px) {
    .testimonial-block--card .testimonial-slide-content {
        margin-left:20px;
        margin-right: 20px;
        padding: 24px 128px 16px 48px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card .testimonial-slide-content {
        margin-left:20px;
        margin-right: 20px;
        padding: 24px 96px 32px 16px;
    }
}

.testimonial-block--card .testimonial-slide-content-cta {
    padding-right: 20px;
    width: fit-content;
}

.testimonial-block--card .testimonial-slide-content-cta:before {
    content: "â€º";
    font-size: 25px;
    position: absolute;
    right: 0;
}

@media (min-width: 768px) {
    .testimonial-block--card .testimonial-slide-content-cta {
        margin-left:44px;
    }
}

.testimonial-block--card .testimonial-slide-content cite {
    height: 64px;
    padding-bottom: 8px;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation {
    align-items: center;
    display: flex;
    flex-direction: row;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-profile {
    height: 48px;
    margin-right: 24px;
    width: 48px;
}

@media (min-width: 1366px) {
    .testimonial-block--card .testimonial-slide-content .block-quote-citation-profile {
        height:56px;
        width: 56px;
    }
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-profile img {
    border-radius: 100%;
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-name {
    padding-right: 4px;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-role {
    font-size: 16px;
    line-height: 20px;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-position {
    display: none;
}

.testimonial-block--card .testimonial-slide-content .card-quote {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    height: 240px;
    letter-spacing: 0.08px;
    margin-bottom: 0;
    padding: 0;
    text-align: left;
}

@media (min-width: 768px) {
    .testimonial-block--card .testimonial-slide-content .card-quote {
        height:128px;
        margin-left: 80px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card .testimonial-slide-content .card-quote {
        font-size:16px;
        height: 200px;
        line-height: 20px;
    }
}

.testimonial-block--card .testimonial-slide-content .card-quote:before {
    display: none;
}

.testimonial-block--card .testimonial-slide-content .card-quote:after {
    display: none;
}

.testimonial-block--card .testimonial-slide-embelishment,.testimonial-block--card .testimonial-slide-media {
    display: none;
}

.testimonial-block--card-swiper ul {
    padding: 0;
}

.testimonial-block--card-swiper .swiper-buttons {
    top: -60px;
}

@media (min-width: 768px) {
    .testimonial-block--card-swiper .swiper-buttons {
        top:0;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card-swiper .swiper-buttons {
        top:-36px;
    }
}

.testimonial-block--card-swiper .swiper-buttons-backwards {
    margin-left: 24px;
}

@media (min-width: 768px) {
    .testimonial-block--card-swiper .swiper-buttons-backwards {
        margin-top:24px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card-swiper .swiper-buttons-backwards {
        margin-left:16px;
        margin-top: 0;
    }
}

.testimonial-block--card-swiper .swiper-buttons-forwards {
    margin-right: 36px;
}

@media (min-width: 768px) {
    .testimonial-block--card-swiper .swiper-buttons-forwards {
        margin-top:24px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card-swiper .swiper-buttons-forwards {
        margin-right:24px;
        margin-top: 0;
    }
}

.testimonial-block--card-swiper .dot-navigation {
    margin-bottom: 0;
}

@media (min-width: 768px) {
    .testimonial-block--card-swiper .dot-navigation {
        display:none;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card-swiper .dot-navigation {
        display:block;
        margin-top: 60px;
    }
}

.testimonial-block {
    background: radial-gradient(circle at top,transparent,#dde6ed);
    padding-bottom: 12px;
}

@media (min-width: 768px) {
    .testimonial-block {
        padding-bottom:45px;
    }
}

.testimonial-block .carousel-mask {
    padding-bottom: 12px;
}

@media (min-width: 768px) {
    .testimonial-block .carousel-mask {
        padding-bottom:24px;
    }
}

.testimonial-block.testimonial-block--card {
    background: none;
    position: relative;
}

.testimonial-block.testimonial-block--card .testimonial-block-bg {
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: -1;
}

.testimonial-block.testimonial-block--card .testimonial-block-bg img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.testimonial-block.testimonial-block--card .testimonial-block-bg:after {
    background: transparent linear-gradient(0deg,rgba(255,255,255,0),rgba(0,0,0,0.98039)) 0 0 no-repeat padding-box;
    content: " ";
    height: 30%;
    left: 0;
    opacity: 0.54;
    position: absolute;
    top: 0;
    width: 100%;
}

@media (min-width: 768px) {
    .testimonial-block.testimonial-block--card .testimonial-block-bg:after {
        background: transparent linear-gradient(270deg,rgba(255,255,255,0),rgba(0,0,0,0.98039)) 0 0 no-repeat padding-box;
        height: 100%;
        opacity: 0.34;
        width: 83%;
    }
}

@media (min-width: 1366px) {
    .testimonial-block.testimonial-block--card .testimonial-block-bg:after {
        background: transparent linear-gradient(270deg,rgba(255,255,255,0),rgba(0,0,0,0.98039)) 0 0 no-repeat padding-box;
        height: 100%;
        opacity: 0.34;
        width: 66%;
    }
}

.testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 52px;
    height: 129px;
    line-height: 54px;
}

@media (min-width: 768px) {
    .testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        flex-direction: row;
        height: auto;
        justify-content: center;
        line-height: 72px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        flex-direction: column;
        font-size: 152px;
        justify-content: flex-start;
        line-height: 152px;
        padding-bottom: 24px;
    }
}

.testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading span {
   
    z-index: 1;
}

.trending-news {
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
    max-width: 366px;
    padding-left: 24px;
    padding-right: 24px;
}

@media (min-width: 768px) {
    .trending-news {
        max-width:100%;
    }
}

@media (min-width: 1366px) {
    .trending-news {
        max-width:432px;
    }
}

.trending-news-title {
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
    font-size: 22px;
    line-height: 28px;
    line-height: 46px;
}

@media (min-width: 1366px) {
    .trending-news-title {
        font-size:24px;
        font-size: 32px;
        line-height: 34px;
        margin-bottom: 24px;
    }
}

.trending-news-item {
    padding-bottom: 16px;
    padding-top: 16px;
}

.trending-news-item-image {
    margin-left: 16px;
}

.trending-news-item-image img {
    border-radius: 8px;
    object-fit: cover;
    width: 100%;
}

.trending-news-item-content-category {
    --text-opacity: 1;
    color: #2257b8;
    color: rgba(34,87,184,var(--text-opacity));
    font-size: 12px;
    line-height: 16px;
    padding-bottom: 8px;
    text-transform: uppercase;
}

@media (min-width: 768px) {
    .trending-news-item-content-category {
        font-size:14px;
        line-height: 14px;
    }
}

@media (min-width: 1366px) {
    .trending-news-item-content-seperator {
        --text-opacity:1;
        border-right: 1px solid #979797;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
        display: inline;
       
        margin-left: 8px;
        margin-right: 8px;
    }
}

.trending-news-item-content-date {
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
   
    font-size: 12px;
    line-height: 16px;
    margin-left: 16px;
    padding-bottom: 8px;
    text-transform: uppercase;
}

@media (min-width: 768px) {
    .trending-news-item-content-date {
        --text-opacity:1;
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        font-size: 14px;
        line-height: 14px;
    }
}

@media (min-width: 1366px) {
    .trending-news-item-content-date {
        margin-left:0;
    }
}

.trending-news-item-content-title {
    margin-bottom: 16px;
}

.trending-news-item-content-summary,.trending-news-item-content-summary p {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 14px;
    line-height: 22px;
}

@media (min-width: 768px) {
    .trending-news-item-content-summary,.trending-news-item-content-summary p {
        font-size:16px;
        line-height: 24px;
    }
}

@media (min-width: 1366px) {
    .trending-news-item-content-summary,.trending-news-item-content-summary p {
        --text-opacity:1;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
       
        font-size: 14px;
        line-height: 22px;
    }
}

.bigmarker-widget-out-box {
    max-width: 100% !important;
    width: 800px !important;
}

input.submit_registration_form {
    border: 0;
    box-shadow: none;
}

.modalPopup {
    background-color: #fff;
    display: inline-flex;
    height: auto;
    left: 50%;
    margin-left: -216px;
    overflow: auto;
    position: fixed;
    top: 10%;
    width: 432px;
    z-index: 5;
}

@media (max-width: 767px) {
    .modalPopup {
        margin-left:-45%;
        width: 90%;
    }
}

@media (max-width: 374px) {
    .modalPopup {
        margin-left:-44%;
        width: 88%;
    }
}

.modalPopupwrapper {
    display: none;
}

.modalPopup-title {
    --text-opacity: 1;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    font-size: 24px;
    line-height: 28px;
    padding-left: 44px;
    padding-right: 44px;
    padding-top: 16px;
    text-align: center;
}

.modalPopup-overlay {
    background: rgba(0,0,0,0.26667);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 4;
}

.modalPopupImg {
    padding: 0;
}

.modalPopup-desc {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    font-size: 16px;
    line-height: 24px;
    padding-left: 64px;
    padding-right: 64px;
    text-align: center;
}

.closeBtn {
    background-color: #f9f9f9;
    background-color: rgba(249,249,249,var(--bg-opacity));
    border-radius: 20px;
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    padding-left: 8px;
    padding-right: 8px;
}

.closeBtn,.closeBtn:hover {
    --text-opacity: 1;
    --bg-opacity: 1;
    opacity: 1;
}

.closeBtn:hover {
    background-color: #444;
    background-color: rgba(68,68,68,var(--bg-opacity));
    color: #f9f9f9;
    color: rgba(249,249,249,var(--text-opacity));
}

.tooltip {
    --text-opacity: 1;
    background: #052c57 !important;
    border-radius: 15px !important;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    opacity: 1 !important;
    padding: 5px !important;
}

.tooltip-title {
    font-size: 16px;
    line-height: 20px;
    padding-top: 8px;
}

.tooltip-content p,.tooltip-title {
    padding-left: 8px;
    padding-right: 8px;
    text-align: center;
}

.tooltip-content p {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    font-size: 14px;
    line-height: 22px;
    padding-top: 4px;
}

.tooltip-cta {
    font-size: 14px;
    line-height: 14px;
    padding: 16px 8px 8px;
    text-decoration: underline;
}

.__react_component_tooltip.place-left:after {
    border-left: 8px solid #052c57 !important;
}

.__react_component_tooltip.place-right:after {
    border-right: 8px solid #052c57 !important;
}

.__react_component_tooltip.place-top:after {
    border-top: 8px solid #052c57 !important;
}

.__react_component_tooltip.place-bottom:after {
    border-bottom: 8px solid #052c57 !important;
}

@-moz-document url-prefix() {
    .header-nav-utility-row .brand svg {
        width: auto;
    }
}

@media (min-width: 768px) {
    .footer .footer-wrapper {
        grid-gap:16px;
        gap: 16px;
        grid-template-columns: repeat(12,minmax(0,1fr));
        padding-top: 64px;
    }

    .footer .footer-row-top .footer-links {
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        grid-row-gap: 16px;
        display: flex;
        flex-wrap: wrap;
        grid-column: span 8 / span 8;
        justify-content: center;
        row-gap: 16px;
    }

    .footer .footer-row-top .footer-links li {
        --text-opacity: 1;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
        color: #003c69;
        color: rgba(0,60,105,var(--text-opacity));
       
        font-size: 16px;
        letter-spacing: 0.08px;
        line-height: 24px;
        padding-bottom: 0;
        padding-left: 16px;
        padding-right: 16px;
    }

    .footer .footer-row-top .footer-contact-social {
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        grid-row-gap: 16px;
        grid-row-gap: 8px;
        flex-wrap: wrap;
        grid-column: span 2 / span 2;
        justify-content: center;
        justify-self: end;
        margin-bottom: 0;
        row-gap: 16px;
        row-gap: 8px;
    }
}

@media (min-width: 1366px) {
    .footer .footer-row-top .footer-contact-social {
        -webkit-box-pack:end;
        -ms-flex-pack: end;
        grid-row-gap: 16px;
        grid-column: span 2 / span 2;
        grid-column-start: 11;
        justify-content: flex-end;
        row-gap: 16px;
    }
}

@media (min-width: 768px) {
    .footer .footer-row-top #ot-sdk-btn.ot-sdk-show-settings {
        --text-opacity:1;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
        color: #003c69;
        color: rgba(0,60,105,var(--text-opacity));
       
        font-size: 16px;
        letter-spacing: 0.08px;
        line-height: 24px;
        padding-bottom: 0;
        padding-right: 0;
    }

    .block-collection {
        padding-bottom: 8px;
        padding-top: 8px;
    }
}

.block-collection-wrapper {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    justify-items: center;
}

@media (min-width: 768px) {
    .block-collection-wrapper {
        grid-row-gap:40px;
        grid-template-columns: repeat(12,minmax(0,1fr));
        row-gap: 40px;
    }
}

.block-collection .block-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
    font-size: 32px;
    grid-column: span 6 / span 6;
    line-height: 36px;
}

@media (min-width: 1366px) {
    .block-collection .block-title {
        font-size:48px;
        line-height: 52px;
    }
}

@media (min-width: 768px) {
    .block-collection .block-title {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .block-collection .block-title {
        line-height:40px;
    }
}

.block-collection .blocks-container {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-column: span 6 / span 6;
    grid-template-columns: repeat(6,minmax(0,1fr));
}

@media (min-width: 768px) {
    .block-collection .blocks-container {
        grid-row-gap:40px;
        grid-column: span 12 / span 12;
        grid-template-columns: repeat(12,minmax(0,1fr));
        margin-left: 8px;
        margin-right: 8px;
        row-gap: 40px;
    }
}

.block-collection .blocks-container > div {
    background-color: transparent;
    background: transparent;
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .block-collection .blocks-container > div {
        grid-column:span 12 / span 12;
    }
}

.block-collection .blocks-container .section-container {
    margin: 0;
    padding: 0;
}

.block-collection .blocks-container .promo-callout {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.block-collection .blocks-container .base-page-content > div {
    background: transparent;
}

.block-collection .block-cta {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    background-color: #0098db;
    background-color: rgba(0,152,219,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: none;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 24px;
    grid-column: span 6 / span 6;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding: 12px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .block-collection .block-cta:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.block-collection .block-cta > span,.block-collection .block-cta i,.block-collection .block-cta svg {
    display: inline;
}

.block-collection .block-cta svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .block-collection .block-cta:hover {
        --bg-opacity:1;
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
    }
}

.block-collection .block-cta:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .block-collection .block-cta:disabled:hover {
        background-color:transparent;
    }
}

.block-collection .block-cta:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 12px;
    position: relative;
}

.block-collection .block-cta:hover {
    --bg-opacity: 1;
    background-color: #003c69;
    background-color: rgba(0,60,105,var(--bg-opacity));
}

@media (min-width: 768px) {
    .block-collection .block-cta {
        grid-column:span 12 / span 12;
        margin: 24px 24px 8px;
    }
}

.category-block-dropdown summary {
    justify-content: center;
}

.category-block-dropdown summary p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    margin-bottom: 32px;
    text-align: center;
}

@media (min-width: 1366px) {
    .category-block-dropdown summary p {
        line-height:48px;
    }
}

.category-block-dropdown .category-block-entries {
    grid-gap: 16px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    gap: 16px;
    grid-template-columns: repeat(auto-fit,100%);
    justify-content: center;
}

@media (min-width: 768px) {
    .category-block-dropdown .category-block-entries {
        grid-template-columns:repeat(auto-fit,75%);
    }
}

@media (min-width: 1366px) {
    .category-block-dropdown .category-block-entries {
        grid-template-columns:repeat(auto-fit,32%);
    }

    .category-block-dropdown .category-block-entries .category-block-entry {
        box-shadow: 0 1px 20px rgba(0,0,0,0.0902);
        width: 432px;
    }
}

.category-block-dropdown .category-block-entries .category-block-entry-tags {
    display: none;
}

.category-block-dropdown .category-block-entries .category-block-entry-content {
    flex-grow: 1;
}

.category-block-dropdown .category-block-entries .category-block-entry-content-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));

    font-size: 24px;
    line-height: 28px;
    margin-top: 8px;
    padding-bottom: 8px;
}

@media (min-width: 1366px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content-title {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        color: #003c69;
        color: rgba(0,60,105,var(--text-opacity));
    
       
        font-size: 40px;
        font-size: 16px;
        line-height: 44px;
        line-height: 20px;
        padding-bottom: 16px;
    }
}

@media (min-width: 1366px) and (min-width:1366px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content-title {
        font-size:32px;
        line-height: 36px;
    }
}

.category-block-dropdown .category-block-entries .category-block-entry-content-subheading {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
   
    font-size: 16px;
    line-height: 20px;
}

@media (min-width: 1366px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content-subheading {
        font-size:20px;
        line-height: 24px;
    }
}

@media (min-width: 768px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content-subheading {
        line-height:26px;
        padding-bottom: 8px;
    }
}

@media (min-width: 1366px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content-subheading {
        padding-bottom:16px;
    }
}

.category-block-dropdown .category-block-entries .category-block-entry-content .body-small {
    font-size: 16px;
    line-height: 24px;
}

@media (min-width: 768px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content .body-small {
        padding-bottom:16px;
    }
}

.category-block-dropdown .category-block-entries .category-block-entry-content-row {
    align-items: center;
}

.category-block-dropdown .category-block-entries .category-block-entry-content-row-primary,.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));

   
   
    font-size: 16px;
    line-height: 20px;
    padding: 0;
}

@media (min-width: 1366px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content-row-primary,.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {
        font-size:20px;
        line-height: 24px;
    }
}

@media (min-width: 768px) {
    .category-block-dropdown .category-block-entries .category-block-entry-content-row-primary,.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {
        line-height:26px;
    }
}

.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {
    padding-bottom: 0 !important;
    padding-left: 8px;
}

.category-block-dropdown .category-block-entries .category-block-entry-links {
    display: flex;
    flex-direction: column-reverse;
}

.category-block-dropdown .category-block-entries .category-block-entry-links .link-small:hover:before {
    display: none;
}

.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a {
    border: 2px solid #0098db;
    border-radius: 8px;
    color: #005bbb !important;
    display: inline-block;
   
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    margin-bottom: 24px;
    padding: 6px 16px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a > span,.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a i,.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a svg {
    display: inline;
}

.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        color: #fff !important;
    }
}

.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a:hover:before {
    display: none;
}

.category-block-dropdown .category-block-entries .category-block-entry-links > :last-child {
    padding-bottom: 24px;
    padding-top: 16px;
}

.category-block-dropdown .category-block-entries .category-block-entry-links > :last-child a {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
   
    font-size: 16px;
    line-height: 20px;
}

@media (min-width: 1366px) {
    .category-block-dropdown .category-block-entries .category-block-entry-links > :last-child a {
        font-size:20px;
        line-height: 24px;
    }
}

@media (min-width: 768px) {
    .category-block-dropdown .category-block-entries .category-block-entry-links > :last-child a {
        line-height:26px;
    }
}

.callout .callout-heading {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    font-size: 32px;
    line-height: 36px;
    line-height: 38px;
}

.callout-img {
    width: 100%;
}

.callout-content,.callout-content .rich-text {
    padding-left: 0;
    padding-right: 0;
}

.callout-content p {
    text-align: inherit !important;
}

@media (min-width: 768px) {
    .callout .callout-row-wrapper {
        flex-direction: row;
    }

    .callout .callout-row-wrapper .mobile-swiper-item {
        flex: 0 0 49%;
    }
}

@media (min-width: 1366px) {
    .callout .callout-row-wrapper .mobile-swiper-item {
        flex: unset;
    }
}

@media (max-width: 767px) {
    .callout .mobile-swiper .mobile-swiper-item .base-page-content,.callout .mobile-swiper .mobile-swiper-item > div {
        -webkit-box-pack:center;
        -ms-flex-pack: center;
        display: flex;
        justify-content: center;
    }

    .callout .mobile-swiper .dot-navigation {
        margin-left: 4px;
        margin-right: 4px;
    }

    .callout .mobile-swiper .dot-navigation button {
        margin-left: 6px;
        margin-right: 6px;
    }
}

.callout-row-subtitle {
    margin-bottom: 24px;
}

.callout-row .callout-row-wrapper {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    grid-gap: 8px;
    display: flex;
    flex-wrap: wrap;
    grid-template-columns: unset;
    justify-content: center;
}

.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2) ~ .mobile-swiper-item {
    margin-left: 0;
    margin-right: 0;
    width: 49%;
}

.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3) ~ .mobile-swiper-item {
    margin-left: 0;
    margin-right: 0;
    width: 32%;
}

.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4) ~ .mobile-swiper-item {
    margin-left: 0;
    margin-right: 0;
    width: 24%;
}

.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5) ~ .mobile-swiper-item {
    margin-left: 0;
    margin-right: 0;
    width: 32%;
}

.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6) ~ .mobile-swiper-item {
    margin-left: 0;
    margin-right: 0;
    width: 32%;
}

.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7) ~ .mobile-swiper-item {
    margin-left: 0;
    margin-right: 0;
    width: 24%;
}

.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8) ~ .mobile-swiper-item {
    margin-left: 0;
    margin-right: 0;
    width: 24%;
}

@media (min-width: 1366px) {
    .callout-row .callout-row-wrapper {
        grid-gap:16px;
        gap: 16px;
    }

    .callout-row .callout-row-wrapper .callout--left .callout-content {
        padding-left: 0;
        padding-right: 0;
    }

    .callout-row .callout-row-wrapper .callout--left .callout-content .rich-text p {
        text-align: left !important;
    }

    .callout-row .callout-row-wrapper .callout--left .callout-contentp {
        text-align: left;
    }

    .callout-row .callout-row-wrapper .callout--left .callout-cta {
        margin-left: 0;
        text-align: left;
    }
}

.cutout-block.section-container {
    max-width: 100%;
}

.cutout-block .swiper-buttons-backwards:before {
    content: "âŒ©";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
}

.cutout-block .swiper-buttons-forwards:before {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
}

.dynamic-faq-content-heading-eyebrow {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));

    font-size: 16px;
    line-height: 16px;
}

@media (min-width: 768px) {
    .dynamic-faq-content-heading-eyebrow {
        --text-opacity:1;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
    
        font-size: 16px;
        line-height: 16px;
    }
}

.dynamic-faq-content-faq-entry summary {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    font-size: 24px;
    line-height: 30px;
}

@media (min-width: 768px) {
    .dynamic-faq-content-faq-entry summary {
        --text-opacity:1;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
    }
}

@media (min-width: 1366px) {
    .dynamic-faq-content-faq-entry summary {
        --text-opacity:1;
        color: #444;
        color: rgba(68,68,68,var(--text-opacity));
    }
}

.dynamic-faq-content-faq-entry p {
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 0;
}

.dynamic-faq-content-faq-entry[open] {
    padding-bottom: 72px;
}

.dynamic-faq-content-cta a {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 18px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.dynamic-faq-content-cta a:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.dynamic-faq-content-cta a:after {
    display: none;
}

@media (hover: hover) {
    .dynamic-faq-content-cta a:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .dynamic-faq-content-cta a:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.dynamic-faq-content-cta a.wrapper:after {
    width: 0;
}

@media (min-width: 1366px) {
    .dynamic-faq-content-cta a {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        display: block;
       
        font-size: 18px;
        line-height: 22px;
        position: relative;
        text-decoration: none;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
        width: fit-content;
    }

    .dynamic-faq-content-cta a:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        bottom: 0;
        content: "";
        display: block;
        height: 1.5px;
        opacity: 0;
        position: absolute;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
        width: 100%;
    }

    .dynamic-faq-content-cta a:after {
        display: none;
    }
}

@media (min-width: 1366px) and (hover:hover) {
    .dynamic-faq-content-cta a:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .dynamic-faq-content-cta a:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (min-width: 1366px) {
    .dynamic-faq-content-cta a.wrapper:after {
        width:0;
    }
}

.news-content-side .EPiServerForms {
    max-width: 864px;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox {
    max-width: 864px;
    position: relative;
    width: 100%;
}

@media (min-width: 1366px) {
    .news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox {
        width:416px;
    }
}

.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha label,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime label,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload label,.news-content-side .EPiServerForms .Form__MainBody section .FormRange label,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection label,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox label {
    --text-opacity: 1;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
    font-size: 18px;
    text-align: left;
    top: 26px;
    transition: top 0.5s,font-size 0.5s;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormRange label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox label.has-data {
    background-color: #fff;
    font-size: 12px;
    top: -11px;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormRange[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label {
    background-color: #fff;
    color: #2257b8;
    font-size: 12px;
    top: -11px;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormRange:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {
    background-color: #fff;
    color: #2257b8;
    font-size: 12px;
    top: -11px;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormSelection:after {
    top: 37px;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormChoice label {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: flex-start;
    justify-content: center;
}

.news-content-side .EPiServerForms .Form__MainBody section .FormChoice label input {
    height: 18px;
    margin: 6px;
}

.news-content-side .EPiServerForms .Form__MainBody section input,.news-content-side .EPiServerForms .Form__MainBody section select,.news-content-side .EPiServerForms .Form__MainBody section textarea {
    height: 80px;
}

.news-content-side .EPiServerForms .Form__MainBody section input::placeholder,.news-content-side .EPiServerForms .Form__MainBody section select::placeholder,.news-content-side .EPiServerForms .Form__MainBody section textarea::placeholder {
    --text-opacity: 1;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
}

.news-content-side .EPiServerForms .Form__MainBody section a.button,.news-content-side .EPiServerForms .Form__MainBody section button {
    margin-left: 0;
    margin-right: auto;
    width: unset;
}

.news-content-side .EPiServerForms .Form__MainBody section a.button,.news-content-side .EPiServerForms .Form__MainBody section a.button > a,.news-content-side .EPiServerForms .Form__MainBody section a.button > button,.news-content-side .EPiServerForms .Form__MainBody section button,.news-content-side .EPiServerForms .Form__MainBody section button > a,.news-content-side .EPiServerForms .Form__MainBody section button > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 24px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding: 12px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .news-content-side .EPiServerForms .Form__MainBody section a.button:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:hover,.news-content-side .EPiServerForms .Form__MainBody section button:hover,.news-content-side .EPiServerForms .Form__MainBody section button > a:hover,.news-content-side .EPiServerForms .Form__MainBody section button > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.news-content-side .EPiServerForms .Form__MainBody section a.button > a > span,.news-content-side .EPiServerForms .Form__MainBody section a.button > a i,.news-content-side .EPiServerForms .Form__MainBody section a.button > a svg,.news-content-side .EPiServerForms .Form__MainBody section a.button > button > span,.news-content-side .EPiServerForms .Form__MainBody section a.button > button i,.news-content-side .EPiServerForms .Form__MainBody section a.button > button svg,.news-content-side .EPiServerForms .Form__MainBody section a.button > span,.news-content-side .EPiServerForms .Form__MainBody section a.button i,.news-content-side .EPiServerForms .Form__MainBody section a.button svg,.news-content-side .EPiServerForms .Form__MainBody section button > a > span,.news-content-side .EPiServerForms .Form__MainBody section button > a i,.news-content-side .EPiServerForms .Form__MainBody section button > a svg,.news-content-side .EPiServerForms .Form__MainBody section button > button > span,.news-content-side .EPiServerForms .Form__MainBody section button > button i,.news-content-side .EPiServerForms .Form__MainBody section button > button svg,.news-content-side .EPiServerForms .Form__MainBody section button > span,.news-content-side .EPiServerForms .Form__MainBody section button i,.news-content-side .EPiServerForms .Form__MainBody section button svg {
    display: inline;
}

.news-content-side .EPiServerForms .Form__MainBody section a.button > a svg,.news-content-side .EPiServerForms .Form__MainBody section a.button > button svg,.news-content-side .EPiServerForms .Form__MainBody section a.button svg,.news-content-side .EPiServerForms .Form__MainBody section button > a svg,.news-content-side .EPiServerForms .Form__MainBody section button > button svg,.news-content-side .EPiServerForms .Form__MainBody section button svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.news-content-side .EPiServerForms .Form__MainBody section a.button:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:disabled,.news-content-side .EPiServerForms .Form__MainBody section button:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > a:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .news-content-side .EPiServerForms .Form__MainBody section a.button:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section button:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > a:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.news-content-side .EPiServerForms .Form__MainBody section a.button.inverted,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted,.news-content-side .EPiServerForms .Form__MainBody section button.inverted,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.news-content-side .EPiServerForms .Form__MainBody section a.button:after,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:after,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:after,.news-content-side .EPiServerForms .Form__MainBody section button:after,.news-content-side .EPiServerForms .Form__MainBody section button > a:after,.news-content-side .EPiServerForms .Form__MainBody section button > button:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 12px;
    position: relative;
}

.news-content-side .EPiServerForms .Form__MainBody section a.button.wrapper,.news-content-side .EPiServerForms .Form__MainBody section button.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

@media (max-width: 767px) {
    .news-content-side .EPiServerForms .Form__MainBody section .Form__Element {
        margin-left:24px;
        margin-right: 24px;
    }
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal {
    grid-column-gap: 4px;
    column-gap: 4px;
    display: inline-block;
    flex-wrap: wrap;
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a {
    display: inline-block;
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex),.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 14px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {
    opacity: 0;
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:after {
    display: none;
}

@media (hover: hover) {
    .news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex).wrapper:after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a.wrapper:after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button.wrapper:after {
    width: 0;
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a.inline {
    display: inline-block;
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 1;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {
    opacity: 0;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):not(.flex),.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:not(.flex),.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:not(.flex) {
    display: inline-block;
}

.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p {
   
    font-size: 16px;
    line-height: 24px;
}

.news-content-side .enhanced-form-color {
    border-radius: 8px;
    padding-bottom: 0;
    padding-top: 0;
}

.news-content-side .enhanced-form-color .enhanced-form {
    background-image: none;
    width: 100%;
}

.news-content-side .enhanced-form-color .enhanced-form-content {
    margin-top: 32px;
    padding-left: 0;
    padding-right: 0;
}

.news-content-side .enhanced-form-color .enhanced-form .layout-container {
    background-image: none;
    border-radius: 8px;
    padding: 0 !important;
}

.news-content-side .enhanced-form-color .enhanced-form .layout-container .Form__Title {
    display: none;
}

.news-content-side .enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form {
    background-image: none;
    max-width: 100%;
    padding: 0;
}

.news-content-side .enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form .layout-container {
    background-color: transparent;
    background-image: none;
    border-radius: 0;
    padding: 0 48px !important;
}

.news-content-side .EPiServerForms .Form__Description,.news-content-side .EPiServerForms .Form__Title {
    --text-opacity: 1;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
}

.enhanced-form-color {
    background-color: #d3d3d3;
    background-size: cover;
    padding-bottom: 0;
}

.enhanced-form-color .enhanced-form-color {
    background-color: transparent;
    background-image: none;
}

.enhanced-form-color .enhanced-form-color .layout-container {
    padding: 0 !important;
}

.enhanced-form-color .enhanced-form {
    box-shadow: none !important;
    max-width: 1328px;
}

.enhanced-form-color .enhanced-form .Form__Description,.enhanced-form-color .enhanced-form .Form__Title {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.enhanced-form-color .enhanced-form .Form__Title {
    padding-top: 8px;
}

.enhanced-form-color .enhanced-form-content {
    display: block !important;
}

@media (min-width: 1366px) {
    .enhanced-form-color .enhanced-form-content {
        display:block;
        grid-column: 1/6;
        margin-bottom: auto;
        margin-top: 0;
        padding-left: 48px;
        padding-right: 48px;
    }
}

.enhanced-form-color .enhanced-form-content-eyebrow {
    color: #fff;
    display: block;
}

.enhanced-form-color .enhanced-form-content-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #fff;

    font-size: 24px;
    line-height: 28px;
}

@media (min-width: 1366px) {
    .enhanced-form-color .enhanced-form-content-title {
        font-size:40px;
        line-height: 44px;
    }
}

.enhanced-form-color .enhanced-form-content-description {
    color: #fff;
    padding-top: 24px;
}

.enhanced-form-color .enhanced-form-content-description .rich-text p {
    color: #fff;
}

.enhanced-form-color .enhanced-form-content-description .rich-text a,.enhanced-form-color .enhanced-form-content-description .rich-text a:visited {
    color: #fff;
    text-decoration: underline;
}

.enhanced-form-color .enhanced-form-content-summary {
    color: #fff;
    padding-top: 24px;
}

.enhanced-form-color .enhanced-form-content-summary .rich-text p {
    color: #fff;
}

.enhanced-form-color .enhanced-form-content-summary .rich-text a,.enhanced-form-color .enhanced-form-content-summary .rich-text a:visited {
    color: #fff;
    text-decoration: underline;
}

.enhanced-form-color .enhanced-form-container,.enhanced-form-color .enhanced-form .layout-container {
    border-radius: 8px;
    padding-bottom: 20px;
    padding-top: 20px;
    width: 100%;
}

@media (min-width: 1366px) {
    .enhanced-form-color .enhanced-form-container,.enhanced-form-color .enhanced-form .layout-container {
        background-color:transparent;
        border-radius: unset;
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
        grid-column: 6/13;
        padding-left: 48px;
        padding-right: 48px;
    }

    .enhanced-form-color .enhanced-form-container .EPiServerForms,.enhanced-form-color .enhanced-form .layout-container .EPiServerForms {
        max-width: 656px;
    }
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: none;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    display: inline-block;
   
    font-size: 24px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding: 12px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button > span,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button i,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button svg {
    display: inline;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:hover {
        --bg-opacity:1;
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
    }
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:disabled {
    --text-opacity: 1;
    box-shadow: inset 0 0 0 3px #bbb;
    color: #bbb;
    color: rgba(187,187,187,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:disabled:hover {
        background-color:transparent;
    }
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 12px;
    position: relative;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal {
    grid-column-gap: 4px;
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    column-gap: 4px;
    display: inline-block;
    flex-wrap: wrap;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button {
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 14px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    opacity: 0;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:after {
    display: none;
}

@media (hover: hover) {
    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex).wrapper:after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a.wrapper:after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button.wrapper:after {
    width: 0;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a.inline {
    display: inline-block;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 1;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    opacity: 0;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:not(.flex) {
    display: inline-block;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormCaptcha[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormDateTime[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormRange[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormRange label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormSelection[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormSelection label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormTextbox label.has-data {
    background-color: transparent;
    color: #fff;
    font-size: 16px;
    top: -22px;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormCaptcha:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormDateTime:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormRange:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormSelection:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {
    background-color: transparent;
    color: #fff;
    font-size: 16px;
    top: -22px;
}

.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload input {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.form-layout-block.enhanced-form-color {
    background-size: cover;
}

@media (min-width: 768px) {
    .form-layout-block.enhanced-form-color.section-container {
        margin:0;
        max-width: 100%;
    }
}

.form-layout-block.enhanced-form-color .enhanced-form .layout-container {
    background-color: transparent;
    background-image: none;
}

.form-layout-block.enhanced-form-color .enhanced-form .layout-container .enhanced-form-color {
    background-color: transparent;
}

.form-layout-block.enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form .layout-container {
    background-color: transparent;
    background-image: none;
    padding: 0 !important;
}

.form-layout-block .layout-container .Form__Description,.form-layout-block .layout-container .Form__Title {
    display: none;
}

.form-layout-block .layout-container .enhanced-form-content {
    display: none !important;
}

.scPage-content-side .enhanced-form-color {
    border-radius: 8px;
    padding-top: 0;
}

.scPage-content-side .enhanced-form-color .enhanced-form-content {
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
}

.scPage-content-side .enhanced-form-color .enhanced-form .layout-container {
    padding: 0;
}

.scPage-content-side .enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form {
    width: unset;
}

.EPiServerForms .Form__MainBody section {
    margin-top: 16px;
}

.EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section button {
    margin-left: 0;
    margin-right: auto;
    padding-bottom: 12px;
    padding-top: 12px;
}

.EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section a.button > a,.EPiServerForms .Form__MainBody section a.button > button,.EPiServerForms .Form__MainBody section button,.EPiServerForms .Form__MainBody section button > a,.EPiServerForms .Form__MainBody section button > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 24px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding-left: 32px;
    padding-right: 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .EPiServerForms .Form__MainBody section a.button:hover,.EPiServerForms .Form__MainBody section a.button > a:hover,.EPiServerForms .Form__MainBody section a.button > button:hover,.EPiServerForms .Form__MainBody section button:hover,.EPiServerForms .Form__MainBody section button > a:hover,.EPiServerForms .Form__MainBody section button > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.EPiServerForms .Form__MainBody section a.button > a > span,.EPiServerForms .Form__MainBody section a.button > a i,.EPiServerForms .Form__MainBody section a.button > a svg,.EPiServerForms .Form__MainBody section a.button > button > span,.EPiServerForms .Form__MainBody section a.button > button i,.EPiServerForms .Form__MainBody section a.button > button svg,.EPiServerForms .Form__MainBody section a.button > span,.EPiServerForms .Form__MainBody section a.button i,.EPiServerForms .Form__MainBody section a.button svg,.EPiServerForms .Form__MainBody section button > a > span,.EPiServerForms .Form__MainBody section button > a i,.EPiServerForms .Form__MainBody section button > a svg,.EPiServerForms .Form__MainBody section button > button > span,.EPiServerForms .Form__MainBody section button > button i,.EPiServerForms .Form__MainBody section button > button svg,.EPiServerForms .Form__MainBody section button > span,.EPiServerForms .Form__MainBody section button i,.EPiServerForms .Form__MainBody section button svg {
    display: inline;
}

.EPiServerForms .Form__MainBody section a.button > a svg,.EPiServerForms .Form__MainBody section a.button > button svg,.EPiServerForms .Form__MainBody section a.button svg,.EPiServerForms .Form__MainBody section button > a svg,.EPiServerForms .Form__MainBody section button > button svg,.EPiServerForms .Form__MainBody section button svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.EPiServerForms .Form__MainBody section a.button:disabled,.EPiServerForms .Form__MainBody section a.button > a:disabled,.EPiServerForms .Form__MainBody section a.button > button:disabled,.EPiServerForms .Form__MainBody section button:disabled,.EPiServerForms .Form__MainBody section button > a:disabled,.EPiServerForms .Form__MainBody section button > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .EPiServerForms .Form__MainBody section a.button:disabled:hover:disabled,.EPiServerForms .Form__MainBody section a.button > a:disabled:hover:disabled,.EPiServerForms .Form__MainBody section a.button > button:disabled:hover:disabled,.EPiServerForms .Form__MainBody section button:disabled:hover:disabled,.EPiServerForms .Form__MainBody section button > a:disabled:hover:disabled,.EPiServerForms .Form__MainBody section button > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.EPiServerForms .Form__MainBody section a.button.inverted,.EPiServerForms .Form__MainBody section a.button > a.inverted,.EPiServerForms .Form__MainBody section a.button > button.inverted,.EPiServerForms .Form__MainBody section button.inverted,.EPiServerForms .Form__MainBody section button > a.inverted,.EPiServerForms .Form__MainBody section button > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .EPiServerForms .Form__MainBody section a.button.inverted:hover,.EPiServerForms .Form__MainBody section a.button > a.inverted:hover,.EPiServerForms .Form__MainBody section a.button > button.inverted:hover,.EPiServerForms .Form__MainBody section button.inverted:hover,.EPiServerForms .Form__MainBody section button > a.inverted:hover,.EPiServerForms .Form__MainBody section button > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.EPiServerForms .Form__MainBody section a.button.inverted:active,.EPiServerForms .Form__MainBody section a.button > a.inverted:active,.EPiServerForms .Form__MainBody section a.button > button.inverted:active,.EPiServerForms .Form__MainBody section button.inverted:active,.EPiServerForms .Form__MainBody section button > a.inverted:active,.EPiServerForms .Form__MainBody section button > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.EPiServerForms .Form__MainBody section a.button.inverted:disabled,.EPiServerForms .Form__MainBody section a.button > a.inverted:disabled,.EPiServerForms .Form__MainBody section a.button > button.inverted:disabled,.EPiServerForms .Form__MainBody section button.inverted:disabled,.EPiServerForms .Form__MainBody section button > a.inverted:disabled,.EPiServerForms .Form__MainBody section button > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .EPiServerForms .Form__MainBody section a.button.inverted:disabled:hover,.EPiServerForms .Form__MainBody section a.button > a.inverted:disabled:hover,.EPiServerForms .Form__MainBody section a.button > button.inverted:disabled:hover,.EPiServerForms .Form__MainBody section button.inverted:disabled:hover,.EPiServerForms .Form__MainBody section button > a.inverted:disabled:hover,.EPiServerForms .Form__MainBody section button > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.EPiServerForms .Form__MainBody section a.button.wrapper,.EPiServerForms .Form__MainBody section button.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.EPiServerForms .Form__MainBody section input,.EPiServerForms .Form__MainBody section select,.EPiServerForms .Form__MainBody section textarea {
    height: 80px;
}

.EPiServerForms .Form__MainBody section input:focus,.EPiServerForms .Form__MainBody section select:focus,.EPiServerForms .Form__MainBody section textarea:focus {
    border: 1px solid #2257b8;
    outline: none;
}

.EPiServerForms .Form__MainBody section input:focus::placeholder,.EPiServerForms .Form__MainBody section select:focus::placeholder,.EPiServerForms .Form__MainBody section textarea:focus::placeholder {
    opacity: 1;
}

.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail .Form__Element__ValidationError {
    background-color: red;
    border-radius: 8px;
    color: #fff;
    display: block;
    margin-top: 4px;
    padding: 5px;
    text-align: center;
    width: 100%;
}

.EPiServerForms .Form__MainBody section .FormCaptcha label,.EPiServerForms .Form__MainBody section .FormDateTime label,.EPiServerForms .Form__MainBody section .FormFileUpload label,.EPiServerForms .Form__MainBody section .FormRange label,.EPiServerForms .Form__MainBody section .FormSelection label,.EPiServerForms .Form__MainBody section .FormTextbox label {
    --text-opacity: 1;
    background-color: transparent;
    color: #666;
    color: rgba(102,102,102,var(--text-opacity));
    font-size: 18px;
    left: 10px;
    padding: 0 10px;
    position: absolute;
    top: 28px;
    transition: top 0.5s,font-size 0.5s;
    z-index: 0;
}

.EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.EPiServerForms .Form__MainBody section .FormRange label.has-data,.EPiServerForms .Form__MainBody section .FormSelection label.has-data,.EPiServerForms .Form__MainBody section .FormTextbox label.has-data {
    background-color: #fff;
    font-size: 18px;
    top: -11px;
}

.EPiServerForms .Form__MainBody section .Form__Element {
    margin-bottom: 20px;
}

.EPiServerForms .Form__MainBody section .FormChoice {
    width: 100%;
}

.EPiServerForms .Form__MainBody section .FormChoice fieldset {
    display: flex;
    flex-wrap: wrap;
}

.EPiServerForms .Form__MainBody section .FormChoice fieldset label {
    width: 100%;
}

@media (min-width: 768px) {
    .EPiServerForms .Form__MainBody section .FormChoice fieldset label {
        width:50%;
    }
}

.EPiServerForms .Form__MainBody section .FormSelection:after {
    top: 35px;
}

.EPiServerForms .Form__MainBody section .FormChoice {
    color: #fff;
}

.EPiServerForms .Form__MainBody section .FormChoice__Input {
    min-width: 20px;
}

.EPiServerForms .Form__MainBody section .FormDateTime,.EPiServerForms .Form__MainBody section .FormFileUpload {
    margin-top: 8px;
}

.EPiServerForms .Form__MainBody section .FormDateTime label,.EPiServerForms .Form__MainBody section .FormFileUpload label {
    background-color: transparent;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    top: -25px;
}

.EPiServerForms .Form__MainBody section .FormFileUpload input {
    padding-top: 24px;
}

.EPiServerForms .Form__MainBody section .Form__Element--NonData p {
    color: #fff;
}

.EPiServerForms .Form__MainBody section a button {
    font-size: 12px;
    line-height: 12px;
}

.EPiServerForms a {
    color: #fff;
}

.EPiServerForms a:before {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 1;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.EPiServerForms a:hover {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.EPiServerForms a:hover:before {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    opacity: 0;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

.form-layout-block-wrapper {
    max-height: 699px;
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper {
        min-height:699px;
    }
}

.form-layout-block-wrapper .background {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
}

.form-layout-block-wrapper .background .bg-img {
    width: 100%;
}

.form-layout-block-wrapper .background .bg-img img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.form-layout-block-wrapper .background .bg-img.featured {
    -webkit-box-ordinal-group: 2;
    -ms-flex-order: 1;
    height: 303px;
    order: 1;
}

.form-layout-block-wrapper .background .bg-img.form {
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    min-height: 540px;
    order: 2;
}

.form-layout-block-wrapper .background .bg-img.form img {
    min-height: 540px;
}

@media (min-width: 768px) {
    .form-layout-block-wrapper .background .bg-img.featured {
        height:500px;
    }
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .background {
        flex-direction: row;
        max-height: 699px;
    }

    .form-layout-block-wrapper .background .bg-img {
        width: 50%;
    }

    .form-layout-block-wrapper .background .bg-img.featured {
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        min-height: 699px;
        order: 2;
    }

    .form-layout-block-wrapper .background .bg-img.form {
        order: 1;
    }
}

.form-layout-block-wrapper .form-layout-block {
    grid-gap: 16px;
    box-shadow: none !important;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    position: relative;
    top: 303px;
}

@media (min-width: 768px) {
    .form-layout-block-wrapper .form-layout-block {
        padding-top:48px;
        top: 500px;
    }
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .form-layout-block {
        grid-template-columns:repeat(12,minmax(0,1fr));
        height: 699px;
        padding-bottom: 90px;
        padding-top: 90px;
        top: 0;
    }
}

.form-layout-block-wrapper .form-layout-block .Form__Title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
    font-size: 16px;
    line-height: 20px;
    padding-bottom: 16px;
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .form-layout-block .Form__Title {
        font-size:32px;
        line-height: 36px;
    }
}

.form-layout-block-wrapper .form-layout-block .Form__Description {
   
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 24px;
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .form-layout-block .Form__Description {
        padding-bottom:28px;
    }
}

.form-layout-block-wrapper .form-layout-block .Form__Description,.form-layout-block-wrapper .form-layout-block .Form__Title {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.form-layout-block-wrapper .form-layout-block-container,.form-layout-block-wrapper .form-layout-block .layout-container {
    align-items: center;
    display: flex;
    grid-column: span 6 / span 6;
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .form-layout-block-container,.form-layout-block-wrapper .form-layout-block .layout-container {
        grid-column:span 5 / span 5;
    }
}

.form-layout-block-wrapper .form-layout-block .featured-img {
    grid-column: span 6 / span 6;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section {
    margin-top: 0;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button {
    margin-top: 16px;
    max-height: 60px;
    max-width: fit-content;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 24px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 36px;
    padding: 12px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button svg {
    display: inline;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 12px;
    position: relative;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button {
        margin-top:32px;
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton {
    --bg-opacity: 1;
    background-color: #0098db;
    background-color: rgba(0,152,219,var(--bg-opacity));
    margin-bottom: 0;
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        border-radius: 8px;
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        display: inline-block;
       
        font-size: 24px;
        height: auto;
        letter-spacing: 0.16px;
        line-height: 20px;
        line-height: 36px;
        padding: 12px 32px;
        text-align: center;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (hover: hover) and (hover:hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover svg {
        display:inline;
    }

    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover svg {
        fill: #fff;
        height: 20px;
        margin-right: 4px;
        transform: translateY(-2.5px);
        width: 20px;
    }
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

@media (hover: hover) and (hover:hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        color: #002146;
        color: rgba(0,33,70,var(--text-opacity));
    }
}

@media (hover: hover) and (hover:hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:active {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #2257b8;
        background-color: rgba(34,87,184,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:disabled {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

@media (hover: hover) and (hover:hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:after {
        content:"âŒª";
        font-family: Font Awesome\\6 Pro;
        font-size: 0.75em;
        font-weight: 900;
        left: 12px;
        position: relative;
    }
}

@media (hover: hover) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.wrapper {
        background-color:transparent;
        margin: 0;
        padding: 0;
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section input {
    border-radius: 8px;
    height: 64px;
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section input {
        height:80px;
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox {
    margin-bottom: 16px;
    width: 100%;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox label {
    --text-opacity: 1;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
    top: 20px;
}

@media (min-width: 1366px) {
    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox label {
        top:28px;
    }
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    top: -22px;
}

.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    top: -22px;
}

.destinations-grid,.generic-grid {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
}

.destinations-grid-wrapper > div,.generic-grid-wrapper > div {
    margin-left: 0;
    margin-right: 0;
}

.destinations-grid-content-overline,.generic-grid-content-overline {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
}

.destinations-grid .title,.generic-grid .title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

   
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 16px;
}

@media (min-width: 1366px) {
    .destinations-grid .title,.generic-grid .title {
        font-size:40px;
        line-height: 44px;
    }
}

@media (min-width: 768px) {
    .destinations-grid .title,.generic-grid .title {
        line-height:48px;
    }
}

.destinations-grid .text-content,.generic-grid .text-content {
    margin-bottom: 32px;
}

.destinations-grid-content-link,.generic-grid-content-link {
    display: none;
}

.destinations-grid-media,.generic-grid-media {
    background: transparent;
}

.destinations-grid-media-large img,.generic-grid-media-large img {
    border-radius: 8px;
}

.destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {
    --text-opacity: 1;
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-box-pack: unset;
    -ms-flex-pack: unset;
    align-items: flex-end;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

   
    font-size: 32px;
    justify-content: unset;
    line-height: 36px;
    padding-bottom: 16px;
    text-align: left;
}

@media (min-width: 1366px) {
    .destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {
        font-size:48px;
        line-height: 52px;
    }
}

@media (min-width: 768px) {
    .destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {
        line-height:56px;
        padding-bottom: 24px;
    }
}

@media (min-width: 1366px) {
    .destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {
        padding-bottom:40px;
    }
}

.destinations-grid-media-grid-row-image img,.generic-grid-media-grid-row-image img {
    border-radius: 8px;
}

.destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {
    --text-opacity: 1;
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-box-pack: unset;
    -ms-flex-pack: unset;
    align-items: flex-end;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));

   
    font-size: 24px;
    justify-content: unset;
    line-height: 28px;
    padding-bottom: 16px;
    text-align: left;
    text-shadow: none;
}

@media (min-width: 1366px) {
    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {
        font-size:40px;
        line-height: 44px;
    }
}

@media (min-width: 768px) {
    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    
       
        font-size: 24px;
        line-height: 28px;
        line-height: 48px;
        padding-bottom: 24px;
    }
}

@media (min-width: 768px) and (min-width:1366px) {
    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {
        font-size:40px;
        line-height: 44px;
    }
}

@media (min-width: 1366px) {
    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {
        --text-opacity:1;
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
       
        line-height: 48px;
        padding-bottom: 40px;
    }
}

.hero-banner-form {
    background-color: #efb41d;
}

.hero-banner-form .hero-text-bottom {
    --text-opacity: 1;
    color: #003876;
    color: rgba(0,56,118,var(--text-opacity));
}

.input-text-icon svg {
    fill: #003876;
}

.leadership-block .title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    line-height: 56px;
    margin-bottom: 8px;
    text-align: center;
}

@media (min-width: 768px) {
    .leadership-block .title {
        grid-column:span 12 / span 12;
    }
}

.leadership-block .mobile-swiper .dot-navigation {
    margin-top: 48px;
}

.leadership-block .mobile-swiper-item {
    width: 100%;
}

@media (min-width: 768px) {
    .leadership-block .mobile-swiper-item {
        grid-column:span 4 / span 4;
        margin-bottom: 0;
        padding-left: 8px;
        padding-right: 8px;
    }

    .leadership-block .mobile-swiper-item.hidden {
        display: flex;
        flex-direction: column;
    }
}

@media (min-width: 1366px) {
    .leadership-block .mobile-swiper-item {
        grid-column:span 3 / span 3;
    }
}

.leadership-block .mobile-swiper-item .base-page-content {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.leadership-block .mobile-swiper-item .leader-img {
    margin-bottom: 16px;
}

.leadership-block .mobile-swiper-item .leader-img img {
    border-radius: 8px;
    object-fit: cover;
    width: 100%;
}

.leadership-block .mobile-swiper-item .leader-info {
    flex-grow: 1;
}

.leadership-block .mobile-swiper-item .leader-info .leader-name {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 4px;
}

.leadership-block .mobile-swiper-item .leader-info .leader-title {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 20px;
    line-height: 24px;
    line-height: 26px;
    margin-bottom: 8px;
}

.leadership-block .mobile-swiper-item .leader-info .leader-description {
    margin-bottom: 32px;
}

@media (min-width: 768px) {
    .leadership-block .callout-row-wrapper {
        grid-gap:16px;
        gap: 16px;
        grid-template-columns: repeat(12,minmax(0,1fr));
        justify-items: center;
    }
}

.leadership-block .callout-row-wrapper .leader-block {
    display: flex;
    flex-direction: column;
    grid-column: span 6 / span 6;
    margin-bottom: 8px;
}

@media (min-width: 768px) {
    .leadership-block .callout-row-wrapper .leader-block {
        grid-column:span 4 / span 4;
        margin-bottom: 0;
    }

    .leadership-block .callout-row-wrapper .leader-block.hidden {
        display: flex;
        flex-direction: column;
    }
}

@media (min-width: 1366px) {
    .leadership-block .callout-row-wrapper .leader-block {
        grid-column:span 3 / span 3;
    }
}

.leadership-block .callout-row-wrapper .leader-block .leader-img {
    margin-bottom: 16px;
}

.leadership-block .callout-row-wrapper .leader-block .leader-img img {
    border-radius: 8px;
    object-fit: cover;
    width: 100%;
}

.leadership-block .callout-row-wrapper .leader-block .leader-info {
    flex-grow: 1;
}

.leadership-block .callout-row-wrapper .leader-block .leader-info .leader-name {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 4px;
}

.leadership-block .callout-row-wrapper .leader-block .leader-info .leader-title {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 20px;
    line-height: 24px;
    line-height: 26px;
    margin-bottom: 8px;
}

.leadership-block .callout-row-wrapper .leader-block .leader-info .leader-description {
    margin-bottom: 32px;
}

.leadership-block .leader-cta,.leadership-block .leader-cta > a,.leadership-block .leader-cta > button {
    color: #6639b7;
    color: rgba(102,57,183,var(--text-opacity));
    display: block;

    font-size: 24px;
    height: auto;
    position: relative;
    text-align: left;
    width: fit-content;
}

.leadership-block .leader-cta:before,.leadership-block .leader-cta > a:before,.leadership-block .leader-cta > button:before {
    content: "ïŒ‹";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    position: absolute;
    right: -50px;
}

.leadership-block .leader-cta.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.leadership-block .leader-cta:after {
    --bg-opacity: 1;
    background-color: #6639b7;
    background-color: rgba(102,57,183,var(--bg-opacity));
    content: "";
    display: block;
    height: 5px;
    opacity: 1;
    position: relative;
    width: 110%;
    width: calc(100% + 50px);
}

@media (hover: hover) {
    .leadership-block .leader-cta:hover:after {
        opacity:0;
        transition: opacity 0.2s ease-in-out;
    }
}

.leadership-block .leader-cta,.leadership-block .leader-cta > a,.leadership-block .leader-cta > button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
}

.leadership-block .leader-cta:after,.leadership-block .leader-cta > a:after,.leadership-block .leader-cta > button:after {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
}

.leadership-block .leader-cta:before {
    top: 6px;
}

@media (min-width: 768px) {
    .leadership-block .leader-cta:before {
        top:0;
    }
}

.leadership-block .leader-cta a {
    font-size: 16px;
    line-height: 36px;
}

.leadership-block .leader-cta a:before {
    display: none;
}

.leadership-block-cta {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
    margin-top: 32px;
}

@media (min-width: 768px) {
    .leadership-block-cta {
        grid-column:span 12 / span 12;
    }
}

.leadership-block-cta a {
    display: block !important;
}

.leadership-block .load-leaders {
    grid-column: span 6 / span 6;
    text-align: center;
}

.leadership-block .load-leaders button p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
}

@media (min-width: 768px) {
    .leadership-block .load-leaders {
        display:none;
    }
}

.leadership-block .swiper-buttons {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    height: 60px;
    justify-content: center;
    left: 0;
    margin-top: 48px;
    position: relative;
    top: unset;
    width: 100%;
}

.leadership-block .swiper-buttons-backwards {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 2px solid #0098db;
    height: 60px;
    margin-bottom: 0;
    margin-right: 12px;
    position: relative;
    width: 60px;
}

.leadership-block .swiper-buttons-backwards:before {
    color: #003c69;
    content: "âŒ©";
    font-family: Font Awesome\\6 Pro;
}

.leadership-block .swiper-buttons-backwards i {
    display: none;
}

.leadership-block .swiper-buttons-forwards {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border: 2px solid #0098db;
    height: 60px;
    margin-bottom: 0;
    margin-left: 12px;
    position: relative;
    width: 60px;
}

.leadership-block .swiper-buttons-forwards:before {
    color: #003c69;
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
}

.leadership-block .swiper-buttons-forwards i {
    display: none;
}

.news-category-chips.section-container {
    padding: 0 0 64px;
}

.news-category-chips-title {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
   
    font-size: 24px;
    line-height: 36px;
}

.news-category-chips-wrapper {
    justify-content: flex-start;
}

@media (min-width: 768px) {
    .news-category-chips-wrapper {
        justify-content: flex-start;
    }
}

.news-category-chips-item {
    border-style: none;
    margin: 0 8px 8px 0;
    padding: 0;
}

@media (min-width: 768px) {
    .news-category-chips-item {
        width:auto;
    }
}

.news-category-chips-item a {
    width: 100%;
}

.news-category-chips-item a,.news-category-chips-item a > a,.news-category-chips-item a > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 16px 32px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .news-category-chips-item a:hover,.news-category-chips-item a > a:hover,.news-category-chips-item a > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.news-category-chips-item a > a > span,.news-category-chips-item a > a i,.news-category-chips-item a > a svg,.news-category-chips-item a > button > span,.news-category-chips-item a > button i,.news-category-chips-item a > button svg,.news-category-chips-item a > span,.news-category-chips-item a i,.news-category-chips-item a svg {
    display: inline;
}

.news-category-chips-item a > a svg,.news-category-chips-item a > button svg,.news-category-chips-item a svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.news-category-chips-item a:disabled,.news-category-chips-item a > a:disabled,.news-category-chips-item a > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .news-category-chips-item a:disabled:hover:disabled,.news-category-chips-item a > a:disabled:hover:disabled,.news-category-chips-item a > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.news-category-chips-item a.inverted,.news-category-chips-item a > a.inverted,.news-category-chips-item a > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .news-category-chips-item a.inverted:hover,.news-category-chips-item a > a.inverted:hover,.news-category-chips-item a > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.news-category-chips-item a.inverted:active,.news-category-chips-item a > a.inverted:active,.news-category-chips-item a > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.news-category-chips-item a.inverted:disabled,.news-category-chips-item a > a.inverted:disabled,.news-category-chips-item a > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .news-category-chips-item a.inverted:disabled:hover,.news-category-chips-item a > a.inverted:disabled:hover,.news-category-chips-item a > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.news-category-chips-item a.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

@media (min-width: 768px) {
    .news-category-chips-item a {
        width:auto;
    }
}

.nurse-zone-wrapper {
    background: transparent linear-gradient(1turn,#f2f8fa,#fff) 0 0 no-repeat padding-box;
}

.nurse-zone-wrapper .nurse-zone .title {
   
    line-height: 40px;
    padding-bottom: 8px;
    text-align: center;
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone .title {
        line-height:56px;
        padding-bottom: 16px;
    }
}

.nurse-zone-wrapper .nurse-zone-top-content p {
    text-align: center;
}

.nurse-zone-wrapper .nurse-zone-bottom {
    padding-left: 16px;
    padding-right: 16px;
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-bottom {
        padding-left:0;
        padding-right: 0;
    }
}

.nurse-zone-wrapper .nurse-zone-card:first-child .card-overline {
    display: none;
}

.nurse-zone-wrapper .nurse-zone-card:first-child .card-image img {
    border-radius: 0;
    height: unset;
    max-height: 272px;
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card:first-child .card-image img {
        border-radius:8px;
        min-height: 320px;
    }
}

.nurse-zone-wrapper .nurse-zone-card:first-child .card-subtitle {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

    font-size: 24px;
    line-height: 28px;
    line-height: 32px;
    padding-bottom: 8px;
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card:first-child .card-subtitle {
        font-size:40px;
        font-size: 24px;
        line-height: 44px;
        line-height: 32px;
        padding-bottom: 16px;
    }
}

.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .nurse-zone-card-body {
    display: none;
}

@media (min-width: 768px) {
    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .nurse-zone-card-body {
        display:block;
    }
}

.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-overline {
    --text-opacity: 1;
    color: #0098db;
    color: rgba(0,152,219,var(--text-opacity));
    font-size: 14px;
    letter-spacing: 1.4px;
    line-height: 14px;
    line-height: 24px;
    padding-bottom: 8px;
    text-transform: uppercase;
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-overline {
        font-size:16px;
        letter-spacing: 1.6px;
        line-height: 16px;
    }
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-overline {
        display:none;
    }
}

.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-image img {
    border-radius: 0;
    min-height: 130px;
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-image img {
        border-radius:8px;
        min-height: 320px;
    }
}

.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-subtitle {
    flex-grow: 1;
    font-size: 20px;
    line-height: 24px;
    line-height: 22px;
    padding-bottom: 24px;
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-subtitle {
        flex-grow: unset;
        font-size: 24px;
        line-height: 32px;
        padding-bottom: 16px;
    }
}

.nurse-zone-wrapper .nurse-zone-card-body {
    flex-grow: 1;
    margin-bottom: 24px;
    padding-top: 0;
}

.nurse-zone-wrapper .nurse-zone-card-body > .rich-text {
    padding-left: 0;
    padding-right: 0;
}

.nurse-zone-wrapper .nurse-zone-card-body > .rich-text > p,.nurse-zone-wrapper .nurse-zone-card-body > p {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
}

.nurse-zone-wrapper .nurse-zone-card-cta {
    border: 2px solid #0094d9;
    border-radius: 8px;
    color: #0065c0 !important;
    display: inline-block;
   
    font-size: 14px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    min-width: 144px;
    padding: 10px 24px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .nurse-zone-wrapper .nurse-zone-card-cta:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.nurse-zone-wrapper .nurse-zone-card-cta > span,.nurse-zone-wrapper .nurse-zone-card-cta i,.nurse-zone-wrapper .nurse-zone-card-cta svg {
    display: inline;
}

.nurse-zone-wrapper .nurse-zone-card-cta svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.nurse-zone-wrapper .nurse-zone-card-cta:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 8px;
    position: relative;
}

@media (hover: hover) {
    .nurse-zone-wrapper .nurse-zone-card-cta:hover {
        background-color:#0094d9;
        color: #fff !important;
    }
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card-cta {
        margin-bottom:10px;
    }

    .nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-eyebrow,.nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-heading,.nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-image {
        padding: 0;
    }
}

.nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-heading.card-subtitle {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
}

@media (min-width: 1366px) {
    .nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-body {
        padding:0;
    }
}

.cookie-banner {
    grid-gap: 16px;
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    box-shadow: none;
    display: grid;
    display: none;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    padding: 12px;
}

@media (min-width: 1366px) {
    .cookie-banner {
        grid-template-columns:repeat(12,minmax(0,1fr));
        padding: 12px 24px;
    }
}

.cookie-banner-content {
    grid-column: span 6 / span 6;
}

@media (min-width: 1366px) {
    .cookie-banner-content {
        grid-column:span 12 / span 12;
    }
}

.cookie-banner-content .rich-text {
    margin: 0;
    padding: 0 0 16px;
}

.cookie-banner-content .rich-text p {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
}

.cookie-banner-content-close {
    padding: 0;
}

.promo-callout {
    --bg-opacity: 1;
    background-image: linear-gradient(53deg, #1383c6, #63bd46) !important;
    background-color: rgba(255,255,255,var(--bg-opacity));
    padding-bottom: 32px;
}

.promo-callout-media {
    grid-column: span 6 / span 6;
    min-height: 150px;
    min-width: 150px;
}

@media (min-width: 768px) {
    .promo-callout-media {
        grid-column:span 12 / span 12;
        min-height: 350px;
        padding: 0;
    }
}

@media (min-width: 1366px) {
    .promo-callout-media {
        align-self:center;
        grid-column: span 6 / span 6;
    }
}

.promo-callout-media-wrapper img {
    height: 100%;
    width: 100%;
}

@media (min-width: 768px) {
    .promo-callout-media-wrapper .video-wrapper {
        padding-bottom:0;
        padding-top: 0;
    }
}

.promo-callout-media-wrapper .video-wrapper .video-youtube {
    margin-bottom: 0;
}

.promo-callout-media-wrapper .video-wrapper .video-youtube img {
    height: 100%;
    top: 0;
    width: 100%;
}

.promo-callout-content {
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .promo-callout-content {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .promo-callout-content {
        align-self:center;
        grid-column: span 6 / span 6;
        margin-left: 16px;
        margin-right: 16px;
        padding-right: 16px;
        padding-top: 0;
    }
}

.promo-callout-content p {
    max-width: unset;
}

.promo-callout-content-cta {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    cursor: pointer;
    justify-content: flex-start;
    padding-bottom: 16px;
}

.promo-callout-content-cta .wrapper {
    --text-opacity: 1;
    color: #6639b7;
    color: rgba(102,57,183,var(--text-opacity));
}

.promo-callout-content-cta div {
    display: flex;
    max-width: 310px;
    min-width: unset !important;
    position: relative;
}

.promo-callout-content-cta a {
    all: unset !important;
    color: #6639b7 !important;
    font-size: 24px !important;
    line-height: 40px !important;
    text-align: left !important;
}

.promo-callout-content-cta a,.promo-callout-content-cta a > a,.promo-callout-content-cta a > button {
    --text-opacity: 1;
    color: #6639b7;
    color: rgba(102,57,183,var(--text-opacity));
    display: block;

    font-size: 24px;
    height: auto;
    position: relative;
    text-align: left;
    width: fit-content;
}

.promo-callout-content-cta a:before,.promo-callout-content-cta a > a:before,.promo-callout-content-cta a > button:before {
    content: "ïŒ‹";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    position: absolute;
    right: -50px;
}

.promo-callout-content-cta a.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

.promo-callout-content-cta a:after {
    --bg-opacity: 1;
    background-color: #6639b7;
    background-color: rgba(102,57,183,var(--bg-opacity));
    content: "";
    display: block;
    height: 5px;
    opacity: 1;
    position: relative;
    width: 110%;
}

@media (hover: hover) {
    .promo-callout-content-cta a:hover:after {
        opacity:0;
        transition: opacity 0.2s ease-in-out;
    }
}

.promo-callout-content-cta a:before {
    right: -50px;
}

.promo-callout-content-cta a:after {
    width: calc(100% + 50px);
}

.promo-callout-content .rich-text {
    padding: 0;
}

.promo-callout-content .rich-text ul {
    padding-left: 0;
}

@media (min-width: 1366px) {
    .promo-callout-content .rich-text p {
        margin-right:16px;
    }
}

.promo-callout-content h3 {
    text-align: left !important;
}

.promo-callout .callout-container {
    display: flex;
    flex-wrap: wrap;
    padding-top: 8px;
}

.promo-callout .callout-container .callout-set {
    display: flex;
    margin-bottom: 24px;
    margin-right: 32px;
}

.promo-callout .callout-container .callout-set-image {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    display: flex;
    justify-content: center;
    margin-right: 12px;
    max-height: 62px;
    max-width: 62px;
    min-height: 62px;
    min-width: 62px;
}

.promo-callout .callout-container .callout-set-image img {
    height: 100%;
    object-fit: cover;
    width: 100%;
}

.promo-callout .callout-container .callout-set-image.stat-callout {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 50%;
}

.promo-callout .callout-container .callout-set-image.stat-callout img,.promo-callout .callout-container .callout-set-image.stat-callout svg {
    fill: #fff;
    height: auto;
    width: 66%;
}

.promo-callout .callout-container .callout-set-image.stat-callout img path,.promo-callout .callout-container .callout-set-image.stat-callout svg path {
    fill: #fff;
}

.promo-callout .callout-container .callout-set-image.stat-callout img stop,.promo-callout .callout-container .callout-set-image.stat-callout svg stop {
    stop-color: #fff !important;
}

.promo-callout .callout-container .callout-set-content {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.promo-callout .callout-container .callout-set-content h5 {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
}

.promo-callout .callout-container .callout-set-content p {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    font-size: 14px;
    line-height: 20px;
    line-height: 30px;
}

.promo-callout .callout-container .callout-tag {
    margin-bottom: 8px;
    margin-right: 8px;
}

.promo-callout .callout-container .callout-tag,.promo-callout .callout-container .callout-tag > a,.promo-callout .callout-container .callout-tag > button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    display: inline-block;
   
    font-size: 14px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    padding: 10px 24px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .promo-callout .callout-container .callout-tag:hover,.promo-callout .callout-container .callout-tag > a:hover,.promo-callout .callout-container .callout-tag > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.promo-callout .callout-container .callout-tag > a > span,.promo-callout .callout-container .callout-tag > a i,.promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button > span,.promo-callout .callout-container .callout-tag > button i,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag > span,.promo-callout .callout-container .callout-tag i,.promo-callout .callout-container .callout-tag svg {
    display: inline;
}

.promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.promo-callout .callout-container .callout-tag:disabled,.promo-callout .callout-container .callout-tag > a:disabled,.promo-callout .callout-container .callout-tag > button:disabled {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #ddd;
    background-color: rgba(221,221,221,var(--bg-opacity));
    color: #979797;
    color: rgba(151,151,151,var(--text-opacity));
    cursor: not-allowed;
}

@media (hover: hover) {
    .promo-callout .callout-container .callout-tag:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > a:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

.promo-callout .callout-container .callout-tag.inverted,.promo-callout .callout-container .callout-tag > a.inverted,.promo-callout .callout-container .callout-tag > button.inverted {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #002146;
    color: rgba(0,33,70,var(--text-opacity));
}

@media (hover: hover) {
    .promo-callout .callout-container .callout-tag.inverted:hover,.promo-callout .callout-container .callout-tag > a.inverted:hover,.promo-callout .callout-container .callout-tag > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

.promo-callout .callout-container .callout-tag.inverted:active,.promo-callout .callout-container .callout-tag > a.inverted:active,.promo-callout .callout-container .callout-tag > button.inverted:active {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #2257b8;
    background-color: rgba(34,87,184,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.promo-callout .callout-container .callout-tag.inverted:disabled,.promo-callout .callout-container .callout-tag > a.inverted:disabled,.promo-callout .callout-container .callout-tag > button.inverted:disabled {
    --bg-opacity: 1;
    background-color: #979797;
    background-color: rgba(151,151,151,var(--bg-opacity));
    color: rgba(255,255,255,0.75);
}

@media (hover: hover) {
    .promo-callout .callout-container .callout-tag.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > a.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

.promo-callout .callout-container .callout-tag.wrapper {
    background-color: transparent;
    margin: 0;
    padding: 0;
}

@media (min-width: 768px) {
    .promo-callout .callout-container .callout-tag {
        margin-bottom:16px;
        margin-right: 16px;
    }

    .promo-callout .callout-container .callout-tag,.promo-callout .callout-container .callout-tag > a,.promo-callout .callout-container .callout-tag > button {
        --bg-opacity: 1;
        --text-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        border-radius: 8px;
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        display: inline-block;
       
        font-size: 16px;
        height: auto;
        letter-spacing: 0.16px;
        line-height: 20px;
        line-height: 24px;
        padding: 16px 32px;
        text-align: center;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (min-width: 768px) and (hover:hover) {
    .promo-callout .callout-container .callout-tag:hover,.promo-callout .callout-container .callout-tag > a:hover,.promo-callout .callout-container .callout-tag > button:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (min-width: 768px) {
    .promo-callout .callout-container .callout-tag > a > span,.promo-callout .callout-container .callout-tag > a i,.promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button > span,.promo-callout .callout-container .callout-tag > button i,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag > span,.promo-callout .callout-container .callout-tag i,.promo-callout .callout-container .callout-tag svg {
        display:inline;
    }

    .promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag svg {
        fill: #fff;
        height: 20px;
        margin-right: 4px;
        transform: translateY(-2.5px);
        width: 20px;
    }
}

@media (min-width: 768px) {
    .promo-callout .callout-container .callout-tag:disabled,.promo-callout .callout-container .callout-tag > a:disabled,.promo-callout .callout-container .callout-tag > button:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

@media (min-width: 768px) and (hover:hover) {
    .promo-callout .callout-container .callout-tag:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > a:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > button:disabled:hover:disabled {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #ddd;
        background-color: rgba(221,221,221,var(--bg-opacity));
        color: #979797;
        color: rgba(151,151,151,var(--text-opacity));
        cursor: not-allowed;
    }
}

@media (min-width: 768px) {
    .promo-callout .callout-container .callout-tag.inverted,.promo-callout .callout-container .callout-tag > a.inverted,.promo-callout .callout-container .callout-tag > button.inverted {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        color: #002146;
        color: rgba(0,33,70,var(--text-opacity));
    }
}

@media (min-width: 768px) and (hover:hover) {
    .promo-callout .callout-container .callout-tag.inverted:hover,.promo-callout .callout-container .callout-tag > a.inverted:hover,.promo-callout .callout-container .callout-tag > button.inverted:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #1765f4;
        background-color: rgba(23,101,244,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

@media (min-width: 768px) {
    .promo-callout .callout-container .callout-tag.inverted:active,.promo-callout .callout-container .callout-tag > a.inverted:active,.promo-callout .callout-container .callout-tag > button.inverted:active {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #2257b8;
        background-color: rgba(34,87,184,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
    }
}

@media (min-width: 768px) {
    .promo-callout .callout-container .callout-tag.inverted:disabled,.promo-callout .callout-container .callout-tag > a.inverted:disabled,.promo-callout .callout-container .callout-tag > button.inverted:disabled {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

@media (min-width: 768px) and (hover:hover) {
    .promo-callout .callout-container .callout-tag.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > a.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > button.inverted:disabled:hover {
        --bg-opacity:1;
        background-color: #979797;
        background-color: rgba(151,151,151,var(--bg-opacity));
        color: rgba(255,255,255,0.75);
    }
}

@media (min-width: 768px) {
    .promo-callout .callout-container .callout-tag.wrapper {
        background-color:transparent;
        margin: 0;
        padding: 0;
    }
}

.promo-callout .callout-container-icon {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: flex;
    justify-content: center;
    padding: 10px 0;
}

.promo-callout .callout-container .tile {
    font-size: 14px;
    height: 154px;
    line-height: 20px;
    padding-left: 10px;
    padding-right: 10px;
    width: 160px;
}

@media (max-width: 767px) {
    .promo-callout .callout-container .tile {
        font-size:12px;
        height: 128px;
        line-height: 18px;
        width: 112px;
    }

    .promo-callout .callout-container .tile img {
        width: 40%;
    }
}

.promo-callout .promo-blockquote-content .promo-callout-content {
    align-self: center;
    display: flex;
    flex-direction: column;
    grid-column: span 6 / span 6;
    margin-left: 0;
}

.promo-callout .promo-blockquote-content .promo-callout-content-cta {
    max-width: 253px;
}

@media (min-width: 1366px) {
    .promo-callout .promo-blockquote-content .promo-callout-media {
        padding-right:16px;
    }
}

.promo-callout .promo-blockquote-content .promo-callout-media-wrapper img {
    height: 100%;
    width: 100%;
}

@media (min-width: 768px) {
    .promo-callout .promo-blockquote-content .promo-callout-media {
        grid-column:7/13;
    }
}

@media (min-width: 1366px) {
    .promo-callout .promo-blockquote-content .promo-callout-media {
        grid-column:7/13;
    }
}

.promo-callout .promo-blockquote-content blockquote {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 32px;
    font-style: italic;
    line-height: 40px;
    padding-bottom: 32px;
}

.promo-callout .reverse-promo {
    grid-auto-flow: unset;
}

@media (min-width: 1366px) {
    .promo-callout .reverse-promo {
        grid-auto-flow:column;
    }
}

@media (min-width: 768px) {
    .promo-callout .reverse-promo .promo-callout-media {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .promo-callout .reverse-promo .promo-callout-media {
        grid-column:7/13;
        padding-right: 16px;
    }
}

@media (min-width: 768px) {
    .promo-callout .reverse-promo .promo-callout-content {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .promo-callout .reverse-promo .promo-callout-content {
        grid-column:1/7;
        padding-right: 16px;
    }
}

.attr-name {
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 18px;
}

.attr-name,.attr-title {
    --text-opacity: 1;
    line-height: 24px;
}

.attr-title {
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    font-size: 16px;
}

.attr-blockquote {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    font-size: 32px;
    font-style: italic;
    line-height: 40px;
    padding-bottom: 32px;
}

.site-search-results-list .search-result {
    grid-gap: 16px;
    grid-row-gap: 0;
    border-top: 1px solid #d1d1d1;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    padding-bottom: 32px;
    padding-top: 32px;
    row-gap: 0;
}

.site-search-results-list .search-result:last-child {
    border-bottom: 1px solid #d1d1d1;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result {
        grid-template-columns:repeat(12,minmax(0,1fr));
    }
}

.site-search-results-list .search-result .result-title {
    font-size: 24px;
    grid-column: span 6 / span 6;
    line-height: 30px;
    margin-bottom: 16px;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result .result-title {
        font-size:22px;
        grid-column: span 12 / span 12;
        line-height: 32px;
    }
}

.site-search-results-list .search-result .result-description {
    grid-column: span 6 / span 6;
    margin-bottom: 14px;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result .result-description {
        grid-column:span 12 / span 12;
        margin-bottom: 16px;
    }
}

.site-search-results-list .search-result .result-link {
    --text-opacity: 1;
    word-wrap: anywhere;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 16px;
    grid-column: span 6 / span 6;
    line-height: 24px;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result .result-link {
        grid-column:span 12 / span 12;
    }
}

.site-search-results-list .search-result .result-img {
    grid-column: span 6 / span 6;
    object-fit: cover;
    width: 100%;
}

.site-search-results-list .search-result .result-img img {
    border-radius: 8px;
    margin-bottom: 24px;
    max-height: 200px;
    width: 100%;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result .result-img {
        grid-column:span 3 / span 3;
        max-height: 180px;
    }
}

.site-search-results-list .search-result .superheader {
   
    font-size: 16px;
    grid-column: span 6 / span 6;
    line-height: 24px;
    margin-bottom: 8px;
}

.site-search-results-list .search-result .superheader span:first-child {
    border-right: 2px solid;
    padding-right: 8px;
}

.site-search-results-list .search-result .superheader span:last-child {
    padding-left: 8px;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result .superheader {
        grid-column:span 12 / span 12;
    }
}

.site-search-results-list .search-result .content {
    grid-column: span 6 / span 6;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result .content {
        align-self: center;
        display: flex;
        flex-direction: column;
        grid-column: span 8 / span 8;
    }
}

.site-search-results-list .search-result .content pre {
    white-space: pre-line;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result.article .result-title {
        font-size:24px;
        line-height: 36px;
        margin-bottom: 8px;
    }
}

.site-search-results-list .search-result.article .result-description {
    margin-bottom: 24px;
}

@media (min-width: 1366px) {
    .site-search-results-list .search-result.article .result-description {
        margin-bottom:16px;
    }

    .site-search-results-list .search-result.page {
        padding-bottom: 52px;
    }
}

.search-form input[type="search"],.search-form input[type="text"] {
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    border-right: none;
    height: 100%;
}

.corp-search {
    margin-top: 20px;
    position: relative;
}

.corp-search.section-container {
    padding-bottom: 0;
}

.corp-search-form {
    height: 80px;
    max-width: 1000px;
    position: relative;
    width: 100%;
}

@media (min-width: 768px) {
    .corp-search-form {
        width:66%;
    }
}

.corp-search-form-input {
    font-size: 26px;
    height: 100%;
    padding-left: 8px;
    padding-right: 8px;
    width: 80%;
}

@media (min-width: 768px) {
    .corp-search-form-input {
        width:90%;
    }
}

.corp-search-title {
    margin-bottom: 16px;
}

.corp-search-button {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border: 2px solid #005bbb;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    height: 100%;
    position: absolute;
    right: 0;
    width: 20%;
}

@media (min-width: 768px) {
    .corp-search-button {
        width:10%;
    }
}

.corp-search-button:before {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    font-size: 24px;
}

.corp-search .search-primary {
    margin-bottom: 16px;
}

.corp-search-amount {
    display: flex;
}

.corp-search-amount > p {
    padding-top: 32px;
}

.corp-search-amount-number {
    font-weight: 700;
    padding-right: 8px;
}

.rich-text {
    word-wrap: anywhere;
}

.rich-text .frame-legacy .caption {
    border: 1px solid #e2e2e2;
    color: #444;
    font-size: 12px;
    max-width: 166px;
    padding: 8px 8px 16px;
    text-align: left;
}

.rich-text .frame-legacy .caption IMG {
    padding-bottom: 8px;
}

.rich-text .frame-left {
    float: left;
    padding-right: 20px;
}

.rich-text .frame-right {
    float: right;
    padding-left: 20px;
}

.rich-text ul {
    padding-left: 28px;
}

.rich-text ul li {
    align-items: baseline;
    font-size: 16px;
    line-height: 24px;
}

.rich-text ul li:before {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: normal;
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    content: "ï˜";
    display: inline-block;
    font-size: 20px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    left: -8px;
    line-height: 1;
    line-height: 21px;
    margin-left: 8px;
    margin-top: 2px;
    position: relative;
}

.see-country {
    background: none;
}

.see-country .card-carousel-btn {
    z-index: 1;
}

.see-country .card-carousel-btn svg {
    fill: #003c69;
}

.city-card-background img {
    border-radius: 4px;
}

.city-card-content-heading {
    margin-top: 32px;
}

.city-card-content-heading > p {
   
    font-size: 40px;
    line-height: 48px;
}

.city-card-content-cta,.city-card-content > a {
    bottom: 32px;
    font-size: 16px !important;
    left: 0;
    padding: 0 40px;
}

@media (min-width: 1366px) {
    .city-card-content-cta,.city-card-content > a {
        bottom:32px;
    }
}

.city-card-content-cta a {
    background-color: #005bbb !important;
    color: #fff !important;
    font-size: 16px;
}

.city-card-content-cta a:hover {
    background-color: #1765f4 !important;
}

.testimonial-slide {
    height: 100%;
}

.testimonial-block--card-swiper .mobile-swiper-slide {
    margin-left: 8px;
    margin-right: 8px;
}

.testimonial-block--card-swiper .mobile-swiper-item {
    height: 100%;
    width: 100%;
}

.testimonial-block--card-swiper .mobile-swiper-item > div,.testimonial-block--card .testimonial-slide > div {
    height: 100%;
}

.testimonial-block--card .testimonial-slide-content {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    height: 100%;
    justify-content: center;
    padding-bottom: 40px;
    padding-top: 40px;
}

@media (min-width: 768px) {
    .testimonial-block--card .testimonial-slide-content {
        margin-left:0;
        margin-right: 0;
        padding: 40px 80px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card .testimonial-slide-content {
        margin-left:0;
        margin-right: 0;
        padding: 83px 114px 82px;
    }
}

.testimonial-block--card .testimonial-slide-content-cta {
    display: none;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-profile {
    display: none;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation .flex {
    flex-direction: column;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-name {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));

   
   
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 4px;
}

@media (min-width: 1366px) {
    .testimonial-block--card .testimonial-slide-content .block-quote-citation-name {
        font-size:20px;
        line-height: 24px;
    }
}

@media (min-width: 768px) {
    .testimonial-block--card .testimonial-slide-content .block-quote-citation-name {
        line-height:26px;
    }
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-role {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 4px;
}

.testimonial-block--card .testimonial-slide-content .block-quote-citation-position {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
    display: block;
   
    font-size: 14px;
    line-height: 24px;
}

.testimonial-block--card .testimonial-slide-content .card-quote {
    -webkit-box-ordinal-group: 2;
    -ms-flex-order: 1;
    font-size: 16px;
    height: auto;
    line-height: 24px;
    order: 1;
    padding-bottom: 8px;
}

@media (min-width: 768px) {
    .testimonial-block--card .testimonial-slide-content .card-quote {
        margin-left:0;
        padding-bottom: 16px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block--card .testimonial-slide-content .card-quote {
        height:auto;
        padding-bottom: 24px;
    }

    .testimonial-block--card-swiper {
        grid-column: 7/13 !important;
    }
}

.testimonial-block--card-swiper .swiper-buttons {
    display: none;
}

.testimonial-block--card-swiper .dot-navigation {
    margin-top: 32px;
}

@media (min-width: 1366px) {
    .testimonial-block--card-swiper .dot-navigation {
        line-height:16px;
        margin-top: 33px;
        text-align: center;
    }
}

.testimonial-block {
    padding-bottom: 0;
}

.testimonial-block.testimonial-block--card .testimonial-block-container {
    padding-bottom: 31px;
}

@media (min-width: 768px) {
    .testimonial-block.testimonial-block--card .testimonial-block-container {
        padding-top:67px;
    }
}

@media (min-width: 1366px) {
    .testimonial-block.testimonial-block--card .testimonial-block-container {
        padding-top:67px;
    }
}

.testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {

    margin-bottom: 0;
}

@media (min-width: 1366px) {
    .testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {
        -webkit-box-pack:center;
        -ms-flex-pack: center;
        font-size: 72px;
        height: 100%;
        justify-content: center;
        left: 191px;
        line-height: 48px;
        line-height: 80px;
        max-width: 25%;
        padding-bottom: 0;
        position: absolute;
        top: 0;
    }
}

.testimonial-block.testimonial-block--card .dot-navigation {
    margin-top: 33px;
}

@media (min-width: 768px) {
    .testimonial-block.testimonial-block--card .dot-navigation {
        display:block;
        text-align: center;
    }
}

.testimonial-block.testimonial-block--card .dot-navigation-btn {
    background-color: transparent;
}

.testimonial-block.testimonial-block--card .dot-navigation-btn.active {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
}

.trending-news {
    grid-gap: 16px;
    grid-row-gap: 0;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    padding-left: 0;
    padding-right: 0;
    row-gap: 0;
}

@media (min-width: 768px) {
    .trending-news {
        grid-gap:16px;
        gap: 16px;
        grid-template-columns: repeat(12,minmax(0,1fr));
        margin-left: 12px;
        margin-right: 12px;
    }
}

@media (min-width: 1366px) {
    .trending-news {
        grid-template-columns:repeat(4,minmax(0,1fr));
        margin: 0;
    }
}

.trending-news-title {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
   
    font-size: 24px;
    grid-column: span 6 / span 6;
    line-height: 30px;
    line-height: 24px;
    margin-bottom: 12px;
}

@media (min-width: 768px) {
    .trending-news-title {
        grid-column:span 12 / span 12;
        margin-bottom: 16px;
    }
}

@media (min-width: 1366px) {
    .trending-news-title {
        grid-column:span 4 / span 4;
    }
}

.trending-news-item {
    border-bottom: 1px solid #e2e2e2;
    grid-column: span 6 / span 6;
    padding-bottom: 24px;
    padding-top: 0;
}

.trending-news-item:not(:first-of-type) {
    padding-top: 24px;
}

@media (min-width: 768px) {
    .trending-news-item:not(:first-of-type) {
        padding-top:32px;
    }
}

@media (min-width: 768px) {
    .trending-news-item {
        grid-column:span 12 / span 12;
        padding-bottom: 48px;
    }
}

@media (min-width: 1366px) {
    .trending-news-item {
        grid-column:span 4 / span 4;
    }
}

.trending-news-item-image {
    display: none;
}

.trending-news-item-content {
    align-items: baseline;
    display: flex;
    flex-direction: column;
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .trending-news-item-content {
        grid-column:span 12 / span 12 !important;
    }
}

@media (min-width: 1366px) {
    .trending-news-item-content {
        grid-column:span 4 / span 4 !important;
    }
}

.trending-news-item-content .meta-wrapper {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    align-items: baseline;
    display: flex;
    order: 2;
}

.trending-news-item-content-category {
    border: 2px solid #0098db;
    border-radius: 8px;
    color: #005bbb !important;
    display: inline-block;
   
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 6px 16px;
    text-align: center;
    text-transform: capitalize;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .trending-news-item-content-category:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.trending-news-item-content-category > span,.trending-news-item-content-category i,.trending-news-item-content-category svg {
    display: inline;
}

.trending-news-item-content-category svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .trending-news-item-content-category:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        color: #fff !important;
    }
}

.trending-news-item-content-seperator {
    display: none;
}

.trending-news-item-content-date {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    padding-left: 12px;
    text-transform: lowercase;
}

.trending-news-item-content-date:first-letter {
    text-transform: capitalize;
}

.trending-news-item-content-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 4px;
}

@media (min-width: 768px) {
    .trending-news-item-content-title {
        margin-bottom:8px;
    }
}

.trending-news-item-content-summary {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 4px;
}

@media (min-width: 768px) {
    .trending-news-item-content-summary {
        margin-bottom:16px;
    }
}

@media (min-width: 1366px) {
    .trending-news-item-content-summary {
        margin-bottom:16px;
    }
}

.pagination {
    justify-content: space-evenly;
    width: 100%;
}

@media (min-width: 768px) {
    .pagination {
        justify-content: center;
        width: unset;
    }
}

.pagination-list {
    justify-content: space-evenly;
    width: 100%;
}

@media (min-width: 768px) {
    .pagination-list {
        justify-content: center;
        width: unset;
    }
}

.pagination-btn {
    --text-opacity: 1;
    border: none;
    border-radius: 4px;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    min-width: unset;
    width: 24px;
}

@media (min-width: 768px) {
    .pagination-btn {
        margin-right:16px;
    }
}

.pagination-btn.active {
    --text-opacity: 1;
    background-color: #003c69 !important;
    border: none !important;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.pagination-nav-btn {
    padding: 0;
}

@media (min-width: 768px) {
    .pagination-nav-btn {
        padding-left:16px;
    }
}

.pagination-nav-btn:before {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
}

.pagination-nav-btn svg {
    display: none;
}

.pagination-nav-btn:first-of-type {
    margin: 0;
    padding: 0;
    transform: rotate(180deg);
}

@media (min-width: 768px) {
    .pagination-nav-btn:first-of-type {
        padding-left:32px;
    }
}

.video-wrapper {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
}

@media (min-width: 768px) {
    .video-wrapper {
        grid-template-columns:repeat(12,minmax(0,1fr));
    }
}

.video-wrapper .video-youtube {
    border-radius: 8px;
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .video-wrapper .video-youtube {
        grid-column:span 12 / span 12;
    }
}

.video-wrapper .video-youtube img {
    opacity: 1;
}

.video-wrapper .video-youtube-button {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    background-color: transparent;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    left: 0;
    opacity: 1;
    position: absolute;
    top: 0;
    transform: unset;
    width: 100%;
    z-index: 1;
}

.video-wrapper .video-youtube-button:before {
    --text-opacity: 1;
    border: none;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    content: "ï…„";
    font-family: Font Awesome\\6 Pro;
    font-size: 60px;
    font-weight: 900;
    left: unset;
    top: unset;
    transform: unset;
}

@media (min-width: 1366px) {
    .video-wrapper .video-youtube-button:before {
        font-size:140px;
    }
}

.video-wrapper .video-youtube-button:hover {
    background-color: transparent;
}

.header-wrapper {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    position: relative;
    z-index: 3;
}

@media (min-width: 1366px) {
    .header-wrapper {
        margin:0 auto;
        max-width: 1328px;
        padding: 0;
    }
}

.header .brand {
    display: none;
    height: 61px;
}

@media (min-width: 1366px) {
    .header .brand {
        display:block;
    }

    .header .brand img {
        max-height: 50px;
        width: auto;
    }
}

.header-nav-utility {
    --bg-opacity: 1;
    background-color: #dde6ed;
    background-color: rgba(221,230,237,var(--bg-opacity));
    display: grid;
    height: 32px;
    position: relative;
}

@media (min-width: 1366px) {
    .header-nav-utility {
        --bg-opacity:1;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        height: 76px;
        justify-content: flex-start;
    }
}

.header-nav-utility-row {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    width: 100%;
}

@media (min-width: 1366px) {
    .header-nav-utility-row {
        justify-content: flex-start;
        width: unset;
    }

    .header-nav-utility-row:last-of-type {
        justify-content: flex-end;
        width: unset;
    }
}

.header-nav-utility-row .brand {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    align-items: flex-start;
    display: flex;
    height: 61px;
    justify-content: flex-start;
}

.header-nav-utility-row .brand img,.header-nav-utility-row .brand svg {
    height: 100%;
    width: auto;
}

@-moz-document url-prefix() {
    .header-nav-utility-row .brand svg {
        width: auto;
    }
}

.utility-nav-item {
    display: flex;
}

.utility-nav-item > div > a.utility-nav-item-link div:not(.flex),.utility-nav-item > div > a.utility-nav-item-link div > a,.utility-nav-item > div > a.utility-nav-item-link div button {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: block;
   
    font-size: 16px;
    line-height: 22px;
    position: relative;
    text-decoration: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: fit-content;
}

.utility-nav-item > div > a.utility-nav-item-link div:not(.flex):before,.utility-nav-item > div > a.utility-nav-item-link div > a:before,.utility-nav-item > div > a.utility-nav-item-link div button:before {
    --bg-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    bottom: 0;
    content: "";
    display: block;
    height: 1.5px;
    opacity: 0;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
    width: 100%;
}

.utility-nav-item > div > a.utility-nav-item-link div:not(.flex):after,.utility-nav-item > div > a.utility-nav-item-link div > a:after,.utility-nav-item > div > a.utility-nav-item-link div button:after {
    display: none;
}

@media (hover: hover) {
    .utility-nav-item > div > a.utility-nav-item-link div:not(.flex):hover,.utility-nav-item > div > a.utility-nav-item-link div > a:hover,.utility-nav-item > div > a.utility-nav-item-link div button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .utility-nav-item > div > a.utility-nav-item-link div:not(.flex):hover:before,.utility-nav-item > div > a.utility-nav-item-link div > a:hover:before,.utility-nav-item > div > a.utility-nav-item-link div button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.utility-nav-item > div > a.utility-nav-item-link div:not(.flex).wrapper:after,.utility-nav-item > div > a.utility-nav-item-link div > a.wrapper:after,.utility-nav-item > div > a.utility-nav-item-link div button.wrapper:after {
    width: 0;
}

.utility-nav-item > div > a.utility-nav-item-link div.inline {
    display: inline-block;
}

.utility-nav-item-link {
    display: flex;
}

.utility-nav-item-link-icon {
    display: none;
}

.utility-nav-item-link-icon svg {
    fill: #2257b8;
    height: 20px;
    width: 20px;
}

@media (min-width: 1366px) {
    .utility-nav-item-link-icon svg {
        height:28px;
        margin-right: 15px;
        width: 28px;
    }
}

.utility-nav-item-link-lead {
    --text-opacity: 1;
    color: #008b95;
    color: rgba(0,139,149,var(--text-opacity));
   
    font-size: 10px;
    line-height: 10px;
    margin-right: 15px;
}

@media (min-width: 1366px) {
    .utility-nav-item-link-lead {
        font-size:12px;
        margin: 0;
    }
}

.utility-nav-item-link-content {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 15px;
    line-height: 24px;
}

@media (min-width: 1366px) {
    .utility-nav-item-link-content {
        font-family:Helvetica Now Display Medium;
    }
}

.utility-nav-item-link-phone {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 18px;
    line-height: 24px;
}

.utility-nav-item-link:not(.hide-small) {
    justify-content: flex-end;
    padding-right: 15px;
    width: 100%;
}

@media (min-width: 1366px) {
    .utility-nav-item-link:not(.hide-small) {
        padding-right:30px;
        width: auto;
    }
}

@media (min-width: 1366px) {
    .utility-nav-item-link {
        align-items: center;
        border: none;
        height: 100%;
        margin-right: 20px;
        position: relative;
    }

    .utility-nav-item-link:not(:last-of-type):after {
        background: #75787b;
        border-radius: 5px;
        content: "";
        height: 100%;
        opacity: 0.15;
        position: absolute;
        right: -30px;
        top: 0;
        width: 2px;
    }

    .utility-nav-item-link-icon,.utility-nav-item-link-lead {
        display: block;
    }
}

@media (max-width: 1365px) {
    .utility-nav-item > div {
        display:none;
    }

    .utility-nav-item div:first-of-type {
        display: block;
    }
}

.utility-nav-item .aboutDropdown {
    display: none;
}

.utility-nav-item .utility-nav-item-link {
    cursor: pointer;
    padding: 16px 20px 16px 24px;
}

.utility-nav-item .aboutMenu-open .aboutDropdown,.utility-nav-item .aboutMenu-open .utility-nav-item-link:first-child {
    --bg-opacity: 1;
    background-color: #f2fafe;
    background-color: rgba(242,250,254,var(--bg-opacity));
}

.utility-nav-item .aboutMenu-open .aboutDropdown {
    box-shadow: 0 10px 10px rgba(0,0,0,0.10196);
    display: flex;
    left: 0;
    padding: 16px 16px 24px;
    position: absolute;
    top: 56px;
    width: max-content;
}

.utility-nav-item .aboutMenu-open .aboutDropdown .dropdownLink {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    cursor: pointer;
    margin: 8px;
    max-width: 400px;
    text-align: left;
}

.utility-search {
    display: flex;
    flex-direction: row;
    height: 40px;
    padding: 0;
    position: relative;
    width: 208px;
}

.utility-search input[type="search"],.utility-search input[type="text"] {
    padding-left: 4px;
}

.utility-search-button {
    --bg-opacity: 1;
    --text-opacity: 1;
    background-color: #005bbb;
    background-color: rgba(0,91,187,var(--bg-opacity));
    border-bottom-right-radius: 8px;
    border-left: 1px solid #c4c4c4;
    border-top-right-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 48px;
}

.utility-search-button:before {
    height: 20px;
    width: 20px;
}

.corp-main-navigation-mobile {
    grid-gap: 16px;
    grid-row-gap: 0;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    height: unset;
    row-gap: 0;
    width: 100%;
}

@media (min-width: 1366px) {
    .corp-main-navigation-mobile {
        display:none;
    }
}

.corp-main-navigation-mobile .list-wrapper {
    display: none;
}

.corp-main-navigation-mobile .list-wrapper button {
    margin-bottom: 24px;
    margin-top: 24px;
}

.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child {
    padding-bottom: 0;
}

.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child:after {
    border-bottom: 1px solid #c6e0e3;
    content: "";
    display: block;
}

.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child .hybrid-link,.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child .mega-link {
    padding-bottom: 16px;
}

.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item > a {
    padding-left: 32px;
}

.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item > a:after {
    content: none;
}

.corp-main-navigation-mobile .link-list-container .link-list-item {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    padding-bottom: 16px;
}

.corp-main-navigation-mobile .link-list-container .link-list-item:before {
    border-bottom: 1px solid #c6e0e3;
    content: "";
    display: block;
    margin-bottom: 16px;
}

.corp-main-navigation-mobile .link-list-container .link-list-item > a {
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    padding-left: 32px;
    width: calc(100% - 32px);
}

.corp-main-navigation-mobile .dropdown-item {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
}

.corp-main-navigation-mobile .dropdown-item:before {
    border-bottom: 1px solid #e6e6e6;
    content: "";
    display: block;
    margin-bottom: 24px;
}

.corp-main-navigation-mobile .dropdown-item.open {
    --bg-opacity: 1;
    background-color: #f2fafe;
    background-color: rgba(242,250,254,var(--bg-opacity));
}

.corp-main-navigation-mobile .dropdown-item.open .dropdown-title:after {
    padding-left: 24px;
    padding-right: 0;
    transform: rotate(180deg);
}

.corp-main-navigation-mobile .dropdown-item.open .link-list-item {
    --bg-opacity: 1;
    background-color: #f2fafe;
    background-color: rgba(242,250,254,var(--bg-opacity));
}

.corp-main-navigation-mobile .dropdown-item.open .list-wrapper {
    display: block;
}

.corp-main-navigation-mobile .dropdown-title {
    --text-opacity: 1;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    display: flex;
   
    font-size: 18px;
    justify-content: space-between;
    line-height: 22px;
    padding-bottom: 24px;
    padding-left: 24px;
}

.corp-main-navigation-mobile .dropdown-title:after {
    content: "ï¸";
    font-family: Font Awesome\\6 Pro;
    padding-right: 24px;
}

.corp-main-navigation-mobile .menu-bar {
    grid-gap: 16px;
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    display: grid;
    gap: 16px;
    grid-column: span 6 / span 6;
    grid-template-columns: repeat(6,minmax(0,1fr));
    height: 87px;
    padding-left: 24px;
    padding-right: 24px;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 99;
}

.corp-main-navigation-mobile .menu-bar .logo {
    align-items: center;
    display: flex;
    grid-column: span 2 / span 2;
}

.corp-main-navigation-mobile .menu-bar .icon-menu {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: flex;
    font-size: 32px;
    grid-column: span 4 / span 4;
    justify-content: flex-end;
}

.corp-main-navigation-mobile .menu-bar .icon-menu .nav-icon {
    align-items: center;
    display: flex;
}

.corp-main-navigation-mobile .menu-bar .icon-menu .phone-icon :before {
    content: "ï‚•";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    padding-bottom: 31px;
    padding-right: 16px;
    padding-top: 24px;
}

.corp-main-navigation-mobile .menu-bar .icon-menu .search-icon :before {
    content: "ï€‚";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    padding-bottom: 31px;
    padding-right: 16px;
    padding-top: 24px;
}

.corp-main-navigation-mobile .menu-bar .icon-menu .menu-icon :before {
    content: "ïƒ‰";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    padding-bottom: 33px;
    padding-top: 28px;
}

.corp-main-navigation-mobile .menu-bar .icon-menu .menu-icon.open :before {
    content: "ï€";
    font-family: Font Awesome\\6 Pro;
    font-weight: 900;
    padding-bottom: 33px;
    padding-top: 28px;
}

.corp-main-navigation-mobile .utility-nav-mobile {
    display: none;
    grid-column: span 6 / span 6;
}

.corp-main-navigation-mobile .utility-nav-mobile > .link-list-container {
    padding-bottom: 200px;
}

@media (min-width: 1366px) {
    .corp-main-navigation-mobile .utility-nav-mobile > .link-list-container {
        padding-bottom:unset;
    }
}

.corp-main-navigation-mobile .utility-nav-mobile.open {
    display: block;
    max-height: 100vh;
    overflow: scroll;
    position: relative;
    z-index: 9;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container {
    padding-top: 88px;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .mega-list-cta-content {
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 24px;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .mega-list-cta-content .see-more {
    --text-opacity: 1;
    align-items: center;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    display: flex;
   
    padding-bottom: 24px;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .mega-list-cta-content .see-more:after {
    content: "ï”";
    font-family: Font Awesome\\6 Pro;
    padding-left: 8px;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .request {
    align-items: center;
    display: flex;
    margin-left: 32px;
    margin-right: 32px;
    padding-bottom: 16px;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .request .request-btn {
    --bg-opacity: 1;
    background-color: #0098db;
    background-color: rgba(0,152,219,var(--bg-opacity));
    width: 100%;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .request .request-btn:after {
    content: "ï”";
    font-family: Font Awesome\\6 Pro;
    padding-left: 8px;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-list-cta:after {
    content: none;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .list-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 8px;
}

.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .description {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    padding-bottom: 16px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-container:before {
    border-bottom: 1px solid #c6e0e3;
    content: "";
    display: block;
    margin-bottom: 14px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top {
    padding-left: 32px;
    padding-right: 32px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 18px;
    line-height: 28px;
    line-height: 26px;
    padding-bottom: 16px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-img {
    padding-bottom: 16px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-img img {
    border-radius: 8px;
    max-height: 180px;
    object-fit: cover;
    width: 100%;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-content-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 20px;
    line-height: 28px;
    line-height: 26px;
    padding-bottom: 8px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-content-description {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 24px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set {
    padding-bottom: 24px;
    padding-top: 24px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set:first-of-type {
    padding-top: 0;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set-title {
   
    font-size: 18px;
    line-height: 24px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set-list li,.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    padding-bottom: 16px;
}

.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set > a {
    padding-top: 8px;
}

@media (max-width: 1365px) {
    .main-desktop-mask {
        display:none;
    }
}

.main-navigation-desktop {
    --bg-opacity: 1;
    background-color: #003c69;
    background-color: rgba(0,60,105,var(--bg-opacity));
}

.main-navigation-desktop .link-standard:before {
    display: none;
}

.main-navigation-desktop .nav-item-panel {
    border-radius: 0;
    cursor: auto;
    display: none;
    left: 0;
    padding: 0;
    position: absolute;
    top: 44px;
    width: 100vw;
}

.main-navigation-desktop .mega-menu picture {
    bottom: 0;
    display: flex;
    max-height: 224px;
    min-width: 463px;
    object-fit: cover;
    position: absolute;
    right: 0;
}

.main-navigation-desktop .mega-menu picture img {
    height: auto;
    object-fit: cover;
    width: 100%;
}

.main-navigation-desktop .mega-menu .menu-content {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(12,minmax(0,1fr));
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 64px;
    padding-top: 32px;
    width: 1328px;
    z-index: 1;
}

.main-navigation-desktop .mega-menu .menu-content .request {
    justify-self: end;
}

.main-navigation-desktop .mega-menu .menu-content .request p {
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 8px;
}

.main-navigation-desktop .mega-menu .menu-content .rich-text {
    padding: 0;
}

.main-navigation-desktop .mega-menu i {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    font-size: 4em;
    justify-self: end;
    padding-top: 4px;
}

.main-navigation-desktop .mega-menu .mega-list {
    grid-gap: 8px;
    display: grid;
    gap: 8px;
    grid-column: span 4 / span 4;
    grid-template-columns: repeat(4,minmax(0,1fr));
    height: fit-content;
}

.main-navigation-desktop .mega-menu .mega-list-cta {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-column: span 4 / span 4;
    grid-template-columns: repeat(4,minmax(0,1fr));
}

.main-navigation-desktop .mega-menu .mega-list-cta-image {
    grid-column: span 1 / span 1;
    margin-left: 32px;
}

.main-navigation-desktop .mega-menu .mega-list-cta-image img {
    height: auto;
    width: 100%;
}

.main-navigation-desktop .mega-menu .mega-list-cta-content {
    display: flex;
    flex-direction: column;
    grid-column: span 3 / span 3;
}

.main-navigation-desktop .mega-menu .mega-list .list-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 4px;
}

.main-navigation-desktop .mega-menu .mega-list .description {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    font-size: 15px;
    line-height: 24px;
    padding-bottom: 0;
}

.main-navigation-desktop .mega-menu .mega-list-list {
    grid-column: 2/5;
}

.main-navigation-desktop .mega-menu .mega-list-list li {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 12px;
}

.main-navigation-desktop .mega-menu .mega-list-list li:last-child {
    margin-bottom: 0;
}

.main-navigation-desktop .mega-menu .mega-list:nth-of-type(2) {
    grid-column: 6 / span 4;
}

.main-navigation-desktop .mega-menu .mega-list-cta-mask {
    grid-column: span 4 / span 4;
}

.main-navigation-desktop .hybrid-menu {
    --bg-opacity: 1;
    background-color: #f2fafe;
    background-color: rgba(242,250,254,var(--bg-opacity));
    display: none;
}

.main-navigation-desktop .hybrid-menu .hybrid-background-img {
    bottom: 0;
    display: flex;
    max-height: 224px;
    min-width: 463px;
    object-fit: cover;
    position: absolute;
    right: 0;
}

.main-navigation-desktop .hybrid-menu .hybrid-background-img img {
    height: auto;
    object-fit: cover;
    width: 100%;
}

.main-navigation-desktop .hybrid-menu .menu-content {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(12,minmax(0,1fr));
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 32px;
    padding-top: 24px;
    width: 1328px;
    z-index: 1;
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-top {
    border-bottom: 1px solid rgba(203,203,203,0.66);
    padding-bottom: 24px;
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-bottom,.main-navigation-desktop .hybrid-menu .menu-content .hybrid-top {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-column: span 12 / span 12;
    grid-template-columns: repeat(12,minmax(0,1fr));
}

.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout {
    grid-row-gap: 0;
    row-gap: 0;
}

.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    display: none;
   
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 4px;
}

.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-image img {
    border-radius: 8px;
    height: 162px;
    object-fit: cover;
    width: 100%;
}

.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-right .highlight-content-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 8px;
    padding-top: 0;
}

.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-right .highlight-description,.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-right .rich-text {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    font-size: 15px;
    line-height: 24px;
}

.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .rich-text {
    padding: 0;
}

.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .rich-text p {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .list-title {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 18px;
    padding-bottom: 4px;
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .list-title.bottom-list {
    font-size: 18px;
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .link-list {
    padding-top: 0;
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .link-list li {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    font-size: 15px;
    line-height: 24px;
    padding-bottom: 12px;
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more {
    padding-bottom: 0;
    padding-top: 0;
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more:after {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
}

.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more a,.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more span {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 16px;
    line-height: 24px;
}

.main-navigation-desktop-wrapper {
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: max-content;
    justify-content: flex-start;
}

.main-navigation-desktop-max,.main-navigation-desktop-wrapper {
    --bg-opacity: 1;
    background-color: #003c69;
    background-color: rgba(0,60,105,var(--bg-opacity));
}

.main-navigation-desktop-max {
    height: 44px;
    max-width: 1328px;
    position: unset;
}

.main-navigation-desktop-max ul li.active {
    background-color: #fff;
}

.main-navigation-desktop .nav-item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    --text-opacity: 1;
    align-items: center;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    cursor: pointer;
    display: flex;
    font-size: 15px;
    height: 100%;
    justify-content: center;
    line-height: 24px;
    margin-right: 0;
    padding-left: 24px;
    padding-right: 24px;
    position: unset;
    width: fit-content;
}

.main-navigation-desktop .nav-item--open {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #f2fafe;
    background-color: rgba(242,250,254,var(--bg-opacity));
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
}

.main-navigation-desktop .nav-item--open:before {
    display: none;
}

.main-navigation-desktop .nav-item--open .nav-item-panel {
    --bg-opacity: 1;
    background-color: #f2fafe;
    background-color: rgba(242,250,254,var(--bg-opacity));
    display: flex;
}

.main-navigation-desktop .link-item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    cursor: pointer;
    display: flex;
    grid-column: 11/12;
    justify-content: center;
    margin-right: auto;
    width: 208px;
}

.main-navigation-desktop .link-item > div {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    font-size: 15px;
    line-height: 24px;
}

.main-navigation-desktop .link-item > div:after {
    --text-opacity: 1;
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

.main-navigation-desktop.stick {
    position: fixed;
    top: 0;
    width: 100vw;
}

body.locked {
    max-height: 100vh;
    overflow: hidden;
}

.base-page {
    overflow-x: hidden;
}

.base-page-hero {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    overflow: hidden;
    position: relative;
}

@media (min-width: 1366px) {
    .base-page-hero {
        min-height:364px;
    }
}

.base-page-hero.pillars-hero {
    margin-bottom: 320px;
    overflow: visible;
}

@media (min-width: 768px) {
    .base-page-hero.pillars-hero {
        margin-bottom:180px;
    }
}

@media (min-width: 1366px) {
    .base-page-hero.pillars-hero .pillars-container {
        position:relative;
        width: 200%;
    }
}

.base-page-hero.pillars-hero .pillars-container .pillars {
    bottom: 0;
    top: 90%;
}

@media (min-width: 1366px) {
    .base-page-hero.pillars-hero .pillars-container .pillars {
        bottom:0;
        top: 0;
    }
}

.base-page-hero-bg {
    height: 100%;
    left: 30%;
    position: absolute;
    top: 0;
    width: 100%;
}

@media (max-width: 1365px) {
    .base-page-hero-bg {
        display:none;
    }
}

@media (min-width: 768px) {
    .base-page-hero-bg {
        left:50%;
    }
}

@media (min-width: 1366px) {
    .base-page-hero-bg {
        left:50%;
        top: 0;
        width: auto;
    }
}

.base-page-hero-bg img {
    height: 100%;
    object-fit: cover;
    object-position: left;
    width: auto;
}

.base-page-hero-bg img.desktop-hero {
    display: none;
}

@media (min-width: 1366px) {
    .base-page-hero-bg img.desktop-hero {
        display:block;
    }

    .base-page-hero-bg img.mobile-hero {
        display: none;
    }
}

.base-page-hero-content {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: auto;
    margin-top: auto;
    padding-bottom: 0;
    padding-top: 40px;
    position: relative;
}

@media (min-width: 768px) {
    .base-page-hero-content {
        align-items: center;
        flex-direction: row;
        min-height: 212px;
        padding-bottom: 0;
    }
}

@media (min-width: 1366px) {
    .base-page-hero-content {
        grid-gap:16px;
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(12,minmax(0,1fr));
        min-height: 364px;
        padding: unset;
    }
}

.base-page-hero-content-mask {
    padding-bottom: 20px;
}

@media (min-width: 1366px) {
    .base-page-hero-content-mask {
        grid-column:1/7;
    }
}

.base-page-hero-content-eyebrow {
    --text-opacity: 1;
    color: #0098db;
    color: rgba(0,152,219,var(--text-opacity));
    display: block;
   
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
}

.base-page-hero-content-heading {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 16px;
}

@media (min-width: 1366px) {
    .base-page-hero-content-heading {
        margin-bottom:24px;
    }

    .base-page-hero-content-body {
        display: flex;
        margin-bottom: 32px;
    }
}

.base-page-hero-content-links-wrapper {
    display: none;
}

@media (min-width: 1366px) {
    .base-page-hero-content-links-wrapper {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 24px;
    }

    .base-page-hero-content-links-wrapper .link-collection-item {
        flex-basis: 50%;
        padding-bottom: 8px;
    }

    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex),.base-page-hero-content-links-wrapper .link-collection-item a button {
        --text-opacity: 1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        display: block;
       
        font-size: 16px;
        line-height: 22px;
        position: relative;
        text-decoration: none;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
        width: fit-content;
    }

    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):before,.base-page-hero-content-links-wrapper .link-collection-item a button:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        bottom: 0;
        content: "";
        display: block;
        height: 1.5px;
        opacity: 0;
        position: absolute;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
        width: 100%;
    }

    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):after,.base-page-hero-content-links-wrapper .link-collection-item a button:after {
        display: none;
    }
}

@media (min-width: 1366px) and (hover:hover) {
    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):hover,.base-page-hero-content-links-wrapper .link-collection-item a button:hover {
        --text-opacity:1;
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }

    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):hover:before,.base-page-hero-content-links-wrapper .link-collection-item a button:hover:before {
        --bg-opacity: 1;
        background-color: #005bbb;
        background-color: rgba(0,91,187,var(--bg-opacity));
        opacity: 1;
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

@media (min-width: 1366px) {
    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex).wrapper:after,.base-page-hero-content-links-wrapper .link-collection-item a button.wrapper:after {
        width:0;
    }
}

@media (min-width: 1366px) {
    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):after,.base-page-hero-content-links-wrapper .link-collection-item a button:after {
        content:"âŒª";
        display: inline-block;
        font-family: Font Awesome\\6 Pro;
        font-size: 0.75em;
        font-weight: 900;
        padding-left: 4px;
        position: relative;
    }
}

@media (min-width: 1366px) {
    .base-page-hero-content-links-wrapper .link-collection-item a.inline {
        display:inline-block;
    }
}

.base-page-hero-content-buttons {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
}

@media (min-width: 1366px) {
    .base-page-hero-content-buttons {
        align-items: center;
        flex-direction: row;
    }
}

.base-page-hero-content-buttons-cta {
    --bg-opacity: 1;
    background-color: #0098db;
    background-color: rgba(0,152,219,var(--bg-opacity));
    margin-bottom: 12px;
}

@media (min-width: 1366px) {
    .base-page-hero-content-buttons-cta {
        align-items: center;
        display: flex;
        margin-bottom: 0;
        margin-right: 32px;
    }

    .base-page-hero-content-buttons-cta:after {
        top: 2px;
    }
}

.base-page-hero-content-buttons-video {
    display: flex !important;
}

.base-page-hero-content-buttons-video i {
    font-size: 24px;
    margin-right: 4px;
}

.base-page-hero-content-image {
    align-self: center;
    display: none;
    max-width: 310px;
}

@media (min-width: 1366px) {
    .base-page-hero-content-image {
        align-self: flex-end;
        display: block;
        grid-column: 7/13;
        max-width: unset;
        padding-left: 20px;
    }
}

.base-page-hero-content-image img {
    height: auto;
    width: 100%;
}

.homepage .section-container {
    padding-bottom: 0;
    padding-top: 24px;
}

.homepage-eyebrow {
    --text-opacity: 1;
    color: #0098db;
    color: rgba(0,152,219,var(--text-opacity));
    display: block;
   
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
}

.homepage-heading {
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 8px;
}

@media (min-width: 768px) {
    .homepage-heading {
        font-size:56px;
        line-height: 64px;
    }
}

.homepage-button {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
}

@media (min-width: 1366px) {
    .homepage-button {
        font-size:24px;
        line-height: 40px;
    }
}

.homepage-hero {
    display: none;
}

@media (min-width: 1366px) {
    .homepage-hero {
        bottom:0;
        display: block;
        grid-column: unset;
        left: 42%;
        padding-left: 0;
        position: absolute;
    }

    .homepage-hero img {
        max-width: 100%;
    }
}

.homepage .base-page-hero {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
}

.homepage .base-page-hero-content {
    min-height: 350px;
}

.homepage .base-page-hero-content-image {
    bottom: 0;
    display: block;
    position: absolute;
    right: 0;
}

@media (min-width: 1366px) {
    .homepage .base-page-hero {
        min-height:464px;
    }
}

.homepage .base-page-hero-content-mask {
    position: relative;
    z-index: 1;
}

@media (min-width: 768px) {
    .homepage .base-page-hero-content-mask {
        padding-bottom:100px;
    }
}

@media (min-width: 1366px) {
    .homepage .base-page-hero-content-mask {
        padding-bottom:60px;
    }
}

.homepage .base-page-hero-content-image {
    max-width: 450px;
    z-index: 0;
}

@media (min-width: 1366px) {
    .homepage .base-page-hero-content-image {
        display:none;
    }
}

.homepage-wrapper {
    margin-bottom: 300px;
    position: relative;
}

@media (min-width: 768px) {
    .homepage-wrapper {
        margin-bottom:100px;
    }
}

@media (min-width: 1366px) {
    .homepage-wrapper {
        margin-bottom:50px;
    }
}

.pillars {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    bottom: -80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    left: 0;
    margin: auto;
    max-width: 368px;
    position: absolute;
    right: 0;
}

@media (min-width: 768px) {
    .pillars {
        bottom:-35%;
        max-width: 728px;
    }
}

@media (min-width: 1366px) {
    .pillars {
        bottom:-15%;
        max-width: 1328px;
    }
}

.pillars .pillars-entry {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    align-items: center;
    background-color: transparent;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    height: 153px;
    justify-content: center;
    margin-bottom: 16px;
    perspective: 1000px;
    width: 176px;
}

.pillars .pillars-entry:hover {
    box-shadow: none;
}

@media (min-width: 1366px) {
    .pillars .pillars-entry {
        height:200px;
        width: 320px;
    }
}

.pillars .pillars-entry-inner {
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    height: 100%;
    position: relative;
    text-align: center;
    transform-style: preserve-3d;
    transition: transform 0.6s;
    width: 100%;
}

.pillars .pillars-entry-inner-back,.pillars .pillars-entry-inner-front {
    --text-opacity: 1;
    backface-visibility: hidden;
    border-radius: 8px;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
    position: absolute;
}

.pillars .pillars-entry-inner-front {
    -ms-flex-pack: distribute;
    border-radius: 8px;
    height: 100%;
    justify-content: space-around;
    padding: 0;
}

.pillars .pillars-entry-inner-front,.pillars .pillars-entry-inner-front a {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.pillars .pillars-entry-inner-front a {
    padding: 40px 24px;
}

@media (min-width: 1366px) {
    .pillars .pillars-entry-inner-front {
        padding:40px 24px;
    }
}

.pillars .pillars-entry-inner-front-image {
    height: 55px;
    width: 55px;
}

@media (min-width: 1366px) {
    .pillars .pillars-entry-inner-front-image {
        height:100px;
        margin-bottom: 20px;
        width: 100px;
    }
}

.pillars .pillars-entry-inner-front-image img {
    height: 100%;
    object-fit: contain;
    transform-style: preserve-3d;
    transition: transform 0.6s;
    width: 100%;
}

.pillars .pillars-entry-inner-back {
    -ms-flex-pack: distribute;
    -webkit-box-align: center;
    -ms-flex-align: center;
    --bg-opacity: 1;
    align-items: center;
    background-color: #fff;
    background-color: rgba(255,255,255,var(--bg-opacity));
    border-radius: 8px;
    box-shadow: 0 5px 24px rgba(0,0,0,0.40392);
    color: #fff;
    display: flex;
    flex-direction: column;
    height: 103%;
    justify-content: space-around;
    left: -50%;
    margin-left: 48.5%;
    margin-top: 30%;
    padding: 40px 32px;
    top: -50%;
    transform: rotateY(180deg);
    transition: box-shadow 0.1;
    width: 103%;
}

.pillars .pillars-entry-inner-back-content li,.pillars .pillars-entry-inner-back-content p {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
    font-size: 15px;
    line-height: 24px;
}

.pillars .pillars-entry-inner-back:hover {
    backface-visibility: visible;
    transition: backface-visibility 1;
}

@media (min-width: 1366px) {
    .pillars .pillars-entry-inner-link {
        font-size:15px;
        line-height: 24px;
        margin-left: auto;
        margin-right: auto;
    }
}

.pillars .pillars-entry-inner-link.inverted {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255,255,255,var(--text-opacity));
}

@media (min-width: 1366px) {
    .pillars-entry:hover .pillars-entry-inner {
        box-shadow: none;
        transform: rotateY(180deg);
    }

    .news {
        padding-top: 80px;
    }

    .news-hero,.news-hero-image img {
        height: 380px;
    }
}

.news-heading {
    display: flex;
    flex-direction: column;
}

.news-heading-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 24px;
    line-height: 32px;
}

@media (min-width: 1366px) {
    .news-heading-title {
        font-family:Helvetica Now Display Bold;
        font-size: 24px;
        line-height: 32px;
    }
}

.news-heading-landing-category {
    border: 2px solid #0094d9;
    border-radius: 8px;
    color: #0065c0 !important;
    display: inline-block;
   
    font-size: 14px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    min-width: 144px;
    padding: 10px 24px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .news-heading-landing-category:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.news-heading-landing-category > span,.news-heading-landing-category i,.news-heading-landing-category svg {
    display: inline;
}

.news-heading-landing-category svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

.news-heading-landing-category:after {
    content: "âŒª";
    font-family: Font Awesome\\6 Pro;
    font-size: 0.75em;
    font-weight: 900;
    left: 8px;
    position: relative;
}

@media (hover: hover) {
    .news-heading-landing-category:hover {
        background-color:#0094d9;
        color: #fff !important;
    }
}

.news-landing-meta-date {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
   
    font-size: 14px;
    line-height: 20px;
    margin-left: 12px;
    text-transform: none;
}

.news-landing-meta-category {
    text-transform: none;
}

.news-landing-meta-seperator {
    display: none;
}

.news-landing-meta-author {
    --text-opacity: 1;
    color: #003c69;
    color: rgba(0,60,105,var(--text-opacity));
   
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 8px;
    padding-top: 32px;
}

@media (min-width: 1366px) {
    .news-content-main {
        padding-left:8px;
        padding-right: 8px;
    }
}

.news-content-main-set .rich-text p {
    font-size: 16px;
    line-height: 24px;
}

.news-content-main-set .rich-text h1 {
    font-size: 24px;
}

.news-content-main-set .rich-text h2 {
    font-size: 22px;
    line-height: 32px;
}

.news-content-main-set .rich-text h3 {
    font-size: 20px;
    line-height: 32px;
}

.news-content-main-set .rich-text h4,.news-content-main-set .rich-text h5,.news-content-main-set .rich-text h6 {
    font-size: 16px;
    letter-spacing: normal;
    line-height: 24px;
}

.news-content-main-set ul {
    padding-left: 28px;
}

.news-content-main-set ul li {
    align-items: baseline;
    font-size: 16px;
    line-height: 24px;
}

.news-content-main-set ul li:before {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: normal;
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
    content: "ï˜";
    display: inline-block;
    font-size: 20px;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    left: -8px;
    line-height: 1;
    line-height: 21px;
    margin-left: 8px;
    margin-top: 2px;
    position: relative;
}

.news-content-side {
    padding-right: 8px;
}

.news-content-side > div:first-child {
    padding: 0;
}

.news-content-side > div:first-child .news-search-box-container {
    align-items: flex-end;
    border-bottom: 1px solid #75787b;
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 12px;
    margin-left: 12px;
    margin-right: 12px;
    padding-bottom: 0;
}

@media (min-width: 1366px) {
    .news-content-side > div:first-child .news-search-box-container {
        margin-left:0;
        margin-right: 0;
    }
}

.news-content-side > div:first-child .news-search-box-container input {
    --text-opacity: 1;
    border: none;
    border-radius: 0;
    box-shadow: none;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
   
    font-size: 16px;
    font-style: italic;
    height: auto;
    line-height: 24px;
    padding-bottom: 8px;
    padding-left: 32px;
}

.news-content-side > div:first-child .news-search-box-container input::placeholder {
    --text-opacity: 1;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
    opacity: 0.5;
}

.news-content-side > div:first-child .news-search-box-container button {
    align-self: center;
    display: flex;
    left: 20px;
    margin-left: 0;
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    position: relative;
    top: unset;
}

.news-content-side > div:first-child .news-search-box-container i svg {
    fill: #005bbb;
    height: 18px;
    width: 18px;
}

@media (min-width: 768px) {
    .news-content-side > div:first-child .news-search-box-container {
        align-items: flex-end;
        border-bottom: 1px solid #75787b;
        display: flex;
        flex-direction: row-reverse;
        margin-bottom: 12px;
        margin-left: 12px;
        margin-right: 12px;
        padding-bottom: 0;
    }
}

@media (min-width: 768px) and (min-width:1366px) {
    .news-content-side > div:first-child .news-search-box-container {
        margin-left:0;
        margin-right: 0;
    }
}

@media (min-width: 768px) {
    .news-content-side > div:first-child .news-search-box-container input {
        --text-opacity:1;
        border: none;
        border-radius: 0;
        box-shadow: none;
        color: #75787b;
        color: rgba(117,120,123,var(--text-opacity));
       
        font-size: 16px;
        font-style: italic;
        height: auto;
        line-height: 24px;
        padding-bottom: 8px;
        padding-left: 32px;
    }
}

@media (min-width: 768px) {

    .news-content-side > div:first-child .news-search-box-container input::placeholder {
        --text-opacity: 1;
        color: #75787b;
        color: rgba(117,120,123,var(--text-opacity));
        opacity: 0.5;
    }
}

@media (min-width: 768px) {
    .news-content-side > div:first-child .news-search-box-container button {
        align-self: center;
        display: flex;
        left: 20px;
        margin-left: 0;
        margin-top: 0;
        padding-left: 0;
        padding-right: 0;
        position: relative;
        top: unset;
    }

    .news-content-side > div:first-child .news-search-box-container i svg {
        fill: #005bbb;
        height: 18px;
        width: 18px;
    }
}

.news-content-side > div:first-child .news-search-box-container {
    padding-left: 8px;
    padding-right: 8px;
}

.news .news-content h2 {
    font-size: 20px;
    line-height: 24px;
}

@media (min-width: 768px) {
    .news .news-content h2 {
        font-size:20px;
        line-height: 24px;
    }
}

.news-landing {
    grid-gap: 16px;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
}

@media (min-width: 768px) {
    .news-landing {
        grid-template-columns:repeat(12,minmax(0,1fr));
    }
}

@media (min-width: 1366px) {
    .news-landing {
        padding-top:80px;
    }
}

.news-landing > h1 {
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .news-landing > h1 {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .news-landing-featured {
        padding-left:0;
        padding-right: 0;
    }
}

.news-landing-hero {
    margin-bottom: 24px;
}

.news-landing-meta {
    order: 3;
}

.news-landing-meta-category {
    border: 2px solid #0098db;
    border-radius: 8px;
    color: #005bbb !important;
    display: inline-block;
   
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 6px 16px;
    text-align: center;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .news-landing-meta-category:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.news-landing-meta-category > span,.news-landing-meta-category i,.news-landing-meta-category svg {
    display: inline;
}

.news-landing-meta-category svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .news-landing-meta-category:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        color: #fff !important;
    }
}

.news-landing-meta-date {
    display: inline-block;
    text-transform: lowercase;
}

.news-landing-meta-date:first-letter {
    text-transform: capitalize;
}

.news-landing-heading {
    display: flex;
    flex-direction: column;
}

.news-landing-heading-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

    font-size: 40px;
    font-size: 24px;
    line-height: 44px;
    line-height: 32px;
}

@media (min-width: 1366px) {
    .news-landing-heading-title {
        font-size:56px;
        line-height: 60px;
    }
}

@media (min-width: 768px) {
    .news-landing-heading-title {
        font-size:24px;
        line-height: 32px;
    }
}

@media (min-width: 1366px) {
    .news-landing-heading-title {
        font-size:24px;
        line-height: 32px;
    }
}

.news-landing-heading-summary {
    margin-bottom: 24px;
}

.news-landing-content {
    grid-column: span 6 / span 6;
}

@media (min-width: 768px) {
    .news-landing-content {
        grid-column:span 12 / span 12;
    }
}

@media (min-width: 1366px) {
    .news-landing-content {
        grid-gap:16px;
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(12,minmax(0,1fr));
    }

    .news-landing-content-main {
        grid-column: span 8 / span 8;
        padding-left: 8px;
        padding-right: 8px;
    }
}

.news-landing-content-main .rich-text p {
    font-size: 16px;
    line-height: 24px;
}

.news-landing-content-side .news-search-box-container {
    align-items: flex-end;
    border-bottom: 1px solid #75787b;
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 12px;
    margin-left: 12px;
    margin-right: 12px;
    padding-bottom: 0;
}

@media (min-width: 1366px) {
    .news-landing-content-side .news-search-box-container {
        margin-left:0;
        margin-right: 0;
    }
}

.news-landing-content-side .news-search-box-container input {
    --text-opacity: 1;
    border: none;
    border-radius: 0;
    box-shadow: none;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
   
    font-size: 16px;
    font-style: italic;
    height: auto;
    line-height: 24px;
    padding-bottom: 8px;
    padding-left: 32px;
}

.news-landing-content-side .news-search-box-container input::placeholder {
    --text-opacity: 1;
    color: #75787b;
    color: rgba(117,120,123,var(--text-opacity));
    opacity: 0.5;
}

.news-landing-content-side .news-search-box-container button {
    align-self: center;
    display: flex;
    left: 20px;
    margin-left: 0;
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    position: relative;
    top: unset;
}

.news-landing-content-side .news-search-box-container i svg {
    fill: #005bbb;
    height: 18px;
    width: 18px;
}

.news-landing-content-side > div:first-child {
    padding-left: 0;
    padding-right: 0;
}

@media (min-width: 1366px) {
    .news-landing-content-side > div:first-child {
        padding-bottom:0;
    }

    .news-landing-content-side {
        grid-column: span 4 / span 4;
        padding-left: 8px;
        padding-right: 8px;
    }
}

.news-results {
    border-top: 1px solid #e2e2e2;
    margin-top: 16px;
    padding-top: 40px;
}

.news-results-heading {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
   
    font-size: 24px;
    line-height: 30px;
    line-height: 24px;
}

@media (min-width: 768px) {
    .news-results-heading {
        margin-bottom:24px;
    }
}

.news-results-container {
    grid-gap: 16px;
    grid-row-gap: 0;
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(6,minmax(0,1fr));
    margin-bottom: 40px;
    row-gap: 0;
}

@media (min-width: 768px) {
    .news-results-container {
        grid-template-columns:repeat(8,minmax(0,1fr));
        margin-bottom: 24px;
    }
}

.news-results-item {
    border-bottom: 1px solid #e2e2e2;
    display: flex;
    flex-direction: column;
    grid-column: span 6 / span 6;
    margin-bottom: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    width: unset !important;
}

@media (min-width: 768px) {
    .news-results-item {
        grid-column:span 4 / span 4;
        margin-bottom: 40px;
        padding-bottom: 40px;
        padding-left: 8px;
        padding-right: 8px;
        width: unset !important;
    }
}

@media (min-width: 1366px) {
    .news-results-item {
        grid-column:span 4 / span 4;
        width: unset !important;
    }
}

.news-results-item:last-of-type {
    margin-bottom: 0;
}

@media (min-width: 768px) {
    .news-results-item:last-of-type {
        margin-bottom:40px;
    }
}

.news-results-item-image {
    margin-bottom: 16px;
}

@media (min-width: 768px) {
    .news-results-item-image {
        margin-bottom:24px;
    }
}

.news-results-item-meta {
    -webkit-box-ordinal-group: 4;
    -ms-flex-order: 3;
    margin-bottom: 0;
    order: 3;
}

@media (min-width: 768px) {
    .news-results-item-meta {
        margin-top:auto;
    }
}

.news-results-item-meta-category {
    border: 2px solid #0098db;
    border-radius: 8px;
    color: #005bbb !important;
    display: inline-block;
   
    font-size: 16px;
    height: auto;
    letter-spacing: 0.16px;
    line-height: 20px;
    line-height: 24px;
    padding: 6px 16px;
    text-align: center;
    text-transform: none;
    transition-duration: 0.2s;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4,0,1,1);
}

@media (hover: hover) {
    .news-results-item-meta-category:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #003c69;
        background-color: rgba(0,60,105,var(--bg-opacity));
        color: #fff;
        color: rgba(255,255,255,var(--text-opacity));
        transition-duration: 0.2s;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4,0,1,1);
    }
}

.news-results-item-meta-category > span,.news-results-item-meta-category i,.news-results-item-meta-category svg {
    display: inline;
}

.news-results-item-meta-category svg {
    fill: #fff;
    height: 20px;
    margin-right: 4px;
    transform: translateY(-2.5px);
    width: 20px;
}

@media (hover: hover) {
    .news-results-item-meta-category:hover {
        --bg-opacity:1;
        --text-opacity: 1;
        background-color: #fff;
        background-color: rgba(255,255,255,var(--bg-opacity));
        background-color: #0098db;
        background-color: rgba(0,152,219,var(--bg-opacity));
        color: #005bbb;
        color: rgba(0,91,187,var(--text-opacity));
        color: #fff !important;
    }
}

.news-results-item-meta-seperator {
    display: none;
}

.news-results-item-meta-date {
    --text-opacity: 1;
    color: #000;
    color: rgba(0,0,0,var(--text-opacity));
    display: inline-block;
   
    font-size: 14px;
    line-height: 20px;
    margin-left: 12px;
    text-transform: lowercase;
}

.news-results-item-meta-date:first-letter {
    text-transform: capitalize;
}

.news-results-item-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
   
    font-size: 24px;
    line-height: 32px;
}

@media (min-width: 768px) {
    .news-results-item-title {
        margin-bottom:16px;
    }
}

.news-results-item-summary {
    margin-bottom: 16px;
}

@media (min-width: 768px) {
    .news-results-item-summary {
        margin-bottom:24px;
    }
}

.news-results-item-summary p {
    --text-opacity: 1;
    color: #444;
    color: rgba(68,68,68,var(--text-opacity));
   
    font-size: 16px;
    line-height: 24px;
}

.news-results-item-summary pre {
   
    white-space: pre-wrap;
}

.news-search {
    grid-column: span 6 / span 6;
    margin: unset;
}

@media (min-width: 768px) {
    .news-search {
        margin-left:auto;
        margin-right: auto;
    }
}

.news-search .news-results-container {
    margin-left: 0;
    margin-right: 0;
}

@media (min-width: 1366px) {
    .news-search {
        grid-column:span 12 / span 12;
    }

    .news-search-page {
        padding-left: 32px;
        padding-right: 32px;
    }
}

.news-search-count,.news-search-results-title {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));
}

.news-search-results-title {

   
    font-size: 16px;
    line-height: 20px;
}

@media (min-width: 1366px) {
    .news-search-results-title {
        font-size:32px;
        line-height: 36px;
    }
}

.scPage {
    grid-gap: 16px;
    gap: 16px;
}

.scPage-hero,.scPage-hero.section-container {
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
}

@media (min-width: 768px) {
    .scPage-hero.section-container {
        margin-bottom:56px;
    }
}

.scPage-hero-heading,.scPage-hero h1 {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

    font-size: 32px;
    line-height: 36px;
    margin-left: 12px;
    margin-right: 12px;
    max-width: 50%;
}

@media (min-width: 1366px) {
    .scPage-hero-heading,.scPage-hero h1 {
        font-size:48px;
        line-height: 52px;
    }
}

@media (min-width: 768px) {
    .scPage-hero-heading,.scPage-hero h1 {
        margin-left:48px;
        margin-right: 48px;
    }
}

.scPage-hero-image img {
    border-radius: 0;
}

.scPage-content-main-set h2 {
    --text-opacity: 1;
    color: #005bbb;
    color: rgba(0,91,187,var(--text-opacity));

    font-size: 32px;
    line-height: 36px;
}

@media (min-width: 1366px) {
    .scPage-content-main-set h2 {
        font-size:48px;
        line-height: 52px;
    }
}

.scPage-content-side .block-wrapper {
    padding-top: 0;
}

.main,main {
    padding-top: 88px;
}

@media (min-width: 1366px) {
    .main,main {
        padding-top:106px;
    }
}

@media (min-width: 768px) {
    .tablet\\:container {
        width:100%;
    }
}

@media (min-width: 768px) and (min-width:768px) {
    .tablet\\:container {
        max-width:768px;
    }
}

@media (min-width: 768px) and (min-width:960px) {
    .tablet\\:container {
        max-width:960px;
    }
}

@media (min-width: 768px) and (min-width:1200px) {
    .tablet\\:container {
        max-width:1200px;
    }
}

@media (min-width: 768px) and (min-width:1366px) {
    .tablet\\:container {
        max-width:1366px;
    }
}

@media (min-width: 768px) {
    .tablet\\:flex {
        display: flex;
    }

    .tablet\\:grid {
        display: grid;
    }

    .tablet\\:flex-row {
        flex-direction: row;
    }

    .tablet\\:flex-row-reverse {
        flex-direction: row-reverse;
    }

    .tablet\\:justify-center {
        justify-content: center;
    }

    .tablet\\:mt-0 {
        margin-top: 0;
    }

    .tablet\\:mb-0 {
        margin-bottom: 0;
    }

    .tablet\\:mb-2 {
        margin-bottom: 8px;
    }

    .tablet\\:mt-4 {
        margin-top: 16px;
    }

    .tablet\\:mr-4 {
        margin-right: 16px;
    }

    .tablet\\:mb-4 {
        margin-bottom: 16px;
    }

    .tablet\\:ml-4 {
        margin-left: 16px;
    }

    .tablet\\:mt-6 {
        margin-top: 24px;
    }

    .tablet\\:mb-6 {
        margin-bottom: 24px;
    }

    .tablet\\:mb-8 {
        margin-bottom: 32px;
    }

    .tablet\\:mb-12 {
        margin-bottom: 48px;
    }

    .tablet\\:py-2 {
        padding-bottom: 8px;
        padding-top: 8px;
    }

    .tablet\\:px-30 {
        padding-left: 120px;
        padding-right: 120px;
    }

    .tablet\\:pt-0 {
        padding-top: 0;
    }

    .tablet\\:pb-0 {
        padding-bottom: 0;
    }

    .tablet\\:pr-2 {
        padding-right: 8px;
    }

    .tablet\\:pb-4 {
        padding-bottom: 16px;
    }

    .tablet\\:pt-6 {
        padding-top: 24px;
    }

    .tablet\\:pb-6 {
        padding-bottom: 24px;
    }

    .tablet\\:text-left {
        text-align: left;
    }

    .tablet\\:gap-0 {
        grid-gap: 0;
        gap: 0;
    }

    .tablet\\:gap-3 {
        grid-gap: 12px;
        gap: 12px;
    }

    .tablet\\:gap-4 {
        grid-gap: 16px;
        gap: 16px;
    }

    .tablet\\:gap-5 {
        grid-gap: 20px;
        gap: 20px;
    }

    .tablet\\:gap-6 {
        grid-gap: 24px;
        gap: 24px;
    }

    .tablet\\:row-gap-6 {
        grid-row-gap: 24px;
        row-gap: 24px;
    }

    .tablet\\:grid-cols-2 {
        grid-template-columns: repeat(2,minmax(0,1fr));
    }

    .tablet\\:grid-cols-4 {
        grid-template-columns: repeat(4,minmax(0,1fr));
    }

    .tablet\\:grid-cols-12 {
        grid-template-columns: repeat(12,minmax(0,1fr));
    }

    .tablet\\:col-span-3 {
        grid-column: span 3 / span 3;
    }

    .tablet\\:col-span-4 {
        grid-column: span 4 / span 4;
    }

    .tablet\\:col-span-6 {
        grid-column: span 6 / span 6;
    }

    .tablet\\:col-span-9 {
        grid-column: span 9 / span 9;
    }

    .tablet\\:col-span-12 {
        grid-column: span 12 / span 12;
    }
}

@media (min-width: 960px) {
    .md\\:container {
        width:100%;
    }
}

@media (min-width: 960px) and (min-width:768px) {
    .md\\:container {
        max-width:768px;
    }
}

@media (min-width: 960px) and (min-width:960px) {
    .md\\:container {
        max-width:960px;
    }
}

@media (min-width: 960px) and (min-width:1200px) {
    .md\\:container {
        max-width:1200px;
    }
}

@media (min-width: 960px) and (min-width:1366px) {
    .md\\:container {
        max-width:1366px;
    }
}

@media (min-width: 960px) {
    .md\\:inline {
        display:inline;
    }

    .md\\:flex {
        display: flex;
    }

    .md\\:flex-row {
        flex-direction: row;
    }

    .md\\:items-start {
        align-items: flex-start;
    }

    .md\\:flex-grow {
        flex-grow: 1;
    }

    .md\\:mx-auto {
        margin-left: auto;
        margin-right: auto;
    }

    .md\\:mb-0 {
        margin-bottom: 0;
    }

    .md\\:ml-2 {
        margin-left: 8px;
    }

    .md\\:mr-6 {
        margin-right: 24px;
    }

    .md\\:mb-14 {
        margin-bottom: 56px;
    }

    .md\\:text-left {
        text-align: left;
    }

    .md\\:w-1\\/2 {
        width: 50%;
    }

    .md\\:w-1\\/3 {
        width: 33.333333%;
    }

    .md\\:w-2\\/3 {
        width: 66.666667%;
    }

    .md\\:gap-5 {
        grid-gap: 20px;
        gap: 20px;
    }
}

@media (min-width: 1200px) {
    .lg\\:container {
        width:100%;
    }
}

@media (min-width: 1200px) and (min-width:768px) {
    .lg\\:container {
        max-width:768px;
    }
}

@media (min-width: 1200px) and (min-width:960px) {
    .lg\\:container {
        max-width:960px;
    }
}

@media (min-width: 1200px) and (min-width:1200px) {
    .lg\\:container {
        max-width:1200px;
    }
}

@media (min-width: 1200px) and (min-width:1366px) {
    .lg\\:container {
        max-width:1366px;
    }
}

@media (min-width: 1200px) {
    .lg\\:block {
        display:block;
    }

    .lg\\:flex {
        display: flex;
    }

    .lg\\:hidden {
        display: none;
    }

    .lg\\:flex-row {
        flex-direction: row;
    }

    .lg\\:flex-row-reverse {
        flex-direction: row-reverse;
    }

    .lg\\:flex-col {
        flex-direction: column;
    }

    .lg\\:justify-between {
        justify-content: space-between;
    }

    .lg\\:mx-0 {
        margin-left: 0;
        margin-right: 0;
    }

    .lg\\:mx-5 {
        margin-left: 20px;
        margin-right: 20px;
    }

    .lg\\:mx-auto {
        margin-left: auto;
        margin-right: auto;
    }

    .lg\\:mb-0 {
        margin-bottom: 0;
    }

    .lg\\:mb-3 {
        margin-bottom: 12px;
    }

    .lg\\:mb-4 {
        margin-bottom: 16px;
    }

    .lg\\:mb-5 {
        margin-bottom: 20px;
    }

    .lg\\:mb-6 {
        margin-bottom: 24px;
    }

    .lg\\:mb-14 {
        margin-bottom: 56px;
    }

    .lg\\:ml-23 {
        margin-left: 92px;
    }

    .lg\\:max-w-desktop {
        max-width: 1366px;
    }

    .lg\\:max-w-1\\/2 {
        max-width: 50%;
    }

    .lg\\:px-0 {
        padding-left: 0;
        padding-right: 0;
    }

    .lg\\:px-5 {
        padding-left: 20px;
        padding-right: 20px;
    }

    .lg\\:py-8 {
        padding-bottom: 32px;
        padding-top: 32px;
    }

    .lg\\:pl-0 {
        padding-left: 0;
    }

    .lg\\:pt-6 {
        padding-top: 24px;
    }

    .lg\\:pr-6 {
        padding-right: 24px;
    }

    .lg\\:pr-8 {
        padding-right: 32px;
    }

    .lg\\:pl-8 {
        padding-left: 32px;
    }

    .lg\\:pb-9 {
        padding-bottom: 36px;
    }

    .lg\\:pb-11 {
        padding-bottom: 44px;
    }

    .lg\\:pt-13 {
        padding-top: 52px;
    }

    .lg\\:pb-13 {
        padding-bottom: 52px;
    }

    .lg\\:pt-16 {
        padding-top: 64px;
    }

    .lg\\:pb-20 {
        padding-bottom: 80px;
    }

    .lg\\:pt-22 {
        padding-top: 88px;
    }

    .lg\\:pr-22 {
        padding-right: 88px;
    }

    .lg\\:pt-50 {
        padding-top: 200px;
    }

    .lg\\:text-left {
        text-align: left;
    }

    .lg\\:w-30 {
        width: 120px;
    }

    .lg\\:w-max {
        width: 1328px;
    }

    .lg\\:w-sidebar {
        width: 296px;
    }

    .lg\\:w-1\\/2 {
        width: 50%;
    }

    .lg\\:w-1\\/3 {
        width: 33.333333%;
    }

    .lg\\:w-2\\/3 {
        width: 66.666667%;
    }

    .lg\\:gap-5 {
        grid-gap: 20px;
        gap: 20px;
    }

    .lg\\:grid-cols-2 {
        grid-template-columns: repeat(2,minmax(0,1fr));
    }

    .lg\\:grid-cols-3 {
        grid-template-columns: repeat(3,minmax(0,1fr));
    }

    .lg\\:grid-cols-4 {
        grid-template-columns: repeat(4,minmax(0,1fr));
    }

    .lg\\:grid-cols-10 {
        grid-template-columns: repeat(10,minmax(0,1fr));
    }

    .lg\\:col-span-2 {
        grid-column: span 2 / span 2;
    }

    .lg\\:col-span-3 {
        grid-column: span 3 / span 3;
    }

    .lg\\:col-span-7 {
        grid-column: span 7 / span 7;
    }

    .lg\\:col-span-10 {
        grid-column: span 10 / span 10;
    }
}

@media (min-width: 1366px) {
    .xl\\:container {
        width:100%;
    }
}

@media (min-width: 1366px) and (min-width:768px) {
    .xl\\:container {
        max-width:768px;
    }
}

@media (min-width: 1366px) and (min-width:960px) {
    .xl\\:container {
        max-width:960px;
    }
}

@media (min-width: 1366px) and (min-width:1200px) {
    .xl\\:container {
        max-width:1200px;
    }
}

@media (min-width: 1366px) and (min-width:1366px) {
    .xl\\:container {
        max-width:1366px;
    }
}

@media (min-width: 1366px) {
    .xl\\:block {
        display:block;
    }

    .xl\\:flex {
        display: flex;
    }

    .xl\\:hidden {
        display: none;
    }

    .xl\\:flex-col {
        flex-direction: column;
    }

    .xl\\:float-left {
        float: left;
    }

    .xl\\:mb-0 {
        margin-bottom: 0;
    }

    .xl\\:mr-2 {
        margin-right: 8px;
    }

    .xl\\:mr-4 {
        margin-right: 16px;
    }

    .xl\\:mb-5 {
        margin-bottom: 20px;
    }

    .xl\\:mt-6 {
        margin-top: 24px;
    }

    .xl\\:mr-6 {
        margin-right: 24px;
    }

    .xl\\:mb-6 {
        margin-bottom: 24px;
    }

    .xl\\:mt-8 {
        margin-top: 32px;
    }

    .xl\\:mb-8 {
        margin-bottom: 32px;
    }

    .xl\\:ml-8 {
        margin-left: 32px;
    }

    .xl\\:mb-12 {
        margin-bottom: 48px;
    }

    .xl\\:mr-13 {
        margin-right: 52px;
    }

    .xl\\:mb-14 {
        margin-bottom: 56px;
    }

    .xl\\:max-w-desktop {
        max-width: 1366px;
    }

    .xl\\:max-w-1\\/2 {
        max-width: 50%;
    }

    .xl\\:p-2 {
        padding: 8px;
    }

    .xl\\:pb-0 {
        padding-bottom: 0;
    }

    .xl\\:pl-0 {
        padding-left: 0;
    }

    .xl\\:pt-2 {
        padding-top: 8px;
    }

    .xl\\:pr-2 {
        padding-right: 8px;
    }

    .xl\\:pb-2 {
        padding-bottom: 8px;
    }

    .xl\\:pt-3 {
        padding-top: 12px;
    }

    .xl\\:pb-3 {
        padding-bottom: 12px;
    }

    .xl\\:pr-4 {
        padding-right: 16px;
    }

    .xl\\:pl-4 {
        padding-left: 16px;
    }

    .xl\\:pt-6 {
        padding-top: 24px;
    }

    .xl\\:pr-6 {
        padding-right: 24px;
    }

    .xl\\:pb-6 {
        padding-bottom: 24px;
    }

    .xl\\:pl-6 {
        padding-left: 24px;
    }

    .xl\\:pt-8 {
        padding-top: 32px;
    }

    .xl\\:pb-8 {
        padding-bottom: 32px;
    }

    .xl\\:pt-13 {
        padding-top: 52px;
    }

    .xl\\:text-left {
        text-align: left;
    }

    .xl\\:w-1\\/2 {
        width: 50%;
    }

    .xl\\:w-1\\/3 {
        width: 33.333333%;
    }

    .xl\\:w-2\\/3 {
        width: 66.666667%;
    }

    .xl\\:gap-0 {
        grid-gap: 0;
        gap: 0;
    }

    .xl\\:gap-4 {
        grid-gap: 16px;
        gap: 16px;
    }

    .xl\\:grid-cols-3 {
        grid-template-columns: repeat(3,minmax(0,1fr));
    }

    .xl\\:grid-cols-4 {
        grid-template-columns: repeat(4,minmax(0,1fr));
    }

    .xl\\:grid-cols-5 {
        grid-template-columns: repeat(5,minmax(0,1fr));
    }

    .xl\\:grid-cols-6 {
        grid-template-columns: repeat(6,minmax(0,1fr));
    }

    .xl\\:grid-cols-12 {
        grid-template-columns: repeat(12,minmax(0,1fr));
    }

    .xl\\:col-span-1 {
        grid-column: span 1 / span 1;
    }

    .xl\\:col-span-2 {
        grid-column: span 2 / span 2;
    }

    .xl\\:col-span-3 {
        grid-column: span 3 / span 3;
    }

    .xl\\:col-span-4 {
        grid-column: span 4 / span 4;
    }

    .xl\\:col-span-5 {
        grid-column: span 5 / span 5;
    }

    .xl\\:col-span-6 {
        grid-column: span 6 / span 6;
    }

    .xl\\:col-span-8 {
        grid-column: span 8 / span 8;
    }

    .xl\\:col-start-2 {
        grid-column-start: 2;
    }

    .xl\\:col-start-3 {
        grid-column-start: 3;
    }

    .xl\\:col-start-4 {
        grid-column-start: 4;
    }
}

.pdf-js-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
}

.pdf-js-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.ndq-10541 .show-all {
    display: none !important;
}

.base-page-hero-content-mask .file-link a 
{
    width:235px;
}`, "",{"version":3,"sources":["webpack://./src/pages/investor/Investor.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI;AACJ;;;;AAIA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B;IAC5B,2CAA2C;IAC3C,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;IAC3B,mEAAmE;IACnE;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gDAAgD;IAChD,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,mEAAmE;IACnE,oBAAoB;IACpB,4BAA4B;IAC5B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8CAA8C;IAC9C,6BAA6B;IAC7B,8BAA8B;IAC9B,sDAAsD;IACtD;AACJ;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mEAAmE;IACnE,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAC9B,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,gDAAgD;IAChD,2BAA2B;IAC3B,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;IACpC,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,qBAAqB;IACrB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb;AACJ;;;;AAIA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB;AACJ;;AAEA;IACI,mEAAmE;IACnE;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,qCAAqC;IACrC;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,gCAAgC;QAChC,uCAAuC;QACvC,6CAA6C;QAC7C,+BAA+B;QAC/B;IACJ;;;;IAIA;QACI,gDAAgD;QAChD,2BAA2B;QAC3B,0BAA0B;QAC1B,2BAA2B;QAC3B,wBAAwB;QACxB,yBAAyB;QACzB,uBAAuB;QACvB,kBAAkB;QAClB;IACJ;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;QACtB,0BAA0B;QAC1B,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;;IAGA;QACI,0BAA0B;QAC1B,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,MAAM;IACN,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,4DAA4D;IAC5D,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;;;AAIA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IAGZ,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,4BAA4B;IAC5B,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IAEzB,iBAAiB;AACrB;;AAEA;IAGI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IAKtB,6EAA6E;IAC7E,4BAA4B;IAC5B,yDAAyD;IACzD,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IAKzB,0DAA0D;IAC1D,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,sBAAsB;IACtB,sBAAsB;IAKtB,yDAAyD;IACzD,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IAKzB,mFAAmF;IACnF,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,wDAAwD;IACxD,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IAKzB,mFAAmF;IACnF,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;IAEtB,6BAA6B;IAE7B,4BAA4B;IAK5B,0DAA0D;IAC1D,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IAEI,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;;;AAIA;IACI,wBAAwB;IACxB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;;;AAIA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,wDAAwD;IACxD,eAAe;IACf,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;QAC5B,mBAAmB;QACnB,eAAe;QACf,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IAGI,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;;AAGA;IACI,YAAY;AAChB;;;AAGA;IACI,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,kCAAkC;IAClC,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;;AAElB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IAGI,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,sBAAsB;KACtB,oCAAqC;IACrC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;;;AAIA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,MAAM,CAAC;;AAEX;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6CAA6C;IAC7C,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;;;;AAIA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,4BAA4B;IAC5B,iCAAiC;AACrC;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IAGI,uBAAuB;AAC3B;;;;AAIA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IAMvB,yIAAyI;AAC7I;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,SAAS;AACb;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA;IAGI,+BAA+B;IAC/B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IAGX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;;;AAIA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI;QACI,4BAA4B;QAC5B,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;QAC3B,UAAU;QACV,YAAY;QACZ,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IAKI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;AAC1B;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI;QACI,UAAU;QACV,cAAc;QACd,SAAS;IACb;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;;;AAIA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,wDAAwD;IACxD,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6CAA6C;IAC7C,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,4BAA4B;IAC5B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,SAAS;IACb;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,8BAA8B;AAClC;;;;AAIA;IACI,iCAAiC;AACrC;;;;AAIA;IACI,iCAAiC;AACrC;;;AAGA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,uIAAuI;IACvI,0IAA0I;IAC1I,uIAAuI;IACvI,qIAAqI;IACrI,iIAAiI;IACjI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,gCAAgC;IAChC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IAGI,2BAA2B;IAG3B,4BAA4B;IAC5B,yGAAyG;IACzG,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IAGI,2BAA2B;IAG3B,4BAA4B;IAI5B,gGAAgG;IAChG,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;;AAIA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,uIAAuI;IACvI,0IAA0I;IAC1I,uIAAuI;IACvI,qIAAqI;IACrI,iIAAiI;IACjI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IAKI,qBAAqB;IAIrB,gGAAgG;IAChG,yGAAyG;IACzG,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,yGAAyG;IACzG,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,aAAa;IACb,WAAW;IACX,eAAe;IAIf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,cAAc;IACd,uDAAuD;IACvD,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,4BAA4B;QAC5B,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,8CAA8C;QAC9C,mBAAmB;QACnB,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,mBAAmB;QACnB,qDAAqD;QACrD,WAAW;QACX,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;QAC7B,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,oDAAoD;QACpD,mBAAmB;QACnB,cAAc;QACd,WAAW;QACX,WAAW;IACf;;IAEA;QACI,6BAA6B;QAC7B,WAAW;QACX,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,WAAW;QACX,2BAA2B;QAC3B,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,qBAAqB;QACrB,kBAAkB;QAClB,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI;QACI,0BAA0B;QAC1B,UAAU;QACV,YAAY;QACZ,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,eAAe;QACf,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IAGI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IAGzB,iBAAiB;IAKjB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,qDAAqD;IACrD,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,SAAS;QACT,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,aAAa;IAKb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,oDAAoD;IACpD,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IAEI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;IACnD,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,wEAAwE;AAC5E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,oBAAoB;IACpB,wCAAwC;IACxC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,sCAAsC;IACtC,uCAAuC;IACvC,2EAA2E;IAC3E,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gDAAgD;IAChD,cAAc;IACd,mBAAmB;IACnB,qDAAqD;IACrD,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,wDAAwD;IACxD,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,wDAAwD;IACxD,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,mCAAmC;IACnC,4CAA4C;AAChD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,4CAA4C;IAC5C,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;SACpB,wBAAwB;IAC7B;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,8CAA8C;QAC9C,gDAAgD;IACpD;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAgDA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IAEI,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAkBA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,mBAAmB;;IAEnB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IAGI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IAGxC,aAAa;IAEb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,+CAA+C;IAC/C,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IAGI,yFAAyF;AAC7F;;AAEA;IACI,UAAU;IAGV,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IAGjC,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IAEI,2DAA2D;IAC3D,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IAEzB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IAEI,uBAAuB;AAC3B;;AAEA;IAEI,sBAAsB;AAC1B;;AAEA;IAEI,uBAAuB;AAC3B;;AAcA;IACI;QAEI,uBAAuB;IAC3B;;IAEA;QAEI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,qBAAqB;QACrB,aAAa;QACb,iBAAiB;QAGjB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gDAA8Q;AAClR;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QAGI,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mDAAmD;IACnD,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,oDAAoD;IACxD;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,mDAAmD;IACnD,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,oDAAoD;IACxD;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,yBAAyB;IACzB,mDAAmD;IACnD,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,oDAAoD;IACxD;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IAGI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IAII,sBAAsB;AAC1B;;AAEA;IAEI,eAAe;AACnB;;AAEA;IAGI,uBAAuB;AAC3B;;AAEA;IAGI,mBAAmB;AACvB;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IAGI,yBAAyB;AAC7B;;AAEA;IAGI,uBAAuB;AAC3B;;AAEA;IAGI,8BAA8B;AAClC;;AAEA;IAGI,cAAc;AAClB;;AAEA;IAGI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,MAAM;AACV;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,qBAAqB;IAGrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IAGtB,4PAA4P;AAChQ;;AASA;IACI;QAEI,wBAAwB;IAC5B;AACJ;;AAUA;IACI;QACI,UAAU;QAEV,mBAAmB;IACvB;AACJ;;AAQA;IACI;QACI,YAAY;IAChB;AACJ;;AAkBA;IACI;QAEI,kDAAkD;QAElD,2BAA2B;IAC/B;;IAEA;QAEI,kDAAkD;QAElD,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IAEnB,mCAAmC;IACnC,cAAc;IACd,0CAA0C;IAC1C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iDAAiD;IAEjD,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI;QAEI,mCAAmC;IACvC;;IAEA;QAEI,gCAAgC;IACpC;AACJ;;AAEA;IAEI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IAEnB,mCAAmC;IACnC,cAAc;IACd,0CAA0C;IAC1C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iDAAiD;IAEjD,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI;QAEI,mCAAmC;IACvC;;IAEA;QAEI,gCAAgC;IACpC;AACJ;;AAEA;IAEI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IAEnB,mCAAmC;IACnC,cAAc;IACd,0CAA0C;IAC1C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iDAAiD;IAEjD,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI;QAEI,mCAAmC;IACvC;;IAEA;QAEI,gCAAgC;IACpC;AACJ;;AAEA;IAEI,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,2CAA2C;QAG3C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,oDAAoD;QACpD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,2CAA2C;QAG3C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,oDAAoD;QACpD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,2CAA2C;QAG3C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,oDAAoD;QACpD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;;AAE5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;;AAE9C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;;AAE5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;AAC7C;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;;IAE3C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;;IAE3C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;AAE5C;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;AAE5C;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,+BAA+B;IAC/B,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,MAAM;AACV;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,UAAU;AACd;;AAEA;;;;;GAKG;;AAEH;IACI,kCAAkC;IAClC,mCAAmC;IAEnC,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,uCAAuC;IACvC,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,uCAAuC;IACvC,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,8FAA8F;IAC9F,oBAAoB;IACpB,4CAA4C;IAC5C,4BAA4B;IAC5B,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IAEI,kBAAkB;IAElB,4CAA4C;IAE5C,2BAA2B;IAE3B,yDAAyD;IAEzD,sBAAsB;IAEtB,mDAAmD;IAEnD,mCAAmC;IAEnC,uEAAuE;IAEvE,uBAAuB;IAEvB,sCAAsC;IAEtC,iEAAiE;AACrE;;AAEA;IAEI,mCAAmC;IAEnC,uEAAuE;IAEvE,uBAAuB;IAEvB,oDAAoD;IAEpD,+EAA+E;AACnF;;AAEA;IAEI,kBAAkB;IAElB,4CAA4C;IAE5C,2BAA2B;IAE3B,yDAAyD;IAEzD,sBAAsB;IAEtB,mDAAmD;AACvD;;AAEA;IAEI,mCAAmC;IAEnC,uEAAuE;IAEvE,wBAAwB;IAExB,oDAAoD;IAEpD,+EAA+E;AACnF;;AAEA;IAEI,kBAAkB;IAElB,4CAA4C;IAE5C,2BAA2B;IAE3B,yDAAyD;IAEzD,sBAAsB;IAEtB,mDAAmD;IAEnD,mCAAmC;IAEnC,uEAAuE;IAEvE,uBAAuB;IAEvB,sCAAsC;IAEtC,iEAAiE;AACrE;;AAEA;IAEI,kBAAkB;IAElB,4CAA4C;IAE5C,2BAA2B;IAE3B,yDAAyD;IAEzD,sBAAsB;IAEtB,mDAAmD;IAEnD,mCAAmC;IAEnC,uEAAuE;IAEvE,uBAAuB;IAEvB,iCAAiC;IAEjC,4DAA4D;AAChE;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IAEI,2BAA2B;IAE3B,yDAAyD;IAEzD,sBAAsB;IAEtB,mDAAmD;IAEnD,mCAAmC;IAEnC,uEAAuE;IAEvE,uBAAuB;IAEvB,mCAAmC;IAEnC,8DAA8D;AAClE;;AAEA;IACI;QAEI,qBAAqB;QAErB,uBAAuB;QAEvB,4BAA4B;QAG5B,oBAAoB;QAGpB,uBAAuB;IAC3B;AACJ;;AAgBA;IACI;QAEI,mBAAmB;IACvB;;IAEA;QAEI,sBAAsB;QAEtB,2CAA2C;IAC/C;AACJ;;AASA;IACI;QACI,YAAY;QACZ,mCAAmC;IACvC;AACJ;;AAmBA;IACI;QACI,YAAY;QACZ,oCAAoC;QAEpC,mBAAmB;IACvB;;IAEA;QACI,UAAU;QAEV,uBAAuB;QAEvB,6CAA6C;IACjD;AACJ;;AAWA;IACI;QAEI,2BAA2B;QAE3B,0GAA0G;IAC9G;AACJ;;AAcA;IACI;QAEI,uBAAuB;IAC3B;;IAEA;QAEI,wBAAwB;IAC5B;AACJ;;AAEA;IAGI,wBAAwB;AAC5B;;AAEA;IAGI,yBAAyB;AAC7B;;AAEA;IAGI,yBAAyB;AAC7B;;AAEA;IAGI,qBAAqB;AACzB;;AAEA;IAGI,qBAAqB;AACzB;;AAEA;IAGI,oBAAoB;AACxB;;AAEA;IAGI,uBAAuB;IAGvB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;;AAGA;IACI,eAAe;;IAEf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,iBAAiB;IAGjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,2BAA2B;IAG3B,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IAGI,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,UAAU;IAGV,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;IAC3C,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAGhB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI;QACI,SAAS;QAGT,oCAAoC;IACxC;AACJ;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAGhB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI;QACI,SAAS;QAGT,oCAAoC;IACxC;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAGhB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI;QACI,SAAS;QAGT,oCAAoC;IACxC;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;IACzC,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,mDAAmD;IACvD;AACJ;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;IACzC,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,mDAAmD;IACvD;AACJ;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;IACzC,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,mDAAmD;IACvD;AACJ;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,wBAAwB;QACxB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,yCAAyC;IAC7C;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,yBAAyB;QACzB,mDAAmD;QACnD,cAAc;QACd,yCAAyC;QACzC,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,kDAAkD;IACtD;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,aAAa;QACb,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;IAGzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;IAGzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;IAGzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;;;AAIA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IAGI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAElC,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IAEjB,gBAAgB;IAChB,cAAc;IACd,4CAA4C;;IAE5C,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAkBA;IACI,YAAY;AAChB;;AAEA;IAKI,qBAAqB;IACrB,gCAAgC;IAGhC,aAAa;IAEb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAEhB,gBAAgB;IAChB,cAAc;IACd,4CAA4C;;IAE5C,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AA8BA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,YAAY;AAChB;;AAEA;IAEI,kBAAkB;IAGlB,aAAa;IACb,UAAU;IACV,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI;QACI,6BAA6B;QAC7B,+CAA+C;IACnD;AACJ;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+DAA+D;IAC/D,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAElB,yCAAyC;IACzC,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;IACvB;AACJ;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IAEb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;;IAEtB,eAAe;AACnB;;AAEA;IACI;QAII,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IAGI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IAEb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,WAAW;IACX,yCAAyC;;IAEzC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IAKI,aAAa;IAEb,sBAAsB;;IAEtB,eAAe;AACnB;;AAEA;IACI;QAII,mBAAmB;QACnB,eAAe;IACnB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IAGI,mBAAmB;AACvB;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;IACX,WAAW;AACf;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAGhB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IAGI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IAGI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IAGI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IAGI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;;IAEI,eAAe;IACf,OAAO;IACP,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IAGI,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAG1C,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IAKI,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;AAE5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;IAGhB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IAEI,2BAA2B;AAC/B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI;QACI,6BAA6B;QAC7B,0BAA0B;QAC1B,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IAKI,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IAGI,eAAe;IAGf,mBAAmB;IACnB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAG1C,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IAGtB,aAAa;IAEb,eAAe;IACf,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI;QAGI,8BAA8B;QAC9B,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IAKI,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,YAAY;;IAEZ,eAAe;IACf,iBAAiB;IAGjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IAGjB,6BAA6B;AACjC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,aAAa;;IAEb,eAAe;IACf,SAAS;IACT,8CAA8C;IAC9C,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,6BAA6B;QAC7B,+CAA+C;QAC/C,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,oBAAoB;IACxB;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,oBAAoB;IACpB,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,aAAa;;IAEb,eAAe;IACf,SAAS;IACT,8CAA8C;IAC9C,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,6BAA6B;QAC7B,+CAA+C;QAC/C,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,oBAAoB;IACxB;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI;QACI,8CAA8C;QAC9C,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,8CAA8C;QAC9C,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,oBAAoB;IACxB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,oBAAoB;IACxB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,UAAU;AACd;;AAEA;IAGI,aAAa;IACb,aAAa;IAEb,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IAEI,uBAAuB;IAEvB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IAGtB,mBAAmB;IAGnB,aAAa;IAEb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QAKI,uBAAuB;QAEvB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IAEI,gBAAgB;AACpB;;AAEA;IACI;QAEI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;IACI,aAAa;;IAEb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;QACd,uBAAuB;QACvB,oBAAoB;QACpB,sBAAsB;QACtB,qDAAqD;QACrD,YAAY;QACZ,2BAA2B;IAC/B;AACJ;;AAEA;IAGI,yBAAyB;AAC7B;;AAEA;IACI;QAGI,2BAA2B;QAC3B,qBAAqB;IACzB;;IAEA;QAGI,yBAAyB;QACzB,qBAAqB;IACzB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI;QACI,wCAAwC;QACxC,eAAe;QACf,iBAAiB;IACrB;;IAEA;QAGI,mBAAmB;QACnB,8CAA8C;QAC9C,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,MAAM;QACN,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QAGI,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,qDAAqD;IAErD,2CAA2C;IAG3C,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,8BAA8B;IAC9B,cAAc;IACd,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,kCAAkC;QAClC,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,OAAO;IACP,eAAe;IACf,MAAM;IACN,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IAGjB,mBAAmB;IACnB,cAAc;IACd,wCAAwC;IAGxC,aAAa;;IAEb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IAGZ,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;IAGV,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,cAAc;;IAEd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IAExB,2CAA2C;IAG3C,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,4BAA4B;IAC5B,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,YAAY;AAChB;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IAErD,2CAA2C;IAC3C,YAAY;IACZ,OAAO;IACP,eAAe;IACf,MAAM;IACN,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,qDAAqD;IAErD,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAGhB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,WAAW;AACf;;AAEA;IAGI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,wCAAwC;IACxC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,eAAe;IACf,MAAM;IACN,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,eAAe;IACf,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,qBAAqB;IAGrB,aAAa;;;IAGb,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IAKjB,eAAe;IAGf,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,wCAAwC;IAC5C;;IAEA;QAGI,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,oDAAoD;IACpD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAClB,UAAU;AACd;;;AAGA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IAGf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAC1C,cAAc;IAGd,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IAEI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IAGf,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,qDAAqD;IAGrD,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,eAAe;IAGf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAC1C,cAAc;IAGd,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IAEI,iBAAiB;IAGjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IAGI,WAAS;AACb;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IAGI,WAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IAGf,sBAAsB;IACtB,qDAAqD;IAGrD,aAAa;IAEb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IAGI,WAAS;;AAEb;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,cAAc;;IAEd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,4CAA4C;IAE5C,WAAS;;IAET,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IAGI,WAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IAGb,0BAA0B;AAC9B;;AAEA;IACI;QACI,cAAc;QACd,sBAAsB;QACtB,qDAAqD;IACzD;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,gDAAgD;IAChD,OAAO;IACP,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;IACI;QACI,oBAAoB;QACpB,YAAY;IAChB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI;QACI,OAAO;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI;QACI,SAAS;QACT,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,SAAS;QACT,QAAQ;IACZ;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI;QACI,UAAU;QACV,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAElB,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IAEI,yCAAyC;AAC7C;;AAEA;IACI;QACI,cAAc;QACd,sBAAsB;QACtB,qDAAqD;QACrD,aAAa;QACb,kBAAkB;QAClB,UAAU;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QAGI,aAAa;QAGb,2BAA2B;IAC/B;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QAGI,QAAQ;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IAEI,sBAAsB;IAEtB,4BAA4B;IAE5B,2BAA2B;IAE3B,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAElB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,OAAO;IAEP,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;AACd;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,WAAW;IACX,4CAA4C;IAC5C,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IAEI,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,yCAAyC;IAGzC,aAAa;;IAEb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;QAC3B,iBAAiB;QACjB,kBAAkB;QAClB,QAAQ;IACZ;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IAGjB,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAG5C,aAAa;;IAEb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IAEf,kBAAkB;IAClB,yBAAyB;IACzB,qDAAqD;IACrD,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IAGN,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAGlB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QAEI,sBAAsB;QACtB,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IAGf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAC1C,cAAc;IAGd,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IAEI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IAGf,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,qDAAqD;IAGrD,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IAEI,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IAEI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,0CAA0C;IAC9C;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IAGI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IAGtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAEhB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,qBAAqB;;IAErB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IAEI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAElB,uCAAuC;IACvC,OAAO;IACP,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,oCAAoC;IACpC,SAAS;IACT,WAAW;IACX,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,iCAAiC;IACjC,UAAU;IACV,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,QAAQ;IACR,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,eAAe;QACf,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;IAEI,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,SAAS;IACT,QAAQ;IAGR,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;IAE5B,2CAA2C;IAC3C,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;QACV,QAAQ;QACR,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IAEI,sBAAsB;IAEtB,4BAA4B;IAE5B,2BAA2B;IAE3B,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAElB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;AAEhD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;;AAEhD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,cAAc;QACd,iBAAiB;QACjB,iBAAiB;QACjB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,OAAO;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IAKI,aAAa;IAEb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IAEnB,0CAA0C;IAC1C,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,QAAQ;IAGR,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,OAAO;IACP,aAAa;IACb,eAAe;IACf,QAAQ;IACR,MAAM;IAGN,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI;QACI,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;IAEZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAGlB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IAGI,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,qBAAqB;QACrB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,YAAY;IAChB;AACJ;;AAEA;IAKI,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;AAC1B;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,4BAA4B;IAC5B,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI;QACI,iBAAiB;QACjB,wBAAwB;QACxB,qBAAqB;QACrB,sBAAsB;QACtB,8BAA8B;QAC9B,4BAA4B;QAC5B,uBAAuB;QACvB,aAAa;IACjB;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,qBAAqB;QACrB,aAAa;QAGb,aAAa;QAEb,eAAe;QACf,4BAA4B;QAC5B,uBAAuB;IAC3B;;IAEA;QAGI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;IACd;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI,0CAA0C;IAC1C,yBAAyB;IACzB,mBAAmB;IAEnB,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,MAAM;IACN,MAAM;IACN,MAAM;IACN,YAAY;IACZ,mBAAmB;IAGnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IAGI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAGhB,wGAAwG;IAIxG,mCAAmC;IAEnC,4BAA4B;AAChC;;AAEA;IACI;QAGI,uEAAuE;IAC3E;AACJ;;AAEA;IAGI,uEAAuE;AAC3E;;AAEA;IAII,oDAAoD;AAExD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iDAAiD;AACrD;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;QAElB,yCAAyC;QACzC,cAAc;QACd,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,qBAAqB;QACrB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IAGI,yBAAyB;AAC7B;;AAEA;IACI,MAAM;IACN,MAAM;IACN,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,kBAAkB;IAGlB,4DAA4D;IAI5D,mCAAmC;IAEnC,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IAGb,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAElB,2CAA2C;IAG3C,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,QAAQ;QACR,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IAEZ,iBAAiB;IAEjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;;IAEd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IAKI,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IAEb,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;AACd;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI;QACI,uBAAuB;QACvB,qBAAqB;QACrB,6CAA6C;QAC7C,uBAAuB;IAC3B;AACJ;;AAEA;IAGI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAElB,0CAA0C;IAG1C,aAAa;IAEb,sBAAsB;IACtB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IAGtB,aAAa;IACb,8BAA8B;IAC9B,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IAKI,aAAa;IAEb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAKI,qBAAqB;IAGrB,aAAa;IAEb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IAGtB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,OAAO;AACX;;AAEA;IACI,4CAA4C;IAC5C,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IAGI,qBAAqB;IACrB,kBAAkB;IAGlB,mBAAmB;IAGnB,aAAa;IAEb,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,0CAA0C;QAC1C,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IAGI,SAAY;AAChB;;AAEA;IAGI,aAAa;AACjB;;AAEA;IAGI,aAAgB;AACpB;;AAEA;IAGI,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IAGI,aAAa;AACjB;;AAEA;IAII,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IAGI,SAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;AAEA;IAKI,aAAa;IAEb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,mBAAmB;IACnB,UAAU;AACd;;AAEA;IAKI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IAEZ,8BAA8B;IAC9B,WAAW;IAEX,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IAEI,oDAAoD;AACxD;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,YAAY;IAEZ,8BAA8B;IAC9B,cAAc;;IAEd,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IAET,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IAGX,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IAGI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;;QAEzC,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;AAC1B;;AAEA;IACI;QAGI,yBAAyB;QACzB,sBAAsB;QAEtB,mBAAmB;QACnB,8BAA8B;IAClC;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IAGjB,gBAAgB;IAChB,kBAAkB;IAElB,yCAAyC;IACzC,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,cAAc;IACd,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IAGR,wBAAwB;AAC5B;;AAEA;IACI;QAGI,mBAAmB;QACnB,aAAa;IACjB;AACJ;;AAEA;IAGI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IAEb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IAGrD,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IAGI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IAEb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;;IAE3C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,sBAAsB;QACtB,iBAAiB;QACjB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;;QAEzC,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IAEb,iBAAiB;IAEjB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IAGR,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,KAAK;IACT;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;IACxB;AACJ;;AAEA;IAGI,aAAa;IACb,kBAAkB;IAGlB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;QACb,aAAa;QACb,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IAKI,aAAa;IAEb,2BAA2B;AAC/B;;AAEA;IAEI,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IAGI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IAEb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IAEI,2CAA2C;AAC/C;;AAEA;IAGI,mBAAmB;IAEnB,2CAA2C;IAG3C,wBAAwB;IAExB,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IAEI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAKI,wBAAwB;IAExB,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IAEI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IAEI,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IAEI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2DAA2D;IAC3D,aAAa;IACb,YAAY;IACZ,OAAO;IACP,SAAS;IACT,eAAe;IACf,MAAM;IACN,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IAGI,yBAAyB;IACzB,sBAAsB;IAGtB,aAAa;IAEb,mBAAmB;IAEnB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,WAAW;AACf;;AAsBA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,qDAAqD;IACrD,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,aAAa;IAGb,yBAAyB;IAGzB,4BAA4B;IAG5B,qDAAqD;IACrD,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IAGI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IAGZ,aAAa;IAEb,sBAAsB;IACtB,2BAA2B;IAC3B,OAAO;IACP,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI;QAGI,uBAAuB;QACvB,oBAAoB;QACpB,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAkBA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;;IAEV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAkBA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,eAAe;IACf,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,qBAAqB;;IAErB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kDAAkD;IAClD,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,yCAAyC;IAC7C;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,yCAAyC;IAC7C;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;IAC1C,sBAAsB;AAC1B;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAGlB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,4CAA4C;IAC5C,WAAW;IACX,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IAGzB,mBAAmB;IACnB,kBAAkB;IAGlB,aAAa;;IAEb,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IAGzB,mBAAmB;IACnB,kBAAkB;IAGlB,aAAa;;IAEb,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;AACd;;AAEA;IAGI,aAAa;IACb,YAAY;IAEZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IAGI,yBAAyB;IAGzB,aAAa;IAEb,sBAAsB;IAGtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;QAChB,aAAa;QACb,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAGlB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QAGI,2BAA2B;QAC3B,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,kBAAkB;QAClB,WAAW;QACX,4CAA4C;QAC5C,qBAAqB;;QAErB,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,kBAAkB;QAGlB,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,iBAAiB;QAGjB,6BAA6B;QAC7B,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,mDAAmD;QACnD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAkCA;IACI,WAAW;;IAEX,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAiBI;QACI,eAAe;IACnB;AACJ;;AAEA;;IAiBI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IAGnB,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,cAAc;IACd,yCAAyC;IAGzC,aAAa;IAEb,UAAU;IAEV,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;QACjB,YAAY;IAChB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QAII,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAE5C,SAAY;IACZ,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAE5C,SAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IAGjB,WAAW;IACX,4CAA4C;IAG5C,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IAGI,2FAA2F;IAC3F,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAkCA;IACI,WAAW;;IAEX,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAiBI;QACI,eAAe;IACnB;AACJ;;AAEA;;IAiBI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI;QACI,SAAS;QACT,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,SAAS;QACT,QAAQ;IACZ;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IAGI,yBAAyB;IACzB,sBAAsB;IAGtB,aAAa;IAEb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI;QAGI,aAAa;QACb,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IAEZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IAEI,mBAAmB;AACvB;;AAEA;IAGI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IAEb,mBAAmB;IAEnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;IAGnB,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,mDAAmD;IACnD,yBAAyB;IACzB,4BAA4B;IAC5B,4BAA4B;IAC5B,SAAS;IACT,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,wBAAwB;QACxB,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IAEI,qBAAqB;IACrB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI;QACI,iBAAiB;QACjB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAGlC,oBAAoB;IACpB,aAAa;IACb,SAAS;IACT,cAAc;IACd,eAAe;IACf,QAAQ;IAGR,+BAA+B;IAC/B,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,SAAS;IACT,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,qDAAqD;IACrD,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IAGf,aAAa;AACjB;;AAEA;IAGI,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAE1C,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IAKI,uBAAuB;IAGvB,aAAa;IAEb,sBAAsB;AAC1B;;;;AAIA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QAGI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IAEZ,mBAAmB;IACnB,WAAW;AACf;;AAEA;IAGI,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IAGpB,mBAAmB;IAGnB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI;QAII,mBAAmB;IACvB;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IAGf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAC1C,cAAc;IAGd,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IAGf,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,qDAAqD;IAGrD,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,cAAc;;IAEd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,sBAAsB;IACtB,kBAAkB;IAElB,0CAA0C;IAC1C,WAAW;IACX,sCAAsC;IACtC,cAAc;;IAEd,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,gBAAgB;IAChB,WAAW;IACX,4CAA4C;IAC5C,cAAc;;IAEd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,iBAAiB;AACrB;;AAEA;IAGI,uBAAuB;AAC3B;;AAEA;IAGI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IAGjB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,iBAAiB;IAGjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IAGjB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA;IAGI,yFAAyF;AAC7F;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,mBAAmB;QACnB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,cAAc;;IAEd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,sBAAsB;IACtB,kBAAkB;IAElB,0CAA0C;IAC1C,WAAW;IACX,sCAAsC;IACtC,cAAc;;IAEd,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,gBAAgB;IAChB,WAAW;IACX,4CAA4C;IAC5C,cAAc;;IAEd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IAGI,uBAAuB;AAC3B;;AAEA;IACI;QAGI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IAGjB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IAEjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;;AAEnB;;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;;IAExC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;;QAEI,eAAe;QACf,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yCAAyC;;IAEzC,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,yCAAyC;;IAEzC,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,kBAAkB;IAElB,0CAA0C;IAC1C,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;;QAEzC,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IAGI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,wCAAwC;;QAExC,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,wCAAwC;;QAExC,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAElB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QAII,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;;IAEd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IAGI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IAGR,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,aAAa;QACb,cAAc;QACd,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;QACf,oBAAoB;IACxB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,qDAAqD;IACrD,SAAS;IAET,uCAAuC;IACvC,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,oBAAoB;QACpB,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IAEZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,MAAM;IACV;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QAGI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;AACzB;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,4CAA4C;QAC5C,qBAAqB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;IAC3C,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,mBAAmB;IAEnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,oBAAoB;IAEpB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAElB,yCAAyC;IACzC,WAAW;IACX,uDAAuD;IACvD,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAElB,sCAAsC;IACtC,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,uDAAuD;IACvD,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,6BAA6B;QAC7B,mCAAmC;QACnC,oCAAoC;QACpC,SAAS;QACT,YAAY;QACZ,SAAS;QAGT,wBAAwB;QACxB,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,iCAAiC;QACjC,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,sBAAsB;QACtB,iBAAiB;QACjB,eAAe;QACf,uBAAuB;QACvB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,uDAAuD;QACvD,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,uDAAuD;QACvD,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,uDAAuD;QACvD,iBAAiB;QACjB,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,SAAS;QACT,WAAW;IACf;AACJ;;AAEA;IAEI,kBAAkB;AACtB;;AAEA;IAEI,mBAAmB;AACvB;;AAEA;IAGI,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IAErD,yCAAyC;IAGzC,aAAa;IAEb,SAAY;IAEZ,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QAEI,gBAAgB;QAChB,aAAa;QACb,uBAAuB;IAC3B;AACJ;;AAEA;IAGI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IAGtB,aAAa;IACb,8BAA8B;IAC9B,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IAGI,qBAAqB;IACrB,cAAc;IACd,yCAAyC;IAGzC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IAEzC,SAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAE7B,gBAAgB;IAChB,WAAW;IACX,4CAA4C;IAC5C,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;IAC3C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,iDAAiD;QACjD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,iDAAiD;IACjD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,MAAM;IACN,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IAGI,oBAAoB;IAGpB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAGlB,+FAA+F;IAC/F,WAAW;IACX,4BAA4B;AAChC;;AAEA;IAII,oDAAoD;AAExD;;AAEA;IACI,SAAS;IACT,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA;IAGI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,wBAAwB;AAC5B;;AAEA;IACI;QAGI,aAAa;IACjB;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IAGnB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,mBAAmB;IAGnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QAGI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;IAEpD,2CAA2C;IAC3C,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;QACb,cAAc;QACd,aAAa;QACb,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAGlB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IAGI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,gBAAgB;IAGhB,aAAa;IAEb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,4BAA4B;IAChC;AACJ;;AAEA;IACI,mBAAmB;IAGnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IAII,mBAAmB;IAGnB,aAAa;IAEb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,WAAW;IACX,yCAAyC;;IAEzC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,KAAK;IACT;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA;IAEI,8DAA8D;IAC9D,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IAGI,+GAA+G;IAC/G,YAAY;IACZ,WAAW;IACX,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI;QAGI,iHAAiH;QACjH,YAAY;QACZ,aAAa;QACb,UAAU;IACd;AACJ;;AAEA;IACI;QAGI,iHAAiH;QACjH,YAAY;QACZ,aAAa;QACb,UAAU;IACd;AACJ;;AAEA;IAKI,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QAGI,wBAAwB;QACxB,qBAAqB;QAErB,mBAAmB;QACnB,YAAY;QACZ,uBAAuB;QACvB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QAGI,uBAAuB;QACvB,oBAAoB;QAEpB,sBAAsB;QACtB,gBAAgB;QAChB,2BAA2B;QAC3B,kBAAkB;QAClB,oBAAoB;IACxB;AACJ;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAElB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,+BAA+B;QAC/B,WAAW;QACX,yCAAyC;QACzC,eAAe;;QAEf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,4CAA4C;;IAE5C,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,4CAA4C;QAC5C,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,yCAAyC;;QAEzC,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IAET,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IAGtB,oBAAoB;IACpB,YAAY;IACZ,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,SAAS;IACT,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qDAAqD;IACrD,mBAAmB;IACnB,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kDAAkD;IAClD,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,8BAA8B;IAC9B,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;QACb,SAAS;QACT,+CAA+C;QAC/C,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,qBAAqB;QACrB,kBAAkB;QAGlB,aAAa;QAEb,eAAe;QACf,4BAA4B;QAC5B,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,yCAAyC;QACzC,cAAc;QACd,yCAAyC;;QAEzC,eAAe;QACf,sBAAsB;QACtB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;QACxB,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QAEjB,eAAe;QACf,4BAA4B;QAC5B,uBAAuB;QACvB,iBAAiB;QACjB,gBAAgB;QAChB,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,kBAAkB;QAClB,kBAAkB;QAClB,4BAA4B;QAC5B,qBAAqB;QACrB,yBAAyB;QACzB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,yCAAyC;QACzC,cAAc;QACd,yCAAyC;;QAEzC,eAAe;QACf,sBAAsB;QACtB,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;IACI;QACI,iBAAiB;QACjB,+CAA+C;QAC/C,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;IAGzC,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI;QACI,iBAAiB;QACjB,8BAA8B;QAC9B,+CAA+C;QAC/C,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,mDAAmD;IACnD,kBAAkB;IAElB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;IACzC,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,4BAA4B;IAC5B,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,mDAAmD;IACvD;AACJ;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI;QACI,6BAA6B;QAC7B,qBAAqB;IACzB;AACJ;;AAEA;IAGI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,qBAAqB;IACrB,SAAS;IACT,4CAA4C;IAC5C,uBAAuB;AAC3B;;AAEA;IACI;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,0CAA0C;IAC9C;;IAEA;QAEI,yCAAyC;QACzC,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IAGI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QACzC,cAAc;QACd,yCAAyC;;;QAGzC,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;;IAIzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IAGI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,yCAAyC;;;;IAIzC,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IAKI,aAAa;IAEb,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,yBAAyB;QACzB,mDAAmD;QACnD,cAAc;QACd,yCAAyC;QACzC,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;;IAIzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QAII,mBAAmB;IACvB;;IAEA;QAGI,aAAa;IACjB;AACJ;;AAEA;IACI;QAGI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,qBAAqB;QAGrB,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,aAAa;IAGb,aAAa;IAEb,eAAe;IACf,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,yCAAyC;;QAEzC,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,yCAAyC;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QACzC,cAAc;;QAEd,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,qBAAqB;QAGrB,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;QAGnD,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,SAAS;QACT,WAAW;QACX,cAAc;QACd,aAAa;QACb,UAAU;QACV,kBAAkB;QAGlB,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;QACnD,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,OAAO;IACX;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,SAAS;IAGT,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AA0BA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,oBAAoB;IAGpB,eAAe;IACf,qBAAqB;IAErB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,UAAU;IAGV,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IAEI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,WAAW;;IAEX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,4BAA4B;QAC5B,oBAAoB;QACpB,+BAA+B;QAC/B,4BAA4B;QAC5B,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,yCAAyC;IACzC,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,mDAAmD;IACvD;AACJ;;AAEA;IACI,iBAAiB;IAEjB,gCAAgC;IAChC,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAG5C,eAAe;IACf,qBAAqB;IAErB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kDAAkD;IAClD,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,UAAU;IAGV,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,QAAQ;QACR,eAAe;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAkBA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IAGT,mCAAmC;IACnC,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IAGI,aAAa;IAEb,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,UAAU;IAGV,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QAII,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QAGI,QAAQ;IACZ;AACJ;;AAEA;IACI,cAAc;IAEd,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,8CAA8C;QAC9C,aAAa;QACb,oBAAoB;QACpB,iBAAiB;QACjB,MAAM;IACV;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;IAGzC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAGhB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,kBAAkB;QAClB,WAAW;QACX,4CAA4C;QAC5C,qBAAqB;;QAErB,eAAe;QACf,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAGlB,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,iBAAiB;QAGjB,6BAA6B;QAC7B,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,mDAAmD;QACnD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,+BAA+B;QAC/B,iBAAiB;QACjB,gBAAgB;QAChB,UAAU;QACV,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,SAAS;QACT,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,SAAS;AACb;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;;IAGzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IACd,yCAAyC;IACzC,WAAW;IACX,4CAA4C;;;IAG5C,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IACd,yCAAyC;IACzC,WAAW;IACX,4CAA4C;;;IAG5C,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QACzC,WAAW;QACX,4CAA4C;;;QAG5C,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,4CAA4C;;QAE5C,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,2BAA2B;QAC3B,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QAKI,aAAa;QAEb,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAElB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IAGI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,SAAS;QACT,+CAA+C;QAC/C,qBAAqB;IACzB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QAKI,aAAa;QAEb,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAElB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IAGI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C,cAAc;;IAEd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAGhB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI;QACI,SAAS;QAGT,oCAAoC;IACxC;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI;QACI,KAAK;IACT;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;;IAEtC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IACI;QAGI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IAGI,qFAAqF;AACzF;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;IACxB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;QACd,qBAAqB;QACrB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IAGI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI;QAGI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IAGI,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,wBAAwB;QACxB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;AAE7C;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IAErD,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI;QACI,8CAA8C;QAC9C,kBAAkB;IACtB;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,qEAAqE;IACrE,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,4BAA4B;IAChC;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,MAAM;IACN,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,4BAA4B;QAC5B,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IAGI,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,2CAA2C;IAC3C,cAAc;;IAEd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAGhB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,oDAAoD;IACpD,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,SAAS;QAGT,oCAAoC;IACxC;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,aAAa;IAEb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IAGI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,mBAAmB;IAGnB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,qBAAqB;IACrB,kBAAkB;IAGlB,aAAa;IAEb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qDAAqD;IACrD,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,kBAAkB;QAClB,WAAW;QACX,4CAA4C;QAC5C,qBAAqB;;QAErB,eAAe;QACf,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAGlB,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,iBAAiB;QAGjB,6BAA6B;QAC7B,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,4CAA4C;QAC5C,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,cAAc;QACd,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,oDAAoD;QACpD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,mDAAmD;QACnD,WAAW;QACX,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yBAAyB;QACzB,qDAAqD;QACrD,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,SAAS;QACT,UAAU;IACd;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,cAAc;QACd,aAAa;QACb,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IAGI,kBAAkB;IAGlB,aAAa;IAEb,sBAAsB;IACtB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,yCAAyC;;IAEzC,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,8BAA8B;QAC9B,iBAAiB;IACrB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,4BAA4B;IAE5B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,2BAA2B;QAC3B,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QAGI,kBAAkB;QAGlB,aAAa;QAEb,sBAAsB;QACtB,4BAA4B;IAChC;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IAGI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAElC,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,OAAO;IACP,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IAGI,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IAEvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IAII,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,yCAAyC;;;;IAIzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,oBAAoB;IACxB;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;QACvB,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,uBAAuB;QACvB,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,MAAM;IACV;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,SAAS;QACT,+CAA+C;QAC/C,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,6CAA6C;QAC7C,SAAS;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;;IAEtC,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IAKI,qBAAqB;IAGrB,aAAa;IAEb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,iBAAiB;IACjB,qBAAqB;IAGrB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAG1B,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,yBAAyB;QACzB,mDAAmD;QACnD,cAAc;QACd,yCAAyC;QACzC,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;IACtC,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IAGI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QAGI,uBAAuB;QACvB,YAAY;IAChB;AACJ;;AAEA;IAGI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QAGI,uBAAuB;QACvB,YAAY;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,uBAAuB;IACvB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;IAGV,yBAAyB;AAC7B;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IAGI,wBAAwB;IACxB,qBAAqB;IAGrB,mBAAmB;IACnB,6BAA6B;IAE7B,gBAAgB;IAGhB,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,OAAO;IACP,UAAU;IACV,kBAAkB;IAClB,MAAM;IAGN,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,4CAA4C;IAC5C,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,UAAU;IAGV,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,uBAAuB;QACvB,oBAAoB;QACpB,sBAAsB;QACtB,qDAAqD;QACrD,YAAY;QACZ,2BAA2B;IAC/B;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IAGnB,aAAa;IACb,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI;QAGI,2BAA2B;QAC3B,YAAY;IAChB;;IAEA;QAGI,yBAAyB;QACzB,YAAY;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IAGpB,uBAAuB;IAGvB,aAAa;IACb,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IAGrB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IAGnD,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;IAClD,SAAS;IACT,WAAW;IACX,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;;IAE1C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,SAAS;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAGI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;IACf;AACJ;;AAEA;IACI;QAGI,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,MAAM;QACN,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IAEI,2CAA2C;IAG3C,aAAa;IACb,OAAO;IACP,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IAGT,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IAKI,aAAa;IAEb,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;IAClD,+BAA+B;IAC/B,8BAA8B;IAC9B,4BAA4B;IAC5B,WAAW;IACX,4CAA4C;IAC5C,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,aAAa;IACb,UAAU;IACV,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAGhB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,yCAAyC;IAGzC,aAAa;;IAEb,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,aAAa;IACb,SAAS;IACT,4BAA4B;IAC5B,8CAA8C;IAC9C,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,YAAY;IACZ,WAAW;AACf;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IAGzC,aAAa;IACb,eAAe;IACf,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IAGjB,mBAAmB;IACnB,cAAc;IACd,yCAAyC;IAGzC,aAAa;;IAEb,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IAGI,mBAAmB;IAGnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,WAAW;AACf;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IAEjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,OAAO;IACP,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,SAAS;IAGT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAEhB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,+CAA+C;IAC/C,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,QAAQ;IACR,4BAA4B;IAC5B,8CAA8C;IAG9C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IAKI,aAAa;IAEb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,aAAa;AACjB;;AAEA;IACI,SAAS;IAGT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAEhB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,+CAA+C;IAC/C,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,aAAa;;IAEb,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IAEb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IAEtB,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IAGf,aAAa;IACb,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IAGf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IACrD,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qDAAqD;IAGrD,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IAGf,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;IACf;AACJ;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI;QACI,QAAQ;QACR,MAAM;IACV;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,MAAM;QACN,WAAW;IACf;AACJ;;AAEA;IACI,YAAY;IAEZ,iBAAiB;IAEjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,uBAAuB;IAGvB,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QAKI,mBAAmB;QAEnB,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,aAAa;QACb,SAAS;QACT,+CAA+C;QAC/C,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QAGI,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QAGI,aAAa;QAEb,eAAe;QACf,oBAAoB;IACxB;;IAEA;QAEI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,yCAAyC;QACzC,cAAc;;QAEd,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,qBAAqB;QAGrB,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;QAGnD,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,SAAS;QACT,WAAW;QACX,cAAc;QACd,aAAa;QACb,UAAU;QACV,kBAAkB;QAGlB,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;QACnD,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,yCAAyC;QAGzC,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,kDAAkD;QAClD,UAAU;QAGV,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI;QACI,OAAO;IACX;AACJ;;AAEA;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,+BAA+B;QAC/B,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IAGrB,uBAAuB;IAGvB,aAAa;IAEb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QAKI,mBAAmB;QAEnB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mDAAmD;IACnD,mBAAmB;AACvB;;AAEA;IACI;QAGI,mBAAmB;QAGnB,aAAa;QACb,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;AACJ;;AAEA;IAGI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAEI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QAEI,oBAAoB;QACpB,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,0CAA0C;IAC1C,cAAc;;IAEd,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,QAAQ;QACR,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IAGZ,aAAa;IAEb,eAAe;IACf,8BAA8B;IAC9B,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA;IAGI,wBAAwB;IACxB,qBAAqB;IAGrB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAGlB,aAAa;IAEb,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IAEnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IAEI,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAElB,uCAAuC;IACvC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAElB,4BAA4B;IAI5B,0BAA0B;IAE1B,WAAW;AACf;;AAEA;IACI,iBAAiB;IAEjB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IAKI,mBAAmB;IAGnB,aAAa;IAEb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IAEZ,mBAAmB;IAEnB,4BAA4B;IAI5B,0BAA0B;IAE1B,WAAW;AACf;;AAEA;IAGI,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,qDAAqD;IACrD,kBAAkB;IAElB,0CAA0C;IAC1C,WAAW;IAGX,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IAET,0BAA0B;IAI1B,0BAA0B;IAE1B,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAEI,4BAA4B;IAI5B,iCAAiC;AAErC;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI;QAEI,gBAAgB;QAEhB,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IAKI,aAAa;IAEb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,sCAAsC;QACtC,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,wBAAwB;QACxB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;;IAEtC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IAGI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAElC,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IAKI,qBAAqB;IACrB,gCAAgC;IAGhC,aAAa;IAEb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAEhB,gBAAgB;IAChB,cAAc;IACd,4CAA4C;;IAE5C,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AA8BA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,YAAY;AAChB;;AAEA;IAEI,kBAAkB;IAGlB,aAAa;IACb,UAAU;IACV,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QAKI,qBAAqB;QACrB,gCAAgC;QAGhC,aAAa;QAEb,2BAA2B;QAC3B,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAEhB,gBAAgB;QAChB,cAAc;QACd,4CAA4C;;QAE5C,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;;IA6BI;QACI,iBAAiB;QACjB,cAAc;QACd,4CAA4C;QAC5C,YAAY;IAChB;AACJ;;AAEA;IACI;QAEI,kBAAkB;QAGlB,aAAa;QACb,UAAU;QACV,cAAc;QACd,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IAGI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAGlB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,yBAAyB;QACzB,mDAAmD;QACnD,cAAc;QACd,yCAAyC;QACzC,sBAAsB;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IAKI,aAAa;IAEb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,aAAa;QACb,SAAS;QACT,+CAA+C;IACnD;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IAKI,qBAAqB;IACrB,gCAAgC;IAGhC,aAAa;IAEb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAEhB,gBAAgB;IAChB,cAAc;IACd,4CAA4C;;IAE5C,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AA8BA;IACI,iBAAiB;IACjB,cAAc;IACd,4CAA4C;IAC5C,YAAY;AAChB;;AAEA;IAEI,kBAAkB;IAGlB,aAAa;IACb,UAAU;IACV,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;;IAEtC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,SAAS;IACT,8CAA8C;IAC9C,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,6CAA6C;QAC7C,mBAAmB;IACvB;AACJ;;AAEA;IAGI,gCAAgC;IAGhC,aAAa;IAEb,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,2BAA2B;QAC3B,mBAAmB;QACnB,oBAAoB;QACpB,iBAAiB;QACjB,kBAAkB;QAClB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,uBAAuB;IAC3B;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;;IAErB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IAGpB,yBAAyB;IAGzB,wBAAwB;IAGxB,mDAAmD;AACvD;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,kDAAkD;QAClD,WAAW;QACX,4CAA4C;QAG5C,yBAAyB;QAGzB,wBAAwB;QAGxB,mDAAmD;IACvD;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IAGjB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;QACtB,qDAAqD;QACrD,yBAAyB;QACzB,mDAAmD;QACnD,cAAc;QACd,yCAAyC;QACzC,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,sCAAsC;IACtC,qBAAqB;;IAErB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yCAAyC;;IAEzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QAGI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QAII,mBAAmB;IACvB;;IAEA;QAII,2BAA2B;IAC/B;;IAEA;QAGI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,MAAM;IACV;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QAGI,aAAa;IACjB;;IAEA;QAII,mBAAmB;IACvB;;IAEA;QAGI,uBAAuB;IAC3B;;IAEA;QAGI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,SAAS;IACb;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QAGI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QAII,mBAAmB;IACvB;;IAEA;QAII,2BAA2B;IAC/B;;IAEA;QAII,sBAAsB;IAC1B;;IAEA;QAGI,8BAA8B;IAClC;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QAGI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QAII,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,MAAM;IACV;;IAEA;QACI,cAAc;QACd,SAAS;IACb;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,8CAA8C;IAClD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,WAAW;AACf","sourcesContent":["\n.icon-key {\n    float: left;\n    margin-top: 0\n}\n\n.key-item {\n    margin: 1em 0\n}\n\n.key-item span:before {\n    font-size: 20px\n}\n\n\n.add-outlook a {\n    font-size: 0\n}\n\n\n\n.add-outlook a::before {\n    background: #ffbc00;\n    color: #fff;\n    font-size: 20px;\n    width: 21px;\n    height: 21px;\n    text-align: center;\n    padding-top: 5px;\n    margin-right: 5px;\n    padding-left: 5px\n}\n\n.add-gcal a {\n    font-size: 0\n}\n\n.add-gcal a::before {\n    background: #dd4b39;\n    color: #fff;\n    font-size: 20px;\n    width: 21px;\n    height: 21px;\n    text-align: center;\n    padding-top: 5px;\n    margin-right: 5px;\n    padding-left: 5px\n}\n\n\n.right-arrow::before {\n    font-size: 14px\n}\n\n.up-arrow::before {\n    font-size: 14px\n}\n\n.ndqicon-check-circle::before,.thank-you-page h1::before {\n    font-size: 22px\n}\n\na.show-all::after {\n    font-size: 14px\n}\n\na.show-all.hide-all::after {\n    font-size: 14px\n}\n\n\n.faq-acc-dl dt::before,.faq-acc-dl .acc-title::before,.acc-wrap dt::before,.acc-wrap .acc-title::before {\n    color: #fff;\n    font-size: 14px\n}\n\n.faq-acc-dl dt.opened::before,.faq-acc-dl .acc-title.opened::before,.acc-wrap dt.opened::before,.acc-wrap .acc-title.opened::before {\n    color: #fff;\n    font-size: 14px\n}\n\n.top-link::after {\n    font-size: 14px;\n    margin-top: -4px\n}\n\n.file--mime-application-pdf a,.webcast-link a,.file--mime-application-rtf a,.file--mime-application-vnd-ms-excel a,.html-link a:before,.file--mime-application-xml a,.field--name-field-nir-ext-document a,.file--mime-text-csv a {\n    text-decoration: none !important\n}\n\n.file--mime-application-pdf a:hover,.webcast-link a:hover,.file--mime-application-rtf a:hover,.file--mime-application-vnd-ms-excel a:hover,.html-link a:hover,.file--mime-application-xml a:hover,.field--name-field-nir-ext-document a:hover,.file--mime-text-csv a:hover {\n    text-decoration: none !important\n}\n\n.file--mime-application-pdf a span,.webcast-link a span,.file--mime-application-rtf a span,.file--mime-application-vnd-ms-excel a span,.html-link a span,.file--mime-application-xml a span,.field--name-field-nir-ext-document a span,.file--mime-text-csv a span,.file--mime-application-pdf a:hover span,.webcast-link a:hover span,.file--mime-application-rtf a:hover span,.file--mime-application-vnd-ms-excel a:hover span,.html-link a:hover span,.file--mime-application-xml a:hover span,.field--name-field-nir-ext-document a:hover span,.file--mime-text-csv a:hover span {\n    text-decoration: none\n}\n\n.visually-hidden,.toolbar-bar li>ul,.toolbar-item>ul {\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px)\n}\n\n.visually-hidden--off,.toolbar-bar li>ul--off,.toolbar-item>ul--off {\n    clip: auto;\n    height: auto;\n    width: auto;\n    overflow: auto\n}\n\n.toolbar-bar li>ul.visually-hidden--off,.toolbar-item>ul.visually-hidden--off {\n    clip: auto;\n    height: auto;\n    width: auto;\n    overflow: auto\n}\n\n.toolbar--wrapper div,.toolbar--wrapper ul,.toolbar--wrapper li,.toolbar--wrapper a {\n    font-size: 14px;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important\n}\n\n.toolbar--wrapper a:link,.toolbar--wrapper a:visited {\n    color: #009ec2;\n    font-weight: normal\n}\n\n.toolbar--wrapper a:link.bold-link,.toolbar--wrapper a:visited.bold-link {\n    font-weight: bold\n}\n\n.toolbar-bar {\n    background: #1d1e25 !important;\n    height: 56px !important\n}\n\n.toolbar-bar a:focus {\n    text-decoration: none !important\n}\n\n.toolbar-bar .nir-menu>li {\n    display: inline-block !important;\n    padding: 0px !important;\n    text-align: left !important;\n    margin: 0px !important\n}\n\n.toolbar-bar .nir-menu>li.nir-menu-item--expanded>a::after {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: color(\"white\")\n}\n\n.toolbar-bar .nir-menu>li.nir-menu-item--expanded>a::after {\n    font-size: 16px !important\n}\n\n.toolbar-bar .nir-menu>li.nir-menu-item--expanded>a:hover::after {\n    color: #00bce3 !important\n}\n\n.toolbar-bar .nir-menu>li a {\n    color: #fff !important;\n    font-size: 1.15em !important;\n    line-height: 1 !important;\n    padding: 19px 7px !important;\n    transition: all .15s ease-in-out !important;\n    text-decoration: none !important;\n    display: block !important;\n    text-align: left !important;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important;\n    margin: 0px !important\n}\n\n.toolbar-bar .nir-menu>li a:hover {\n    color: #00bce3 !important;\n    text-decoration: none !important\n}\n\n.toolbar-bar .nir-menu>li a.menu-open {\n    background-color: #111217 !important;\n    color: #00bce3 !important;\n    text-decoration: none !important\n}\n\n.toolbar-bar .nir-menu>li a.menu-open::after {\n    color: #00bce3 !important\n}\n\n.toolbar-bar .nir-menu>li ul {\n    box-shadow: 0 5px 10px rgba(0,0,0,.2) !important;\n    background: #fff !important;\n    position: absolute !important;\n    padding-top: 3px !important;\n    margin: 0px !important;\n    width: 200px !important;\n    padding-left: 0px !important\n}\n\n.toolbar-bar .nir-menu>li ul li {\n    float: left !important;\n    width: 100% !important;\n    margin: 0px !important\n}\n\n.toolbar-bar .nir-menu>li ul li:hover {\n    background: #459699 !important\n}\n\n.toolbar-bar .nir-menu>li ul li:hover a {\n    color: #fff !important;\n    transition: none !important\n}\n\n.toolbar-bar .nir-menu>li ul a {\n    color: #333 !important;\n    font-size: 14px !important;\n    padding: 10px 20px !important\n}\n\n.toolbar-bar .nir-menu>li.nir-menu-item--site-status a:hover {\n    color: #fff !important\n}\n\n.toolbar-bar .nir-menu>li.nir-menu-item--site-status--secondary a {\n    color: #000 !important\n}\n\n.toolbar-bar>.nir-menu {\n    display: inline !important;\n    font-size: 14px !important;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important;\n    margin: 0 !important;\n    line-height: 56px !important;\n    float: left !important;\n    padding-left: 0 !important\n}\n\n.toolbar-bar>.nir-menu>li:first-child a {\n    padding-left: 15px !important\n}\n\n.nir-toolbar {\n    -webkit-font-smoothing: antialiased !important;\n    position: relative !important;\n    z-index: 2147483647 !important;\n    box-shadow: -1px 0 3px 1px rgba(0,0,0,.333) !important;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important\n}\n\n.nir-toolbar a.menu-open {\n    background-color: #111217 !important;\n    color: #00bce3 !important;\n    text-decoration: none !important\n}\n\n.nir-toolbar a.menu-open::after {\n    color: #00bce3 !important\n}\n\n.nir-toolbar .toolbar-item {\n    position: relative !important;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important;\n    float: left !important;\n    height: 56px !important;\n    padding: 0px !important\n}\n\n.nir-toolbar .toolbar-item h2,.nir-toolbar .toolbar-item h3 {\n    display: inline-block !important;\n    margin: 10px 0 !important\n}\n\n.nir-toolbar .toolbar-item>a {\n    display: inline-block !important;\n    padding: 20px 14px !important;\n    color: #fff !important;\n    font-size: 1.15em !important;\n    font-weight: normal !important;\n    line-height: 1 !important;\n    transition: all .15s ease-in-out !important\n}\n\n.nir-toolbar .toolbar-item>a:hover {\n    color: #00bce3 !important;\n    text-decoration: none !important\n}\n\n.nir-toolbar .toolbar-item ul {\n    font-size: 12px !important;\n    font-weight: normal !important;\n    box-shadow: 0 5px 10px rgba(0,0,0,.2) !important;\n    background: #fff !important;\n    position: absolute !important;\n    right: 0 !important;\n    padding-top: 0 !important;\n    padding-left: 0 !important;\n    margin-top: 1px !important;\n    width: 200px !important;\n    overflow: hidden !important\n}\n\n.nir-toolbar .toolbar-item ul li {\n    float: left !important;\n    width: 100% !important;\n    color: #333 !important\n}\n\n.nir-toolbar .toolbar-item ul li .image-style-nir-toolbar-profile {\n    float: left !important;\n    margin-left: 20px !important\n}\n\n.nir-toolbar .toolbar-item ul li .profile-info {\n    float: left !important;\n    width: 145px !important\n}\n\n.nir-toolbar .toolbar-item ul li .profile-info .menu-email {\n    font-size: 12px !important\n}\n\n.nir-toolbar .toolbar-item ul li .profile-info .user-name {\n    font-size: 14px !important;\n    margin-bottom: 5px !important\n}\n\n.nir-toolbar .toolbar-item ul li a {\n    color: #333 !important;\n    padding: 10px 20px !important;\n    display: block !important\n}\n\n.nir-toolbar .toolbar-item ul li:hover {\n    background: #459699 !important\n}\n\n.nir-toolbar .toolbar-item ul li:hover a {\n    color: #fff !important;\n    transition: none !important;\n    text-decoration: none !important\n}\n\n.nir-toolbar .toolbar-item ul .user-profile-item {\n    background-color: #eee;\n    padding: 20px 0 !important\n}\n\n.nir-toolbar .toolbar-item ul .user-profile-item a {\n    padding: 0 !important;\n    line-height: 13px !important\n}\n\n.nir-toolbar .toolbar-item ul .user-profile-item:hover {\n    background-color: #eee !important;\n    cursor: default !important\n}\n\n.nir-toolbar .toolbar-item.user-tab>a {\n    padding: 10px 14px !important\n}\n\n.nir-toolbar .toolbar-item.user-tab>a .user-name-tab {\n    text-indent: -9999px !important\n}\n\n.nir-toolbar .toolbar-item.user-tab ul {\n    width: 250px !important\n}\n\n.nir-toolbar .toolbar-item.user-tab div {\n    display: inline-block !important\n}\n\n.nir-toolbar .toolbar-item.help-tab>a {\n    color: #1d1e25 !important;\n    padding: 16px 14px !important;\n    border-right: 1px solid #474a53 !important;\n    border-left: 1px solid #474a53 !important\n}\n\n.nir-toolbar .toolbar-item.help-tab>a:hover {\n    color: #3f878a !important\n}\n\n.nir-toolbar .toolbar-item.help-tab>a>span {\n    border-radius: 50% !important;\n    background: #fff !important;\n    height: 24px !important;\n    width: 24px !important;\n    display: block !important;\n    padding-left: 2px !important;\n    padding-top: 2px !important\n}\n\n.nir-toolbar .toolbar-item.help-tab>a>span::after {\n    content: \"î‚³\";\n    display: inline-block;\n    text-decoration: none;\n    color: color(\"nir_toolbar_grey\")\n}\n\n.nir-toolbar .toolbar-item.help-tab>a>span:hover::after {\n    color: #459699 !important\n}\n\n.nir-toolbar .toolbar-item.help-tab>a>span::after {\n    font-size: 20px !important\n}\n\n.nir-toolbar .toolbar-item.help-tab>a>span span {\n    display: none\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a {\n    color: #1d1e25 !important;\n    padding: 0 !important;\n    border-right: 1px solid #474a53 !important;\n    border-left: 1px solid #474a53 !important\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a:hover {\n    color: #459699 !important\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a.menu-open>span::after {\n    color: #3f878a !important;\n    transform: rotate(45deg) !important\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a>span {\n    height: 46px !important;\n    width: 54px !important;\n    display: block !important\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a>span::after {\n    content: \"âœ\";\n    display: inline-block;\n    text-decoration: none;\n    color: color(\"nir_toolbar_grey\")\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a>span:hover::after {\n    color: #3f878a !important\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a>span::after {\n    font-size: 40px !important;\n    color: #fff !important;\n    transform: rotate(-45deg) !important;\n    transition: transform .5s;\n    margin: 10px 8px 11px 8px !important;\n    height: 35px !important;\n    line-height: 21px;\n    width: 35px !important;\n    text-align: center;\n    align-items: center;\n    margin-top: -9px;\n    display: block;\n    padding: 0 !important\n}\n\n.nir-toolbar .toolbar-item.local-tasks-tab>a>span span {\n    display: none !important\n}\n\n.nir-toolbar .toolbar-bar .nir-toolbar-tab>.toolbar-item:hover,.nir-toolbar .toolbar-bar .nir-toolbar-tab>.toolbar-item:hover {\n    background-color: #111217 !important;\n    background-image: none !important\n}\n\n.nir-toolbar .site-name-tab {\n    border-top-style: solid !important;\n    border-top-width: 4px !important\n}\n\n.nir-toolbar .site-name-tab.secondary {\n    border-top-color: #fd0 !important\n}\n\n.nir-toolbar .site-name-tab.primary {\n    border-top-color: #19b772 !important\n}\n\n.nir-toolbar .site-name-tab.local {\n    border-top-color: #da353b\n}\n\n.nir-toolbar .site-name-tab>a {\n    padding: 16px 4px 19px 10px !important;\n    font-size: 1em !important\n}\n\n.nir-toolbar .site-name-tab>a::after {\n    content: \"î€’\";\n    display: inline-block;\n    text-decoration: none;\n    color: color(\"white\")\n}\n\n.nir-toolbar .site-name-tab>a::after {\n    font-size: 14px !important\n}\n\n.nir-toolbar .site-name-tab>a:hover::after {\n    color: #3f878a !important\n}\n\n.local-tasks-sidebar--wrapper {\n    position: absolute;\n    right: 0;\n    width: 200px;\n    background: #eee;\n    z-index: 100;\n    transition-property: width;\n    transition-delay: .4s;\n    bottom: 0;\n    top: 93px\n}\n\n.local-tasks-sidebar--wrapper.toolbar--closed {\n    top: 0\n}\n\n.local-tasks-sidebar--wrapper--closed {\n    width: 0\n}\n\n.local-tasks-sidebar--wrapper--open {\n    box-shadow: -3px 0 3px 1px rgba(0,0,0,.333) !important\n}\n\n.local-tasks-sidebar--wrapper .menu-local-tasks--nir {\n    padding: 15px\n}\n\n.local-tasks-sidebar--wrapper .tabs.primary {\n    margin-top: 15px\n}\n\n.local-tasks-sidebar--wrapper .tabs.primary a {\n    background: none\n}\n\n.local-tasks-sidebar--wrapper .tabs.primary .tabs__tab.is-active {\n    border-radius: 0\n}\n\n.local-tasks-sidebar--wrapper .tabs.primary .tabs__tab.is-active a {\n    color: #111217\n}\n\n.local-tasks-sidebar--wrapper .tabs.primary .tabs__tab {\n    background: #fefefe;\n    border: 0;\n    margin: 5px 0;\n    text-align: center\n}\n\n\n\n#toolbar-item-administration {\n    margin-left: 4px !important;\n    border-left: 1px solid #666 !important\n}\n\n.image-style-nir-toolbar-profile {\n    display: inline-block !important;\n    height: 35px !important;\n    width: 35px !important;\n    margin: 0 4px !important;\n    overflow: hidden !important;\n    border-radius: 50% !important;\n    vertical-align: middle !important\n}\n\n.image-style-nir-toolbar-profile.empty-image {\n    border: 1px solid #fff !important\n}\n\n.image-style-nir-toolbar-profile.empty-image::after {\n    content: \"î€‹\";\n    display: inline-block;\n    text-decoration: none;\n    color: color(blue)\n}\n\n.image-style-nir-toolbar-profile.empty-image::after {\n    color: #fff !important;\n    font-size: 50px !important;\n    margin-left: -9px !important;\n    margin-top: -6px !important\n}\n\n.user-profile-item .image-style-nir-toolbar-profile.empty-image {\n    border: 1px solid #ccc !important\n}\n\n.user-profile-item .image-style-nir-toolbar-profile::after {\n    color: #ccc !important;\n    margin-left: -9px !important;\n    margin-top: 13px !important\n}\n\n.secondary-toolbar {\n    padding: 10px !important;\n    font-size: 16px !important;\n    width: 100% !important;\n    position: relative !important;\n    right: 0 !important;\n    left: 0 !important;\n    top: 0 !important;\n    z-index: 500 !important;\n    height: 37px !important\n}\n\n.secondary-toolbar div,.secondary-toolbar span,.secondary-toolbar a {\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif !important;\n    font-size: 1em !important\n}\n\n.secondary-toolbar .environment {\n    float: left !important;\n    font-size: 1em !important\n}\n\n.secondary-toolbar--local {\n    background: #f05b5b !important;\n    color: #fff !important\n}\n\n.secondary-toolbar--uat {\n    background: #37b777 !important;\n    color: #fff !important\n}\n\n.secondary-toolbar--test {\n    background: #459699 !important;\n    color: #fff !important\n}\n\n.secondary-toolbar--dev {\n    background: #c042f8 !important;\n    color: #fff !important\n}\n\n.secondary-toolbar--nasdaqbeta {\n    background: #fecb24 !important\n}\n\n@media only screen and (max-width: 500px) {\n    .secondary-toolbar .environment {\n        display:none !important\n    }\n}\n\n.nir-menu-item--site-status {\n    pointer-events: none !important;\n    cursor: default !important\n}\n\n.nir-menu-item--site-status--secondary {\n    background: #fecb24 !important\n}\n\n.nir-menu-item--site-status--primary {\n    background: #37b777 !important\n}\n\n\n.secondary-toolbar .nir-notification--text {\n    margin-left: 3px !important;\n    font-size: .8em !important\n}\n\n.nir-notification--text {\n    margin-left: 3px !important\n}\n\n.nir-notification--status {\n    border-radius: 50% !important;\n    display: inline-block !important;\n    width: 10px !important;\n    height: 10px !important;\n    border: 1px solid #fff !important;\n    margin-left: 3px !important\n}\n\n.nir-notification--status--off {\n    background: #f05b5b !important\n}\n\n.nir-notification--status--on {\n    background: #37b777 !important\n}\n\n.toolbar--toggle {\n    position: absolute !important;\n    display: block !important;\n    width: 20px !important;\n    height: 20px !important;\n    background: #000 !important;\n    margin: 0 5px !important;\n    border-radius: 0 0 3px 3px !important;\n    right: 30px\n}\n\n.toolbar--toggle--open a::after {\n    content: \"î’\";\n    display: inline-block;\n    text-decoration: none;\n    color: color(\"white\")\n}\n\n.toolbar--toggle--closed a::after {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: color(\"white\")\n}\n\n.toolbar--toggle a:after {\n    color: #fff !important;\n    font-size: 20px !important\n}\n\n.toolbar--toggle--text {\n    display: none !important\n}\n\n.local-tasks-sidebar--toggle--text {\n    display: none !important\n}\n\n@media only screen and (max-width: 363px) {\n    .toolbar-item.help-tab {\n        display:none !important\n    }\n}\n\n@media(min-width: 16.5em) {\n    .nir-toolbar .toolbar-bar .nir-toolbar-tab,.nir-toolbar .toolbar-tray-horizontal li {\n        float:right !important\n    }\n}\n\n@media only screen and (max-width: 64em) {\n    .toolbar-bar .nir-logo {\n        background-size:30px !important;\n        width: 50px !important\n    }\n\n    .toolbar-bar>.nir-menu>li>a {\n        background-size: 27px !important;\n        background-repeat: no-repeat !important;\n        background-position: center center !important;\n        text-indent: -9999px !important;\n        padding: 19px 21px !important\n    }\n\n  \n\n    .toolbar-bar .nir-menu>li ul {\n        box-shadow: 0 5px 10px rgba(0,0,0,.2) !important;\n        background: #fff !important;\n        position: fixed !important;\n        padding-top: 3px !important;\n        margin-top: 0 !important;\n        margin-left: 0 !important;\n        width: 200px !important;\n        left: 0 !important;\n        top: 56px !important\n    }\n\n    .toolbar-bar .nir-menu .nir-menu-item--site-status:before {\n        display: block !important;\n        color: #fff !important;\n        font-size: 36px !important;\n        margin: 0 !important;\n        padding: 0 10px !important\n    }\n\n    .toolbar-bar .nir-menu .nir-menu-item--site-status--primary::before {\n        content: \"P\" !important\n    }\n\n    .toolbar-bar .nir-menu .nir-menu-item--site-status--secondary::before {\n        content: \"S\" !important;\n        color: #000 !important\n    }\n\n    .toolbar-bar .nir-menu .nir-menu-item--site-status a {\n        display: none !important\n    }\n\n    .nir-toolbar .toolbar-item.user-tab>a {\n        padding: 10px 5px !important\n    }\n\n \n    .nir-toolbar .toolbar-item.site-name-tab>ul {\n        position: fixed !important;\n        right: 0 !important;\n        top: 56px !important\n    }\n}\n\n.sidr {\n    display: block;\n    position: fixed;\n    top: 0;\n    height: 100%;\n    z-index: 999999;\n    width: 260px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    font-family: \"lucida grande\",tahoma,verdana,arial,sans-serif;\n    font-size: 15px;\n    background: #333;\n    color: #fff;\n    box-shadow: 0 0 5px 5px #222 inset;\n}\n\n.sidr .sidr-inner {\n    padding: 0 0 15px;\n}\n\n.sidr .sidr-inner > p {\n    margin-left: 15px;\n    margin-right: 15px;\n}\n\n.sidr.right {\n    left: auto;\n    right: -260px;\n}\n\n.sidr.left {\n    left: -260px;\n    right: auto;\n}\n\n\n\n.sidr p {\n    font-size: 13px;\n    margin: 0 0 12px;\n}\n\n.sidr p a {\n    color: rgba(255,255,255,0.9);\n}\n\n.sidr > p {\n    margin-left: 15px;\n    margin-right: 15px;\n}\n\n.sidr ul {\n    display: block;\n    margin: 0 0 15px;\n    padding: 0;\n    border-top: 1px solid #1a1a1a;\n    border-bottom: 1px solid #4d4d4d;\n}\n\n.sidr ul li {\n    display: block;\n    margin: 0;\n    line-height: 48px;\n    border-top: 1px solid #4d4d4d;\n    border-bottom: 1px solid #1a1a1a;\n}\n\n.sidr ul li:hover,.sidr ul li.active,.sidr ul li.sidr-class-active {\n    border-top: 0;\n    line-height: 49px;\n}\n\n.sidr ul li:hover > a,.sidr ul li:hover > span,.sidr ul li.active > a,.sidr ul li.active > span,.sidr ul li.sidr-class-active > a,.sidr ul li.sidr-class-active > span {\n    box-shadow: 0 0 15px 3px #222 inset;\n}\n\n.sidr ul li a,.sidr ul li span {\n    padding: 0 15px;\n    display: block;\n    text-decoration: none;\n    color: #fff;\n}\n\n.sidr ul li ul {\n    border-bottom: 0;\n    margin: 0;\n}\n\n.sidr ul li ul li {\n    line-height: 40px;\n    font-size: 13px;\n}\n\n.sidr ul li ul li:last-child {\n    border-bottom: 0;\n}\n\n.sidr ul li ul li:hover,.sidr ul li ul li.active,.sidr ul li ul li.sidr-class-active {\n    border-top: 0;\n    line-height: 41px;\n}\n\n.sidr ul li ul li:hover > a,.sidr ul li ul li:hover > span,.sidr ul li ul li.active > a,.sidr ul li ul li.active > span,.sidr ul li ul li.sidr-class-active > a,.sidr ul li ul li.sidr-class-active > span {\n    box-shadow: 0 0 15px 3px #222 inset;\n}\n\n.sidr ul li ul li a,.sidr ul li ul li span {\n    color: rgba(255,255,255,0.8);\n    padding-left: 30px;\n}\n\n.sidr form {\n    margin: 0 15px;\n}\n\n.sidr label {\n    font-size: 13px;\n}\n\n.sidr input[type=\"text\"],.sidr input[type=\"password\"],.sidr input[type=\"date\"],.sidr input[type=\"datetime\"],.sidr input[type=\"email\"],.sidr input[type=\"number\"],.sidr input[type=\"search\"],.sidr input[type=\"tel\"],.sidr input[type=\"time\"],.sidr input[type=\"url\"],.sidr textarea,.sidr select {\n    width: 100%;\n    font-size: 13px;\n    padding: 5px;\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    margin: 0 0 10px;\n    border-radius: 2px;\n    border: 0;\n    background: rgba(0,0,0,0.1);\n    color: rgba(255,255,255,0.6);\n    display: block;\n    clear: both;\n}\n\n.sidr input[type=checkbox] {\n    width: auto;\n    display: inline;\n    clear: none;\n}\n\n.sidr input[type=button],.sidr input[type=submit] {\n    color: #333;\n    background: #fff;\n}\n\n.sidr input[type=button]:hover,.sidr input[type=submit]:hover {\n    background: rgba(255,255,255,0.9);\n}\n\n.select2-container--default .select2-results__option.select2-results__option--highlighted[aria-selected] {\n    background-color: #2d72e1\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove {\n    color: inherit\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-selection__choice {\n    border-color: #949494\n}\n\n.chosen-container {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    font-size: 13px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    user-select: none;\n}\n\n.chosen-container * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n.chosen-container .chosen-drop {\n    position: absolute;\n    top: 100%;\n    left: -9999px;\n    z-index: 1010;\n    width: 100%;\n    border: 1px solid #aaa;\n    border-top: 0;\n    background: #fff;\n    box-shadow: 0 4px 5px rgba(0,0,0,0.15);\n}\n\n.chosen-container.chosen-with-drop .chosen-drop {\n    left: 0;\n}\n\n.chosen-container a {\n    cursor: pointer;\n}\n\n.chosen-container .search-choice .group-name,.chosen-container .chosen-single .group-name {\n    margin-right: 4px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-weight: normal;\n    color: #999999;\n}\n\n.chosen-container .search-choice .group-name:after,.chosen-container .chosen-single .group-name:after {\n    content: \":\";\n    padding-left: 2px;\n    vertical-align: top;\n}\n\n.chosen-container-single .chosen-single {\n    position: relative;\n    display: block;\n    overflow: hidden;\n    padding: 0 0 0 8px;\n    height: 25px;\n    border: 1px solid #aaa;\n    border-radius: 5px;\n    background-color: #fff;\n    background: -webkit-gradient(linear,50% 0%,50% 100%,color-stop(20%,#ffffff),color-stop(50%,#f6f6f6),color-stop(52%,#eeeeee),color-stop(100%,#f4f4f4));\n    background: -webkit-linear-gradient(#ffffff 20%,#f6f6f6 50%,#eeeeee 52%,#f4f4f4 100%);\n    background: -moz-linear-gradient(#ffffff 20%,#f6f6f6 50%,#eeeeee 52%,#f4f4f4 100%);\n    background: -o-linear-gradient(#ffffff 20%,#f6f6f6 50%,#eeeeee 52%,#f4f4f4 100%);\n    background: linear-gradient(#ffffff 20%,#f6f6f6 50%,#eeeeee 52%,#f4f4f4 100%);\n    background-clip: padding-box;\n    box-shadow: 0 0 3px white inset,0 1px 1px rgba(0,0,0,0.1);\n    color: #444;\n    text-decoration: none;\n    white-space: nowrap;\n    line-height: 24px;\n}\n\n.chosen-container-single .chosen-default {\n    color: #999;\n}\n\n.chosen-container-single .chosen-single span {\n    display: block;\n    overflow: hidden;\n    margin-right: 26px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.chosen-container-single .chosen-single-with-deselect span {\n    margin-right: 38px;\n}\n\n\n.chosen-container-single .chosen-single abbr:hover {\n    background-position: -42px -10px;\n}\n\n.chosen-container-single.chosen-disabled .chosen-single abbr:hover {\n    background-position: -42px -10px;\n}\n\n.chosen-container-single .chosen-single div {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: block;\n    width: 18px;\n    height: 100%;\n}\n\n\n.chosen-container-single .chosen-search {\n    position: relative;\n    z-index: 1010;\n    margin: 0;\n    padding: 3px 4px;\n    white-space: nowrap;\n}\n\n\n.chosen-container-single .chosen-drop {\n    margin-top: -1px;\n    border-radius: 0 0 4px 4px;\n    background-clip: padding-box;\n}\n\n.chosen-container-single.chosen-container-single-nosearch .chosen-search {\n    position: absolute;\n    left: -9999px;\n}\n\n.chosen-container .chosen-results {\n    color: #444;\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: auto;\n    margin: 0 4px 4px 0;\n    padding: 0 0 0 4px;\n    max-height: 240px;\n    -webkit-overflow-scrolling: touch;\n}\n\n.chosen-container .chosen-results li {\n    display: none;\n    margin: 0;\n    padding: 5px 6px;\n    list-style: none;\n    line-height: 15px;\n    word-wrap: break-word;\n    -webkit-touch-callout: none;\n}\n\n.chosen-container .chosen-results li.active-result {\n    display: list-item;\n    cursor: pointer;\n}\n\n.chosen-container .chosen-results li.disabled-result {\n    display: list-item;\n    color: #ccc;\n    cursor: default;\n}\n\n.chosen-container .chosen-results li.highlighted {\n    background-color: #3875d7;\n    background-image: -webkit-gradient(linear,50% 0%,50% 100%,color-stop(20%,#3875d7),color-stop(90%,#2a62bc));\n    background-image: -webkit-linear-gradient(#3875d7 20%,#2a62bc 90%);\n    background-image: -moz-linear-gradient(#3875d7 20%,#2a62bc 90%);\n    background-image: -o-linear-gradient(#3875d7 20%,#2a62bc 90%);\n    background-image: linear-gradient(#3875d7 20%,#2a62bc 90%);\n    color: #fff;\n}\n\n.chosen-container .chosen-results li.no-results {\n    color: #777;\n    display: list-item;\n    background: #f4f4f4;\n}\n\n.chosen-container .chosen-results li.group-result {\n    display: list-item;\n    font-weight: bold;\n    cursor: default;\n}\n\n.chosen-container .chosen-results li.group-option {\n    padding-left: 15px;\n}\n\n.chosen-container .chosen-results li em {\n    font-style: normal;\n    text-decoration: underline;\n}\n\n.chosen-container-multi .chosen-choices {\n    position: relative;\n    overflow: hidden;\n    margin: 0;\n    padding: 0 5px;\n    width: 100%;\n    height: auto !important;\n    height: 1%;\n    border: 1px solid #aaa;\n    background-color: #fff;\n    background-image: -webkit-gradient(linear,50% 0%,50% 100%,color-stop(1%,#eeeeee),color-stop(15%,#ffffff));\n    background-image: -webkit-linear-gradient(#eeeeee 1%,#ffffff 15%);\n    background-image: -moz-linear-gradient(#eeeeee 1%,#ffffff 15%);\n    background-image: -o-linear-gradient(#eeeeee 1%,#ffffff 15%);\n    background-image: linear-gradient(#eeeeee 1%,#ffffff 15%);\n    cursor: text;\n}\n\n.chosen-container-multi .chosen-choices li {\n    float: left;\n    list-style: none;\n}\n\n.chosen-container-multi .chosen-choices li.search-field {\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.chosen-container-multi .chosen-choices li.search-field input[type=\"text\"] {\n    margin: 1px 0;\n    padding: 0;\n    height: 25px;\n    outline: 0;\n    border: 0 !important;\n    background: transparent !important;\n    box-shadow: none;\n    color: #797676;\n    font-size: 100%;\n    font-family: sans-serif;\n    line-height: normal;\n    border-radius: 0;\n}\n\n.chosen-container-multi .chosen-choices li.search-choice {\n    position: relative;\n    margin: 3px 5px 3px 0;\n    padding: 3px 20px 3px 5px;\n    border: 1px solid #aaa;\n    max-width: 100%;\n    border-radius: 3px;\n    background-color: #eeeeee;\n    background-image: -webkit-gradient(linear,50% 0%,50% 100%,color-stop(20%,#f4f4f4),color-stop(50%,#f0f0f0),color-stop(52%,#e8e8e8),color-stop(100%,#eeeeee));\n    background-image: -webkit-linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    background-image: -moz-linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    background-image: -o-linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    background-image: linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    background-size: 100% 19px;\n    background-repeat: repeat-x;\n    background-clip: padding-box;\n    box-shadow: 0 0 2px white inset,0 1px 0 rgba(0,0,0,0.05);\n    color: #333;\n    line-height: 13px;\n    cursor: default;\n}\n\n.chosen-container-multi .chosen-choices li.search-choice span {\n    word-wrap: break-word;\n}\n\n\n.chosen-container-multi .chosen-choices li.search-choice .search-choice-close:hover {\n    background-position: -42px -10px;\n}\n\n.chosen-container-multi .chosen-choices li.search-choice-disabled {\n    padding-right: 5px;\n    border: 1px solid #ccc;\n    background-color: #e4e4e4;\n    background-image: -webkit-gradient(linear,50% 0%,50% 100%,color-stop(20%,#f4f4f4),color-stop(50%,#f0f0f0),color-stop(52%,#e8e8e8),color-stop(100%,#eeeeee));\n    background-image: -webkit-linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    background-image: -moz-linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    background-image: -o-linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    background-image: linear-gradient(#f4f4f4 20%,#f0f0f0 50%,#e8e8e8 52%,#eeeeee 100%);\n    color: #666;\n}\n\n.chosen-container-multi .chosen-choices li.search-choice-focus {\n    background: #d4d4d4;\n}\n\n.chosen-container-multi .chosen-choices li.search-choice-focus .search-choice-close {\n    background-position: -42px -10px;\n}\n\n.chosen-container-multi .chosen-results {\n    margin: 0;\n    padding: 0;\n}\n\n.chosen-container-multi .chosen-drop .result-selected {\n    display: list-item;\n    color: #ccc;\n    cursor: default;\n}\n\n.chosen-container-active .chosen-single {\n    border: 1px solid #5897fb;\n    box-shadow: 0 0 5px rgba(0,0,0,0.3);\n}\n\n.chosen-container-active.chosen-with-drop .chosen-single {\n    border: 1px solid #aaa;\n    -moz-border-radius-bottomright: 0;\n    border-bottom-right-radius: 0;\n    -moz-border-radius-bottomleft: 0;\n    border-bottom-left-radius: 0;\n    background-image: -webkit-gradient(linear,50% 0%,50% 100%,color-stop(20%,#eeeeee),color-stop(80%,#ffffff));\n    background-image: -webkit-linear-gradient(#eeeeee 20%,#ffffff 80%);\n    background-image: -moz-linear-gradient(#eeeeee 20%,#ffffff 80%);\n    background-image: -o-linear-gradient(#eeeeee 20%,#ffffff 80%);\n    background-image: linear-gradient(#eeeeee 20%,#ffffff 80%);\n    box-shadow: 0 1px 0 #fff inset;\n}\n\n.chosen-container-active.chosen-with-drop .chosen-single div {\n    border-left: none;\n    background: transparent;\n}\n\n.chosen-container-active.chosen-with-drop .chosen-single div b {\n    background-position: -18px 2px;\n}\n\n.chosen-container-active .chosen-choices {\n    border: 1px solid #5897fb;\n    box-shadow: 0 0 5px rgba(0,0,0,0.3);\n}\n\n.chosen-container-active .chosen-choices li.search-field input[type=\"text\"] {\n    color: #222 !important;\n}\n\n.chosen-disabled {\n    opacity: 0.5 !important;\n    cursor: default;\n}\n\n.chosen-disabled .chosen-single {\n    cursor: default;\n}\n\n.chosen-disabled .chosen-choices .search-choice .search-choice-close {\n    cursor: default;\n}\n\n.chosen-rtl {\n    text-align: right;\n}\n\n.chosen-rtl .chosen-single {\n    overflow: visible;\n    padding: 0 8px 0 0;\n}\n\n.chosen-rtl .chosen-single span {\n    margin-right: 0;\n    margin-left: 26px;\n    direction: rtl;\n}\n\n.chosen-rtl .chosen-single-with-deselect span {\n    margin-left: 38px;\n}\n\n.chosen-rtl .chosen-single div {\n    right: auto;\n    left: 3px;\n}\n\n.chosen-rtl .chosen-single abbr {\n    right: auto;\n    left: 26px;\n}\n\n.chosen-rtl .chosen-choices li {\n    float: right;\n}\n\n.chosen-rtl .chosen-choices li.search-field input[type=\"text\"] {\n    direction: rtl;\n}\n\n.chosen-rtl .chosen-choices li.search-choice {\n    margin: 3px 5px 3px 0;\n    padding: 3px 5px 3px 19px;\n}\n\n.chosen-rtl .chosen-choices li.search-choice .search-choice-close {\n    right: auto;\n    left: 4px;\n}\n\n.chosen-rtl.chosen-container-single-nosearch .chosen-search,.chosen-rtl .chosen-drop {\n    left: 9999px;\n}\n\n.chosen-rtl.chosen-container-single .chosen-results {\n    margin: 0 0 4px 4px;\n    padding: 0 4px 0 0;\n}\n\n.chosen-rtl .chosen-results li.group-option {\n    padding-right: 15px;\n    padding-left: 0;\n}\n\n.chosen-rtl.chosen-container-active.chosen-with-drop .chosen-single div {\n    border-right: none;\n}\n\n\n\n.chosen-rtl.chosen-container-single .chosen-single div b {\n    background-position: 6px 2px;\n}\n\n.chosen-rtl.chosen-container-single.chosen-with-drop .chosen-single div b {\n    background-position: -12px 2px;\n}\n\n\n.ixbrl-link a::before,#ndq-content .ixbrl-link a::before {\n    font-family: \"ndqfonticons\";\n    font-size: 26px;\n    vertical-align: middle;\n    padding-right: 5px;\n    font-weight: normal;\n    text-decoration: none\n}\n\n.ixbrl-link a::before,#ndq-content .ixbrl-link a::before {\n    content: \"î½\";\n    display: inline-block;\n    text-decoration: none;\n    color: #000\n}\n\n.nir-sec-header .sec-docs .file-link,.nir-sec-header .sec-docs .field.ixbrl-link,#ndq-content .nir-sec-header .sec-docs .file-link,#ndq-content .nir-sec-header .sec-docs .field.ixbrl-link {\n    display: inline-block\n}\n\n.nir-sec-header .sec-docs .ixbrl-link a,#ndq-content .nir-sec-header .sec-docs .ixbrl-link a {\n    font-size: 0\n}\n\n.nir-sec-header,#ndq-content .nir-sec-header {\n    box-sizing: border-box\n}\n\np.attribution-legend {\n    display: inline-flex\n}\n\np.attribution-legend span {\n    padding-top: 10px\n}\n\np.attribution-legend img#lseg-logo {\n    width: 88px;\n    height: 39px\n}\n\n#ndq-content .float-left {\n    float: left;\n}\n\n#ndq-content .clear-both {\n    clear: both;\n}\n\n#ndq-content img,#ndq-content legend {\n    border: 0;\n}\n\n#ndq-content legend,#ndq-content td,#ndq-content th {\n    padding: 0;\n}\n\n#ndq-content article,#ndq-content aside,#ndq-content details,#ndq-content figcaption,#ndq-content figure,#ndq-content footer,#ndq-content header,#ndq-content hgroup,#ndq-content main,#ndq-content menu,#ndq-content nav,#ndq-content section,#ndq-content summary {\n    display: block;\n}\n\n#ndq-content audio,#ndq-content canvas,#ndq-content progress,#ndq-content video {\n    display: inline-block;\n    vertical-align: baseline;\n}\n\n#ndq-content audio:not([controls]) {\n    display: none;\n    height: 0;\n}\n\n#ndq-content [hidden],#ndq-content template {\n    display: none;\n}\n\n#ndq-content abbr[title] {\n    border-bottom: 1px dotted;\n}\n\n#ndq-content b,#ndq-content optgroup,#ndq-content strong {\n    font-weight: 700;\n}\n\n#ndq-content dfn {\n    font-style: italic;\n}\n\n#ndq-content h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n}\n\n#ndq-content mark {\n    background: #ff0;\n    color: #000;\n}\n\n#ndq-content small {\n    font-size: 80%;\n}\n\n#ndq-content sub,#ndq-content sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n}\n\n#ndq-content sup {\n    top: -0.5em;\n}\n\n#ndq-content sub {\n    bottom: -0.25em;\n}\n\n#ndq-content svg:not(:root) {\n    overflow: hidden;\n}\n\n#ndq-content figure {\n    margin: 1em 40px;\n}\n\n#ndq-content hr {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n    height: 0;\n}\n\n#ndq-content pre,#ndq-content textarea {\n    overflow: auto;\n}\n\n#ndq-content code,#ndq-content kbd,#ndq-content pre,#ndq-content samp {\n    font-family: monospace,monospace;\n    font-size: 1em;\n}\n\n#ndq-content button,#ndq-content input,#ndq-content optgroup,#ndq-content select,#ndq-content textarea {\n    color: inherit;\n    font: inherit;\n    margin: 0;\n}\n\n#ndq-content button::-moz-focus-inner,#ndq-content input::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n#ndq-content input {\n    line-height: normal;\n}\n\n#ndq-content input[type=checkbox],#ndq-content input[type=radio] {\n    box-sizing: border-box;\n    padding: 0;\n}\n\n#ndq-content input[type=number]::-webkit-inner-spin-button,#ndq-content input[type=number]::-webkit-outer-spin-button {\n    height: auto;\n}\n\n\n\n#ndq-content fieldset {\n    border: 1px solid silver;\n    margin: 0 2px;\n    padding: 0.35em 0.625em 0.75em;\n}\n\n#ndq-content table {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\n\n\n@media print {\n    #ndq-content html {\n        font-size: 12pt;\n    }\n}\n\n#ndq-content body {\n    margin: 0;\n    padding: 0;\n}\n\n#ndq-content * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n#ndq-content article,#ndq-content aside,#ndq-content details,#ndq-content figcaption,#ndq-content figure,#ndq-content footer,#ndq-content header,#ndq-content hgroup,#ndq-content main,#ndq-content menu,#ndq-content nav,#ndq-content section,#ndq-content summary {\n    display: block;\n}\n\n\n#ndq-content audio:not([controls]) {\n    display: none;\n    height: 0;\n}\n\n#ndq-content [hidden] {\n    display: none;\n}\n\n#ndq-content template {\n    display: none;\n}\n\n#ndq-content html,#ndq-content body {\n    font-size: 87.5%;\n    line-height: 1.42857em;\n    min-height: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n}\n\n@media print {\n    #ndq-content html,#ndq-content body {\n        font-size: 12pt;\n    }\n}\n\n#ndq-content body {\n    background: #f5f5f5;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 14px;\n    word-wrap: break-word;\n    color: #333;\n}\n\n#ndq-content body .container {\n    background: #fff;\n    background: rgba(255,255,255,0.9);\n}\n\n#ndq-content body .menu-item {\n    padding-top: 0;\n    margin: 0;\n}\n\n#ndq-content a#logo {\n    width: 100px;\n    display: block;\n    padding: 5px;\n    float: left;\n    margin-bottom: 15px;\n}\n\n@media print {\n    #ndq-content :link,#ndq-content :visited {\n        text-decoration: underline;\n    }\n\n    #ndq-content a[href]:after {\n        content: \" (\" attr(href) \")\";\n        font-weight: normal;\n        font-size: 14px;\n        text-decoration: none;\n    }\n\n    #ndq-content a[href^='javascript:']:after,#ndq-content a[href^='#']:after {\n        content: '';\n    }\n}\n\n#ndq-content img {\n    border: 0;\n    -ms-interpolation-mode: bicubic;\n}\n\n#ndq-content img,#ndq-content svg {\n    max-width: 100%;\n    height: auto;\n    width: auto;\n}\n\n#ndq-content svg:not(:root) {\n    overflow: hidden;\n}\n\n#ndq-content form {\n    margin: 0;\n}\n\n#ndq-content button,#ndq-content input,#ndq-content optgroup,#ndq-content select,#ndq-content textarea {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    max-width: 100%;\n    color: inherit;\n    font: inherit;\n    margin: 0;\n}\n\n#ndq-content button {\n    overflow: visible;\n}\n\n#ndq-content button,#ndq-content select {\n    text-transform: none;\n}\n\n#ndq-content button::-moz-focus-inner,#ndq-content input::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n\n#ndq-content input[type=\"number\"]::-webkit-inner-spin-button,#ndq-content input[type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n}\n\n\n#ndq-content input[type=\"text\"],#ndq-content input[type=\"search\"],#ndq-content input[type=\"tel\"],#ndq-content input[type=\"url\"],#ndq-content input[type=\"email\"],#ndq-content input[type=\"password\"],#ndq-content input[type=\"date\"],#ndq-content input[type=\"time\"],#ndq-content input[type=\"number\"],#ndq-content input[type=\"datalist\"],#ndq-content textarea {\n    line-height: inherit;\n    display: block;\n    width: auto;\n    padding: 10px 15px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    margin-top: 5px;\n    color: #666;\n    border: 1px solid var(--border-color,#cbcbcd);\n    border-radius: 4px;\n    outline: 0px;\n}\n\n\n#ndq-content fieldset {\n    padding: 0.5em 0.89286em 0.92857em;\n    border: 1px solid var(--border-color,#cbcbcd);\n    margin: 0 2px;\n}\n\n#ndq-content fieldset:before {\n    content: '';\n    display: table;\n}\n\n#ndq-content fieldset:after {\n    content: '';\n    display: table;\n    clear: both;\n}\n\n#ndq-content legend {\n    border: 0;\n    margin-left: -5px;\n    padding: 0 5px;\n   \n}\n\n#ndq-content optgroup {\n    font-weight: bold;\n}\n\n#ndq-content textarea {\n    overflow: auto;\n}\n\n#ndq-content blockquote {\n    margin: 0 2em 1.42857em;\n}\n\n#ndq-content figure {\n    margin: 0 0 1.42857em;\n}\n\n#ndq-content hr {\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n    height: 0;\n}\n#ndq-content pre {\n    font-family: monospace;\n    _font-family: 'courier new',monospace;\n    font-size: .8em;\n    line-height: 1.45;\n}\n\n#ndq-content pre {\n    overflow: auto;\n}\n\n#ndq-content dl,#ndq-content menu,#ndq-content ol,#ndq-content ul {\n    margin: 1em 0;\n}\n\n#ndq-content ol ol,#ndq-content ol ul,#ndq-content ul ol,#ndq-content ul ul {\n    margin: 0;\n}\n\n#ndq-content dd {\n    margin: 0 0 0 28px;\n}\n\n#ndq-content [dir=\"rtl\"] dd {\n    margin: 0 28px 0 0;\n}\n\n#ndq-content menu,#ndq-content ol,#ndq-content ul {\n    padding: 0 0 0 28px;\n}\n\n#ndq-content [dir=\"rtl\"] menu,#ndq-content [dir=\"rtl\"] ol,#ndq-content [dir=\"rtl\"] ul {\n    padding: 0 28px 0 0;\n}\n\n#ndq-content nav ul,#ndq-content nav ol {\n    list-style: none;\n    list-style-image: none;\n}\n\n#ndq-content h1,#ndq-content #nir-header__site-name {\n    font-size: 1.5em;\n    line-height: 1.42857em;\n    margin-top: 0.66657em;\n    margin-bottom: 0.47614em;\n}\n\n#ndq-content table.nirtable caption,#ndq-content table.dataTable caption,#ndq-content .block-market-data-block__estimates__all .js-form-type-select label {\n    font-size: 1.3em;\n    line-height: 1.42857em;\n    margin-top: 0.35714em;\n    margin-bottom: 0.35714em;\n    border-bottom: solid 1px var(--border-color,#cbcbcd);\n}\n\n#ndq-content h3 {\n    font-size: 1.2em;\n    line-height: 1.42857em;\n    margin-top: 1em;\n    margin-bottom: 1em;\n}\n\n#ndq-content h5,#ndq-content h6,#ndq-content .view-nir-media-gallery-items-grid .views-row h2,#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-title {\n    font-size: 1.1em;\n    line-height: 1.42857em;\n    margin-top: 1.42857em;\n    margin-bottom: 1.42857em;\n}\n\n#ndq-content table.nirtable,#ndq-content table.dataTable {\n    margin: 0 0 15px 0;\n    border-collapse: separate;\n    border-spacing: 0;\n    border: 0;\n    table-layout: fixed;\n    width: 100%;\n    word-wrap: normal;\n}\n\n#ndq-content table.nirtable caption,#ndq-content table.dataTable caption {\n    font-weight: bold;\n    text-align: left;\n    padding: 5px 0;\n}\n\n#ndq-content table.nirtable tbody tr:nth-child(odd),#ndq-content table.dataTable tbody tr:nth-child(odd) {\n    background-color: #f5fafa;\n}\n\n#ndq-content table.nirtable td,#ndq-content table.nirtable th,#ndq-content table.dataTable td,#ndq-content table.dataTable th {\n    padding: 15px;\n    border: 0;\n}\n\n#ndq-content table.nirtable th,#ndq-content table.nirtable thead td,#ndq-content table.dataTable th,#ndq-content table.dataTable thead td {\n    background-color: #666;\n    color: #fff;\n    text-align: left;\n    position: relative;\n}\n\n#ndq-content .two-col-node .node-left {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node .node-left {\n        width:36.70886%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .two-col-node .node-right {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node .node-right {\n        width:62.02532%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .two-col-node-alt1 .node-left {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node-alt1 .node-left {\n        width:24.05063%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .two-col-node-alt1 .node-right {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node-alt1 .node-right {\n        width:74.68354%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .two-col-node-alt2 .node-left {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node-alt2 .node-left {\n        width:36.70886%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .two-col-node-alt2 .node-right {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node-alt2 .node-right {\n        width:62.02532%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .two-col-node-alt3 .node-left {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node-alt3 .node-left {\n        width:17.72152%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .two-col-node-alt3 .node-right {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-node-alt3 .node-right {\n        width:81.01266%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .two-col-half .left-half {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-half .left-half {\n        width:49.36709%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .two-col-half .right-half {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .two-col-half .right-half {\n        width:49.36709%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .modal-content .node-left {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .modal-content .node-left {\n        width:17.72152%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .modal-content .node-right {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .modal-content .node-right {\n        width:81.01266%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .split-half {\n    float: left;\n    margin-bottom: 1em;\n    width: 100%;\n}\n\n#ndq-content .split-half .left-half {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .split-half .left-half {\n        width:49.36709%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .split-half .right-half {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .split-half .right-half {\n        width:49.36709%;\n        float: right;\n        margin-right: 0;\n        float: left;\n    }\n}\n\n#ndq-content .full-width {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n#ndq-content .container-fluid {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n#ndq-content .row:before {\n    content: '';\n    display: table;\n}\n\n#ndq-content .row:after {\n    content: '';\n    display: table;\n    clear: both;\n}\n\n#ndq-content .tabledrag-handle .handle,#ndq-content .mceToolbar table td a {\n    box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    -webkit-box-sizing: content-box;\n    -o-box-sizing: content-box;\n}\n\n#ndq-content .container-fluid .container-fluid {\n    width: auto;\n    margin-left: -1.69492%;\n    margin-right: -1.69492%;\n}\n\n@media (min-width: 320px) {\n    #ndq-content body.body-sidebars-first aside.sidebar-first {\n        width:100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-first aside.sidebar-first > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n\n    #ndq-content body.body-sidebars-first section#content {\n        width: 100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-first section#content > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content body.body-sidebars-first aside.sidebar-first {\n        width:24.05063%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n\n    #ndq-content body.body-sidebars-first aside.sidebar-first > * {\n        padding-left: 1em;\n    }\n\n    #ndq-content body.body-sidebars-first section#content {\n        width: 74.68354%;\n        float: right;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-first section#content > * {\n        padding-right: 1em;\n    }\n}\n\n@media (min-width: 320px) {\n    #ndq-content body.body-sidebars-last aside.sidebar-last {\n        width:100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-last aside.sidebar-last > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n\n    #ndq-content body.body-sidebars-last section#content {\n        width: 100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-last section#content > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content body.body-sidebars-last aside.sidebar-last {\n        width:24.05063%;\n        float: right;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-last aside.sidebar-last > * {\n        padding-right: 1em;\n    }\n\n    #ndq-content body.body-sidebars-last section#content {\n        width: 74.68354%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n\n    #ndq-content body.body-sidebars-last section#content > * {\n        padding-left: 1em;\n    }\n}\n\n@media (min-width: 320px) {\n    #ndq-content body.body-sidebars-both aside.sidebar-first {\n        width:100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-both aside.sidebar-first > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n\n    #ndq-content body.body-sidebars-both aside.sidebar-last {\n        width: 100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-both aside.sidebar-last > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n\n    #ndq-content body.body-sidebars-both section#content {\n        width: 100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-both section#content > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content body.body-sidebars-both aside.sidebar-first {\n        width:24.05063%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n\n    #ndq-content body.body-sidebars-both aside.sidebar-first > * {\n        padding-left: 1em;\n    }\n\n    #ndq-content body.body-sidebars-both section#content {\n        width: 49.36709%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n\n    #ndq-content body.body-sidebars-both aside.sidebar-last {\n        width: 24.05063%;\n        float: right;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-both aside.sidebar-last > * {\n        padding-right: 1em;\n    }\n}\n\n@media (min-width: 320px) {\n    #ndq-content body.body-sidebars-none section#content {\n        width:100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-none section#content > * {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content body.body-sidebars-none section#content {\n        width:100%;\n        float: left;\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    #ndq-content body.body-sidebars-none section#content > * {\n        padding-left: 1em;\n        padding-right: 1em;\n    }\n}\n\n#ndq-content aside.sidebar {\n    overflow: hidden;\n}\n\n@media (max-width: 769px) {\n    #ndq-content body.search #main .container {\n        display:flex;\n        flex-direction: column;\n    }\n\n    #ndq-content body.search #main .container #content {\n        order: 2;\n    }\n\n    #ndq-content body.search #main .container .sidebar-last {\n        order: 1;\n    }\n}\n\n#ndq-content .views-view-grid.cols-3 .views-col {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n#ndq-content .views-view-grid.cols-3 .col-1 {\n    width: 100%;\n    float: left;\n    margin-right: 1.69492%;\n}\n\n#ndq-content .views-view-grid.cols-3 .col-3 {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 769px) {\n    #ndq-content .views-view-grid.cols-3 .views-col {\n        width:32.20339%;\n        float: left;\n        margin-right: 1.69492%;\n    }\n\n    #ndq-content .views-view-grid.cols-3 .col-1 {\n        width: 32.20339%;\n        float: left;\n        margin-right: 1.69492%;\n    }\n\n    #ndq-content .views-view-grid.cols-3 .col-3 {\n        width: 32.20339%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .hidden,#ndq-content html.js .js-hidden,#ndq-content html.js .element-hidden,#ndq-content html.js .js-hide {\n    display: none;\n}\n\n#ndq-content .visually-hidden,#ndq-content .visually-hidden--focusable,#ndq-content .element-focusable,#ndq-content .element-invisible,#ndq-content .breadcrumb__title,#ndq-content .main-navigation .block-menu .block__title,#ndq-content .main-navigation .block-menu-block .block__title {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n#ndq-content .visually-hidden--off,#ndq-content .visually-hidden--focusable:active,#ndq-content .visually-hidden--focusable:focus,#ndq-content .element-focusable:active,#ndq-content .element-focusable:focus {\n    position: static !important;\n    clip: auto;\n    height: auto;\n    width: auto;\n    overflow: auto;\n}\n\n#ndq-content .clearfix:before,#ndq-content .tabs:before,#ndq-content .tabs--secondary:before,.block--local-tasks-block .tabs:before,.block--local-tasks-block .tabs--secondary:before,#ndq-content div[class*='view-widget-']:before,#ndq-content #nir-header:before {\n    content: '';\n    display: table;\n}\n\n#ndq-content .clearfix:after,#ndq-content .tabs:after,#ndq-content .tabs--secondary:after,.block--local-tasks-block .tabs:after,.block--local-tasks-block .tabs--secondary:after,#ndq-content div[class*='view-widget-']:after,#ndq-content #nir-header:after {\n    content: '';\n    display: table;\n    clear: both;\n}\n\n#ndq-content .ui-dialog-titlebar-close::before,#ndq-content a.summary-toggle::before,#ndq-content a.summary-toggle:hover::before,#ndq-content a.summary-toggle.open::before,#ndq-content a.summary-toggle.open:hover::before,#ndq-content a.nir-widget--person--accordion-toggle::before,#ndq-content a.nir-widget--person--accordion-toggle:hover::before,#ndq-content a.nir-widget--person--accordion-toggle.open::before,#ndq-content a.nir-widget--person--accordion-toggle.open:hover::before,#ndq-content a.nir-widget--news--accordion-toggle::before,#ndq-content a.nir-widget--news--accordion-toggle:hover::before,#ndq-content a.nir-widget--news--accordion-toggle.open::before,#ndq-content a.nir-widget--news--accordion-toggle.open:hover::before,#ndq-content .webcast-link a::before,#ndq-content .normal-webcast-link a::before,#ndq-content .widget-file--html::before,#ndq-content .field--name-field-nir-ext-document a::before,#ndq-content .field--name-field-nir-news-supp-ext-url a::before,#ndq-content .external-link::before,#ndq-content .widget-file--mime-video-x-ms-asf::before,#ndq-content .file--mime-video-x-ms-asf a::before,#ndq-content .widget-file--mime-image-x-ms-bmp::before,#ndq-content .file--mime-image-x-ms-bmp a::before,#ndq-content .widget-file--mime-text-csv::before,#ndq-content .file--mime-text-csv a::before,#ndq-content .file--mime-text-csv.file--text a::before,#ndq-content .market-data-file-download-csv::before,#ndq-content .widget-file--mime-application-msword::before,#ndq-content .file--mime-application-msword a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document a::before,#ndq-content .widget-file--mime-application-postscript::before,#ndq-content .file--mime-application-postscript a::before,#ndq-content .widget-file--mime-application-epub::before,#ndq-content .file--mime-application-epub a::before,#ndq-content .widget-file--fla::before,#ndq-content .file--fla a::before,#ndq-content .widget-file--mime-video-x-flv::before,#ndq-content .file--mime-video-x-flv a::before,#ndq-content .widget-file--mime-image-gif::before,#ndq-content .file--mime-image-gif a::before,#ndq-content .widget-file--ics::before,#ndq-content .file--ics a::before,#ndq-content .widget-file--mime-image-jpeg::before,#ndq-content .widget-file--mime-image-jpg::before,#ndq-content .file--mime-image-jpeg a::before,#ndq-content .file--mime-image-jpg a::before,#ndq-content .widget-file--mime-application-pgp-keys::before,#ndq-content .file--mime-application-pgp-keys a::before,#ndq-content .widget-file--mime-application-x-mobipocket-ebook::before,#ndq-content .file--mime-application-x-mobipocket-ebook a::before,#ndq-content .widget-file--mime-video-quicktime::before,#ndq-content .file--mime-video-quicktime a::before,#ndq-content .widget-file--mime-audio-mpeg::before,#ndq-content .file--mime-audio-mpeg a::before,#ndq-content .widget-file--mpg::before,#ndq-content .file--mpg a::before,#ndq-content .widget-file--odt::before,#ndq-content .file--odt a::before,#ndq-content .widget-file--application-pdf::before,#ndq-content .file--application-pdf a::before,#ndq-content .widget-file--mime-image-png::before,#ndq-content .file--mime-image-png a::before,#ndq-content .widget-file--mime-application-vnd-ms-powerpoint::before,#ndq-content .file--mime-application-vnd-ms-powerpoint a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow a::before,#ndq-content .widget-file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12 a::before,#ndq-content .widget-file--mime-application-rar::before,#ndq-content .file--mime-application-rar a::before,#ndq-content .widget-file--mime-application-rtf::before,#ndq-content .file--mime-application-rtf a::before,#ndq-content .widget-file--rtx::before,#ndq-content .file--rtx a::before,#ndq-content .widget-file--swf::before,#ndq-content .file--swf a::before,#ndq-content .widget-file--mime-image-tiff::before,#ndq-content .file--mime-image-tiff a::before,#ndq-content .widget-file--text::before,#ndq-content .file--text a::before,#ndq-content .widget-file--mime-audio-x-wav::before,#ndq-content .file--mime-audio-x-wav a::before,#ndq-content .widget-file--mime-audio-x-ms-wma::before,#ndq-content .file--mime-audio-x-ms-wma a::before,#ndq-content .widget-file--mime-video-x-ms-wmv::before,#ndq-content .file--mime-video-x-ms-wmv a::before,#ndq-content .widget-file--xls::before,#ndq-content .file--xls a::before,#ndq-content .widget-file--x-office-spreadsheet::before,#ndq-content .file--x-office-spreadsheet a::before,#ndq-content .market-data-file-download-xls::before,#ndq-content .widget-file--mime-application-vnd-ms-excel-sheet-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-excel-sheet-macroEnabled-12 a::before,#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet a::before,#ndq-content .widget-file--mime-application-xml::before,#ndq-content .file--mime-application-xml a::before,#ndq-content .widget-file--mime-application-octet-stream::before,#ndq-content .file--mime-application-octet-stream a::before,#ndq-content .widget-file--mime-application-zip::before,#ndq-content .file--mime-application-zip a::before,#ndq-content .ndqicon__chairperson a::before,#ndq-content span.ndqicon__chairperson::before,#ndq-content .ndqicon__chairperson a_after::after,#ndq-content span.ndqicon__chairperson_after::after,#ndq-content .ndqicon__cob a::before,#ndq-content span.ndqicon__cob::before,#ndq-content .ndqicon__cob a_after::after,#ndq-content span.ndqicon__cob_after::after,#ndq-content .ndqicon__vicechair::before,#ndq-content span.ndqicon__vicechair::before,#ndq-content span.ndqicon__vicechair_after::after,#ndq-content .ndqicon__leaddir::before,#ndq-content span.ndqicon__leaddir::before,#ndq-content .ndqicon__leaddir_after::after,#ndq-content span.ndqicon__leaddir_after::after,#ndq-content .ndqicon__chair::before,#ndq-content .ndqicon__chair1::before,#ndq-content .ndqicon__chair2::before,#ndq-content .ndqicon__chair3::before,#ndq-content .ndqicon__member a::before,#ndq-content span.ndqicon__member::before,#ndq-content .ndqicon__download::before,#ndq-content .ndqicon__independent::before,#ndq-content .ndqicon__independent_italic::before,#ndq-content .ndqicon__calculator::before,#ndq-content span.ndqicon__calculator::before,#ndq-content .ndqicon__calculator_after::after,#ndq-content span.ndqicon__calculator_after::after,#ndq-content .ndqicon__calculator1::before,#ndq-content .html-link a::before,#ndq-content .asset-link a::before,#ndq-content .add-outlook a::before,#ndq-content .add-gcal a::before,#ndq-content .right-arrow::before,#ndq-content .up-arrow::before,#ndq-content .ndqicon-check-circle::before,#ndq-content .thank-you-page h1::before,#ndq-content a.show-all::after,#ndq-content a.show-all.hide-all::after,#ndq-content .faq-acc-dl dt::before,#ndq-content .faq-acc-dl .acc-title::before,#ndq-content .acc-wrap dt::before,#ndq-content .acc-wrap .acc-title::before,#ndq-content .faq-acc-dl dt.opened::before,#ndq-content .faq-acc-dl .acc-title.opened::before,#ndq-content .acc-wrap dt.opened::before,#ndq-content .acc-wrap .acc-title.opened::before,#ndq-content .top-link::after,#ndq-content .nir-mean-value-rating .rating-arrow::after,#ndq-content .block-search-form form::after,#ndq-content .view-search form::after,#ndq-content .view-search .inline-asset span.file--application-pdf::before,#ndq-content .field--name-field-nir-committee-link a::before,#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one::before {\n    font-family: \"ndqfonticons\";\n    font-size: 26px;\n    vertical-align: middle;\n    padding-right: 5px;\n    font-weight: normal;\n    text-decoration: none;\n}\n\n#ndq-content .ui-dialog-titlebar-close::before {\n    content: \"î€“\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ui-dialog-titlebar-close::before {\n    color: #666;\n    font-size: 20px;\n}\n\n#ndq-content .ui-dialog-titlebar-close::before:hover {\n    color: #0480a9;\n}\n\n#ndq-content a.summary-toggle {\n    font-weight: normal;\n    cursor: pointer;\n}\n\n#ndq-content a.summary-toggle::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.summary-toggle:hover::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.summary-toggle:before,#ndq-content a.summary-toggle:hover:before {\n    font-size: 15px;\n    line-height: 0;\n}\n\n#ndq-content a.summary-toggle span {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n#ndq-content a.summary-toggle.open::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.summary-toggle.open:hover::before {\n    content: \"îŽ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.summary-toggle.open:before,#ndq-content a.summary-toggle.open:hover:before {\n    font-size: 15px;\n    line-height: 0;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle {\n    font-weight: normal;\n    cursor: pointer;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle:hover::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle:before,#ndq-content a.nir-widget--person--accordion-toggle:hover:before {\n    font-size: 15px;\n    line-height: 0;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle span {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle.open::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle.open:hover::before {\n    content: \"îŽ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle.open:before,#ndq-content a.nir-widget--person--accordion-toggle.open:hover:before {\n    font-size: 15px;\n    line-height: 0;\n}\n\n#ndq-content a.nir-widget--person--accordion-toggle + div {\n    display: inline;\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle {\n    font-weight: normal;\n    cursor: pointer;\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle:hover::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle:before,#ndq-content a.nir-widget--news--accordion-toggle:hover:before {\n    font-size: 15px;\n    line-height: 0;\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle span {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle.open::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle.open:hover::before {\n    content: \"îŽ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.nir-widget--news--accordion-toggle.open:before,#ndq-content a.nir-widget--news--accordion-toggle.open:hover:before {\n    font-size: 15px;\n    line-height: 0;\n}\n\n#ndq-content .ndqicon-disable-link {\n    margin-left: 30px;\n}\n\n#ndq-content .ndqicon-disable-link a::before {\n    margin-left: -30px;\n    cursor: default !important;\n    pointer-events: none !important;\n}\n\n#ndq-content .ndqicon-hide-icon a::before {\n    display: none !important;\n}\n\n#ndq-content .summary-hidden {\n    display: none;\n}\n\n#ndq-content .webcast-link a::before,#ndq-content .normal-webcast-link a::before {\n    content: \"î€œ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--html::before,#ndq-content .field--name-field-nir-ext-document a::before,#ndq-content .field--name-field-nir-news-supp-ext-url a::before,#ndq-content .external-link::before {\n    content: \"î·\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-video-x-ms-asf::before,#ndq-content .file--mime-video-x-ms-asf a::before {\n    content: \"î„ƒ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-image-x-ms-bmp::before,#ndq-content .file--mime-image-x-ms-bmp a::before {\n    content: \"î„„\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-text-csv::before,#ndq-content .file--mime-text-csv a::before,#ndq-content .file--mime-text-csv.file--text a::before,#ndq-content .market-data-file-download-csv::before {\n    content: \"î°\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-msword::before,#ndq-content .file--mime-application-msword a::before {\n    content: \"î²\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-wordprocessingml-document a::before {\n    content: \"î³\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-postscript::before,#ndq-content .file--mime-application-postscript a::before {\n    content: \"îƒµ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-epub::before,#ndq-content .file--mime-application-epub a::before {\n    content: \"îƒ¶\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--fla::before,#ndq-content .file--fla a::before {\n    content: \"î´\";\n    display: inline-block;\n    text-decoration: none;\n    color: #c00;\n}\n\n#ndq-content .widget-file--mime-video-x-flv::before,#ndq-content .file--mime-video-x-flv a::before {\n    content: \"îµ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #c00;\n}\n\n#ndq-content .widget-file--mime-image-gif::before,#ndq-content .file--mime-image-gif a::before {\n    content: \"î‚€\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--ics::before,#ndq-content .file--ics a::before {\n    content: \"îƒ¾\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-image-jpeg::before,#ndq-content .widget-file--mime-image-jpg::before,#ndq-content .file--mime-image-jpeg a::before,#ndq-content .file--mime-image-jpg a::before {\n    content: \"î¿\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-pgp-keys::before,#ndq-content .file--mime-application-pgp-keys a::before {\n    content: \"îƒ¿\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-x-mobipocket-ebook::before,#ndq-content .file--mime-application-x-mobipocket-ebook a::before {\n    content: \"îƒ·\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-video-quicktime::before,#ndq-content .file--mime-video-quicktime a::before {\n    content: \"îƒ¸\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-audio-mpeg::before,#ndq-content .file--mime-audio-mpeg a::before {\n    content: \"î‚…\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mpg::before,#ndq-content .file--mpg a::before {\n    content: \"îƒ¹\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--odt::before,#ndq-content .file--odt a::before {\n    content: \"îƒ»\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--application-pdf::before,#ndq-content .file--application-pdf a::before {\n    content: \"î‚ˆ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #c00;\n}\n\n#ndq-content .widget-file--mime-image-png::before,#ndq-content .file--mime-image-png a::before {\n    content: \"î‚‚\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-vnd-ms-powerpoint::before,#ndq-content .file--mime-application-vnd-ms-powerpoint a::before {\n    content: \"î‚‰\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-presentation a::before {\n    content: \"î‚‹\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-presentationml-slideshow a::before {\n    content: \"îƒ¼\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-vnd-ms-powerpoint::before,#ndq-content .file--mime-application-vnd-ms-powerpoint a::before {\n    content: \"î‚Š\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-powerpoint-presentation-macroEnabled-12 a::before {\n    content: \"îƒ½\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-rar::before,#ndq-content .file--mime-application-rar a::before {\n    content: \"î„‚\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-application-rtf::before,#ndq-content .file--mime-application-rtf a::before {\n    content: \"î„€\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--rtx::before,#ndq-content .file--rtx a::before {\n    content: \"î„\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--swf::before,#ndq-content .file--swf a::before {\n    content: \"î¶\";\n    display: inline-block;\n    text-decoration: none;\n    color: #c00;\n}\n\n#ndq-content .widget-file--mime-image-tiff::before,#ndq-content .file--mime-image-tiff a::before {\n    content: \"î‚\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--text::before,#ndq-content .file--text a::before {\n    content: \"î‚Œ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-audio-x-wav::before,#ndq-content .file--mime-audio-x-wav a::before {\n    content: \"î„ˆ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-audio-x-ms-wma::before,#ndq-content .file--mime-audio-x-ms-wma a::before {\n    content: \"î„…\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--mime-video-x-ms-wmv::before,#ndq-content .file--mime-video-x-ms-wmv a::before {\n    content: \"î„†\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .widget-file--xls::before,#ndq-content .file--xls a::before,#ndq-content .widget-file--x-office-spreadsheet::before,#ndq-content .file--x-office-spreadsheet a::before,#ndq-content .market-data-file-download-xls::before {\n    content: \"î¹\";\n    display: inline-block;\n    text-decoration: none;\n    color: #1D6F42;\n}\n\n#ndq-content .widget-file--mime-application-vnd-ms-excel-sheet-macroEnabled-12::before,#ndq-content .file--mime-application-vnd-ms-excel-sheet-macroEnabled-12 a::before {\n    content: \"î€Ÿ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #1D6F42;\n}\n\n#ndq-content .widget-file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet::before,#ndq-content .file--mime-application-vnd-openxmlformats-officedocument-spreadsheetml-sheet a::before {\n    content: \"î»\";\n    display: inline-block;\n    text-decoration: none;\n    color: #1D6F42;\n}\n\n#ndq-content .widget-file--mime-application-xml::before,#ndq-content .file--mime-application-xml a::before {\n    content: \"î¾\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .node--type-nir-sec-filing .file--mime-application-xsd a:before,#ndq-content .node--type-nir-sec-filing .file--mime-application-xml a:before {\n    content: \"\\e07d\";\n    color: #7b41bd;\n}\n\n#ndq-content .widget-file--mime-application-zip::before,#ndq-content .file--mime-application-zip a::before {\n    content: \"î‚\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content [class^=\"ndqicon__\"] a::before {\n    font-size: 20px;\n}\n\n#ndq-content .ndqicon__chairperson a::before,#ndq-content span.ndqicon__chairperson::before {\n    content: \"î€‹\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__chairperson a_after::after {\n    content: \"î€‹\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content span.ndqicon__chairperson_after::after {\n    content: \"î€‹\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__cob a::before,#ndq-content span.ndqicon__cob::before {\n    content: \"î€¨\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__cob a_after::after {\n    content: \"î€¨\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content span.ndqicon__cob_after::after {\n    content: \"î€¨\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__vicechair::before,#ndq-content span.ndqicon__vicechair::before {\n    content: \"î€§\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__vicechair:after::after,#ndq-content span.ndqicon__vicechair:after::after {\n    content: \"î€§\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content span.ndqicon__vicechair_after::after {\n    content: \"î€§\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__leaddir::before,#ndq-content span.ndqicon__leaddir::before {\n    content: \"îª\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__leaddir_after::after {\n    content: \"îª\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content span.ndqicon__leaddir_after::after {\n    content: \"îª\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__chair::before {\n    content: \"î€¨\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__chair1::before {\n    content: \"îª\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__chair2::before {\n    content: \"î«\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__chair3::before {\n    content: \"î¬\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__member a::before,#ndq-content span.ndqicon__member::before {\n    content: \"î€Š\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__download::before {\n    content: \"î“\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__independent::before {\n    content: \"î€\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__independent_italic::before {\n    content: \"î€Ž\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__calculator::before,#ndq-content span.ndqicon__calculator::before {\n    content: \"î€²\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__calculator_after::after {\n    content: \"î€²\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content span.ndqicon__calculator_after::after {\n    content: \"î€²\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon__calculator1::before {\n    content: \"î€¯\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .icon-key {\n    float: left;\n    margin-top: 0;\n}\n\n#ndq-content .key-item {\n    margin: 1em 0;\n}\n\n#ndq-content .key-item span:before {\n    font-size: 20px;\n}\n\n#ndq-content .html-link a::before,#ndq-content .asset-link a::before {\n    content: \"î·\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0472bd;\n}\n\n#ndq-content .widget-file--mime-application-octet-stream::before,#ndq-content .file--mime-application-octet-stream a::before,#ndq-content .html-link.xbrl-viewer-lik a::before,#ndq-content .html-link.xbrl-viewer-link a::before {\n    content: \"î„‡\";\n    display: inline-block;\n    text-decoration: none;\n    color: #7b41bd;\n}\n\n#ndq-content .add-outlook a {\n    font-size: 0;\n}\n\n#ndq-content .add-outlook a::before {\n    content: \"î€¿\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .add-outlook a::before {\n    background: #FFBC00;\n    color: #fff;\n    font-size: 20px;\n    width: 21px;\n    height: 21px;\n    text-align: center;\n    padding-top: 5px;\n    margin-right: 5px;\n    padding-left: 5px;\n}\n\n#ndq-content .add-gcal a {\n    font-size: 0;\n}\n\n#ndq-content .add-gcal a::before {\n    content: \"î€ž\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .add-gcal a::before {\n    background: #dd4b39;\n    color: #fff;\n    font-size: 20px;\n    width: 21px;\n    height: 21px;\n    text-align: center;\n    padding-top: 5px;\n    margin-right: 5px;\n    padding-left: 5px;\n}\n\n#ndq-content .right-arrow::before {\n    content: \"î„Œ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #666;\n}\n\n#ndq-content .right-arrow::before {\n    font-size: 14px;\n}\n\n#ndq-content .up-arrow::before {\n    content: \"î’\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .up-arrow::before {\n    font-size: 14px;\n}\n\n#ndq-content .ndqicon-check-circle::before,#ndq-content .thank-you-page h1::before {\n    content: \"î„–\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .ndqicon-check-circle::before,#ndq-content .thank-you-page h1::before {\n    font-size: 22px;\n}\n\n#ndq-content a.show-all::after {\n    content: \"î€’\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.show-all::after {\n    font-size: 14px;\n}\n\n#ndq-content a.show-all.hide-all::after {\n    content: \"î€‘\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content a.show-all.hide-all::after {\n    font-size: 14px;\n}\n\n#ndq-content .faq-acc-dl dt::before,#ndq-content .faq-acc-dl .acc-title::before,#ndq-content .acc-wrap dt::before,#ndq-content .acc-wrap .acc-title::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .faq-acc-dl dt::before,#ndq-content .faq-acc-dl .acc-title::before,#ndq-content .acc-wrap dt::before,#ndq-content .acc-wrap .acc-title::before {\n    color: white;\n    font-size: 14px;\n}\n\n#ndq-content .faq-acc-dl dt.opened::before,#ndq-content .faq-acc-dl .acc-title.opened::before,#ndq-content .acc-wrap dt.opened::before,#ndq-content .acc-wrap .acc-title.opened::before {\n    content: \"î\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .faq-acc-dl dt.opened::before,#ndq-content .faq-acc-dl .acc-title.opened::before,#ndq-content .acc-wrap dt.opened::before,#ndq-content .acc-wrap .acc-title.opened::before {\n    color: white;\n    font-size: 14px;\n}\n\n#ndq-content .top-link::after {\n    content: \"î’\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .top-link::after {\n    font-size: 14px;\n    margin-top: -4px;\n}\n\n\n\n#ndq-content [dir=\"rtl\"] .autocomplete,#ndq-content [dir=\"rtl\"] html.js input.form-autocomplete,#ndq-content html.js [dir=\"rtl\"] input.form-autocomplete {\n    background-position: 0% 2px;\n}\n\n#ndq-content .autocomplete.is-throbbing,#ndq-content .autocomplete--is-throbbing,#ndq-content html.js input.is-throbbing.form-autocomplete,#ndq-content html.js input.throbbing {\n    background-position: 100% -18px;\n}\n\n#ndq-content [dir=\"rtl\"] .autocomplete.is-throbbing,#ndq-content [dir=\"rtl\"] .autocomplete--is-throbbing,#ndq-content [dir=\"rtl\"] html.js input.is-throbbing.form-autocomplete,#ndq-content html.js [dir=\"rtl\"] input.is-throbbing.form-autocomplete,#ndq-content [dir=\"rtl\"] html.js input.throbbing,#ndq-content html.js [dir=\"rtl\"] input.throbbing {\n    background-position: 0% -18px;\n}\n\n#ndq-content .autocomplete__list-wrapper,#ndq-content #autocomplete {\n    border: 1px solid;\n    overflow: hidden;\n    position: absolute;\n    z-index: 100;\n}\n\n#ndq-content .autocomplete__list,#ndq-content #autocomplete ul {\n    list-style: none;\n    list-style-image: none;\n    margin: 0;\n    padding: 0;\n}\n\n#ndq-content .autocomplete__list-item,#ndq-content #autocomplete li {\n    background: #fff;\n    color: #000;\n    cursor: default;\n    white-space: pre;\n    zoom:1;}\n\n#ndq-content .autocomplete__list-item--is-selected,#ndq-content #autocomplete .selected {\n    background: #0480a9;\n    color: #fff;\n}\n\n#ndq-content .box,#ndq-content .box__right {\n    border: 1px solid var(--border-color,#cbcbcd);\n    padding: 1em;\n}\n\n#ndq-content .box__title {\n    margin: 0;\n}\n\n#ndq-content .box--highlight {\n    border-color: #0480a9;\n}\n\n#ndq-content .box__right {\n    margin-left: 1.5em !important;\n    margin-bottom: 1em;\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n@media (min-width: 1024px) {\n    #ndq-content .box__right {\n        width:30.37975%;\n        margin-right: 0;\n        float: right;\n    }\n}\n\n@media print {\n    #ndq-content .breadcrumb {\n        display: none;\n    }\n}\n\n#ndq-content .breadcrumb__list {\n    margin: 0;\n    padding: 0;\n}\n\n#ndq-content .breadcrumb__item {\n    display: inline;\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n#ndq-content .nir-chart {\n    margin: 15px;\n}\n\n#ndq-content .collapsible-fieldset,#ndq-content .collapsible {\n    position: relative;\n}\n\n#ndq-content .collapsible-fieldset.is-collapsed,#ndq-content .collapsible-fieldset--is-collapsed,#ndq-content .is-collapsed.collapsible,#ndq-content .collapsible.collapsed {\n    border-bottom-width: 0;\n    border-left-width: 0;\n    border-right-width: 0;\n    height: 1em;\n}\n\n#ndq-content .is-collapsed .collapsible-fieldset__wrapper,#ndq-content .collapsible-fieldset--is-collapsed__wrapper,#ndq-content .collapsible.collapsed .fieldset-wrapper {\n    display: none;\n}\n\n\n#ndq-content [dir=\"rtl\"] .collapsible-fieldset__legend,#ndq-content [dir=\"rtl\"] .collapsible .fieldset-legend,#ndq-content .collapsible [dir=\"rtl\"] .fieldset-legend {\n    padding-left: 0;\n    padding-right: 15px;\n    background-position: 98% 75%;\n}\n\n\n\n#ndq-content .collapsible-fieldset__summary,#ndq-content .collapsible .fieldset-legend .summary {\n    color: #847271;\n    font-size: .9em;\n    margin-left: 0.5em;\n}\n\n#ndq-content .comment__section,#ndq-content .comments {\n    margin: 1.42857em 0;\n}\n\n#ndq-content .comment__title {\n    margin: 0;\n}\n\n#ndq-content .comment__permalink {\n    text-transform: uppercase;\n    font-size: 75%;\n}\n\n#ndq-content .comment--preview,#ndq-content .comment-preview {\n    background-color: #fffadb;\n}\n\n#ndq-content .comment--nested,#ndq-content .indented {\n    margin-left: 28px;\n}\n\n#ndq-content [dir=\"rtl\"] .comment--nested,#ndq-content [dir=\"rtl\"] .indented {\n    margin-left: 0;\n    margin-right: 28px;\n}\n\n#ndq-content table.dataTable {\n    table-layout: auto;\n}\n\n#ndq-content table.dataTable thead th,#ndq-content table.dataTable tfoot th {\n    font-weight: bold;\n}\n\n#ndq-content table.dataTable thead th:active,#ndq-content table.dataTable thead td:active {\n    outline: none;\n}\n\n\n#ndq-content table.dataTable thead .sorting,#ndq-content table.dataTable thead .sorting_asc,#ndq-content table.dataTable thead .sorting_desc,#ndq-content table.dataTable thead .sorting_asc_disabled,#ndq-content table.dataTable thead .sorting_desc_disabled {\n    background-repeat: no-repeat;\n    background-position: center right;\n}\n\n\n#ndq-content table.dataTable tbody tr.selected {\n    background-color: #B0BED9;\n}\n\n#ndq-content table.dataTable.stripe tbody tr.odd,#ndq-content table.dataTable.display tbody tr.odd {\n    background-color: #f9f9f9;\n}\n\n#ndq-content table.dataTable.stripe tbody tr.odd.selected,#ndq-content table.dataTable.display tbody tr.odd.selected {\n    background-color: #acbad4;\n}\n\n#ndq-content table.dataTable.hover tbody tr:hover,#ndq-content table.dataTable.display tbody tr:hover {\n    background-color: #f6f6f6;\n}\n\n#ndq-content table.dataTable.hover tbody tr:hover.selected,#ndq-content table.dataTable.display tbody tr:hover.selected {\n    background-color: #aab7d1;\n}\n\n#ndq-content table.dataTable.order-column tbody tr > .sorting_1,#ndq-content table.dataTable.order-column tbody tr > .sorting_2,#ndq-content table.dataTable.order-column tbody tr > .sorting_3,#ndq-content table.dataTable.display tbody tr > .sorting_1,#ndq-content table.dataTable.display tbody tr > .sorting_2,#ndq-content table.dataTable.display tbody tr > .sorting_3 {\n    background-color: #fafafa;\n}\n\n#ndq-content table.dataTable.order-column tbody tr.selected > .sorting_1,#ndq-content table.dataTable.order-column tbody tr.selected > .sorting_2,#ndq-content table.dataTable.order-column tbody tr.selected > .sorting_3,#ndq-content table.dataTable.display tbody tr.selected > .sorting_1,#ndq-content table.dataTable.display tbody tr.selected > .sorting_2,#ndq-content table.dataTable.display tbody tr.selected > .sorting_3 {\n    background-color: #acbad5;\n}\n\n#ndq-content table.dataTable.display tbody tr.odd > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.odd > .sorting_1 {\n    background-color: #f1f1f1;\n}\n\n#ndq-content table.dataTable.display tbody tr.odd > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.odd > .sorting_2 {\n    background-color: #f3f3f3;\n}\n\n#ndq-content table.dataTable.display tbody tr.odd > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.odd > .sorting_3 {\n    background-color: whitesmoke;\n}\n\n#ndq-content table.dataTable.display tbody tr.odd.selected > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.odd.selected > .sorting_1 {\n    background-color: #a6b4cd;\n}\n\n#ndq-content table.dataTable.display tbody tr.odd.selected > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.odd.selected > .sorting_2 {\n    background-color: #a8b5cf;\n}\n\n#ndq-content table.dataTable.display tbody tr.odd.selected > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.odd.selected > .sorting_3 {\n    background-color: #a9b7d1;\n}\n\n#ndq-content table.dataTable.display tbody tr.even > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.even > .sorting_1 {\n    background-color: #fafafa;\n}\n\n#ndq-content table.dataTable.display tbody tr.even > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.even > .sorting_2 {\n    background-color: #fcfcfc;\n}\n\n#ndq-content table.dataTable.display tbody tr.even > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.even > .sorting_3 {\n    background-color: #fefefe;\n}\n\n#ndq-content table.dataTable.display tbody tr.even.selected > .sorting_1,#ndq-content table.dataTable.order-column.stripe tbody tr.even.selected > .sorting_1 {\n    background-color: #acbad5;\n}\n\n#ndq-content table.dataTable.display tbody tr.even.selected > .sorting_2,#ndq-content table.dataTable.order-column.stripe tbody tr.even.selected > .sorting_2 {\n    background-color: #aebcd6;\n}\n\n#ndq-content table.dataTable.display tbody tr.even.selected > .sorting_3,#ndq-content table.dataTable.order-column.stripe tbody tr.even.selected > .sorting_3 {\n    background-color: #afbdd8;\n}\n\n#ndq-content table.dataTable.display tbody tr:hover > .sorting_1,#ndq-content table.dataTable.order-column.hover tbody tr:hover > .sorting_1 {\n    background-color: #eaeaea;\n}\n\n#ndq-content table.dataTable.display tbody tr:hover > .sorting_2,#ndq-content table.dataTable.order-column.hover tbody tr:hover > .sorting_2 {\n    background-color: #ececec;\n}\n\n#ndq-content table.dataTable.display tbody tr:hover > .sorting_3,#ndq-content table.dataTable.order-column.hover tbody tr:hover > .sorting_3 {\n    background-color: #efefef;\n}\n\n#ndq-content table.dataTable.display tbody tr:hover.selected > .sorting_1,#ndq-content table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_1 {\n    background-color: #a2aec7;\n}\n\n#ndq-content table.dataTable.display tbody tr:hover.selected > .sorting_2,#ndq-content table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_2 {\n    background-color: #a3b0c9;\n}\n\n#ndq-content table.dataTable.display tbody tr:hover.selected > .sorting_3,#ndq-content table.dataTable.order-column.hover tbody tr:hover.selected > .sorting_3 {\n    background-color: #a5b2cb;\n}\n\n#ndq-content table.dataTable.nowrap th,#ndq-content table.dataTable.nowrap td {\n    white-space: nowrap;\n}\n\n#ndq-content table.dataTable.compact thead th,#ndq-content table.dataTable.compact thead td {\n    padding: 4px 17px 4px 4px;\n}\n\n#ndq-content table.dataTable.compact tfoot th,#ndq-content table.dataTable.compact tfoot td {\n    padding: 4px;\n}\n\n#ndq-content table.dataTable.compact tbody th,#ndq-content table.dataTable.compact tbody td {\n    padding: 4px;\n}\n\n#ndq-content table.dataTable th.dt-left,#ndq-content table.dataTable td.dt-left {\n    text-align: left;\n}\n\n#ndq-content table.dataTable th.dt-center,#ndq-content table.dataTable td.dt-center,#ndq-content table.dataTable td.dataTables_empty {\n    text-align: center;\n}\n\n#ndq-content table.dataTable th.dt-right,#ndq-content table.dataTable td.dt-right {\n    text-align: right;\n}\n\n#ndq-content table.dataTable th.dt-justify,#ndq-content table.dataTable td.dt-justify {\n    text-align: justify;\n}\n\n#ndq-content table.dataTable th.dt-nowrap,#ndq-content table.dataTable td.dt-nowrap {\n    white-space: nowrap;\n}\n\n#ndq-content table.dataTable thead th.dt-head-left,#ndq-content table.dataTable thead td.dt-head-left,#ndq-content table.dataTable tfoot th.dt-head-left,#ndq-content table.dataTable tfoot td.dt-head-left {\n    text-align: left;\n}\n\n#ndq-content table.dataTable thead th.dt-head-center,#ndq-content table.dataTable thead td.dt-head-center,#ndq-content table.dataTable tfoot th.dt-head-center,#ndq-content table.dataTable tfoot td.dt-head-center {\n    text-align: center;\n}\n\n#ndq-content table.dataTable thead th.dt-head-right,#ndq-content table.dataTable thead td.dt-head-right,#ndq-content table.dataTable tfoot th.dt-head-right,#ndq-content table.dataTable tfoot td.dt-head-right {\n    text-align: right;\n}\n\n#ndq-content table.dataTable thead th.dt-head-justify,#ndq-content table.dataTable thead td.dt-head-justify,#ndq-content table.dataTable tfoot th.dt-head-justify,#ndq-content table.dataTable tfoot td.dt-head-justify {\n    text-align: justify;\n}\n\n#ndq-content table.dataTable thead th.dt-head-nowrap,#ndq-content table.dataTable thead td.dt-head-nowrap,#ndq-content table.dataTable tfoot th.dt-head-nowrap,#ndq-content table.dataTable tfoot td.dt-head-nowrap {\n    white-space: nowrap;\n}\n\n#ndq-content table.dataTable tbody th.dt-body-left,#ndq-content table.dataTable tbody td.dt-body-left {\n    text-align: left;\n}\n\n#ndq-content table.dataTable tbody th.dt-body-center,#ndq-content table.dataTable tbody td.dt-body-center {\n    text-align: center;\n}\n\n#ndq-content table.dataTable tbody th.dt-body-right,#ndq-content table.dataTable tbody td.dt-body-right {\n    text-align: right;\n}\n\n#ndq-content table.dataTable tbody th.dt-body-justify,#ndq-content table.dataTable tbody td.dt-body-justify {\n    text-align: justify;\n}\n\n#ndq-content table.dataTable tbody th.dt-body-nowrap,#ndq-content table.dataTable tbody td.dt-body-nowrap {\n    white-space: nowrap;\n}\n\n#ndq-content table.dataTable,#ndq-content table.dataTable th,#ndq-content table.dataTable td {\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n}\n\n\n\n#ndq-content .dataTables_wrapper .dataTables_length {\n    float: left;\n}\n\n#ndq-content .dataTables_wrapper .dataTables_filter {\n    float: right;\n    text-align: left;\n}\n\n#ndq-content .dataTables_wrapper .dataTables_filter input {\n    margin-bottom: 0.5em;\n}\n\n#ndq-content .dataTables_wrapper .dataTables_info {\n    clear: both;\n    float: left;\n    padding-top: 0.755em;\n}\n\n#ndq-content .dataTables_wrapper .dataTables_paginate .ellipsis {\n    padding: 0 1em;\n}\n\n#ndq-content .dataTables_wrapper .dataTables_processing {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100%;\n    height: 40px;\n    margin-left: -50%;\n    margin-top: -25px;\n    padding-top: 20px;\n    text-align: center;\n    font-size: 1.2em;\n    background-color: white;\n    background: -webkit-gradient(linear,left top,right top,color-stop(0%,rgba(255,255,255,0)),color-stop(25%,rgba(255,255,255,0.9)),color-stop(75%,rgba(255,255,255,0.9)),color-stop(100%,rgba(255,255,255,0)));\n    background: -webkit-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,0.9) 25%,rgba(255,255,255,0.9) 75%,rgba(255,255,255,0) 100%);\n    background: -moz-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,0.9) 25%,rgba(255,255,255,0.9) 75%,rgba(255,255,255,0) 100%);\n    background: -ms-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,0.9) 25%,rgba(255,255,255,0.9) 75%,rgba(255,255,255,0) 100%);\n    background: -o-linear-gradient(left,rgba(255,255,255,0) 0%,rgba(255,255,255,0.9) 25%,rgba(255,255,255,0.9) 75%,rgba(255,255,255,0) 100%);\n    background: linear-gradient(to right,rgba(255,255,255,0) 0%,rgba(255,255,255,0.9) 25%,rgba(255,255,255,0.9) 75%,rgba(255,255,255,0) 100%);\n}\n\n\n#ndq-content .dataTables_wrapper .dataTables_scroll {\n    clear: both;\n}\n\n\n#ndq-content .dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody th > div.dataTables_sizing,#ndq-content .dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody td > div.dataTables_sizing {\n    height: 0;\n    overflow: hidden;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n#ndq-content .dataTables_wrapper:after {\n    visibility: hidden;\n    display: block;\n    content: \"\";\n    clear: both;\n    height: 0;\n}\n\n@media screen and (max-width: 767px) {\n    #ndq-content .nir-datatables thead td {\n        display:none;\n    }\n\n    #ndq-content .dataTables_wrapper .dataTables_info,#ndq-content .dataTables_wrapper .dataTables_paginate {\n        float: none;\n        text-align: center;\n    }\n\n    #ndq-content .dataTables_wrapper .dataTables_paginate {\n        margin-top: 0.5em;\n    }\n}\n\n@media screen and (max-width: 640px) {\n    #ndq-content .dataTables_wrapper .dataTables_filter {\n        margin-top:0.5em;\n    }\n}\n\n#ndq-content .dataTables_length select {\n    display: inline;\n    margin-bottom: 5px;\n}\n\n#ndq-content .block-nir-attribution-block {\n    float: left;\n    padding: 0 1em;\n}\n\n#ndq-content .block-nir-attribution-block > p {\n    margin-top: 20px;\n}\n\n#ndq-content hr,#ndq-content .divider {\n    margin: 1.42857em 0;\n    border: 0;\n    border-bottom: 3px solid #0480a9;\n}\n\n#ndq-content hr > :first-child,#ndq-content .divider > :first-child {\n    margin-top: 1.42857em;\n}\n\n#ndq-content form.views-exposed-form .form-item {\n    margin-bottom: 1em;\n    float: left;\n    margin-right: 12px;\n}\n\n#ndq-content form.views-exposed-form .form-actions {\n    margin: 38px 0 0 0;\n}\n\n@media (max-width: 481px) {\n    #ndq-content form.views-exposed-form .form-actions {\n        clear:both;\n    }\n}\n\n#ndq-content form.views-exposed-form .form-item-items-per-page label::after {\n    content: \":\";\n}\n\n#ndq-content .region .block.block-facets {\n    padding: 0px;\n    margin: 0;\n}\n\n#ndq-content .region .block.block-facets h2 {\n    display: inline-block;\n    font-size: 14px;\n    line-height: 1.42857;\n    margin: 0;\n    border-bottom: 0;\n}\n\n#ndq-content .region .block.block-facets ul {\n    padding: 0;\n    margin: 0;\n}\n\n#ndq-content .region .block.block-facets ul li {\n    margin: 0.4em 0 0.4em 2em;\n}\n\n#ndq-content .field--label-inline {\n    display: block;\n}\n\n#ndq-content .field--label-inline * {\n    display: inline;\n}\n\n#ndq-content .field--label-inline .field__label::after {\n    content: \":\";\n}\n\n#ndq-content .full-name {\n    font-weight: bold;\n}\n\n#ndq-content .field__centered {\n    width: 100%;\n    text-align: center;\n}\n\n#ndq-content .field__light-italic {\n    font-style: italic;\n    color: #847271;\n}\n\n#ndq-content .small-inline-label {\n    font-size: 11px;\n    float: left;\n    margin-right: 0.5em;\n}\n\n#ndq-content .form-item {\n    margin: 1.42857em 0;\n}\n\n#ndq-content .form-item__required::after,#ndq-content .form-required::after {\n    content: \"*\";\n    color: #c00;\n    display: inline;\n    margin: 0 0 0 5px;\n}\n\n#ndq-content .form-item__description,#ndq-content .form-item .description {\n    font-size: 1.1em;\n}\n\n#ndq-content .form-item--inline div,#ndq-content .form-item--inline label,#ndq-content .container-inline .form-item div,#ndq-content .container-inline .form-item label {\n    display: inline;\n}\n\n#ndq-content .form-item--inline__exception,#ndq-content .container-inline .fieldset-wrapper {\n    display: block;\n}\n\n#ndq-content .form-item--tight,#ndq-content .form-item--radio,#ndq-content .form-type-radio,#ndq-content .form-type-checkbox,#ndq-content .password-parent,#ndq-content .confirm-parent,#ndq-content table .form-item {\n    margin: 0;\n}\n\n#ndq-content .form-item--radio__label,#ndq-content .form-item--radio .form-item__label,#ndq-content label.option,#ndq-content .form-type-radio .form-item__label,#ndq-content .form-type-checkbox .form-item__label {\n    display: inline;\n    font-weight: normal;\n}\n\n#ndq-content .form-item--radio__description,#ndq-content .form-item--radio .form-item__description,#ndq-content .form-type-radio .description,#ndq-content .form-type-checkbox .description,#ndq-content .form-type-radio .form-item__description,#ndq-content .form-type-checkbox .form-item__description,#ndq-content .form-item--radio .form-item .description,#ndq-content .form-item .form-item--radio .description,#ndq-content .form-type-radio .form-item .description,#ndq-content .form-item .form-type-radio .description,#ndq-content .form-type-checkbox .form-item .description,#ndq-content .form-item .form-type-checkbox .description {\n    margin-left: 1.4em;\n}\n\n#ndq-content .form-item.is-error .form-item__widget,#ndq-content .form-item--is-error__widget,#ndq-content .form-item.is-error input,#ndq-content .form-item.is-error textarea,#ndq-content .form-item.is-error select,#ndq-content .form-item--is-error input,#ndq-content .form-item--is-error textarea,#ndq-content .form-item--is-error select,#ndq-content .form-item input.error,#ndq-content .form-item textarea.error,#ndq-content .form-item select.error {\n    border: 1px solid #c00;\n}\n\n#ndq-content .form-note .form-required::after {\n    margin: 0px;\n}\n\n#ndq-content .captcha {\n    margin-bottom: 1em;\n}\n\n#ndq-content .view-nir-glossary .views-row {\n    margin-bottom: 20px;\n}\n\n#ndq-content .highlight-mark,#ndq-content .new,#ndq-content .update {\n    color: #c00;\n    background-color: transparent;\n}\n\n#ndq-content .inline-links,#ndq-content .inline.links {\n    padding: 0;\n}\n\n#ndq-content .inline-links__item,#ndq-content .inline.links li {\n    display: inline;\n    list-style-type: none;\n    padding: 0 1em 0 0;\n}\n\n#ndq-content [dir=\"rtl\"] .inline-links__item,#ndq-content [dir=\"rtl\"] .inline.links li,#ndq-content .inline.links [dir=\"rtl\"] li {\n    display: inline-block;\n    padding: 0 0 0 1em;\n}\n\n#ndq-content .inline-sibling,#ndq-content span.field-label,#ndq-content .field__label-inline {\n    display: inline;\n    margin-right: 10px;\n}\n\n#ndq-content [dir=\"rtl\"] .inline-sibling,#ndq-content [dir=\"rtl\"] span.field-label,#ndq-content [dir=\"rtl\"] .field__label-inline {\n    margin-right: 0;\n    margin-left: 10px;\n}\n\n#ndq-content .inline-sibling__child,#ndq-content .inline-sibling *,#ndq-content span.field-label *,#ndq-content .field__label-inline * {\n    display: inline;\n}\n\n#ndq-content .inline-sibling__adjacent,#ndq-content .inline-sibling + *,#ndq-content .inline-sibling + * > *:first-child,#ndq-content .field__items-inline,#ndq-content span.field-label + *,#ndq-content .field__label-inline + *,#ndq-content span.field-label + * > *:first-child,#ndq-content .field__label-inline + * > *:first-child {\n    display: inline;\n}\n\n#ndq-content .ipe-category-picker-search input[type=\"text\"] {\n    display: inline;\n    width: 183px;\n}\n\n#ndq-content #panels-ipe-tray .ipe-tab-wrapper ul.ipe-tabs li {\n    margin: 0px !important;\n    padding: 0px !important;\n}\n\n#ndq-content #panels-ipe-tray .ipe-tab-wrapper ul.ipe-tabs li.ipe-tab > a:link {\n    text-decoration: none !important;\n    color: black !important;\n}\n\n#ndq-content .ipe-block-plugin-info p {\n    padding: 0 10px 10px 10px;\n}\n\n#ndq-content .dcsns-content *,#ndq-content .dcsns-toolbar * {\n    box-sizing: content-box;\n}\n\n#ndq-content .dcsns-content blockquote {\n    margin: 0;\n}\n\n#ndq-content .stream li.dcsns-tumblr .section-text img {\n    max-width: 99%;\n}\n\n#ndq-content .dcsns-flickr .stream li .section-title {\n    width: 100%;\n}\n\n#ndq-content .light_1 .stream li .section-title,#ndq-content .light_2 .stream li .section-title {\n    color: #666;\n}\n\n#ndq-content .dark_2 .stream li .icon {\n    position: absolute;\n    left: 4px;\n    bottom: 2px;\n    z-index: 2;\n    width: 22px;\n}\n\n#ndq-content .language-switcher-language-url ul {\n    float: right;\n}\n\n#ndq-content .language-switcher-language-url ul .is-active {\n    color: #000;\n}\n\n#ndq-content .ui-dialog {\n    background: transparent;\n    border: 0;\n    position: absolute;\n    z-index: 1260;\n    padding: 0;\n}\n\n@media all and (max-width: 48em) {\n    #ndq-content .ui-dialog {\n        min-width:92%;\n        max-width: 92%;\n    }\n}\n\n#ndq-content .ui-dialog {\n    -webkit-box-shadow: 0 0 5px #847271;\n    -moz-box-shadow: 0 0 5px #847271;\n    -ms-box-shadow: 0 0 5px #847271;\n    -o-box-shadow: 0 0 5px #847271;\n    box-shadow: 0 0 5px #847271;\n}\n\n#ndq-content .ui-dialog:focus {\n    outline: none;\n}\n\n#ndq-content .ui-icon,#ndq-content .ui-widget-content .ui-icon {\n    background: none;\n}\n\n#ndq-content .ui-widget-content {\n    border: 0;\n}\n\n#ndq-content .ui-widget-header {\n    border: 0;\n}\n\n#ndq-content .ui-widget {\n    font-family: inherit;\n    font-size: inherit;\n}\n\n#ndq-content .ui-dialog .ui-dialog-titlebar {\n    background: #fff;\n    border-radius: 0;\n    padding: 0;\n    height: 0;\n}\n\n#ndq-content [dir=\"rtl\"] .ui-dialog .ui-dialog-titlebar {\n    padding-left: 49px;\n    padding-right: 15px;\n}\n\n#ndq-content .ui-dialog .ui-dialog-title {\n    font-size: 1.231em;\n    font-weight: 600;\n    margin: 0;\n    color: #ffffff;\n    -webkit-font-smoothing: antialiased;\n}\n\n#ndq-content .ui-dialog .ui-dialog-titlebar-close {\n    border: 0;\n    background: none;\n    right: 23px;\n    top: 5px;\n    margin: 0;\n    height: 16px;\n    width: 16px;\n    position: absolute;\n}\n\n#ndq-content .ui-dialog .ui-dialog-titlebar-close:before {\n    font-size: 35px;\n    position: absolute;\n}\n\n#ndq-content [dir=\"rtl\"] .ui-dialog .ui-dialog-titlebar-close {\n    right: auto;\n    left: 20px;\n}\n\n#ndq-content .ui-dialog .ui-icon.ui-icon-closethick {\n    margin-top: -12px;\n}\n\n#ndq-content .ui-dialog .ui-widget-content.ui-dialog-content {\n    border-top: 0;\n    background: #ffffff;\n    overflow: auto;\n    padding: 20px;\n    font-size: 15px;\n}\n\n#ndq-content .views-ui-dialog .ui-widget-content.ui-dialog-content {\n    padding: 0;\n}\n\n#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane {\n    color: #fff;\n    padding: 0;\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button {\n    background: #0480a9;\n    border: inherit;\n    border-radius: 4px;\n    color: white;\n    margin: 0;\n    padding: 10px 15px;\n}\n\n#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:hover,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:focus {\n    background: #0184A2;\n    color: #fff;\n}\n\n#ndq-content .ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n    margin: 0 20px 20px 20px;\n    padding: 0;\n    text-align: center;\n    float: none;\n}\n\n#ndq-content .ui-dialog .ui-dialog-buttonpane .ui-button-text-only .ui-button-text {\n    padding: 0;\n}\n\n#ndq-content .ui-dialog .ui-dialog-content {\n    position: static;\n}\n\n#ndq-content .ui-dialog .ui-dialog-content .form-actions {\n    padding: 0;\n    margin: 0;\n}\n\n\n\n#ndq-content [dir=\"rtl\"] .ui-dialog .ajax-progress-throbber {\n    left: auto;\n    right: 49%;\n}\n\n#ndq-content .ui-dialog .ajax-progress-throbber .throbber,#ndq-content .ui-dialog .ajax-progress-throbber .message {\n    display: none;\n}\n\n#ndq-content .more-link,#ndq-content .more-help-link {\n    text-align: right;\n}\n\n#ndq-content [dir=\"rtl\"] .more-link,#ndq-content [dir=\"rtl\"] .more-help-link {\n    text-align: left;\n}\n\n\n\n#ndq-content [dir=\"rtl\"] .more-link__help-icon,#ndq-content [dir=\"rtl\"] .more-help-link a,#ndq-content .more-help-link [dir=\"rtl\"] a {\n    padding: 1px 20px 1px 0;\n    background-position: 100% 50%;\n}\n\n#ndq-content #mobile-header {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n\n#ndq-content #responsive-menu-button:hover,#ndq-content #responsive-menu-button:focus {\n    text-decoration: none;\n}\n\n#ndq-content .menu--irhorizontal {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n@media (min-width: 769px) {\n    #ndq-content #mobile-header {\n        position:absolute !important;\n        height: 1px;\n        width: 1px;\n        overflow: hidden;\n        clip: rect(1px,1px,1px,1px);\n    }\n\n    #ndq-content .menu--irhorizontal {\n        position: static !important;\n        clip: auto;\n        height: auto;\n        width: auto;\n        overflow: auto;\n    }\n}\n\n#ndq-content .sidr-class-visually-hidden {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n#ndq-content #header-region {\n    position: relative;\n}\n\n#ndq-content .toolbar-vertical {\n    padding-top: 39px;\n}\n\n#ndq-content .navbar,#ndq-content .main-navigation .links,#ndq-content .main-navigation .menu {\n    margin: 1em 0;\n    padding: 0;\n    text-align: left;\n}\n\n#ndq-content [dir=\"rtl\"] .navbar,#ndq-content [dir=\"rtl\"] .main-navigation .links,#ndq-content .main-navigation [dir=\"rtl\"] .links,#ndq-content [dir=\"rtl\"] .main-navigation .menu,#ndq-content .main-navigation [dir=\"rtl\"] .menu {\n    text-align: right;\n}\n\n#ndq-content .navbar__item,#ndq-content .navbar li,#ndq-content .main-navigation .links li,#ndq-content .main-navigation .menu li {\n    float: left;\n    margin: .4em 2em .4em 2em;\n    list-style-type: none;\n    list-style-image: none;\n}\n\n#ndq-content .navbar__item:hover > ul,#ndq-content .navbar li:hover > ul,#ndq-content .main-navigation .links li:hover > ul,#ndq-content .main-navigation .menu li:hover > ul {\n    display: block;\n    position: absolute;\n    background: #fff;\n    background: rgba(255,255,255,0.9);\n}\n\n#ndq-content [dir=\"rtl\"] .navbar__item,#ndq-content [dir=\"rtl\"] .navbar li,#ndq-content [dir=\"rtl\"] .main-navigation .links li,#ndq-content .main-navigation [dir=\"rtl\"] .links li,#ndq-content [dir=\"rtl\"] .main-navigation .menu li,#ndq-content .main-navigation [dir=\"rtl\"] .menu li {\n    float: right;\n    padding: 0 0 0 10px;\n}\n\n#ndq-content .navbar__item .menu,#ndq-content .navbar li .menu,#ndq-content .main-navigation .links li .menu,#ndq-content .main-navigation .menu li .menu {\n    display: none;\n}\n\n#ndq-content .navbar__item .menu li,#ndq-content .navbar li .menu li,#ndq-content .main-navigation .links li .menu li,#ndq-content .main-navigation .menu li .menu li {\n    float: none;\n    margin-left: 15px;\n    font-size: 0.8em;\n    line-height: 1.7em;\n}\n\n#ndq-content .block-nir-website-notices {\n    display: none;\n}\n\n#ndq-content .notification-modal .ui-dialog {\n    font-size: 1.1em;\n    line-height: 1.5em;\n}\n\n#ndq-content .pager {\n    clear: both;\n    padding: 0;\n    text-align: center;\n}\n\n@media print {\n    #ndq-content .pager {\n        display: none;\n    }\n}\n\n#ndq-content .pager__item,#ndq-content .pager__current-item,#ndq-content .pager .is-active,#ndq-content .pager-current,#ndq-content .pager-item,#ndq-content .pager-first,#ndq-content .pager-previous,#ndq-content .pager-next,#ndq-content .pager-last,#ndq-content .pager-ellipsis {\n    display: inline-block;\n    padding: 5px 8px;\n    list-style-type: none;\n    background-image: none;\n}\n\n#ndq-content .pager__current-item,#ndq-content .pager .is-active,#ndq-content .pager-current {\n    font-weight: bold;\n    background-color: #0480a9;\n    border-radius: 4px;\n    padding: 10px 15px;\n    color: #fff;\n}\n\n#ndq-content .pager__current-item a,#ndq-content .pager .is-active a,#ndq-content .pager-current a {\n    color: white;\n}\n\n#ndq-content .pager__items {\n    float: left;\n    width: 100%;\n    padding: 0;\n}\n\n#ndq-content .results-summary {\n    text-align: center;\n}\n\n#ndq-content .progress-bar,#ndq-content .progress {\n    font-weight: bold;\n}\n\n#ndq-content .progress-bar__bar,#ndq-content .progress .bar {\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    -ms-border-radius: 3px;\n    -o-border-radius: 3px;\n    border-radius: 3px;\n    margin: 0 .2em;\n    border: 1px solid #666;\n    background-color: #ddd;\n}\n\n\n#ndq-content .progress-bar__percentage,#ndq-content .progress .percentage {\n    float: right;\n}\n\n#ndq-content [dir=\"rtl\"] .progress-bar__percentage,#ndq-content [dir=\"rtl\"] .progress .percentage,#ndq-content .progress [dir=\"rtl\"] .percentage {\n    float: left;\n}\n\n#ndq-content .progress-bar--inline,#ndq-content .ajax-progress-bar {\n    width: 16em;\n    display: inline-block;\n}\n\n#ndq-content [dir=\"rtl\"] .progress-bar--inline,#ndq-content [dir=\"rtl\"] .ajax-progress-bar {\n    float: right;\n}\n\n#ndq-content .progress-throbber,#ndq-content .ajax-progress {\n    display: inline-block;\n}\n\n#ndq-content [dir=\"rtl\"] .progress-throbber,#ndq-content [dir=\"rtl\"] .ajax-progress {\n    float: right;\n}\n\n#ndq-content [dir=\"rtl\"] .progress-throbber__widget,#ndq-content [dir=\"rtl\"] .ajax-progress .throbber,#ndq-content .ajax-progress [dir=\"rtl\"] .throbber {\n    float: right;\n}\n\n#ndq-content .progress-throbber__widget-in-tr,#ndq-content tr .ajax-progress .throbber {\n    margin: 0 2px;\n}\n\n#ndq-content .progress-throbber__message,#ndq-content .ajax-progress .message {\n    padding-left: 20px;\n}\n\n#ndq-content .nir-mean-value-rating {\n    width: 100%;\n    padding-top: 70px;\n}\n\n#ndq-content .nir-mean-value-rating .rating-box {\n    width: 20%;\n    height: 16px;\n    float: left;\n}\n\n#ndq-content .nir-mean-value-rating .sell {\n    float: left;\n}\n\n#ndq-content .nir-mean-value-rating .strongbuy {\n    float: right;\n}\n\n#ndq-content .nir-mean-value-rating h3 {\n    text-align: center;\n}\n\n#ndq-content .nir-mean-value-rating .mean-recommendation {\n    text-align: center;\n    font-weight: bold;\n}\n\n#ndq-content .nir-mean-value-rating .rating {\n    position: relative;\n    padding: 10px 0 35px;\n    width: 85%;\n    margin: 0 auto;\n    max-width: 135px;\n}\n\n#ndq-content .nir-mean-value-rating .rating-arrow {\n    display: block;\n    height: 10px;\n    width: 10px;\n    top: -8px;\n    position: absolute;\n}\n\n#ndq-content .nir-mean-value-rating .rating-arrow::after {\n    content: \"î€’\";\n    display: inline-block;\n    text-decoration: none;\n    color: #000;\n}\n\n#ndq-content .nir-mean-value-rating .rating-arrow::after {\n    font-size: 16px;\n    margin-left: 5px;\n}\n\n#ndq-content .nir-mean-value-rating .clearfix {\n    clear: both;\n    max-width: 230px;\n    margin: 0 auto;\n}\n\n#ndq-content .block-market-data-block__estimates__analyst-ratings {\n    float: left;\n    width: 100%;\n}\n\n@media (min-width: 1024px) {\n    #ndq-content .block-market-data-block__estimates__analyst-ratings > div {\n        float:left;\n        max-width: 50%;\n        margin: 0;\n    }\n}\n\n#ndq-content .resizable-textarea {\n    width: 100%;\n    vertical-align: bottom;\n}\n\n\n\n#ndq-content .responsive-video,#ndq-content .media-youtube-video,#ndq-content .media-vimeo-preview-wrapper {\n    position: relative;\n    padding-bottom: 56.25%;\n    padding-top: 25px;\n    height: 0;\n}\n\n#ndq-content .responsive-video__embed,#ndq-content .responsive-video iframe,#ndq-content .media-youtube-video iframe,#ndq-content .media-vimeo-preview-wrapper iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n#ndq-content .responsive-video--4-3 {\n    padding-bottom: 75%;\n}\n\n#ndq-content .block-search-form form,#ndq-content .view-search form {\n    position: relative;\n}\n\n#ndq-content .block-search-form form input[type=search],#ndq-content .block-search-form form input[type=text],#ndq-content .view-search form input[type=search],#ndq-content .view-search form input[type=text] {\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0;\n}\n\n#ndq-content .block-search-form form input[type=submit],#ndq-content .view-search form input[type=submit] {\n    border: 0;\n    background: transparent;\n    position: absolute;\n    text-indent: -8472719px;\n    padding: 10px 25px;\n    top: 0;\n    right: 0;\n    margin: 0;\n    z-index: 100;\n}\n\n#ndq-content .block-search-form form .form-type-textfield,#ndq-content .view-search form .form-type-textfield {\n    width: 100%;\n    margin: 0;\n}\n\n#ndq-content .block-search-form form::after,#ndq-content .view-search form::after {\n    content: \"î€¹\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .block-search-form form::after,#ndq-content .view-search form::after {\n    position: absolute;\n    top: 3px;\n    right: 0;\n    z-index: 99;\n    font-size: 33px;\n    padding: 11px 9px;\n}\n\n#ndq-content .block-search-form .view-content,#ndq-content .view-search .view-content {\n    margin-top: 25px;\n}\n\n#ndq-content .search-result {\n    margin-bottom: 20px;\n}\n\n#ndq-content .search-result:before {\n    content: '';\n    display: table;\n}\n\n#ndq-content .search-result:after {\n    content: '';\n    display: table;\n    clear: both;\n}\n\n#ndq-content .search-result-contenttype {\n    display: block;\n    color: #666;\n    font-size: 12px;\n}\n\n#ndq-content .search-result-title {\n    font-size: 1.2em;\n    margin-bottom: 5px;\n    margin-top: 0;\n}\n\n#ndq-content .search-result-thumbnail {\n    float: left;\n    width: 24%;\n    position: relative;\n    overflow: hidden;\n    margin-right: 10px;\n    margin-top: 4px;\n    margin-bottom: 0;\n}\n\n#ndq-content .search-result-thumbnail img {\n    max-width: 100%;\n}\n\n#ndq-content .search-result .external-link h3 {\n    display: inline;\n}\n\n#ndq-content .search-result h3 {\n    margin-bottom: 5px;\n    margin-top: 0;\n}\n\n#ndq-content .search-result-snippet-wrapper {\n    float: left;\n    width: 73%;\n}\n\n#ndq-content .search-result-snippet-wrapper-full {\n    width: 100%;\n}\n\n#ndq-content .search-result .item-list {\n    display: inline;\n}\n\n#ndq-content .search-result .item-list ul {\n    margin-top: 0;\n    padding: 0;\n}\n\n#ndq-content .search-result .item-list ul li {\n    list-style-type: none;\n}\n\n#ndq-content .search-result-tags {\n    font-size: 11px;\n    margin-top: 8px;\n}\n\n#ndq-content .search-result-tags ul {\n    margin: 0;\n    padding: 0;\n    display: inline;\n}\n\n#ndq-content .search-result-tags .item-list {\n    display: inline;\n}\n\n#ndq-content .search-result-tags li {\n    margin: 0 2px 5px 0;\n    padding: 0;\n    list-style-type: none;\n    display: inline-block;\n    font-weight: normal;\n    color: #fff;\n}\n\n#ndq-content .search-result-tags li a {\n    background: #ddd;\n    padding: 2px 6px;\n    border-radius: 3px;\n    color: #333;\n}\n\n#ndq-content .search-result-tags li a:link,#ndq-content .search-result-tags li a:visited,#ndq-content .search-result-tags li a:hover,#ndq-content .search-result-tags li a:active {\n    color: #333;\n}\n\n#ndq-content .search-result .file a::before {\n    line-height: 26px;\n}\n\n#ndq-content .view-search .views-exposed-form label {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n#ndq-content .view-search .inline-asset {\n    display: inline-block;\n}\n\n#ndq-content .view-search .inline-asset .field__item {\n    margin: 0;\n    padding: 0;\n}\n\n#ndq-content .view-search .inline-asset .filesize {\n    display: none;\n}\n\n#ndq-content .view-search .inline-asset span.file--application-pdf::before {\n    content: \"î‚ˆ\";\n    display: inline-block;\n    text-decoration: none;\n    color: #c00;\n}\n\n#ndq-content .view-search .inline-asset span.file--application-pdf a {\n    display: none;\n}\n\n#ndq-content .view-search .inline-asset span.file--application-pdf a:hover {\n    text-decoration: none;\n}\n\n#ndq-content .view-search .inline-asset span.file--application-pdf::before {\n    padding: 0;\n}\n\n#ndq-content .search-result-snippet-wrapper p:first-child {\n    padding-top: 0;\n    margin-top: 0;\n}\n\n#ndq-content .nir-sec-header {\n    font-size: 14px;\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    float: left;\n    width: 100%;\n    background-color: #fff;\n    border-bottom: 1px dotted var(--border-color,#cbcbcd);\n    padding: 10px;\n    margin-bottom: 10px;\n}\n\n#ndq-content .nir-sec-header h1 {\n    color: black;\n    font-size: 1.5em;\n    font-weight: bold;\n    float: left;\n    line-height: 1.42857em;\n    margin: 0;\n    padding: 0;\n}\n\n#ndq-content .nir-sec-header .logo {\n    width: 30px;\n    float: left;\n    margin-right: 5px;\n}\n\n#ndq-content .nir-sec-header .logo img {\n    height: 30px;\n}\n\n#ndq-content .nir-sec-header .sec-docs {\n    float: right;\n}\n\n#ndq-content .nir-sec-header .file a {\n    font-size: 0px;\n    text-decoration: none;\n}\n\n#ndq-content .nir-sec-header .file a:hover {\n    text-decoration: none;\n}\n\n#ndq-content .menu,#ndq-content .side-menu {\n    margin: 0;\n    padding: 0;\n    line-height: 23.8px;\n}\n\n#ndq-content .menu__item,#ndq-content .side-menu__item,#ndq-content .side-menu__item {\n    list-style-type: none;\n}\n\n#ndq-content .menu__item.is-expanded,#ndq-content .menu__item--is-expanded,#ndq-content .side-menu__item.is-expanded,#ndq-content .side-menu__item--is-expanded,#ndq-content .is-expanded.side-menu__item,#ndq-content .side-menu__item.is-expanded {\n    list-style-type: none;\n}\n\n#ndq-content .menu__item.is-collapsed,#ndq-content .menu__item--is-collapsed,#ndq-content .side-menu__item.is-collapsed,#ndq-content .side-menu__item--is-collapsed,#ndq-content .is-collapsed.side-menu__item,#ndq-content .side-menu__item.is-collapsed {\n    list-style-type: none;\n}\n\n#ndq-content .menu__item .side-menu,#ndq-content .side-menu__item .side-menu,#ndq-content .side-menu__item .side-menu {\n    margin-bottom: 10px;\n}\n\n#ndq-content .menu__item .side-menu__item,#ndq-content .side-menu__item .side-menu__item,#ndq-content .side-menu__item .side-menu__item {\n    margin-left: 15px;\n    font-size: 0.8em;\n    line-height: 1.7em;\n}\n\n#ndq-content .menu__link.is-active,#ndq-content .menu__link--is-active,#ndq-content .side-menu__link.is-active,#ndq-content .side-menu__link--is-active,#ndq-content .menu a.active {\n    color: #000;\n}\n\n#ndq-content .skip-link {\n    display: block;\n    padding: 2px 0 3px;\n    text-align: center;\n}\n\n#ndq-content .skip-link:link,#ndq-content .skip-link:visited {\n    background-color: #666;\n    color: #fff;\n}\n\n#ndq-content .skip-link__wrapper {\n    margin: 0;\n}\n\n@media print {\n    #ndq-content .skip-link__wrapper {\n        display: none;\n    }\n}\n\n#ndq-content .block-jquery-social-media-tabs * {\n    box-sizing: content-box;\n}\n\n#ndq-content .sliding {\n    z-index: 1000;\n}\n\n#ndq-content .quote-wrap {\n    border: 1px solid var(--border-color,#cbcbcd);\n    float: left;\n    position: relative;\n    width: 100%;\n}\n\n#ndq-content .quote-wrap select {\n    color: #333;\n    position: absolute;\n    padding: 1px 5px;\n    appearance: menulist;\n    -moz-appearance: menulist;\n    -webkit-appearance: menulist;\n    top: 15px;\n    left: 10px;\n}\n\n#ndq-content [class^=\"stock-quote\"] {\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .stock-quote {\n    padding: 1em;\n    margin-bottom: 1em;\n}\n\n#ndq-content .stock-quote dd,#ndq-content .stock-quote dt {\n    margin: 0;\n    display: inline-block;\n}\n\n#ndq-content .stock-quote dd {\n    width: 60%;\n}\n\n#ndq-content .stock-quote dt {\n    width: 40%;\n}\n\n#ndq-content .stock-quote .left {\n    float: left;\n}\n\n#ndq-content .stock-quote .center {\n    float: left;\n}\n\n#ndq-content .stock-quote .right {\n    float: left;\n}\n\n#ndq-content .stock-quote time {\n    font-size: 0.75em;\n}\n\n#ndq-content .stock-quote__short select {\n    display: inline;\n}\n\n#ndq-content .stock-quote__featured .stock-quote {\n    margin-bottom: 0;\n}\n\n#ndq-content .stock-quote__featured time {\n    float: left;\n    margin-top: 0.5em;\n}\n\n#ndq-content .stock-quote__featured .quote-price {\n    margin-bottom: 1em;\n}\n\n#ndq-content .quote-price {\n    font-size: 2em;\n    line-height: 100%;\n}\n\n#ndq-content .price-down {\n    color: #d6353a;\n}\n\n#ndq-content .price-up {\n    color: #228260;\n}\n\n#ndq-content .user-toggle-on .stock-quote:nth-of-type(1) {\n    display: block;\n}\n\n#ndq-content .user-toggle-on .stock-quote,#ndq-content .user-toggle-on .exchange {\n    display: none;\n}\n\n#ndq-content .user-toggle-on .quote-price {\n    margin-top: 35px;\n}\n\n@media (max-width: 769px) {\n    #ndq-content .stock-quote {\n        padding-bottom:2em;\n        position: relative;\n    }\n}\n\n#ndq-content .stock-quote .left-stock {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .stock-quote .left-stock {\n        width:100%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content .stock-quote .left-stock {\n        width:24.05063%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n@media (max-width: 769px) {\n    #ndq-content .stock-quote .left-stock time {\n        position:absolute;\n        bottom: 0em;\n        left: 1em;\n    }\n}\n\n#ndq-content .stock-quote .center-stock {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .stock-quote .center-stock {\n        width:49.36709%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content .stock-quote .center-stock {\n        width:36.70886%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .stock-quote .right-stock {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .stock-quote .right-stock {\n        width:49.36709%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content .stock-quote .right-stock {\n        width:36.70886%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .table-drag__wrapper,#ndq-content body.drag {\n    cursor: move;\n}\n\n#ndq-content .table-drag__item,#ndq-content tr.drag {\n    background-color: #fffadb;\n}\n\n#ndq-content .table-drag__item-previous,#ndq-content tr.drag-previous {\n    background-color: #fff7c2;\n}\n\n#ndq-content .table-drag__handle,#ndq-content .tabledrag-handle {\n    cursor: move;\n    float: left;\n    height: 1.7em;\n    margin-left: -1em;\n    overflow: hidden;\n    text-decoration: none;\n}\n\n#ndq-content [dir=\"rtl\"] .table-drag__handle,#ndq-content [dir=\"rtl\"] .tabledrag-handle {\n    float: right;\n    margin-right: -1em;\n    margin-left: 0;\n}\n\n#ndq-content .table-drag__handle:focus,#ndq-content .table-drag__handle:hover,#ndq-content .tabledrag-handle:focus,#ndq-content .tabledrag-handle:hover {\n    text-decoration: none;\n}\n\n\n#ndq-content .table-drag__handle-icon--is-hover,#ndq-content .tabledrag-handle-hover .handle {\n    background-position: 6px -11px;\n}\n\n#ndq-content .table-drag__toggle-weight-wrapper,#ndq-content .tabledrag-toggle-weight-wrapper {\n    text-align: right;\n}\n\n#ndq-content [dir=\"rtl\"] .table-drag__toggle-weight-wrapper,#ndq-content [dir=\"rtl\"] .tabledrag-toggle-weight-wrapper {\n    text-align: left;\n}\n\n#ndq-content .table-drag__toggle-weight,#ndq-content .tabledrag-toggle-weight {\n    font-size: 0.9em;\n}\n\n#ndq-content .table-drag__indentation,#ndq-content .indentation {\n    float: left;\n    height: 1.7em;\n    margin: -0.4em 0.2em -0.4em -0.4em;\n    padding: .42em 0 .42em .6em;\n    width: 20px;\n}\n\n#ndq-content [dir=\"rtl\"] .table-drag__indentation,#ndq-content [dir=\"rtl\"] .indentation {\n    float: right;\n    margin: -0.4em -0.4em -0.4em 0.2em;\n    padding: 0.42em 0.6em 0.42em 0;\n}\n\n\n\n#ndq-content [dir=\"rtl\"] .table-drag__tree-child,#ndq-content [dir=\"rtl\"] .table-drag__tree-child-last,#ndq-content [dir=\"rtl\"] .tree-child-last,#ndq-content [dir=\"rtl\"] .table-drag__tree-child-horizontal,#ndq-content [dir=\"rtl\"] .tree-child-horizontal,#ndq-content [dir=\"rtl\"] .tree-child {\n    background-position: -65px center;\n}\n\n\n\n#ndq-content .table-drag__tree-child-horizontal,#ndq-content .tree-child-horizontal {\n    background-position: -11px center;\n}\n\n\n#ndq-content .clearfix:before,#ndq-content .tabs:before,#ndq-content .tabs--secondary:before,.block--local-tasks-block .tabs:before,.block--local-tasks-block .tabs--secondary:before,#ndq-content div[class*='view-widget-']:before,#ndq-content #nir-header:before {\n    content: '';\n    display: table;\n}\n\n#ndq-content .clearfix:after,#ndq-content .tabs:after,#ndq-content .tabs--secondary:after,.block--local-tasks-block .tabs:after,.block--local-tasks-block .tabs--secondary:after,#ndq-content div[class*='view-widget-']:after,#ndq-content #nir-header:after {\n    content: '';\n    display: table;\n    clear: both;\n}\n\n#ndq-content .tabs,#ndq-content .tabs--secondary,.block--local-tasks-block .tabs,.block--local-tasks-block .tabs--secondary {\n    background-image: -owg(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: -webkit(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: -moz(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: -o(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false);\n    margin: 1.42857em 0;\n    padding: 0 2px;\n    list-style: none !important;\n    list-style-type: none !important;\n    white-space: nowrap\n}\n\n@media print {\n    #ndq-content .tabs,#ndq-content .tabs--secondary,.block--local-tasks-block .tabs,.block--local-tasks-block .tabs--secondary {\n        display: none\n    }\n}\n\n#ndq-content .tabs__tab,.block--local-tasks-block .tabs__tab {\n    -moz-border-radius-topleft: 4px;\n    -webkit-border-top-left-radius: 4px;\n    border-top-left-radius: 4px;\n    -moz-border-radius-topright: 4px;\n    -webkit-border-top-right-radius: 4px;\n    border-top-right-radius: 4px;\n    text-shadow: compact(compact(1px 1px 0 false #fff),false,false,false,false,false,false,false,false,false);\n    float: left;\n    margin: 0 3px;\n    border: 1px solid #ddd;\n    border-bottom-color: transparent;\n    list-style-type: none;\n    border-bottom: 0 \\0/ie\n}\n\n[dir=\"rtl\"] #ndq-content .tabs__tab,[dir=\"rtl\"] .block--local-tasks-block .tabs__tab {\n    float: right\n}\n\n#ndq-content .tabs__tab.is-active,.block--local-tasks-block .tabs__tab.is-active {\n    border-bottom-color: #fff;\n}\n\n#ndq-content .tabs__tab-link-common,#ndq-content .tabs a,#ndq-content .tabs--secondary a,#ndq-content .tabs--secondary__tab-link,.block--local-tasks-block .tabs__tab-link-common,.block--local-tasks-block .tabs a,.block--local-tasks-block .tabs--secondary a,.block--local-tasks-block .tabs--secondary__tab-link {\n    border: 1px solid var(--border-color,#cbcbcd);\n    border-right: 0;\n    border-bottom: 0;\n    display: block;\n    text-decoration: none;\n}\n\n#ndq-content .tabs a,#ndq-content .tabs--secondary a,.block--local-tasks-block .tabs a,.block--local-tasks-block .tabs--secondary a {\n    -moz-border-radius-topleft: 4px;\n    -webkit-border-top-left-radius: 4px;\n    border-top-left-radius: 4px;\n    -moz-border-radius-topright: 4px;\n    -webkit-border-top-right-radius: 4px;\n    border-top-right-radius: 4px;\n    -webkit-transition: compact(compact(background-color 0.3s,false,false,false,false,false,false,false,false,false) false false);\n    -moz-transition: compact(compact(background-color 0.3s,false,false,false,false,false,false,false,false,false) false false false);\n    -o-transition: compact(compact(background-color 0.3s,false,false,false,false,false,false,false,false,false) false false false);\n    transition: compact(background-color 0.3s,false,false,false,false,false,false,false,false,false);\n    color: #000;\n    background-color: #ddd;\n    letter-spacing: 1px;\n    padding: 0 1em;\n    text-align: center;\n}\n\n#ndq-content .tabs a:focus,#ndq-content .tabs a:hover,#ndq-content .tabs--secondary a:focus,#ndq-content .tabs--secondary a:hover,.block--local-tasks-block .tabs a:focus,.block--local-tasks-block .tabs a:hover,.block--local-tasks-block .tabs--secondary a:focus,.block--local-tasks-block .tabs--secondary a:hover {\n    background-color: #eaeaea;\n    border-color: #f1f1f1;\n}\n\n\n\n#ndq-content .tabs--secondary,.block--local-tasks-block .tabs--secondary {\n    font-size: .9em;\n    background-image: none;\n}\n\n#ndq-content .tabs + .tabs--secondary,#ndq-content .tabs--secondary + .tabs--secondary,.block--local-tasks-block .tabs + .tabs--secondary,.block--local-tasks-block .tabs--secondary + .tabs--secondary {\n    background-image: -owg(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: -webkit(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: -moz(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: -o(compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false));\n    background-image: compact(linear-gradient(bottom,#ddd 1px,transparent 1px),false,false,false,false,false,false,false,false,false);\n    margin-top: -1.42857em;\n}\n\n#ndq-content .tabs--secondary__tab,.block--local-tasks-block .tabs--secondary__tab {\n    margin: 0.71429em 0.21429em;\n    float: left;\n}\n\n#ndq-content [dir=\"rtl\"] .tabs--secondary__tab,.block--local-tasks-block [dir=\"rtl\"] .tabs--secondary__tab {\n    float: right;\n}\n\n#ndq-content .tabs--secondary__tab-link,.block--local-tasks-block .tabs--secondary__tab-link {\n    -webkit-border-radius: 0.75em;\n    -moz-border-radius: 0.75em;\n    -ms-border-radius: 0.75em;\n    -o-border-radius: 0.75em;\n    border-radius: 0.75em;\n    -webkit-transition: compact(compact(background-color 0.3s,false,false,false,false,false,false,false,false,false) false false);\n    -moz-transition: compact(compact(background-color 0.3s,false,false,false,false,false,false,false,false,false) false false false);\n    -o-transition: compact(compact(background-color 0.3s,false,false,false,false,false,false,false,false,false) false false false);\n    transition: compact(background-color 0.3s,false,false,false,false,false,false,false,false,false);\n    text-shadow: compact(compact(1px 1px 0 false #fff),false,false,false,false,false,false,false,false,false);\n    color: #666;\n    background-color: #f1f1f1;\n    padding: 0 0.5em;\n}\n\n#ndq-content .tabs--secondary__tab-link:focus,#ndq-content .tabs--secondary__tab-link:hover,.block--local-tasks-block .tabs--secondary__tab-link:focus,.block--local-tasks-block .tabs--secondary__tab-link:hover {\n    color: #333;\n    background-color: #ddd;\n    border-color: #847271;\n}\n\n#ndq-content .tabs--secondary__tab-link.is-active,#ndq-content .tabs--secondary__tab-link--is-active,#ndq-content .tabs--secondary__tab-link:active,.block--local-tasks-block .tabs--secondary__tab-link.is-active,.block--local-tasks-block .tabs--secondary__tab-link--is-active,.block--local-tasks-block .tabs--secondary__tab-link:active {\n    text-shadow: compact(compact(1px 1px 0 false #333),false,false,false,false,false,false,false,false,false);\n    color: #fff;\n    background-color: #666;\n    border-color: #000;\n}\n\n#ndq-content .styled-tag {\n    background-color: #0480a9;\n    border-radius: 3px;\n    color: white;\n    float: left;\n    padding: 5px 10px;\n    margin: 0 2px 5px 0;\n}\n\n#ndq-content .styled-tag::before {\n    content: '#';\n}\n\n#ndq-content .styled-tag__small {\n    background-color: #ddd;\n    border-radius: 3px;\n    color: #333;\n    float: left;\n    font-size: 11px;\n    line-height: 15px;\n    padding: 2px 6px 4px 6px;\n    margin: 0 2px 5px 0;\n}\n\n#ndq-content .styled-tag__small a {\n    color: white;\n}\n\n#ndq-content .styled-tag a {\n    color: white;\n}\n\n#ndq-content .views-field-field-nir-tags a {\n    background-color: #ddd;\n    border-radius: 3px;\n    color: #333;\n    float: left;\n    font-size: 0.8em;\n    line-height: 1.33929em;\n    padding: 4px 6px 4px 6px;\n}\n\n#ndq-content .views-field-field-nir-tags .views-label {\n    float: left;\n}\n\n#ndq-content .field--name-field-nir-media-gallery-tags .field__label,#ndq-content .field--name-field-nir-multimedia-tags .field__label {\n    float: left;\n    font-size: 11px;\n    padding-right: 3px;\n}\n\n#ndq-content .field--name-field-nir-media-gallery-tags a,#ndq-content .field--name-field-nir-multimedia-tags a {\n    background-color: #ddd;\n    color: #333;\n}\n\n#ndq-content [role=\"tooltip\"] {\n    background: #0480a9;\n    filter: alpha(opacity=0);\n    -moz-opacity: 0;\n    -khtml-opacity: 0;\n    -webkit-opacity: 0;\n    opacity: 0;\n    font-weight: normal;\n    position: absolute;\n    margin-right: 20px;\n    left: 0px;\n    top: -1px;\n    color: #fff;\n    padding: 10px;\n    z-index: -1;\n    font-size: 12px;\n    -moz-border-radius: 3px;\n    -webkit-border-radius: 3px;\n    -khtml-border-radius: 3px;\n    border-radius: 3px;\n    max-width: 800px;\n}\n\n#ndq-content [role=\"tooltip\"]::after {\n    position: absolute;\n    bottom: -4px;\n    left: 20px;\n    margin: 0 auto;\n    content: '';\n    width: 0;\n    height: 0;\n    border-top: 4px solid #0480a9;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n}\n\n#ndq-content .tool-hide {\n    display: none;\n}\n\n#ndq-content .tool-show {\n    display: block;\n}\n\n#ndq-content .watermark {\n    display: block;\n    height: 0;\n    overflow: visible;\n    background-color: transparent;\n    color: #eee;\n    font-size: 75px;\n    line-height: 1;\n    font-family: Impact,\"Arial Narrow\",Helvetica,sans-serif;\n    font-weight: bold;\n    text-transform: uppercase;\n    text-align: center;\n    text-shadow: 0 0 1px rgba(0,0,0,0.1);\n    word-wrap: break-word;\n}\n\n#ndq-content .node--view-mode-nir-grid h3 {\n    color: #666;\n    font-size: 1.1em;\n}\n\n#ndq-content .node--view-mode-nir-grid img {\n    padding-right: 15px;\n}\n\n@media (max-width: 481px) {\n    #ndq-content .block-views-blockwidget-assets-widget-assets-grid .views-col {\n        width:100% !important;\n    }\n}\n\n#ndq-content .block-views-blockwidget-assets-widget-assets-ul img {\n    margin: 0 2% 2% 0;\n}\n\n#ndq-content .block-views-blockwidget-assets-widget-assets-ul .file a:hover {\n    text-decoration: underline;\n}\n\n#ndq-content div[class*='view-widget-'] .pager {\n    float: left;\n}\n\n#ndq-content div[class*='view-widget-'] .results-summary {\n    float: right;\n    padding: 10px 0;\n    margin: 1em 0;\n}\n\n#ndq-content .nir-widget .field--label-hidden h4 {\n    display: none;\n}\n\n#ndq-content .nir-widget .nir-widget--field {\n    margin: 10px 0px;\n}\n\n#ndq-content .nir-widget .nir-widgets--file-list--hide-filesize .filesize {\n    display: none;\n}\n\n#ndq-content .nir-widget .nir-widgets--file-list--hide-title a {\n    height: 0px;\n    overflow: hidden;\n    display: block;\n}\n\n#ndq-content .nir-widget .nir-widgets--file-list--hide-title a::before {\n    position: absolute;\n    margin-top: -10px;\n}\n\n#ndq-content .nir-widget .nir-widget--labeled-field .nir-widget--label,#ndq-content .nir-widget .nir-widget--labeled-field .nir-widget--field {\n    display: inline-block;\n}\n\n#ndq-content .striped-odd tbody tr:nth-child(odd) {\n    background-color: #f5fafa;\n}\n\n#ndq-content .striped-even tbody tr:nth-child(even) {\n    background-color: #f5fafa;\n}\n\n#ndq-content .fundamentals tr td:nth-child(2) {\n    text-align: right;\n}\n\n#ndq-content .earnings-estimates {\n    table-layout: auto;\n}\n\n#ndq-content .earnings-estimates tr td:not(:first-child) {\n    text-align: right;\n}\n\n#ndq-content .earnings-estimates caption {\n    text-align: right;\n    border-bottom: 0;\n    font-size: 1em;\n    padding: 15px;\n    margin: 0;\n    background-color: #666;\n    color: #fff;\n}\n\n@media (max-width: 769px) {\n    #ndq-content .earnings-estimates.estimates-analyst-forecasts thead tr:first-child {\n        display:none;\n    }\n}\n\n#ndq-content .earnings-estimates.estimates-analyst-forecasts thead td {\n    background-color: #666;\n    color: #fff;\n    font-weight: bold;\n    text-align: left;\n}\n\n#ndq-content .earnings-estimates.estimates-analyst-forecasts caption {\n    display: none;\n}\n\n#ndq-content .earnings-estimates th {\n    text-align: right;\n}\n\n#ndq-content .earnings-estimates th:first-child,#ndq-content .earnings-estimates th.caption {\n    text-align: left;\n}\n\n#ndq-content .block-widget-committee-composition table th a {\n    color: #fff;\n}\n\n#ndq-content .block-widget-committee-composition table tbody tr td {\n    text-align: center;\n}\n\n#ndq-content .block-widget-committee-composition table tbody tr td:first-child {\n    text-align: left;\n}\n\n#ndq-content .block-widget-committee-composition table tbody tr a::before {\n    content: none;\n}\n\n#ndq-content .block-widget-committee-composition table tbody tr span::before {\n    font-size: 20px;\n    padding-right: 0;\n}\n\n#ndq-content .commitee-key span::before {\n    font-size: 20px;\n    padding-right: 0;\n}\n\n#ndq-content .collapse-table {\n    border-collapse: collapse;\n}\n\n@media (max-width: 481px) {\n    #ndq-content .collapse-table th {\n        position:absolute !important;\n        height: 1px;\n        width: 1px;\n        overflow: hidden;\n        clip: rect(1px,1px,1px,1px);\n    }\n\n    #ndq-content .collapse-table tr {\n        border: 1px dotted var(--border-color,#cbcbcd);\n        margin-bottom: 25px;\n        display: block;\n        float: left;\n        width: 100%;\n    }\n\n    #ndq-content .collapse-table tbody tr td,#ndq-content .collapse-table tfoot tr td {\n        box-sizing: border-box;\n        float: left;\n        width: 100%;\n        text-align: left !important;\n    }\n\n    #ndq-content .collapse-table tbody tr td:empty,#ndq-content .collapse-table tfoot tr td:empty {\n        display: none;\n    }\n\n    #ndq-content .collapse-table tbody tr td::before,#ndq-content .collapse-table tfoot tr td::before {\n        content: attr(data-before);\n        font-weight: bold;\n        padding-bottom: 7px;\n        border-bottom: 1px dotted var(--border-color,#cbcbcd);\n        width: 100%;\n        float: left;\n        margin-bottom: 5px;\n    }\n\n    #ndq-content .collapse-table tbody tr td:first-child::before,#ndq-content .collapse-table tfoot tr td:first-child::before {\n        border-bottom: 0;\n    }\n\n    #ndq-content .collapse-table .table-indent {\n        padding-left: 15px;\n    }\n}\n\n#ndq-content .field--name-field-nir-committee-body {\n    float: left;\n}\n\n#ndq-content .commiteetable thead span {\n    display: none;\n}\n\n@media (max-width: 481px) {\n    #ndq-content .commiteetable td::before {\n        display:none;\n    }\n\n    #ndq-content .commiteetable tr {\n        border: 0;\n        margin-bottom: 0;\n    }\n\n    #ndq-content .commiteetable thead {\n        display: none;\n    }\n\n    #ndq-content .commiteetable thead span {\n        display: none;\n    }\n}\n\n#ndq-content .collapse-table-wide {\n    border-collapse: collapse;\n}\n\n#ndq-content .collapse-table-wide .desk-absolute {\n    position: absolute;\n}\n\n@media (max-width: 769px) {\n    #ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-rec-date,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-pay-date,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-dec-date,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-div-type,#ndq-content .collapse-table-wide .total-row .views-field-field-nir-split-numerator {\n        display:none;\n    }\n\n    #ndq-content .collapse-table-wide .desk-absolute {\n        position: relative;\n    }\n\n    #ndq-content .collapse-table-wide th {\n        position: absolute !important;\n        height: 1px;\n        width: 1px;\n        overflow: hidden;\n        clip: rect(1px,1px,1px,1px);\n    }\n\n    #ndq-content .collapse-table-wide tbody tr {\n        border-bottom: 1px solid var(--border-color,#cbcbcd);\n        margin-bottom: 25px;\n        display: block;\n        float: left;\n        width: 100%;\n    }\n\n    #ndq-content .collapse-table-wide caption {\n        background-color: transparent;\n        color: #333;\n        text-align: left;\n        padding-left: 0;\n    }\n\n    #ndq-content .collapse-table-wide tbody tr td,#ndq-content .collapse-table-wide tfoot tr td {\n        box-sizing: border-box;\n        float: left;\n        width: 100%;\n        text-align: left !important;\n        position: relative;\n        padding-left: 60%;\n        white-space: normal;\n        text-align: left;\n    }\n\n    #ndq-content .collapse-table-wide tbody tr td:empty,#ndq-content .collapse-table-wide tfoot tr td:empty {\n        display: none;\n    }\n\n    #ndq-content .collapse-table-wide tbody tr td::before,#ndq-content .collapse-table-wide tfoot tr td::before {\n        content: attr(data-before);\n        font-weight: bold;\n        padding: 0 10px 7px 0;\n        margin-bottom: 5px;\n        position: absolute;\n        left: 6px;\n        width: 55%;\n        vertical-align: middle;\n        white-space: nowrap;\n        text-align: left;\n    }\n\n    #ndq-content .collapse-table-wide tbody tr td:first-child::before,#ndq-content .collapse-table-wide tfoot tr td:first-child::before {\n        border-bottom: 0;\n    }\n\n    #ndq-content .collapse-table-wide .table-indent {\n        padding-left: 15px;\n    }\n}\n\n#ndq-content .mobile-show {\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px,1px,1px,1px);\n}\n\n@media (max-width: 481px) {\n    #ndq-content .mobile-show {\n        position:static !important;\n        clip: auto;\n        height: auto;\n        width: auto;\n        overflow: auto;\n    }\n}\n\n#ndq-content td.views-field-field-nir-asset-source {\n    color: #333;\n}\n\n#ndq-content .ndq-source p {\n    font-size: 12px;\n}\n\n#ndq-content .table-indent {\n    padding-left: 30px;\n}\n\n#ndq-content tr.detail-level-1 {\n    font-weight: bold;\n}\n\n#ndq-content table.cash-flow td,#ndq-content table.income-statment td {\n    text-align: right;\n}\n\n#ndq-content table.cash-flow td:first-child,#ndq-content table.income-statment td:first-child {\n    text-align: left;\n}\n\n#ndq-content table.cash-flow th,#ndq-content table.income-statment th {\n    text-align: right;\n}\n\n#ndq-content table.historical-lookup td:nth-child(n+2),#ndq-content table.historical-lookup th:nth-child(n+2),#ndq-content table.ownership td:nth-child(n+2),#ndq-content table.ownership th:nth-child(n+2) {\n    text-align: right;\n}\n\n#ndq-content table.historical-lookup tr:first-child {\n    font-weight: bold;\n}\n\n@media (max-width: 769px) {\n    #ndq-content table.estimates-reference-information tr {\n        margin-bottom:0;\n    }\n\n    #ndq-content table.estimates-reference-information td:first-child {\n        padding-left: 10px;\n        width: 60%;\n    }\n\n    #ndq-content table.estimates-reference-information td:last-child {\n        padding-left: 0;\n        width: 40%;\n        float: right;\n    }\n}\n\n#ndq-content #block-facetbreadbox.block-facet-select-breadbox {\n    background-color: #ddd;\n    padding: 10px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n#ndq-content #block-facetbreadbox.block-facet-select-breadbox h2 {\n    display: inline-block;\n    font-size: 14px;\n    line-height: 1.42857;\n    margin: 0;\n    border-bottom: 0;\n}\n\n#ndq-content #block-facetbreadbox.block-facet-select-breadbox a {\n    font-size: 11px;\n    margin-left: 5px;\n}\n\n#ndq-content #block-facetbreadbox.block-facet-select-breadbox ul {\n    padding: 0;\n    margin: 0;\n}\n\n#ndq-content #block-facetbreadbox.block-facet-select-breadbox ul li {\n    margin: 0.4em 0 0.4em 2em;\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-thumbnail {\n    float: left;\n    margin-right: 10px;\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-thumbnail {\n        width:30.37975%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-body,#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content,#ndq-content .view-widget-bundled-content .views-field-field-nir-tags {\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-body,#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content,#ndq-content .view-widget-bundled-content .views-field-field-nir-tags {\n        width:68.35443%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-tags {\n    font-size: 11px;\n    line-height: 16px;\n    margin-top: 1.5em;\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-tags .views-label {\n    margin: 0 10px 0 0px;\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content {\n    float: left;\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content ul {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content ul div {\n    margin: 0;\n    line-height: 1;\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-content .webcast-link {\n    font-weight: normal;\n}\n\n#ndq-content .view-widget-bundled-content .views-field-field-nir-bundle-body p {\n    margin-top: 0;\n}\n\n#ndq-content .acc-title,#ndq-content .view-grouping,#ndq-content .acc-body {\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .acc-body {\n    margin-top: 1em;\n    margin-bottom: 15px;\n}\n\n#ndq-content .block-views-blockwidget-bundled-content-block-1 {\n    position: relative;\n}\n\n#ndq-content .block-views-blockwidget-bundled-content-block-1 .show-all {\n    margin-top: 0;\n}\n\n#ndq-content .button,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button,#ndq-content button,#ndq-content [type=\"button\"],#ndq-content [type=\"reset\"],#ndq-content [type=\"submit\"],#ndq-content .market-data-filter-form input {\n    -webkit-appearance: button;\n    -moz-appearance: button;\n    appearance: button;\n    display: inline-block;\n    text-decoration: none;\n    color: #fff;\n    padding: 10px 15px;\n    margin: 5px 0 0 0;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    background-image: none;\n    background-color: #0480a9;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1.42857143;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-transition: all 1s ease;\n    -moz-transition: all 1s ease;\n    -ms-transition: all 1s ease;\n    -o-transition: all 1s ease;\n    transition: all 1s ease;\n}\n\n#ndq-content .button:hover,#ndq-content .button:focus,#ndq-content .button:active,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:hover,#ndq-content button:hover,#ndq-content [type=\"button\"]:hover,#ndq-content [type=\"reset\"]:hover,#ndq-content [type=\"submit\"]:hover,#ndq-content .market-data-filter-form input:hover,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:focus,#ndq-content button:focus,#ndq-content [type=\"button\"]:focus,#ndq-content [type=\"reset\"]:focus,#ndq-content [type=\"submit\"]:focus,#ndq-content .market-data-filter-form input:focus,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane .ui-button:active,#ndq-content button:active,#ndq-content [type=\"button\"]:active,#ndq-content [type=\"reset\"]:active,#ndq-content [type=\"submit\"]:active,#ndq-content .market-data-filter-form input:active {\n    background-color: #0184A2;\n    text-decoration: none;\n    color: #fff;\n}\n\n#ndq-content .button[disabled],#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button,#ndq-content button[disabled],#ndq-content [disabled][type=\"button\"],#ndq-content [disabled][type=\"reset\"],#ndq-content [disabled][type=\"submit\"],#ndq-content .market-data-filter-form input[disabled] {\n    cursor: default;\n    color: #847271;\n}\n\n#ndq-content .button[disabled]:hover,#ndq-content .button[disabled]:focus,#ndq-content .button[disabled]:active,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button:hover,#ndq-content button[disabled]:hover,#ndq-content [disabled][type=\"button\"]:hover,#ndq-content [disabled][type=\"reset\"]:hover,#ndq-content [disabled][type=\"submit\"]:hover,#ndq-content .market-data-filter-form input[disabled]:hover,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button:focus,#ndq-content button[disabled]:focus,#ndq-content [disabled][type=\"button\"]:focus,#ndq-content [disabled][type=\"reset\"]:focus,#ndq-content [disabled][type=\"submit\"]:focus,#ndq-content .market-data-filter-form input[disabled]:focus,#ndq-content .ui-dialog .ui-widget-content.ui-dialog-buttonpane [disabled].ui-button:active,#ndq-content button[disabled]:active,#ndq-content [disabled][type=\"button\"]:active,#ndq-content [disabled][type=\"reset\"]:active,#ndq-content [disabled][type=\"submit\"]:active,#ndq-content .market-data-filter-form input[disabled]:active {\n    color: #847271;\n}\n\n#ndq-content ul.no-list-style,#ndq-content .view-widget-assets .item-list ul,#ndq-content .view-widget-people .item-list > ul,#ndq-content .view-widget-events .item-list ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n#ndq-content .field--name-field-nir-asset-source {\n    margin: 1em 0;\n    font-size: 12px;\n}\n\n#ndq-content .field--name-field-nir-asset-source .field__label {\n    font-weight: bold;\n}\n\n#ndq-content .view-widget-assets .item-list ul {\n    margin: 0;\n}\n\n#ndq-content .view-widget-assets .item-list ul li {\n    border-bottom: 1px solid #eee;\n    float: left;\n    margin: 10px 0;\n    padding-bottom: 15px;\n    width: 100%;\n}\n\n#ndq-content .view-widget-assets table td {\n    vertical-align: top;\n}\n\n#ndq-content .view-widget-assets table td h4 {\n    margin: 0 0 8px 0;\n}\n\n#ndq-content .view-widget-assets table .field--name-field-nir-ext-document a,#ndq-content .view-widget-assets table .field--name-field-nir-document a {\n    line-height: 30px;\n}\n\n#ndq-content .view-widget-assets table .item-list ul {\n    margin: 5px 0;\n}\n\n#ndq-content .view-widget-assets table .item-list ul li {\n    border: 0;\n    margin: 0;\n    padding: 0;\n}\n\n#ndq-content .view-widget-assets table .field__label {\n    display: none;\n}\n\n#ndq-content .view-widget-assets table tbody .views-field-field-nir-asset-date {\n    font-style: italic;\n    color: #847271;\n    font-size: 12px;\n}\n\n@media (max-width: 481px) {\n    #ndq-content .view-widget-assets table tbody .views-field-field-nir-asset-date {\n        font-style:normal;\n        font-size: 14px;\n        color: #333;\n    }\n\n    #ndq-content .view-widget-assets table tbody .views-field-field-nir-asset-date time {\n        font-size: 12px;\n    }\n}\n\n#ndq-content .view-widget-assets .views-col {\n    padding: 1%;\n}\n\n#ndq-content .view-widget-assets .views-col article {\n    border: 1px solid #847271;\n    float: left;\n    padding: 4%;\n    width: 100%;\n}\n\n#ndq-content .view-widget-assets .views-col h3 {\n    margin: 0;\n}\n\n#ndq-content .view-widget-sec-filings table th a {\n    color: white;\n}\n\n#ndq-content .view-widget-sec-filings table td {\n    vertical-align: top;\n}\n\n#ndq-content .view-widget-sec-filings table td p {\n    margin: 0;\n}\n\n#ndq-content .view-widget-sec-filings .html-link,#ndq-content .view-widget-sec-filings .file-link {\n    float: left;\n}\n\n#ndq-content .view-widget-sec-filings .html-link .filesize,#ndq-content .view-widget-sec-filings .file-link .filesize {\n    display: none;\n}\n\n#ndq-content .view-widget-sec-filings .html-link a,#ndq-content .view-widget-sec-filings .file-link a {\n    font-size: 0;\n}\n\n#ndq-content .view-widget-sec-filings .html-link a::before,#ndq-content .view-widget-sec-filings .file-link a::before {\n    font-size: 30px;\n    line-height: 1em;\n}\n\n#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf .filesize {\n    display: none;\n}\n\n#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf .file--mime-application-xml a:before,#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf .file--mime-application-xsd a:before {\n    content: \"\\e07d\";\n    color: #7b41bd;\n}\n\n#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf a {\n    font-size: 0;\n}\n\n#ndq-content .view-widget-sec-filings .views-field-field-nir-sec-pdf a::before {\n    font-size: 30px;\n    line-height: 1em;\n}\n\n#ndq-content .field--name-field-nir-asset-source,#ndq-content .asset-date {\n    color: #847271;\n    font-style: italic;\n}\n\n#ndq-content .asset-date {\n    font-size: 12px;\n}\n\n#ndq-content .nir-docs {\n    margin: 20px 0;\n}\n\n#ndq-content .nir-docs a {\n    line-height: 30px;\n}\n\n#ndq-content .nir-docs a:hover,#ndq-content .nir-docs a:focus {\n    text-decoration: none;\n}\n\n#ndq-content .field--name-field-nir-ext-document,#ndq-content .field--name-field-nir-document,#ndq-content .field--name-field-nir-ext-document {\n    font-weight: bold;\n}\n\n#ndq-content .asset-link {\n    font-size: 14px;\n    font-weight: bold;\n    margin: 1em 0;\n}\n\n#ndq-content .view-empty {\n    margin: 1em 0;\n}\n\n#ndq-content .filesize {\n    font-style: italic;\n    font-weight: normal;\n    color: #847271;\n}\n\n#ndq-content .file-link .file {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n#ndq-content .view-widget-people .item-list > ul > li {\n    border-bottom: 1px solid var(--border-color,#cbcbcd);\n    float: left;\n    margin: 10px 0;\n    padding-bottom: 15px;\n    width: 100%;\n}\n\n#ndq-content .block-views-blockwidget-people-widget-assets-ul {\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list {\n    margin-bottom: 2em;\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list ul li {\n    float: left;\n    width: 100%;\n    border-bottom: 1px dotted var(--border-color,#cbcbcd);\n    list-style-type: none;\n    padding: 2em 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .item-list ul li:first-child {\n    border-top: 1px dotted var(--border-color,#cbcbcd);\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-teaser .field-content {\n    margin: 1em 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-teaser p {\n    margin: 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-title h3 {\n    margin: 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-date {\n    width: 100%;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .field--name-field-nir-document {\n    font-weight: normal;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .field--name-field-nir-document .field__item {\n    margin-top: 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-title,#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-title {\n    font-weight: bold;\n    font-size: 16px;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .field--name-field-nir-tags .field__label {\n    font-size: 11px;\n    float: left;\n    margin-right: 0.5em;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-thumbnail {\n    float: left;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .views-field-field-nir-news-thumbnail img {\n    border-left: 8px solid #0480a9;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .col {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(1) {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n@media (min-width: 1024px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(1) {\n        width:62.02532%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(2) {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 20px;\n}\n\n@media (min-width: 769px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(2) {\n        width:81.01266%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 1024px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-news-supp .col:nth-child(2) {\n        width:36.70886%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail .col:nth-child(1) {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n@media (min-width: 769px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail .col:nth-child(1) {\n        width:17.72152%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n@media (min-width: 769px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail .col:nth-child(2) {\n        width:81.01266%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(1) {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n@media (min-width: 769px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(1) {\n        width:17.72152%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(2) {\n    margin-top: 0;\n}\n\n@media (min-width: 769px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(2) {\n        width:81.01266%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 1024px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(2) {\n        width:43.03797%;\n        float: left;\n        margin-right: 1.26582%;\n    }\n}\n\n#ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(3) {\n    width: 100%;\n    float: left;\n    margin-left: 0;\n    margin-right: 0;\n    margin-top: 20px;\n}\n\n@media (min-width: 769px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(3) {\n        width:81.01266%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 1024px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .col:nth-child(3) {\n        width:36.70886%;\n        float: right;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 1024px) {\n    #ndq-content .view-widget-news.view-display-id-widget_news_ul .has-thumbnail.has-news-supp .views-field-field-nir-news-title {\n        margin-bottom:5px;\n    }\n}\n\n#ndq-content .view-widget-news.view-display-id-table .field--name-field-nir-document .field__item {\n    margin-top: 0px;\n    margin-bottom: 0px;\n}\n\n#ndq-content .view-widget-news.view-display-id-table .html-link,#ndq-content .view-widget-news.view-display-id-table .file-link {\n    float: left;\n}\n\n#ndq-content .view-widget-news.view-display-id-table .html-link .filesize,#ndq-content .view-widget-news.view-display-id-table .file-link .filesize {\n    display: none;\n}\n\n#ndq-content .view-widget-news.view-display-id-table .html-link a,#ndq-content .view-widget-news.view-display-id-table .file-link a {\n    font-size: 0;\n}\n\n#ndq-content .view-widget-news.view-display-id-table .html-link a::before,#ndq-content .view-widget-news.view-display-id-table .file-link a::before {\n    font-size: 30px;\n    line-height: 1em;\n}\n\n#ndq-content .view-widget-news.view-display-id-table table {\n    table-layout: initial;\n}\n\n#ndq-content .view-widget-news.view-display-id-table table td {\n    vertical-align: top;\n}\n\n#ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-date {\n    width: 200px;\n}\n\n@media screen and (max-width: 480px) {\n    #ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-date {\n        width:initial;\n    }\n}\n\n#ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-supp-format {\n    width: 180px;\n}\n\n@media screen and (max-width: 480px) {\n    #ndq-content .view-widget-news.view-display-id-table table td.views-field-field-nir-news-supp-format {\n        width:initial;\n    }\n}\n\n#ndq-content .block-views {\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .view-widget-events .item-list ul li {\n    border-bottom: 1px solid var(--border-color,#cbcbcd);\n    float: left;\n    margin: 10px 0;\n    padding-bottom: 15px;\n    width: 100%;\n}\n\n#ndq-content .view-widget-events .field--name-field-nir-event-thumbnail img {\n    padding-right: 0;\n}\n\n#ndq-content .view-widget-events h3 {\n    margin-top: 0;\n    font-size: 16px;\n}\n\n#ndq-content .view-widget-events .field--name-field-nir-event-summary {\n    margin-bottom: 1em;\n}\n\n#ndq-content .view-widget-events .two-col-half:empty {\n    display: none;\n}\n\n#ndq-content .view-widget-events .full-width {\n    float: none;\n    clear: both;\n}\n\n#ndq-content .view-widget-events .full-width > div {\n    margin-top: 1em;\n}\n\n#ndq-content .view-widget-events .left-half,#ndq-content .view-widget-events .right-half {\n    margin-bottom: 1em;\n}\n\n#ndq-content .view-widget-events .webcast-link {\n    margin-top: 0;\n}\n\n#ndq-content .view-widget-events.view-display-id-table table {\n    table-layout: initial;\n}\n\n#ndq-content .view-widget-events.view-display-id-table table td {\n    vertical-align: top;\n}\n\n#ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-start-date {\n    width: 200px;\n}\n\n@media screen and (max-width: 480px) {\n    #ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-start-date {\n        width:initial;\n    }\n}\n\n#ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-add-calender {\n    width: 130px;\n}\n\n@media screen and (max-width: 480px) {\n    #ndq-content .view-widget-events.view-display-id-table table td.views-field-field-nir-event-add-calender {\n        width:initial;\n    }\n}\n\n#ndq-content .view-nir-media-gallery-items-grid .views-row {\n    margin-bottom: 30px;\n}\n\n#ndq-content .view-nir-media-gallery-items-grid .views-row h2 {\n    border-bottom: 0;\n    margin: 0;\n}\n\n#ndq-content .view-nir-media-gallery-items-grid form.views-exposed-form .form-actions {\n    margin: 0;\n}\n\n#ndq-content .view-nir-media-gallery-items-grid form.views-exposed-form .form-item {\n    margin: 6px 0 16px 0;\n}\n\n#ndq-content .view-nir-media-gallery-items-grid form.views-exposed-form input {\n    display: none;\n}\n\n#ndq-content .gallery-title {\n    padding: 5px 0;\n    margin-bottom: 20px;\n}\n\n#ndq-content .view-nir-media-galleries-widget-grid .view-footer {\n    margin: 1em 0;\n    width: 100%;\n    float: left;\n    text-align: left;\n    padding: 25px 0;\n}\n\n#ndq-content .view-nir-media-galleries-widget-grid .pager {\n    margin: 1em 0;\n    width: 100%;\n    float: left;\n    text-align: left;\n}\n\n@media (min-width: 480px) {\n    #ndq-content .view-nir-media-galleries-widget-grid .view-footer {\n        width:50%;\n        float: right;\n        text-align: right;\n    }\n\n    #ndq-content .view-nir-media-galleries-widget-grid .pager {\n        width: 50%;\n        float: left;\n        text-align: left;\n    }\n}\n\n#ndq-content .faq-dl {\n    counter-reset: faq-counter;\n}\n\n#ndq-content .faq-dl dt:before {\n    content: counter(faq-counter) \".\";\n    counter-increment: faq-counter;\n    padding-right: 0.75em;\n    padding-left: 0.5em;\n}\n\n#ndq-content .faq-dl dt {\n    margin: 1.4em 0 1em 0;\n    font-weight: bold;\n}\n\n#ndq-content .faq-dl dd {\n    margin: 1em 0;\n    padding-left: 2.1em;\n}\n\n#ndq-content .faq-dl .top-link {\n    padding-left: 2.1em;\n}\n\n#ndq-content .faq-acc-dl dt,#ndq-content .faq-acc-dl .acc-title,#ndq-content .acc-wrap dt,#ndq-content .acc-wrap .acc-title {\n    cursor: pointer;\n    line-height: 1.5em;\n    border-radius: 3px;\n    background: #666;\n    color: #fff;\n    border-bottom: 1px solid white;\n    padding: 15px;\n    -webkit-transition: all 1s ease;\n    -moz-transition: all 1s ease;\n    -ms-transition: all 1s ease;\n    -o-transition: all 1s ease;\n    transition: all 1s ease;\n}\n\n#ndq-content .faq-acc-dl dt:hover,#ndq-content .faq-acc-dl .acc-title:hover,#ndq-content .acc-wrap dt:hover,#ndq-content .acc-wrap .acc-title:hover {\n    background-color: #0480a9;\n}\n\n#ndq-content .faq-acc-dl dt.opened,#ndq-content .faq-acc-dl .acc-title.opened,#ndq-content .acc-wrap dt.opened,#ndq-content .acc-wrap .acc-title.opened {\n    background-color: #0480a9;\n}\n\n#ndq-content .faq-acc-dl dd,#ndq-content .acc-wrap dd {\n    margin: 1em 0;\n}\n\n#ndq-content .show-all {\n    float: left;\n    text-align: right;\n    width: 100%;\n    margin-top: -25px;\n}\n\n#ndq-content .view-grouping {\n    margin-bottom: 1em;\n}\n\n#ndq-content .form-table__sticky-header,#ndq-content .sticky-header {\n    position: fixed;\n    visibility: hidden;\n    margin-top: 0;\n    background-color: #fff;\n}\n\n#ndq-content .form-table__sticky-header.is-sticky,#ndq-content .form-table__sticky-header--is-sticky,#ndq-content .is-sticky.sticky-header {\n    visibility: visible;\n}\n\n#ndq-content .form-table__header,#ndq-content .form-table th,#ndq-content form table th {\n    border-bottom: 3px solid var(--border-color,#cbcbcd);\n    padding-right: 1em;\n    text-align: left;\n}\n\n#ndq-content [dir=\"rtl\"] .form-table__header,#ndq-content [dir=\"rtl\"] .form-table th,#ndq-content .form-table [dir=\"rtl\"] th,#ndq-content [dir=\"rtl\"] form table th,#ndq-content form table [dir=\"rtl\"] th {\n    text-align: right;\n    padding-left: 1em;\n    padding-right: 0;\n}\n\n#ndq-content .form-table__body,#ndq-content .form-table tbody,#ndq-content form table tbody {\n    border-top: 1px solid var(--border-color,#cbcbcd);\n}\n\n#ndq-content .form-table__row,#ndq-content .form-table tbody tr,#ndq-content form table tbody tr {\n    padding: .1em .6em;\n    border-bottom: 1px solid var(--border-color,#cbcbcd);\n    background-color: #eee;\n}\n\n#ndq-content .form-table__row-even,#ndq-content .form-table tbody tr:nth-child(even),#ndq-content form table tbody tr:nth-child(even) {\n    background-color: #fff;\n}\n\n#ndq-content .form-table__list,#ndq-content .form-table ul,#ndq-content form table ul {\n    margin: 0;\n}\n\n#ndq-content .form-table__narrow-column,#ndq-content .form-table th.form-table__narrow-column,#ndq-content form table th.form-table__narrow-column,#ndq-content td .checkbox,#ndq-content th .checkbox {\n    width: -moz-min-content;\n    width: -webkit-min-content;\n    text-align: center;\n}\n\n#ndq-content td.active {\n    background-color: #ddd;\n}\n\n#ndq-content td.menu-disabled {\n    background: #ddd;\n}\n\n#ndq-content tr.selected td {\n    background: #fffadb;\n}\n\n#ndq-content #nir-header__logo {\n    float: left;\n    margin: 0 10px 0 0;\n    padding: 0;\n}\n\n#ndq-content [dir=\"rtl\"] #nir-header__logo {\n    float: right;\n    margin: 0 0 0 10px;\n}\n\n#ndq-content #nir-header__logo-image {\n    vertical-align: bottom;\n}\n\n#ndq-content #nir-header__name-and-slogan {\n    float: left;\n}\n\n#ndq-content #nir-header__site-name {\n    margin: 0;\n}\n\n#ndq-content #nir-header__site-link:link,#ndq-content #nir-header__site-link:visited {\n    color: #000;\n    text-decoration: none;\n}\n\n#ndq-content #nir-header__site-link:hover,#ndq-content #nir-header__site-link:focus {\n    text-decoration: underline;\n}\n\n#ndq-content #nir-header__site-slogan {\n    margin: 0;\n}\n\n#ndq-content #nir-header__secondary-menu {\n    float: right;\n}\n\n#ndq-content [dir=\"rtl\"] #nir-header__secondary-menu {\n    float: left;\n}\n\n#ndq-content #nir-header__region {\n    clear: both;\n}\n\n#ndq-content .messages,#ndq-content .messages--status,#ndq-content .messages--warning,#ndq-content .messages.warning,#ndq-content .messages--error,#ndq-content .messages.error {\n    margin: 1.42857em 0;\n    position: relative;\n    padding: 10px 10px 10px 44px;\n    border: 1px solid #0480a9;\n    width: 100%;\n    float: left;\n}\n\n#ndq-content [dir=\"rtl\"] .messages,#ndq-content [dir=\"rtl\"] .messages--status,#ndq-content [dir=\"rtl\"] .messages--warning,#ndq-content [dir=\"rtl\"] .messages.warning,#ndq-content [dir=\"rtl\"] .messages--error,#ndq-content [dir=\"rtl\"] .messages.error {\n    padding: 10px 44px 10px 10px;\n    background-position: 99% 8px;\n}\n\n#ndq-content .messages__icon {\n    position: absolute;\n    top: 50%;\n    left: 10px;\n    height: 24px;\n    width: 24px;\n    margin-top: -12px;\n    line-height: 1;\n}\n\n#ndq-content [dir=\"rtl\"] .messages__icon {\n    left: auto;\n    right: 0;\n}\n\n#ndq-content .messages__icon path {\n    fill: #0480a9;\n}\n\n#ndq-content .messages__list {\n    margin: 0;\n}\n\n#ndq-content .messages__item {\n    list-style-image: none;\n}\n\n#ndq-content .messages--ok-color,#ndq-content .messages,#ndq-content .messages--status,#ndq-content .messages--warning,#ndq-content .messages.warning,#ndq-content .messages--error,#ndq-content .messages.error,#ndq-content .ok,#ndq-content .revision-current {\n    background-color: #fff;\n    color: #0480a9;\n}\n\n#ndq-content .messages--warning-color,#ndq-content .messages--warning,#ndq-content .messages.warning,#ndq-content .warning {\n    background-color: #fffce6;\n    color: #000;\n}\n\n#ndq-content .messages--error-color,#ndq-content .messages--error,#ndq-content .messages.error,#ndq-content .error {\n    background-color: #fff0f0;\n    color: #c00;\n}\n\n#ndq-content .messages--warning,#ndq-content .messages.warning {\n    border-color: #fd0;\n}\n\n#ndq-content .messages--warning path,#ndq-content .messages.warning path {\n    fill: #fd0;\n}\n\n#ndq-content .messages--error,#ndq-content .messages.error {\n    border-color: #c00;\n}\n\n#ndq-content .messages--error path,#ndq-content .messages.error path {\n    fill: #c00;\n}\n\n#ndq-content .messages--error__highlighted-text,#ndq-content .messages--error .error,#ndq-content .messages.error .error {\n    color: #000;\n}\n\n@media print {\n    #ndq-content .print-none,#ndq-content .toolbar,#ndq-content .action-links,#ndq-content .links,#ndq-content .book-navigation,#ndq-content .forum-topic-navigation,#ndq-content .feed-icons {\n        display: none;\n    }\n}\n\n#ndq-content .sidebars .block {\n    margin: 10px 0;\n    padding: 10px 0;\n}\n\n#ndq-content #content .block-system-main-block {\n    margin: 10px 0;\n    clear: both;\n}\n\n#ndq-content .node--type-person h3 {\n    margin-top: 0;\n}\n\n#ndq-content .node--type-person .field--name-field-nir-person-company {\n    margin-bottom: 1em;\n}\n\n#ndq-content .node--type-person .field--name-field-nir-person-dir-details {\n    margin-top: 1em;\n}\n\n#ndq-content .node--type-person .field--name-field-nir-person-dir-details .field-item {\n    margin-bottom: 5px;\n}\n\n#ndq-content .centered-header {\n    border-bottom: 1px solid #847271;\n    margin-bottom: 10px;\n    width: 100%;\n    float: right;\n    margin-right: 0;\n}\n\n#ndq-content .centered-header .field--name-field-nir-committee-charter-date {\n    font-weight: bold;\n    font-size: smaller;\n}\n\n#ndq-content .centered-header .field--name-field-nir-committee-document,#ndq-content .centered-header .field--name-field-nir-asset,#ndq-content .centered-header .field--name-field-nir-committee-link {\n    text-align: right;\n}\n\n#ndq-content .centered-header .field--name-field-nir-committee-document span a::before,#ndq-content .centered-header .field--name-field-nir-asset span a::before,#ndq-content .centered-header .field--name-field-nir-committee-link span a::before {\n    font-size: 20px;\n}\n\n#ndq-content .centered-header .field--name-field-nir-asset a {\n    font-weight: normal;\n}\n\n#ndq-content .field--name-field-nir-committee-link a::before {\n    content: \"î·\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .field--name-field-nir-committee-member {\n    border-top: 1px solid #847271;\n    border-bottom: 1px solid #847271;\n    float: left;\n    width: 100%;\n    padding: 8px 0;\n    margin: 10px 0 0;\n}\n\n#ndq-content .field--name-field-nir-committee-member span::before {\n    font-size: 20px;\n    padding-right: 0;\n}\n\n#ndq-content .commitee_member {\n    border-right: 1px solid var(--border-color,#cbcbcd);\n    padding-right: 5px;\n    margin-right: 5px;\n}\n\n#ndq-content .commitee_member:last-child {\n    border-right: 0;\n}\n\n#ndq-content .commitee_member span::before {\n    font-size: 20px;\n    padding-right: 0;\n}\n\n#ndq-content .add-event {\n    margin-bottom: 15px;\n}\n\n#ndq-content .field--name-field-nir-event-thumbnail img {\n    border-left: 8px solid #0480a9;\n    padding-right: 15px;\n}\n\n#ndq-content .field--name-field-nir-person-company {\n    font-style: italic;\n}\n\n#ndq-content .node--view-mode-full .field--name-field-nir-event-summary {\n    font-weight: bold;\n    color: #666;\n}\n\n#ndq-content .node--view-mode-full .field--name-field-nir-event-summary p:first-child {\n    margin-top: 0;\n}\n\n#ndq-content .node--type-nir-event .node--type-nir-asset .field--name-field-nir-document .field__item,#ndq-content .node--type-nir-event .node--type-nir-asset .field--name-field-nir-ext-document .field__item {\n    margin: 1em 0;\n}\n\n#ndq-content .node--type-nir-event h4 {\n    margin: 0 0 5px 0;\n}\n\n#ndq-content .node--type-nir-event .field--label-inline .field__label::after {\n    content: '';\n}\n\n#ndq-content .node--type-nir-event .field--name-field-nir-event-speaker-name {\n    font-weight: bold;\n    font-style: italic;\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .node--type-nir-event .field--name-field-nir-event-speaker-co {\n    float: left;\n}\n\n#ndq-content .node--type-nir-event p.address {\n    margin: 0;\n}\n\n#ndq-content .node--type-nir-event .location-info {\n    font-style: italic;\n    color: #666;\n}\n\n#ndq-content .node--type-nir-event .field--name-field-nir-event-loc-desc p,#ndq-content .node--type-nir-event .field--name-field-nir-event-rep-dial-notes p {\n    margin: 0;\n}\n\n#ndq-content .node--type-nir-event .field__item > p {\n    margin: 0;\n}\n\n#ndq-content .webcast-link {\n    font-weight: bold;\n    margin: 1em 0;\n}\n\n#ndq-content .speaker-name {\n    font-weight: bold;\n    font-style: italic;\n}\n\n#ndq-content .speaker-title .field {\n    display: inline-block;\n}\n\n#ndq-content .speaker-group {\n    float: left;\n    margin-bottom: 1em;\n    width: 100%;\n}\n\n#ndq-content .field--name-field-nir-news-document a {\n    font-weight: bold;\n}\n\n#ndq-content .field--name-field-nir-document,#ndq-content .field--name-field-nir-news-document,#ndq-content .field--name-field-nir-news-supp-format,#ndq-content .field--name-field-nir-news-supp-references {\n    font-weight: bold;\n}\n\n#ndq-content .field--name-field-nir-document .field__item,#ndq-content .field--name-field-nir-news-document .field__item,#ndq-content .field--name-field-nir-news-supp-format .field__item,#ndq-content .field--name-field-nir-news-supp-references .field__item {\n    margin-top: 5px;\n    margin-bottom: 1em;\n}\n\n#ndq-content .box__right .field__label {\n    margin-bottom: 0.5em;\n}\n\n#ndq-content .box__right .field--name-field-nir-tags .field__label {\n    font-size: 11px;\n    float: left;\n    margin-right: 0.5em;\n}\n\n#ndq-content .field--name-field-nir-sec-form {\n    font-size: 20px;\n    line-height: 150%;\n}\n\n#ndq-content .detail-group {\n    line-height: 175%;\n}\n\n#ndq-content .doc-group,#ndq-content .xbrl-group {\n    line-height: 200%;\n}\n\n#ndq-content .node--type-nir-sec-filing .field--name-field-nir-tags {\n    margin: 0.5em 0;\n}\n\n#ndq-content .node--type-nir-sec-filing .field--name-field-nir-tags a {\n    color: #333;\n}\n\n#ndq-content .add-outlook,#ndq-content .add-gcal {\n    float: left;\n    margin-top: 1em;\n}\n\n#ndq-content .media-meta div {\n    display: inline-block;\n}\n\n#ndq-content .field--name-field-nir-multimedia-tags {\n    float: left;\n    width: 100%;\n    margin-top: 10px;\n}\n\n#ndq-content .field--name-field-nir-multimedia-tags .field__label {\n    font-size: 11px;\n    float: left;\n    margin-right: 0.5em;\n}\n\n#ndq-content .field--name-field-nir-multimedia-item .file-link,#ndq-content .field--name-field-nir-multimedia-item .media-meta {\n   \n    display: inline-block;\n}\n\n#ndq-content .field--name-field-nir-multimedia-item .filesize {\n    padding-right: 5px;\n}\n\n#ndq-content .field--name-field-nir-multimedia-item .media-meta {\n    font-style: italic;\n    font-weight: normal;\n    color: #847271;\n}\n\n#ndq-content .field.field--name-field-nir-multimedia-item {\n    margin: 1em 0;\n}\n\n#ndq-content .field.field--name-field-nir-multimedia-item a::before {\n    font-size: 30px;\n    margin-bottom: 5px;\n    float: left;\n}\n\n#ndq-content .node--nir-multimedia--full h2 {\n    margin-bottom: 0.75em;\n}\n\n#ndq-content .node--nir-multimedia--full .two-col-node .node-left {\n    max-width: 300px;\n    float: left;\n}\n\n#ndq-content .node--nir-multimedia--full .two-col-node .node-right {\n    float: left;\n}\n\n#ndq-content .node--nir-multimedia--full .styled-tag__small a {\n    color: #333;\n}\n\n#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-tags {\n    padding: 1em 0;\n}\n\n#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-title {\n    font-weight: bold;\n    margin: 12px 0;\n}\n\n#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-desc p:first-child {\n    margin-top: 0;\n}\n\n#ndq-content .node--view-mode-nir-media-gallery-viewmode .field--name-field-nir-media-gallery-desc p:last-child {\n    margin-top: 0;\n}\n\n#ndq-content .field--name-field-nir-multimedia-item .filesize {\n    display: none;\n}\n\n#ndq-content .field--name-field-nir-multimedia-item .file-link {\n    padding-right: 5px;\n}\n\n#ndq-content .node--type-nir-multimedia .filesize {\n    display: none;\n}\n\n#ndq-content .view-search .filesize {\n    display: none;\n}\n\n#ndq-content .field--name-field-nir-multimedia-item .field__label {\n    display: none;\n}\n\n#ndq-content .historical-price-lookup-form .form-item,#ndq-content .stock-price-calculator-form .form-item {\n\n    display: inline-block;\n    margin-right: 20px;\n    position: relative;\n}\n\n#ndq-content .historical-price-lookup-form .form-item label::after,#ndq-content .stock-price-calculator-form .form-item label::after {\n    content: ':';\n}\n\n#ndq-content .market-data-filter-form .form-item {\n   \n    display: inline-block;\n    margin-right: 20px;\n    position: relative;\n}\n\n#ndq-content .market-data-filter-form .form-item label::after {\n    content: ':';\n}\n\n#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one {\n    padding-left: 25px;\n}\n\n#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one::before {\n    content: \"î‚º\";\n    display: inline-block;\n    text-decoration: none;\n    color: #0480a9;\n}\n\n#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one::before {\n    color: #666;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n\n#ndq-content .market-data-filter-form .form-item.form-item-period-compare-one label {\n    font-size: 75%;\n    color: #666;\n}\n\n#ndq-content .market-data-filter-form .form-item.form-item-period-compare-two {\n    padding-left: 25px;\n}\n\n#ndq-content .market-data-filter-form .form-item.form-item-period-compare-two::before {\n    color: #666;\n    content: 'to';\n    font-weight: bold;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n\n#ndq-content .market-data-filter-form .form-item.form-item-period-compare-two label {\n    font-size: 75%;\n    color: #666;\n}\n\n#ndq-content .market-data-filter-form input {\n    margin: 2.8em 0em 1.42857em 0em;\n}\n\n#ndq-content .md-download {\n    float: left;\n    width: 100%;\n    margin: 1em 0;\n}\n\n#ndq-content .md-download .filesize {\n    margin-left: 0.5em;\n}\n\n#ndq-content .historical-price-lookup-form .form-submit,#ndq-content .stock-price-calculator-form .form-submit {\n    margin-top: 3.1em;\n}\n\n@media (max-width: 481px) {\n    #ndq-content .historical-price-lookup-form .form-wrapper {\n        display:block;\n        clear: both;\n    }\n\n    #ndq-content .historical-price-lookup-form .form-item {\n        margin-right: 5px;\n        margin-bottom: 0;\n    }\n\n    #ndq-content .historical-price-lookup-form .form-submit {\n        margin-top: 10px;\n    }\n}\n\n#ndq-content .form-item-symbols-historical {\n    max-width: 120px;\n}\n\n#ndq-content .form-item-symbols-historical .form-select {\n    max-width: 120px;\n}\n\n#ndq-content .form-no-label {\n    margin-top: 2.8em;\n}\n\n#ndq-content .filter-row {\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .captcha-admin-links {\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .form-select {\n    width: auto;\n}\n\n#ndq-content .contact-form input[type=\"text\"],#ndq-content .contact-form input[type=\"search\"],#ndq-content .contact-form input[type=\"tel\"],#ndq-content .contact-form input[type=\"url\"],#ndq-content .contact-form input[type=\"email\"],#ndq-content .contact-form input[type=\"password\"],#ndq-content .contact-form input[type=\"date\"],#ndq-content .contact-form input[type=\"time\"],#ndq-content .contact-form input[type=\"number\"],#ndq-content .contact-form input[type=\"datalist\"] {\n    width: 100%;\n}\n\n#ndq-content .contact-form textarea,#ndq-content .contact-form select,#ndq-content .contact-form fieldset,#ndq-content .contact-form .form-select {\n    width: 100%;\n}\n\n#ndq-content .asterisk::after {\n    content: \"*\";\n    color: #c00;\n    display: inline;\n    margin: 0;\n}\n\n#ndq-content .nir-email-alerts-signup-form input[type=\"text\"],#ndq-content .nir-email-alerts-signup-form input[type=\"search\"],#ndq-content .nir-email-alerts-signup-form input[type=\"tel\"],#ndq-content .nir-email-alerts-signup-form input[type=\"url\"],#ndq-content .nir-email-alerts-signup-form input[type=\"email\"],#ndq-content .nir-email-alerts-signup-form input[type=\"password\"],#ndq-content .nir-email-alerts-signup-form input[type=\"date\"],#ndq-content .nir-email-alerts-signup-form input[type=\"time\"],#ndq-content .nir-email-alerts-signup-form input[type=\"number\"],#ndq-content .nir-email-alerts-signup-form input[type=\"datalist\"] {\n    width: 100%;\n}\n\n#ndq-content .nir-email-alerts-signup-form .form-select {\n    width: 100%;\n}\n\n#ndq-content .nir-email-alerts-signup-form table {\n    table-layout: fixed;\n}\n\n#ndq-content .nir-email-alerts-signup-form table th {\n    border-bottom: 0;\n    color: #333;\n    background: #fff;\n}\n\n#ndq-content .nir-email-alerts-signup-form table th:first-child::after {\n    content: \"*\";\n    color: #c00;\n    display: inline;\n    margin: 0 0 0 5px;\n}\n\n#ndq-content .nir-email-alerts-signup-form table th,#ndq-content .nir-email-alerts-signup-form table td {\n    padding: 5px 0;\n}\n\n#ndq-content .ipe-block-plugin-form select {\n    color: #333;\n    padding: 1px 5px;\n    appearance: menulist;\n    margin-bottom: 0.5em;\n    -moz-appearance: menulist;\n    -webkit-appearance: menulist;\n}\n\n#ndq-content .form-item-nir-email-alerts-unsubscribe-from-all {\n    margin: 1em 0;\n}\n\n#ndq-content .form-item-nir-email-alerts-unsubscribe-from-all label {\n    font-weight: bold;\n}\n\n#ndq-content .modal-content .field--name-field-nir-person-company,#ndq-content .modal-content .field--name-field-nir-person-dir-since {\n    margin-bottom: 1em;\n}\n\n#ndq-content .modal-content .field--name-field-nir-person-dir-details .field__item {\n    margin: 0.4em 0;\n}\n\n#ndq-content .modal-content .field--name-field-nir-person-dir-details .field__item:before {\n    font-size: 22px;\n}\n\n#ndq-content .modal-content h3.full-name {\n    margin-top: 0;\n}\n\n#ndq-content .modal-content a {\n    color: #0480a9;\n}\n\n#ndq-content .ui-dialog button,#ndq-content .ui-dialog button:hover {\n    background: none;\n}\n\n#ndq-content .bold-row {\n    font-weight: bold;\n}\n\n#ndq-content .table-title {\n    float: left;\n    width: 100%;\n}\n\n#ndq-content .form-table,#ndq-content form table {\n    table-layout: auto;\n}\n\n#ndq-content .form-table tr,#ndq-content form table tr {\n    vertical-align: top;\n}\n\n#ndq-content .form-table tr:nth-child(odd),#ndq-content .form-table tr:nth-child(even),#ndq-content form table tr:nth-child(odd),#ndq-content form table tr:nth-child(even) {\n    background-color: transparent;\n}\n\n#ndq-content .form-table tr.field-multiple-drag,#ndq-content form table tr.field-multiple-drag {\n    padding: 15px 0 0 0;\n}\n\n#ndq-content .form-table td.field-multiple-drag,#ndq-content form table td.field-multiple-drag {\n    padding: 15px 0 0 0;\n}\n\n#ndq-content .form-table__header,#ndq-content .form-table th,#ndq-content form table th {\n    background-color: transparent;\n}\n\n#ndq-content .ipe-category-picker-top.active h4 {\n    width: 100%;\n}\n\n\n.ui-dialog .ui-dialog-titlebar-close {\n    right: 10px;\n    top: 10px;\n}\n\n.ir-day [class*='block-region-'] {\n    margin-bottom: 3em;\n}\n\n[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav {\n    padding: 0 1em 2em 1em;\n    margin-bottom: 1em;\n}\n\n[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top {\n    background-color: #fff;\n}\n\n[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top::after,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav.llf-fixed-top::after {\n    content: '';\n    width: 100%;\n    display: block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    border-bottom: 1px var(--border-style,solid) var(--border-color,#cbcbcd);\n}\n\n[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li {\n    padding: 1em 0;\n    flex: 0 0 33.333333%;\n    text-align: center;\n}\n\n[id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li:last-child,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li:last-child {\n    padding: 0;\n    flex: 0 0 100%;\n}\n\nnav.block--system-menu-blockir-day-sub-nav [class*='llf-btn'],nav.block--system-menu-blockir-day-sub-nav [class*='idm-btn'],nav.block--system-menu-blockir-day-sub-nav .button,nav.block--system-menu-blockir-day-sub-nav button,nav.block--system-menu-blockir-day-sub-nav input[type=\"submit\"] {\n    --button-display: block;\n    display: block;\n}\n\n@media screen and (min-width: 768px) {\n    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav {\n        padding:1em;\n        margin-bottom: 1em;\n    }\n\n    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul {\n        flex-direction: row;\n        align-items: center;\n    }\n\n    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav ul li {\n        flex: 0 0 auto !important;\n        text-align: left;\n        padding: 1em 1.75em 1em 0;\n    }\n}\n\n@media screen and (min-width: 992px) {\n    [id*='ndq-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav,[id*='lfg-content'] .ir-day nav.block--system-menu-blockir-day-sub-nav {\n        padding:1em 0 1em 0;\n        margin-bottom: 1em;\n    }\n}\n\n.ir-day .ndm-hero {\n    position: relative;\n    padding: 3em;\n    min-height: 33vw;\n    display: flex;\n    align-items: center;\n}\n\n.ir-day .ndm-full-bg {\n    position: absolute;\n    display: block;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.ir-day .ndm-full-bg::after {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    opacity: .5;\n}\n\n.ir-day .ndm-full-bg img {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.ir-day .ndm-hero-content {\n    position: relative;\n}\n\n.ir-day .ndm-modal-bio-portrait {\n    height: 0;\n    padding-top: 115%;\n    position: relative;\n    display: block;\n    background-color: #ccc;\n}\n\n.ir-day .ndm-modal-bio-portrait img,.ir-day .ndm-modal-bio-portrait.bio-no-image:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover;\n}\n\n.ir-day .ndm-modal-bio-portrait.bio-no-image:before {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    content: \"Read Bio\";\n    font-size: 2em;\n    color: #fff;\n    font-weight: bold;\n}\n\n.ir-day-page .bio-dialog-modal .ui-widget-header {\n    background: none;\n}\n\n.ir-day-page .bio-dialog-modal .ui-widget-content {\n    border: 0;\n}\n\n.ir-day-page .modalDialog .node--person--full .node__content {\n    display: flex;\n    justify-content: space-between;\n}\n\n.ir-day-page .modalDialog .node--person--full .node__content .node-left {\n    flex: 0 0 30%;\n    padding-right: 15px;\n}\n\n.ir-day-page .modalDialog .node--person--full .node__content .node-right {\n    flex: 0 0 65%;\n}\n\n#ndq-content .block--assets-starter {\n    --image-outline-color: var(--border-color,#cbcbcd);\n}\n\n#ndq-content .block--assets-starter .nir-widget--list > article {\n    border: 0 !important;\n    background-color: transparent !important;\n    padding: 0 1rem;\n    margin-bottom: 2rem;\n}\n\n#ndq-content .block--assets-starter .nir-widget .nir-widget--field {\n    margin-bottom: 1rem;\n}\n\n#ndq-content .block--assets-starter .nir-widget .nir-widget--field:last-child {\n    margin-bottom: 0;\n}\n\n#ndq-content .block--assets-starter .nir-widget .nir-widget--field.nir-widgets--asset--title {\n    font-size: 1.3em;\n    line-height: 1.3em;\n    margin: 0 0 .7em 0;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n}\n\n#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-document .field__item,#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-news-document .field__item,#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-news-supp-format .field__item,#ndq-content .block--assets-starter .nir-widget .field--name-field-nir-news-supp-references .field__item {\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\n#ndq-content .block--assets-starter .nir-widget .nir-widget--field.nir-widget--asset--thumbnail,#ndq-content .block--assets-starter .nir-widget .nir-widget--asset--thumbnail img {\n    width: 100%;\n}\n\n#ndq-content .block--assets-starter .nir-widget .nir-widget--asset--thumbnail img {\n    border: 1px solid var(--image-outline-color);\n}\n\n[class*=\"block--views-blockwidget-bundled-content-block\"] {\n    --quarterly-results-boxes: transparent;\n    --quarterly-results-box-padding: .3em 0;\n    --quarterly-results-boxes-border-top: 0px solid var(--border-color,#cbcbcd);\n    --quarterly-results-border-width: 1px 0px 1px 0;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block-1--5986\"] .view-filters,#ndq-content [class*=\"block--views-blockwidget-bundled-content-block-1--5986\"] .show-all,#ndq-content [class*=\"block--views-blockwidget-bundled-content-block-1--5986\"] .hide-all {\n    display: none !important;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter .acc-title,#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter.view-grouping,#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter .acc-body {\n    float: none !important;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter {\n    padding: 1em 1em 2em 1em;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter .qrGridContent {\n    background-color: var(--quarterly-results-boxes);\n    padding: 1em 0;\n    margin-bottom: 1rem;\n    border-width: var(--quarterly-results-border-width,0);\n    border-style: solid;\n    border-color: var(--border-color);\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter h2 {\n    margin: 0 0 1rem 0 !important;\n    padding: 0 !important;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter h3 {\n    border-bottom: var(--quarterly-results-boxes-border-top);\n    padding: 0 0 .5rem 0 !important;\n    margin: 0 !important;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter ul > li {\n    padding: var(--quarterly-results-box-padding) !important;\n    border: 0 !important;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter .sameH {\n    align-content: space-between;\n    align-items: stretch;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter .qrGridContent .views-field {\n    width: 100%;\n    float: none;\n}\n\n#ndq-content [class*=\"block--views-blockwidget-bundled-content-block\"] .bundle-grid-starter .qrGridContent .item-list ul > li {\n    background-color: transparent !important;\n}\n\n:root {\n    --border-color: #cbcbcd;\n    --title: 1.2rem;\n    --title-line-height: inherit;\n    --date-time: 1rem;\n}\n\n.nir-node--5806 {\n    --title: 1rem;\n    --date-time: 1rem;\n}\n\n#ndq-content .block--events-starter {\n    margin-bottom: 3rem;\n}\n\n#ndq-content .block--events-starter article.node--nir-event--nir-widget-list {\n    border-bottom: 1px solid var(--border-color);\n    padding: 1rem 0;\n    margin: 0;\n}\n\n#ndq-content .block--events-starter article.node--nir-event--nir-widget-list:first-of-type {\n    border-top: 1px solid var(--border-color);\n}\n\n#ndq-content .block--events-starter .additional-details:not(:empty) {\n    margin-top: 1rem;\n}\n\n#ndq-content .block--events-starter .field__item {\n    margin: 0 0 0.5rem 0 !important;\n    padding: 0 !important;\n}\n\n#ndq-content .block--events-starter .nir-widget--event--webcast .field__item,#ndq-content .block--events-starter .nir-widget--event--add-to-calendar .field__item,#ndq-content .block--events-starter .nir-widget--event--support-materials .field__item {\n    line-height: 1 !important;\n}\n\n#ndq-content .block--events-starter .field__item a {\n    display: inline-block;\n}\n\n#ndq-content .block--events-starter .asset-link {\n    font-size: inherit;\n    font-weight: inherit;\n    margin: 0;\n}\n\n#ndq-content .block--events-starter .field--name-field-nir-event-summary {\n    font-size: inherit;\n    font-weight: inherit;\n    color: inherit;\n}\n\n#ndq-content .block--events-starter .nir-widgets--event--title,#ndq-content .block--events-starter .nir-widgets--event--title * {\n    font-size: var(--title);\n    line-height: var(--title-line-height);\n}\n\n#ndq-content .block--events-starter .nir-widget--event--date {\n    font-size: var(--date-time);\n}\n\n#ndq-content .block--events-starter .nir-widget--event--add-to-calendar .nir-widget--field:last-of-type .field__item {\n    margin-bottom: 0 !important;\n}\n\n#ndq-content .block--events-starter .add-gcal a,#ndq-content .block--events-starter .add-outlook a {\n    font-size: inherit;\n}\n\n#ndq-content .block--events-starter .add-outlook,#ndq-content .block--events-starter .add-gcal {\n    float: none !important;\n}\n\n#ndq-content .block--events-starter .add-outlook,#ndq-content .block--events-starter .add-gcal {\n    margin: 0;\n}\n\n#ndq-content .block--events-starter .supporting-links {\n    margin-top: 1rem;\n}\n\n@media (min-width: 768px) {\n    #ndq-content .block--events-starter .supporting-links {\n        margin-top:0;\n    }\n}\n\n.nir-node--5806 #ndq-content [class*='llf-col-'].full-on-front {\n    flex: 0 0 100% !important;\n    max-width: 100%;\n}\n\n.nir-node--5806 #ndq-content .nir-widget .full-on-front .nir-widget--field {\n    margin-bottom: .7rem;\n}\n\n.nir-node--5806 #ndq-content .nir-widget .full-on-front .nir-widget--field:last-of-type {\n    margin-bottom: 0rem;\n}\n\n:root {\n    --border-color: #cbcbcd;\n    --title: 1.2rem;\n    --title-line-height: inherit;\n    --date-time: 0.9rem;\n}\n\n.nir-node--5806 {\n    --title: 1rem;\n    --date-time: 1rem;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news form .nir-widgets--field-container {\n    display: inline-block;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list article {\n    clear: both;\n    margin-bottom: 1rem !important;\n    padding-bottom: 0.625rem !important;\n    border-bottom: 1px solid var(--border-color);\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--accordion {\n    display: flex;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget a.nir-widget--news--accordion-toggle {\n    display: flex;\n    align-items: baseline;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--teaser {\n    margin-left: 1.375rem !important;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time {\n    font-size: var(--date-time);\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--supporting-materials {\n    width: auto;\n    display: inline-block;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--supporting-materials .nir-widgets-file-link:before,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats .nir-widgets-file-link:before {\n    content: \"|\";\n    color: inherit;\n    padding-left: 0.5rem;\n    padding-right: 0.313rem;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats .nir-widgets-file-link a {\n    font-size: 0;\n    line-height: 0;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats .nir-widgets-file-link a span:before {\n    margin-top: -0.5rem;\n    line-height: 1;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field.nir-widget--news--teaser {\n    margin: 0 !important;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time {\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field.nir-widget--news--teaser:after {\n    content: '...';\n    left: -5px;\n    position: relative;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field {\n    margin: 0 0 .7rem;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--field:last-of-type {\n    margin: 0;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--date-time,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--addl-formats,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--read-more {\n    padding: 0;\n    margin: 0;\n    line-height: 1;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--headline,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--news--headline * {\n    font-size: var(--title);\n    line-height: var(--title-line-height);\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget #widget-form-base {\n    border: 0;\n    background-color: transparent;\n    margin: 0 0 1rem 0;\n    padding: 0 !important;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list > article,#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list > article:last-child {\n    border-width: 0;\n    border-bottom: 1px solid var(--border-color);\n    background-color: transparent !important;\n    margin: 0 !important;\n    padding: 1rem 0 !important;\n}\n\n#ndq-content .block--news-list-starter.block-nir-news__widget .nir-widget--list > article:first-of-type {\n    border-top: 1px solid var(--border-color);\n}\n\n.nir-node--5816 #ndq-content .block--search-form form .button--primary {\n    margin: 0 0 2px .8rem !important;\n    float: none;\n}\n\n.nir-node--5816 #ndq-content .block-search-form form::after {\n    content: '';\n    display: none;\n}\n\n.nir-node--5816 #ndq-content .block-search-form form input[type=submit] {\n    position: relative;\n    text-indent: 0;\n    color: #fff;\n    background-color: #4C77A9;\n    top: initial;\n    right: initial;\n}\n\n@media (min-width: 992px) {\n    .nir-node--5816 #ndq-content .block-search-form {\n        position:absolute;\n        right: 1rem;\n        margin-top: 1rem;\n    }\n\n    .nir-node--5816 #ndq-content .block-search-form form .form-item {\n        display: inline-block;\n        ;margin-top: 0 !important;\n    }\n}\n\n:root {\n    --border-color: #cbcbcd;\n}\n\n#ndq-content .block--analyst-starter .nirtable {\n    border-collapse: collapse;\n}\n\n#ndq-content .block--analyst-starter .field--name-field-nir-person-company {\n    font-style: normal;\n    font-weight: bold;\n}\n\n@media (max-width: 769px) {\n    #ndq-content .block--analyst-starter .nirtable.collapse-table-wide tbody > tr > td {\n        padding-left:20%;\n    }\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget {\n    --max-thumbnail-width: 20%;\n    --people-starter--icon-size: 26px;\n}\n\n@media (min-width: 1920px) {\n    #ndq-content .block--people-starter.block--nir-people__widget {\n        --max-thumbnail-width:10%;\n    }\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--field {\n    margin-bottom: 0.7rem;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--field:last-of-type {\n    margin-bottom: 0;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--person--name {\n    font-size: 1.2em;\n    font-weight: 600;\n    margin: 0 0 .5rem 0;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article .nir-widget--person--title {\n    font-size: 1.1em;\n    margin: 0 0 .5rem 0;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article {\n    background-color: transparent !important;\n    border: 1px solid var(--border-color);\n    border-width: 0 0 1px 0;\n    padding: 1em 0;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list > article:first-of-type {\n    border-top-width: 1px;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] img,#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] source,#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] svg,#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] picture {\n    width: 100%;\n    padding: 0;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'] {\n    float: none;\n    padding: 0;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col {\n    flex: 1 1 100% !important;\n    min-width: 100% !important;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col + .llf-col {\n    flex: 1 1 100%;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .nir-widget--field.nir-widget--person--dir-details .nir-widget--list-item {\n    margin-right: 0.5em;\n    display: block;\n}\n\n@media (min-width: 576px) {\n    #ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col {\n        flex:1 1 var(--max-thumbnail-width) !important;\n        min-width: var(--max-thumbnail-width) !important;\n    }\n\n    #ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='nir-widget--'][class*='--thumbnail'].llf-col + .llf-col {\n        flex: 1 1 auto;\n    }\n\n    #ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .nir-widget--field.nir-widget--person--dir-details .nir-widget--list-item {\n        display: inline-block;\n    }\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='ndqicon__'],#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list [class*='ndqicon__']:before {\n    line-height: var(--people-starter--icon-size);\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__independent::before {\n    margin-top: -4px;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__calculator::before {\n    margin-top: -6px;\n}\n\n.ndqicon__calculator::before {\n    margin-top: -6px;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__vicechair::before {\n    margin-top: -1px;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__chair::before {\n    margin-top: -1px;\n}\n\n#ndq-content .block--people-starter.block--nir-people__widget .nir-widget--list .ndqicon__leaddir::before {\n    margin-top: -4px;\n}\n\n@-webkit-keyframes opacity0to1 {\n    0% {\n        opacity: 0;\n    }\n\n    10% {\n        opacity: 0;\n    }\n\n    20% {\n        opacity: 0;\n    }\n\n    30% {\n        opacity: 0;\n    }\n\n    40% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 0;\n    }\n\n    60% {\n        opacity: 0.2;\n    }\n\n    70% {\n        opacity: 0.4;\n    }\n\n    80% {\n        opacity: 0.6;\n    }\n\n    90% {\n        opacity: 0.8;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes opacity0to1 {\n    0% {\n        opacity: 0;\n    }\n\n    10% {\n        opacity: 0;\n    }\n\n    20% {\n        opacity: 0;\n    }\n\n    30% {\n        opacity: 0;\n    }\n\n    40% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 0;\n    }\n\n    60% {\n        opacity: 0.2;\n    }\n\n    70% {\n        opacity: 0.4;\n    }\n\n    80% {\n        opacity: 0.6;\n    }\n\n    90% {\n        opacity: 0.8;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\nhtml {\n    -webkit-text-size-adjust: 100%;\n    line-height: 1.15;\n}\n\nbody {\n    margin: 0;\n}\n\nmain {\n    display: block;\n}\n\nh1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n}\n\nhr {\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n}\n\n\nhr {\n    border-top-width: 1px;\n}\n\nimg {\n    border-style: solid;\n}\n\ntextarea {\n    resize: vertical;\n}\n\ninput::-webkit-input-placeholder,textarea::-webkit-input-placeholder {\n    color: #a0aec0;\n}\n\ninput::-moz-placeholder,textarea::-moz-placeholder {\n    color: #a0aec0;\n}\n\ninput:-ms-input-placeholder,textarea:-ms-input-placeholder {\n    color: #a0aec0;\n}\n\ninput::-ms-input-placeholder,textarea::-ms-input-placeholder {\n    color: #a0aec0;\n}\n\ninput::placeholder,textarea::placeholder {\n    color: #a0aec0;\n}\n\n[role=\"button\"],button {\n    cursor: pointer;\n}\n\ntable {\n    border-collapse: collapse;\n}\n\nh1,h2,h3,h4,h5,h6 {\n    font-size: inherit;\n    font-weight: inherit;\n}\n\na {\n    color: inherit;\n    text-decoration: inherit;\n}\n\nbutton,input,optgroup,select,textarea {\n    color: inherit;\n    line-height: inherit;\n    padding: 0;\n}\n\ncode,kbd,pre,samp {\n    font-family: SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;\n}\n\naudio,canvas,embed,iframe,img,object,svg,video {\n    display: block;\n}\n\nimg,video {\n    height: auto;\n    max-width: 100%;\n}\n\n.container {\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .container {\n        max-width:768px;\n    }\n}\n\n@media (min-width: 960px) {\n    .container {\n        max-width:960px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .container {\n        max-width:1200px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .container {\n        max-width:1366px;\n    }\n}\n\n[data-whatintent=\"mouse\"] :focus,[data-whatintent=\"touch\"] :focus {\n    outline: none;\n}\n\n.visually-hidden {\n    clip: rect(1px 1px 1px 1px);\n    clip: rect(1px,1px,1px,1px);\n    height: 1px;\n    overflow: hidden;\n    position: absolute !important;\n    white-space: nowrap;\n    width: 1px;\n}\n\n.block-quote {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: block;\n   \n    font-size: 28px;\n    line-height: 34px;\n    margin-bottom: 12px;\n    padding-top: 50px;\n    position: relative;\n}\n\n@media (min-width: 960px) {\n    .block-quote {\n        margin-bottom:20px;\n        padding-top: 70px;\n    }\n}\n\n.block-quote p {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 22px;\n    line-height: 32px;\n    text-align: left;\n}\n\n@media (min-width: 960px) {\n    .block-quote p {\n        font-size:38px;\n        line-height: 42px;\n    }\n}\n\n.block-quote:before {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    content: open-quote;\n   \n    font-size: 98px;\n    left: -4px;\n    line-height: 30px;\n    position: absolute;\n    top: 32px;\n    width: 100%;\n}\n\n@media (min-width: 960px) {\n    .block-quote:before {\n        font-size:185px;\n        left: -15px;\n        line-height: 30px;\n        top: 50px;\n    }\n}\n\n.block-quote:after {\n    content: close-quote;\n    position: absolute;\n    visibility: hidden;\n}\n\n.block-quote-citation {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    font-style: normal;\n}\n\n.block-quote-citation-name {\n   \n    font-size: 16px;\n    line-height: 24px;\n}\n\n.block-quote-citation-position {\n   \n    font-size: 15px;\n    line-height: 22px;\n}\n\n.favorite-button.halo:after {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0,0,0,var(--bg-opacity));\n    border-radius: 100%;\n    content: \"\";\n    height: 100%;\n    left: 0;\n    opacity: 0.13;\n    padding: 6px;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: -1;\n}\n\n.favorite-button svg {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.favorite-button:not(.full) {\n    border-radius: 100%;\n    height: 36px;\n    width: 36px;\n}\n\n.gradient-sky-to-sand {\n    background: transparent -o-linear-gradient(top,#c6e7fa 0,#fbf7ed 100%) 0 0 no-repeat padding-box;\n    background: transparent -webkit-gradient(linear,left top,left bottom,from(#c6e7fa),to(#fbf7ed)) 0 0 no-repeat padding-box;\n    background: transparent linear-gradient(180deg,#c6e7fa,#fbf7ed) 0 0 no-repeat padding-box;\n}\n\nimg.lazy {\n    opacity: 0;\n    -webkit-transition: opacity 0.1s ease-out;\n    -o-transition: opacity 0.1s ease-out;\n    transition: opacity 0.1s ease-out;\n}\n\n.lazy {\n    background-image: none !important;\n    -webkit-transition: background-image 0.1s ease-out;\n    -o-transition: background-image 0.1s ease-out;\n    transition: background-image 0.1s ease-out;\n}\n\n.lds-ring {\n    display: inline-block;\n    height: 80px;\n    left: calc(50vw - 20px);\n    position: absolute;\n    top: calc(50vh - 200px);\n    width: 80px;\n}\n\n.lds-ring > div {\n    -webkit-animation: lds-ring 1.2s cubic-bezier(0.5,0,0.5,1) infinite;\n    animation: lds-ring 1.2s cubic-bezier(0.5,0,0.5,1) infinite;\n    border: 8px solid transparent;\n    border-radius: 50%;\n    border-top-color: #f7b22e;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    display: block;\n    height: 64px;\n    margin: 8px;\n    position: absolute;\n    width: 64px;\n}\n\n.lds-ring > div:first-child {\n    -webkit-animation-delay: -0.45s;\n    animation-delay: -0.45s;\n}\n\n.lds-ring > div:nth-child(2) {\n    -webkit-animation-delay: -0.3s;\n    animation-delay: -0.3s;\n}\n\n.lds-ring > div:nth-child(3) {\n    -webkit-animation-delay: -0.15s;\n    animation-delay: -0.15s;\n}\n\n@-webkit-keyframes lds-ring {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn);\n    }\n}\n\n@keyframes lds-ring {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn);\n    }\n}\n\n.media-full,.media-full > iframe {\n    height: 100%;\n    width: 100%;\n}\n\n.media-full > img {\n    height: auto;\n    width: 100%;\n}\n\n.media-full-height > img {\n    height: 100%;\n    width: auto;\n}\n\n@media (min-width: 768px) {\n    .section-container {\n        max-width:656px;\n        padding: 56px 0;\n    }\n}\n\n\n.breadcrumbs li {\n    display: none;\n}\n\n@media (min-width: 768px) {\n    .breadcrumbs li {\n        display:inline;\n    }\n\n    .breadcrumbs li:before {\n        border-right: 1.6px solid;\n        content: \"\";\n        display: inline-block;\n        height: 0.8em;\n        margin-right: 7px;\n        -webkit-transform: rotate(15deg);\n        -ms-transform: rotate(15deg);\n        transform: rotate(15deg);\n    }\n\n    .breadcrumbs li:first-child a:before {\n        content: \"<\";\n        display: inline-block;\n        padding-right: 8px;\n    }\n}\n\n.breadcrumbs li:last-of-type {\n    display: inline;\n}\n\n.breadcrumbs li a:before {\n    content: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='24' viewBox='0 0 16 24'><path fill='%23ffffff' d='M16.59,8.59,12,13.17,7.41,8.59,6,10l6,6,6-6Z' style='transform: rotate(90deg); transform-origin: center center;' /></svg>\");\n}\n\n@media (min-width: 768px) {\n    .breadcrumbs li a:before {\n        display:none;\n    }\n}\n\n@media (hover: hover) {\n    .breadcrumbs li a:hover {\n        -webkit-transition-duration:0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .breadcrumbs li a:hover:after {\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (min-width: 1366px) {\n    .breadcrumbs {\n        margin-left:auto;\n        margin-right: auto;\n    }\n}\n\n.cta-primary-large,.cta-primary-large > a,.cta-primary-large > button {\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 27px;\n    font-size: 16px;\n    height: 56px;\n    line-height: 56px;\n    min-width: 196px;\n    padding: 0 2rem;\n}\n\n@media (hover: hover) {\n    .cta-primary-large:hover,.cta-primary-large > a:hover,.cta-primary-large > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-large.dark,.cta-primary-large:active,.cta-primary-large > a.dark,.cta-primary-large > a:active,.cta-primary-large > button.dark,.cta-primary-large > button:active {\n    --bg-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-large.dark:hover,.cta-primary-large > a.dark:hover,.cta-primary-large > button.dark:hover {\n        --bg-opacity:1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n    }\n}\n\n.cta-primary-large.dark:active,.cta-primary-large > a.dark:active,.cta-primary-large > button.dark:active {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n}\n\n.cta-primary-medium,.cta-primary-medium > a,.cta-primary-medium > button {\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 27px;\n    height: 48px;\n    line-height: 48px;\n    min-width: 164px;\n    padding: 0 2rem;\n}\n\n@media (hover: hover) {\n    .cta-primary-medium:hover,.cta-primary-medium > a:hover,.cta-primary-medium > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-medium.dark,.cta-primary-medium:active,.cta-primary-medium > a.dark,.cta-primary-medium > a:active,.cta-primary-medium > button.dark,.cta-primary-medium > button:active {\n    --bg-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-medium.dark:hover,.cta-primary-medium > a.dark:hover,.cta-primary-medium > button.dark:hover {\n        --bg-opacity:1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n    }\n}\n\n.cta-primary-medium.dark:active,.cta-primary-medium > a.dark:active,.cta-primary-medium > button.dark:active {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n}\n\n.cta-primary-small,.cta-primary-small > a,.cta-primary-small > button {\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 27px;\n    font-size: 16px;\n    height: 32px;\n    line-height: 32px;\n    min-width: 136px;\n    padding: 0 2rem;\n}\n\n@media (hover: hover) {\n    .cta-primary-small:hover,.cta-primary-small > a:hover,.cta-primary-small > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-small.dark,.cta-primary-small:active,.cta-primary-small > a.dark,.cta-primary-small > a:active,.cta-primary-small > button.dark,.cta-primary-small > button:active {\n    --bg-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-small.dark:hover,.cta-primary-small > a.dark:hover,.cta-primary-small > button.dark:hover {\n        --bg-opacity:1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n    }\n}\n\n.cta-primary-small.dark:active,.cta-primary-small > a.dark:active,.cta-primary-small > button.dark:active {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n}\n\n.bg-black {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0,0,0,var(--bg-opacity));\n}\n\n.bg-white {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n}\n\n.bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237,242,247,var(--bg-opacity));\n}\n\n.bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45,55,72,var(--bg-opacity));\n}\n\n.bg-green {\n    --bg-opacity: 1;\n    background-color: #1e7721;\n    background-color: rgba(30,119,33,var(--bg-opacity));\n}\n\n.bg-teal {\n    --bg-opacity: 1;\n    background-color: #008b95;\n    background-color: rgba(0,139,149,var(--bg-opacity));\n}\n\n.bg-purple {\n    --bg-opacity: 1;\n    background-color: #6639b7;\n    background-color: rgba(102,57,183,var(--bg-opacity));\n}\n\n.bg-royal {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n}\n\n.bg-royallight {\n    --bg-opacity: 1;\n    background-color: #1765f4;\n    background-color: rgba(23,101,244,var(--bg-opacity));\n}\n\n.bg-royaldark {\n    --bg-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n}\n\n.bg-lime {\n    --bg-opacity: 1;\n    background-color: #84c434;\n    background-color: rgba(132,196,52,var(--bg-opacity));\n}\n\n.bg-limelight {\n    --bg-opacity: 1;\n    background-color: #91dd33;\n    background-color: rgba(145,221,51,var(--bg-opacity));\n}\n\n.bg-cerulean {\n    --bg-opacity: 1;\n    background-color: #7bafd3;\n    background-color: rgba(123,175,211,var(--bg-opacity));\n}\n\n.bg-chateau {\n    --bg-opacity: 1;\n    background-color: #1e7721;\n    background-color: rgba(30,119,33,var(--bg-opacity));\n}\n\n.bg-sky {\n    --bg-opacity: 1;\n    background-color: #c6e7fa;\n    background-color: rgba(198,231,250,var(--bg-opacity));\n}\n\n.bg-azure {\n    --bg-opacity: 1;\n    background-color: #4dbae9;\n    background-color: rgba(77,186,233,var(--bg-opacity));\n}\n\n.bg-coolgrey {\n    --bg-opacity: 1;\n    background-color: #dde6ed;\n    background-color: rgba(221,230,237,var(--bg-opacity));\n}\n\n.bg-sunny {\n    --bg-opacity: 1;\n    background-color: #f7b22e;\n    background-color: rgba(247,178,46,var(--bg-opacity));\n}\n\n.bg-sandstone {\n    --bg-opacity: 1;\n    background-color: #fbf7ed;\n    background-color: rgba(251,247,237,var(--bg-opacity));\n}\n\n.bg-tertiaryyellow {\n    --bg-opacity: 1;\n    background-color: #fff5de;\n    background-color: rgba(255,245,222,var(--bg-opacity));\n}\n\n.bg-olympic {\n    --bg-opacity: 1;\n    background-color: #2475a5;\n    background-color: rgba(36,117,165,var(--bg-opacity));\n}\n\n.bg-turquoise {\n    --bg-opacity: 1;\n    background-color: #27817f;\n    background-color: rgba(39,129,127,var(--bg-opacity));\n}\n\n.bg-grey-13 {\n    --bg-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n}\n\n.bg-grey-27 {\n    --bg-opacity: 1;\n    background-color: #bbb;\n    background-color: rgba(187,187,187,var(--bg-opacity));\n}\n\n.bg-grey-50 {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n}\n\n.bg-grey-60 {\n    --bg-opacity: 1;\n    background-color: #666;\n    background-color: rgba(102,102,102,var(--bg-opacity));\n}\n\n.bg-grey-73 {\n    --bg-opacity: 1;\n    background-color: #444;\n    background-color: rgba(68,68,68,var(--bg-opacity));\n}\n\n.bg-grey-93 {\n    --bg-opacity: 1;\n    background-color: #131313;\n    background-color: rgba(19,19,19,var(--bg-opacity));\n}\n\n.bg-grey-07 {\n    --bg-opacity: 1;\n    background-color: #eee;\n    background-color: rgba(238,238,238,var(--bg-opacity));\n}\n\n.bg-grey-03 {\n    --bg-opacity: 1;\n    background-color: #f9f9f9;\n    background-color: rgba(249,249,249,var(--bg-opacity));\n}\n\n.bg-primarygrey {\n    --bg-opacity: 1;\n    background-color: #4a4a4a;\n    background-color: rgba(74,74,74,var(--bg-opacity));\n}\n\n.bg-secondaryblue {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n}\n\n.bg-primaryblue {\n    --bg-opacity: 1;\n    background-color: #003876;\n    background-color: rgba(0,56,118,var(--bg-opacity));\n}\n\n.bg-crisisred {\n    --bg-opacity: 1;\n    background-color: #f34436;\n    background-color: rgba(243,68,54,var(--bg-opacity));\n}\n\n.bg-errorred {\n    --bg-opacity: 1;\n    background-color: #b0001f;\n    background-color: rgba(176,0,31,var(--bg-opacity));\n}\n\n.bg-midnightblue {\n    --bg-opacity: 1;\n    background-color: #003c69;\n    background-color: rgba(0,60,105,var(--bg-opacity));\n}\n\n.bg-marineblue {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n}\n\n.bg-skyblue {\n    --bg-opacity: 1;\n    background-color: #0098db;\n    background-color: rgba(0,152,219,var(--bg-opacity));\n}\n\n.bg-mossgreen {\n    --bg-opacity: 1;\n    background-color: #34b233;\n    background-color: rgba(52,178,51,var(--bg-opacity));\n}\n\n.bg-highlightblue {\n    --bg-opacity: 1;\n    background-color: #a5e3ff;\n    background-color: rgba(165,227,255,var(--bg-opacity));\n}\n\n.bg-lightestblue {\n    --bg-opacity: 1;\n    background-color: #f2fafe;\n    background-color: rgba(242,250,254,var(--bg-opacity));\n}\n\n.bg-darkgradient,.bg-lightgradient {\n    --bg-opacity: 1;\n    background-color: #d00;\n    background-color: rgba(221,0,0,var(--bg-opacity));\n}\n\n.bg-secondaryorange {\n    --bg-opacity: 1;\n    background-color: #f90;\n    background-color: rgba(255,153,0,var(--bg-opacity));\n}\n\n.border-gray-200 {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237,242,247,var(--border-opacity));\n}\n\n.border-grey-27 {\n    --border-opacity: 1;\n    border-color: #bbb;\n    border-color: rgba(187,187,187,var(--border-opacity));\n}\n\n.rounded-sm {\n    border-radius: 8px;\n}\n\n.rounded {\n    border-radius: 27px;\n}\n\n.border-solid {\n    border-style: solid;\n}\n\n.border-4 {\n    border-width: 4px;\n}\n\n.border {\n    border-width: 1px;\n}\n\n.border-r-2 {\n    border-right-width: 2px;\n}\n\n.border-b-2 {\n    border-bottom-width: 2px;\n}\n\n.border-t-4 {\n    border-top-width: 4px;\n}\n\n.block {\n    display: block;\n}\n\n.inline {\n    display: inline;\n}\n\n.flex {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.table {\n    display: table;\n}\n\n.grid {\n    display: grid;\n}\n\n.hidden {\n    display: none;\n}\n\n.flex-row {\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n\n.flex-row,.flex-row-reverse {\n    -webkit-box-orient: horizontal;\n}\n\n.flex-row-reverse {\n    -webkit-box-direction: reverse;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n}\n\n.flex-col {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.flex-wrap {\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.items-start {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n}\n\n.items-center {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.justify-start {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n}\n\n.justify-end {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n}\n\n.justify-center {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n.justify-between {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n}\n\n.flex-initial {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 1 auto;\n    flex: 0 1 auto;\n}\n\n.flex-grow {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.font-semibold {\n    font-weight: 600;\n}\n\n.font-bold {\n    font-weight: 700;\n}\n\n.h-6 {\n    height: 24px;\n}\n\n.h-8 {\n    height: 32px;\n}\n\n.h-15 {\n    height: 60px;\n}\n\n.h-50 {\n    height: 200px;\n}\n\n.h-full {\n    height: 100%;\n}\n\n.h-screen {\n    height: 100vh;\n}\n\n.text-h1lg {\n    font-size: 56px;\n    line-height: 60px;\n}\n\n.text-h2lg {\n    font-size: 48px;\n    line-height: 52px;\n}\n\n.text-bodysmall {\n    font-size: 14px;\n    line-height: 22px;\n}\n\n.leading-6 {\n    line-height: 1.5rem;\n}\n\n.m-6 {\n    margin: 24px;\n}\n\n.my-2 {\n    margin-bottom: 8px;\n    margin-top: 8px;\n}\n\n.mx-2 {\n    margin-left: 8px;\n    margin-right: 8px;\n}\n\n.my-3 {\n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n\n.my-4 {\n    margin-bottom: 16px;\n    margin-top: 16px;\n}\n\n.mx-4 {\n    margin-left: 16px;\n    margin-right: 16px;\n}\n\n.mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.-mx-5 {\n    margin-left: -20px;\n    margin-right: -20px;\n}\n\n.mb-0 {\n    margin-bottom: 0;\n}\n\n.mt-1 {\n    margin-top: 4px;\n}\n\n.mr-1 {\n    margin-right: 4px;\n}\n\n.mb-1 {\n    margin-bottom: 4px;\n}\n\n.ml-1 {\n    margin-left: 4px;\n}\n\n.mt-2 {\n    margin-top: 8px;\n}\n\n.mr-2 {\n    margin-right: 8px;\n}\n\n.mb-2 {\n    margin-bottom: 8px;\n}\n\n.ml-2 {\n    margin-left: 8px;\n}\n\n.mt-3 {\n    margin-top: 12px;\n}\n\n.mr-3 {\n    margin-right: 12px;\n}\n\n.mb-3 {\n    margin-bottom: 12px;\n}\n\n.ml-3 {\n    margin-left: 12px;\n}\n\n.mt-4 {\n    margin-top: 16px;\n}\n\n.mr-4 {\n    margin-right: 16px;\n}\n\n.mb-4 {\n    margin-bottom: 16px;\n}\n\n.ml-4 {\n    margin-left: 16px;\n}\n\n.mt-5 {\n    margin-top: 20px;\n}\n\n.mr-5 {\n    margin-right: 20px;\n}\n\n.mb-5 {\n    margin-bottom: 20px;\n}\n\n.mt-6 {\n    margin-top: 24px;\n}\n\n.mr-6 {\n    margin-right: 24px;\n}\n\n.mb-6 {\n    margin-bottom: 24px;\n}\n\n.ml-6 {\n    margin-left: 24px;\n}\n\n.mr-7 {\n    margin-right: 28px;\n}\n\n.mb-7 {\n    margin-bottom: 28px;\n}\n\n.mt-8 {\n    margin-top: 32px;\n}\n\n.mb-8 {\n    margin-bottom: 32px;\n}\n\n.mb-9 {\n    margin-bottom: 36px;\n}\n\n.mt-10 {\n    margin-top: 40px;\n}\n\n.mr-10 {\n    margin-right: 40px;\n}\n\n.mt-11 {\n    margin-top: 44px;\n}\n\n.ml-12 {\n    margin-left: 48px;\n}\n\n.mb-14 {\n    margin-bottom: 56px;\n}\n\n.mb-50 {\n    margin-bottom: 200px;\n}\n\n.max-w-mobile {\n    max-width: calc(100% - 30px);\n}\n\n.min-w-full {\n    min-width: 100%;\n}\n\n.overflow-hidden {\n    overflow: hidden;\n}\n\n.p-0 {\n    padding: 0;\n}\n\n.p-1 {\n    padding: 4px;\n}\n\n.p-2 {\n    padding: 8px;\n}\n\n.p-3 {\n    padding: 12px;\n}\n\n.p-4 {\n    padding: 16px;\n}\n\n.p-6 {\n    padding: 24px;\n}\n\n.px-0 {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.py-1 {\n    padding-bottom: 4px;\n    padding-top: 4px;\n}\n\n.px-1 {\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n.py-2 {\n    padding-bottom: 8px;\n    padding-top: 8px;\n}\n\n.py-3 {\n    padding-bottom: 12px;\n    padding-top: 12px;\n}\n\n.px-3 {\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n.py-4 {\n    padding-bottom: 16px;\n    padding-top: 16px;\n}\n\n.px-4 {\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\n.px-5 {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.py-6 {\n    padding-bottom: 24px;\n    padding-top: 24px;\n}\n\n.px-6 {\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n.py-8 {\n    padding-bottom: 32px;\n    padding-top: 32px;\n}\n\n.px-8 {\n    padding-left: 32px;\n    padding-right: 32px;\n}\n\n.px-16 {\n    padding-left: 64px;\n    padding-right: 64px;\n}\n\n.pt-0 {\n    padding-top: 0;\n}\n\n.pr-0 {\n    padding-right: 0;\n}\n\n.pb-0 {\n    padding-bottom: 0;\n}\n\n.pt-1 {\n    padding-top: 4px;\n}\n\n.pb-1 {\n    padding-bottom: 4px;\n}\n\n.pl-1 {\n    padding-left: 4px;\n}\n\n.pt-2 {\n    padding-top: 8px;\n}\n\n.pb-2 {\n    padding-bottom: 8px;\n}\n\n.pl-2 {\n    padding-left: 8px;\n}\n\n.pt-3 {\n    padding-top: 12px;\n}\n\n.pr-3 {\n    padding-right: 12px;\n}\n\n.pb-3 {\n    padding-bottom: 12px;\n}\n\n.pl-3 {\n    padding-left: 12px;\n}\n\n.pt-4 {\n    padding-top: 16px;\n}\n\n.pr-4 {\n    padding-right: 16px;\n}\n\n.pb-4 {\n    padding-bottom: 16px;\n}\n\n.pl-4 {\n    padding-left: 16px;\n}\n\n.pr-5 {\n    padding-right: 20px;\n}\n\n.pb-5 {\n    padding-bottom: 20px;\n}\n\n.pt-6 {\n    padding-top: 24px;\n}\n\n.pr-6 {\n    padding-right: 24px;\n}\n\n.pb-6 {\n    padding-bottom: 24px;\n}\n\n.pl-6 {\n    padding-left: 24px;\n}\n\n.pt-7 {\n    padding-top: 28px;\n}\n\n.pb-7 {\n    padding-bottom: 28px;\n}\n\n.pt-8 {\n    padding-top: 32px;\n}\n\n.pr-8 {\n    padding-right: 32px;\n}\n\n.pb-8 {\n    padding-bottom: 32px;\n}\n\n.pl-8 {\n    padding-left: 32px;\n}\n\n.pt-9 {\n    padding-top: 36px;\n}\n\n.pr-9 {\n    padding-right: 36px;\n}\n\n.pb-10 {\n    padding-bottom: 40px;\n}\n\n.pt-12 {\n    padding-top: 48px;\n}\n\n.pb-13 {\n    padding-bottom: 52px;\n}\n\n.pb-15 {\n    padding-bottom: 60px;\n}\n\n.pt-20 {\n    padding-top: 80px;\n}\n\n.pt-25 {\n    padding-top: 100px;\n}\n\n.pb-30 {\n    padding-bottom: 120px;\n}\n\n.pb-50 {\n    padding-bottom: 200px;\n}\n\n.static {\n    position: static;\n}\n\n.fixed {\n    position: fixed;\n}\n\n.absolute {\n    position: absolute;\n}\n\n.relative {\n    position: relative;\n}\n\n.top-0 {\n    top: 0;\n}\n\n.right-0 {\n    right: 0;\n}\n\n.bottom-0 {\n    bottom: 0;\n}\n\n.left-0 {\n    left: 0;\n}\n\n.resize {\n    resize: both;\n}\n\n.table-auto {\n    table-layout: auto;\n}\n\n.text-left {\n    text-align: left;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.text-right {\n    text-align: right;\n}\n\n.text-black {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n}\n\n.text-white {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.text-gray-300 {\n    --text-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226,232,240,var(--text-opacity));\n}\n\n.text-gray-500 {\n    --text-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160,174,192,var(--text-opacity));\n}\n\n.text-royaldark {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n.text-chateau {\n    --text-opacity: 1;\n    color: #1e7721;\n    color: rgba(30,119,33,var(--text-opacity));\n}\n\n.text-grey-50 {\n    --text-opacity: 1;\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n}\n\n.text-grey-60 {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n}\n\n.text-grey-73 {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n}\n\n.text-grey-93 {\n    --text-opacity: 1;\n    color: #131313;\n    color: rgba(19,19,19,var(--text-opacity));\n}\n\n.text-secondaryblue {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.text-pomegranate {\n    --text-opacity: 1;\n    color: #f34436;\n    color: rgba(243,68,54,var(--text-opacity));\n}\n\n.select-none {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.invisible {\n    visibility: hidden;\n}\n\n.whitespace-pre-line {\n    white-space: pre-line;\n}\n\n.w-3 {\n    width: 12px;\n}\n\n.w-6 {\n    width: 24px;\n}\n\n.w-17 {\n    width: 68px;\n}\n\n.w-sidebar {\n    width: 296px;\n}\n\n.w-2\\/5 {\n    width: 40%;\n}\n\n.w-full {\n    width: 100%;\n}\n\n.z-0 {\n    z-index: 0;\n}\n\n.gap-0 {\n    grid-gap: 0;\n    gap: 0;\n}\n\n.gap-1 {\n    grid-gap: 4px;\n    gap: 4px;\n}\n\n.gap-3 {\n    grid-gap: 12px;\n    gap: 12px;\n}\n\n.gap-4 {\n    grid-gap: 16px;\n    gap: 16px;\n}\n\n.col-gap-4 {\n    grid-column-gap: 16px;\n    -webkit-column-gap: 16px;\n    -moz-column-gap: 16px;\n    column-gap: 16px;\n}\n\n.row-gap-6 {\n    grid-row-gap: 24px;\n    row-gap: 24px;\n}\n\n.grid-cols-1 {\n    grid-template-columns: repeat(1,minmax(0,1fr));\n}\n\n.grid-cols-2 {\n    grid-template-columns: repeat(2,minmax(0,1fr));\n}\n\n.grid-cols-3 {\n    grid-template-columns: repeat(3,minmax(0,1fr));\n}\n\n.grid-cols-6 {\n    grid-template-columns: repeat(6,minmax(0,1fr));\n}\n\n.grid-cols-10 {\n    grid-template-columns: repeat(10,minmax(0,1fr));\n}\n\n.grid-cols-12 {\n    grid-template-columns: repeat(12,minmax(0,1fr));\n}\n\n.col-span-2 {\n    grid-column: span 2 / span 2;\n}\n\n.col-span-3 {\n    grid-column: span 3 / span 3;\n}\n\n.col-span-4 {\n    grid-column: span 4 / span 4;\n}\n\n.col-span-6 {\n    grid-column: span 6 / span 6;\n}\n\n.col-span-10 {\n    grid-column: span 10 / span 10;\n}\n\n.col-span-12 {\n    grid-column: span 12 / span 12;\n}\n\n.col-start-9 {\n    grid-column-start: 9;\n}\n\n.col-start-11 {\n    grid-column-start: 11;\n}\n\n.grid-rows-2 {\n    grid-template-rows: repeat(2,minmax(0,1fr));\n}\n\n.transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    -webkit-transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n    -ms-transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n}\n\n@-webkit-keyframes spin {\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn);\n    }\n}\n\n@keyframes spin {\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn);\n    }\n}\n\n@-webkit-keyframes ping {\n    75%,to {\n        opacity: 0;\n        -webkit-transform: scale(2);\n        transform: scale(2);\n    }\n}\n\n@keyframes ping {\n    75%,to {\n        opacity: 0;\n        -webkit-transform: scale(2);\n        transform: scale(2);\n    }\n}\n\n@-webkit-keyframes pulse {\n    50% {\n        opacity: 0.5;\n    }\n}\n\n@keyframes pulse {\n    50% {\n        opacity: 0.5;\n    }\n}\n\n@-webkit-keyframes bounce {\n    0%,to {\n        -webkit-animation-timing-function: cubic-bezier(0.8,0,1,1);\n        animation-timing-function: cubic-bezier(0.8,0,1,1);\n        -webkit-transform: translateY(-25%);\n        transform: translateY(-25%);\n    }\n\n    50% {\n        -webkit-animation-timing-function: cubic-bezier(0,0,0.2,1);\n        animation-timing-function: cubic-bezier(0,0,0.2,1);\n        -webkit-transform: none;\n        transform: none;\n    }\n}\n\n@keyframes bounce {\n    0%,to {\n        -webkit-animation-timing-function: cubic-bezier(0.8,0,1,1);\n        animation-timing-function: cubic-bezier(0.8,0,1,1);\n        -webkit-transform: translateY(-25%);\n        transform: translateY(-25%);\n    }\n\n    50% {\n        -webkit-animation-timing-function: cubic-bezier(0,0,0.2,1);\n        animation-timing-function: cubic-bezier(0,0,0.2,1);\n        -webkit-transform: none;\n        transform: none;\n    }\n}\n\n.cta-secondary-large,.cta-secondary-large > a,.cta-secondary-large > button {\n    --text-opacity: 1;\n    border-radius: 27px;\n    -webkit-box-shadow: inset 0 0 0 3px #1765f4;\n    box-shadow: inset 0 0 0 3px #1765f4;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 16px;\n    height: 54px;\n    letter-spacing: 0.16px;\n    line-height: 54px;\n    min-width: 196px;\n    padding: 0 2rem;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-secondary-large:hover,.cta-secondary-large > a:hover,.cta-secondary-large > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-secondary-large > a > span,.cta-secondary-large > a i,.cta-secondary-large > a svg,.cta-secondary-large > button > span,.cta-secondary-large > button i,.cta-secondary-large > button svg,.cta-secondary-large > span,.cta-secondary-large i,.cta-secondary-large svg {\n    display: inline;\n}\n\n.cta-secondary-large > a svg,.cta-secondary-large > button svg,.cta-secondary-large svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-secondary-large:active,.cta-secondary-large > a:active,.cta-secondary-large > button:active {\n    --bg-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n    -webkit-box-shadow: inset 0 0 0 3px #062c57;\n    box-shadow: inset 0 0 0 3px #062c57;\n}\n\n.cta-secondary-large.inverted,.cta-secondary-large > a.inverted,.cta-secondary-large > button.inverted {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #fff;\n    box-shadow: inset 0 0 0 3px #fff;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-secondary-large.inverted:hover,.cta-secondary-large > a.inverted:hover,.cta-secondary-large > button.inverted:hover {\n        -webkit-box-shadow:inset 0 0 0 3px #1765f4;\n        box-shadow: inset 0 0 0 3px #1765f4;\n    }\n\n    .cta-secondary-large.inverted:hover:disabled,.cta-secondary-large > a.inverted:hover:disabled,.cta-secondary-large > button.inverted:hover:disabled {\n        -webkit-box-shadow: inset 0 0 0 3px #bbb;\n        box-shadow: inset 0 0 0 3px #bbb;\n    }\n}\n\n.cta-secondary-large.inverted:active,.cta-secondary-large > a.inverted:active,.cta-secondary-large > button.inverted:active {\n    -webkit-box-shadow: inset 0 0 0 3px #062c57;\n    box-shadow: inset 0 0 0 3px #062c57;\n}\n\n.cta-secondary-large:disabled,.cta-secondary-large > a:disabled,.cta-secondary-large > button:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-secondary-large:disabled:hover,.cta-secondary-large > a:disabled:hover,.cta-secondary-large > button:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.cta-secondary-large.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-secondary-medium,.cta-secondary-medium > a,.cta-secondary-medium > button {\n    --text-opacity: 1;\n    border-radius: 27px;\n    -webkit-box-shadow: inset 0 0 0 3px #1765f4;\n    box-shadow: inset 0 0 0 3px #1765f4;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 16px;\n    height: 44px;\n    letter-spacing: 0.16px;\n    line-height: 44px;\n    min-width: 164px;\n    padding: 0 2rem;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-secondary-medium:hover,.cta-secondary-medium > a:hover,.cta-secondary-medium > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-secondary-medium > a > span,.cta-secondary-medium > a i,.cta-secondary-medium > a svg,.cta-secondary-medium > button > span,.cta-secondary-medium > button i,.cta-secondary-medium > button svg,.cta-secondary-medium > span,.cta-secondary-medium i,.cta-secondary-medium svg {\n    display: inline;\n}\n\n.cta-secondary-medium > a svg,.cta-secondary-medium > button svg,.cta-secondary-medium svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-secondary-medium:active,.cta-secondary-medium > a:active,.cta-secondary-medium > button:active {\n    --bg-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n    -webkit-box-shadow: inset 0 0 0 3px #062c57;\n    box-shadow: inset 0 0 0 3px #062c57;\n}\n\n.cta-secondary-medium.inverted,.cta-secondary-medium > a.inverted,.cta-secondary-medium > button.inverted {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #fff;\n    box-shadow: inset 0 0 0 3px #fff;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-secondary-medium.inverted:hover,.cta-secondary-medium > a.inverted:hover,.cta-secondary-medium > button.inverted:hover {\n        -webkit-box-shadow:inset 0 0 0 3px #1765f4;\n        box-shadow: inset 0 0 0 3px #1765f4;\n    }\n\n    .cta-secondary-medium.inverted:hover:disabled,.cta-secondary-medium > a.inverted:hover:disabled,.cta-secondary-medium > button.inverted:hover:disabled {\n        -webkit-box-shadow: inset 0 0 0 3px #bbb;\n        box-shadow: inset 0 0 0 3px #bbb;\n    }\n}\n\n.cta-secondary-medium.inverted:active,.cta-secondary-medium > a.inverted:active,.cta-secondary-medium > button.inverted:active {\n    -webkit-box-shadow: inset 0 0 0 3px #062c57;\n    box-shadow: inset 0 0 0 3px #062c57;\n}\n\n.cta-secondary-medium:disabled,.cta-secondary-medium > a:disabled,.cta-secondary-medium > button:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-secondary-medium:disabled:hover,.cta-secondary-medium > a:disabled:hover,.cta-secondary-medium > button:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.cta-secondary-medium.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-secondary-small,.cta-secondary-small > a,.cta-secondary-small > button {\n    --text-opacity: 1;\n    border-radius: 27px;\n    -webkit-box-shadow: inset 0 0 0 3px #1765f4;\n    box-shadow: inset 0 0 0 3px #1765f4;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 16px;\n    height: 36px;\n    letter-spacing: 0.16px;\n    line-height: 36px;\n    min-width: 136px;\n    padding: 0 2rem;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-secondary-small:hover,.cta-secondary-small > a:hover,.cta-secondary-small > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-secondary-small > a > span,.cta-secondary-small > a i,.cta-secondary-small > a svg,.cta-secondary-small > button > span,.cta-secondary-small > button i,.cta-secondary-small > button svg,.cta-secondary-small > span,.cta-secondary-small i,.cta-secondary-small svg {\n    display: inline;\n}\n\n.cta-secondary-small > a svg,.cta-secondary-small > button svg,.cta-secondary-small svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-secondary-small:active,.cta-secondary-small > a:active,.cta-secondary-small > button:active {\n    --bg-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n    -webkit-box-shadow: inset 0 0 0 3px #062c57;\n    box-shadow: inset 0 0 0 3px #062c57;\n}\n\n.cta-secondary-small.inverted,.cta-secondary-small > a.inverted,.cta-secondary-small > button.inverted {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #fff;\n    box-shadow: inset 0 0 0 3px #fff;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-secondary-small.inverted:hover,.cta-secondary-small > a.inverted:hover,.cta-secondary-small > button.inverted:hover {\n        -webkit-box-shadow:inset 0 0 0 3px #1765f4;\n        box-shadow: inset 0 0 0 3px #1765f4;\n    }\n\n    .cta-secondary-small.inverted:hover:disabled,.cta-secondary-small > a.inverted:hover:disabled,.cta-secondary-small > button.inverted:hover:disabled {\n        -webkit-box-shadow: inset 0 0 0 3px #bbb;\n        box-shadow: inset 0 0 0 3px #bbb;\n    }\n}\n\n.cta-secondary-small.inverted:active,.cta-secondary-small > a.inverted:active,.cta-secondary-small > button.inverted:active {\n    -webkit-box-shadow: inset 0 0 0 3px #062c57;\n    box-shadow: inset 0 0 0 3px #062c57;\n}\n\n.cta-secondary-small:disabled,.cta-secondary-small > a:disabled,.cta-secondary-small > button:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-secondary-small:disabled:hover,.cta-secondary-small > a:disabled:hover,.cta-secondary-small > button:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.cta-secondary-small.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.link-large:not(.flex),.link-large > a,.link-large button {\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.link-large:not(.flex):after,.link-large > a:after,.link-large button:after {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n@media (hover: hover) {\n    .link-large:not(.flex):hover,.link-large > a:hover,.link-large button:hover {\n        --text-opacity:1;\n        color: #1765f4;\n        color: rgba(23,101,244,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-large:not(.flex):hover:after,.link-large > a:hover:after,.link-large button:hover:after {\n        --bg-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-standard:not(.flex),.link-standard > a,.link-standard button {\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.link-standard:not(.flex):after,.link-standard > a:after,.link-standard button:after {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n@media (hover: hover) {\n    .link-standard:not(.flex):hover,.link-standard > a:hover,.link-standard button:hover {\n        --text-opacity:1;\n        color: #1765f4;\n        color: rgba(23,101,244,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-standard:not(.flex):hover:after,.link-standard > a:hover:after,.link-standard button:hover:after {\n        --bg-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-small:not(.flex),.link-small > a,.link-small button {\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.link-small:not(.flex):after,.link-small > a:after,.link-small button:after {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n@media (hover: hover) {\n    .link-small:not(.flex):hover,.link-small > a:hover,.link-small button:hover {\n        --text-opacity:1;\n        color: #1765f4;\n        color: rgba(23,101,244,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-small:not(.flex):hover:after,.link-small > a:hover:after,.link-small button:hover:after {\n        --bg-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.heading-one,h1,h1 > p {\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n}\n\n@media (min-width: 768px) {\n    .heading-one,h1,h1 > p {\n        font-size:40px;\n        line-height: 48px;\n    }\n}\n\n.heading-two,h2,h2 > p {\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n\n}\n\n@media (min-width: 768px) {\n    .heading-two,h2,h2 > p {\n        font-size:40px;\n        line-height: 48px;\n    }\n}\n\n.heading-three,h3,h3 > p {\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n}\n\n@media (min-width: 768px) {\n    .heading-three,h3,h3 > p {\n        font-size:24px;\n        line-height: 36px;\n    }\n}\n\n.heading-four,h4,h4 > p {\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n}\n\n@media (min-width: 1366px) {\n    .heading-four,h4,h4 > p {\n        letter-spacing:1.96px;\n    }\n}\n\n.heading-five,.heading-six,h5,h5 > p,h6,h6 > p {\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n}\n\n.display-one-home {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n    font-size: 32px;\n    line-height: 40px;\n}\n\n@media (min-width: 768px) {\n    .display-one-home {\n        font-size:52px;\n        line-height: 44px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .display-one-home {\n        font-size:60px;\n        line-height: 52px;\n    }\n}\n\n.display-two-home {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n   \n    font-size: 72px;\n    line-height: 56px;\n}\n\n@media (min-width: 768px) {\n    .display-two-home {\n        font-size:76px;\n        line-height: 68px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .display-two-home {\n        font-size:80px;\n        line-height: 72px;\n    }\n}\n\n.display-one {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 32px;\n}\n\n@media (min-width: 768px) {\n    .display-one {\n        font-size:40px;\n        line-height: 42px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .display-one {\n        font-size:40px;\n        line-height: 48px;\n    }\n}\n\n.display-two {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 72px;\n    line-height: 48px;\n}\n\n@media (min-width: 768px) {\n    .display-two {\n        font-size:124px;\n        line-height: 80px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .display-two {\n        font-size:136px;\n        line-height: 88px;\n    }\n}\n\n.hero-one {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 26px;\n    line-height: 32px;\n}\n\n@media (min-width: 1366px) {\n    .hero-one {\n        font-size:44px;\n        line-height: 48px;\n    }\n}\n\n.hero-two {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 72px;\n    line-height: 48px;\n}\n\n@media (min-width: 1366px) {\n    .hero-two {\n        font-size:138px;\n        line-height: 138px;\n    }\n}\n\n.standard-heading-one {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n    font-size: 32px;\n    line-height: 40px;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .standard-heading-one {\n        font-size:60px;\n        line-height: 68px;\n    }\n}\n\n.standard-heading-one h1,.standard-heading-one h2,.standard-heading-one h3,.standard-heading-one h4,.standard-heading-one p {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n    font-size: 32px;\n    line-height: 40px;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .standard-heading-one h1,.standard-heading-one h2,.standard-heading-one h3,.standard-heading-one h4,.standard-heading-one p {\n        font-size:60px;\n        line-height: 68px;\n    }\n}\n\n.standard-heading-two {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 32px;\n    line-height: 40px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .standard-heading-two {\n        font-size:60px;\n        line-height: 68px;\n    }\n}\n\n.standard-heading-two h1,.standard-heading-two h2,.standard-heading-two h3,.standard-heading-two h4,.standard-heading-two p {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 32px;\n    line-height: 40px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .standard-heading-two h1,.standard-heading-two h2,.standard-heading-two h3,.standard-heading-two h4,.standard-heading-two p {\n        font-size:60px;\n        line-height: 68px;\n    }\n}\n\nol li,ul li {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 24px;\n}\n\n.subtitle-one {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n\n    font-size: 24px;\n    letter-spacing: 0.19px;\n    line-height: 34px;\n}\n\n.subtitle-two {\n   \n    font-size: 20px;\n    letter-spacing: 0.16px;\n    line-height: 28px;\n}\n\n.body-large,.subtitle-two {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n}\n\n.body-large {\n   \n    letter-spacing: -0.28px;\n}\n\n.body-standard-16,p {\n    letter-spacing: 0.08px;\n}\n\n.body-bold-large {\n    letter-spacing: -0.28px;\n}\n\n.quote {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 28px;\n    line-height: 34px;\n}\n\n@media (min-width: 1366px) {\n    .quote {\n        font-size:38px;\n        line-height: 61px;\n    }\n}\n\n.style-title {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 88px;\n    line-height: 68px;\n}\n\n@media (min-width: 768px) {\n    .style-title {\n        font-size:80px;\n        line-height: 56px;\n    }\n}\n\n.caption {\n    font-size: 14px;\n    letter-spacing: 0.06px;\n}\n\n.caption,.caption-small {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    line-height: 14px;\n}\n\n.caption-small {\n    font-size: 12px;\n}\n\n.overline,.overline-article,.overline-article-dark,.overline-small {\n   \n    font-size: 14px;\n    line-height: 14px;\n    text-transform: uppercase;\n}\n\n.overline {\n    letter-spacing: 0.96px;\n}\n\n.overline,.overline-small {\n    --text-opacity: 1;\n    color: #1765f4;\n    color: rgba(23,101,244,var(--text-opacity));\n}\n\n.overline-small {\n    font-size: 12px;\n    line-height: 16px;\n}\n\n.overline-article {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    letter-spacing: 0.38px;\n}\n\n.button-link,.button-link-large,.button-link-large-white,.button-link-small,.button-link-white,.subtle-link {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 22px;\n}\n\n.button-link-small {\n    font-size: 14px;\n    line-height: 34px;\n}\n\n.button-link-large {\n    font-size: 18px;\n    line-height: 22px;\n}\n\n.button-link-large-white,.button-link-white {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.button-link-large-white {\n    font-size: 18px;\n    line-height: 22px;\n}\n\n.subtle-link {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n}\n\n.overline-crisis {\n    font-size: 14px;\n    line-height: 14px;\n}\n\n.overline-crisis,.overline-crisis-small {\n    --text-opacity: 1;\n    color: #f34436;\n    color: rgba(243,68,54,var(--text-opacity));\n   \n    text-transform: uppercase;\n}\n\n.overline-crisis-small {\n    font-size: 12px;\n    line-height: 16px;\n}\n\n.salary {\n    --text-opacity: 1;\n    color: #84c434;\n    color: rgba(132,196,52,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 14px;\n}\n\n@media (min-width: 1366px) {\n    .salary {\n        font-size:18px;\n        line-height: 14px;\n    }\n}\n\n.salary-large {\n    --text-opacity: 1;\n    color: #84c434;\n    color: rgba(132,196,52,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 14px;\n}\n\n@media (min-width: 1366px) {\n    .salary-large {\n        font-size:20px;\n        line-height: 14px;\n    }\n}\n\n.job-title-small {\n    font-size: 18px;\n    line-height: 20px;\n}\n\n.job-title-medium,.job-title-small {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n}\n\n.job-title-medium {\n    font-size: 20px;\n    line-height: 24px;\n}\n\n.job-title-large {\n    font-size: 22px;\n    line-height: 26px;\n}\n\n.job-title-large,.job-title-xlarge {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n}\n\n.job-title-xlarge {\n    font-size: 24px;\n    line-height: 32px;\n}\n\n.blog-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n\n    font-size: 22px;\n    line-height: 28px;\n}\n\n@media (min-width: 768px) {\n    .blog-title {\n        font-size:26px;\n        line-height: 32px;\n    }\n}\n\n.blog-title-large {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n\n    font-size: 22px;\n    font-size: 24px;\n    line-height: 28px;\n    line-height: 30px;\n}\n\n@media (min-width: 768px) {\n    .blog-title-large {\n        font-size:26px;\n        font-size: 30px;\n        line-height: 32px;\n        line-height: 38px;\n    }\n}\n\n.blog-title-grey {\n   \n    font-size: 26px;\n    line-height: 32px;\n}\n\n@media (min-width: 768px) {\n    .blog-title-grey {\n        font-size:30px;\n        line-height: 44px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .blog-title-grey {\n        font-size:36px;\n        line-height: 40px;\n    }\n}\n\n.blog-title-large-grey {\n   \n    font-size: 32px;\n    line-height: 40px;\n}\n\n@media (min-width: 768px) {\n    .blog-title-large-grey {\n        font-size:34px;\n        line-height: 40px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .blog-title-large-grey {\n        font-size:42px;\n        line-height: 56px;\n    }\n}\n\n.blog-overline {\n    --text-opacity: 1;\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n   \n    font-size: 14px;\n    line-height: 28px;\n}\n\n.form-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 26px;\n    line-height: 32px;\n}\n\n@media (min-width: 768px) {\n    .form-title {\n        font-size:24px;\n        line-height: 28px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .form-title {\n        font-size:32px;\n        line-height: 44px;\n    }\n}\n\n.form-label-top-min {\n    color: #131313;\n    color: rgba(19,19,19,var(--text-opacity));\n}\n\n.form-label-error,.form-label-top-min {\n    --text-opacity: 1;\n    font-size: 12px;\n    line-height: 16px;\n}\n\n.form-label-error {\n    color: #b0001f;\n    color: rgba(176,0,31,var(--text-opacity));\n}\n\n.form-label-min-default {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    font-size: 12px;\n    line-height: 14px;\n}\n\n.form-label-inactive {\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n}\n\n.form-label-entry,.form-label-inactive {\n    --text-opacity: 1;\n    font-size: 16px;\n    line-height: 16px;\n}\n\n.form-label-entry {\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n}\n\n.form-label-default {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    font-size: 16px;\n    line-height: 16px;\n}\n\n.job-card-tag {\n    --text-opacity: 1;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 10px;\n    line-height: 12px;\n    padding: 3px 10px;\n    right: 35px;\n    text-transform: uppercase;\n    top: 0;\n}\n\n@media (min-width: 1366px) {\n    .job-card-tag {\n        font-size:12px;\n        line-height: 15px;\n        padding: 7px 15px 8px;\n        right: 70px;\n    }\n\n    .job-card-tag-feature,.job-card-tag-hot {\n        right: 30px;\n    }\n}\n\n.job-card-tag-locum {\n    background-color: #0895a3;\n}\n\n.job-card-tag-perm {\n    background-color: #4eaef2;\n}\n\n.job-card-tag-remote {\n    background-color: #0895a3;\n}\n\n.job-card-tag-recent-view {\n    padding: 2px 10px;\n    right: 30px;\n    top: -16px;\n}\n\n/* .fa {\n    font-family: Font Awesome\\6 Pro;\n    font-family: var(--fa-style-family,\"Font Awesome 6 Pro\");\n    font-weight: 900;\n    font-weight: var(--fa-style,900);\n} */\n\n.checkedList li:before,.fa,.fa-brands,.fa-duotone,.fa-light,.fa-regular,.fa-solid,.fa-thin,.fab,.fad,.fal,.far,.fas,.fat,.news-content-main-set ul li:before,.rich-text ul li:before {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n    text-rendering: auto;\n    display: inline-block;\n    display: var(--fa-display,inline-block);\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n}\n\n.fa-1x {\n    font-size: 1em;\n}\n\n.fa-2x {\n    font-size: 2em;\n}\n\n.fa-3x {\n    font-size: 3em;\n}\n\n.fa-4x {\n    font-size: 4em;\n}\n\n.fa-5x {\n    font-size: 5em;\n}\n\n.fa-6x {\n    font-size: 6em;\n}\n\n.fa-7x {\n    font-size: 7em;\n}\n\n.fa-8x {\n    font-size: 8em;\n}\n\n.fa-9x {\n    font-size: 9em;\n}\n\n.fa-10x {\n    font-size: 10em;\n}\n\n.fa-2xs {\n    font-size: 0.625em;\n    line-height: 0.1em;\n    vertical-align: 0.225em;\n}\n\n.fa-xs {\n    font-size: 0.75em;\n    line-height: 0.0833333333em;\n    vertical-align: 0.125em;\n}\n\n.fa-sm {\n    font-size: 0.875em;\n    line-height: 0.0714285714em;\n    vertical-align: 0.0535714286em;\n}\n\n.fa-lg {\n    font-size: 1.25em;\n    line-height: 0.05em;\n    vertical-align: -0.075em;\n}\n\n.fa-xl {\n    font-size: 1.5em;\n    line-height: 0.0416666667em;\n    vertical-align: -0.125em;\n}\n\n.fa-2xl {\n    font-size: 2em;\n    line-height: 0.03125em;\n    vertical-align: -0.1875em;\n}\n\n.fa-fw {\n    text-align: center;\n    width: 1.25em;\n}\n\n.fa-ul {\n    list-style-type: none;\n    margin-left: 2.5em;\n    margin-left: var(--fa-li-margin,2.5em);\n    padding-left: 0;\n}\n\n.fa-ul > li {\n    position: relative;\n}\n\n.fa-li {\n    left: -2em;\n    left: calc(var(--fa-li-width,2em) * -1);\n    line-height: inherit;\n    position: absolute;\n    text-align: center;\n    width: 2em;\n    width: var(--fa-li-width,2em);\n}\n\n.fa-border {\n    border: 0.08em solid #eee;\n    border: var(--fa-border-width,0.08em) var(--fa-border-style,solid) var(--fa-border-color,#eee);\n    border-radius: 0.1em;\n    border-radius: var(--fa-border-radius,0.1em);\n    padding: 0.2em 0.25em 0.15em;\n    padding: var(--fa-border-padding,0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n    float: left;\n    margin-right: 0.3em;\n    margin-right: var(--fa-pull-margin,0.3em);\n}\n\n.fa-pull-right {\n    float: right;\n    margin-left: 0.3em;\n    margin-left: var(--fa-pull-margin,0.3em);\n}\n\n.fa-beat {\n    -webkit-animation-delay: 0;\n    animation-delay: 0;\n    -webkit-animation-delay: var(--fa-animation-delay,0);\n    animation-delay: var(--fa-animation-delay,0);\n    -webkit-animation-direction: normal;\n    animation-direction: normal;\n    -webkit-animation-direction: var(--fa-animation-direction,normal);\n    animation-direction: var(--fa-animation-direction,normal);\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-duration: var(--fa-animation-duration,1s);\n    animation-duration: var(--fa-animation-duration,1s);\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    -webkit-animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    -webkit-animation-name: fa-beat;\n    animation-name: fa-beat;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n    -webkit-animation-timing-function: var(--fa-animation-timing,ease-in-out);\n    animation-timing-function: var(--fa-animation-timing,ease-in-out);\n}\n\n.fa-fade {\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    -webkit-animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    -webkit-animation-name: fa-fade;\n    animation-name: fa-fade;\n    -webkit-animation-timing-function: cubic-bezier(0.4,0,0.6,1);\n    animation-timing-function: cubic-bezier(0.4,0,0.6,1);\n    -webkit-animation-timing-function: var(--fa-animation-timing,cubic-bezier(0.4,0,0.6,1));\n    animation-timing-function: var(--fa-animation-timing,cubic-bezier(0.4,0,0.6,1));\n}\n\n.fa-fade,.fa-flash {\n    -webkit-animation-delay: 0;\n    animation-delay: 0;\n    -webkit-animation-delay: var(--fa-animation-delay,0);\n    animation-delay: var(--fa-animation-delay,0);\n    -webkit-animation-direction: normal;\n    animation-direction: normal;\n    -webkit-animation-direction: var(--fa-animation-direction,normal);\n    animation-direction: var(--fa-animation-direction,normal);\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-duration: var(--fa-animation-duration,1s);\n    animation-duration: var(--fa-animation-duration,1s);\n}\n\n.fa-flash {\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    -webkit-animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    -webkit-animation-name: fa-flash;\n    animation-name: fa-flash;\n    -webkit-animation-timing-function: cubic-bezier(0.4,0,0.6,1);\n    animation-timing-function: cubic-bezier(0.4,0,0.6,1);\n    -webkit-animation-timing-function: var(--fa-animation-timing,cubic-bezier(0.4,0,0.6,1));\n    animation-timing-function: var(--fa-animation-timing,cubic-bezier(0.4,0,0.6,1));\n}\n\n.fa-flip {\n    -webkit-animation-delay: 0;\n    animation-delay: 0;\n    -webkit-animation-delay: var(--fa-animation-delay,0);\n    animation-delay: var(--fa-animation-delay,0);\n    -webkit-animation-direction: normal;\n    animation-direction: normal;\n    -webkit-animation-direction: var(--fa-animation-direction,normal);\n    animation-direction: var(--fa-animation-direction,normal);\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-duration: var(--fa-animation-duration,1s);\n    animation-duration: var(--fa-animation-duration,1s);\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    -webkit-animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    -webkit-animation-name: fa-flip;\n    animation-name: fa-flip;\n    -webkit-animation-timing-function: ease-in-out;\n    animation-timing-function: ease-in-out;\n    -webkit-animation-timing-function: var(--fa-animation-timing,ease-in-out);\n    animation-timing-function: var(--fa-animation-timing,ease-in-out);\n}\n\n.fa-spin {\n    -webkit-animation-delay: 0;\n    animation-delay: 0;\n    -webkit-animation-delay: var(--fa-animation-delay,0);\n    animation-delay: var(--fa-animation-delay,0);\n    -webkit-animation-direction: normal;\n    animation-direction: normal;\n    -webkit-animation-direction: var(--fa-animation-direction,normal);\n    animation-direction: var(--fa-animation-direction,normal);\n    -webkit-animation-duration: 2s;\n    animation-duration: 2s;\n    -webkit-animation-duration: var(--fa-animation-duration,2s);\n    animation-duration: var(--fa-animation-duration,2s);\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    -webkit-animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    -webkit-animation-name: fa-spin;\n    animation-name: fa-spin;\n    -webkit-animation-timing-function: linear;\n    animation-timing-function: linear;\n    -webkit-animation-timing-function: var(--fa-animation-timing,linear);\n    animation-timing-function: var(--fa-animation-timing,linear);\n}\n\n.fa-spin-reverse {\n    --fa-animation-direction: reverse;\n}\n\n.fa-pulse,.fa-spin-pulse {\n    -webkit-animation-direction: normal;\n    animation-direction: normal;\n    -webkit-animation-direction: var(--fa-animation-direction,normal);\n    animation-direction: var(--fa-animation-direction,normal);\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-duration: var(--fa-animation-duration,1s);\n    animation-duration: var(--fa-animation-duration,1s);\n    -webkit-animation-iteration-count: infinite;\n    animation-iteration-count: infinite;\n    -webkit-animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    animation-iteration-count: var(--fa-animation-iteration-count,infinite);\n    -webkit-animation-name: fa-spin;\n    animation-name: fa-spin;\n    -webkit-animation-timing-function: steps(8);\n    animation-timing-function: steps(8);\n    -webkit-animation-timing-function: var(--fa-animation-timing,steps(8));\n    animation-timing-function: var(--fa-animation-timing,steps(8));\n}\n\n@media (prefers-reduced-motion:reduce) {\n    .fa-beat,.fa-fade,.fa-flash,.fa-flip,.fa-pulse,.fa-spin,.fa-spin-pulse {\n        -webkit-animation-delay: -1ms;\n        animation-delay: -1ms;\n        -webkit-animation-duration: 1ms;\n        animation-duration: 1ms;\n        -webkit-animation-iteration-count: 1;\n        animation-iteration-count: 1;\n        -webkit-transition-delay: 0s;\n        -o-transition-delay: 0s;\n        transition-delay: 0s;\n        -webkit-transition-duration: 0s;\n        -o-transition-duration: 0s;\n        transition-duration: 0s;\n    }\n}\n\n@-webkit-keyframes fa-beat {\n    0%,90% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n\n    45% {\n        -webkit-transform: scale(1.25);\n        transform: scale(1.25);\n        -webkit-transform: scale(var(--fa-beat-scale,1.25));\n        transform: scale(var(--fa-beat-scale,1.25));\n    }\n}\n\n@keyframes fa-beat {\n    0%,90% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n\n    45% {\n        -webkit-transform: scale(1.25);\n        transform: scale(1.25);\n        -webkit-transform: scale(var(--fa-beat-scale,1.25));\n        transform: scale(var(--fa-beat-scale,1.25));\n    }\n}\n\n@-webkit-keyframes fa-fade {\n    50% {\n        opacity: 0.4;\n        opacity: var(--fa-fade-opacity,0.4);\n    }\n}\n\n@keyframes fa-fade {\n    50% {\n        opacity: 0.4;\n        opacity: var(--fa-fade-opacity,0.4);\n    }\n}\n\n@-webkit-keyframes fa-flash {\n    0%,to {\n        opacity: 0.4;\n        opacity: var(--fa-flash-opacity,0.4);\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 1;\n        -webkit-transform: scale(1.125);\n        transform: scale(1.125);\n        -webkit-transform: scale(var(--fa-flash-scale,1.125));\n        transform: scale(var(--fa-flash-scale,1.125));\n    }\n}\n\n@keyframes fa-flash {\n    0%,to {\n        opacity: 0.4;\n        opacity: var(--fa-flash-opacity,0.4);\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 1;\n        -webkit-transform: scale(1.125);\n        transform: scale(1.125);\n        -webkit-transform: scale(var(--fa-flash-scale,1.125));\n        transform: scale(var(--fa-flash-scale,1.125));\n    }\n}\n\n@-webkit-keyframes fa-flip {\n    50% {\n        -webkit-transform: rotateY(-180deg);\n        transform: rotateY(-180deg);\n        -webkit-transform: rotate3d(var(--fa-flip-x,0),var(--fa-flip-y,1),var(--fa-flip-z,0),var(--fa-flip-angle,-180deg));\n        transform: rotate3d(var(--fa-flip-x,0),var(--fa-flip-y,1),var(--fa-flip-z,0),var(--fa-flip-angle,-180deg));\n    }\n}\n\n@keyframes fa-flip {\n    50% {\n        -webkit-transform: rotateY(-180deg);\n        transform: rotateY(-180deg);\n        -webkit-transform: rotate3d(var(--fa-flip-x,0),var(--fa-flip-y,1),var(--fa-flip-z,0),var(--fa-flip-angle,-180deg));\n        transform: rotate3d(var(--fa-flip-x,0),var(--fa-flip-y,1),var(--fa-flip-z,0),var(--fa-flip-angle,-180deg));\n    }\n}\n\n@-webkit-keyframes fa-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn);\n    }\n}\n\n@keyframes fa-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn);\n    }\n}\n\n.fa-rotate-90 {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n    -webkit-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n    transform: scaleX(-1);\n}\n\n.fa-flip-vertical {\n    -webkit-transform: scaleY(-1);\n    -ms-transform: scaleY(-1);\n    transform: scaleY(-1);\n}\n\n.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical {\n    -webkit-transform: scale(-1);\n    -ms-transform: scale(-1);\n    transform: scale(-1);\n}\n\n.fa-rotate-by {\n    -webkit-transform: rotate(none);\n    -ms-transform: rotate(none);\n    transform: rotate(none);\n    -webkit-transform: rotate(var(--fa-rotate-angle,none));\n    -ms-transform: rotate(var(--fa-rotate-angle,none));\n    transform: rotate(var(--fa-rotate-angle,none));\n}\n\n.fa-stack {\n    display: inline-block;\n    height: 2em;\n    line-height: 2em;\n    position: relative;\n    vertical-align: middle;\n    width: 2.5em;\n}\n\n.fa-stack-1x,.fa-stack-2x {\n    left: 0;\n    position: absolute;\n    text-align: center;\n    width: 100%;\n    z-index: auto;\n    z-index: var(--fa-stack-z-index,auto);\n}\n\n.fa-stack-1x {\n    line-height: inherit;\n}\n\n.fa-stack-2x {\n    font-size: 2em;\n}\n\n.fa-inverse {\n    color: #fff;\n    color: var(--fa-inverse,#fff);\n}\n\n\n.breadcrumbs li {\n    display: inline;\n   \n    font-size: 16px;\n    line-height: 32px;\n    margin-right: 4px;\n}\n\n.breadcrumbs li:before {\n    border-right: 1.6px solid;\n    content: \"\";\n    display: inline-block;\n    height: 0.8em;\n    margin-right: 7px;\n    -webkit-transform: rotate(15deg);\n    -ms-transform: rotate(15deg);\n    transform: rotate(15deg);\n}\n\n.breadcrumbs li:first-of-type:before {\n    display: none;\n}\n\n.breadcrumbs li a {\n    display: inline-block;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.breadcrumbs li a:after {\n    background-color: currentColor;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transform: translateY(-5px);\n    -ms-transform: translateY(-5px);\n    transform: translateY(-5px);\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.breadcrumbs li a:hover {\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.breadcrumbs li a:hover:after {\n    opacity: 1;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.breadcrumbs li {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n.breadcrumbs li:last-of-type {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.breadcrumbs--light li {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.breadcrumbs--light li:last-of-type {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.cta-primary-large {\n    padding-bottom: 12px;\n    padding-top: 12px;\n}\n\n.cta-primary-large,.cta-primary-large > a,.cta-primary-large > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 24px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding-left: 32px;\n    padding-right: 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-primary-large:hover,.cta-primary-large > a:hover,.cta-primary-large > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-large > a > span,.cta-primary-large > a i,.cta-primary-large > a svg,.cta-primary-large > button > span,.cta-primary-large > button i,.cta-primary-large > button svg,.cta-primary-large > span,.cta-primary-large i,.cta-primary-large svg {\n    display: inline;\n}\n\n.cta-primary-large > a svg,.cta-primary-large > button svg,.cta-primary-large svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-primary-large:disabled,.cta-primary-large > a:disabled,.cta-primary-large > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-primary-large:disabled:hover:disabled,.cta-primary-large > a:disabled:hover:disabled,.cta-primary-large > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.cta-primary-large.inverted,.cta-primary-large > a.inverted,.cta-primary-large > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-large.inverted:hover,.cta-primary-large > a.inverted:hover,.cta-primary-large > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.cta-primary-large.inverted:active,.cta-primary-large > a.inverted:active,.cta-primary-large > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.cta-primary-large.inverted:disabled,.cta-primary-large > a.inverted:disabled,.cta-primary-large > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .cta-primary-large.inverted:disabled:hover,.cta-primary-large > a.inverted:disabled:hover,.cta-primary-large > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.cta-primary-large.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-medium,.cta-primary-medium > a,.cta-primary-medium > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 16px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-primary-medium:hover,.cta-primary-medium > a:hover,.cta-primary-medium > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-medium > a > span,.cta-primary-medium > a i,.cta-primary-medium > a svg,.cta-primary-medium > button > span,.cta-primary-medium > button i,.cta-primary-medium > button svg,.cta-primary-medium > span,.cta-primary-medium i,.cta-primary-medium svg {\n    display: inline;\n}\n\n.cta-primary-medium > a svg,.cta-primary-medium > button svg,.cta-primary-medium svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-primary-medium:disabled,.cta-primary-medium > a:disabled,.cta-primary-medium > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-primary-medium:disabled:hover:disabled,.cta-primary-medium > a:disabled:hover:disabled,.cta-primary-medium > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.cta-primary-medium.inverted,.cta-primary-medium > a.inverted,.cta-primary-medium > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-medium.inverted:hover,.cta-primary-medium > a.inverted:hover,.cta-primary-medium > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.cta-primary-medium.inverted:active,.cta-primary-medium > a.inverted:active,.cta-primary-medium > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.cta-primary-medium.inverted:disabled,.cta-primary-medium > a.inverted:disabled,.cta-primary-medium > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .cta-primary-medium.inverted:disabled:hover,.cta-primary-medium > a.inverted:disabled:hover,.cta-primary-medium > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.cta-primary-medium.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-small,.cta-primary-small > a,.cta-primary-small > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 14px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    padding: 10px 24px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-primary-small:hover,.cta-primary-small > a:hover,.cta-primary-small > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-small > a > span,.cta-primary-small > a i,.cta-primary-small > a svg,.cta-primary-small > button > span,.cta-primary-small > button i,.cta-primary-small > button svg,.cta-primary-small > span,.cta-primary-small i,.cta-primary-small svg {\n    display: inline;\n}\n\n.cta-primary-small > a svg,.cta-primary-small > button svg,.cta-primary-small svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-primary-small:disabled,.cta-primary-small > a:disabled,.cta-primary-small > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-primary-small:disabled:hover:disabled,.cta-primary-small > a:disabled:hover:disabled,.cta-primary-small > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.cta-primary-small.inverted,.cta-primary-small > a.inverted,.cta-primary-small > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-small.inverted:hover,.cta-primary-small > a.inverted:hover,.cta-primary-small > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.cta-primary-small.inverted:active,.cta-primary-small > a.inverted:active,.cta-primary-small > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.cta-primary-small.inverted:disabled,.cta-primary-small > a.inverted:disabled,.cta-primary-small > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .cta-primary-small.inverted:disabled:hover,.cta-primary-small > a.inverted:disabled:hover,.cta-primary-small > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.cta-primary-small.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-icon-large,.cta-primary-icon-large > a,.cta-primary-icon-large > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 24px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding: 12px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-large:hover,.cta-primary-icon-large > a:hover,.cta-primary-icon-large > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-icon-large > a > span,.cta-primary-icon-large > a i,.cta-primary-icon-large > a svg,.cta-primary-icon-large > button > span,.cta-primary-icon-large > button i,.cta-primary-icon-large > button svg,.cta-primary-icon-large > span,.cta-primary-icon-large i,.cta-primary-icon-large svg {\n    display: inline;\n}\n\n.cta-primary-icon-large > a svg,.cta-primary-icon-large > button svg,.cta-primary-icon-large svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-primary-icon-large:disabled,.cta-primary-icon-large > a:disabled,.cta-primary-icon-large > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-large:disabled:hover:disabled,.cta-primary-icon-large > a:disabled:hover:disabled,.cta-primary-icon-large > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.cta-primary-icon-large.inverted,.cta-primary-icon-large > a.inverted,.cta-primary-icon-large > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-large.inverted:hover,.cta-primary-icon-large > a.inverted:hover,.cta-primary-icon-large > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.cta-primary-icon-large.inverted:active,.cta-primary-icon-large > a.inverted:active,.cta-primary-icon-large > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.cta-primary-icon-large.inverted:disabled,.cta-primary-icon-large > a.inverted:disabled,.cta-primary-icon-large > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-large.inverted:disabled:hover,.cta-primary-icon-large > a.inverted:disabled:hover,.cta-primary-icon-large > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.cta-primary-icon-large:after,.cta-primary-icon-large > a:after,.cta-primary-icon-large > button:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 12px;\n    position: relative;\n}\n\n.cta-primary-icon-large.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-icon-medium,.cta-primary-icon-medium > a,.cta-primary-icon-medium > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 16px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-medium:hover,.cta-primary-icon-medium > a:hover,.cta-primary-icon-medium > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-icon-medium > a > span,.cta-primary-icon-medium > a i,.cta-primary-icon-medium > a svg,.cta-primary-icon-medium > button > span,.cta-primary-icon-medium > button i,.cta-primary-icon-medium > button svg,.cta-primary-icon-medium > span,.cta-primary-icon-medium i,.cta-primary-icon-medium svg {\n    display: inline;\n}\n\n.cta-primary-icon-medium > a svg,.cta-primary-icon-medium > button svg,.cta-primary-icon-medium svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-primary-icon-medium:disabled,.cta-primary-icon-medium > a:disabled,.cta-primary-icon-medium > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-medium:disabled:hover:disabled,.cta-primary-icon-medium > a:disabled:hover:disabled,.cta-primary-icon-medium > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.cta-primary-icon-medium.inverted,.cta-primary-icon-medium > a.inverted,.cta-primary-icon-medium > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-medium.inverted:hover,.cta-primary-icon-medium > a.inverted:hover,.cta-primary-icon-medium > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.cta-primary-icon-medium.inverted:active,.cta-primary-icon-medium > a.inverted:active,.cta-primary-icon-medium > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.cta-primary-icon-medium.inverted:disabled,.cta-primary-icon-medium > a.inverted:disabled,.cta-primary-icon-medium > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-medium.inverted:disabled:hover,.cta-primary-icon-medium > a.inverted:disabled:hover,.cta-primary-icon-medium > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.cta-primary-icon-medium:after,.cta-primary-icon-medium > a:after,.cta-primary-icon-medium > button:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 8px;\n    position: relative;\n}\n\n.cta-primary-icon-medium.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-icon-small,.cta-primary-icon-small > a,.cta-primary-icon-small > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 14px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    padding: 10px 24px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-small:hover,.cta-primary-icon-small > a:hover,.cta-primary-icon-small > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-primary-icon-small > a > span,.cta-primary-icon-small > a i,.cta-primary-icon-small > a svg,.cta-primary-icon-small > button > span,.cta-primary-icon-small > button i,.cta-primary-icon-small > button svg,.cta-primary-icon-small > span,.cta-primary-icon-small i,.cta-primary-icon-small svg {\n    display: inline;\n}\n\n.cta-primary-icon-small > a svg,.cta-primary-icon-small > button svg,.cta-primary-icon-small svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.cta-primary-icon-small:disabled,.cta-primary-icon-small > a:disabled,.cta-primary-icon-small > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-small:disabled:hover:disabled,.cta-primary-icon-small > a:disabled:hover:disabled,.cta-primary-icon-small > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.cta-primary-icon-small.inverted,.cta-primary-icon-small > a.inverted,.cta-primary-icon-small > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-small.inverted:hover,.cta-primary-icon-small > a.inverted:hover,.cta-primary-icon-small > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.cta-primary-icon-small.inverted:active,.cta-primary-icon-small > a.inverted:active,.cta-primary-icon-small > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.cta-primary-icon-small.inverted:disabled,.cta-primary-icon-small > a.inverted:disabled,.cta-primary-icon-small > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .cta-primary-icon-small.inverted:disabled:hover,.cta-primary-icon-small > a.inverted:disabled:hover,.cta-primary-icon-small > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.cta-primary-icon-small:after,.cta-primary-icon-small > a:after,.cta-primary-icon-small > button:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 8px;\n    position: relative;\n}\n\n.cta-primary-icon-small.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-underlined,.cta-primary-underlined > a,.cta-primary-underlined > button {\n    --text-opacity: 1;\n    color: #6639b7;\n    color: rgba(102,57,183,var(--text-opacity));\n    display: block;\n    font-size: 24px;\n    height: auto;\n    position: relative;\n    text-align: left;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.cta-primary-underlined:before,.cta-primary-underlined > a:before,.cta-primary-underlined > button:before {\n    content: \"ïŒ‹\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    position: absolute;\n    right: -50px;\n}\n\n.cta-primary-underlined.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-underlined:after {\n    --bg-opacity: 1;\n    background-color: #6639b7;\n    background-color: rgba(102,57,183,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 5px;\n    opacity: 1;\n    position: relative;\n    width: 110%;\n    width: calc(100% + 50px);\n}\n\n@media (hover: hover) {\n    .cta-primary-underlined:hover:after {\n        opacity:0;\n        -webkit-transition: opacity 0.2s ease-in-out;\n        -o-transition: opacity 0.2s ease-in-out;\n        transition: opacity 0.2s ease-in-out;\n    }\n}\n\n.cta-primary-underlined-blue,.cta-primary-underlined-blue > a,.cta-primary-underlined-blue > button {\n    color: #6639b7;\n    color: rgba(102,57,183,var(--text-opacity));\n    display: block;\n    font-size: 24px;\n    height: auto;\n    position: relative;\n    text-align: left;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.cta-primary-underlined-blue:before,.cta-primary-underlined-blue > a:before,.cta-primary-underlined-blue > button:before {\n    content: \"ïŒ‹\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    position: absolute;\n    right: -50px;\n}\n\n.cta-primary-underlined-blue.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-underlined-blue:after {\n    --bg-opacity: 1;\n    background-color: #6639b7;\n    background-color: rgba(102,57,183,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 5px;\n    opacity: 1;\n    position: relative;\n    width: 110%;\n    width: calc(100% + 50px);\n}\n\n@media (hover: hover) {\n    .cta-primary-underlined-blue:hover:after {\n        opacity:0;\n        -webkit-transition: opacity 0.2s ease-in-out;\n        -o-transition: opacity 0.2s ease-in-out;\n        transition: opacity 0.2s ease-in-out;\n    }\n}\n\n.cta-primary-underlined-blue,.cta-primary-underlined-blue > a,.cta-primary-underlined-blue > button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n}\n\n.cta-primary-underlined-blue:after,.cta-primary-underlined-blue > a:after,.cta-primary-underlined-blue > button:after {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n}\n\n.cta-primary-underlined-navy,.cta-primary-underlined-navy > a,.cta-primary-underlined-navy > button {\n    color: #6639b7;\n    color: rgba(102,57,183,var(--text-opacity));\n    display: block;\n    font-size: 24px;\n    height: auto;\n    position: relative;\n    text-align: left;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.cta-primary-underlined-navy:before,.cta-primary-underlined-navy > a:before,.cta-primary-underlined-navy > button:before {\n    content: \"ïŒ‹\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    position: absolute;\n    right: -50px;\n}\n\n.cta-primary-underlined-navy.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.cta-primary-underlined-navy:after {\n    --bg-opacity: 1;\n    background-color: #6639b7;\n    background-color: rgba(102,57,183,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 5px;\n    opacity: 1;\n    position: relative;\n    width: 110%;\n    width: calc(100% + 50px);\n}\n\n@media (hover: hover) {\n    .cta-primary-underlined-navy:hover:after {\n        opacity:0;\n        -webkit-transition: opacity 0.2s ease-in-out;\n        -o-transition: opacity 0.2s ease-in-out;\n        transition: opacity 0.2s ease-in-out;\n    }\n}\n\n.cta-primary-underlined-navy,.cta-primary-underlined-navy > a,.cta-primary-underlined-navy > button {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n}\n\n.cta-primary-underlined-navy:after,.cta-primary-underlined-navy > a:after,.cta-primary-underlined-navy > button:after {\n    --bg-opacity: 1;\n    background-color: #003c69;\n    background-color: rgba(0,60,105,var(--bg-opacity));\n}\n\n.cta-secondary-large {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: inline-block;\n    font-size: 24px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding: 12px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-secondary-large:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-secondary-large > span,.cta-secondary-large i,.cta-secondary-large svg {\n    display: inline;\n}\n\n.cta-secondary-large svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .cta-secondary-large:hover {\n        --bg-opacity:1;\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n    }\n}\n\n.cta-secondary-large:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-secondary-large:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.cta-secondary-large:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 12px;\n    position: relative;\n}\n\n.cta-secondary-medium {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: inline-block;\n    \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 16px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-secondary-medium:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-secondary-medium > span,.cta-secondary-medium i,.cta-secondary-medium svg {\n    display: inline;\n}\n\n.cta-secondary-medium svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .cta-secondary-medium:hover {\n        --bg-opacity:1;\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n    }\n}\n\n.cta-secondary-medium:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-secondary-medium:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.cta-secondary-medium:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 8px;\n    position: relative;\n}\n\n.cta-secondary-small {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: inline-block;\n    \n    font-size: 14px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    padding: 10px 24px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .cta-secondary-small:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.cta-secondary-small > span,.cta-secondary-small i,.cta-secondary-small svg {\n    display: inline;\n}\n\n.cta-secondary-small svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .cta-secondary-small:hover {\n        --bg-opacity:1;\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n    }\n}\n\n.cta-secondary-small:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .cta-secondary-small:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.cta-secondary-small:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 8px;\n    position: relative;\n}\n\n.ghost-button {\n    border: 2px solid #0094d9;\n    border-radius: 8px;\n    color: #0065c0 !important;\n    display: inline-block;\n    \n    font-size: 14px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    min-width: 144px;\n    padding: 10px 24px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .ghost-button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.ghost-button > span,.ghost-button i,.ghost-button svg {\n    display: inline;\n}\n\n.ghost-button svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.ghost-button:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 8px;\n    position: relative;\n}\n\n@media (hover: hover) {\n    .ghost-button:hover {\n        background-color:#0094d9;\n        color: #fff !important;\n    }\n}\n\n.blog-tag {\n    border: 2px solid #0098db;\n    border-radius: 8px;\n    color: #005bbb !important;\n    display: inline-block;\n    \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 6px 16px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .blog-tag:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.blog-tag > span,.blog-tag i,.blog-tag svg {\n    display: inline;\n}\n\n.blog-tag svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .blog-tag:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n    }\n}\n\n.blog-tag-link {\n    border: 2px solid #0098db;\n    border-radius: 8px;\n    color: #005bbb !important;\n    display: inline-block;\n    \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 6px 16px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .blog-tag-link:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.blog-tag-link > span,.blog-tag-link i,.blog-tag-link svg {\n    display: inline;\n}\n\n.blog-tag-link svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .blog-tag-link:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        color: #fff !important;\n    }\n}\n\n.tag-button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n    \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 8px 16px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .tag-button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.tag-button > span,.tag-button i,.tag-button svg {\n    display: inline;\n}\n\n.tag-button svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.tag-button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .tag-button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.tag-button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .tag-button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.tag-button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.tag-button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .tag-button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n@media (hover: hover) {\n    .tag-button:hover {\n        --bg-opacity:1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n    }\n}\n\n@media (min-width: 1366px) {\n    .tag-button {\n        height:auto;\n        padding: 16px 32px;\n    }\n}\n\n.favorite-button {\n    border-color: #0977a9;\n}\n\n.link-large:not(.flex),.link-large > a,.link-large button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n    \n    font-size: 18px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.link-large:not(.flex):before,.link-large > a:before,.link-large button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.link-large:not(.flex):after,.link-large > a:after,.link-large button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .link-large:not(.flex):hover,.link-large > a:hover,.link-large button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-large:not(.flex):hover:before,.link-large > a:hover:before,.link-large button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-large:not(.flex).wrapper:after,.link-large > a.wrapper:after,.link-large button.wrapper:after {\n    width: 0;\n}\n\n.link-large.inline {\n    display: inline-block;\n}\n\n.link-standard:not(.flex),.link-standard > a,.link-standard button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 16px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.link-standard:not(.flex):before,.link-standard > a:before,.link-standard button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.link-standard:not(.flex):after,.link-standard > a:after,.link-standard button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .link-standard:not(.flex):hover,.link-standard > a:hover,.link-standard button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-standard:not(.flex):hover:before,.link-standard > a:hover:before,.link-standard button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-standard:not(.flex).wrapper:after,.link-standard > a.wrapper:after,.link-standard button.wrapper:after {\n    width: 0;\n}\n\n.link-standard.inline {\n    display: inline-block;\n}\n\n.link-small:not(.flex),.link-small > a,.link-small button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 14px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.link-small:not(.flex):before,.link-small > a:before,.link-small button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.link-small:not(.flex):after,.link-small > a:after,.link-small button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .link-small:not(.flex):hover,.link-small > a:hover,.link-small button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-small:not(.flex):hover:before,.link-small > a:hover:before,.link-small button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-small:not(.flex).wrapper:after,.link-small > a.wrapper:after,.link-small button.wrapper:after {\n    width: 0;\n}\n\n.link-small.inline {\n    display: inline-block;\n}\n\n.link-large-caret:not(.flex),.link-large-caret button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.link-large-caret:not(.flex):before,.link-large-caret button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.link-large-caret:not(.flex):after,.link-large-caret button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .link-large-caret:not(.flex):hover,.link-large-caret button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-large-caret:not(.flex):hover:before,.link-large-caret button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-large-caret:not(.flex).wrapper:after,.link-large-caret button.wrapper:after {\n    width: 0;\n}\n\n.link-large-caret:not(.flex):after,.link-large-caret button:after {\n    content: \"âŒª\";\n    display: inline-block;\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    padding-left: 4px;\n    position: relative;\n}\n\n.link-large-caret.inline {\n    display: inline-block;\n}\n\n.link-standard-caret:not(.flex),.link-standard-caret button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 16px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.link-standard-caret:not(.flex):before,.link-standard-caret button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.link-standard-caret:not(.flex):after,.link-standard-caret button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .link-standard-caret:not(.flex):hover,.link-standard-caret button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-standard-caret:not(.flex):hover:before,.link-standard-caret button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-standard-caret:not(.flex).wrapper:after,.link-standard-caret button.wrapper:after {\n    width: 0;\n}\n\n.link-standard-caret:not(.flex):after,.link-standard-caret button:after {\n    content: \"âŒª\";\n    display: inline-block;\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    padding-left: 4px;\n    position: relative;\n}\n\n.link-standard-caret.inline {\n    display: inline-block;\n}\n\n.link-small-caret:not(.flex),.link-small-caret button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 14px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.link-small-caret:not(.flex):before,.link-small-caret button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.link-small-caret:not(.flex):after,.link-small-caret button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .link-small-caret:not(.flex):hover,.link-small-caret button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .link-small-caret:not(.flex):hover:before,.link-small-caret button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.link-small-caret:not(.flex).wrapper:after,.link-small-caret button.wrapper:after {\n    width: 0;\n}\n\n.link-small-caret:not(.flex):after,.link-small-caret button:after {\n    content: \"âŒª\";\n    display: inline-block;\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    padding-left: 4px;\n    position: relative;\n}\n\n.link-small-caret.inline {\n    display: inline-block;\n}\n\nhtml {\n    -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n\n.section-container {\n    margin: 0 auto;\n    padding: 24px 12px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .section-container {\n        margin:0 auto;\n        max-width: 90%;\n        padding: 24px 12px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .section-container {\n        max-width:1328px;\n        padding: 0px 0;\n    }\n}\n\n.heading-one,h1,h1 > p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n    font-size: 40px;\n    line-height: 44px;\n}\n\n@media (min-width: 1366px) {\n    .heading-one,h1,h1 > p {\n        font-size:56px;\n        line-height: 60px;\n    }\n}\n\n.heading-two,h2,h2 > p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n    font-size: 32px;\n    line-height: 36px;\n}\n\n@media (min-width: 1366px) {\n    .heading-two,h2,h2 > p {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n.heading-three,h3,h3 > p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n    font-size: 24px;\n    line-height: 28px;\n}\n\n@media (min-width: 1366px) {\n    .heading-three,h3,h3 > p {\n        font-size:40px;\n        line-height: 44px;\n    }\n}\n\n.heading-four,h4,h4 > p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n    font-size: 16px;\n    line-height: 20px;\n}\n\n@media (min-width: 1366px) {\n    .heading-four,h4,h4 > p {\n        font-size:32px;\n        line-height: 36px;\n    }\n}\n\n.heading-five,h5,h5 > p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n    font-size: 16px;\n    line-height: 20px;\n}\n\n@media (min-width: 1366px) {\n    .heading-five,h5,h5 > p {\n        font-size:24px;\n        line-height: 28px;\n    }\n}\n\n.heading-six,h6,h6 > p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n    font-size: 16px;\n    line-height: 20px;\n}\n\n@media (min-width: 1366px) {\n    .heading-six,h6,h6 > p {\n        font-size:20px;\n        line-height: 24px;\n    }\n}\n\n\n\n.eyebrow {\n    --text-opacity: 1;\n    color: #0098db;\n    color: rgba(0,152,219,var(--text-opacity));\n    font-size: 14px;\n    letter-spacing: 1.4px;\n    line-height: 14px;\n    text-transform: uppercase;\n}\n\n.checkedList {\n    padding-left: 28px;\n}\n\n.checkedList li {\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.checkedList li:before {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    content: \"ï˜\";\n    display: inline-block;\n    font-size: 20px;\n    font-style: normal;\n    font-variant: normal;\n    font-weight: 400;\n    left: -8px;\n    line-height: 1;\n    line-height: 21px;\n    margin-left: 8px;\n    margin-top: 2px;\n    position: relative;\n}\n\n.search-primary.news-search-box-container input {\n    --text-opacity: 1;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n   \n    font-size: 16px;\n    font-size: 20px;\n    font-style: italic;\n    line-height: 24px;\n    line-height: 28px;\n    padding-left: 52px;\n}\n\n.search-primary.news-search-box-container input::-webkit-input-placeholder {\n    opacity: 0.5;\n}\n\n.search-primary.news-search-box-container input::-moz-placeholder {\n    opacity: 0.5;\n}\n\n.search-primary.news-search-box-container input:-ms-input-placeholder {\n    opacity: 0.5;\n}\n\n.search-primary.news-search-box-container input::-ms-input-placeholder {\n    opacity: 0.5;\n}\n\n.search-primary.news-search-box-container input::placeholder {\n    opacity: 0.5;\n}\n\n.search-secondary .news-search-box-container {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    border-bottom: 1px solid #75787b;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n    margin-bottom: 12px;\n    margin-left: 12px;\n    margin-right: 12px;\n    padding-bottom: 0;\n}\n\n@media (min-width: 1366px) {\n    .search-secondary .news-search-box-container {\n        margin-left:0;\n        margin-right: 0;\n    }\n}\n\n.search-secondary .news-search-box-container input {\n    --text-opacity: 1;\n    border: none;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n   \n    font-size: 16px;\n    font-style: italic;\n    height: auto;\n    line-height: 24px;\n    padding-bottom: 8px;\n    padding-left: 32px;\n}\n\n.search-secondary .news-search-box-container input::-webkit-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.search-secondary .news-search-box-container input::-moz-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.search-secondary .news-search-box-container input:-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.search-secondary .news-search-box-container input::-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.search-secondary .news-search-box-container input::placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.search-secondary .news-search-box-container button {\n    -ms-flex-item-align: center;\n    align-self: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    left: 20px;\n    margin-left: 0;\n    margin-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n    position: relative;\n    top: unset;\n}\n\n.search-secondary .news-search-box-container i svg {\n    fill: #005bbb;\n    height: 18px;\n    width: 18px;\n}\n\n.news {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n}\n\n@media (min-width: 1366px) {\n    .news {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n    }\n}\n\n.news .news-content {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-column: span 6 / span 6;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n}\n\n@media (min-width: 1366px) {\n    .news .news-content {\n        grid-column:span 12 / span 12;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n    }\n}\n\n.news .news-content .gated-download {\n    background: #f0f0f0 0 0 no-repeat padding-box;\n    border-radius: 8px;\n    padding: 25px;\n    text-align: center;\n}\n\n.news .news-content .gated-download .download-circle-icon {\n    float: right;\n    padding-top: 5px;\n}\n\n.news .news-content .gated-download img {\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.news .news-content .gated-download h5 {\n    color: #005bbb;\n    font: normal normal normal 24px/32px Helvetica Now Display Bold;\n    letter-spacing: 0;\n    margin: auto;\n    padding-bottom: 15px;\n    width: 100%;\n}\n\n.news .news-content .gated-download p {\n    background: #fff 0 0 no-repeat padding-box;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    line-height: 55px;\n    margin: auto;\n    padding: 20px 0;\n    width: 100%;\n}\n\n.news .news-content .gated-download p a {\n    font: normal normal 700 24px/26px Helvetica Now Display bold;\n    letter-spacing: 0;\n    line-height: 50px;\n}\n\n.news .news-content-main {\n    grid-column: span 6 / span 6;\n}\n\n.news .news-content-main .news-under-hero-above-content {\n    display: none;\n}\n\n@media (max-width: 767px) {\n    .news .news-content-main .news-under-hero-above-content {\n        display:unset;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news .news-content-main {\n        grid-column:span 8 / span 8;\n    }\n}\n\n.news .news-content-side {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 1366px) {\n    .news .news-content-side {\n        grid-column:span 4 / span 4;\n    }\n}\n\n@media (max-width: 767px) {\n    .news .news-content-side .gated-download {\n        display:none;\n    }\n}\n\n.news .news-content-side > div:first-child {\n    padding: 0 12px 12px;\n}\n\n@media (min-width: 768px) {\n    .news .news-content-side > div:first-child {\n        padding:0 24px 12px;\n    }\n}\n\n.news .news-content-bottom {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 1366px) {\n    .news .news-content-bottom {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 375px) {\n    .news .news-content h2 {\n        font-size:32px;\n        line-height: 36px;\n        margin-bottom: 16px;\n    }\n}\n\n@media (min-width: 768px) {\n    .news .news-content h2 {\n        font-size:40px;\n        line-height: 48px;\n        margin-bottom: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news .news-content h2 {\n        font-size:48px;\n        line-height: 52px;\n        margin-bottom: 16px;\n    }\n}\n\n.news .breadcrumbs {\n    grid-column: span 6 / span 6;\n    margin-left: 0;\n    padding-left: 8px;\n}\n\n@media (min-width: 768px) {\n    .news .breadcrumbs {\n        padding-left:24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news {\n        max-width:1366px;\n    }\n\n    .news .breadcrumbs {\n        grid-column: span 12 / span 12;\n        padding-right: 24px;\n    }\n}\n\n.news-hero {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 265px;\n    position: relative;\n    width: 100%;\n}\n\n.news-hero-image {\n    height: 100%;\n    width: 100%;\n}\n\n.news-hero-image img {\n    height: 265px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .news-hero-image img {\n        border-radius:8px;\n        height: 380px;\n    }\n}\n\n.news-heading-title {\n    font-size: 32px;\n    line-height: 36px;\n    margin-bottom: 12px;\n}\n\n@media (min-width: 1366px) {\n    .news-heading-title {\n        font-size:48px;\n        line-height: 52px;\n        margin-bottom: 16px;\n    }\n}\n\n.news-heading-date {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 16px;\n    margin-bottom: 12px;\n}\n\n@media (min-width: 1366px) {\n    .news-heading-date {\n        font-size:18px;\n        line-height: 20px;\n        margin-bottom: 16px;\n    }\n}\n\n.news-heading-subtitle {\n    --text-opacity: 1;\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n   \n    font-size: 22px;\n}\n\n@media (min-width: 1366px) {\n    .news-heading-subtitle {\n        font-size:16px;\n        line-height: 20px;\n    }\n}\n\n.news-container {\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n@media (min-width: 768px) {\n    .news-container {\n        padding-left:24px;\n        padding-right: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news-container {\n        padding-left:0;\n        padding-right: 0;\n    }\n}\n\n.news-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n   \n    font-size: 16px;\n}\n\n@media (min-width: 1366px) {\n    .news-content {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        font-size: 16px;\n    }\n\n    .news-content-main {\n        margin-left: 0;\n        min-width: 800px;\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n.news-content-main .subheading {\n    font-size: 36px;\n    line-height: 36px;\n}\n\n.news-content-main-set {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    line-height: 26px;\n    margin-bottom: 32px;\n}\n\n.news-content-main-set h2 {\n    font-size: 32px;\n    line-height: 36px;\n    margin-bottom: 24px;\n}\n\n.news-content-main-set p {\n   \n    font-size: 16px;\n    line-height: 26px;\n    margin-bottom: 24px;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .news-content-main-set p {\n        font-size:16px;\n    }\n}\n\n.news-content-main-set-image {\n    height: 100%;\n    width: 100%;\n}\n\n.news-content-main-set-image img {\n    border-radius: 8px;\n    height: 100%;\n    width: 100%;\n}\n\n.news-content-main-set figure.image {\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.news-content-main-set figcaption {\n    font-size: 12px;\n    margin-bottom: 12px;\n    margin-top: 12px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .news-content-main-set figcaption {\n        font-size:14px;\n    }\n\n    .news-content-side {\n        margin-left: 0;\n        margin-right: 0;\n    }\n}\n\n.news-content-side .section-container {\n    padding: 12px;\n}\n\n@media (min-width: 768px) {\n    .news-content-side .section-container {\n        padding:24px;\n    }\n}\n\n.news-content-side > div:first-child {\n    padding-bottom: 12px;\n}\n\n@media (min-width: 768px) {\n    .news-content-side > div:first-child {\n        padding-bottom:12px;\n    }\n}\n\n.news-landing .breadcrumbs {\n    margin-left: 0;\n    padding-left: 8px;\n}\n\n.news-landing h1 {\n    padding-bottom: 8px;\n    padding-left: 24px;\n}\n\n.news-landing .breadcrumbs {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    padding-top: 22px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing {\n        max-width:1366px;\n    }\n\n    .news-landing .breadcrumbs {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n.news-landing-featured {\n    padding: 0;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-featured {\n        padding-left:24px;\n        padding-right: 24px;\n    }\n}\n\n.news-landing-hero {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    position: relative;\n    width: 100%;\n}\n\n.news-landing-hero-image {\n    height: 100%;\n    width: 100%;\n}\n\n.news-landing-hero-image img {\n    height: 220px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-hero-image img {\n        border-radius:8px;\n        height: 470px;\n    }\n}\n\n.news-landing-meta-category {\n    font-size: 14px;\n    text-transform: uppercase;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-meta-category {\n        font-size:20px;\n    }\n}\n\n.news-landing-meta-seperator {\n    --text-opacity: 1;\n    border-right: 1px solid #979797;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    margin-left: 12px;\n}\n\n.news-landing-meta-date {\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    text-transform: uppercase;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-meta-date {\n        font-size:20px;\n        margin-left: 8px;\n    }\n}\n\n.news-landing-heading {\n    margin-left: 12px;\n    margin-right: 12px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-heading {\n        margin-left:0;\n        margin-right: 0;\n    }\n}\n\n.news-landing-heading-title {\n    font-size: 32px;\n    line-height: 36px;\n    margin-bottom: 12px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-heading-title {\n        font-size:48px;\n        line-height: 52px;\n        margin-bottom: 16px;\n    }\n}\n\n@media (min-width: 768px) {\n    .news-landing-heading-title {\n        font-size:40px;\n        line-height: 48px;\n        margin-bottom: 16px;\n    }\n}\n\n@media (min-width: 375px) {\n    .news-landing-heading-title {\n        font-size:32px;\n        line-height: 36px;\n        margin-bottom: 16px;\n    }\n}\n\n.news-landing-heading-date {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 16px;\n    margin-bottom: 12px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-heading-date {\n        font-size:18px;\n        line-height: 20px;\n        margin-bottom: 16px;\n    }\n}\n\n.news-landing-heading-summary {\n   \n    font-size: 16px;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-heading-summary {\n        line-height:26px;\n    }\n}\n\n.news-landing-heading-summary p {\n    line-height: 26px;\n    text-align: left;\n}\n\n.news-landing-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n   \n    font-size: 16px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-content {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        font-size: 15px;\n    }\n}\n\n.news-landing-content-main {\n    margin-bottom: 32px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-content-main {\n        min-width:700px;\n    }\n\n    .news-landing-content-side {\n        margin-left: 0;\n        margin-right: 0;\n        min-width: 455px;\n    }\n}\n\n.news-landing-content-side .section-container {\n    padding: 12px;\n}\n\n@media (min-width: 768px) {\n    .news-landing-content-side .section-container {\n        padding:24px;\n    }\n}\n\n.news-landing-content-side > div:first-child {\n    padding: 0 12px 12px;\n}\n\n@media (min-width: 768px) {\n    .news-landing-content-side > div:first-child {\n        padding:0 24px 12px;\n    }\n}\n\n.news-landing-bottom {\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-bottom {\n        margin-left:0;\n        margin-right: 0;\n    }\n}\n\n.section-homepage {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.section-homepage,.section-homepage-hero {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    position: relative;\n}\n\n.section-homepage-hero {\n    width: 100%;\n}\n\n.section-homepage-hero-image,.section-homepage-hero-image-mobile {\n    height: 200px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .section-homepage-hero-image,.section-homepage-hero-image-mobile {\n        height:284px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-hero-image,.section-homepage-hero-image-mobile {\n        height:360px;\n    }\n}\n\n.section-homepage-hero-image-mobile img,.section-homepage-hero-image img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n    z-index: -1;\n}\n\n.section-homepage-hero-image-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n    left: 50%;\n    max-height: 100%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n    z-index: 0;\n}\n\n@media (min-width: 768px) {\n    .section-homepage-hero-image-content {\n        padding-bottom:32px;\n        padding-top: 32px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-hero-image-content {\n        padding-bottom:48px;\n        padding-top: 48px;\n    }\n}\n\n.section-homepage-hero-image-content.hero-left {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    text-align: left;\n}\n\n.section-homepage-hero-image-content.hero-right {\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-hero-image-content {\n        min-height:250px;\n    }\n}\n\n.section-homepage-hero-image-content-heading > span {\n    display: block;\n    text-shadow: 0 3px 40px rgba(0,0,0,0.23137);\n}\n\n.section-homepage-hero-image-content-heading.hero-left {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    text-align: left;\n}\n\n.section-homepage-hero-image-content-heading.hero-right {\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    text-align: right;\n}\n\n.section-homepage-hero-image-content-heading .top {\n    font-size: 32px;\n    line-height: 36px;\n    line-height: 32px;\n    padding-top: 8px;\n}\n\n@media (min-width: 768px) {\n    .section-homepage-hero-image-content-heading .top {\n        font-size:40px;\n        line-height: 48px;\n        line-height: 53px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-hero-image-content-heading .top {\n        font-size:40px;\n        line-height: 48px;\n    }\n}\n\n.section-homepage-hero-image-content-heading .bottom {\n    font-size: 56px;\n    line-height: 56px;\n}\n\n@media (min-width: 768px) {\n    .section-homepage-hero-image-content-heading .bottom {\n        font-size:76px;\n        line-height: 68px;\n        line-height: 99px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-hero-image-content-heading .bottom {\n        font-size:136px;\n        line-height: 167px;\n    }\n}\n\n.section-homepage .breadcrumbs {\n   \n    font-size: 14px;\n    left: 0;\n    line-height: 32px;\n    padding-bottom: 0;\n    padding-top: 0;\n    position: absolute;\n    right: 0;\n    width: 100%;\n    z-index: 1;\n}\n\n.section-homepage .breadcrumbs li:before {\n    border-color: #fff;\n}\n\n.section-homepage .breadcrumbs a {\n    color: #fff !important;\n}\n\n.section-homepage .breadcrumbs a:before {\n    position: relative;\n    top: 2px;\n}\n\n.section-homepage-content {\n    margin-top: -24px;\n    text-align: center;\n    width: calc(100% - 24px);\n    z-index: 1;\n}\n\n.section-homepage-content .solo .cta-primary-large,.section-homepage-content .solo h2,.section-homepage-content .solo p {\n    margin-left: 0;\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-content .solo {\n        height:200px;\n        margin-top: -240px;\n        max-width: 1400px;\n        white-space: nowrap;\n    }\n}\n\n.section-homepage-content-intro {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    --bg-opacity: 1;\n    align-items: center;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 5px 20px rgba(0,0,0,0.10196);\n    box-shadow: 0 5px 20px rgba(0,0,0,0.10196);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 32px;\n    overflow: hidden;\n    padding: 24px 16px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .section-homepage-content-intro {\n        padding:32px 24px;\n    }\n}\n\n@media (max-width: 1199px) {\n    .section-homepage-content-intro .tablet\\:grid {\n        display:block;\n    }\n\n    .section-homepage-content-intro .promo-callout-media {\n        padding: 0;\n    }\n\n    .section-homepage-content-intro .promo-callout-media-wrapper.media-full img {\n        width: 100%;\n    }\n\n    .section-homepage-content-intro .promo-callout-content p {\n        max-width: none;\n    }\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-content-intro {\n        padding:48px 56px;\n    }\n}\n\n.section-homepage-content-intro .rich-text p:last-of-type {\n    margin-bottom: 0;\n}\n\n.section-homepage-content-intro .section-container {\n    padding: 0;\n}\n\n.section-homepage-content-intro .callout {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin: 0;\n    max-width: 960px;\n}\n\n.section-homepage-content-intro .callout img {\n    display: none;\n}\n\n.section-homepage-content-intro .callout h3 {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n}\n\n@media (min-width: 1366px) {\n    .section-homepage-content-intro .callout h3 {\n        font-size:48px;\n        line-height: 58px;\n    }\n}\n\n.section-homepage-content-intro .callout-cta {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    margin-top: 20px;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.section-homepage-content-intro .callout-cta:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .section-homepage-content-intro .callout-cta:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.section-homepage-content-intro .callout-cta.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .section-homepage-content-intro .callout-cta.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.section-homepage-content-intro .callout-cta.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.section-homepage-content-intro .callout-cta.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .section-homepage-content-intro .callout-cta.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.section-homepage-content-intro .callout-cta,.section-homepage-content-intro .callout-cta > a,.section-homepage-content-intro .callout-cta > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    height: 44px;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 44px;\n    padding-left: 32px;\n    padding-right: 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .section-homepage-content-intro .callout-cta:hover,.section-homepage-content-intro .callout-cta > a:hover,.section-homepage-content-intro .callout-cta > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.section-homepage-content-intro .callout-cta > a > span,.section-homepage-content-intro .callout-cta > a i,.section-homepage-content-intro .callout-cta > a svg,.section-homepage-content-intro .callout-cta > button > span,.section-homepage-content-intro .callout-cta > button i,.section-homepage-content-intro .callout-cta > button svg,.section-homepage-content-intro .callout-cta > span,.section-homepage-content-intro .callout-cta i,.section-homepage-content-intro .callout-cta svg {\n    display: inline;\n}\n\n.section-homepage-content-intro .callout-cta > a svg,.section-homepage-content-intro .callout-cta > button svg,.section-homepage-content-intro .callout-cta svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.section-homepage-content-intro .callout-cta:disabled,.section-homepage-content-intro .callout-cta > a:disabled,.section-homepage-content-intro .callout-cta > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .section-homepage-content-intro .callout-cta:disabled:hover:disabled,.section-homepage-content-intro .callout-cta > a:disabled:hover:disabled,.section-homepage-content-intro .callout-cta > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.section-homepage-content-intro .callout-cta.inverted,.section-homepage-content-intro .callout-cta > a.inverted,.section-homepage-content-intro .callout-cta > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .section-homepage-content-intro .callout-cta.inverted:hover,.section-homepage-content-intro .callout-cta > a.inverted:hover,.section-homepage-content-intro .callout-cta > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.section-homepage-content-intro .callout-cta.inverted:active,.section-homepage-content-intro .callout-cta > a.inverted:active,.section-homepage-content-intro .callout-cta > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.section-homepage-content-intro .callout-cta.inverted:disabled,.section-homepage-content-intro .callout-cta > a.inverted:disabled,.section-homepage-content-intro .callout-cta > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .section-homepage-content-intro .callout-cta.inverted:disabled:hover,.section-homepage-content-intro .callout-cta > a.inverted:disabled:hover,.section-homepage-content-intro .callout-cta > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.section-homepage-content-intro .callout-cta:after,.section-homepage-content-intro .callout-cta > a:after,.section-homepage-content-intro .callout-cta > button:after {\n    display: none;\n}\n\n.section-homepage-content-intro .callout-cta.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.section-homepage-content-intro .promo-callout {\n    background-color: #fff;\n}\n\n.section-homepage-content-intro .promo-callout-media-wrapper {\n    padding: 0;\n}\n\n.section-homepage-content-intro .promo-callout-media-wrapper img {\n    margin-left: auto;\n    margin-right: auto;\n    width: auto;\n}\n\n.section-homepage-content-intro .promo-callout-content {\n    padding: 30px 15px;\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-content-intro .promo-callout-content {\n        padding-right:12px;\n    }\n}\n\n.section-homepage-content-intro .promo-callout-content .heading-two,.section-homepage-content-intro .promo-callout-content h2 {\n    margin-bottom: 8px;\n}\n\n.section-homepage-content-intro .promo-callout-content .heading-two p,.section-homepage-content-intro .promo-callout-content h2 p {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    text-align: center;\n}\n\n.section-homepage-content-intro .enhanced-form-color {\n    padding-bottom: 0;\n    padding-top: 0;\n}\n\n.section-homepage-content-intro .enhanced-form-color .enhanced-form {\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n}\n\n@media (min-width: 1366px) {\n    .section-homepage-content-intro .enhanced-form-color .enhanced-form {\n        width:1318px;\n    }\n\n    .section-homepage-content-intro .enhanced-form-color .enhanced-form .enhanced-form {\n        width: unset;\n    }\n}\n\n@media (min-width: 768px) {\n    .section-homepage-content {\n        margin-top:-48px;\n        max-width: 1318px;\n        width: calc(100% - 48px);\n    }\n}\n\n.scPage {\n    grid-row-gap: 0;\n    display: grid;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    row-gap: 0;\n}\n\n@media (min-width: 768px) {\n    .scPage {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n    }\n}\n\n.scPage .breadcrumbs {\n    grid-column: span 6 / span 6;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 0;\n    padding-right: 0;\n    width: 368px;\n}\n\n@media (min-width: 768px) {\n    .scPage .breadcrumbs {\n        grid-column:span 12 / span 12;\n        margin-left: auto;\n        margin-right: auto;\n        width: 656px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .scPage .breadcrumbs {\n        margin-left:auto;\n        margin-right: auto;\n        width: 1366px;\n    }\n}\n\n.scPage .breadcrumbs.section-container {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.scPage-hero {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    grid-column: span 6 / span 6;\n    height: 220px;\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .scPage-hero {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .scPage-hero {\n        height:380px;\n    }\n}\n\n.scPage-hero.section-container {\n    margin-bottom: 16px;\n    margin-top: 0;\n    padding: 0;\n}\n\n.scPage-hero-image {\n    height: 100%;\n    width: 100%;\n}\n\n.scPage-hero-image img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .scPage-hero-image img {\n        border-radius:8px;\n    }\n}\n\n.scPage-hero-heading,.scPage-hero h1 {\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    max-width: 547px;\n    position: absolute;\n}\n\n@media (min-width: 1366px) {\n    .scPage-hero-heading,.scPage-hero h1 {\n        margin-left:28px;\n        margin-right: 28px;\n    }\n}\n\n.scPage-hero .right {\n    right: 0;\n}\n\n.scPage-content {\n    display: grid;\n    grid-column: span 6 / span 6;\n    grid-template-columns: 1fr;\n    padding: 16px 12px;\n}\n\n@media (min-width: 768px) {\n    .scPage-content {\n        grid-column:span 12 / span 12;\n        grid-template-columns: 1fr;\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .scPage-content {\n        grid-template-columns:1fr fit-content(200px);\n    }\n}\n\n.scPage-content.section-container {\n    margin-bottom: 0;\n    margin-top: 0;\n    padding-bottom: 0;\n    padding-top: 0;\n}\n\n.scPage-content-main .subheading {\n    font-size: 36px;\n    line-height: 36px;\n}\n\n.scPage-content-main-set {\n    margin-bottom: 32px;\n}\n\n.scPage-content-main-set h2 {\n    font-size: 44px;\n    line-height: 48px;\n    margin-bottom: 24px;\n}\n\n.scPage-content-main-set p {\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.scPage-content-main-set-image {\n    height: 100%;\n    width: 100%;\n}\n\n.scPage-content-main-set-image img {\n    border-radius: 8px;\n    height: 100%;\n    width: 100%;\n}\n\n.scPage-content-main-quote {\n    border-bottom: 1px solid gray;\n    border-top: 1px solid gray;\n    height: 700px;\n    width: 100%;\n}\n\n.scPage-content-side {\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .scPage-content-side {\n        min-width:416px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .scPage-content-side {\n        margin-left:32px;\n        max-width: 420px;\n    }\n}\n\n.scPage-content-side .placeholderBox {\n    border: 1px solid gray;\n    height: 350px;\n}\n\n@media (min-width: 1366px) {\n    .scPage-content-side .placeholderBox {\n        width:380px;\n    }\n}\n\n.scPage-bottom {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .scPage-bottom {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.start-page section:nth-child(2) > div {\n    padding-top: 74px;\n}\n\n@media (min-width: 768px) {\n    .start-page section:nth-child(2) > div {\n        padding-top:94px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .start-page section:nth-child(2) > div {\n        padding-top:94px;\n    }\n}\n\n.faq {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    position: relative;\n}\n\n.faq-wrapper {\n    --bg-opacity: 1;\n    background-color: #fff5de;\n    background-color: rgba(255,245,222,var(--bg-opacity));\n}\n\n.faq .breadcrumbs {\n    left: 0;\n    padding-bottom: 0;\n    padding-top: 0;\n    position: absolute;\n    right: 0;\n    width: 100%;\n}\n\n.faq .breadcrumbs li:before {\n    border-color: #fff;\n}\n\n.faq .breadcrumbs a {\n    color: #fff !important;\n}\n\n.faq .breadcrumbs a:before {\n    position: relative;\n    top: 2px;\n}\n\n.faq-hero {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    position: relative;\n    width: 100%;\n}\n\n.faq-hero-image,.faq-hero-image-mobile {\n    height: 220px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .faq-hero-image,.faq-hero-image-mobile {\n        min-height:350px;\n    }\n}\n\n.faq-hero-image-mobile img,.faq-hero-image img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.faq-hero .hero-cta {\n    height: 400px;\n}\n\n.faq-intro {\n    max-width: 368px;\n    text-align: center;\n    width: 100%;\n    z-index: 1;\n}\n\n@media (min-width: 768px) {\n    .faq-intro {\n        max-width:656px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-intro {\n        max-width:1328px;\n        text-align: left;\n    }\n}\n\n.faq-intro-hero {\n    height: 120px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: -160px;\n    padding-left: 12px;\n    padding-right: 12px;\n    z-index: 2;\n}\n\n@media (min-width: 768px) {\n    .faq-intro-hero {\n        padding-left:24px;\n        padding-right: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-hero {\n        height:250px;\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: -290px;\n        max-width: 1366px;\n    }\n}\n\n.faq-intro-hero-heading,.faq-intro-hero h1 {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    font-size: 29px;\n    margin-bottom: 8px;\n    margin-left: 20px;\n    margin-right: 40px;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-hero-heading,.faq-intro-hero h1 {\n        font-size:58px;\n        margin-left: 90px;\n        text-align: left;\n    }\n}\n\n.faq-intro-hero-style p {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 72px;\n    line-height: 48px;\n    margin-left: -20px;\n    text-align: left;\n    text-shadow: 0 3px 40px rgba(0,0,0,0.23137);\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-hero-style p {\n        font-size:138px;\n        line-height: 80px;\n        margin-left: -90px;\n    }\n}\n\n.faq-intro-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    --bg-opacity: 1;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 5px 20px rgba(0,0,0,0.10196);\n    box-shadow: 0 5px 20px rgba(0,0,0,0.10196);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 20px;\n    width: calc(100% - 24px);\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-content {\n        padding:32px 140px;\n    }\n}\n\n.faq-intro-content-text {\n    max-width: 800px;\n}\n\n.faq-intro-content-text .heading-two,.faq-intro-content-text h2 {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n\n    margin-bottom: 8px;\n    text-align: center;\n}\n\n.faq-intro-content-text .heading-two p,.faq-intro-content-text h2 p {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    font-size: 58px;\n    line-height: 63px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-content-text .heading-two,.faq-intro-content-text h2 {\n        margin-bottom:40px;\n        text-align: center;\n    }\n}\n\n.faq-intro-content-text .lower-text {\n    margin-bottom: 32px;\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-content-text .lower-text {\n        margin-bottom:48px;\n        text-align: center;\n    }\n}\n\n.faq-intro-content-icons {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-content-icons {\n        -webkit-box-pack:justify;\n        -ms-flex-pack: justify;\n        justify-content: space-between;\n        max-width: 800px;\n    }\n}\n\n.faq-intro-content-icons a {\n    width: 50%;\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-content-icons a {\n        width:auto;\n    }\n}\n\n.faq-intro-content-icons-set {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 12px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 125px;\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-content-icons-set {\n        width:150px;\n    }\n}\n\n.faq-intro-content-icons-set-image {\n    height: 75px;\n    margin-bottom: 8px;\n    width: 75px;\n}\n\n@media (min-width: 1366px) {\n    .faq-intro-content-icons-set-image {\n        margin-bottom:20px;\n    }\n}\n\n.faq-intro-content-icons-set-image img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.faq-intro-content-icons-set p {\n    text-align: center;\n}\n\n.faq-content {\n    --bg-opacity: 1;\n    background-color: #fbf7ed;\n    background-color: rgba(251,247,237,var(--bg-opacity));\n    padding-bottom: 24px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .faq-content {\n        padding-bottom:32px;\n    }\n}\n\n.faq-content .faq-content {\n    padding: 0;\n}\n\n.faq-content-entry[open] .faq-content-entry-summary {\n    padding-bottom: 24px;\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry[open] .faq-content-entry-summary {\n        padding-bottom:32px;\n    }\n}\n\n.faq-content-entry[open] .faq-content-entry-title-wrapper-icon:before {\n    content: \"âˆ’\";\n}\n\n.faq-content-entry .faq-content-entry-title-wrapper-icon:before {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    content: \"+\";\n   \n    font-size: 36px;\n    line-height: 30px;\n    -webkit-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n.faq-content-entry {\n    cursor: pointer;\n    scroll-margin-top: 200px;\n}\n\n.faq-content-entry .focus-visible {\n    border: 2px solid;\n    border-radius: 7px;\n}\n\n.faq-content-entry :focus-visible {\n    border: 2px solid;\n    border-radius: 7px;\n}\n\n.faq-content-entry summary::marker {\n    display: none;\n}\n\n.faq-content-entry summary::-webkit-details-marker {\n    display: none;\n}\n\n.faq-content-entry summary {\n    display: inline;\n    outline: none;\n    width: 100%;\n}\n\n.faq-content-entry-subentry:after {\n    border-bottom: 1px solid #b8babc;\n    content: \"\";\n    display: block;\n    margin: auto;\n    max-width: 368px;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-subentry:after {\n        max-width:656px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry:after {\n        max-width:1104px;\n    }\n}\n\n.faq-content-entry-subentry .faq-content-entry-subentry-title-wrapper-icon:after {\n    content: \"+\";\n    font-size: 34px;\n    line-height: 21px;\n    -webkit-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry .faq-content-entry-subentry-title-wrapper-icon:after {\n        line-height:30px;\n    }\n}\n\n.faq-content-entry-subentry[open] .faq-content-entry-subentry-title-wrapper-icon:after {\n    content: \"âˆ’\";\n}\n\n.faq-content-entry-subentry[open] {\n    --bg-opacity: 1;\n    background-color: #fcfaf5;\n    background-color: rgba(252,250,245,var(--bg-opacity));\n}\n\n.faq-content-entry-title-wrapper {\n    grid-gap: 16px;\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: grid;\n   \n    font-size: 24px;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    letter-spacing: 0;\n    line-height: 32px;\n    margin: auto;\n    max-width: 368px;\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-title-wrapper {\n        grid-column:span 12 / span 12;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        max-width: 656px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-title-wrapper {\n        max-width:1328px;\n    }\n}\n\n.faq-content-entry-title-wrapper-text {\n    grid-column: span 5 / span 5;\n    grid-column-start: 2;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-title-wrapper-text {\n        grid-column:span 11 / span 11;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-title-wrapper-text {\n        grid-column:span 9 / span 9;\n        grid-column-start: 3;\n    }\n}\n\n.faq-content-entry-title-wrapper-icon {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    grid-column-start: 1;\n    grid-column: span 1 / span 1;\n    justify-content: center;\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-title-wrapper-icon {\n        grid-column-start:2;\n    }\n}\n\n.faq-content-entry-subentry {\n    text-align: left;\n}\n\n.faq-content-entry-subentry-title-wrapper {\n    grid-gap: 16px;\n    --text-opacity: 1;\n    color: #4a4a4a;\n    color: rgba(74,74,74,var(--text-opacity));\n    display: grid;\n   \n    font-size: 18px;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    letter-spacing: 0;\n    line-height: 22px;\n    margin: auto;\n    max-width: 368px;\n    padding-left: 12px;\n    padding-right: 12px;\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-subentry-title-wrapper {\n        grid-column:span 12 / span 12;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        max-width: 656px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry-title-wrapper {\n        font-size:16px;\n        line-height: 20px;\n        max-width: 1328px;\n    }\n}\n\n.faq-content-entry-subentry-title-wrapper-text {\n    grid-column: span 5 / span 5;\n    grid-column-start: 1;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-subentry-title-wrapper-text {\n        grid-column:span 11 / span 11;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry-title-wrapper-text {\n        grid-column:span 9 / span 9;\n        grid-column-start: 2;\n    }\n}\n\n.faq-content-entry-subentry-title-wrapper-icon {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n}\n\n.faq-content-entry-subentry > div.rich-text {\n    grid-gap: 16px;\n    --bg-opacity: 1;\n    background-color: #fcfaf5;\n    background-color: rgba(252,250,245,var(--bg-opacity));\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    letter-spacing: 0;\n    margin: auto;\n    max-width: 368px;\n    padding-bottom: 40px;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-subentry > div.rich-text {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n        max-width: 656px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry > div.rich-text {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n        max-width: 1328px;\n        padding-bottom: 72px;\n    }\n}\n\n.faq-content-entry-subentry > div.rich-text ol {\n    grid-column: span 6 / span 6;\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-subentry > div.rich-text ol {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry > div.rich-text ol {\n        grid-column:span 9 / span 9;\n        grid-column-start: 2;\n    }\n}\n\n.faq-content-entry-subentry p {\n    grid-column: span 6 / span 6;\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n@media (min-width: 768px) {\n    .faq-content-entry-subentry p {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry p {\n        grid-column:span 9 / span 9;\n        grid-column-start: 2;\n    }\n}\n\n.faq-content-entry-subentry summary {\n    grid-column: span 5 / span 5;\n    outline: none;\n    padding-bottom: 16px;\n    padding-top: 16px;\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-subentry summary {\n        padding-bottom:24px;\n        padding-top: 24px;\n    }\n}\n\n.faq-content-entry-summary {\n    padding-top: 24px;\n}\n\n@media (min-width: 1366px) {\n    .faq-content-entry-summary {\n        padding-top:32px;\n    }\n}\n\n.imagebackground-page {\n    position: relative;\n}\n\n.imagebackground-page-hero-image {\n    bottom: 0;\n    left: 0;\n    overflow: hidden;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100vw;\n    z-index: 0;\n}\n\n.imagebackground-page-hero-image picture {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 220px;\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-hero-image picture {\n        height:100%;\n    }\n}\n\n.imagebackground-page-hero-image picture img {\n    -webkit-filter: brightness(0.7);\n    filter: brightness(0.7);\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-hero-image picture img {\n        -webkit-filter:none;\n        filter: none;\n    }\n}\n\n.imagebackground-page-wrapper {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n    padding: 32px 16px 56px;\n    position: relative;\n    z-index: 0;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-wrapper {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        align-items: flex-start;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n}\n\n.imagebackground-page-content {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 5px 20px rgba(0,0,0,0.10196);\n    box-shadow: 0 5px 20px rgba(0,0,0,0.10196);\n    margin-right: 12px;\n    min-height: 500px;\n}\n\n.imagebackground-page-content .enhanced-form-color {\n    padding-bottom: 16px;\n    padding-top: 16px;\n}\n\n.imagebackground-page-content .enhanced-form-color .enhanced-form:first-of-type {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-content {\n        -webkit-box-shadow:none;\n        box-shadow: none;\n        width: 50%;\n    }\n}\n\n.imagebackground-page-headers {\n    margin-left: 12px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-headers {\n        width:50%;\n    }\n}\n\n.imagebackground-page-headers .hero-text {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 8px;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-headers .hero-text {\n        margin-bottom:0;\n    }\n}\n\n.imagebackground-page-headers .hero-text .hero-one {\n    font-size: 32px;\n    line-height: 38px;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-headers .hero-text .hero-one {\n        font-size:40px;\n        line-height: 46px;\n    }\n}\n\n.imagebackground-page-headers .hero-text .hero-two {\n    font-size: 44px;\n    line-height: 39px;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-headers .hero-text .hero-two {\n        font-size:80px;\n        line-height: 94px;\n    }\n}\n\n.imagebackground-page-headers h4 {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    text-transform: none;\n}\n\n.imagebackground-page-headers h4 .alternate-text {\n    bottom: -12px;\n   \n    font-size: 56px;\n    line-height: 12px;\n    position: relative;\n}\n\n.imagebackground-page-headers-content {\n    display: none;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-headers-content {\n        display:block;\n    }\n}\n\n.news-search-page {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n}\n\n@media (min-width: 1366px) {\n    .news-search-page {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n    }\n}\n\n.news-search-page .news-search-top {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 1366px) {\n    .news-search-page .news-search-top {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.news-search-page .news-search-results {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 1366px) {\n    .news-search-page .news-search-results {\n        grid-column:span 12 / span 12;\n    }\n\n    .main,main {\n        padding-top: 106px;\n    }\n}\n\n.body,body {\n    overflow-x: hidden;\n    width: 100vw;\n}\n\n.block-wrapper {\n    margin: 0 auto;\n    max-width: 1200px;\n}\n\n.block-wrapper p {\n    margin-bottom: 20px;\n}\n\n@media (min-width: 1366px) {\n    .header-wrapper {\n        margin:0 auto;\n        max-width: 1328px;\n    }\n\n    .header .brand {\n        display: block;\n    }\n\n    .header .brand img {\n        max-height: 68px;\n        width: auto;\n    }\n}\n\n.header-nav-utility {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n@media (min-width: 1366px) {\n    .header-nav-utility {\n        --bg-opacity:1;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        height: 88px;\n        justify-content: flex-start;\n    }\n}\n\n.header-nav-utility-row {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n}\n\n@media (min-width: 1366px) {\n    .header-nav-utility-row {\n        -webkit-box-pack:start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n        width: 33.3333333333%;\n    }\n\n    .header-nav-utility-row:last-of-type {\n        -webkit-box-pack: end;\n        -ms-flex-pack: end;\n        justify-content: flex-end;\n        width: 66.6666666667%;\n    }\n}\n\n.header-nav-utility-row .brand {\n    height: 55px;\n}\n\n@-moz-document url-prefix() {\n    .header-nav-utility-row .brand svg {\n        width: auto;\n    }\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link-icon svg {\n        height:24px;\n        margin-right: 15px;\n        width: 24px;\n    }\n}\n\n.utility-nav-item-link-lead {\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    font-size: 16px;\n    line-height: 24px;\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link-lead {\n        font-size:14px;\n        line-height: 24px;\n        margin: 0;\n    }\n}\n\n.utility-nav-item-link-content {\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    font-size: 18px;\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link-content {\n        font-family:Helvetica Now Display Medium;\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .utility-nav-item-link {\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        border-right: 1px solid rgba(117,120,123,0.15);\n        margin-right: 30px;\n        position: relative;\n    }\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link:not(:last-of-type):after {\n        background:#75787b;\n        border-radius: 5px;\n        content: \"\";\n        height: 100%;\n        opacity: 0.15;\n        position: absolute;\n        right: -30px;\n        top: 0;\n        width: 2px;\n    }\n\n    .utility-nav-item-link-icon,.utility-nav-item-link-lead {\n        display: block;\n    }\n}\n\n@media (max-width: 1365px) {\n    .utility-nav-item {\n        width:100%;\n    }\n\n    .utility-nav-item div:first-of-type {\n        display: block;\n        margin-left: auto;\n    }\n\n    .utility-nav-item div:nth-child(2) {\n        -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n        order: -1;\n    }\n\n    .utility-nav-item [aria-label=\"Call Us\"] .utility-nav-item-link-lead {\n        display: none;\n    }\n\n    .utility-nav-item [aria-label=\"Call Us\"] .utility-nav-item-link-content {\n        padding-left: 10px;\n    }\n\n    .hide-small {\n        display: none;\n    }\n}\n\n.main-navigation-mobile {\n    height: 56px;\n}\n\n.main-navigation-mobile-menu {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    --bg-opacity: 1;\n    align-items: center;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    -webkit-box-shadow: 0 3px 6px rgba(0,28,59,0.16078);\n    box-shadow: 0 3px 6px rgba(0,28,59,0.16078);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    justify-content: space-between;\n    padding-bottom: 0;\n    padding-top: 0;\n    position: relative;\n    z-index: 90;\n}\n\n.main-navigation-mobile-menu > * {\n    margin-right: 16px;\n}\n\n.main-navigation-mobile-menu > :last-child {\n    margin-right: 0;\n}\n\n.main-navigation-mobile-drawer {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    max-height: calc(100vh - 98px);\n    overflow: auto;\n    padding-bottom: 12px;\n    z-index: 9;\n}\n\n@supports (background: -webkit-named-image(i)) {\n    .main-navigation-mobile-drawer {\n        margin-top:-98px;\n        min-height: -webkit-fill-available;\n        padding-top: 98px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .main-navigation-mobile-drawer {\n        z-index:auto;\n    }\n}\n\n.main-navigation-mobile-drawer ul {\n    list-style: none;\n    padding: 48px 0 0;\n}\n\n@media (min-width: 1366px) {\n    .main-navigation-mobile-drawer ul {\n        padding:0;\n    }\n}\n\n.main-navigation-mobile-drawer ul li {\n    font-size: 20px;\n    line-height: 24px;\n    padding-bottom: 40px;\n}\n\n.main-navigation-mobile.mini {\n    background-color: #fff;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n}\n\n.main-navigation-mobile.mini .job-cart-alert {\n    top: 56px;\n}\n\n.main-navigation-mobile .mobile-brand {\n    margin-right: auto;\n    padding-right: 16px;\n}\n\n.main-navigation-mobile .mobile-brand img {\n    height: 44px;\n    width: auto;\n}\n\n.main-navigation-mobile svg {\n    fill: #002146;\n    height: 24px;\n    width: 24px;\n}\n\n.main-navigation-mobile .nav-link {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    padding-left: 24px;\n    padding-right: 24px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .main-navigation-mobile .nav-link {\n        padding:0 56px;\n    }\n}\n\n.main-navigation-mobile .footer-link {\n    position: relative;\n}\n\n.main-navigation-mobile .footer-link:before {\n    background-color: #ddd;\n    content: \"\";\n    height: 1px;\n    left: 30px;\n    position: absolute;\n    width: calc(100% - 60px);\n}\n\n.main-navigation-mobile .sub-nav-trigger {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    --text-opacity: 1;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n    justify-content: space-between;\n    padding-left: 24px;\n    padding-right: 24px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .main-navigation-mobile .sub-nav-trigger {\n        padding:0 56px;\n    }\n}\n\n.main-navigation-mobile .sub-nav-trigger svg {\n    fill: #002146;\n    height: 16px;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    width: 18px;\n}\n\n.main-navigation-mobile .sub-nav-trigger.open {\n    padding-bottom: 24px;\n}\n\n.main-navigation-mobile .sub-nav-trigger.open svg {\n    fill: #d00;\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n\n.main-navigation-mobile .sub-nav-drawer {\n    background-color: #eff5fa;\n    padding-top: 40px;\n}\n\n.main-navigation-mobile .sub-nav-link {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: block;\n   \n    padding-left: 48px;\n    padding-right: 48px;\n}\n\n@media (min-width: 768px) {\n    .main-navigation-mobile .sub-nav-link {\n        padding:0 72px;\n    }\n}\n\n.main-navigation-desktop .section-container {\n    padding: 0;\n}\n\n.main-navigation-desktop .nav-item-panel {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    background-color: #fff;\n    border-radius: 0 8px 0 0;\n    -webkit-box-shadow: 0 10px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 10px 10px rgba(0,0,0,0.10196);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: space-between;\n    left: -20px;\n    padding: 32px 48px 48px 32px;\n    top: 43px;\n    width: 672px;\n}\n\n.main-navigation-desktop .nav-item-panel ul {\n    padding-top: 4px;\n}\n\n.main-navigation-desktop .nav-item-panel.nav-item-panel-right {\n    border-radius: 8px 0 0 0;\n    left: auto;\n    right: -13px;\n}\n\n.main-navigation-desktop-wrapper {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    list-style: none;\n    padding-bottom: 0;\n    padding-top: 0;\n}\n\n.main-navigation-desktop-wrapper ul {\n    list-style: none;\n}\n\n.main-navigation-desktop-min {\n    --bg-opacity: 1;\n    background-color: #dde6ed;\n    background-color: rgba(221,230,237,var(--bg-opacity));\n    -webkit-box-shadow: 0 3px 6px rgba(0,28,59,0.16078);\n    box-shadow: 0 3px 6px rgba(0,28,59,0.16078);\n    height: 64px;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 2;\n}\n\n.main-navigation-desktop-min .logo-brand {\n    margin-right: 60px;\n}\n\n.main-navigation-desktop-min .logo-brand img {\n    height: 50px;\n    width: auto;\n}\n\n.main-navigation-desktop-min .nav-item-panel {\n    top: 36px;\n}\n\n.main-navigation-desktop-max {\n    background-color: #dde6ed;\n    background-color: rgba(221,230,237,var(--bg-opacity));\n    -webkit-box-shadow: 0 3px 6px rgba(0,28,59,0.16078);\n    box-shadow: 0 3px 6px rgba(0,28,59,0.16078);\n    height: 64px;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n}\n\n.main-navigation-desktop .nav-item {\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    line-height: 22px;\n    margin-right: 36px;\n    position: relative;\n    z-index: 2;\n}\n\n.main-navigation-desktop .nav-item button {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.main-navigation-desktop .nav-item button svg {\n    fill: #002146;\n    height: 20px;\n    margin-left: 6px;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    width: 12px;\n}\n\n.main-navigation-desktop .nav-item--open:before {\n    background-color: #fff;\n    border-radius: 10px 10px 0 0;\n    content: \"\";\n    height: 55px;\n    left: -20px;\n    position: absolute;\n    top: -10px;\n    width: calc(100% + 33px);\n    z-index: -1;\n}\n\n.main-navigation-desktop .nav-item--open button svg {\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n\n.main-navigation-desktop .sub-nav-item {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: block;\n   \n    font-size: 20px;\n    line-height: 28px;\n    margin-bottom: 24px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.main-navigation-desktop .sub-nav-item:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.main-navigation-desktop .sub-nav-item:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .main-navigation-desktop .sub-nav-item:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .main-navigation-desktop .sub-nav-item:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.main-navigation-desktop .sub-nav-item.wrapper:after {\n    width: 0;\n}\n\n.main-navigation-desktop .sub-nav-item:hover:after {\n    margin-top: 8px;\n}\n\n.main-navigation-desktop .nav-item-callout {\n    max-width: 224px;\n    padding-top: 0;\n}\n\n.main-navigation-desktop .nav-item-callout img {\n    border-radius: 10px;\n    height: 160px;\n    margin-bottom: 16px;\n    width: 100%;\n}\n\n.main-navigation-desktop .nav-item-callout a {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 24px;\n    letter-spacing: -0.4px;\n    line-height: 30px;\n    margin-bottom: 16px;\n}\n\n.main-navigation-desktop .nav-item-callout p {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 14px;\n    letter-spacing: -0.3px;\n    line-height: 16px;\n    padding-top: 16px;\n}\n\n.menu-overlay.open {\n    background: #000 0 0 no-repeat padding-box;\n    height: 101vh;\n    opacity: 0.25;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: -1;\n}\n\n.job-search.mini {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    position: fixed;\n    top: 51px;\n    width: 100%;\n}\n\n.job-search.mini.mobile {\n    top: 56px;\n}\n\n.job-search .job-see-all {\n    line-height: 0;\n    margin-bottom: 20px;\n    margin-left: 750px;\n}\n\n.job-search-button {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    align-items: center;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: inline-block;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n   \n    height: 48px;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    margin: 0;\n    min-width: 196px;\n    padding-left: 32px;\n    padding-right: 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .job-search-button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.job-search-button > span,.job-search-button i,.job-search-button svg {\n    display: inline;\n}\n\n.job-search-button svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.job-search-button i,.job-search-button svg {\n    fill: #002146;\n    height: 16px;\n    margin-right: 8px;\n    -webkit-transform: none;\n    -ms-transform: none;\n    -webkit-transform: initial;\n    -ms-transform: initial;\n    transform: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 16px;\n}\n\n.job-search-button > span,.job-search-button i,.job-search-button svg {\n    display: block;\n}\n\n@media (hover: hover) {\n    .job-search-button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        color: #002146;\n        color: rgba(0,33,70,var(--text-opacity));\n    }\n\n    .job-search-button:hover svg {\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.job-search-button.open {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #f7b22e;\n    background-color: rgba(247,178,46,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.job-search-button.open svg {\n    fill: #fff;\n}\n\n.header-navigation {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    position: relative;\n    z-index: 2;\n}\n\n\n.featured-jobs-heading {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 32px;\n    line-height: 40px;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-heading {\n        font-size:34px;\n        line-height: 40px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-heading {\n        font-size:42px;\n        line-height: 56px;\n    }\n}\n\n.featured-jobs-hero {\n    height: 100%;\n    left: 0;\n    overflow: hidden;\n    top: 0;\n    width: 100%;\n    z-index: -1;\n}\n\n.featured-jobs-hero img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: auto;\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-hero img {\n        min-height:450px;\n    }\n}\n\n.featured-jobs .section-container {\n    padding-bottom: 24px;\n    padding-top: 24px;\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs .section-container {\n        padding-bottom:32px;\n        padding-top: 32px;\n    }\n}\n\n.featured-jobs .swiper-wrapper {\n    margin-left: -12px;\n    margin-right: -12px;\n    overflow-x: hidden;\n}\n\n.featured-jobs .mobile-swiper {\n    padding-left: 32px;\n    padding-right: 32px;\n}\n\n.featured-jobs .mobile-swiper-container {\n    overflow-y: visible;\n    padding-left: 0;\n}\n\n.featured-jobs .mobile-swiper-slide {\n    margin: 0;\n    padding: 0 8px;\n    width: 100%;\n}\n\n.featured-jobs .mobile-swiper-slide .featured-jobs-card {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.featured-jobs .large-grid {\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs .large-grid {\n        margin-bottom:24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs .large-grid {\n        margin-bottom:32px;\n    }\n}\n\n.featured-jobs .large-grid .featured-jobs-card:nth-child(odd) {\n    margin: 0 0 0 auto;\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs .large-grid .featured-jobs-card:nth-child(odd) {\n        margin:0 auto;\n    }\n}\n\n.featured-jobs .large-grid .featured-jobs-card:nth-child(2n) {\n    margin: 0 auto 0 0;\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs .large-grid .featured-jobs-card:nth-child(2n) {\n        margin:0 auto;\n    }\n}\n\n.featured-jobs-grid p.subtitle-two {\n    --text-opacity: 1;\n    color: #131313;\n    color: rgba(19,19,19,var(--text-opacity));\n}\n\n.featured-jobs-card {\n    --bg-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    display: block;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n    margin-left: 24px;\n    margin-right: 24px;\n    overflow: hidden;\n}\n\n.featured-jobs-card-container {\n    height: 408px;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-card-container {\n        height:320px;\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-card-container {\n        height:337px;\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n.featured-jobs-card .sticker {\n    border-radius: 3px;\n    width: 60%;\n}\n\n.featured-jobs-card .crisis-response {\n    --text-opacity: 1;\n    color: #f34436;\n    color: rgba(243,68,54,var(--text-opacity));\n}\n\n.featured-jobs-card .favorite-button {\n    z-index: 1;\n}\n\n.featured-jobs-card .favorite-button svg {\n    height: 24px;\n    width: 24px;\n}\n\n.featured-jobs-card-img {\n    -ms-flex-item-align: start;\n    align-self: start;\n    height: 168px;\n    overflow: hidden;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-card-img {\n        height:137px;\n    }\n}\n\n.featured-jobs-card-img img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.featured-jobs-card-content {\n    --bg-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    flex-grow: 1;\n    padding: 16px;\n    position: relative;\n}\n\n.featured-jobs-card-content-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 24px;\n}\n\n.featured-jobs-card-content-title:after {\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: -140px;\n}\n\n.featured-jobs-card-content-location {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 14px;\n}\n\n.featured-jobs-card-content-salary {\n    -ms-flex-item-align: end;\n    align-self: end;\n    margin-top: auto;\n}\n\n.featured-jobs-card-content-salary-content {\n    --text-opacity: 1;\n    color: #1e7721;\n    color: rgba(30,119,33,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 14px;\n}\n\n.featured-jobs-card .favorite-button {\n    right: 8px;\n    top: 8px;\n}\n\n.featured-jobs-card .favorite-button svg .stroke {\n    fill: #2257b8;\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-card {\n        margin:0;\n    }\n}\n\n.featured-jobs-row {\n    --bg-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    display: block;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row-container {\n        padding-left:16px;\n        padding-right: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-row-container {\n        padding-left:24px;\n        padding-right: 24px;\n    }\n}\n\n.featured-jobs-row .sticker {\n    border-radius: 3px;\n    font-size: 12px;\n    margin-left: 10px;\n    width: 120px;\n}\n\n.featured-jobs-row .crisis-response {\n    --text-opacity: 1;\n    color: #f34436;\n    color: rgba(243,68,54,var(--text-opacity));\n}\n\n.featured-jobs-row .favorite-button {\n    z-index: 1;\n}\n\n.featured-jobs-row .favorite-button svg {\n    height: 18px;\n    width: 18px;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row .favorite-button svg {\n        height:24px;\n        width: 24px;\n    }\n}\n\n.featured-jobs-row-detail {\n    -ms-flex-item-align: start;\n    align-self: start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 5px;\n    overflow: hidden;\n    width: 100%;\n}\n\n.featured-jobs-row-detail-title {\n    -webkit-box-flex: 70%;\n    -ms-flex: 70%;\n    flex: 70%;\n}\n\n.featured-jobs-row-detail-title-text {\n    float: left;\n    margin-right: 5px;\n}\n\n.featured-jobs-row-detail-jobid {\n    -webkit-box-flex: 30%;\n    -ms-flex: 30%;\n    flex: 30%;\n    padding-right: 30px;\n}\n\n.featured-jobs-row-detail-jobid p {\n    font-size: 13px;\n}\n\n.featured-jobs-row-detail img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.featured-jobs-row-detail-grid {\n    font-size: 13px;\n}\n\n.featured-jobs-row-detail-grid .subtitle-two {\n    font-size: 13px;\n    font-weight: 700;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row-detail-grid .subtitle-two {\n        font-size:14px;\n    }\n}\n\n.featured-jobs-row-detail-grid .body-small {\n    font-size: 13px;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row-detail-grid .body-small {\n        font-size:14px;\n    }\n}\n\n.featured-jobs-row-content {\n    --bg-opacity: 1;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    padding: 16px;\n    position: relative;\n}\n\n.featured-jobs-row-content-title {\n    -webkit-box-flex: 40%;\n    -ms-flex: 40%;\n    flex: 40%;\n   \n}\n\n.featured-jobs-row-content-title,.featured-jobs-row-content-title-btn {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    line-height: 24px;\n}\n\n.featured-jobs-row-content-title-btn {\n    display: block;\n   \n    font-size: 13px;\n    margin-bottom: 4px;\n    margin-right: 20px;\n    margin-top: 4px;\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row-content-title-btn {\n        font-size:16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-row-content-title-btn {\n        font-size:20px;\n        line-height: 22px;\n        margin-bottom: 24px;\n    }\n}\n\n.featured-jobs-row-content-title-btn:after {\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.featured-jobs-row-content-title-btn-detail {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: block;\n   \n    font-size: 13px;\n    line-height: 24px;\n    margin-bottom: 4px;\n    margin-right: 20px;\n    margin-top: 4px;\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row-content-title-btn-detail {\n        font-size:16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-row-content-title-btn-detail {\n        font-size:20px;\n        line-height: 22px;\n        margin-bottom: 24px;\n    }\n}\n\n.featured-jobs-row-content-location {\n    --text-opacity: 1;\n    -webkit-box-flex: 20%;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    -ms-flex: 20%;\n    flex: 20%;\n   \n    font-size: 12px;\n    line-height: 24px;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row-content-location {\n        font-size:16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-row-content-location {\n        font-size:20px;\n    }\n}\n\n.featured-jobs-row-content-salary {\n    -webkit-box-flex: 30%;\n    -ms-flex: 30%;\n    flex: 30%;\n    line-height: 24px;\n    padding-right: 30px;\n}\n\n.featured-jobs-row-content-salary-content {\n    --text-opacity: 1;\n    color: #1e7721;\n    color: rgba(30,119,33,var(--text-opacity));\n   \n    font-size: 12px;\n}\n\n.featured-jobs-row-content-salary-content .call-details-link {\n    position: relative;\n    z-index: 1;\n}\n\n@media (min-width: 768px) {\n    .featured-jobs-row-content-salary-content {\n        font-size:16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-row-content-salary-content {\n        font-size:20px;\n    }\n}\n\n.featured-jobs-row-overview .more-detail-link {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    font-size: 16px;\n    font-weight: 700;\n    padding-left: 20px;\n}\n\n.featured-jobs-row .favorite-button {\n    right: 8px;\n    top: 8px;\n}\n\n.featured-jobs-row .favorite-button svg .stroke {\n    fill: #2257b8;\n}\n\n@media (min-width: 1366px) {\n    .featured-jobs-row {\n        margin:0;\n    }\n}\n\n.auto-complete .option {\n    --text-opacity: 1;\n    border-bottom: 1px solid #ddd;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.auto-complete .option-link {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    padding-bottom: 8px;\n    padding-right: 8px;\n    padding-top: 8px;\n    text-align: left;\n    width: 100%;\n}\n\n.auto-complete .option svg {\n    fill: #131313;\n    -webkit-transform: translateY(6px);\n    -ms-transform: translateY(6px);\n    transform: translateY(6px);\n}\n\n@media (hover: hover) {\n    .auto-complete .option:hover {\n        --bg-opacity:1;\n        background-color: #eee;\n        background-color: rgba(238,238,238,var(--bg-opacity));\n    }\n}\n\n.auto-complete .option-active {\n    --bg-opacity: 1;\n    background-color: #eee;\n    background-color: rgba(238,238,238,var(--bg-opacity));\n}\n\n.auto-complete-container {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 4px;\n    -webkit-box-shadow: 0 1px 15px rgba(185,187,188,0.25098);\n    box-shadow: 0 1px 15px rgba(185,187,188,0.25098);\n    left: 0;\n    top: 100%;\n    width: 100%;\n    z-index: 2;\n}\n\n@media (min-width: 1200px) {\n    .auto-complete-container {\n        top:calc(100% + 2px);\n        width: 381px;\n    }\n}\n\n.auto-complete .search-heading {\n   \n    font-size: 16px;\n    line-height: 14px;\n    margin-bottom: 8px;\n}\n\n.auto-complete .clear-button {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 14px;\n    margin-bottom: 8px;\n}\n\n.auto-complete .empty-search {\n    right: 20px;\n    top: 33%;\n}\n\n@media (min-width: 1200px) {\n    .auto-complete .empty-search {\n        top:50%;\n    }\n}\n\n.auto-complete .search-suggestion {\n    --text-opacity: 1;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    font-size: 14px;\n    line-height: 18px;\n    margin-bottom: 8px;\n    margin-right: 15px;\n    padding: 7px 5px 9px;\n}\n\n.job-search-form {\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .job-search-form {\n        margin:0 auto;\n        max-width: 475px;\n    }\n}\n\n.job-search-form label {\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .job-search-form label {\n        max-width:475px;\n    }\n}\n\n.job-search-form label input {\n    border-radius: 6px;\n    height: 56px;\n    margin-bottom: 12px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0 48px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .job-search-form label input {\n        margin-bottom:24px;\n    }\n}\n\n.job-search-form label i {\n    height: 24px;\n    left: 12px;\n    position: absolute;\n    top: 28%;\n    width: 24px;\n}\n\n@media (min-width: 768px) {\n    .job-search-form label i {\n        left:42px;\n        top: 23%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .job-search-form label i {\n        left:38px;\n        top: 28%;\n    }\n}\n\n.job-search-form label i svg,.job-search-form label i svg .stroke {\n    fill: #002146;\n}\n\n@media (min-width: 768px) {\n    .job-search-form label i svg,.job-search-form label i svg .stroke {\n        height:16px;\n        width: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .job-search-form label i svg,.job-search-form label i svg .stroke {\n        height:24px;\n        width: 24px;\n    }\n}\n\n.job-search-form .auto-complete .empty-search {\n    right: 20px;\n    top: 18px;\n}\n\n@media (min-width: 768px) {\n    .job-search-form .auto-complete .empty-search {\n        right:36px;\n        top: 5px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .job-search-form .auto-complete .empty-search {\n        right:36px;\n        top: 19px;\n    }\n}\n\n.job-search-form .auto-complete-container {\n    top: 56px;\n    width: 324px;\n}\n\n@media (min-width: 1366px) {\n    .job-search-form .auto-complete-container {\n        width:475px;\n    }\n}\n\n.discipline-search-form-job {\n    max-width: 400px;\n}\n\n.discipline-search-form-job input {\n    border-radius: 5px;\n    -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    color: #000;\n    font-size: 18px;\n    padding: 20px 64px 20px 28px;\n}\n\n.discipline-search-form-job .empty-search {\n    display: none;\n}\n\n.discipline-search-form-job button {\n    border-radius: 50px;\n    min-width: auto;\n    padding: 27px;\n    position: absolute;\n    right: 6px;\n    top: 6px;\n}\n\n.discipline-search-form-job button i {\n    left: 16px;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    top: 10px;\n}\n\n.discipline-search-form-job button i svg {\n    height: 24px;\n    width: 24px;\n}\n\n.job-search {\n    -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n}\n\n@media (min-width: 1366px) {\n    .job-search {\n        --bg-opacity:1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        height: 152px;\n        position: relative;\n        z-index: 2;\n    }\n}\n\n.job-search-form--desktop {\n    border: 2px solid #ddddde;\n    border-radius: 8px;\n    height: 88px;\n    width: 880px;\n}\n\n.job-search-form--desktop label {\n   \n    font-size: 16px;\n    letter-spacing: -0.45px;\n    line-height: 24px;\n}\n\n.job-search-form--desktop input {\n   \n    font-size: 14px;\n    line-height: 20px;\n}\n\n.job-search-form--desktop input:active,.job-search-form--desktop input:focus {\n    outline: none;\n}\n\n.job-search-form--mobile {\n    z-index: 9;\n}\n\n.job-search-form--mobile label {\n    position: relative;\n}\n\n.job-search-form--mobile label svg {\n    height: 20px;\n    left: 20px;\n    position: absolute;\n    top: calc(50% - 10px);\n    width: 20px;\n}\n\n.job-search-form--mobile input {\n    border-radius: 7px;\n    font-size: 18px;\n    height: 56px;\n    line-height: 22px;\n    line-height: 26px;\n    padding-left: 48px;\n    padding-right: 48px;\n}\n\n.job-search .all-jobs-link {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    position: relative;\n}\n\n@media (hover: hover) {\n    .job-search .all-jobs-link:hover:after {\n        display:none;\n    }\n}\n\n.job-search .all-jobs-link.hidden {\n    display: none !important;\n}\n\n.job-search .all-jobs-link svg {\n    fill: #666;\n    height: 24px;\n    position: absolute;\n    right: -26px;\n    top: 0;\n    width: 24px;\n}\n\n@media (min-width: 1366px) {\n    .job-search .all-jobs-link svg {\n        top:-11px;\n    }\n}\n\n.job-search .all-jobs-link.desktop {\n    display: none;\n}\n\n@media (min-width: 1366px) {\n    .job-search .all-jobs-link.desktop {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-transform: translateY(22px);\n        -ms-transform: translateY(22px);\n        transform: translateY(22px);\n    }\n}\n\n.results-list-heading {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 18px;\n    line-height: 32px;\n}\n\n@media (min-width: 1200px) {\n    .results-list-heading {\n        font-size:24px;\n        line-height: 36px;\n    }\n}\n\n.results-list-heading .emphasis {\n   \n    font-size: 24px;\n}\n\n@media (min-width: 1200px) {\n    .results-list-heading .emphasis {\n        font-size:32px;\n    }\n}\n\n.results-list .sort-btn {\n    --text-opacity: 1;\n    color: #131313;\n    color: rgba(19,19,19,var(--text-opacity));\n   \n    font-size: 18px;\n}\n\n.results-list .sort-btn.active {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.results-list .filter-modal-trigger {\n    max-width: 300px;\n}\n\n.results-list .filter-modal-trigger svg {\n    height: 18px;\n    width: 18px;\n}\n\n.results-list .filter-modal-trigger svg .stroke {\n    fill: #fff;\n}\n\n@media (min-width: 768px) {\n    .results-list .job-search-results {\n        -webkit-box-ordinal-group:3;\n        -ms-flex-order: 2;\n        order: 2;\n    }\n}\n\n.mobile-sort {\n    border: 2px solid #ddddde;\n    border-radius: 4px;\n    padding: 7px 25px 7px 16px;\n}\n\n.mobile-sort-wrapper {\n    display: inline-block;\n    position: relative;\n}\n\n.mobile-sort-wrapper:after {\n    content: \"âˆ¨\";\n    font-size: 18px;\n    font-weight: 700;\n    height: 0;\n    padding: 7px 0 0 8px;\n    pointer-events: none;\n    position: absolute;\n    right: 6px;\n    top: -1px;\n}\n\n.below-job-results {\n    -webkit-animation-duration: 2s;\n    animation-duration: 2s;\n    -webkit-animation-iteration-count: 1;\n    animation-iteration-count: 1;\n    -webkit-animation-name: opacity0to1;\n    animation-name: opacity0to1;\n    -webkit-animation-timing-function: linear;\n    animation-timing-function: linear;\n}\n\n.result-card {\n    border-radius: 7px;\n    -webkit-box-shadow: 0 1px 15px rgba(185,187,188,0.25098);\n    box-shadow: 0 1px 15px rgba(185,187,188,0.25098);\n    overflow: hidden;\n}\n\n.result-card .favorite-button {\n    right: 8px;\n    top: 8px;\n    z-index: 1;\n}\n\n@media (min-width: 1200px) {\n    .result-card .favorite-button {\n        right:12px;\n        top: 12px;\n    }\n}\n\n.result-card .favorite-button svg {\n    height: 20px;\n    width: 20px;\n}\n\n.result-card .favorite-button svg .stroke {\n    fill: #2257b8;\n}\n\n.result-card .sticker {\n    position: absolute;\n    width: 100%;\n}\n\n.result-card .call-details-link {\n    position: relative;\n    z-index: 1;\n}\n\n.result-card-img {\n    overflow: hidden;\n    position: relative;\n    width: 95px;\n}\n\n.result-card-img img {\n    height: 100%;\n    left: 0;\n    -o-object-fit: cover;\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    width: auto;\n    z-index: 0;\n}\n\n@media (min-width: 1200px) {\n    .result-card-img {\n        width:20%;\n    }\n}\n\n.result-card-img-locum {\n    border-radius: 10px;\n    margin-left: 8px;\n    margin-top: 8px;\n}\n\n@media (min-width: 1200px) {\n    .result-card-img-locum {\n        margin-left:16px;\n        margin-top: 16px;\n    }\n}\n\n.result-card-content-critical p {\n    --text-opacity: 1;\n    color: #f34436;\n    color: rgba(243,68,54,var(--text-opacity));\n   \n    font-size: 14px;\n    line-height: 19px;\n    text-align: left;\n    text-transform: uppercase;\n}\n\n.result-card-content-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: block;\n   \n    font-size: 20px;\n    line-height: 24px;\n    margin-bottom: 4px;\n    margin-right: 20px;\n    margin-top: 4px;\n}\n\n@media (min-width: 1200px) {\n    .result-card-content-title {\n        font-size:24px;\n        line-height: 22px;\n        margin-bottom: 24px;\n    }\n}\n\n.result-card-content-title:after {\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.result-card-content-location {\n    font-size: 16px;\n}\n\n.result-card-content-details,.result-card-content-location {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    line-height: 14px;\n}\n\n.result-card-content-details {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    align-items: center;\n    font-size: 14px;\n    justify-content: space-between;\n    width: 95%;\n}\n\n.result-card-content-details .salary {\n    --text-opacity: 1;\n    color: #1e7721;\n    color: rgba(30,119,33,var(--text-opacity));\n   \n    font-size: 18px;\n}\n\n.result-card-content-pricing-salary {\n    --text-opacity: 1;\n    color: #1e7721;\n    color: rgba(30,119,33,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 24px;\n}\n\n.result-card-content-feature {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    font-size: 16px;\n    line-height: 22px;\n}\n\n.result-card-content-feature svg {\n    fill: #666;\n    height: 15px;\n    margin-right: 4px;\n    -webkit-transform: translateY(4px);\n    -ms-transform: translateY(4px);\n    transform: translateY(4px);\n    width: 15px;\n}\n\n.result-card-content-feature p {\n    line-height: normal;\n}\n\n.searchCard {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.searchCard .card-content-box {\n    width: 80%;\n}\n\n.searchCard .result-card-content {\n    padding: 12px;\n}\n\n.searchCard .result-card-content-details {\n    margin-bottom: 4px;\n}\n\n.searchCard .result-card-content-location {\n    margin-bottom: 12px;\n}\n\n.searchCard .bottom-wrapper .result-card-content-details {\n    margin-bottom: 0;\n}\n\n.pagination-btn {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 1px solid #979797;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    display: block;\n    font-size: 18px;\n    height: 100%;\n    line-height: 38px;\n    margin-right: 12px;\n    min-width: 33px;\n    text-align: center;\n}\n\n.pagination-btn.active {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    cursor: not-allowed;\n}\n\n.pagination-btn:disabled {\n    cursor: not-allowed;\n}\n\n.pagination-nav-btn svg {\n    height: 40px;\n    width: 40px;\n}\n\n.pagination-nav-btn svg .stroke {\n    fill: #002146;\n}\n\n.pagination-nav-btn:first-of-type {\n    margin-right: 12px;\n}\n\n.pagination-nav-btn:disabled {\n    cursor: not-allowed;\n}\n\n.pagination-nav-btn:disabled .stroke {\n    fill: #bbb;\n}\n\n.filters {\n    -ms-flex-item-align: start;\n    align-self: flex-start;\n    border: 1px solid #ddddde;\n    width: 530px;\n}\n\n.filters .filter-sections .leading-6 {\n    width: 90%;\n}\n\n.filters .filter-sections .filterSubSpec {\n    line-height: 1.5rem;\n    padding: 5px 0;\n    width: 90%;\n}\n\n.filters-title {\n   \n    font-size: 20px;\n    line-height: 22px;\n}\n\n.filters-applied-label {\n   \n    font-size: 16px;\n}\n\n.filters-applied-list-item {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    --text-opacity: 1;\n    align-items: center;\n    border: 2px solid #bbb;\n    border-radius: 19px;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n    font-size: 14px;\n    margin: 0 8px 8px 0;\n    padding: 7.54px 11.25px;\n}\n\n.filters-applied-list-item span {\n    margin-right: 4px;\n}\n\n.filters-applied-list-item svg .stroke {\n    fill: #bbb;\n}\n\n.filters-exclusive {\n    border-radius: 6px;\n}\n\n@media (min-width: 768px) {\n    .filters {\n        -webkit-box-ordinal-group:2;\n        -ms-flex-order: 1;\n        margin-right: 64px;\n        order: 1;\n    }\n}\n\n.filter-section {\n    border-bottom: 2px solid #ccc;\n}\n\n.filter-section-description {\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.filter-section-input {\n    border: 2px solid #ccc;\n    border-radius: 5px;\n    height: 44px;\n    padding-left: 12px;\n    padding-right: 12px;\n    width: 100%;\n}\n\n.filter-section-facet {\n    --text-opacity: 1;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n    font-size: 16px;\n    line-height: 38px;\n}\n\n.filter-section-facet-count {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    -ms-flex-item-align: center;\n    align-self: center;\n    background-color: #c6e7fa;\n    background-color: rgba(198,231,250,var(--bg-opacity));\n    border-radius: 4px;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    line-height: 24px;\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n.filter-section-facet input[type=\"checkbox\"] {\n    height: 20px;\n    width: 20px;\n}\n\n.filter-section .empty-search {\n    bottom: 0;\n    right: 5px;\n}\n\n.toggle {\n    display: inline-block;\n    height: 13px;\n    position: relative;\n    width: 30px;\n}\n\n.toggle input {\n    height: 0;\n    opacity: 0;\n    width: 0;\n}\n\n.toggle input:checked + .toggle-slider {\n    background-color: #358437;\n}\n\n.toggle input:checked + .toggle-slider:before {\n    -webkit-transform: translateX(15px);\n    -ms-transform: translateX(15px);\n    transform: translateX(15px);\n}\n\n.toggle-slider {\n    background-color: #ccc;\n    border-radius: 19px;\n    bottom: 0;\n    cursor: pointer;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    -webkit-transition: 0.4s;\n    -o-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.toggle-slider:before {\n    background-color: #fff;\n    border: 1px solid #999;\n    border-radius: 100%;\n    bottom: -2px;\n    content: \"\";\n    height: 17px;\n    position: absolute;\n    -webkit-transition: 0.4s;\n    -o-transition: 0.4s;\n    transition: 0.4s;\n    width: 17px;\n}\n\n.no-results {\n    border-radius: 10px;\n    padding: 12px 16px 40px;\n    width: 100%;\n}\n\n.no-results-img {\n    width: 100%;\n}\n\n.no-results-img img {\n    height: auto;\n    width: 100%;\n}\n\n.no-results-content {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (min-width: 1200px) {\n    .no-results {\n        -ms-flex-item-align:start;\n        align-self: flex-start;\n        margin-left: auto;\n        margin-right: 40px;\n        max-width: 1366px;\n        padding: 32px 0;\n    }\n\n    .no-results-img {\n        width: 300px;\n    }\n\n    .no-results-content {\n        width: 60%;\n    }\n}\n\n.no-results .emphasis {\n   \n    font-size: 24px;\n}\n\n@media (min-width: 1200px) {\n    .no-results .emphasis {\n        font-size:32px;\n    }\n}\n\n.no-results h2 {\n    color: inherit;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\n\n.mobile-modal {\n    height: 100vh;\n    left: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    top: 0;\n    width: 100vw;\n    z-index: 9999;\n}\n\n.mobile-modal-header {\n    border-bottom: 1px solid #707070;\n    border-top: 2px solid #707070;\n}\n\n.mobile-modal-close {\n    right: 30px;\n}\n\n.mobile-modal-footer {\n    border: 1px solid #ddd;\n    z-index: 999;\n}\n\n.mobile-modal-footer button {\n    display: block;\n    margin: 0 auto;\n}\n\n.hot-jobs {\n    overflow-x: hidden;\n}\n\n.hot-jobs-heading {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 32px;\n    line-height: 40px;\n}\n\n@media (min-width: 768px) {\n    .hot-jobs-heading {\n        font-size:34px;\n        line-height: 40px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs-heading {\n        font-size:42px;\n        line-height: 56px;\n    }\n}\n\n.hot-jobs-hero {\n    height: 100%;\n    left: 0;\n    overflow: hidden;\n    top: 0;\n    width: 100%;\n    z-index: -1;\n}\n\n.hot-jobs-hero img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: auto;\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs-hero img {\n        min-height:450px;\n    }\n}\n\n.hot-jobs .section-container {\n    padding-bottom: 24px;\n    padding-top: 24px;\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs .section-container {\n        padding-bottom:32px;\n        padding-top: 32px;\n    }\n}\n\n.hot-jobs .swiper-wrapper {\n    margin-left: -24px;\n    margin-right: -24px;\n    overflow-x: hidden;\n}\n\n.hot-jobs .mobile-swiper {\n    padding-left: 32px;\n    padding-right: 32px;\n}\n\n.hot-jobs .mobile-swiper-container {\n    overflow-y: visible;\n    padding-left: 0;\n}\n\n.hot-jobs .mobile-swiper-slide {\n    margin: 0;\n    padding: 0 8px;\n    width: 100%;\n}\n\n.hot-jobs .mobile-swiper-slide .hot-jobs-card {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.hot-jobs .mobile-swiper .dot-navigation {\n    margin-top: 32px;\n}\n\n.hot-jobs .large-grid {\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\n@media (min-width: 768px) {\n    .hot-jobs .large-grid {\n        margin-bottom:24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs .large-grid {\n        margin-bottom:32px;\n    }\n}\n\n.hot-jobs .large-grid .hot-jobs-card:nth-child(odd) {\n    margin: 0 0 0 auto;\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs .large-grid .hot-jobs-card:nth-child(odd) {\n        margin:0 auto;\n    }\n}\n\n.hot-jobs .large-grid .hot-jobs-card:nth-child(2n) {\n    margin: 0 auto 0 0;\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs .large-grid .hot-jobs-card:nth-child(2n) {\n        margin:0 auto;\n    }\n}\n\n.hot-jobs-card {\n    --bg-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    display: block;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n    margin-left: 24px;\n    margin-right: 24px;\n    overflow: hidden;\n}\n\n.hot-jobs-card-container {\n    height: 312px;\n}\n\n@media (min-width: 768px) {\n    .hot-jobs-card-container {\n        height:281px;\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs-card-container {\n        height:280px;\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n}\n\n.hot-jobs-card .sticker {\n    border-radius: 3px;\n    width: 60%;\n}\n\n.hot-jobs-card .crisis-response {\n    --text-opacity: 1;\n    color: #f34436;\n    color: rgba(243,68,54,var(--text-opacity));\n}\n\n.hot-jobs-card .favorite-button {\n    z-index: 1;\n}\n\n.hot-jobs-card .favorite-button svg {\n    height: 24px;\n    width: 24px;\n}\n\n.hot-jobs-card-img {\n    -ms-flex-item-align: start;\n    align-self: start;\n    height: 168px;\n    overflow: hidden;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .hot-jobs-card-img {\n        height:137px;\n    }\n}\n\n.hot-jobs-card-img img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.hot-jobs-card-content {\n    --bg-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    flex-grow: 1;\n    padding: 16px;\n    position: relative;\n}\n\n.hot-jobs-card-content-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 24px;\n}\n\n.hot-jobs-card-content-title:after {\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: -140px;\n}\n\n.hot-jobs-card-content-location {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 14px;\n}\n\n.hot-jobs-card-content-salary {\n    -ms-flex-item-align: end;\n    align-self: end;\n    margin-top: auto;\n}\n\n.hot-jobs-card-content-salary .call-details-link {\n    position: relative;\n    z-index: 1;\n}\n\n.hot-jobs-card-content-salary-content {\n    --text-opacity: 1;\n    color: #1e7721;\n    color: rgba(30,119,33,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 14px;\n}\n\n.hot-jobs-card .favorite-button {\n    right: 8px;\n    top: 8px;\n}\n\n.hot-jobs-card .favorite-button svg .stroke {\n    fill: #fff;\n}\n\n@media (min-width: 1366px) {\n    .hot-jobs-card {\n        margin:0;\n    }\n}\n\n.map-tile-map {\n    border-radius: 7px;\n    height: 290px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .map-tile-map {\n        height:450px;\n        width: 400px;\n    }\n}\n\n.job-details-title {\n    font-size: 26px;\n}\n\n@media (min-width: 1200px) {\n    .job-details-title {\n        font-size:38px;\n    }\n}\n\n.job-details-body-disclaimer p {\n    font-size: 14px;\n    font-style: italic;\n    line-height: 22px;\n    text-align: left;\n}\n\n.job-details-hero {\n    height: 170px;\n    overflow: hidden;\n    width: 100%;\n}\n\n.job-details-hero img {\n    height: auto;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .job-details-hero {\n        height:190px;\n    }\n}\n\n.job-details-sidebar {\n    -ms-flex-item-align: start;\n    align-self: flex-start;\n    border: 2px solid #ddd;\n    min-width: 390px;\n}\n\n.job-details-sidebar,.job-details-slide-nav {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 51px;\n}\n\n.job-details-slide-nav {\n    border-bottom: 1px solid #ddd;\n    border-top: 2px solid #ddd;\n    z-index: 1;\n}\n\n.job-details-slide-nav-item,.job-details-slide-nav-item--active {\n    margin-right: 24px;\n    padding-bottom: 8px;\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n.job-details-slide-nav-item--active {\n    --text-opacity: 1;\n    border-bottom: 5px solid #2257b8;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .job-details-slide-nav-item:hover {\n        --text-opacity:1;\n        color: #2257b8;\n        color: rgba(34,87,184,var(--text-opacity));\n    }\n}\n\n.job-details-slide-nav-item button {\n    height: 100%;\n    width: 100%;\n}\n\n.job-details-mobile-apply {\n    border: 1px solid #ddd;\n    z-index: 999;\n}\n\n.job-details .icon-style {\n    -webkit-transform: translateY(3px);\n    -ms-transform: translateY(3px);\n    transform: translateY(3px);\n}\n\n.job-details .icon-style svg {\n    height: 16px;\n    width: 16px;\n}\n\n.job-details .icon-style svg .stroke {\n    fill: #2257b8;\n}\n\n.job-details .favorite-button {\n    position: static;\n}\n\n.job-details .favorite-button i,.job-details .favorite-button svg {\n    height: 18.35px;\n    width: 20px;\n}\n\n.job-details .favorite-button i .stroke,.job-details .favorite-button svg .stroke {\n    fill: #2257b8;\n}\n\n.job-details .sticker {\n    border-radius: 3px;\n}\n\n.nav-article {\n    border-top: 1px solid #ddd;\n}\n\n.nav-article ul {\n    list-style: disc none outside;\n    list-style: initial;\n    padding-left: 28px;\n}\n\n.job-cart-item {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    border-top: 1px solid #ccc;\n    justify-content: space-between;\n}\n\n.job-cart-item-img {\n    max-height: 90px;\n    min-width: 120px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 120px;\n}\n\n.job-cart-item-details {\n    max-width: 54%;\n    width: 54%;\n}\n\n.job-cart-item-details .job-link {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 16px;\n    line-height: 22px;\n    line-height: 18px;\n}\n\n.job-cart-item-details .job-link img {\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n.job-cart-item-details .job-link:after {\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.job-cart-item-details p {\n    line-height: 1;\n}\n\n.job-cart-item-remove {\n    height: 24px;\n    padding: 4px;\n    width: 24px;\n    z-index: 3;\n}\n\n.job-cart-item-remove svg {\n    height: 12px;\n    width: 12px;\n}\n\n.job-cart-alert {\n    background-color: #fff;\n    border: solid #c4cace;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 0 6px rgba(0,0,0,0.12157);\n    box-shadow: 0 0 6px rgba(0,0,0,0.12157);\n    left: 0;\n    padding: 20px;\n    position: fixed;\n    top: 88px;\n    width: 100%;\n}\n\n.job-cart-alert .job-cart-alert-text {\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.job-cart-alert a,.job-cart-alert button {\n    margin-top: 15px;\n    padding: 0 1rem;\n    width: 100%;\n}\n\n@media (max-width: 767px) {\n    .job-cart-alert button {\n        margin-bottom:25px;\n    }\n}\n\n.job-cart-alert .arrow-up {\n    border-bottom: 15px solid #fff;\n    border-left: 15px solid transparent;\n    border-right: 15px solid transparent;\n    height: 0;\n    right: 98px;\n    top: -14px;\n    width: 0;\n    z-index: 2;\n}\n\n@media (min-width: 768px) {\n    .job-cart-alert .arrow-up {\n        right:37%;\n    }\n}\n\n.job-cart-alert .arrow-up-border {\n    border-bottom: 15px solid #c4cace;\n    top: -18px;\n    z-index: 1;\n}\n\n@media (min-width: 768px) {\n    .job-cart-alert {\n        border-radius:3px;\n        left: -250%;\n        padding: 15px;\n        position: absolute;\n        top: 116%;\n        width: 220px;\n    }\n\n    .job-cart-alert button.job-cart-alert-dismiss {\n        margin: unset;\n        margin-top: 20px;\n        width: unset;\n    }\n}\n\n@media (min-width: 1366px) {\n    .job-cart-alert {\n        border-radius:3px;\n        left: unset;\n        padding: 15px;\n        position: absolute;\n        right: 10%;\n        top: 145%;\n        width: 225px;\n    }\n}\n\n.job-cart-alert button.job-cart-alert-dismiss {\n    cursor: pointer;\n    height: 12.5px;\n    right: 16px;\n    top: 8px;\n    width: 12.5px;\n    z-index: 1;\n}\n\n.job-cart-alert button.job-cart-alert-dismiss svg {\n    fill: #75787b;\n    height: 12.5px;\n    width: 12.5px;\n}\n\n.job-cart-count-0 {\n    display: none;\n}\n\n.job-cart {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n}\n\n@media (min-width: 1366px) {\n    .job-cart {\n        padding-right:32px;\n    }\n}\n\n@media (max-width: 1365px) {\n    .job-cart-apply-btn {\n        display:inline !important;\n        font-size: 14px;\n        height: 40px;\n        line-height: 1;\n        max-width: 100px;\n        min-width: 128px;\n        padding: 12px 10px;\n        text-align: center;\n    }\n}\n\n.job-cart-trigger.open {\n    -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n}\n\n.job-cart-trigger svg {\n    height: 30px;\n    width: 32.86px;\n}\n\n.job-cart-trigger svg .stroke {\n    fill: #d00;\n}\n\n.job-cart-trigger-badge svg .stroke {\n    fill: #2257b8;\n}\n\n.job-cart-trigger-count {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    left: 50%;\n    top: 55%;\n    -webkit-transform: translate(-50%,-60%);\n    -ms-transform: translate(-50%,-60%);\n    transform: translate(-50%,-60%);\n}\n\n.job-cart-trigger-count.open {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.job-cart-text {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.job-cart-chevron svg .stroke {\n    fill: #2257b8;\n}\n\n.job-cart-summary {\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    border-top-left-radius: 10px;\n    -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n    left: -242px;\n    max-width: 500px;\n    min-width: 375px;\n    top: 45px;\n    z-index: 9;\n}\n\n.job-cart-summary-footer {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    border-top: 1px solid #ccc;\n    justify-content: space-between;\n}\n\n.job-cart-list {\n    list-style: none;\n    max-height: 336px;\n    overflow-y: auto;\n    padding: 0;\n}\n\n@media (min-width: 1366px) {\n    .job-cart {\n        position:relative;\n    }\n\n    .job-cart-trigger-count {\n        left: 40%;\n    }\n\n    .job-cart-summary {\n        left: auto;\n        right: 0;\n        top: 45px;\n        width: 450px;\n    }\n}\n\n.section-container {\n    padding-top: 24px;\n}\n\n@media (min-width: 1366px) {\n    .section-container {\n        padding-top:32px;\n    }\n}\n\n.section-wrapper {\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n}\n\n.recently-viewed {\n    -webkit-animation-duration: 2s;\n    animation-duration: 2s;\n    -webkit-animation-iteration-count: 1;\n    animation-iteration-count: 1;\n    -webkit-animation-name: opacity0to1;\n    animation-name: opacity0to1;\n    -webkit-animation-timing-function: linear;\n    animation-timing-function: linear;\n}\n\n.recently-viewed .result-card {\n    border-radius: 8px;\n    -webkit-box-shadow: 0 2px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 2px 10px rgba(0,0,0,0.10196);\n    height: auto;\n    max-width: 452px;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .result-card {\n        height:193px;\n        margin-left: 8px;\n        margin-right: 8px;\n        width: 304px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .recently-viewed .result-card {\n        height:auto;\n        margin-left: 16px;\n        margin-right: 16px;\n        width: 400px;\n    }\n}\n\n.recently-viewed .title {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n}\n\n@media (min-width: 768px) {\n    .recently-viewed .title {\n        font-size:34px;\n        line-height: 40px;\n        margin-bottom: 32px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .recently-viewed .title {\n        font-size:42px;\n        line-height: 56px;\n        line-height: 68px;\n    }\n}\n\n.recently-viewed ul {\n    padding: unset;\n}\n\n.recently-viewed .mobile-swiper-slide {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.recently-viewed .result-card-img {\n    height: 100%;\n    width: 88px;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .result-card-img {\n        width:72px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .recently-viewed .result-card-img {\n        width:88px;\n    }\n}\n\n.recently-viewed .dot-navigation {\n    margin-bottom: 32px;\n    margin-top: 24px;\n}\n\n.recently-viewed .sticker {\n   \n    opacity: 1;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .sticker {\n        font-size:10px;\n        padding-bottom: 4px;\n        padding-top: 4px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .recently-viewed .sticker {\n        font-size:12px;\n        line-height: 16px;\n    }\n}\n\n.recently-viewed .result-card-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n    width: calc(100% - 16px);\n}\n\n.recently-viewed .result-card-content-title {\n   \n    margin: 0;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .result-card-content-title {\n        font-size:18px;\n        line-height: 20px;\n        margin: 0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .recently-viewed .result-card-content-title {\n        font-size:20px;\n        line-height: 24px;\n    }\n}\n\n.recently-viewed .salary {\n    font-size: 20px;\n    line-height: 28px;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .salary {\n        font-size:24px;\n        line-height: 30px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .recently-viewed .salary {\n        font-size:20px;\n        line-height: 28px;\n    }\n}\n\n.recently-viewed .weekly {\n    --text-opacity: 1;\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n   \n}\n\n.recently-viewed .result-card-content-location {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    line-height: 24px;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .result-card-content-location {\n        font-size:14px;\n        line-height: 22px;\n        margin: 0;\n    }\n}\n\n.recently-viewed .result-card-content-details {\n    --text-opacity: 1;\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    font-size: 12px;\n    line-height: 16px;\n    width: 100%;\n}\n\n.recently-viewed .result-card-content-details span {\n    font-weight: 400;\n}\n\n.recently-viewed .card-content-box {\n    left: -40px;\n    margin-left: 16px;\n    margin-right: 16px;\n    padding-bottom: 16px;\n    padding-top: 16px;\n    position: relative;\n    width: 248px;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .card-content-box {\n        left:-32px;\n        margin-left: 0;\n        margin-right: 8px;\n        padding-left: 8px;\n        width: 224px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .recently-viewed .card-content-box {\n        left:-16px;\n        margin-right: 0;\n        padding-left: 16px;\n        width: 296px;\n    }\n\n    .recently-viewed .card-content-box-locum {\n        left: 0;\n    }\n}\n\n.recently-viewed .favorite-button {\n    margin-right: 16px;\n    margin-top: 16px;\n    right: 0;\n    top: 0;\n}\n\n@media (min-width: 768px) {\n    .recently-viewed .favorite-button {\n        margin-right:16px;\n    }\n}\n\n.recently-viewed .favorite-button svg {\n    height: 24px;\n    margin: 0;\n    width: 24px;\n}\n\n.recently-viewed .favorite-button svg .stroke {\n    fill: #002146;\n}\n\n.recently-viewed .favorite-button:not(.full) {\n    height: 24px;\n    width: 24px;\n}\n\n.recently-viewed .result-card-content-critical p {\n   \n    font-size: 12px;\n    line-height: 16px;\n}\n\n.recently-viewed .bottom-wrapper {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    height: 100%;\n    justify-content: flex-end;\n}\n\n.favorite-modal-body,.recently-viewed .bottom-wrapper {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.favorite-modal-body {\n    background: #fff;\n    border: 1px solid #f5f6f8;\n    border-radius: 10px;\n    -webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.25098);\n    box-shadow: 0 2px 12px rgba(0,0,0,0.25098);\n    float: left;\n    left: 50%;\n    max-width: 335px;\n    opacity: 1;\n    position: fixed;\n    top: 50%;\n    -webkit-transform: translate(-50%,-50%);\n    -ms-transform: translate(-50%,-50%);\n    transform: translate(-50%,-50%);\n    width: 95%;\n}\n\n.favorite-modal-body .favorite-modal-content {\n    padding: 30px;\n}\n\n.favorite-modal-body .favorite-modal-content-details {\n    float: left;\n    max-width: 65%;\n    padding-left: 20px;\n}\n\n.favorite-modal-body img {\n    border-radius: 4px;\n    float: left;\n    margin-bottom: 15px;\n    max-height: 90px;\n}\n\n.favorite-modal-body a,.favorite-modal-body button {\n    margin-top: 15px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .favorite-modal-body {\n        max-width:480px;\n    }\n\n    .favorite-modal-body img {\n        max-height: 90px;\n    }\n}\n\nbutton.job-cart-alert-dismiss {\n    right: 20px;\n    top: 1px;\n    width: 12.5px;\n}\n\nbutton.job-cart-alert-dismiss svg {\n    fill: #75787b;\n}\n\n.favorite-modal-overlay {\n    background-color: #000;\n    bottom: 0;\n    left: 0;\n    opacity: 0.25;\n    position: fixed;\n    right: 0;\n    top: 0;\n    -webkit-transition: opacity 0.2s;\n    -o-transition: opacity 0.2s;\n    transition: opacity 0.2s;\n}\n\n.overlay .cancel {\n    cursor: default;\n    height: 100%;\n    position: absolute;\n    width: 100%;\n}\n\n.overlay:target {\n    opacity: 1;\n    visibility: visible;\n}\n\n.callout {\n    margin: 0 auto;\n    max-width: 384px;\n    padding-bottom: 16px;\n}\n\n@media (min-width: 768px) {\n    .callout {\n        margin:initial;\n        max-width: none;\n    }\n}\n\n.callout-img {\n    height: 160px;\n    margin: 16px auto;\n    width: 160px;\n}\n\n.callout-img img,.callout-img svg {\n    height: 100%;\n    -o-object-fit: contain;\n    object-fit: contain;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .callout-img {\n        height:136px;\n        margin-bottom: 16px;\n        width: 136px;\n    }\n\n    .callout--left .callout-img {\n        margin-left: 0;\n        margin-right: 0;\n    }\n}\n\n.callout-heading {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 16px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .callout--left .callout-heading {\n        text-align:left;\n    }\n}\n\n.callout-content {\n    padding-bottom: 16px;\n    padding-left: 8px;\n    padding-right: 8px;\n    text-align: left;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .callout--left .callout-content {\n        text-align:left;\n    }\n}\n\n.callout-content p,.callout-cta {\n    text-align: center;\n}\n\n.callout-cta {\n    margin-left: auto;\n    margin-right: auto;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n@media (min-width: 1366px) {\n    .callout--left .callout-cta {\n        margin-left:0;\n        margin-right: auto;\n        text-align: left;\n    }\n}\n\n.callout-row-subtitle p {\n    text-align: center;\n}\n\n.callout-row-bg .background,.callout-row-bg .background img,.callout-row-bg img {\n    height: 100%;\n    width: 100%;\n}\n\n.callout-row div.cta-primary-medium {\n    margin-bottom: 32px;\n    padding: 0;\n}\n\n@media (min-width: 768px) {\n    .callout-row div.cta-primary-medium {\n        margin-bottom:0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .callout-row div.cta-primary-medium {\n        margin-bottom:8px;\n    }\n}\n\n.callout-row ul {\n    padding-left: 0;\n}\n\n.callout-row .cta-text {\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n}\n\n.callout-row .statistics-callout-item {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -ms-flex-item-align: center;\n    align-items: center;\n    align-self: center;\n    border-radius: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 320px;\n    justify-content: center;\n    margin-bottom: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 320px;\n}\n\n@media (min-width: 768px) {\n    .callout-row .statistics-callout-item {\n        margin-bottom:0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .callout-row .statistics-callout-item {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        grid-column: unset;\n        height: 320px;\n        justify-content: center;\n        width: 320px;\n    }\n}\n\n.callout-row .statistics-callout-item .item-contents {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n@media (min-width: 1366px) {\n    .callout-row .statistics-callout-item .item-contents {\n        padding-left:20px;\n        padding-right: 20px;\n    }\n}\n\n.callout-row .statistics-callout-item p {\n    color: #005bbb;\n    text-align: center;\n}\n\n.callout-row .statistics-callout-item .icon-img {\n    height: auto;\n    max-width: 100px;\n    padding-bottom: 8px;\n}\n\n.callout-row .statistics-callout-item .icon-img img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.callout-row .statistics-callout-item .title {\n   \n    font-size: 42px;\n    line-height: 62px;\n}\n\n@media (min-width: 1366px) {\n    .callout-row .statistics-callout-item .title {\n        font-size:46px;\n        line-height: 68px;\n    }\n}\n\n.callout-row .statistics-callout-item .description {\n   \n    font-size: 14px;\n    line-height: 20px;\n}\n\n@media (min-width: 768px) {\n    .callout-row .statistics-callout-item .description {\n        padding-left:20px;\n        padding-right: 20px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .callout-row .statistics-callout-item .description {\n        font-size:16px;\n        line-height: 24px;\n    }\n}\n\n.generic-row-wrapper {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    max-width: unset !important;\n}\n\n@media (min-width: 1366px) {\n    .generic-row-wrapper {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n    }\n}\n\n.generic-row-wrapper .generic-row {\n    grid-gap: 16px;\n    grid-row-gap: 24px;\n    display: grid;\n    gap: 16px;\n    grid-column: span 6 / span 6;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    row-gap: 24px;\n}\n\n@media (min-width: 1366px) {\n    .generic-row-wrapper .generic-row {\n        grid-row-gap:16px;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        grid-auto-flow: column;\n        grid-column: span 12 / span 12;\n        grid-template-columns: unset;\n        justify-content: center;\n        row-gap: 16px;\n    }\n}\n\n.generic-row-wrapper .generic-row .callout-item {\n    grid-column: span 3 / span 3;\n}\n\n.generic-row-wrapper .generic-row .callout-item .statistics-callout-item {\n    height: unset;\n    margin-left: auto;\n    margin-right: auto;\n    width: unset;\n}\n\n@media (max-width: 767px) {\n    .generic-row-wrapper .generic-row .callout-item .statistics-callout-item {\n        background-color:unset !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .generic-row-wrapper .generic-row .callout-item .statistics-callout-item {\n        height:320px;\n        width: 320px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .callout-row .callout-row-wrapper {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        grid-gap: 8px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        grid-template-columns: unset;\n        justify-content: center;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item {\n        -webkit-box-flex: unset;\n        -ms-flex: unset;\n        flex: unset;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2) ~ .mobile-swiper-item {\n        margin-left: 0;\n        margin-right: 0;\n        width: 49%;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3) ~ .mobile-swiper-item {\n        margin-left: 0;\n        margin-right: 0;\n        width: 32%;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4) ~ .mobile-swiper-item {\n        margin-left: 0;\n        margin-right: 0;\n        width: 24%;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5) ~ .mobile-swiper-item {\n        margin-left: 0;\n        margin-right: 0;\n        width: 32%;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6) ~ .mobile-swiper-item {\n        margin-left: 0;\n        margin-right: 0;\n        width: 32%;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7) ~ .mobile-swiper-item {\n        margin-left: 0;\n        margin-right: 0;\n        width: 24%;\n    }\n\n    .callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8) ~ .mobile-swiper-item {\n        margin-left: 0;\n        margin-right: 0;\n        width: 24%;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:1366px) {\n    .callout-row {\n        grid-gap:16px;\n        gap: 16px;\n    }\n\n    .callout-row .callout--left .callout-content {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .callout-row .callout--left .callout-content .rich-text p {\n        text-align: left !important;\n    }\n\n    .callout-row .callout--left .callout-contentp {\n        text-align: left;\n    }\n\n    .callout-row .callout--left .callout-cta {\n        margin-left: 0;\n        text-align: left;\n    }\n}\n\n.cardGridBlockSearch {\n    --bg-opacity: 1;\n    background-color: #f9f9f9;\n    background-color: rgba(249,249,249,var(--bg-opacity));\n    padding-top: 20px;\n    text-align: center;\n    z-index: 1;\n}\n\n.cardGridBlockSearchwrapper {\n    display: block;\n    position: relative;\n}\n\n.cardGridBlockSearch-header {\n    --bg-opacity: 1;\n    background-color: #f9f9f9;\n    background-color: rgba(249,249,249,var(--bg-opacity));\n    color: #0b2c57;\n   \n    font-size: 22px;\n    line-height: 28px;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .cardGridBlockSearch-header {\n        font-size:28px;\n        line-height: 56px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .cardGridBlockSearch-header {\n        font-size:42px;\n        line-height: 56px;\n    }\n}\n\n.cardGridBlockSearch-icon {\n    margin-left: 20px;\n    margin-top: 20px;\n    position: absolute;\n}\n\n.cardGridBlockSearch-icon svg {\n    fill: #2257b8;\n    height: 18px;\n    width: 17px;\n}\n\n@media (min-width: 1200px) {\n    .cardGridBlockSearch-icon svg {\n        height:22px;\n        width: 21px;\n    }\n}\n\n.cardGridBlockSearch .advancedSearchTextbox {\n    background: #fff 0 0 no-repeat padding-box;\n    border: 1px solid #c6c6c6;\n    border-radius: 40px;\n    -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.07843);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.07843);\n    color: #000;\n    height: 54px;\n    opacity: 1;\n    padding-left: 40px;\n    width: 335px;\n}\n\n@media (min-width: 768px) {\n    .cardGridBlockSearch .advancedSearchTextbox {\n        width:600px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .cardGridBlockSearch .advancedSearchTextbox {\n        height:60px;\n        padding-left: 50px;\n        width: 768px;\n    }\n}\n\n.cardGridBlockSearch .searchButton {\n    background: transparent;\n    border: none;\n    margin-right: 12px;\n    opacity: 0;\n    outline: none;\n}\n\n.cardGridBlockSearch .searchButton img {\n    height: 22px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 22px;\n}\n\n.card-carousel {\n    --n: 1;\n    --i: 0;\n    --u: 4;\n    --neg: -100%;\n    --mobile-peek: 65px;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin: 0 auto;\n    position: relative;\n}\n\n.card-carousel,.card-carousel-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n}\n\n.card-carousel-container {\n    overflow: hidden;\n    -webkit-transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--mobile-peek)));\n    -ms-transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--mobile-peek)));\n    transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--mobile-peek)));\n    -webkit-transition: -webkit-transform 0.5s ease-out;\n    transition: -webkit-transform 0.5s ease-out;\n    -o-transition: transform 0.5s ease-out;\n    transition: transform 0.5s ease-out;\n    transition: transform 0.5s ease-out,-webkit-transform 0.5s ease-out;\n    width: calc(var(--n) * 100%);\n}\n\n@media (min-width: 768px) {\n    .card-carousel-container {\n        -webkit-transform:translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));\n        -ms-transform: translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));\n        transform: translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));\n    }\n}\n\n.card-carousel-container.paged {\n    -webkit-transform: translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));\n    -ms-transform: translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));\n    transform: translate(calc(var(--i) / var(--n) / var(--u) * var(--neg)));\n}\n\n.card-carousel .smooth {\n    -webkit-transition: -webkit-transform calc(var(--f) * 0.5s) ease-out;\n    transition: -webkit-transform calc(var(--f) * 0.5s) ease-out;\n    -o-transition: transform calc(var(--f) * 0.5s) ease-out;\n    transition: transform calc(var(--f) * 0.5s) ease-out;\n    transition: transform calc(var(--f) * 0.5s) ease-out,-webkit-transform calc(var(--f) * 0.5s) ease-out;\n}\n\n.card-carousel-mask {\n    overflow-x: hidden;\n}\n\n.card-carousel-mask ul {\n    list-style: none;\n    padding-left: 0;\n}\n\n.card-carousel-slide {\n    width: 100%;\n    width: calc(100% / var(--n) - var(--mobile-peek));\n}\n\n@media (min-width: 768px) {\n    .card-carousel-slide {\n        width:calc(100% / var(--n) / var(--u) + 1px);\n    }\n}\n\n.card-carousel-slide.paged {\n    width: calc(100% / var(--n) / var(--u) + 1px);\n}\n\n.card-carousel-btn {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    display: none;\n}\n\n@media (min-width: 768px) {\n    .card-carousel-btn {\n        border-radius:100%;\n        -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n        box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n        display: block;\n        height: 30px;\n        min-width: 30px;\n        position: absolute;\n        right: 12px;\n        top: calc(50% - 30px);\n        width: 30px;\n        z-index: 2;\n    }\n\n    .card-carousel-btn svg {\n        fill: #d00;\n        height: 100%;\n        width: 100%;\n    }\n}\n\n.card-carousel-btn.prev {\n    left: 12px;\n    margin-right: 24px;\n}\n\n.card-carousel-btn.next svg {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n.carousel {\n    --n: 1;\n    --i: 0;\n    --neg: -100%;\n    margin: 0 auto;\n    position: relative;\n    width: 100%;\n}\n\n.carousel-container {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    overflow-y: hidden;\n    -webkit-transform: translate(calc(var(--i) / var(--n) * var(--neg)));\n    -ms-transform: translate(calc(var(--i) / var(--n) * var(--neg)));\n    transform: translate(calc(var(--i) / var(--n) * var(--neg)));\n    -webkit-transition: -webkit-transform 0.5s ease-out;\n    transition: -webkit-transform 0.5s ease-out;\n    -o-transition: transform 0.5s ease-out;\n    transition: transform 0.5s ease-out;\n    transition: transform 0.5s ease-out,-webkit-transform 0.5s ease-out;\n    width: 100%;\n    width: calc(var(--n) * 100%);\n}\n\n.carousel-mask {\n    overflow-x: hidden;\n    padding-bottom: 4px;\n}\n\n.carousel-button {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    align-items: center;\n    border: 1px solid #707070;\n    border-radius: 100%;\n    bottom: -65px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 65px;\n    justify-content: center;\n    position: absolute;\n    width: 65px;\n}\n\n.carousel-button svg {\n    fill: #707070;\n    height: 65px;\n    width: 65px;\n}\n\n.carousel-button--prev {\n    left: calc(50% - 129px);\n}\n\n.carousel-button--next {\n    left: calc(50% + 20px);\n}\n\n.carousel-counter {\n    bottom: -48.75px;\n    left: calc(50% - 44px);\n    position: absolute;\n    text-align: center;\n    width: 44px;\n}\n\n.carousel-slide {\n    display: block;\n    height: 100%;\n    width: 100%;\n    width: calc(100% / var(--n));\n}\n\n.carousel-slide > div {\n    margin: 0 auto;\n}\n\n.carousel .dot-navigation {\n    margin-top: 32px;\n}\n\n.cutout-block {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n}\n\n.cutout-block-mask {\n    overflow-x: hidden;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .cutout-block-mask {\n        overflow-x:visible;\n        width: 768px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .cutout-block-mask {\n        width:908px;\n    }\n}\n\n.cutout-block .mobile-swiper {\n    overflow-x: unset;\n}\n\n@media (min-width: 768px) {\n    .cutout-block .mobile-swiper {\n        min-height:593px;\n    }\n}\n\n.cutout-block .mobile-swiper-item {\n    height: 100%;\n    margin: 0;\n}\n\n.cutout-block .mobile-swiper-slide {\n    margin: 0;\n    overflow: visible;\n}\n\n.cutout-block .mobile-swiper-container {\n    overflow-x: hidden;\n}\n\n@media (min-width: 768px) {\n    .cutout-block .mobile-swiper-container {\n        overflow:visible;\n    }\n}\n\n.cutout-block .cutout-slide {\n    background-color: transparent;\n    height: 100%;\n    margin-bottom: 100px;\n    margin-top: 100px;\n}\n\n@media (min-width: 1366px) {\n    .cutout-block .cutout-slide {\n        padding-left:64px;\n        padding-right: 64px;\n    }\n}\n\n.cutout-block .cutout-slide q:before {\n    content: \"\";\n    display: none;\n}\n\n.cutout-block .cutout-slide q:after {\n    content: \"\";\n    display: none;\n}\n\n.cutout-block .cutout-slide-mask {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    background-color: #fff;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 13px 39px rgba(0,0,0,0.16078);\n    box-shadow: 0 13px 39px rgba(0,0,0,0.16078);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 395px;\n    justify-content: flex-end;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 56px;\n    padding-left: 24px;\n    padding-top: 56px;\n    position: relative;\n    width: 95%;\n}\n\n@media (min-width: 768px) {\n    .cutout-block .cutout-slide-mask {\n        padding-left:24px;\n        padding-right: 24px;\n        width: 668px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .cutout-block .cutout-slide-mask {\n        padding:64px;\n        width: 880px;\n    }\n}\n\n.cutout-block .cutout-slide-mask .cutout-slide-media {\n    bottom: 0;\n    height: 85%;\n    left: 56%;\n    position: absolute;\n    width: auto;\n}\n\n@media (min-width: 768px) {\n    .cutout-block .cutout-slide-mask .cutout-slide-media {\n        height:342px;\n        left: unset;\n        right: 0;\n        width: 310px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .cutout-block .cutout-slide-mask .cutout-slide-media {\n        height:442px;\n        width: 410px;\n    }\n}\n\n.cutout-block .cutout-slide-mask .cutout-slide-media img {\n    border-bottom-right-radius: 8px;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    -o-object-position: left;\n    object-position: left;\n    width: 100%;\n}\n\n.cutout-block .cutout-slide-mask .cutout-slide-content {\n    max-width: 60%;\n}\n\n@media (min-width: 768px) {\n    .cutout-block .cutout-slide-mask .cutout-slide-content {\n        max-width:55%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .cutout-block .cutout-slide-mask .cutout-slide-content {\n        max-width:419px;\n    }\n}\n\n.cutout-block .cutout-slide-mask .cutout-slide-content h6 {\n    color: #003c69;\n    line-height: 24px;\n    margin-bottom: 16px;\n}\n\n@media (min-width: 768px) {\n    .cutout-block .cutout-slide-mask .cutout-slide-content h6 {\n        line-height:36px;\n    }\n}\n\n.cutout-block .cutout-slide-mask .cutout-quote-citation {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    font-size: 14px;\n    font-style: normal;\n    line-height: 24px;\n    margin-bottom: 16px;\n    margin-top: 16px;\n}\n\n.cutout-block .cutout-slide-mask .cutout-quote-citation-name {\n    color: #005bbb;\n   \n    font-weight: 700;\n}\n\n.cutout-block .cutout-slide-mask button {\n    margin-top: 24px;\n}\n\n.cutout-block .swiper-buttons {\n    bottom: 0;\n    display: block;\n    height: 60px;\n    left: 50%;\n    margin-left: -77px;\n    top: unset;\n    width: 144px;\n}\n\n.cutout-block .swiper-buttons-backwards {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 2px solid #0098db;\n    height: 60px;\n    margin-bottom: 0;\n    width: 60px;\n}\n\n.cutout-block .swiper-buttons-backwards i {\n    display: none;\n}\n\n.cutout-block .swiper-buttons-forwards {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 2px solid #0098db;\n    height: 60px;\n    margin-bottom: 0;\n    width: 60px;\n}\n\n.cutout-block .dot-navigation,.cutout-block .swiper-buttons-forwards i {\n    display: none;\n}\n\n.image-carousel {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 120px;\n}\n\n.image-carousel-title {\n    font-size: 40px;\n    line-height: 44px;\n    line-height: 52px;\n    margin-bottom: 24px;\n}\n\n@media (min-width: 768px) {\n    .image-carousel-title {\n        margin-bottom:32px;\n    }\n}\n\n.image-carousel-mask {\n    position: relative;\n}\n\n.image-carousel-mask .card-carousel-btn {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 1px solid #0098db;\n    border-radius: 100%;\n    bottom: -80px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    display: block;\n    height: 60px;\n    margin-bottom: 0;\n    position: absolute;\n    top: unset;\n    width: 60px;\n    z-index: 1;\n}\n\n@media (min-width: 768px) {\n    .image-carousel-mask .card-carousel-btn {\n        bottom:-100px;\n    }\n}\n\n.image-carousel-mask .card-carousel-btn .stroke,.image-carousel-mask .card-carousel-btn svg {\n    fill: #003c69;\n    height: 100%;\n    width: 100%;\n}\n\n.image-carousel-mask .card-carousel-btn.next {\n    left: 50%;\n}\n\n.image-carousel-mask .card-carousel-btn.prev {\n    left: unset;\n    right: 50%;\n}\n\n.image-carousel-mask .card-carousel-slide .image-slide-mask {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\n.category-block {\n    --bg-opacity: 1;\n    background-color: #f9f9f9;\n    background-color: rgba(249,249,249,var(--bg-opacity));\n}\n\n@media (min-width: 1200px) {\n    .category-block {\n        padding:50px 0;\n    }\n}\n\n.category-block-wrapper {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.category-block-entries {\n    grid-gap: 28px;\n    display: grid;\n    grid-template-columns: 100%;\n}\n\n@media (min-width: 1200px) {\n    .category-block-entries {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        grid-template-columns: repeat(auto-fit,420px);\n        justify-content: center;\n    }\n}\n\n.category-block-entry {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-pack: distribute;\n    background-color: #fff;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,0.05098);\n    box-shadow: 0 5px 10px rgba(0,0,0,0.05098);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    justify-content: space-around;\n    padding: 38px 28px 20px;\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .category-block-entry {\n        padding:32px 28px 16px;\n        width: 420px;\n    }\n}\n\n.category-block-entry.tag2 .category-block-entry-tags-tag2,.category-block-entry.tag .category-block-entry-tags-tag {\n    display: block;\n}\n\n.category-block-entry-tags {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: space-between;\n    left: 0;\n    padding-left: 24px;\n    padding-right: 24px;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n.category-block-entry-tags-tag,.category-block-entry-tags-tag2 {\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    padding: 4px 8px;\n}\n\n.category-block-entry-tags-tag-color {\n    background-color: rgba(132,196,52,0.2);\n}\n\n.category-block-entry-tags-tag p {\n    color: #1e7721;\n}\n\n.category-block-entry-tags-tag2 {\n    background-color: #1e7721;\n}\n\n.category-block-entry-tags-tag2 p {\n    color: #fff;\n}\n\n.category-block-entry-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.category-block-entry-content p {\n    padding-bottom: 4px;\n}\n\n@media (min-width: 1200px) {\n    .category-block-entry-content p {\n        padding-bottom:8px;\n    }\n}\n\n.category-block-entry-content-title {\n    font-size: 32px;\n    line-height: 38px;\n}\n\n.category-block-entry-content-row {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n\n.category-block-entry-content-row-primary {\n    color: #1e7721;\n}\n\n.category-block-entry-content-row-secondary {\n    padding-bottom: 10px !important;\n    padding-left: 8px;\n}\n\n.category-block-entry-links {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: space-between;\n}\n\n.category-block-dropdown .category-block-dropdown-summary:after {\n    font-size: 54px;\n    left: 0;\n}\n\n.category-block-dropdown {\n    border-bottom: 1px solid rgba(68,68,68,0.15);\n    outline: none;\n}\n\n@media (min-width: 1200px) {\n    .category-block-dropdown {\n        border:none;\n    }\n}\n\n.category-block-dropdown summary {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    list-style-type: none;\n    outline: none;\n    padding-right: 40px;\n    pointer-events: none;\n    position: relative;\n}\n\n.category-block-dropdown summary-title,.category-block-dropdown summary p {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    margin-bottom: 8px;\n    padding-left: 8px;\n}\n\n@media (min-width: 1200px) {\n    .category-block-dropdown summary-title,.category-block-dropdown summary p {\n        --text-opacity:1;\n        color: #2257b8;\n        color: rgba(34,87,184,var(--text-opacity));\n        margin-bottom: 24px;\n    }\n}\n\n.category-block-dropdown summary::marker {\n    display: none;\n}\n\n.category-block-dropdown summary::-webkit-details-marker {\n    display: none;\n}\n\n.css-zy4qjm.webchat__send-box-text-box .webchat__send-box-text-box__input,.css-zy4qjm.webchat__send-box-text-box .webchat__send-box-text-box__text-area-box,[data-css-zy4qjm].webchat__send-box-text-box .webchat__send-box-text-box__input,[data-css-zy4qjm].webchat__send-box-text-box .webchat__send-box-text-box__text-area-box {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 0%;\n    flex: 1 1 0%;\n}\n\n.css-zy4qjm.webchat__send-box-text-box,[data-css-zy4qjm].webchat__send-box-text-box {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.css-1fe8kfc,[data-css-1fe8kfc] {\n    -webkit-box-flex: 10000;\n    -ms-flex: 10000 1 0%;\n    flex: 10000 1 0%;\n}\n\n.css-eycyw2 > .main,[data-css-eycyw2] > .main {\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n    background-color: #fff;\n    border-top: 1px solid #e6e6e6;\n    min-height: 40px;\n}\n\n.css-1882x3w > .main,.css-ca0rlf,[data-css-1882x3w] > .main,[data-css-ca0rlf] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.css-ca0rlf,[data-css-ca0rlf] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.css-y1c0xs,[data-css-y1c0xs] {\n    height: 100%;\n    overflow-y: auto;\n    width: 100%;\n}\n\n.css-mfy564,[data-css-mfy564] {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 0%;\n    flex: 1 1 0%;\n}\n\n.css-gtdio3,[data-css-gtdio3] {\n    overflow: hidden;\n    position: relative;\n}\n\n.css-13t1vy4,[data-css-13t1vy4] {\n    background-color: #fff;\n    height: 100%;\n    width: 100%;\n    z-index: 0;\n}\n\n.css-1t62idy,[data-css-1t62idy] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.css-9ohtah,[data-css-9ohtah] {\n    color: transparent;\n    height: 1px;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    white-space: nowrap;\n    width: 1px;\n}\n\n.chat-opener {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    border-radius: 100%;\n    bottom: 25px;\n    -webkit-box-shadow: 0 4px 12px #bcbcbc;\n    box-shadow: 0 4px 12px #bcbcbc;\n    color: #fff;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    font-size: 16px;\n    font-weight: 700;\n    padding: 18px;\n    position: fixed;\n    right: 15px;\n    text-align: center;\n    width: 75px;\n    z-index: 99;\n}\n\n.chat-opener svg {\n    -webkit-filter: drop-shadow(0 3px 6px rgba(0,61,93,0.48627));\n    filter: drop-shadow(0 3px 6px rgba(0,61,93,0.48627));\n}\n\n.chat-opener.active {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.chat-opener a {\n    color: #fff;\n    display: block;\n    margin-bottom: -4px;\n}\n\n.chat-opener a img.avatar {\n    border-radius: 100%;\n    width: 60px;\n}\n\n.chat-opener .bottip {\n    background-color: #222;\n    border-radius: 3px;\n    color: #fff;\n    font-size: 12px;\n    padding: 6px 10px;\n    position: absolute;\n    right: 75px;\n    top: 20px;\n    white-space: nowrap;\n}\n\n.chat-opener-message {\n    background: #f8f8f8;\n    border: 1px solid rgba(117,120,123,0.15);\n    border-radius: 10px;\n    bottom: 40px;\n    -webkit-box-shadow: 0 4px 12px #bcbcbc;\n    box-shadow: 0 4px 12px #bcbcbc;\n    color: #050f38;\n   \n    max-width: 300px;\n    padding: 9px 40px 11px 14px;\n    position: fixed;\n    right: 100px;\n    z-index: 99;\n}\n\n.chat-opener-message-dismiss {\n    position: absolute;\n    right: 9px;\n    top: 10px;\n}\n\n.chat-opener-message svg .stroke {\n    fill: #868686;\n}\n\n.chat-window {\n    background-color: #fff;\n    bottom: 0;\n    -webkit-box-shadow: 0 0 12px #000;\n    box-shadow: 0 0 12px #000;\n    max-width: 380px;\n    padding: 0;\n    position: fixed;\n    right: 0;\n    width: 380px;\n    width: 100%;\n    z-index: 99;\n}\n\n.chat-window,.chat-window .heading {\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.chat-window .heading {\n    background-color: #222;\n    color: #fff;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 18px;\n    padding: 8px 5px 5px 12px;\n    position: relative;\n}\n\n.chat-window .heading svg,.chat-window .heading svg .stroke {\n    fill: #fff;\n}\n\n.chat-window .chatTitle {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.chat-window .heading a {\n    color: #fff;\n    display: inline-block;\n    padding: 0 5px;\n}\n\n.chat-window #bot {\n    height: 80vh;\n    padding-bottom: 8px;\n    position: relative;\n}\n\n.chat-window #bot .wc-textbox {\n    left: 5px;\n}\n\n.chat-window #bot .wc-header {\n    display: none;\n}\n\n.chat-window #bot .wc-adaptive-card {\n    width: auto;\n}\n\n.chat-window #bot .wc-message-groups {\n    top: 0;\n}\n\n.chat-window #bot .main {\n    padding-top: 0;\n}\n\n.chat-window #bot a {\n    color: #0977a9;\n}\n\n.css-bo8nme {\n    overflow: visible;\n}\n\n.css-1g3yky9 {\n    margin-top: 10px;\n}\n\n.ac-pushButton > div {\n    white-space: normal !important;\n}\n\n@media (min-width: 768px) {\n    .dropdown-cta .title {\n        line-height:46px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .dropdown-cta .title {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n    \n        font-size: 32px;\n        line-height: 36px;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:1366px) {\n    .dropdown-cta .title {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n.dropdown-cta-top {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n@media (min-width: 1200px) {\n    .dropdown-cta-top {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        justify-content: space-between;\n    }\n}\n\n.dropdown-cta-top-dropdown {\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .dropdown-cta-top-dropdown {\n        max-width:400px;\n    }\n}\n\n.dropdown-cta-top-dropdown select {\n    --text-opacity: 1;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 18px;\n    height: 56px;\n    line-height: 20px;\n    line-height: 17px;\n    width: 100%;\n}\n\n.dropdown-cta-top-dropdown:after {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    content: \"â€º\";\n    font-size: 35px;\n    height: 34px;\n    pointer-events: none;\n    position: absolute;\n    right: 5px;\n    top: 20%;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n@media (min-width: 1200px) {\n    .dropdown-cta-top-dropdown {\n        height:-webkit-fit-content;\n        height: -moz-fit-content;\n        height: fit-content;\n        margin-top: 0;\n    }\n}\n\n.dropdown-cta-top-button {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    justify-content: center;\n}\n\n@media (min-width: 768px) {\n    .dropdown-cta-top-button {\n        max-width:100%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .dropdown-cta-top-button button {\n        font-family:Helvetica Now Display Medium;\n    }\n}\n\n.dropdown-cta-bottom-card {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n}\n\n.dropdown-cta-bottom-card-image {\n    height: 80px;\n    margin: 16px 8px;\n    width: 80px;\n}\n\n@media (min-width: 1200px) {\n    .dropdown-cta-bottom-card-image {\n        height:112px;\n        width: 112px;\n    }\n}\n\n.dropdown-cta-bottom-card-image img {\n    border-radius: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.dropdown-cta-bottom-card-content-primary {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 18px;\n    line-height: 20px;\n    line-height: 18px;\n}\n\n@media (min-width: 768px) {\n    .dropdown-cta-bottom-card-content-primary {\n        font-size:18px;\n        line-height: 20px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .dropdown-cta-bottom-card-content-primary {\n        font-size:16px;\n        line-height: 20px;\n    }\n}\n\n.dropdown-cta-bottom-card-content-secondary {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n   \n    font-size: 14px;\n    font-weight: 700;\n    line-height: 14px;\n}\n\n@media (min-width: 1366px) {\n    .dropdown-cta-bottom-card-content-secondary {\n        font-size:18px;\n        line-height: 14px;\n    }\n}\n\n.dropdown-cta-bottom-cta {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    justify-content: center;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.dropdown-cta-bottom-cta p {\n    --text-opacity: 1;\n    color: #1765f4;\n    color: rgba(23,101,244,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 22px;\n}\n\n@media (min-width: 768px) {\n    .dynamic-faq {\n        padding:24px 0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq {\n        padding:32px 0;\n    }\n}\n\n.dynamic-faq-content {\n    max-width: 100%;\n}\n\n.dynamic-faq-content-heading-eyebrow {\n    margin-bottom: 16px;\n}\n\n@media (min-width: 768px) {\n    .dynamic-faq-content-heading-eyebrow {\n        color:#00304e;\n        font-size: 14px;\n        font-weight: 700;\n        letter-spacing: 1.26px;\n        line-height: 48px;\n        text-transform: uppercase;\n    }\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-heading-eyebrow {\n        color:#444;\n        font-size: 16px;\n        margin-bottom: 24px;\n        margin-top: 32px;\n    }\n}\n\n.dynamic-faq-content-heading-header {\n    margin-bottom: 24px;\n}\n\n@media (min-width: 768px) {\n    .dynamic-faq-content-heading-header {\n        font-size:32px;\n        line-height: 40px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-heading-header {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n    \n        font-size: 32px;\n        line-height: 36px;\n        margin-bottom: 48px;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:1366px) {\n    .dynamic-faq-content-heading-header {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n.dynamic-faq-content-image {\n    border-radius: 8px;\n    display: block;\n    margin-bottom: 24px;\n    width: 100%;\n}\n\n.dynamic-faq-content-image img {\n    border-radius: 8px;\n    height: 200px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    -o-object-position: top;\n    object-position: top;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .dynamic-faq-content-image img {\n        height:357px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-image {\n        display:none;\n    }\n}\n\n.dynamic-faq-content-faq {\n    margin-bottom: 24px;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-faq {\n        margin-bottom:32px;\n    }\n}\n\n.dynamic-faq-content-faq-entry[open] .dynamic-faq-content-faq-entry-summary:after {\n    content: \"âˆ’\";\n}\n\n.dynamic-faq-content-faq-entry[close] {\n    background-color: red;\n}\n\n.dynamic-faq-content-faq-entry {\n    border-top: 1px solid #eee;\n    padding-bottom: 16px;\n    padding-top: 16px;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-faq-entry {\n        padding-bottom:24px;\n        padding-top: 24px;\n    }\n}\n\n.dynamic-faq-content-faq-entry:last-child {\n    border-bottom: 1px solid #eee;\n}\n\n.dynamic-faq-content-faq-entry summary {\n    color: #131313;\n    list-style-type: none;\n    outline: none;\n    padding-right: 40px;\n    position: relative;\n}\n\n.dynamic-faq-content-faq-entry summary::marker {\n    display: none;\n}\n\n.dynamic-faq-content-faq-entry summary::-webkit-details-marker {\n    display: none;\n}\n\n.dynamic-faq-content-faq-entry summary:after {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    content: \"+\";\n    font-size: 34px;\n    height: 34px;\n    position: absolute;\n    right: 0;\n    top: 25%;\n    -webkit-transition: all 0.3s ease-out;\n    -o-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n    width: 34px;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-faq-entry summary:after {\n        top:0;\n    }\n}\n\n.dynamic-faq-content-faq-entry p {\n    color: #666;\n    line-height: 22px;\n    margin-top: 16px;\n    padding-bottom: 56px;\n    padding-right: 40px;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-faq-entry p {\n        color:#4a4a4a;\n        line-height: 24px;\n        margin-top: 24px;\n        padding-bottom: 72px;\n    }\n}\n\n.dynamic-faq-content-cta {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    position: relative;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.dynamic-faq-content-cta a {\n    color: #2257b8;\n    line-height: 26px;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-cta a {\n        font-size:23px;\n        line-height: 34px;\n    }\n}\n\n.dynamic-faq-desktop {\n    margin-top: 4px;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-desktop {\n        grid-column:8/13;\n        margin-top: 80px;\n    }\n}\n\n.dynamic-faq-desktop-image {\n    display: none;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-desktop-image {\n        display:block;\n        height: 497px;\n        width: 100%;\n    }\n}\n\n.dynamic-faq-desktop-image img {\n    border-radius: 8px;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.reverse-col {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n}\n\n.enhanced-form {\n    -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n    max-width: 100%;\n}\n\n@media (max-width: 1365px) {\n    .enhanced-form {\n        padding:0 24px;\n    }\n}\n\n.enhanced-form-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-content {\n        grid-column:2/5;\n        margin-bottom: 40px;\n    }\n}\n\n.enhanced-form-content p {\n    text-align: center;\n}\n\n.enhanced-form-content-eyebrow {\n    display: none;\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-content-eyebrow {\n        display:block;\n    }\n}\n\n.enhanced-form-content-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 32px;\n    line-height: 38px;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .enhanced-form-content-title {\n        font-size:44px;\n        line-height: 48px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-content-title {\n        font-size:56px;\n        line-height: 60px;\n    }\n}\n\n.enhanced-form-container,.enhanced-form .layout-container {\n    margin: 0 auto;\n    max-width: 100%;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .enhanced-form-container,.enhanced-form .layout-container {\n        width:100%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-container,.enhanced-form .layout-container {\n        grid-column:6/12;\n        width: unset;\n    }\n}\n\n.enhanced-form .Form__Title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 26px;\n    line-height: 32px;\n    margin-bottom: 32px;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .enhanced-form .Form__Title {\n        font-size:24px;\n        line-height: 28px;\n        margin-bottom: 48px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form .Form__Title {\n        font-size:32px;\n        line-height: 38px;\n        margin-bottom: 48px;\n    }\n}\n\n.scPage-content-side .EPiServerForms {\n    -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.16078);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.16078);\n}\n\n.news-content-side .enhanced-form,.news-landing-content-side .enhanced-form,.scPage-content-side .enhanced-form,.sidebar .enhanced-form {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    border-radius: 10px;\n    -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.16078);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.16078);\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding: 32px 24px 32px 30px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .news-content-side .enhanced-form,.news-landing-content-side .enhanced-form,.scPage-content-side .enhanced-form,.sidebar .enhanced-form {\n        width:420px;\n    }\n}\n\n.news-content-side .enhanced-form-content,.news-landing-content-side .enhanced-form-content,.scPage-content-side .enhanced-form-content,.sidebar .enhanced-form-content {\n    margin-bottom: 0;\n    width: 100%;\n}\n\n.news-content-side .enhanced-form-content-eyebrow,.news-landing-content-side .enhanced-form-content-eyebrow,.scPage-content-side .enhanced-form-content-eyebrow,.sidebar .enhanced-form-content-eyebrow {\n    display: none;\n}\n\n.news-content-side .enhanced-form-container,.news-landing-content-side .enhanced-form-container,.scPage-content-side .enhanced-form-container,.sidebar .enhanced-form-container {\n    width: unset;\n}\n\n.news-content-side .EPiServerForms,.news-landing-content-side .EPiServerForms,.scPage-content-side .EPiServerForms,.sidebar .EPiServerForms {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    width: 100%;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-landing-content-side .EPiServerForms .Form__MainBody section .FormTextbox,.scPage-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.scPage-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.scPage-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.scPage-content-side .EPiServerForms .Form__MainBody section .FormRange,.scPage-content-side .EPiServerForms .Form__MainBody section .FormSelection,.scPage-content-side .EPiServerForms .Form__MainBody section .FormTextbox,.sidebar .EPiServerForms .Form__MainBody section .FormCaptcha,.sidebar .EPiServerForms .Form__MainBody section .FormDateTime,.sidebar .EPiServerForms .Form__MainBody section .FormFileUpload,.sidebar .EPiServerForms .Form__MainBody section .FormRange,.sidebar .EPiServerForms .Form__MainBody section .FormSelection,.sidebar .EPiServerForms .Form__MainBody section .FormTextbox {\n    width: 100%;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody button,.news-landing-content-side .EPiServerForms .Form__MainBody button,.scPage-content-side .EPiServerForms .Form__MainBody button,.sidebar .EPiServerForms .Form__MainBody button {\n    margin: 0;\n    width: 100%;\n}\n\n.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData,.news-landing-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData,.scPage-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData,.sidebar .EPiServerForms .FormParagraphText.Form__Element--NonData {\n    width: 100%;\n}\n\n.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData h3,.news-landing-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData h3,.scPage-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData h3,.sidebar .EPiServerForms .FormParagraphText.Form__Element--NonData h3 {\n   \n    text-align: center;\n}\n\n.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p,.news-landing-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p,.scPage-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p,.sidebar .EPiServerForms .FormParagraphText.Form__Element--NonData p {\n   \n    font-size: 14px;\n    line-height: 22px;\n}\n\n.imagebackground-page-content .enhanced-form {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding: 0 !important;\n    width: 100%;\n}\n\n.imagebackground-page-content .enhanced-form-color {\n    border-radius: 8px;\n}\n\n.imagebackground-page-content .enhanced-form-content {\n    margin-bottom: 0;\n    padding-left: 32px;\n    padding-right: 32px;\n    width: 100%;\n}\n\n.imagebackground-page-content .enhanced-form-content-eyebrow {\n    display: none;\n}\n\n.imagebackground-page-content .EPiServerForms {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    padding: 0 32px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .imagebackground-page-content .EPiServerForms .Form__MainBody section .FormCaptcha,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormDateTime,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormFileUpload,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormRange,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormSelection,.imagebackground-page-content .EPiServerForms .Form__MainBody section .FormTextbox {\n        width:49%;\n    }\n}\n\n.imagebackground-page-content .EPiServerForms .Form__MainBody button {\n    margin: 0;\n}\n\n.imagebackground-page-content .EPiServerForms .FormParagraphText.Form__Element--NonData {\n    width: 100%;\n}\n\n.imagebackground-page-content .EPiServerForms .FormParagraphText.Form__Element--NonData h3 {\n   \n    text-align: center;\n}\n\n.imagebackground-page-content .EPiServerForms .FormParagraphText.Form__Element--NonData p {\n   \n    font-size: 14px;\n    line-height: 22px;\n}\n\n.enhanced-form-color {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    padding-bottom: 20px;\n    padding-top: 32px;\n}\n\n@media (min-width: 768px) {\n    .enhanced-form-color {\n        padding-bottom:120px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-color {\n        padding-bottom:140px;\n    }\n}\n\n.enhanced-form-color .enhanced-form:first-of-type {\n    -webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n    box-shadow: 0 10px 20px rgba(0,0,0,0.10196);\n}\n\n.enhanced-form-color .enhanced-form {\n    border-radius: 10px;\n    padding-top: 32px;\n}\n\n.enhanced-form-color .enhanced-form,.enhanced-form-color .enhanced-form .enhanced-form {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.enhanced-form-color .enhanced-form-color,.enhanced-form-color .layout-container {\n    padding: 0;\n}\n\n.FormSubmitModal {\n    background: rgba(255,255,255,0.8) url(\"\") 50% 50% no-repeat;\n    display: none;\n    height: 100%;\n    left: 0;\n    margin: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 9999;\n}\n\n.FormSubmitLoading .FormSubmitModal {\n    display: block;\n    overflow: hidden;\n}\n\n.ui-datepicker .ui-button:focus .ui-icon,.ui-datepicker .ui-button:hover .ui-icon,.ui-datepicker .ui-state-focus .ui-icon,.ui-datepicker .ui-state-hover .ui-icon,.ui-datepicker .ui-widget-header .ui-icon {\n    background-image: url(\"\");\n}\n\n.form-layout-block .enhanced-form-container .Form__Title {\n    display: none;\n}\n\n.form-layout-block .enhanced-form-content {\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block .enhanced-form-content {\n        padding-left:0;\n        padding-right: 0;\n    }\n\n    .form-layout-block .layout-container {\n        padding-top: 30px;\n    }\n}\n\n@media (min-width: 960px) {\n    .form-layout-block .layout-container {\n        padding-bottom:0;\n        padding-top: 0;\n    }\n}\n\n.form-layout-block .layout-container .enhanced-form {\n    display: block;\n    grid: none;\n    padding: 0 24px;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block .layout-container .enhanced-form {\n        padding-left:0;\n        padding-right: 0;\n    }\n}\n\n.form-layout-block .layout-container .enhanced-form-content {\n    display: none;\n}\n\n.form-layout-block .layout-container .enhanced-form-container {\n    grid-column: none;\n}\n\n.form-layout-block .layout-container form {\n    padding-bottom: 0;\n    padding-top: 0;\n}\n\n#recaptchaLegal {\n    display: none;\n}\n\n.grecaptcha-badge {\n    visibility: hidden;\n}\n\n@media (max-width: 1365px) {\n    .form-anchor {\n        position:relative;\n        top: -87px;\n    }\n}\n\n.EPiServerForms {\n    border-radius: 10px;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 720px;\n    width: 100%;\n}\n\n.EPiServerForms .hide {\n    display: none !important;\n}\n\n.EPiServerForms .Form__Status div {\n    margin: 0;\n    padding: 0;\n}\n\n.EPiServerForms .Form__MainBody section {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-top: 8px;\n    position: relative;\n    width: 100%;\n}\n\n.EPiServerForms .Form__MainBody section .Form__Element {\n    margin-bottom: 16px;\n}\n\n.EPiServerForms .Form__MainBody section input,.EPiServerForms .Form__MainBody section select,.EPiServerForms .Form__MainBody section textarea {\n    border: 1px solid #bbb;\n    border-radius: 5px;\n    color: inherit;\n    height: 50px;\n    line-height: inherit;\n    padding: 0 20px;\n    width: 100%;\n}\n\n.EPiServerForms .Form__MainBody section input::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section select::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section textarea::-webkit-input-placeholder {\n    color: #666;\n    opacity: 0;\n}\n\n.EPiServerForms .Form__MainBody section input::-moz-placeholder,.EPiServerForms .Form__MainBody section select::-moz-placeholder,.EPiServerForms .Form__MainBody section textarea::-moz-placeholder {\n    color: #666;\n    opacity: 0;\n}\n\n.EPiServerForms .Form__MainBody section input:-ms-input-placeholder,.EPiServerForms .Form__MainBody section select:-ms-input-placeholder,.EPiServerForms .Form__MainBody section textarea:-ms-input-placeholder {\n    color: #666;\n    opacity: 0;\n}\n\n.EPiServerForms .Form__MainBody section input::-ms-input-placeholder,.EPiServerForms .Form__MainBody section select::-ms-input-placeholder,.EPiServerForms .Form__MainBody section textarea::-ms-input-placeholder {\n    color: #666;\n    opacity: 0;\n}\n\n.EPiServerForms .Form__MainBody section input::placeholder,.EPiServerForms .Form__MainBody section select::placeholder,.EPiServerForms .Form__MainBody section textarea::placeholder {\n    color: #666;\n    opacity: 0;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #c6e7fa;\n    background-color: rgba(198,231,250,var(--bg-opacity));\n    border-radius: 8px;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    display: block;\n    height: auto;\n    margin-bottom: 20px;\n    opacity: 1;\n    padding: 16px;\n    -webkit-transition-duration: 0.5s;\n    -o-transition-duration: 0.5s;\n    transition-duration: 0.5s;\n    -webkit-transition-property: opacity;\n    -o-transition-property: opacity;\n    transition-property: opacity;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,0.2,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,0.2,1);\n    transition-timing-function: cubic-bezier(0.4,0,0.2,1);\n    width: 100%;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart:not(.take-over) {\n    padding-left: 52px;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    align-items: center;\n    bottom: -4px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    justify-content: flex-start;\n    left: 0;\n    padding-bottom: 32px;\n    padding-top: 24px;\n    position: relative;\n    right: 0;\n    text-align: center;\n    top: -4px;\n    z-index: 1;\n}\n\n@media (min-width: 1366px) {\n    .EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        padding-bottom: 48px;\n        padding-top: 32px;\n    }\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .take-over-icon {\n    display: block;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .small-icon {\n    display: none;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .message {\n    margin-bottom: 32px;\n    margin-top: 24px;\n    max-width: 456px;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.take-over .link-start-over {\n    margin-top: 16px;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart.hidden {\n    display: none;\n    height: 0;\n    opacity: 0;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .take-over-icon,.EPiServerForms .Form__MainBody section .FormApplicationQuickStart a.hidden {\n    display: none;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .small-icon {\n    left: 16px;\n    position: absolute;\n    top: 20px;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .small-icon svg {\n    fill: #003876;\n}\n\n.EPiServerForms .Form__MainBody section .FormApplicationQuickStart .message {\n    margin-bottom: 16px;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha,.EPiServerForms .Form__MainBody section .FormDateTime,.EPiServerForms .Form__MainBody section .FormFileUpload,.EPiServerForms .Form__MainBody section .FormRange,.EPiServerForms .Form__MainBody section .FormSelection,.EPiServerForms .Form__MainBody section .FormTextbox {\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .EPiServerForms .Form__MainBody section .FormCaptcha,.EPiServerForms .Form__MainBody section .FormDateTime,.EPiServerForms .Form__MainBody section .FormFileUpload,.EPiServerForms .Form__MainBody section .FormRange,.EPiServerForms .Form__MainBody section .FormSelection,.EPiServerForms .Form__MainBody section .FormTextbox {\n        width:320px;\n    }\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select {\n    border: 1px solid red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select::-webkit-input-placeholder {\n    color: red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input::-moz-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select::-moz-placeholder {\n    color: red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input:-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select:-ms-input-placeholder {\n    color: red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input::-ms-input-placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select::-ms-input-placeholder {\n    color: red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select::placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail input::placeholder,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select::placeholder {\n    color: red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select {\n    color: rgba(0,0,0,0);\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select:focus,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select.has-data,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select:focus {\n    color: red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormRange.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail select option:not(:first-of-type),.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail select option:not(:first-of-type) {\n    color: #000;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail .Form__Element__ValidationError {\n    color: red;\n   \n    font-size: 14px;\n    line-height: 14px;\n    padding-left: 12px;\n    padding-right: 12px;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail label,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail label,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail label,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail label,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail label,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail label {\n    color: red;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha label,.EPiServerForms .Form__MainBody section .FormDateTime label,.EPiServerForms .Form__MainBody section .FormFileUpload label,.EPiServerForms .Form__MainBody section .FormRange label,.EPiServerForms .Form__MainBody section .FormSelection label,.EPiServerForms .Form__MainBody section .FormTextbox label {\n    font-size: 12px;\n    font-size: 16px;\n    text-align: left;\n    top: 12px;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.EPiServerForms .Form__MainBody section .FormRange label.has-data,.EPiServerForms .Form__MainBody section .FormSelection label.has-data,.EPiServerForms .Form__MainBody section .FormTextbox label.has-data {\n    font-size: 12px;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha[focus-within] label,.EPiServerForms .Form__MainBody section .FormDateTime[focus-within] label,.EPiServerForms .Form__MainBody section .FormFileUpload[focus-within] label,.EPiServerForms .Form__MainBody section .FormRange[focus-within] label,.EPiServerForms .Form__MainBody section .FormSelection[focus-within] label,.EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label {\n    background-color: #fff;\n    color: #2257b8;\n    font-size: 12px;\n    top: -11px;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha:focus-within label,.EPiServerForms .Form__MainBody section .FormDateTime:focus-within label,.EPiServerForms .Form__MainBody section .FormFileUpload:focus-within label,.EPiServerForms .Form__MainBody section .FormRange:focus-within label,.EPiServerForms .Form__MainBody section .FormSelection:focus-within label,.EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {\n    background-color: #fff;\n    color: #2257b8;\n    font-size: 12px;\n    top: -11px;\n}\n\n.EPiServerForms .Form__MainBody section .FormFileUpload {\n    width: 100%;\n}\n\n.EPiServerForms .Form__MainBody section .FormFileUpload label {\n    background-color: #fff;\n    font-size: 12px;\n    top: -11px;\n}\n\n.EPiServerForms .Form__MainBody section .FormFileUpload input {\n    overflow: hidden;\n    padding-bottom: 8px;\n    padding-top: 8px;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime label {\n    background-color: #fff;\n    font-size: 12px;\n    top: -11px;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime input {\n    width: 100%;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime input::-webkit-input-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime input::-moz-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime input:-ms-input-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime input::-ms-input-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime input::placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha button {\n    background-color: #2257b8 !important;\n    height: 35px;\n    margin-bottom: 4px;\n    width: 200px;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha img {\n    margin-bottom: 4px;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha label {\n    background-color: #fff;\n    color: #2257b8;\n    display: none;\n    font-size: 12px;\n    left: 10px;\n    padding: 0 10px;\n    position: absolute;\n    top: -21px;\n    z-index: 0;\n}\n\n\n.EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 27px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 16px;\n    height: 56px;\n    letter-spacing: 0.16px;\n    margin-left: auto;\n    min-width: 196px;\n    padding: 0 2rem;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section button {\n        width:320px;\n    }\n}\n\n.EPiServerForms .Form__MainBody section a.button {\n    padding-top: 16px;\n}\n\n.EPiServerForms .Form__MainBody section a.button:after {\n    display: none;\n}\n\n.EPiServerForms.form-take-over .Form__Element:not(.FormStep) {\n    display: none;\n}\n\n.EPiServerForms .FormParagraphText.Form__Element--NonData {\n    width: 100%;\n}\n\n.EPiServerForms .FormParagraphText.Form__Element--NonData p {\n   \n    font-size: 14px;\n    line-height: 22px;\n}\n\n.EPiServerForms a {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n    display: inline-block;\n   \n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.EPiServerForms a:before {\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    opacity: 0;\n}\n\n.EPiServerForms a:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .EPiServerForms a:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .EPiServerForms a:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.EPiServerForms a.wrapper:after {\n    width: 0;\n}\n\n.EPiServerForms a.disclaimer-hide,.EPiServerForms span.disclaimer-more {\n    display: none;\n}\n\n.destinations-grid-wrapper,.generic-grid-wrapper {\n    word-wrap: anywhere;\n}\n\n.destinations-grid-content .text-content,.generic-grid-content .text-content {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-content .text-content,.generic-grid-content .text-content {\n        --text-opacity:1;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n    }\n\n    .destinations-grid-content .title,.generic-grid-content .title {\n        --text-opacity: 1;\n        color: #003876;\n        color: rgba(0,56,118,var(--text-opacity));\n    }\n}\n\n.destinations-grid-content-overline,.generic-grid-content-overline {\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    letter-spacing: 1.26px;\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-content-overline,.generic-grid-content-overline {\n        font-size:16px;\n        line-height: 16px;\n    }\n}\n\n.destinations-grid-content p,.generic-grid-content p {\n    text-align: left;\n}\n\n.destinations-grid-content-link,.generic-grid-content-link {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    padding-right: 15px;\n    position: relative;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.destinations-grid-content-link:before,.generic-grid-content-link:before {\n    content: \"â€º\";\n    font-size: 25px;\n    line-height: 20px;\n    position: absolute;\n    right: 0;\n}\n\n.destinations-grid-media,.generic-grid-media {\n    margin: 0 auto;\n    opacity: 0.85;\n    width: 100%;\n}\n\n.destinations-grid-media-text,.generic-grid-media-text {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    padding: 16px;\n    position: absolute;\n    text-align: center;\n}\n\n.destinations-grid-media-subtext,.generic-grid-media-subtext {\n    --text-opacity: 1;\n    bottom: 0;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    padding: 2%;\n    position: absolute;\n    right: 0;\n}\n\n.destinations-grid-media-large,.generic-grid-media-large {\n    margin-bottom: 8px;\n    position: relative;\n}\n\n.destinations-grid-media-large img,.generic-grid-media-large img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid-media-large img,.generic-grid-media-large img {\n        height:608px;\n    }\n}\n\n.destinations-grid-media-large .destinations-grid-media-text,.destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .destinations-grid-media-text,.generic-grid-media-large .generic-grid-media-text {\n    -ms-flex-item-align: center;\n    -ms-flex-pack: distribute;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    align-self: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n    font-size: 56px;\n    height: 100%;\n    justify-content: space-around;\n    line-height: 56px;\n    text-align: center;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-media-large .destinations-grid-media-text,.destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .destinations-grid-media-text,.generic-grid-media-large .generic-grid-media-text {\n        font-size:60px;\n        line-height: 52px;\n    }\n}\n\n.destinations-grid-media-large .destinations-grid-media-text,.generic-grid-media-large .destinations-grid-media-text {\n    bottom: 30%;\n}\n\n.destinations-grid-media-grid,.generic-grid-media-grid {\n    grid-template-rows: repeat(2,minmax(0,auto));\n}\n\n.destinations-grid-media-grid .two-image,.generic-grid-media-grid .two-image {\n    max-height: 176px;\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-media-grid .two-image,.generic-grid-media-grid .two-image {\n        max-height:320px;\n    }\n}\n\n.destinations-grid-media-grid .three-image,.generic-grid-media-grid .three-image {\n    max-height: 176px;\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-media-grid .three-image,.generic-grid-media-grid .three-image {\n        max-height:320px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid-media-grid,.generic-grid-media-grid {\n        height:608px;\n    }\n}\n\n.destinations-grid-media-grid .generic-grid-media-text,.generic-grid-media-grid .generic-grid-media-text {\n    padding-bottom: 24px;\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid-media-grid .generic-grid-media-text,.generic-grid-media-grid .generic-grid-media-text {\n        padding-bottom:16px;\n        padding-right: 24px;\n    }\n}\n\n.destinations-grid-media-grid-row,.generic-grid-media-grid-row {\n    height: 50%;\n}\n\n.destinations-grid-media-grid-row-image,.generic-grid-media-grid-row-image {\n    position: relative;\n}\n\n.destinations-grid-media-grid-row-image img,.generic-grid-media-grid-row-image img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.destinations-grid-media-grid-row-image .destinations-grid-media-text,.destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .destinations-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {\n    -ms-flex-item-align: center;\n    -ms-flex-pack: distribute;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    align-self: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n    font-size: 22px;\n    height: 100%;\n    justify-content: space-around;\n    line-height: 24px;\n    text-shadow: 0 3px 6px #000029;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-media-grid-row-image .destinations-grid-media-text,.destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .destinations-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {\n        font-size:32px;\n        line-height: 40px;\n    }\n}\n\n.destinations-grid-media-grid-row-image .destinations-grid-media-text,.generic-grid-media-grid-row-image .destinations-grid-media-text {\n    bottom: 30%;\n}\n\n.hero-banner {\n    height: 460px;\n    position: relative;\n}\n\n.hero-banner.auto-height {\n    height: auto;\n}\n\n@media (min-width: 768px) {\n    .hero-banner.auto-height {\n        height:auto;\n    }\n\n    .hero-banner {\n        height: 288px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner {\n        height:472px;\n    }\n}\n\n.hero-banner-image-mask {\n    height: 100%;\n    left: 0;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    width: 100vw;\n    z-index: 0;\n}\n\n.hero-banner-image-mask picture {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n.hero-banner-image-mask picture img {\n    height: auto;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.hero-banner-form {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    background-color: #1f95cb;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    height: 336px;\n    padding: 16px;\n    position: relative;\n    top: 160px;\n    width: 100%;\n    z-index: 1;\n}\n\n.hero-banner-form input::-webkit-input-placeholder {\n    line-height: normal !important;\n}\n\n@media (min-width: 768px) {\n    .hero-banner-form {\n        height:320px;\n        margin: 0;\n        max-width: 546px;\n        padding: 24px;\n        position: absolute;\n        right: 0;\n        top: 33px;\n        width: 320px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form {\n        height:511px;\n        max-width: 656px;\n        padding-top: 32px;\n        top: 24px;\n        width: 656px;\n    }\n}\n\n.hero-banner-form-mask {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 100%;\n    justify-content: flex-end;\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .hero-banner-form-mask {\n        height:100%;\n    }\n}\n\n.hero-banner-form .hero-text {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 16px;\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form .hero-text {\n        margin-bottom:24px;\n    }\n}\n\n.hero-banner-form .hero-text-top {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n    font-size: 24px;\n    line-height: 30px;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .hero-banner-form .hero-text-top {\n        font-size:32px;\n        line-height: 36px;\n        line-height: 32px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form .hero-text-top {\n        font-size:40px;\n        line-height: 42px;\n    }\n}\n\n.hero-banner-form .hero-text-bottom {\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n   \n    font-size: 56px;\n    line-height: 60px;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .hero-banner-form .hero-text-bottom {\n        font-size:36px;\n        line-height: 40px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form .hero-text-bottom {\n        font-size:48px;\n        font-size: 56px;\n        line-height: 52px;\n    }\n}\n\n.hero-banner-form .hero-text {\n    overflow: hidden;\n}\n\n.hero-banner-form-controls {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    margin-top: 8px;\n    overflow: hidden;\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form-controls {\n        -webkit-box-pack:start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n        margin-left: 36px;\n        margin-top: 32px;\n    }\n\n    .hero-banner-form-controls button {\n        --bg-opacity: 1;\n        --text-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        border-radius: 8px;\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        display: inline-block;\n       \n        height: 48px;\n        letter-spacing: 0.16px;\n        line-height: 20px;\n        line-height: 48px;\n        min-width: 164px;\n        padding-left: 32px;\n        padding-right: 32px;\n        text-align: center;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (min-width: 1366px) and (hover:hover) {\n    .hero-banner-form-controls button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form-controls button > span,.hero-banner-form-controls button i,.hero-banner-form-controls button svg {\n        display:inline;\n    }\n\n    .hero-banner-form-controls button svg {\n        fill: #fff;\n        height: 20px;\n        margin-right: 4px;\n        -webkit-transform: translateY(-2.5px);\n        -ms-transform: translateY(-2.5px);\n        transform: translateY(-2.5px);\n        width: 20px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form-controls button:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n@media (min-width: 1366px) and (hover:hover) {\n    .hero-banner-form-controls button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form-controls button.inverted {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        color: #002146;\n        color: rgba(0,33,70,var(--text-opacity));\n    }\n}\n\n@media (min-width: 1366px) and (hover:hover) {\n    .hero-banner-form-controls button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form-controls button.inverted:active {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #2257b8;\n        background-color: rgba(34,87,184,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form-controls button.inverted:disabled {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n@media (min-width: 1366px) and (hover:hover) {\n    .hero-banner-form-controls button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.hero-banner-form-background {\n    bottom: 20px;\n    height: 80px;\n    position: absolute;\n    right: 12px;\n    width: 140px;\n    z-index: -1;\n}\n\n@media (min-width: 768px) {\n    .hero-banner-form-background {\n        height:80px;\n        width: 134px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form-background {\n        height:162px;\n        width: 278px;\n    }\n}\n\n.hero-banner-form-background img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.hero-banner-form .job-search-form input {\n    border-radius: 6px;\n    height: 56px;\n    margin-bottom: 8px;\n    padding-left: 48px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .hero-banner-form .job-search-form input {\n        height:32px;\n        padding-bottom: 4px;\n        padding-left: 32px;\n        width: 208px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form .job-search-form input {\n        height:64px;\n        padding-bottom: 4px;\n        padding-left: 48px;\n        width: 432px;\n    }\n}\n\n.hero-banner-form .job-search-form input::-webkit-input-placeholder {\n    color: #999;\n   \n    font-size: 16px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.hero-banner-form .job-search-form input::-moz-placeholder {\n    color: #999;\n   \n    font-size: 16px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.hero-banner-form .job-search-form input:-ms-input-placeholder {\n    color: #999;\n   \n    font-size: 16px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.hero-banner-form .job-search-form input::-ms-input-placeholder {\n    color: #999;\n   \n    font-size: 16px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.hero-banner-form .job-search-form input::placeholder {\n    color: #999;\n   \n    font-size: 16px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n@media (min-width: 768px) {\n    .hero-banner-form .job-search-form input::-webkit-input-placeholder {\n        font-size:11px;\n    }\n\n    .hero-banner-form .job-search-form input::-moz-placeholder {\n        font-size: 11px;\n    }\n\n    .hero-banner-form .job-search-form input:-ms-input-placeholder {\n        font-size: 11px;\n    }\n\n    .hero-banner-form .job-search-form input::-ms-input-placeholder {\n        font-size: 11px;\n    }\n\n    .hero-banner-form .job-search-form input::placeholder {\n        font-size: 11px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hero-banner-form .job-search-form input::-webkit-input-placeholder {\n        font-size:18px;\n    }\n\n    .hero-banner-form .job-search-form input::-moz-placeholder {\n        font-size: 18px;\n    }\n\n    .hero-banner-form .job-search-form input:-ms-input-placeholder {\n        font-size: 18px;\n    }\n\n    .hero-banner-form .job-search-form input::-ms-input-placeholder {\n        font-size: 18px;\n    }\n\n    .hero-banner-form .job-search-form input::placeholder {\n        font-size: 18px;\n    }\n}\n\n.hero-banner-strike {\n    --text-opacity: 1;\n    -webkit-box-flex: 0;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    --bg-opacity: 1;\n    background-color: #003876;\n    background-color: rgba(0,56,118,var(--bg-opacity));\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: none;\n    flex: none;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: -36px;\n    margin-left: 16px;\n    margin-right: 16px;\n    padding: 32px;\n    position: relative;\n    z-index: 1;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-strike {\n        margin-left:120px;\n        min-height: 424px;\n        width: 545px;\n    }\n}\n\n.hero-banner-strike-mask {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 1365px;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-strike-mask {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 28px;\n    }\n}\n\n.hero-banner-strike-header {\n    --text-opacity: 1;\n    -webkit-box-flex: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    -ms-flex: 1 1 0%;\n    flex: 1 1 0%;\n    margin: 44px 36px 20px;\n    z-index: 1;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-strike-header {\n        margin-left:0;\n        margin-right: 0;\n        margin-top: 36px;\n    }\n}\n\n.hero-banner-strike-header h1 {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    font-size: 40px;\n    line-height: 44px;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-strike-header h1 {\n        font-size:56px;\n        line-height: 60px;\n    }\n}\n\n.hero-banner-strike-header .hero-description {\n    font-size: 18px;\n    line-height: 28px;\n}\n\n.hero-banner-strike-card-header {\n    --text-opacity: 1;\n    color: #c6e7fa;\n    color: rgba(198,231,250,var(--text-opacity));\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 30px;\n    margin-bottom: 20px;\n    position: relative;\n    text-transform: uppercase;\n}\n\n.hero-banner-strike-card-header:after {\n    --bg-opacity: 1;\n    background-color: #c6e7fa;\n    background-color: rgba(198,231,250,var(--bg-opacity));\n    bottom: -4px;\n    content: \"\";\n    height: 4px;\n    left: 0;\n    position: absolute;\n    width: 28px;\n}\n\n.hero-banner-cta {\n    --text-opacity: 1;\n    -webkit-box-flex: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    -ms-flex: 1 1 0%;\n    flex: 1 1 0%;\n    padding-bottom: 104px;\n    padding-left: 32px;\n    padding-top: 216px;\n    position: relative;\n    z-index: 1;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-cta {\n        padding-left:0;\n        padding-top: 132px;\n    }\n}\n\n.hero-banner-cta h1 {\n    --text-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 22px;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-cta h1 .hero-text {\n        margin-bottom:12px;\n    }\n}\n\n.hero-banner-cta h1 .hero-text-top {\n   \n    font-size: 28px;\n    line-height: 32px;\n    min-height: auto;\n    padding-bottom: 8px;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-cta h1 .hero-text-top {\n        font-size:48px;\n        line-height: 48px;\n    }\n}\n\n.hero-banner-cta h1 .hero-text-bottom {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 58px;\n    line-height: 63px;\n}\n\n@media (min-width: 1200px) {\n    .hero-banner-cta h1 .hero-text-bottom {\n        font-size:96px;\n        line-height: 96px;\n    }\n}\n\n.hero-banner-cta .cta-primary-large,.hero-banner-cta .cta-primary-large > a,.hero-banner-cta .cta-primary-large > button {\n    background-color: #ff6319;\n}\n\n.hero-banner .img-gradient:after {\n    background: transparent -o-linear-gradient(left,#000 0,rgba(0,0,0,0) 100%) 0 0 no-repeat padding-box;\n    background: transparent -webkit-gradient(linear,left top,right top,from(#000),to(rgba(0,0,0,0))) 0 0 no-repeat padding-box;\n    background: transparent linear-gradient(90deg,#000,rgba(0,0,0,0)) 0 0 no-repeat padding-box;\n    content: \"\";\n    display: inline-block;\n    height: 100%;\n    left: 0;\n    opacity: 0.4;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n.input-text {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    max-width: 475px;\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .input-text {\n        margin-bottom:8px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n\n.input-text input {\n    border-radius: 6px;\n    height: 56px;\n    margin-bottom: 8px;\n    padding-left: 48px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .input-text input {\n        height:32px;\n        padding-bottom: 4px;\n        padding-left: 32px;\n        width: 208px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .input-text input {\n        height:64px;\n        padding-bottom: 4px;\n        padding-left: 48px;\n        width: 432px;\n    }\n}\n\n.input-text input::-webkit-input-placeholder {\n    color: #999;\n   \n    font-size: 18px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.input-text input::-moz-placeholder {\n    color: #999;\n   \n    font-size: 18px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.input-text input:-ms-input-placeholder {\n    color: #999;\n   \n    font-size: 18px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.input-text input::-ms-input-placeholder {\n    color: #999;\n   \n    font-size: 18px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n.input-text input::placeholder {\n    color: #999;\n   \n    font-size: 18px;\n    letter-spacing: 0.18px;\n    line-height: 56px;\n}\n\n@media (min-width: 768px) {\n    .input-text input::-webkit-input-placeholder {\n        font-size:11px;\n    }\n\n    .input-text input::-moz-placeholder {\n        font-size: 11px;\n    }\n\n    .input-text input:-ms-input-placeholder {\n        font-size: 11px;\n    }\n\n    .input-text input::-ms-input-placeholder {\n        font-size: 11px;\n    }\n\n    .input-text input::placeholder {\n        font-size: 11px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .input-text input::-webkit-input-placeholder {\n        font-size:18px;\n    }\n\n    .input-text input::-moz-placeholder {\n        font-size: 18px;\n    }\n\n    .input-text input:-ms-input-placeholder {\n        font-size: 18px;\n    }\n\n    .input-text input::-ms-input-placeholder {\n        font-size: 18px;\n    }\n\n    .input-text input::placeholder {\n        font-size: 18px;\n    }\n}\n\n.input-text-icon {\n    height: 24px;\n    left: 16px;\n    position: absolute;\n    top: 25%;\n    width: 24px;\n}\n\n@media (min-width: 768px) {\n    .input-text-icon {\n        left:40px;\n        top: 15%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .input-text-icon {\n        left:40px;\n        top: 23%;\n    }\n}\n\n.input-text-icon svg {\n    fill: #d00;\n}\n\n.header-filler {\n    height: 64px;\n}\n\n@media (min-width: 1366px) {\n    .header-filler {\n        height:126px;\n    }\n}\n\n.igFeed-content {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.igFeed-content-heading {\n    --text-opacity: 1;\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n    margin-left: 12px;\n    margin-right: 12px;\n}\n\n.igFeed-content-logo {\n    display: none;\n    height: 100px;\n}\n\n@media (min-width: 1200px) {\n    .igFeed-content-logo {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        height: 100px;\n        width: 200px;\n    }\n}\n\n.igFeed-content-logo img {\n    height: 100%;\n    -o-object-fit: contain;\n    object-fit: contain;\n    width: 100%;\n}\n\n.igFeed-card {\n    aspect-ratio: 1/1;\n    height: 100%;\n    width: 100%;\n}\n\n.igFeed-card img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.igFeed-card-image-thumbnail img {\n    -o-object-fit: contain;\n    object-fit: contain;\n}\n\n.interactive-ux-container {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n@media (max-width: 767px) {\n    .interactive-ux-container {\n        display:none;\n    }\n}\n\n.interactive-ux-container-column {\n    background: inherit;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n@media (min-width: 768px) {\n    .interactive-ux-container-column {\n        max-width:33%;\n    }\n}\n\n@media (max-width: 374px) {\n    .interactive-ux-container-column {\n        max-width:100%;\n    }\n}\n\n.interactive-ux-container-column .interactive-ux-item-card {\n    height: 110px;\n    margin-bottom: 45px;\n    max-width: 400px;\n}\n\n@media (max-width: 1365px) {\n    .interactive-ux-container-column .interactive-ux-item-card {\n        max-width:340px;\n    }\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-text {\n    width: 70%;\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-text-title {\n    color: var(--interactive-ux-svg-color);\n    letter-spacing: 0;\n    text-align: right;\n    width: 100%;\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-text-description {\n    color: #333;\n    letter-spacing: 0;\n    max-width: 300px;\n    text-align: right;\n    width: unset;\n}\n\n@media (max-width: 1199px) {\n    .interactive-ux-container-column .interactive-ux-item-card-text-description {\n        max-width:290px;\n    }\n}\n\n@media (max-width: 767px) {\n    .interactive-ux-container-column .interactive-ux-item-card-text-description {\n        max-width:250px;\n    }\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-0 {\n    margin-top: 150px;\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-icon {\n    border: 2px solid var(--interactive-ux-svg-color);\n    border-radius: 70px;\n    float: left;\n    height: 70px;\n    width: 70px;\n}\n\n@media (max-width: 1365px) {\n    .interactive-ux-container-column .interactive-ux-item-card-icon {\n        border-radius:62px;\n        height: 62px;\n        width: 62px;\n    }\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-icon svg {\n    height: 70px;\n    margin: auto;\n}\n\n@media (max-width: 1365px) {\n    .interactive-ux-container-column .interactive-ux-item-card-icon svg {\n        height:62px;\n    }\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-icon svg path,.interactive-ux-container-column .interactive-ux-item-card-icon svg rect {\n    fill: var(--interactive-ux-svg-color);\n    stroke: #fff;\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-icon:hover {\n    background-color: var(--interactive-ux-svg-color);\n}\n\n.interactive-ux-container-column .interactive-ux-item-card-icon:hover svg path,.interactive-ux-container-column .interactive-ux-item-card-icon:hover svg rect {\n    stroke: unset;\n    fill: var(--interactive-ux-svg-hover-color);\n}\n\n.interactive-ux-container-column-right .interactive-ux-item-card-text {\n    float: right;\n    margin-left: 20px;\n}\n\n@media (max-width: 959px) {\n    .interactive-ux-container-column-right .interactive-ux-item-card-text {\n        margin-left:10px;\n    }\n}\n\n@media (max-width: 767px) {\n    .interactive-ux-container-column-right .interactive-ux-item-card-text {\n        margin-left:0;\n    }\n}\n\n.interactive-ux-container-column-right .interactive-ux-item-card-text-description,.interactive-ux-container-column-right .interactive-ux-item-card-text-title {\n    text-align: left;\n}\n\n.interactive-ux-container-column-right .interactive-ux-item-card-icon {\n    float: left;\n}\n\n.interactive-ux-container-column-left .interactive-ux-item-card-text {\n    float: left;\n    margin-right: 20px;\n}\n\n@media (max-width: 959px) {\n    .interactive-ux-container-column-left .interactive-ux-item-card-text {\n        margin-right:10px;\n    }\n}\n\n@media (max-width: 767px) {\n    .interactive-ux-container-column-left .interactive-ux-item-card-text {\n        margin-right:0;\n    }\n}\n\n.interactive-ux-container-column-left .interactive-ux-item-card-text-description,.interactive-ux-container-column-left .interactive-ux-item-card-text-title {\n    text-align: right;\n}\n\n.interactive-ux-container-column-left .interactive-ux-item-card-icon {\n    float: right;\n}\n\n.interactive-ux-container-column-image img {\n    margin: auto;\n    max-width: 400px;\n}\n\n@media (max-width: 959px) {\n    .interactive-ux-container-column-image img {\n        max-width:230px;\n    }\n}\n\n@media (max-width: 374px) {\n    .interactive-ux-container-column-image img {\n        max-width:100%;\n    }\n}\n\n.interactive-ux-container-mobile {\n    display: unset;\n}\n\n@media (min-width: 768px) {\n    .interactive-ux-container-mobile {\n        display:none;\n    }\n}\n\n.interactive-ux-container-mobile ul.mobile-swiper-container {\n    margin-bottom: 30px;\n}\n\n@media (max-width: 959px) {\n    .interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item > div {\n        display:inline;\n        display: initial;\n    }\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card {\n    margin: auto;\n    width: 85%;\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-text {\n    float: left;\n    width: 75%;\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-text-title {\n    color: var(--interactive-ux-svg-color);\n    letter-spacing: 0;\n    text-align: left;\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-text-description {\n    color: #333;\n    letter-spacing: 0;\n    max-width: 230px;\n    text-align: left;\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon {\n    border: 2px solid var(--interactive-ux-svg-color);\n    border-radius: 50px;\n    float: left;\n    height: 50px;\n    margin-right: 15px;\n    width: 50px;\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon svg {\n    height: 50px;\n    margin: auto;\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon svg path,.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon svg rect {\n    fill: var(--interactive-ux-svg-color);\n    stroke: unset;\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon:hover {\n    background-color: var(--interactive-ux-svg-color);\n}\n\n.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon:hover svg path,.interactive-ux-container-mobile .callout .mobile-swiper .mobile-swiper-item .interactive-ux-item-card-icon:hover svg rect {\n    stroke: unset;\n    fill: var(--interactive-ux-svg-hover-color);\n}\n\n.interactive-ux h1.interactive-ux-title {\n    color: #003c69;\n    letter-spacing: 0;\n    text-align: center;\n}\n\n.interactive-ux p.interactive-ux-subtitle {\n    color: #333;\n    letter-spacing: 0;\n    text-align: center;\n}\n\n.intercept-survey-banner {\n    --bg-opacity: 1;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    background-image: url(\"\");\n    background-repeat: no-repeat;\n    border-radius: 25px 25px 0 0;\n    bottom: 0;\n    display: none;\n    height: 150px;\n    justify-content: center;\n    position: fixed;\n    width: 100%;\n    z-index: 9999;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-banner {\n        background-image:url(\"\");\n        height: 162px;\n    }\n}\n\n.intercept-survey-banner-content-text {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n    font-size: 24px;\n    line-height: 42px;\n    margin: 10px 0 0 -10px;\n    padding: 0 16px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-banner-content-text {\n        font-size:38px;\n        line-height: 42px;\n        margin: 40px 0 0 120px;\n        padding: 0 16px;\n        text-align: left;\n    }\n}\n\n.intercept-survey-banner-content-subHeader {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 14px;\n    line-height: 21px;\n    margin: 0 0 0 10px;\n    padding: 0 16px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-banner-content-subHeader {\n        font-size:20px;\n        line-height: 29px;\n        margin: 10px 0 0 120px;\n        padding: 0 16px;\n        text-align: left;\n    }\n}\n\n.intercept-survey-banner-content-actions {\n    -ms-flex-line-pack: center;\n    align-content: center;\n    font-size: 18px;\n    padding: 20px 0 0 30px;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-banner-content-actions {\n        margin-right:80px;\n        padding: 48px 0 48px 20px;\n    }\n}\n\n.intercept-survey-banner-content-actions-buttontext {\n    display: block;\n    margin-left: 5px;\n    margin-top: 5px;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-banner-content-actions-buttontext {\n        margin-left:15px;\n        margin-top: 0;\n    }\n}\n\n.intercept-survey-banner-content-actions .cta-primary-small {\n    background-color: #fff;\n    height: 48px;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-banner-content-actions .cta-primary-small {\n        height:56px;\n        line-height: 56px;\n        min-width: 196px;\n    }\n}\n\n.intercept-survey-banner-content-actions-image {\n    margin-top: 10px;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-banner-content-actions-image {\n        margin-left:15px;\n        margin-top: 15px;\n    }\n}\n\n.intercept-survey-banner-content-actions-yes.cta-primary-small {\n    color: #005d70;\n}\n\n.intercept-survey-banner-content-actions-no.cta-primary-small {\n    color: #75787b;\n}\n\n@media (min-width: 960px) {\n    .intercept-survey-banner-content {\n        padding:0;\n    }\n}\n\n.intercept-survey-confirm {\n    background-color: #005d70;\n    border-radius: 15px 15px 15px 15px;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    height: 194px;\n    left: 50%;\n    overflow: auto;\n    position: fixed;\n    top: 50%;\n    -webkit-transform: translate(-50%,-50%);\n    -ms-transform: translate(-50%,-50%);\n    transform: translate(-50%,-50%);\n    width: 345px;\n    z-index: 5;\n}\n\n@media (min-width: 960px) {\n    .intercept-survey-confirm {\n        height:249px;\n        width: 530px;\n    }\n}\n\n.intercept-survey-confirm .cta-primary-small {\n    --text-opacity: 1;\n    background-color: #005d70;\n    border: #fff;\n    border-style: solid;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    cursor: pointer;\n    font-size: 18px;\n    height: 48px;\n    padding-top: 3px;\n}\n\n@media (min-width: 1366px) {\n    .intercept-survey-confirm .cta-primary-small {\n        height:60px;\n        line-height: 56px;\n        min-width: 196px;\n        padding-top: 0;\n    }\n}\n\n.intercept-survey-confirm-wrapper {\n    display: none;\n}\n\n.intercept-survey-confirm-text {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n    font-size: 26px;\n    line-height: 30px;\n    padding: 30px 25px;\n    text-align: center;\n}\n\n@media (min-width: 960px) {\n    .intercept-survey-confirm-text {\n        font-size:38px;\n        line-height: 42px;\n        padding: 40px 50px 30px;\n    }\n}\n\n.intercept-survey-confirm-overlay {\n    background: rgba(0,0,0,0.26667);\n    bottom: 0;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 4;\n}\n\n.internal-widget-wrapper {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    background-color: #f9f9f9;\n    background-color: rgba(249,249,249,var(--bg-opacity));\n    justify-content: center;\n}\n\n.internal-widget-card,.internal-widget-wrapper {\n    --bg-opacity: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.internal-widget-card {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,0.05098);\n    box-shadow: 0 5px 10px rgba(0,0,0,0.05098);\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 16px;\n    padding: 24px 16px 16px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .internal-widget-card {\n        margin-bottom:48px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .internal-widget-card {\n        margin-bottom:40px;\n        margin-left: 0;\n        margin-right: 0;\n        padding: 32px 16px;\n        width: 435px;\n    }\n}\n\n.internal-widget-card-title {\n    margin-bottom: 16px;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .internal-widget-card-title {\n        margin-bottom:24px;\n    }\n}\n\n.internal-widget-card-profile {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-top: 16px;\n}\n\n.internal-widget-card-profile-image {\n    height: 40px;\n    margin-right: 12px;\n    width: 40px;\n}\n\n.internal-widget-card-profile-image img {\n    border-radius: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.internal-widget-card-profile-title {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n\n\n.internal-widget-card-image {\n    margin-bottom: 16px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .internal-widget-card-image {\n        margin-bottom:24px;\n    }\n}\n\n.internal-widget-card-image img {\n    border-radius: 6px;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.internal-widget-card-content {\n    font-size: 14px;\n    line-height: 21px;\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .internal-widget-card-content {\n        font-size:16px;\n        line-height: 24px;\n    }\n}\n\n.internal-widget-card.hidden {\n    display: none;\n}\n\n@media (min-width: 768px) {\n    .internal-widget-card.hidden {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n}\n\n.internal-widget-load-more {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.internal-widget-load-more p {\n    color: #fff;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .internal-widget-load-more {\n        display:none;\n    }\n}\n\n.license-map {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 1365px;\n}\n\n.license-map-wrapper {\n    background-color: #fff;\n}\n\n.license-map-image {\n    height: 210px;\n    margin: 32px auto;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .license-map-image {\n        height:367px;\n        margin-bottom: 40px;\n        margin-top: 40px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .license-map-image {\n        height:492px;\n    }\n}\n\n.license-map-image img {\n    height: 100%;\n    -o-object-fit: contain;\n    object-fit: contain;\n    width: 100%;\n}\n\n.license-map-legend {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    margin-bottom: 32px;\n    margin-left: 24px;\n    margin-right: 24px;\n}\n\n@media (min-width: 768px) {\n    .license-map-legend {\n        margin-bottom:8px;\n        margin-left: 0;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .license-map-legend {\n        margin-bottom:16px;\n    }\n}\n\n.license-map-legend-entry {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: flex-start;\n}\n\n@media (min-width: 1366px) {\n    .license-map-legend-entry {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n}\n\n.license-map-legend-entry-icon {\n    background-color: gray;\n    height: 40px;\n    margin-right: 20px;\n    min-width: 40px;\n}\n\n@media (min-width: 768px) {\n    .license-map-legend-entry-icon {\n        height:48px;\n        min-width: 48px;\n    }\n}\n\n.license-map-legend-entry-label {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 24px;\n    letter-spacing: -0.28px;\n    line-height: 30px;\n    max-width: 300px;\n}\n\n.hot-locations {\n    height: 100%;\n    overflow-x: hidden;\n}\n\n.hot-locations-heading {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 32px;\n    line-height: 40px;\n}\n\n@media (min-width: 768px) {\n    .hot-locations-heading {\n        font-size:34px;\n        line-height: 40px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hot-locations-heading {\n        font-size:42px;\n        line-height: 56px;\n    }\n}\n\n.hot-locations-hero {\n    left: 0;\n    overflow: hidden;\n    top: 0;\n    width: 100%;\n}\n\n.hot-locations-hero img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: auto;\n}\n\n@media (min-width: 1366px) {\n    .hot-locations-hero img {\n        height:200px;\n    }\n}\n\n.hot-locations .section-container {\n    padding-bottom: 24px;\n    padding-top: 24px;\n}\n\n@media (min-width: 1366px) {\n    .hot-locations .section-container {\n        padding-bottom:32px;\n        padding-top: 230px;\n    }\n}\n\n.hot-locations .large-grid {\n    margin-bottom: 0;\n    margin-top: 0;\n}\n\n@media (min-width: 768px) {\n    .hot-locations .large-grid {\n        margin-bottom:24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hot-locations .large-grid {\n        margin-bottom:32px;\n    }\n}\n\n.hot-locations .large-grid .hot-locations-card:nth-child(odd) {\n    margin: 0 0 0 auto;\n}\n\n@media (min-width: 1366px) {\n    .hot-locations .large-grid .hot-locations-card:nth-child(odd) {\n        margin:0 auto;\n    }\n}\n\n.hot-locations .large-grid .hot-locations-card:nth-child(2n) {\n    margin: 0 auto 0 0;\n}\n\n@media (min-width: 1366px) {\n    .hot-locations .large-grid .hot-locations-card:nth-child(2n) {\n        margin:0 auto;\n    }\n}\n\n.detail-grid-content .title {\n    padding-bottom: 25px;\n    text-align: center;\n}\n\n.hot-locations-card {\n    --bg-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.10196);\n    display: block;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n    margin-left: 24px;\n    margin-right: 24px;\n    overflow: hidden;\n}\n\n@media (min-width: 1366px) {\n    .hot-locations-card-container {\n        height:628px;\n    }\n}\n\n.hot-locations-card .teaser-title {\n   \n    font-size: 38px;\n    line-height: 40px;\n    padding-bottom: 12px;\n    padding-top: 12px;\n}\n\n@media (max-width: 767px) {\n    .hot-locations-card .teaser-title {\n        font-size:24px;\n        line-height: 30px;\n    }\n}\n\n.hot-locations-card .teaser-text {\n    font-size: 16px;\n    padding: 16px 0 25px;\n}\n\n@media (max-width: 1365px) {\n    .hot-locations-card .teaser-text {\n        font-size:16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hot-locations-card .teaser-text {\n        min-height:110px;\n    }\n}\n\n.hot-locations-card-image {\n    height: 230px;\n}\n\n@media (min-width: 1366px) {\n    .hot-locations-card-image {\n        height:316px;\n    }\n}\n\n.hot-locations-card-image img {\n    height: inherit;\n}\n\n.hot-locations-card-content {\n    --bg-opacity: 1;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    flex-grow: 1;\n    padding: 16px 50px;\n    position: relative;\n}\n\n@media (max-width: 767px) {\n    .hot-locations-card-content {\n        padding-left:30px;\n        padding-right: 30px;\n    }\n}\n\n.hot-locations-card-content-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 24px;\n}\n\n.hot-locations-card-content-title:after {\n    bottom: 0;\n    content: \"\";\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: -140px;\n}\n\n.hot-locations-card-content-location {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 14px;\n}\n\n.hot-locations-card-links {\n    padding-bottom: 20px;\n    padding-left: 50px;\n    padding-right: 50px;\n}\n\n@media (max-width: 767px) {\n    .hot-locations-card-links {\n        padding-bottom:25px;\n        padding-left: 30px;\n        padding-right: 30px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .hot-locations-card {\n        margin:0;\n    }\n}\n\n@media (max-width: 767px) {\n    .hot-locations-card .link-large > a {\n        font-size:16px;\n    }\n}\n\n.small-card .link-large > a {\n    font-size: 16px;\n}\n\n.small-card .teaser-title {\n    font-size: 28px;\n    line-height: 30px;\n    padding-bottom: 12px;\n    padding-top: 10px;\n}\n\n.small-card .teaser-text {\n    display: none;\n}\n\n.small-card .teaser-text .rich-text {\n    padding: 0;\n}\n\n@media (min-width: 1366px) {\n    .small-card .hot-locations-card-container {\n        height:306px;\n        padding-left: 16px;\n    }\n}\n\n.small-card .hot-locations-card-image {\n    height: 179px;\n}\n\n.small-card .hot-locations-card-content {\n    padding-left: 30px;\n    padding-right: 30px;\n}\n\n@media (min-width: 768px) {\n    .small-card .third-card-mobile {\n        display:none;\n    }\n}\n\n.small-card .third-card-mobile .teaser-text {\n    display: block;\n}\n\n@media (max-width: 767px) {\n    .small-card .third-card-desktop {\n        display:none;\n    }\n}\n\n.small-card .third-card-desktop .hot-locations-card-content {\n    height: 250px;\n    padding-left: 30px;\n    padding-right: 30px;\n}\n\n.small-card .third-card-desktop .hot-locations-card-content .teaser-title {\n    padding-top: 25px;\n}\n\n.small-card .third-card-desktop .hot-locations-card-content .teaser-text {\n    display: block;\n}\n\n.small-card .third-card-desktop .hot-locations-card-content .hot-locations-card-links {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.small-card .third-card-desktop .hot-locations-card-image {\n    float: left;\n    height: 306px;\n    width: 293px;\n}\n\n.small-card .hot-locations-card-links {\n    padding-left: 30px;\n    padding-right: 30px;\n}\n\n.location-categories {\n    margin-bottom: 16px;\n}\n\n.location-categories-title {\n    --text-opacity: 1;\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n   \n    font-size: 20px;\n}\n\n@media (min-width: 1200px) {\n    .location-categories-title {\n        font-size:24px;\n    }\n}\n\n.location-categories-item {\n    width: 100%;\n}\n\n.location-categories-item-link {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: block;\n   \n    font-size: 22px;\n    margin-bottom: 12px;\n    padding: 12px 24px;\n    text-transform: uppercase;\n    width: 100%;\n}\n\n.location-categories-item-selected {\n   \n    font-size: 24px;\n}\n\n.location-categories-mobile-header {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 6px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 6px 10px rgba(0,0,0,0.10196);\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    height: 50px;\n    padding: 8px 24px 12px;\n    width: 100%;\n}\n\n.location-categories-mobile-header-selected {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.location-categories-mobile-header-selected i .stroke {\n    fill: #fff;\n}\n\n.location-categories-mobile-header-title {\n    float: left;\n}\n\n.location-categories-mobile-header i {\n    float: right;\n}\n\n.location-categories-mobile .location-categories-item-link {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 0;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    margin-bottom: 0;\n    padding: 8px 24px;\n    text-transform: uppercase;\n    width: 100%;\n}\n\n.location-category-chips {\n    margin-bottom: -100px;\n}\n\n.location-category-chips-wrapper {\n    --bg-opacity: 1;\n    background-color: #f9f9f9;\n    background-color: rgba(249,249,249,var(--bg-opacity));\n    padding-top: 40px;\n}\n\n.location-category-chips-item,.location-category-chips-wrapper {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n.location-category-chips-item {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin: 4px;\n    padding: 4px 16px;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.location-category-chips-item-wrapper {\n    border-width: 2px;\n}\n\n.location-category-chips-item a {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n    opacity: 1;\n}\n\n.media-callout-wrapper-top-content {\n    height: auto;\n    max-width: 1550px;\n    padding-bottom: 200px;\n}\n\n@media (min-width: 1200px) {\n    .media-callout-wrapper-top-content {\n        padding-bottom:300px;\n    }\n}\n\n.media-callout-wrapper-top-content .text-wrapper label {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    margin-left: 20px;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.media-callout-wrapper-top-content .text-wrapper .right-column {\n    height: auto;\n    overflow: hidden;\n}\n\n.media-callout-wrapper-top-content .text-wrapper .right-column-content {\n    margin-top: -100%;\n    -webkit-transition: all 0.5s ease-in;\n    -o-transition: all 0.5s ease-in;\n    transition: all 0.5s ease-in;\n}\n\n.media-callout-wrapper-top-content .text-wrapper #readmore:checked + .right-column .right-column-content {\n    margin-top: 0;\n}\n\n@media (min-width: 1200px) {\n    .media-callout-wrapper-top-content .text-wrapper {\n        width:1130px;\n    }\n\n    .media-callout-wrapper-top-content .text-wrapper .right-column-content {\n        margin-top: 0;\n    }\n}\n\n.media-callout-wrapper-top-content .text-wrapper p {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    line-height: 30px;\n}\n\n.media-callout-wrapper-top-content .text-wrapper .read-more p:after {\n    display: none;\n}\n\n.media-callout-wrapper-top-content h1:first-of-type {\n    color: #fff;\n}\n\n.media-callout-wrapper-top-content-media {\n    bottom: -100px;\n}\n\n.media-callout-wrapper-top-content-media section {\n    display: contents;\n}\n\n.media-callout-wrapper-top-content-media section:last-of-type {\n    display: none;\n}\n\n@media (min-width: 1200px) {\n    .media-callout-wrapper-top-content-media section:last-of-type {\n        display:contents;\n    }\n}\n\n.media-callout-wrapper-top-content-media-container {\n    height: 250px;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .media-callout-wrapper-top-content-media-container {\n        height:450px;\n        width: 50%;\n    }\n}\n\n.media-callout-wrapper-top-content-media-image {\n    height: 250px;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .media-callout-wrapper-top-content-media-image {\n        height:auto;\n        width: 50%;\n    }\n}\n\n.media-callout-wrapper-top-content-media img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.media-callout-wrapper-top-content-media iframe {\n    height: 100%;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .media-callout-wrapper-top-content-media {\n        bottom:-225px;\n        max-width: 1454px;\n    }\n}\n\n.media-callout-wrapper-bottom {\n    background: transparent -o-linear-gradient(top,#f2f2f0 0,#f8f5ed 100%) 0 0 no-repeat padding-box;\n    background: transparent -webkit-gradient(linear,left top,left bottom,from(#f2f2f0),to(#f8f5ed)) 0 0 no-repeat padding-box;\n    background: transparent linear-gradient(180deg,#f2f2f0,#f8f5ed) 0 0 no-repeat padding-box;\n}\n\n.media-callout-wrapper-bottom-content {\n    max-width: 1550px;\n}\n\n.media-callout-wrapper-bottom-content .media-callout-card {\n    max-width: 475px;\n}\n\n.media-callout-wrapper-bottom-content .media-callout-card h1 {\n    font-size: 32px;\n}\n\n@media (min-width: 1200px) {\n    .media-callout-wrapper-bottom-content .media-callout-card h1 {\n        font-size:42px;\n    }\n}\n\n@media (min-width: 768px) {\n    .media-combo.section-container {\n        padding-bottom:24px;\n        padding-top: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .media-combo.section-container {\n        padding-bottom:32px;\n        padding-top: 32px;\n    }\n}\n\n.media-combo .promo-callout {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    padding-bottom: 24px;\n}\n\n@media (min-width: 768px) {\n    .media-combo .promo-callout {\n        padding-bottom:0;\n    }\n}\n\n.media-combo .promo-callout .section-container {\n    padding-bottom: 0;\n    padding-top: 0;\n}\n\n@media (min-width: 768px) {\n    .media-combo .promo-callout .section-container {\n        padding-bottom:24px;\n        padding-top: 0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .media-combo .promo-callout .section-container {\n        padding-bottom:64px;\n    }\n}\n\n.media-combo .mobile-swiper-item {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n@media (min-width: 1366px) {\n    .media-combo .mobile-swiper-item {\n        padding-bottom:32px;\n    }\n}\n\n.media-combo .mobile-swiper-item .callout {\n    padding-bottom: 32px;\n    padding-top: 16px;\n}\n\n@media (min-width: 1366px) {\n    .media-combo .mobile-swiper-item .callout {\n        padding-top:24px;\n    }\n}\n\n.media-combo .dot-navigation {\n    margin-bottom: 24px;\n    margin-top: 24px;\n}\n\n.news-categories {\n    margin-bottom: 16px;\n}\n\n.news-categories-title {\n    --text-opacity: 1;\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n   \n    font-size: 20px;\n}\n\n@media (min-width: 1200px) {\n    .news-categories-title {\n        font-size:24px;\n    }\n}\n\n.news-categories-item {\n    width: 100%;\n}\n\n.news-categories-item-link {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: block;\n   \n    font-size: 22px;\n    margin-bottom: 12px;\n    padding: 12px 24px;\n    text-transform: uppercase;\n    width: 100%;\n}\n\n.news-categories-item-selected {\n   \n    font-size: 24px;\n}\n\n.news-categories-mobile-header {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 6px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 6px 10px rgba(0,0,0,0.10196);\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    height: 50px;\n    padding: 8px 24px 12px;\n    width: 100%;\n}\n\n.news-categories-mobile-header-selected {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.news-categories-mobile-header-selected i .stroke {\n    fill: #fff;\n}\n\n.news-categories-mobile-header-title {\n    float: left;\n}\n\n.news-categories-mobile-header i {\n    float: right;\n}\n\n.news-categories-mobile .news-categories-item-link {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    border-radius: 0;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    margin-bottom: 0;\n    padding: 8px 24px;\n    text-transform: uppercase;\n    width: 100%;\n}\n\n.news-category-chips-wrapper {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@media (min-width: 960px) {\n    .news-category-chips-wrapper {\n        -webkit-box-pack:start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n    }\n}\n\n.news-category-chips-item {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    justify-content: center;\n    margin: 4px;\n    padding: 4px 16px;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.news-category-chips-item-wrapper {\n    border-width: 2px;\n}\n\n.news-category-chips-item a {\n    opacity: 1;\n}\n\n@media (min-width: 1200px) {\n    .news-results {\n        margin-left:auto;\n        margin-right: auto;\n        max-width: 1366px;\n    }\n}\n\n.news-results-heading {\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n   \n    font-size: 22px;\n    margin-bottom: 16px;\n}\n\n@media (min-width: 1200px) {\n    .news-results-heading {\n        font-size:48px;\n        margin-bottom: 20px;\n    }\n}\n\n.news-results-item {\n    margin-bottom: 40px;\n}\n\n.news-results-item-image img {\n    border-radius: 8px;\n    height: 220px;\n    max-height: 220px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .news-results-item-image img {\n        height:265px;\n        max-height: 265px;\n    }\n}\n\n.news-results-item-meta {\n    margin-bottom: 8px;\n}\n\n.news-results-item-meta-category {\n   \n    font-size: 13px;\n    text-transform: uppercase;\n}\n\n@media (min-width: 1200px) {\n    .news-results-item-meta-category {\n        font-size:16px;\n    }\n}\n\n.news-results-item-meta-seperator {\n    --text-opacity: 1;\n    border-right: 1px solid #979797;\n    display: inline;\n   \n}\n\n.news-results-item-meta-date,.news-results-item-meta-seperator {\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    margin-left: 8px;\n}\n\n.news-results-item-meta-date {\n   \n    font-size: 13px;\n    text-transform: uppercase;\n}\n\n@media (min-width: 1200px) {\n    .news-results-item-meta-date {\n        font-size:16px;\n    }\n}\n\n.news-results-item-title {\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 24px;\n    margin-bottom: 8px;\n}\n\n@media (min-width: 1200px) {\n    .news-results-item-title {\n        \n        font-size: 24px;\n        font-size: 32px;\n        line-height: 34px;\n    }\n}\n\n.news-results-item-summary,.news-results-item-summary p {\n    --text-opacity: 1;\n    color: #4a4a4a;\n    color: rgba(74,74,74,var(--text-opacity));\n   \n    font-size: 16px;\n    text-align: left;\n}\n\n.news-results-pager {\n    margin: auto;\n}\n\n.news-results-pager .pagination-btn.active {\n    background: #0977a9;\n    border: 1px solid #0098db;\n}\n\n.news-results-content {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    width: 100%;\n}\n\n.news-results-content p {\n    text-align: center;\n}\n\n.news-results-loading {\n    display: block;\n    margin-top: 100px;\n    text-align: center;\n    width: 100%;\n}\n\n.news-results-loading .lds-ring {\n    position: inherit;\n}\n\n.news-search {\n    padding-top: 0;\n}\n\n@media (min-width: 1366px) {\n    .news-search {\n        grid-column:span 12 / span 12;\n        margin-left: auto;\n        margin-right: auto;\n        max-width: 1366px;\n    }\n}\n\n.news-search-count {\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n   \n    font-size: 20px;\n}\n\n.news-search-count .bold {\n    font-size: 30px;\n}\n\n@media (min-width: 1366px) {\n    .news-search-count .bold {\n        font-size:32px;\n    }\n}\n\n.news-search-results-title {\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n   \n    font-size: 30px;\n}\n\n@media (min-width: 1366px) {\n    .news-search-results-title {\n        font-size:48px;\n    }\n}\n\n.news-search-results .body-standard-18,.news-search-results .body-standard-18 p {\n    --text-opacity: 1;\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n}\n\n.news-search-box {\n    margin-left: 16px;\n    margin-right: 16px;\n    padding-bottom: 12px;\n}\n\n@media (min-width: 1200px) {\n    .news-search-box {\n        margin-left:auto;\n        margin-right: auto;\n        max-width: 1366px;\n    }\n}\n\n.news-search-box-container {\n    --text-opacity: 1;\n    color: #718096;\n    color: rgba(113,128,150,var(--text-opacity));\n    margin-bottom: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n}\n\n.news-search-box-container-left {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.news-search-box-container input {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 1px solid #dbdbdb;\n    border-radius: 8px;\n    -webkit-box-shadow: 0 6px 10px rgba(0,0,0,0.05098);\n    box-shadow: 0 6px 10px rgba(0,0,0,0.05098);\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n    font-size: 15px;\n    height: 40px;\n    height: 50px;\n    padding-left: 52px;\n    padding-right: 16px;\n    width: 100%;\n}\n\n@media (min-width: 1200px) {\n    .news-search-box-container input {\n        font-size:18px;\n        height: 70px;\n    }\n}\n\n.news-search-box-container button {\n    margin-top: 15px;\n}\n\n@media (min-width: 1200px) {\n    .news-search-box-container button {\n        margin-top:25px;\n    }\n}\n\n.news-search-box-container svg {\n    fill: #002146;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone {\n        padding-bottom:24px;\n        padding-top: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone {\n        padding-bottom:32px;\n        padding-top: 32px;\n    }\n}\n\n@media (min-width: 768px) {\n    .nurse-zone .title {\n        line-height:46px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone .title {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n    \n        font-size: 32px;\n        line-height: 36px;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:1366px) {\n    .nurse-zone .title {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n.nurse-zone-top-content a {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    padding-left: 2px;\n}\n\n.nurse-zone-bottom {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    width: 100%;\n}\n\n.nurse-zone-card:first-child {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-card:first-child {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-card:first-child {\n        grid-column:span 4 / span 4;\n    }\n}\n\n.nurse-zone-card:first-child .card-image img {\n    height: 160px;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-card:first-child .card-image img {\n        height:248px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-card:first-child .card-image img {\n        height:248px;\n    }\n}\n\n.nurse-zone-card:first-child .card-subtitle {\n    font-size: 22px;\n    line-height: 28px;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-card:first-child .card-subtitle {\n        --text-opacity:1;\n        color: #002146;\n        color: rgba(0,33,70,var(--text-opacity));\n    \n        font-size: 22px;\n        font-size: 24px;\n        line-height: 28px;\n        line-height: 30px;\n    }\n}\n\n@media (min-width: 768px) and (min-width:768px) {\n    .nurse-zone-card:first-child .card-subtitle {\n        font-size:26px;\n        font-size: 30px;\n        line-height: 32px;\n        line-height: 38px;\n    }\n}\n\n.nurse-zone-card:not(:first-child) {\n    grid-column: span 3 / span 3;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-card:not(:first-child) {\n        grid-column:span 6 / span 6;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-card:not(:first-child) {\n        grid-column:span 4 / span 4;\n    }\n}\n\n.nurse-zone-card:not(:first-child) .card-overline {\n    font-size: 12px;\n    line-height: 16px;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-card:not(:first-child) .card-overline {\n        font-size:14px;\n        line-height: 14px;\n    }\n}\n\n.nurse-zone-card:not(:first-child) .card-image img {\n    height: 120px;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-card:not(:first-child) .card-image img {\n        height:160px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-card:not(:first-child) .card-image img {\n        height:248px;\n    }\n}\n\n.nurse-zone-card:not(:first-child) .card-subtitle {\n    font-size: 22px;\n    line-height: 28px;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-card:not(:first-child) .card-subtitle {\n        --text-opacity:1;\n        color: #002146;\n        color: rgba(0,33,70,var(--text-opacity));\n    \n        font-size: 22px;\n        font-size: 24px;\n        line-height: 28px;\n        line-height: 30px;\n    }\n}\n\n@media (min-width: 768px) and (min-width:768px) {\n    .nurse-zone-card:not(:first-child) .card-subtitle {\n        font-size:26px;\n        line-height: 32px;\n    }\n}\n\n@media (min-width: 768px) and (min-width:768px) {\n    .nurse-zone-card:not(:first-child) .card-subtitle {\n        font-size:30px;\n        line-height: 38px;\n    }\n}\n\n.nurse-zone-card {\n    margin-bottom: 24px;\n}\n\n.nurse-zone-card-image {\n    border-radius: 27px;\n    margin-bottom: 16px;\n    width: 100%;\n}\n\n.nurse-zone-card-image img {\n    border-radius: 8px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.nurse-zone-card-body {\n    text-align: left;\n}\n\n.nurse-zone-card-body > .rich-text,.nurse-zone-card-body > .rich-text > p {\n    line-height: 24px;\n}\n\n.nurse-zone-card-cta {\n    display: none;\n}\n\n.nurse-zone-card-eyebrow {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.physician-cost-calculator {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin: 28px 0 24px;\n}\n\n@media (min-width: 1366px) {\n    .physician-cost-calculator {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n}\n\n.physician-cost-calculator-wrapper {\n    margin: 0 auto;\n    max-width: 1064px;\n    padding: 72px 24px 60px;\n    text-align: center;\n}\n\n.physician-cost-calculator-wrapper p {\n    text-align: center;\n}\n\n.physician-cost-calculator-header {\n    color: #003c69;\n    font-size: 22px;\n    line-height: 32px;\n    padding-bottom: 12px;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .physician-cost-calculator-header {\n        font-size:40px;\n        line-height: 64px;\n        padding-bottom: 32px;\n        text-align: center;\n    }\n}\n\n.physician-cost-calculator-description {\n    padding-bottom: 40px;\n}\n\n.physician-cost-calculator-description p {\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .physician-cost-calculator-description p {\n        text-align:center;\n    }\n}\n\n.physician-cost-calculator-select {\n    position: relative;\n}\n\n@media (min-width: 1366px) {\n    .physician-cost-calculator-select {\n        display:inline-block;\n    }\n}\n\n.physician-cost-calculator-select-label {\n    color: #003976;\n    display: block;\n\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 22px;\n    padding-bottom: 12px;\n}\n\n.physician-cost-calculator-select select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border: 1px solid #9a9a9a;\n    border-radius: 8px;\n    padding: 16px 52px 16px 24px;\n    width: 100%;\n}\n\n.physician-cost-calculator-select:after {\n    --text-opacity: 1;\n    color: #444;\n    content: \"â€º\";\n    font-size: 35px;\n    height: 34px;\n    pointer-events: none;\n    position: absolute;\n    right: 5px;\n    top: 20%;\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n.physician-cost-calculator-tile {\n    border-radius: 8px;\n    font-size: 28px;\n    margin: 5px 0;\n    padding: 20px 28px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .physician-cost-calculator-tile {\n        font-size:22px;\n        height: 180px;\n        margin: 0 10px;\n        padding: 24px 16px;\n        width: 200px;\n    }\n}\n\n.physician-cost-calculator-tile-header {\n    color: #003c69;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    padding-bottom: 10px;\n    text-transform: uppercase;\n}\n\n@media (min-width: 1366px) {\n    .physician-cost-calculator-tile-header {\n        min-height:64px;\n        padding-bottom: 24px;\n    }\n}\n\n.physician-cost-calculator-tile:first-child {\n    background-color: rgba(132,195,70,0.10196);\n    color: #84c346;\n}\n\n.physician-cost-calculator-tile:nth-child(2) {\n    background-color: rgba(74,186,235,0.10196);\n    color: #4abaeb;\n}\n\n.physician-cost-calculator-tile:nth-child(3) {\n    background-color: rgba(83,66,153,0.10196);\n    color: #534299;\n}\n\n.physician-cost-calculator-tile:nth-child(4) {\n    background-color: rgba(55,179,74,0.10196);\n    color: #37b34a;\n}\n\n.physician-cost-calculator-tile:nth-child(5) {\n    background-color: rgba(0,150,165,0.10196);\n    color: #0096a5;\n}\n\n.physician-cost-calculator-more-information {\n    margin: auto;\n    max-width: 700px;\n}\n\n.physician-cost-calculator-more-information p {\n    color: #75787b;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.physician-cost-calculator-more-information .rich-text a {\n    color: #003c69;\n    font-weight: 700;\n}\n\n.physician-cost-calculator-sources-title {\n    color: #003976;\n    font-size: 20px;\n    line-height: 32px;\n    padding: 20px 0 12px;\n}\n\n.physician-cost-calculator-sources-description p {\n    color: #444;\n    font-size: 14px;\n    line-height: 21px;\n}\n\n.cookie-banner {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    background-color: #dde6ed;\n    background-color: rgba(221,230,237,var(--bg-opacity));\n    bottom: 0;\n    -webkit-box-shadow: 0 0 2px 1px rgba(0,0,0,0.2);\n    box-shadow: 0 0 2px 1px rgba(0,0,0,0.2);\n    font-size: 13px;\n    height: auto;\n    justify-content: center;\n    line-height: 1.5;\n    position: fixed;\n    text-align: center;\n    width: 100%;\n    z-index: 9999;\n}\n\n@media (min-width: 768px) {\n    .cookie-banner .mobile {\n        display:none;\n    }\n}\n\n@media (max-width: 767px) {\n    .cookie-banner .desktop {\n        display:none;\n    }\n}\n\n.cookie-banner .privacy-read-more {\n    display: none;\n}\n\n@media (max-width: 767px) {\n    .cookie-banner .privacy-read-more {\n        display:inline;\n    }\n\n    .cookie-banner .privacy-read-more-text {\n        display: none;\n    }\n}\n\n.cookie-banner .hide {\n    display: none;\n}\n\n.cookie-banner .expand {\n    display: inline;\n}\n\n.cookie-banner-content-text {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    font-size: 14px;\n    justify-content: center;\n    line-height: 19px;\n    margin: 0 0 10px;\n    padding: 0 16px;\n    text-align: center;\n}\n\n.cookie-banner-content-close {\n    padding: 0 0 10px;\n}\n\n@media (min-width: 960px) {\n    .cookie-banner {\n        padding:12px 24px;\n    }\n}\n\n.promo-callout .reverse-promo {\n    grid-auto-flow: column;\n}\n\n@media (min-width: 768px) {\n    .promo-callout .reverse-promo .promo-callout-media {\n        grid-column:7/13;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout .reverse-promo .promo-callout-media {\n        grid-column:7/13;\n        padding-left: 24px;\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .reverse-promo .promo-callout-content {\n        grid-column:1/7;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout .reverse-promo .promo-callout-content {\n        grid-column:1/7;\n        padding-right: 24px;\n    }\n}\n\n.promo-callout-media {\n    padding-bottom: 24px;\n}\n\n@media (min-width: 768px) {\n    .promo-callout-media {\n        grid-column:1/7;\n        padding: 24px 20px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout-media {\n        grid-column:1/7;\n        height: auto;\n        padding-bottom: 28px;\n        padding-right: 24px;\n        padding-top: 24px;\n    }\n}\n\n.promo-callout-media-wrapper img {\n    border-radius: 8px;\n    height: auto;\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n.promo-callout-media-wrapper .video-wrapper .video-youtube {\n    border-radius: 10px;\n}\n\n.promo-callout-media-wrapper .video-wrapper .video-youtube img {\n    top: -16.65%;\n}\n\n@media (min-width: 768px) {\n    .promo-callout-media-wrapper .video-wrapper .video-youtube img {\n        height:240px;\n        top: -18.82%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout-media-wrapper .video-wrapper .video-youtube img {\n        height:342px;\n        top: 0;\n    }\n}\n\n.promo-callout-content {\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .promo-callout-content {\n        grid-column:7/13;\n        padding-top: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout-content {\n        align-self:flex-start;\n        grid-column: 7/13;\n        padding-left: 24px;\n    }\n}\n\n.promo-callout-content div.rich-text {\n    padding-left: 0;\n}\n\n.promo-callout-content-cta .wrapper {\n    min-width: 192px;\n    width: auto;\n}\n\n.promo-callout-content-cta .wrapper a {\n    width: 100%;\n}\n\n.promo-callout-content-cta .cta-primary-wrapper {\n    margin-bottom: 32px;\n}\n\n.promo-callout-content-cta .cta-primary-medium > a {\n    background-color: #2257b8;\n}\n\n.promo-callout-content .promo-eyebrow {\n    color: #0098db;\n    font-size: 24px;\n    line-height: 32px;\n}\n\n.promo-callout li {\n    line-height: 26px;\n    margin-left: 15px;\n}\n\n.promo-callout-tile {\n    display: none;\n}\n\n.promo-callout-tile .callout-container-icon {\n    height: 56px;\n}\n\n.promo-callout-tile .tile-text {\n    min-width: 70px;\n}\n\n@media (max-width: 1365px) {\n    .promo-callout-tile {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .promo-callout-tile .promo-callout-content {\n        margin: auto;\n        width: 720px;\n    }\n}\n\n@media (max-width: 767px) {\n    .promo-callout-tile .promo-callout-content {\n        margin:auto;\n        width: 362px;\n    }\n}\n\n@media (max-width: 374px) {\n    .promo-callout-tile .promo-callout-content {\n        margin:auto;\n        width: 244px;\n    }\n}\n\n.rich-text {\n    word-wrap: break-word;\n    line-height: 18px;\n    word-break: break-word;\n}\n\n.rich-text .cta-primary-large,.rich-text .cta-primary-medium,.rich-text .cta-primary-small {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.rich-text .cta-primary-large:visited,.rich-text .cta-primary-medium:visited,.rich-text .cta-primary-small:visited {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    text-decoration: none;\n}\n\n@media (hover: hover) {\n    .rich-text .cta-primary-large:hover,.rich-text .cta-primary-medium:hover,.rich-text .cta-primary-small:hover,.rich-text .cta-secondary-large:hover,.rich-text .cta-secondary-medium:hover,.rich-text .cta-secondary-small:hover {\n        --text-opacity:1;\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        text-decoration: none;\n    }\n}\n\n.rich-text ol {\n    --text-opacity: 1;\n    color: #4a4a4a;\n    color: rgba(74,74,74,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 26px;\n    padding-left: 22px;\n}\n\n.rich-text ol li {\n    list-style: decimal;\n}\n\n.rich-text img {\n    display: inline;\n    display: initial;\n}\n\n.rich-text a,.rich-text a:visited {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n}\n\n.rich-text a:hover {\n    --text-opacity: 1;\n    color: #1765f4;\n    color: rgba(23,101,244,var(--text-opacity));\n    text-decoration: underline;\n}\n\n.rich-text ul {\n    --text-opacity: 1;\n    color: #4a4a4a;\n    color: rgba(74,74,74,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 26px;\n    list-style: none;\n    margin: 24px 0 0;\n    padding-left: 20px;\n}\n\n.rich-text ul li {\n    margin-bottom: 16px;\n    text-align: left;\n}\n\n.rich-text ul li:before {\n    color: #4a4a4a;\n    color: rgba(74,74,74,var(--text-opacity));\n    content: \"â‹…\";\n    font-size: 48px;\n    font-weight: 700;\n    margin-left: -20px;\n    margin-top: -4px;\n    vertical-align: top;\n    width: 20px;\n}\n\n.rich-text ul ul {\n    margin: 0;\n}\n\n.section-container .rich-text {\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.see-country-link a {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    line-height: 22px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.see-country-link a:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.see-country-link a:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .see-country-link a:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .see-country-link a:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.see-country-link a.wrapper:after {\n    width: 0;\n}\n\n@media (min-width: 1366px) {\n    .see-country-link a {\n        margin:0;\n    }\n}\n\n.city-card {\n    height: 423px;\n    min-height: 423px;\n}\n\n@media (min-width: 1366px) {\n    .city-card {\n        height:459px;\n        min-height: 459px;\n    }\n}\n\n.city-card-background {\n    width: 100%;\n    z-index: -1;\n}\n\n.city-card-background img {\n    border-radius: 27px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.city-card-content {\n    overflow: hidden;\n    padding: 0 40px;\n}\n\n.city-card-content-heading > p {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n   \n    font-size: 80px;\n    line-height: 56px;\n    text-align: center;\n    text-shadow: 0 3px 45px rgba(0,0,0,0.92157);\n}\n\n@media (min-width: 1366px) {\n    .city-card-content-heading > p {\n        font-size:80px;\n        line-height: 56px;\n    }\n}\n\n#svgStateMap,.svgStateMap {\n    margin: auto;\n    pointer-events: none;\n    -ms-touch-action: auto;\n    touch-action: auto;\n    width: 100%;\n}\n\n#svgStateMap .map-background,#svgStateMap path,.svgStateMap .map-background,.svgStateMap path {\n    pointer-events: auto;\n}\n\n#svgStateMap path.map-state,.svgStateMap path.map-state {\n    stroke: #fff;\n    fill: var(--color);\n}\n\n#svgStateMap path.map-state:hover,.svgStateMap path.map-state:hover {\n    stroke-width: 1;\n    fill: var(--hover-color);\n}\n\n.state-license-map .state-license-map-legend {\n    float: right;\n    margin-right: 40%;\n    width: 150px;\n}\n\n.state-license-map .state-license-map-legend div {\n    border-radius: 6px;\n    -webkit-box-shadow: 0 2px 6px rgba(0,0,0,0.05882);\n    box-shadow: 0 2px 6px rgba(0,0,0,0.05882);\n    color: #fff;\n    font: normal normal 700 12px/17px Helvetica Now Display;\n    padding: 7px;\n    text-align: center;\n    width: 150px;\n}\n\n.state-map-modal {\n    background-color: #fff;\n    border-radius: 5px;\n    -webkit-box-shadow: 0 5px 20px rgba(0,0,0,0.2);\n    box-shadow: 0 5px 20px rgba(0,0,0,0.2);\n    display: block;\n    max-height: 500px;\n    padding: 30px;\n    position: absolute;\n    width: 450px;\n}\n\n.state-map-modal.hidden {\n    display: none;\n}\n\n.state-map-modal h2 {\n    font: normal normal 700 18px/26px Helvetica Now Display;\n}\n\n.state-map-modal p {\n    font: normal normal normal 14px/21px Helvetica Now Text;\n}\n\n.state-map-modal a:not(.cta-primary-medium) {\n    font: normal normal normal 14px/26px Helvetica Now Text;\n    letter-spacing: 0;\n    text-decoration: underline;\n}\n\n.state-map-modal a.cta-primary-medium {\n    margin-top: 20px;\n}\n\n.state-map-modal .map-modal-dismiss {\n    height: 10px;\n    right: 10px;\n    top: 10px;\n    width: 10px;\n}\n\n@media (min-width: 768px) {\n    .state-map-modal .arrow-side {\n        border-bottom:15px solid #fff;\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        height: 0;\n        right: -15px;\n        top: 85px;\n        -webkit-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n        transform: rotate(90deg);\n        width: 0;\n        z-index: 2;\n    }\n\n    .state-map-modal .arrow-side-border {\n        border-bottom: 15px solid #c4cace;\n        right: -18px;\n        z-index: 1;\n    }\n}\n\n@media (max-width: 1199px) {\n    .state-map-modal {\n        bottom:0;\n        left: unset !important;\n        max-height: unset;\n        position: fixed;\n        right: unset !important;\n        top: unset !important;\n        width: 100%;\n    }\n\n    .state-map-modal h2 {\n        font: normal normal 700 14px/18px Helvetica Now Display;\n        letter-spacing: 0;\n        text-align: left;\n    }\n\n    .state-map-modal p {\n        font: normal normal normal 12px/17px Helvetica Now Text;\n        letter-spacing: 0;\n        text-align: left;\n    }\n\n    .state-map-modal a:not(.cta-primary-medium) {\n        font: normal normal normal 14px/26px Helvetica Now Text;\n        letter-spacing: 0;\n        text-decoration: underline;\n    }\n\n    .state-map-modal .map-modal-dismiss {\n        height: 20px;\n        right: 15px;\n        top: 15px;\n        width: 20px;\n    }\n}\n\nbody.state-map {\n    -ms-touch-action: none;\n    touch-action: none;\n}\n\nbody.state-map-page {\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n}\n\n.strike-card {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-flex: 1;\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    -webkit-box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    box-shadow: 0 3px 6px rgba(0,0,0,0.16078);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1 1 0%;\n    flex: 1 1 0%;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 465px;\n    margin-bottom: 4px;\n    padding: 36px 28px;\n    position: relative;\n}\n\n@media (min-width: 1200px) {\n    .strike-card {\n        -webkit-box-shadow:none;\n        box-shadow: none;\n        height: 440px;\n        padding: 24px 24px 36px;\n    }\n}\n\n.callout-row .strike-card {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n    flex: none;\n}\n\n.strike-card.tag2 .strike-card-tags-tag2,.strike-card.tag .strike-card-tags-tag {\n    display: block;\n}\n\n.strike-card-tags {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: space-between;\n    left: 0;\n    padding-left: 24px;\n    padding-right: 24px;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n.strike-card-tags-tag,.strike-card-tags-tag2 {\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    padding: 4px 8px;\n}\n\n.strike-card-tags-tag-color {\n    background-color: rgba(132,196,52,0.2);\n}\n\n.strike-card-tags-tag p {\n    color: #1e7721;\n}\n\n.strike-card-tags-tag2 {\n    --bg-opacity: 1;\n    background-color: #b0001f;\n    background-color: rgba(176,0,31,var(--bg-opacity));\n}\n\n.strike-card-tags-tag2 p {\n    color: #fff;\n}\n\n.strike-card-title {\n    color: #f7b22e;\n    color: rgba(247,178,46,var(--text-opacity));\n}\n\n.strike-card-location,.strike-card-title {\n    --text-opacity: 1;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 24px;\n}\n\n.strike-card-location {\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 12px;\n}\n\n.strike-card-location svg {\n    height: 20px;\n    padding-left: 4px;\n    width: 20px;\n}\n\n.strike-card-location svg .stroke {\n    fill: #062c57;\n}\n\n.strike-card-description {\n    -webkit-box-flex: 1;\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    -ms-flex: 1 1 0%;\n    flex: 1 1 0%;\n}\n\n.strike-card .rich-text ul {\n    padding-bottom: 16px;\n}\n\n.strike-card .rich-text ul li {\n    margin-bottom: 8px;\n}\n\n.strike-list .strike-card {\n    --bg-opacity: 1;\n    background-color: #eee;\n    background-color: rgba(238,238,238,var(--bg-opacity));\n    position: relative;\n}\n\n.hero-banner .strike-card {\n    --text-opacity: 1;\n    background-color: transparent;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    height: auto;\n    margin-bottom: 0;\n    padding: 0;\n}\n\n.hero-banner .strike-card-title {\n    --text-opacity: 1;\n    color: #f7b22e;\n    color: rgba(247,178,46,var(--text-opacity));\n    font-size: 24px;\n    line-height: 24px;\n    margin-bottom: 4px;\n}\n\n.hero-banner .strike-card-location {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    margin-bottom: 16px;\n}\n\n.hero-banner .strike-card-description,.hero-banner .strike-card-details {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    font-size: 18px;\n    line-height: 28px;\n}\n\n.hero-banner .strike-card-description .rich-text ul li,.hero-banner .strike-card-description .rich-text ul li:before,.hero-banner .strike-card-description p,.hero-banner .strike-card-details .rich-text ul li,.hero-banner .strike-card-details .rich-text ul li:before,.hero-banner .strike-card-details p {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.hero-banner .strike-card a.cta-primary-medium {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .hero-banner .strike-card a.cta-primary-medium:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #002146;\n        background-color: rgba(0,33,70,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.hero-banner .strike-card a.cta-primary-medium:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #666;\n    background-color: rgba(102,102,102,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.hero-banner .strike-card svg .stroke {\n    fill: #fff;\n}\n\n.card-carousel .strike-card-details {\n    display: none;\n}\n\n.mobile-swiper-item .strike-card .rich-text ul {\n    padding-left: 20px;\n}\n\n.promo-callout-strike .card-carousel-btn.prev {\n    margin-right: -40px;\n    z-index: 1;\n}\n\n.promo-callout-strike .card-carousel-btn.next {\n    margin-right: -20px;\n    position: relative;\n    right: 20px;\n}\n\n.promo-callout-strike .link-small:before {\n    content: \"â€º\";\n    font-size: 14px;\n    line-height: 20px;\n    position: absolute;\n    right: -12px;\n}\n\n.promo-callout-strike a.cta-primary-medium {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n}\n\n.promo-callout-strike a.cta-primary-medium:hover {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #002146;\n    background-color: rgba(0,33,70,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.promo-callout-strike a.cta-primary-medium:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #666;\n    background-color: rgba(102,102,102,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.promo-callout-strike-row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.promo-callout-strike-row .callout {\n    margin-right: 16px;\n}\n\n.promo-callout-strike-row .callout-img {\n    height: 24px;\n    margin-bottom: 8px;\n    width: 24px;\n}\n\n@media (min-width: 1200px) {\n    .promo-callout-strike-row .callout-img {\n        height:24px;\n        width: 24px;\n    }\n}\n\n.promo-callout-strike-row .callout-heading {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    font-size: 14px;\n    line-height: 17px;\n    word-spacing: 30000px;\n}\n\n.mobile-swiper {\n    --n: 0;\n    --neg: -100%;\n    --po: 0px;\n    overflow-x: hidden;\n    width: 100%;\n}\n\n.mobile-swiper-container {\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    max-height: 100vh;\n    overflow-y: hidden;\n    -webkit-transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--po)));\n    -ms-transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--po)));\n    transform: translate(calc(var(--i) / var(--n) * var(--neg) + var(--tx) + var(--i) * var(--po)));\n    width: 100%;\n    width: calc(var(--n) * 100%);\n}\n\n.mobile-swiper .smooth {\n    -webkit-transition: -webkit-transform calc(var(--f) * 0.5s) ease-out;\n    transition: -webkit-transform calc(var(--f) * 0.5s) ease-out;\n    -o-transition: transform calc(var(--f) * 0.5s) ease-out;\n    transition: transform calc(var(--f) * 0.5s) ease-out;\n    transition: transform calc(var(--f) * 0.5s) ease-out,-webkit-transform calc(var(--f) * 0.5s) ease-out;\n}\n\n.mobile-swiper-slide {\n    --pr: 0px;\n    display: block;\n    margin: 0 4px;\n    padding-right: var(--pr);\n    width: 100%;\n    width: calc(100% / var(--n) - var(--po));\n    z-index: 2;\n}\n\n@media (min-width: 768px) {\n    .mobile-swiper-slide {\n        margin:0;\n    }\n}\n\n.mobile-swiper-slide > div {\n    margin: 0 auto;\n}\n\n.mobile-swiper-item {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-left: 8px;\n    margin-right: 8px;\n}\n\n.mobile-swiper-item .rich-text ul {\n    padding-left: 0;\n}\n\n.dot-navigation {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n}\n\n.dot-navigation-btn {\n    --bg-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    border-radius: 100%;\n    height: 15px;\n    margin-right: 12px;\n    width: 15px;\n}\n\n.dot-navigation-btn.active {\n    --bg-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n}\n\n.swiper-buttons {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: none;\n    height: 100%;\n    left: 28px;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: calc(100% - 56px);\n}\n\n@media (min-width: 768px) {\n    .swiper-buttons {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n}\n\n.swiper-buttons button {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: #efeeed;\n    border-radius: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 40px;\n    justify-content: center;\n    margin-bottom: 48px;\n    pointer-events: auto;\n    width: 40px;\n}\n\n.swiper-buttons button svg {\n    fill: #2257b8;\n    height: 40px;\n    width: 40px;\n}\n\n.swiper-buttons-backwards {\n    left: 0;\n    position: absolute;\n}\n\n.swiper-buttons-forwards {\n    position: absolute;\n    right: 0;\n}\n\n.swiper .dot-navigation-btn {\n    --bg-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    border: 2px solid #fff;\n}\n\n.swiper .dot-navigation-btn.active {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n}\n\n.swiper ul {\n    list-style: none;\n}\n\n.swiper ul .mobile-swiper-slide {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n}\n\n.testimonial-slide {\n    position: relative;\n}\n\n@media (min-width: 1366px) {\n    .testimonial-slide {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n}\n\n.testimonial-slide-media img {\n    height: auto;\n    width: 100%;\n}\n\n.testimonial-slide-media iframe.videoBlock {\n    height: 481px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-slide-media {\n        margin-left:-165px;\n        min-width: 50%;\n        width: 100%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-slide-media {\n        max-height:567px;\n        position: relative;\n    }\n\n    .testimonial-slide-media iframe.videoBlock {\n        width: 701px;\n    }\n}\n\n.testimonial-slide-content {\n    --bg-opacity: 1;\n    background-color: #84c434;\n    background-color: rgba(132,196,52,var(--bg-opacity));\n    -webkit-box-shadow: 5px 1px 6px rgba(0,0,0,0.14902);\n    box-shadow: 5px 1px 6px rgba(0,0,0,0.14902);\n    margin: -24px auto 0;\n    padding: 12px;\n    position: relative;\n    width: calc(100% - 24px);\n}\n\n@media (min-width: 768px) {\n    .testimonial-slide-content {\n        max-width:50%;\n        min-width: 50%;\n        padding: 24px;\n        width: 100%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-slide-content {\n        position:relative;\n    }\n}\n\n.testimonial-slide-embelishment {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: flex-end;\n    position: absolute;\n    right: 0;\n    top: 80%;\n    z-index: -1;\n}\n\n@media (min-width: 1366px) {\n    .testimonial-slide-embelishment {\n        overflow:hidden;\n        top: 35%;\n    }\n\n    .testimonial-slide-embelishment img,.testimonial-slide-embelishment svg {\n        height: 360px;\n        width: 360px;\n    }\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card .testimonial-block-container {\n        padding-bottom:80px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card .testimonial-block-container {\n        padding-bottom:100px;\n        padding-top: 140px;\n    }\n}\n\n.testimonial-block--card .testimonial-slide .rich-text {\n    --text-opacity: 1;\n    color: #000;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 18px;\n    letter-spacing: 0.09px;\n    line-height: 28px;\n    padding-top: 0;\n}\n\n.testimonial-block--card .testimonial-slide-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n    margin: 0;\n    max-width: none;\n    min-width: none;\n    padding: 8px 24px 24px;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card .testimonial-slide-content {\n        margin-left:20px;\n        margin-right: 20px;\n        padding: 24px 128px 16px 48px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card .testimonial-slide-content {\n        margin-left:20px;\n        margin-right: 20px;\n        padding: 24px 96px 32px 16px;\n    }\n}\n\n.testimonial-block--card .testimonial-slide-content-cta {\n    padding-right: 20px;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.testimonial-block--card .testimonial-slide-content-cta:before {\n    content: \"â€º\";\n    font-size: 25px;\n    position: absolute;\n    right: 0;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card .testimonial-slide-content-cta {\n        margin-left:44px;\n    }\n}\n\n.testimonial-block--card .testimonial-slide-content cite {\n    height: 64px;\n    padding-bottom: 8px;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation {\n    -webkit-box-orient: horizontal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-profile {\n    height: 48px;\n    margin-right: 24px;\n    width: 48px;\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card .testimonial-slide-content .block-quote-citation-profile {\n        height:56px;\n        width: 56px;\n    }\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-profile img {\n    border-radius: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-name {\n    padding-right: 4px;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-role {\n    font-size: 16px;\n    line-height: 20px;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-position {\n    display: none;\n}\n\n.testimonial-block--card .testimonial-slide-content .card-quote {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    height: 240px;\n    letter-spacing: 0.08px;\n    margin-bottom: 0;\n    padding: 0;\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card .testimonial-slide-content .card-quote {\n        height:128px;\n        margin-left: 80px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card .testimonial-slide-content .card-quote {\n        font-size:16px;\n        height: 200px;\n        line-height: 20px;\n    }\n}\n\n.testimonial-block--card .testimonial-slide-content .card-quote:before {\n    display: none;\n}\n\n.testimonial-block--card .testimonial-slide-content .card-quote:after {\n    display: none;\n}\n\n.testimonial-block--card .testimonial-slide-embelishment,.testimonial-block--card .testimonial-slide-media {\n    display: none;\n}\n\n.testimonial-block--card-swiper ul {\n    padding: 0;\n}\n\n.testimonial-block--card-swiper .swiper-buttons {\n    top: -60px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card-swiper .swiper-buttons {\n        top:0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card-swiper .swiper-buttons {\n        top:-36px;\n    }\n}\n\n.testimonial-block--card-swiper .swiper-buttons-backwards {\n    margin-left: 24px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card-swiper .swiper-buttons-backwards {\n        margin-top:24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card-swiper .swiper-buttons-backwards {\n        margin-left:16px;\n        margin-top: 0;\n    }\n}\n\n.testimonial-block--card-swiper .swiper-buttons-forwards {\n    margin-right: 36px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card-swiper .swiper-buttons-forwards {\n        margin-top:24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card-swiper .swiper-buttons-forwards {\n        margin-right:24px;\n        margin-top: 0;\n    }\n}\n\n.testimonial-block--card-swiper .dot-navigation {\n    margin-bottom: 0;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card-swiper .dot-navigation {\n        display:none;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card-swiper .dot-navigation {\n        display:block;\n        margin-top: 60px;\n    }\n}\n\n.testimonial-block {\n    background: -o-radial-gradient(top,circle,transparent,#dde6ed);\n    background: radial-gradient(circle at top,transparent,#dde6ed);\n    padding-bottom: 12px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block {\n        padding-bottom:45px;\n    }\n}\n\n.testimonial-block .carousel-mask {\n    padding-bottom: 12px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block .carousel-mask {\n        padding-bottom:24px;\n    }\n}\n\n.testimonial-block.testimonial-block--card {\n    background: none;\n    position: relative;\n}\n\n.testimonial-block.testimonial-block--card .testimonial-block-bg {\n    height: 100%;\n    position: absolute;\n    width: 100%;\n    z-index: -1;\n}\n\n.testimonial-block.testimonial-block--card .testimonial-block-bg img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.testimonial-block.testimonial-block--card .testimonial-block-bg:after {\n    background: transparent -o-linear-gradient(bottom,rgba(255,255,255,0) 0,rgba(0,0,0,0.98039) 100%) 0 0 no-repeat padding-box;\n    background: transparent -webkit-gradient(linear,left bottom,left top,from(rgba(255,255,255,0)),to(rgba(0,0,0,0.98039))) 0 0 no-repeat padding-box;\n    background: transparent linear-gradient(0deg,rgba(255,255,255,0),rgba(0,0,0,0.98039)) 0 0 no-repeat padding-box;\n    content: \" \";\n    height: 30%;\n    left: 0;\n    opacity: 0.54;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block.testimonial-block--card .testimonial-block-bg:after {\n        background:transparent -o-linear-gradient(right,rgba(255,255,255,0) 0,rgba(0,0,0,0.98039) 100%) 0 0 no-repeat padding-box;\n        background: transparent -webkit-gradient(linear,right top,left top,from(rgba(255,255,255,0)),to(rgba(0,0,0,0.98039))) 0 0 no-repeat padding-box;\n        background: transparent linear-gradient(270deg,rgba(255,255,255,0),rgba(0,0,0,0.98039)) 0 0 no-repeat padding-box;\n        height: 100%;\n        opacity: 0.34;\n        width: 83%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block.testimonial-block--card .testimonial-block-bg:after {\n        background:transparent -o-linear-gradient(right,rgba(255,255,255,0) 0,rgba(0,0,0,0.98039) 100%) 0 0 no-repeat padding-box;\n        background: transparent -webkit-gradient(linear,right top,left top,from(rgba(255,255,255,0)),to(rgba(0,0,0,0.98039))) 0 0 no-repeat padding-box;\n        background: transparent linear-gradient(270deg,rgba(255,255,255,0),rgba(0,0,0,0.98039)) 0 0 no-repeat padding-box;\n        height: 100%;\n        opacity: 0.34;\n        width: 66%;\n    }\n}\n\n.testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    font-size: 52px;\n    height: 129px;\n    line-height: 54px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        height: auto;\n        justify-content: center;\n        line-height: 72px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {\n        -webkit-box-orient:vertical;\n        -webkit-box-direction: normal;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        -ms-flex-direction: column;\n        flex-direction: column;\n        font-size: 152px;\n        justify-content: flex-start;\n        line-height: 152px;\n        padding-bottom: 24px;\n    }\n}\n\n.testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading span {\n   \n    z-index: 1;\n}\n\n.trending-news {\n    margin-bottom: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 366px;\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n@media (min-width: 768px) {\n    .trending-news {\n        max-width:100%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news {\n        max-width:432px;\n    }\n}\n\n.trending-news-title {\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n    font-size: 22px;\n    line-height: 28px;\n    line-height: 46px;\n}\n\n@media (min-width: 1366px) {\n    .trending-news-title {\n        font-size:24px;\n        font-size: 32px;\n        line-height: 34px;\n        margin-bottom: 24px;\n    }\n}\n\n.trending-news-item {\n    padding-bottom: 16px;\n    padding-top: 16px;\n}\n\n.trending-news-item-image {\n    margin-left: 16px;\n}\n\n.trending-news-item-image img {\n    border-radius: 8px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.trending-news-item-content-category {\n    --text-opacity: 1;\n    color: #2257b8;\n    color: rgba(34,87,184,var(--text-opacity));\n    font-size: 12px;\n    line-height: 16px;\n    padding-bottom: 8px;\n    text-transform: uppercase;\n}\n\n@media (min-width: 768px) {\n    .trending-news-item-content-category {\n        font-size:14px;\n        line-height: 14px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news-item-content-seperator {\n        --text-opacity:1;\n        border-right: 1px solid #979797;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n        display: inline;\n       \n        margin-left: 8px;\n        margin-right: 8px;\n    }\n}\n\n.trending-news-item-content-date {\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n   \n    font-size: 12px;\n    line-height: 16px;\n    margin-left: 16px;\n    padding-bottom: 8px;\n    text-transform: uppercase;\n}\n\n@media (min-width: 768px) {\n    .trending-news-item-content-date {\n        --text-opacity:1;\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        font-size: 14px;\n        line-height: 14px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news-item-content-date {\n        margin-left:0;\n    }\n}\n\n.trending-news-item-content-title {\n    margin-bottom: 16px;\n}\n\n.trending-news-item-content-summary,.trending-news-item-content-summary p {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 14px;\n    line-height: 22px;\n}\n\n@media (min-width: 768px) {\n    .trending-news-item-content-summary,.trending-news-item-content-summary p {\n        font-size:16px;\n        line-height: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news-item-content-summary,.trending-news-item-content-summary p {\n        --text-opacity:1;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n       \n        font-size: 14px;\n        line-height: 22px;\n    }\n}\n\n.bigmarker-widget-out-box {\n    max-width: 100% !important;\n    width: 800px !important;\n}\n\ninput.submit_registration_form {\n    border: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.modalPopup {\n    background-color: #fff;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    height: auto;\n    left: 50%;\n    margin-left: -216px;\n    overflow: auto;\n    position: fixed;\n    top: 10%;\n    width: 432px;\n    z-index: 5;\n}\n\n@media (max-width: 767px) {\n    .modalPopup {\n        margin-left:-45%;\n        width: 90%;\n    }\n}\n\n@media (max-width: 374px) {\n    .modalPopup {\n        margin-left:-44%;\n        width: 88%;\n    }\n}\n\n.modalPopupwrapper {\n    display: none;\n}\n\n.modalPopup-title {\n    --text-opacity: 1;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    font-size: 24px;\n    line-height: 28px;\n    padding-left: 44px;\n    padding-right: 44px;\n    padding-top: 16px;\n    text-align: center;\n}\n\n.modalPopup-overlay {\n    background: rgba(0,0,0,0.26667);\n    bottom: 0;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 4;\n}\n\n.modalPopupImg {\n    padding: 0;\n}\n\n.modalPopup-desc {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    font-size: 16px;\n    line-height: 24px;\n    padding-left: 64px;\n    padding-right: 64px;\n    text-align: center;\n}\n\n.closeBtn {\n    background-color: #f9f9f9;\n    background-color: rgba(249,249,249,var(--bg-opacity));\n    border-radius: 20px;\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 20px;\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.closeBtn,.closeBtn:hover {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    opacity: 1;\n}\n\n.closeBtn:hover {\n    background-color: #444;\n    background-color: rgba(68,68,68,var(--bg-opacity));\n    color: #f9f9f9;\n    color: rgba(249,249,249,var(--text-opacity));\n}\n\n.tooltip {\n    --text-opacity: 1;\n    background: #052c57 !important;\n    border-radius: 15px !important;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    opacity: 1 !important;\n    padding: 5px !important;\n}\n\n.tooltip-title {\n    font-size: 16px;\n    line-height: 20px;\n    padding-top: 8px;\n}\n\n.tooltip-content p,.tooltip-title {\n    padding-left: 8px;\n    padding-right: 8px;\n    text-align: center;\n}\n\n.tooltip-content p {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    font-size: 14px;\n    line-height: 22px;\n    padding-top: 4px;\n}\n\n.tooltip-cta {\n    font-size: 14px;\n    line-height: 14px;\n    padding: 16px 8px 8px;\n    text-decoration: underline;\n}\n\n.__react_component_tooltip.place-left:after {\n    border-left: 8px solid #052c57 !important;\n}\n\n.__react_component_tooltip.place-right:after {\n    border-right: 8px solid #052c57 !important;\n}\n\n.__react_component_tooltip.place-top:after {\n    border-top: 8px solid #052c57 !important;\n}\n\n.__react_component_tooltip.place-bottom:after {\n    border-bottom: 8px solid #052c57 !important;\n}\n\n@-moz-document url-prefix() {\n    .header-nav-utility-row .brand svg {\n        width: auto;\n    }\n}\n\n@media (min-width: 768px) {\n    .footer .footer-wrapper {\n        grid-gap:16px;\n        gap: 16px;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        padding-top: 64px;\n    }\n\n    .footer .footer-row-top .footer-links {\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        grid-row-gap: 16px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        grid-column: span 8 / span 8;\n        justify-content: center;\n        row-gap: 16px;\n    }\n\n    .footer .footer-row-top .footer-links li {\n        --text-opacity: 1;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n        color: #003c69;\n        color: rgba(0,60,105,var(--text-opacity));\n       \n        font-size: 16px;\n        letter-spacing: 0.08px;\n        line-height: 24px;\n        padding-bottom: 0;\n        padding-left: 16px;\n        padding-right: 16px;\n    }\n\n    .footer .footer-row-top .footer-contact-social {\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        grid-row-gap: 16px;\n        grid-row-gap: 8px;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        grid-column: span 2 / span 2;\n        justify-content: center;\n        justify-self: end;\n        margin-bottom: 0;\n        row-gap: 16px;\n        row-gap: 8px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .footer .footer-row-top .footer-contact-social {\n        -webkit-box-pack:end;\n        -ms-flex-pack: end;\n        grid-row-gap: 16px;\n        grid-column: span 2 / span 2;\n        grid-column-start: 11;\n        justify-content: flex-end;\n        row-gap: 16px;\n    }\n}\n\n@media (min-width: 768px) {\n    .footer .footer-row-top #ot-sdk-btn.ot-sdk-show-settings {\n        --text-opacity:1;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n        color: #003c69;\n        color: rgba(0,60,105,var(--text-opacity));\n       \n        font-size: 16px;\n        letter-spacing: 0.08px;\n        line-height: 24px;\n        padding-bottom: 0;\n        padding-right: 0;\n    }\n\n    .block-collection {\n        padding-bottom: 8px;\n        padding-top: 8px;\n    }\n}\n\n.block-collection-wrapper {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    justify-items: center;\n}\n\n@media (min-width: 768px) {\n    .block-collection-wrapper {\n        grid-row-gap:40px;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        row-gap: 40px;\n    }\n}\n\n.block-collection .block-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n    font-size: 32px;\n    grid-column: span 6 / span 6;\n    line-height: 36px;\n}\n\n@media (min-width: 1366px) {\n    .block-collection .block-title {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n@media (min-width: 768px) {\n    .block-collection .block-title {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .block-collection .block-title {\n        line-height:40px;\n    }\n}\n\n.block-collection .blocks-container {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-column: span 6 / span 6;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n}\n\n@media (min-width: 768px) {\n    .block-collection .blocks-container {\n        grid-row-gap:40px;\n        grid-column: span 12 / span 12;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        margin-left: 8px;\n        margin-right: 8px;\n        row-gap: 40px;\n    }\n}\n\n.block-collection .blocks-container > div {\n    background-color: transparent;\n    background: transparent;\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .block-collection .blocks-container > div {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.block-collection .blocks-container .section-container {\n    margin: 0;\n    padding: 0;\n}\n\n.block-collection .blocks-container .promo-callout {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.block-collection .blocks-container .base-page-content > div {\n    background: transparent;\n}\n\n.block-collection .block-cta {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    background-color: #0098db;\n    background-color: rgba(0,152,219,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 24px;\n    grid-column: span 6 / span 6;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding: 12px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .block-collection .block-cta:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.block-collection .block-cta > span,.block-collection .block-cta i,.block-collection .block-cta svg {\n    display: inline;\n}\n\n.block-collection .block-cta svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .block-collection .block-cta:hover {\n        --bg-opacity:1;\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n    }\n}\n\n.block-collection .block-cta:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .block-collection .block-cta:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.block-collection .block-cta:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 12px;\n    position: relative;\n}\n\n.block-collection .block-cta:hover {\n    --bg-opacity: 1;\n    background-color: #003c69;\n    background-color: rgba(0,60,105,var(--bg-opacity));\n}\n\n@media (min-width: 768px) {\n    .block-collection .block-cta {\n        grid-column:span 12 / span 12;\n        margin: 24px 24px 8px;\n    }\n}\n\n.category-block-dropdown summary {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n.category-block-dropdown summary p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    margin-bottom: 32px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .category-block-dropdown summary p {\n        line-height:48px;\n    }\n}\n\n.category-block-dropdown .category-block-entries {\n    grid-gap: 16px;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    gap: 16px;\n    grid-template-columns: repeat(auto-fit,100%);\n    justify-content: center;\n}\n\n@media (min-width: 768px) {\n    .category-block-dropdown .category-block-entries {\n        grid-template-columns:repeat(auto-fit,75%);\n    }\n}\n\n@media (min-width: 1366px) {\n    .category-block-dropdown .category-block-entries {\n        grid-template-columns:repeat(auto-fit,32%);\n    }\n\n    .category-block-dropdown .category-block-entries .category-block-entry {\n        -webkit-box-shadow: 0 1px 20px rgba(0,0,0,0.0902);\n        box-shadow: 0 1px 20px rgba(0,0,0,0.0902);\n        width: 432px;\n    }\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-tags {\n    display: none;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-content {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-content-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n\n    font-size: 24px;\n    line-height: 28px;\n    margin-top: 8px;\n    padding-bottom: 8px;\n}\n\n@media (min-width: 1366px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content-title {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        color: #003c69;\n        color: rgba(0,60,105,var(--text-opacity));\n    \n       \n        font-size: 40px;\n        font-size: 16px;\n        line-height: 44px;\n        line-height: 20px;\n        padding-bottom: 16px;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:1366px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content-title {\n        font-size:32px;\n        line-height: 36px;\n    }\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-content-subheading {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n   \n    font-size: 16px;\n    line-height: 20px;\n}\n\n@media (min-width: 1366px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content-subheading {\n        font-size:20px;\n        line-height: 24px;\n    }\n}\n\n@media (min-width: 768px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content-subheading {\n        line-height:26px;\n        padding-bottom: 8px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content-subheading {\n        padding-bottom:16px;\n    }\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-content .body-small {\n    font-size: 16px;\n    line-height: 24px;\n}\n\n@media (min-width: 768px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content .body-small {\n        padding-bottom:16px;\n    }\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-content-row {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-content-row-primary,.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n\n   \n   \n    font-size: 16px;\n    line-height: 20px;\n    padding: 0;\n}\n\n@media (min-width: 1366px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content-row-primary,.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {\n        font-size:20px;\n        line-height: 24px;\n    }\n}\n\n@media (min-width: 768px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-content-row-primary,.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {\n        line-height:26px;\n    }\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-content-row-secondary {\n    padding-bottom: 0 !important;\n    padding-left: 8px;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: reverse;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column-reverse;\n    flex-direction: column-reverse;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links .link-small:hover:before {\n    display: none;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a {\n    border: 2px solid #0098db;\n    border-radius: 8px;\n    color: #005bbb !important;\n    display: inline-block;\n   \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    margin-bottom: 24px;\n    padding: 6px 16px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a > span,.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a i,.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a svg {\n    display: inline;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        color: #fff !important;\n    }\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links > :first-child a:hover:before {\n    display: none;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links > :last-child {\n    padding-bottom: 24px;\n    padding-top: 16px;\n}\n\n.category-block-dropdown .category-block-entries .category-block-entry-links > :last-child a {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n   \n    font-size: 16px;\n    line-height: 20px;\n}\n\n@media (min-width: 1366px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-links > :last-child a {\n        font-size:20px;\n        line-height: 24px;\n    }\n}\n\n@media (min-width: 768px) {\n    .category-block-dropdown .category-block-entries .category-block-entry-links > :last-child a {\n        line-height:26px;\n    }\n}\n\n.callout .callout-heading {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    font-size: 32px;\n    line-height: 36px;\n    line-height: 38px;\n}\n\n.callout-img {\n    width: 100%;\n}\n\n.callout-content,.callout-content .rich-text {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.callout-content p {\n    text-align: inherit !important;\n}\n\n@media (min-width: 768px) {\n    .callout .callout-row-wrapper {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .callout .callout-row-wrapper .mobile-swiper-item {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 49%;\n        flex: 0 0 49%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .callout .callout-row-wrapper .mobile-swiper-item {\n        -webkit-box-flex:unset;\n        -ms-flex: unset;\n        flex: unset;\n    }\n}\n\n@media (max-width: 767px) {\n    .callout .mobile-swiper .mobile-swiper-item .base-page-content,.callout .mobile-swiper .mobile-swiper-item > div {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        justify-content: center;\n    }\n\n    .callout .mobile-swiper .dot-navigation {\n        margin-left: 4px;\n        margin-right: 4px;\n    }\n\n    .callout .mobile-swiper .dot-navigation button {\n        margin-left: 6px;\n        margin-right: 6px;\n    }\n}\n\n.callout-row-subtitle {\n    margin-bottom: 24px;\n}\n\n.callout-row .callout-row-wrapper {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    grid-gap: 8px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    grid-template-columns: unset;\n    justify-content: center;\n}\n\n.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(2) ~ .mobile-swiper-item {\n    margin-left: 0;\n    margin-right: 0;\n    width: 49%;\n}\n\n.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(3) ~ .mobile-swiper-item {\n    margin-left: 0;\n    margin-right: 0;\n    width: 32%;\n}\n\n.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(4) ~ .mobile-swiper-item {\n    margin-left: 0;\n    margin-right: 0;\n    width: 24%;\n}\n\n.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(5) ~ .mobile-swiper-item {\n    margin-left: 0;\n    margin-right: 0;\n    width: 32%;\n}\n\n.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(6) ~ .mobile-swiper-item {\n    margin-left: 0;\n    margin-right: 0;\n    width: 32%;\n}\n\n.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(7) ~ .mobile-swiper-item {\n    margin-left: 0;\n    margin-right: 0;\n    width: 24%;\n}\n\n.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8),.callout-row .callout-row-wrapper .mobile-swiper-item:first-child:nth-last-child(8) ~ .mobile-swiper-item {\n    margin-left: 0;\n    margin-right: 0;\n    width: 24%;\n}\n\n@media (min-width: 1366px) {\n    .callout-row .callout-row-wrapper {\n        grid-gap:16px;\n        gap: 16px;\n    }\n\n    .callout-row .callout-row-wrapper .callout--left .callout-content {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .callout-row .callout-row-wrapper .callout--left .callout-content .rich-text p {\n        text-align: left !important;\n    }\n\n    .callout-row .callout-row-wrapper .callout--left .callout-contentp {\n        text-align: left;\n    }\n\n    .callout-row .callout-row-wrapper .callout--left .callout-cta {\n        margin-left: 0;\n        text-align: left;\n    }\n}\n\n.cutout-block.section-container {\n    max-width: 100%;\n}\n\n.cutout-block .swiper-buttons-backwards:before {\n    content: \"âŒ©\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n}\n\n.cutout-block .swiper-buttons-forwards:before {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n}\n\n.dynamic-faq-content-heading-eyebrow {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n\n    font-size: 16px;\n    line-height: 16px;\n}\n\n@media (min-width: 768px) {\n    .dynamic-faq-content-heading-eyebrow {\n        --text-opacity:1;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n    \n        font-size: 16px;\n        line-height: 16px;\n    }\n}\n\n.dynamic-faq-content-faq-entry summary {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    font-size: 24px;\n    line-height: 30px;\n}\n\n@media (min-width: 768px) {\n    .dynamic-faq-content-faq-entry summary {\n        --text-opacity:1;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n    }\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-faq-entry summary {\n        --text-opacity:1;\n        color: #444;\n        color: rgba(68,68,68,var(--text-opacity));\n    }\n}\n\n.dynamic-faq-content-faq-entry p {\n    font-size: 16px;\n    line-height: 24px;\n    padding-bottom: 0;\n}\n\n.dynamic-faq-content-faq-entry[open] {\n    padding-bottom: 72px;\n}\n\n.dynamic-faq-content-cta a {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 18px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.dynamic-faq-content-cta a:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.dynamic-faq-content-cta a:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .dynamic-faq-content-cta a:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .dynamic-faq-content-cta a:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.dynamic-faq-content-cta a.wrapper:after {\n    width: 0;\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-cta a {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        display: block;\n       \n        font-size: 18px;\n        line-height: 22px;\n        position: relative;\n        text-decoration: none;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n        width: -webkit-fit-content;\n        width: -moz-fit-content;\n        width: fit-content;\n    }\n\n    .dynamic-faq-content-cta a:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        bottom: 0;\n        content: \"\";\n        display: block;\n        height: 1.5px;\n        opacity: 0;\n        position: absolute;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n        width: 100%;\n    }\n\n    .dynamic-faq-content-cta a:after {\n        display: none;\n    }\n}\n\n@media (min-width: 1366px) and (hover:hover) {\n    .dynamic-faq-content-cta a:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .dynamic-faq-content-cta a:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (min-width: 1366px) {\n    .dynamic-faq-content-cta a.wrapper:after {\n        width:0;\n    }\n}\n\n.news-content-side .EPiServerForms {\n    max-width: 864px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox {\n    max-width: 864px;\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload,.news-content-side .EPiServerForms .Form__MainBody section .FormRange,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox {\n        width:416px;\n    }\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha label,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime label,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload label,.news-content-side .EPiServerForms .Form__MainBody section .FormRange label,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection label,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox label {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    font-size: 18px;\n    text-align: left;\n    top: 26px;\n    -webkit-transition: top 0.5s,font-size 0.5s;\n    -o-transition: top 0.5s,font-size 0.5s;\n    transition: top 0.5s,font-size 0.5s;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormRange label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection label.has-data,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox label.has-data {\n    background-color: #fff;\n    font-size: 12px;\n    top: -11px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormRange[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection[focus-within] label,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label {\n    background-color: #fff;\n    color: #2257b8;\n    font-size: 12px;\n    top: -11px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormCaptcha:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormDateTime:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormFileUpload:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormRange:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormSelection:focus-within label,.news-content-side .EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {\n    background-color: #fff;\n    color: #2257b8;\n    font-size: 12px;\n    top: -11px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormSelection:after {\n    top: 37px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormChoice label {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .FormChoice label input {\n    height: 18px;\n    margin: 6px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section input,.news-content-side .EPiServerForms .Form__MainBody section select,.news-content-side .EPiServerForms .Form__MainBody section textarea {\n    height: 80px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section input::-webkit-input-placeholder,.news-content-side .EPiServerForms .Form__MainBody section select::-webkit-input-placeholder,.news-content-side .EPiServerForms .Form__MainBody section textarea::-webkit-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section input::-moz-placeholder,.news-content-side .EPiServerForms .Form__MainBody section select::-moz-placeholder,.news-content-side .EPiServerForms .Form__MainBody section textarea::-moz-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section input:-ms-input-placeholder,.news-content-side .EPiServerForms .Form__MainBody section select:-ms-input-placeholder,.news-content-side .EPiServerForms .Form__MainBody section textarea:-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section input::-ms-input-placeholder,.news-content-side .EPiServerForms .Form__MainBody section select::-ms-input-placeholder,.news-content-side .EPiServerForms .Form__MainBody section textarea::-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section input::placeholder,.news-content-side .EPiServerForms .Form__MainBody section select::placeholder,.news-content-side .EPiServerForms .Form__MainBody section textarea::placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button,.news-content-side .EPiServerForms .Form__MainBody section button {\n    margin-left: 0;\n    margin-right: auto;\n    width: unset;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button,.news-content-side .EPiServerForms .Form__MainBody section a.button > a,.news-content-side .EPiServerForms .Form__MainBody section a.button > button,.news-content-side .EPiServerForms .Form__MainBody section button,.news-content-side .EPiServerForms .Form__MainBody section button > a,.news-content-side .EPiServerForms .Form__MainBody section button > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 24px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding: 12px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .news-content-side .EPiServerForms .Form__MainBody section a.button:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:hover,.news-content-side .EPiServerForms .Form__MainBody section button:hover,.news-content-side .EPiServerForms .Form__MainBody section button > a:hover,.news-content-side .EPiServerForms .Form__MainBody section button > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button > a > span,.news-content-side .EPiServerForms .Form__MainBody section a.button > a i,.news-content-side .EPiServerForms .Form__MainBody section a.button > a svg,.news-content-side .EPiServerForms .Form__MainBody section a.button > button > span,.news-content-side .EPiServerForms .Form__MainBody section a.button > button i,.news-content-side .EPiServerForms .Form__MainBody section a.button > button svg,.news-content-side .EPiServerForms .Form__MainBody section a.button > span,.news-content-side .EPiServerForms .Form__MainBody section a.button i,.news-content-side .EPiServerForms .Form__MainBody section a.button svg,.news-content-side .EPiServerForms .Form__MainBody section button > a > span,.news-content-side .EPiServerForms .Form__MainBody section button > a i,.news-content-side .EPiServerForms .Form__MainBody section button > a svg,.news-content-side .EPiServerForms .Form__MainBody section button > button > span,.news-content-side .EPiServerForms .Form__MainBody section button > button i,.news-content-side .EPiServerForms .Form__MainBody section button > button svg,.news-content-side .EPiServerForms .Form__MainBody section button > span,.news-content-side .EPiServerForms .Form__MainBody section button i,.news-content-side .EPiServerForms .Form__MainBody section button svg {\n    display: inline;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button > a svg,.news-content-side .EPiServerForms .Form__MainBody section a.button > button svg,.news-content-side .EPiServerForms .Form__MainBody section a.button svg,.news-content-side .EPiServerForms .Form__MainBody section button > a svg,.news-content-side .EPiServerForms .Form__MainBody section button > button svg,.news-content-side .EPiServerForms .Form__MainBody section button svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:disabled,.news-content-side .EPiServerForms .Form__MainBody section button:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > a:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .news-content-side .EPiServerForms .Form__MainBody section a.button:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section button:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > a:disabled:hover:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button.inverted,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted,.news-content-side .EPiServerForms .Form__MainBody section button.inverted,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:hover,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:active,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:disabled,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .news-content-side .EPiServerForms .Form__MainBody section a.button.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > a.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section a.button > button.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section button.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section button > a.inverted:disabled:hover,.news-content-side .EPiServerForms .Form__MainBody section button > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button:after,.news-content-side .EPiServerForms .Form__MainBody section a.button > a:after,.news-content-side .EPiServerForms .Form__MainBody section a.button > button:after,.news-content-side .EPiServerForms .Form__MainBody section button:after,.news-content-side .EPiServerForms .Form__MainBody section button > a:after,.news-content-side .EPiServerForms .Form__MainBody section button > button:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 12px;\n    position: relative;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section a.button.wrapper,.news-content-side .EPiServerForms .Form__MainBody section button.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n@media (max-width: 767px) {\n    .news-content-side .EPiServerForms .Form__MainBody section .Form__Element {\n        margin-left:24px;\n        margin-right: 24px;\n    }\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal {\n    grid-column-gap: 4px;\n    -webkit-column-gap: 4px;\n    -moz-column-gap: 4px;\n    column-gap: 4px;\n    display: inline-block;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a {\n    display: inline-block;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex),.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 14px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {\n    opacity: 0;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex).wrapper:after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a.wrapper:after,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button.wrapper:after {\n    width: 0;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a.inline {\n    display: inline-block;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 1;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {\n    opacity: 0;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):not(.flex),.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:not(.flex),.news-content-side .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:not(.flex) {\n    display: inline-block;\n}\n\n.news-content-side .EPiServerForms .FormParagraphText.Form__Element--NonData p {\n   \n    font-size: 16px;\n    line-height: 24px;\n}\n\n.news-content-side .enhanced-form-color {\n    border-radius: 8px;\n    padding-bottom: 0;\n    padding-top: 0;\n}\n\n.news-content-side .enhanced-form-color .enhanced-form {\n    background-image: none;\n    width: 100%;\n}\n\n.news-content-side .enhanced-form-color .enhanced-form-content {\n    margin-top: 32px;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.news-content-side .enhanced-form-color .enhanced-form .layout-container {\n    background-image: none;\n    border-radius: 8px;\n    padding: 0 !important;\n}\n\n.news-content-side .enhanced-form-color .enhanced-form .layout-container .Form__Title {\n    display: none;\n}\n\n.news-content-side .enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form {\n    background-image: none;\n    max-width: 100%;\n    padding: 0;\n}\n\n.news-content-side .enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form .layout-container {\n    background-color: transparent;\n    background-image: none;\n    border-radius: 0;\n    padding: 0 48px !important;\n}\n\n.news-content-side .EPiServerForms .Form__Description,.news-content-side .EPiServerForms .Form__Title {\n    --text-opacity: 1;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n}\n\n.enhanced-form-color {\n    background-color: #d3d3d3;\n    background-size: cover;\n    padding-bottom: 0;\n}\n\n.enhanced-form-color .enhanced-form-color {\n    background-color: transparent;\n    background-image: none;\n}\n\n.enhanced-form-color .enhanced-form-color .layout-container {\n    padding: 0 !important;\n}\n\n.enhanced-form-color .enhanced-form {\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    max-width: 1328px;\n}\n\n.enhanced-form-color .enhanced-form .Form__Description,.enhanced-form-color .enhanced-form .Form__Title {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.enhanced-form-color .enhanced-form .Form__Title {\n    padding-top: 8px;\n}\n\n.enhanced-form-color .enhanced-form-content {\n    display: block !important;\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-color .enhanced-form-content {\n        display:block;\n        grid-column: 1/6;\n        margin-bottom: auto;\n        margin-top: 0;\n        padding-left: 48px;\n        padding-right: 48px;\n    }\n}\n\n.enhanced-form-color .enhanced-form-content-eyebrow {\n    color: #fff;\n    display: block;\n}\n\n.enhanced-form-color .enhanced-form-content-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #fff;\n\n    font-size: 24px;\n    line-height: 28px;\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-color .enhanced-form-content-title {\n        font-size:40px;\n        line-height: 44px;\n    }\n}\n\n.enhanced-form-color .enhanced-form-content-description {\n    color: #fff;\n    padding-top: 24px;\n}\n\n.enhanced-form-color .enhanced-form-content-description .rich-text p {\n    color: #fff;\n}\n\n.enhanced-form-color .enhanced-form-content-description .rich-text a,.enhanced-form-color .enhanced-form-content-description .rich-text a:visited {\n    color: #fff;\n    text-decoration: underline;\n}\n\n.enhanced-form-color .enhanced-form-content-summary {\n    color: #fff;\n    padding-top: 24px;\n}\n\n.enhanced-form-color .enhanced-form-content-summary .rich-text p {\n    color: #fff;\n}\n\n.enhanced-form-color .enhanced-form-content-summary .rich-text a,.enhanced-form-color .enhanced-form-content-summary .rich-text a:visited {\n    color: #fff;\n    text-decoration: underline;\n}\n\n.enhanced-form-color .enhanced-form-container,.enhanced-form-color .enhanced-form .layout-container {\n    border-radius: 8px;\n    padding-bottom: 20px;\n    padding-top: 20px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .enhanced-form-color .enhanced-form-container,.enhanced-form-color .enhanced-form .layout-container {\n        background-color:transparent;\n        border-radius: unset;\n        border-bottom-right-radius: 8px;\n        border-top-right-radius: 8px;\n        grid-column: 6/13;\n        padding-left: 48px;\n        padding-right: 48px;\n    }\n\n    .enhanced-form-color .enhanced-form-container .EPiServerForms,.enhanced-form-color .enhanced-form .layout-container .EPiServerForms {\n        max-width: 656px;\n    }\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 24px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding: 12px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button > span,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button i,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button svg {\n    display: inline;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:hover {\n        --bg-opacity:1;\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n    }\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:disabled {\n    --text-opacity: 1;\n    -webkit-box-shadow: inset 0 0 0 3px #bbb;\n    box-shadow: inset 0 0 0 3px #bbb;\n    color: #bbb;\n    color: rgba(187,187,187,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:disabled:hover {\n        background-color:transparent;\n    }\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section button:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 12px;\n    position: relative;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal {\n    grid-column-gap: 4px;\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    -webkit-column-gap: 4px;\n    -moz-column-gap: 4px;\n    column-gap: 4px;\n    display: inline-block;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button {\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 14px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    opacity: 0;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex).wrapper:after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a.wrapper:after,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button.wrapper:after {\n    width: 0;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a.inline {\n    display: inline-block;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:before {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 1;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:hover:before,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:hover:before {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    opacity: 0;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a:not(.flex):not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a > a:not(.flex),.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .Form__Element .recaptcha-legal a button:not(.flex) {\n    display: inline-block;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormCaptcha[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormDateTime[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormRange[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormRange label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormSelection[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormSelection label.has-data,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormTextbox label.has-data {\n    background-color: transparent;\n    color: #fff;\n    font-size: 16px;\n    top: -22px;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormCaptcha:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormDateTime:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormRange:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormSelection:focus-within label,.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {\n    background-color: transparent;\n    color: #fff;\n    font-size: 16px;\n    top: -22px;\n}\n\n.enhanced-form-color .enhanced-form .EPiServerForms .Form__MainBody section .FormFileUpload input {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.form-layout-block.enhanced-form-color {\n    background-size: cover;\n}\n\n@media (min-width: 768px) {\n    .form-layout-block.enhanced-form-color.section-container {\n        margin:0;\n        max-width: 100%;\n    }\n}\n\n.form-layout-block.enhanced-form-color .enhanced-form .layout-container {\n    background-color: transparent;\n    background-image: none;\n}\n\n.form-layout-block.enhanced-form-color .enhanced-form .layout-container .enhanced-form-color {\n    background-color: transparent;\n}\n\n.form-layout-block.enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form .layout-container {\n    background-color: transparent;\n    background-image: none;\n    padding: 0 !important;\n}\n\n.form-layout-block .layout-container .Form__Description,.form-layout-block .layout-container .Form__Title {\n    display: none;\n}\n\n.form-layout-block .layout-container .enhanced-form-content {\n    display: none !important;\n}\n\n.scPage-content-side .enhanced-form-color {\n    border-radius: 8px;\n    padding-top: 0;\n}\n\n.scPage-content-side .enhanced-form-color .enhanced-form-content {\n    margin-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.scPage-content-side .enhanced-form-color .enhanced-form .layout-container {\n    padding: 0;\n}\n\n.scPage-content-side .enhanced-form-color .enhanced-form .layout-container .enhanced-form-color .enhanced-form {\n    width: unset;\n}\n\n.EPiServerForms .Form__MainBody section {\n    margin-top: 16px;\n}\n\n.EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section button {\n    margin-left: 0;\n    margin-right: auto;\n    padding-bottom: 12px;\n    padding-top: 12px;\n}\n\n.EPiServerForms .Form__MainBody section a.button,.EPiServerForms .Form__MainBody section a.button > a,.EPiServerForms .Form__MainBody section a.button > button,.EPiServerForms .Form__MainBody section button,.EPiServerForms .Form__MainBody section button > a,.EPiServerForms .Form__MainBody section button > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 24px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding-left: 32px;\n    padding-right: 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .EPiServerForms .Form__MainBody section a.button:hover,.EPiServerForms .Form__MainBody section a.button > a:hover,.EPiServerForms .Form__MainBody section a.button > button:hover,.EPiServerForms .Form__MainBody section button:hover,.EPiServerForms .Form__MainBody section button > a:hover,.EPiServerForms .Form__MainBody section button > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.EPiServerForms .Form__MainBody section a.button > a > span,.EPiServerForms .Form__MainBody section a.button > a i,.EPiServerForms .Form__MainBody section a.button > a svg,.EPiServerForms .Form__MainBody section a.button > button > span,.EPiServerForms .Form__MainBody section a.button > button i,.EPiServerForms .Form__MainBody section a.button > button svg,.EPiServerForms .Form__MainBody section a.button > span,.EPiServerForms .Form__MainBody section a.button i,.EPiServerForms .Form__MainBody section a.button svg,.EPiServerForms .Form__MainBody section button > a > span,.EPiServerForms .Form__MainBody section button > a i,.EPiServerForms .Form__MainBody section button > a svg,.EPiServerForms .Form__MainBody section button > button > span,.EPiServerForms .Form__MainBody section button > button i,.EPiServerForms .Form__MainBody section button > button svg,.EPiServerForms .Form__MainBody section button > span,.EPiServerForms .Form__MainBody section button i,.EPiServerForms .Form__MainBody section button svg {\n    display: inline;\n}\n\n.EPiServerForms .Form__MainBody section a.button > a svg,.EPiServerForms .Form__MainBody section a.button > button svg,.EPiServerForms .Form__MainBody section a.button svg,.EPiServerForms .Form__MainBody section button > a svg,.EPiServerForms .Form__MainBody section button > button svg,.EPiServerForms .Form__MainBody section button svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.EPiServerForms .Form__MainBody section a.button:disabled,.EPiServerForms .Form__MainBody section a.button > a:disabled,.EPiServerForms .Form__MainBody section a.button > button:disabled,.EPiServerForms .Form__MainBody section button:disabled,.EPiServerForms .Form__MainBody section button > a:disabled,.EPiServerForms .Form__MainBody section button > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .EPiServerForms .Form__MainBody section a.button:disabled:hover:disabled,.EPiServerForms .Form__MainBody section a.button > a:disabled:hover:disabled,.EPiServerForms .Form__MainBody section a.button > button:disabled:hover:disabled,.EPiServerForms .Form__MainBody section button:disabled:hover:disabled,.EPiServerForms .Form__MainBody section button > a:disabled:hover:disabled,.EPiServerForms .Form__MainBody section button > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.EPiServerForms .Form__MainBody section a.button.inverted,.EPiServerForms .Form__MainBody section a.button > a.inverted,.EPiServerForms .Form__MainBody section a.button > button.inverted,.EPiServerForms .Form__MainBody section button.inverted,.EPiServerForms .Form__MainBody section button > a.inverted,.EPiServerForms .Form__MainBody section button > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .EPiServerForms .Form__MainBody section a.button.inverted:hover,.EPiServerForms .Form__MainBody section a.button > a.inverted:hover,.EPiServerForms .Form__MainBody section a.button > button.inverted:hover,.EPiServerForms .Form__MainBody section button.inverted:hover,.EPiServerForms .Form__MainBody section button > a.inverted:hover,.EPiServerForms .Form__MainBody section button > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.EPiServerForms .Form__MainBody section a.button.inverted:active,.EPiServerForms .Form__MainBody section a.button > a.inverted:active,.EPiServerForms .Form__MainBody section a.button > button.inverted:active,.EPiServerForms .Form__MainBody section button.inverted:active,.EPiServerForms .Form__MainBody section button > a.inverted:active,.EPiServerForms .Form__MainBody section button > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.EPiServerForms .Form__MainBody section a.button.inverted:disabled,.EPiServerForms .Form__MainBody section a.button > a.inverted:disabled,.EPiServerForms .Form__MainBody section a.button > button.inverted:disabled,.EPiServerForms .Form__MainBody section button.inverted:disabled,.EPiServerForms .Form__MainBody section button > a.inverted:disabled,.EPiServerForms .Form__MainBody section button > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .EPiServerForms .Form__MainBody section a.button.inverted:disabled:hover,.EPiServerForms .Form__MainBody section a.button > a.inverted:disabled:hover,.EPiServerForms .Form__MainBody section a.button > button.inverted:disabled:hover,.EPiServerForms .Form__MainBody section button.inverted:disabled:hover,.EPiServerForms .Form__MainBody section button > a.inverted:disabled:hover,.EPiServerForms .Form__MainBody section button > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.EPiServerForms .Form__MainBody section a.button.wrapper,.EPiServerForms .Form__MainBody section button.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.EPiServerForms .Form__MainBody section input,.EPiServerForms .Form__MainBody section select,.EPiServerForms .Form__MainBody section textarea {\n    height: 80px;\n}\n\n.EPiServerForms .Form__MainBody section input:focus,.EPiServerForms .Form__MainBody section select:focus,.EPiServerForms .Form__MainBody section textarea:focus {\n    border: 1px solid #2257b8;\n    outline: none;\n}\n\n.EPiServerForms .Form__MainBody section input:focus::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section select:focus::-webkit-input-placeholder,.EPiServerForms .Form__MainBody section textarea:focus::-webkit-input-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section input:focus::-moz-placeholder,.EPiServerForms .Form__MainBody section select:focus::-moz-placeholder,.EPiServerForms .Form__MainBody section textarea:focus::-moz-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section input:focus:-ms-input-placeholder,.EPiServerForms .Form__MainBody section select:focus:-ms-input-placeholder,.EPiServerForms .Form__MainBody section textarea:focus:-ms-input-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section input:focus::-ms-input-placeholder,.EPiServerForms .Form__MainBody section select:focus::-ms-input-placeholder,.EPiServerForms .Form__MainBody section textarea:focus::-ms-input-placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section input:focus::placeholder,.EPiServerForms .Form__MainBody section select:focus::placeholder,.EPiServerForms .Form__MainBody section textarea:focus::placeholder {\n    opacity: 1;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormDateTime.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormFileUpload.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormRange.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormSelection.ValidationFail .Form__Element__ValidationError,.EPiServerForms .Form__MainBody section .FormTextbox.ValidationFail .Form__Element__ValidationError {\n    background-color: red;\n    border-radius: 8px;\n    color: #fff;\n    display: block;\n    margin-top: 4px;\n    padding: 5px;\n    text-align: center;\n    width: 100%;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha label,.EPiServerForms .Form__MainBody section .FormDateTime label,.EPiServerForms .Form__MainBody section .FormFileUpload label,.EPiServerForms .Form__MainBody section .FormRange label,.EPiServerForms .Form__MainBody section .FormSelection label,.EPiServerForms .Form__MainBody section .FormTextbox label {\n    --text-opacity: 1;\n    background-color: transparent;\n    color: #666;\n    color: rgba(102,102,102,var(--text-opacity));\n    font-size: 18px;\n    left: 10px;\n    padding: 0 10px;\n    position: absolute;\n    top: 28px;\n    -webkit-transition: top 0.5s,font-size 0.5s;\n    -o-transition: top 0.5s,font-size 0.5s;\n    transition: top 0.5s,font-size 0.5s;\n    z-index: 0;\n}\n\n.EPiServerForms .Form__MainBody section .FormCaptcha label.has-data,.EPiServerForms .Form__MainBody section .FormDateTime label.has-data,.EPiServerForms .Form__MainBody section .FormFileUpload label.has-data,.EPiServerForms .Form__MainBody section .FormRange label.has-data,.EPiServerForms .Form__MainBody section .FormSelection label.has-data,.EPiServerForms .Form__MainBody section .FormTextbox label.has-data {\n    background-color: #fff;\n    font-size: 18px;\n    top: -11px;\n}\n\n.EPiServerForms .Form__MainBody section .Form__Element {\n    margin-bottom: 20px;\n}\n\n.EPiServerForms .Form__MainBody section .FormChoice {\n    width: 100%;\n}\n\n.EPiServerForms .Form__MainBody section .FormChoice fieldset {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n.EPiServerForms .Form__MainBody section .FormChoice fieldset label {\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .EPiServerForms .Form__MainBody section .FormChoice fieldset label {\n        width:50%;\n    }\n}\n\n.EPiServerForms .Form__MainBody section .FormSelection:after {\n    top: 35px;\n}\n\n.EPiServerForms .Form__MainBody section .FormChoice {\n    color: #fff;\n}\n\n.EPiServerForms .Form__MainBody section .FormChoice__Input {\n    min-width: 20px;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime,.EPiServerForms .Form__MainBody section .FormFileUpload {\n    margin-top: 8px;\n}\n\n.EPiServerForms .Form__MainBody section .FormDateTime label,.EPiServerForms .Form__MainBody section .FormFileUpload label {\n    background-color: transparent;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 700;\n    top: -25px;\n}\n\n.EPiServerForms .Form__MainBody section .FormFileUpload input {\n    padding-top: 24px;\n}\n\n.EPiServerForms .Form__MainBody section .Form__Element--NonData p {\n    color: #fff;\n}\n\n.EPiServerForms .Form__MainBody section a button {\n    font-size: 12px;\n    line-height: 12px;\n}\n\n.EPiServerForms a {\n    color: #fff;\n}\n\n.EPiServerForms a:before {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 1;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.EPiServerForms a:hover {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.EPiServerForms a:hover:before {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    opacity: 0;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n.form-layout-block-wrapper {\n    max-height: 699px;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper {\n        min-height:699px;\n    }\n}\n\n.form-layout-block-wrapper .background {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    position: absolute;\n    width: 100%;\n}\n\n.form-layout-block-wrapper .background .bg-img {\n    width: 100%;\n}\n\n.form-layout-block-wrapper .background .bg-img img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.form-layout-block-wrapper .background .bg-img.featured {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    height: 303px;\n    order: 1;\n}\n\n.form-layout-block-wrapper .background .bg-img.form {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    min-height: 540px;\n    order: 2;\n}\n\n.form-layout-block-wrapper .background .bg-img.form img {\n    min-height: 540px;\n}\n\n@media (min-width: 768px) {\n    .form-layout-block-wrapper .background .bg-img.featured {\n        height:500px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .background {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        max-height: 699px;\n    }\n\n    .form-layout-block-wrapper .background .bg-img {\n        width: 50%;\n    }\n\n    .form-layout-block-wrapper .background .bg-img.featured {\n        -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n        min-height: 699px;\n        order: 2;\n    }\n\n    .form-layout-block-wrapper .background .bg-img.form {\n        -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n        order: 1;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block {\n    grid-gap: 16px;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    position: relative;\n    top: 303px;\n}\n\n@media (min-width: 768px) {\n    .form-layout-block-wrapper .form-layout-block {\n        padding-top:48px;\n        top: 500px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .form-layout-block {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n        height: 699px;\n        padding-bottom: 90px;\n        padding-top: 90px;\n        top: 0;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .Form__Title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n    font-size: 16px;\n    line-height: 20px;\n    padding-bottom: 16px;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .form-layout-block .Form__Title {\n        font-size:32px;\n        line-height: 36px;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .Form__Description {\n   \n    font-size: 16px;\n    line-height: 24px;\n    padding-bottom: 24px;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .form-layout-block .Form__Description {\n        padding-bottom:28px;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .Form__Description,.form-layout-block-wrapper .form-layout-block .Form__Title {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.form-layout-block-wrapper .form-layout-block-container,.form-layout-block-wrapper .form-layout-block .layout-container {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .form-layout-block-container,.form-layout-block-wrapper .form-layout-block .layout-container {\n        grid-column:span 5 / span 5;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .featured-img {\n    grid-column: span 6 / span 6;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section {\n    margin-top: 0;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button {\n    margin-top: 16px;\n    max-height: 60px;\n    max-width: -webkit-fit-content;\n    max-width: -moz-fit-content;\n    max-width: fit-content;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 24px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 36px;\n    padding: 12px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button svg {\n    display: inline;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > a:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button > button:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 12px;\n    position: relative;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button {\n        margin-top:32px;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton {\n    --bg-opacity: 1;\n    background-color: #0098db;\n    background-color: rgba(0,152,219,var(--bg-opacity));\n    margin-bottom: 0;\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        border-radius: 8px;\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        display: inline-block;\n       \n        font-size: 24px;\n        height: auto;\n        letter-spacing: 0.16px;\n        line-height: 20px;\n        line-height: 36px;\n        padding: 12px 32px;\n        text-align: center;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (hover: hover) and (hover:hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > span,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover i,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover svg {\n        display:inline;\n    }\n\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button svg,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover svg {\n        fill: #fff;\n        height: 20px;\n        margin-right: 4px;\n        -webkit-transform: translateY(-2.5px);\n        -ms-transform: translateY(-2.5px);\n        transform: translateY(-2.5px);\n        width: 20px;\n    }\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n@media (hover: hover) and (hover:hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:disabled:hover:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        color: #002146;\n        color: rgba(0,33,70,var(--text-opacity));\n    }\n}\n\n@media (hover: hover) and (hover:hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:active,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:active {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #2257b8;\n        background-color: rgba(34,87,184,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:disabled,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:disabled {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n@media (hover: hover) and (hover:hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a.inverted:disabled:hover,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > a:after,.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover > button:after {\n        content:\"âŒª\";\n        font-family: Font Awesome\\6 Pro;\n        font-size: 0.75em;\n        font-weight: 900;\n        left: 12px;\n        position: relative;\n    }\n}\n\n@media (hover: hover) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section button.FormSubmitButton:hover.wrapper {\n        background-color:transparent;\n        margin: 0;\n        padding: 0;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section input {\n    border-radius: 8px;\n    height: 64px;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section input {\n        height:80px;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox {\n    margin-bottom: 16px;\n    width: 100%;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox label {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    top: 20px;\n}\n\n@media (min-width: 1366px) {\n    .form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox label {\n        top:28px;\n    }\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox[focus-within] label {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    top: -22px;\n}\n\n.form-layout-block-wrapper .form-layout-block .EPiServerForms .Form__MainBody section .FormTextbox:focus-within label {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    top: -22px;\n}\n\n.destinations-grid,.generic-grid {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n}\n\n.destinations-grid-wrapper > div,.generic-grid-wrapper > div {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.destinations-grid-content-overline,.generic-grid-content-overline {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 0;\n}\n\n.destinations-grid .title,.generic-grid .title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n   \n    font-size: 24px;\n    line-height: 28px;\n    margin-bottom: 16px;\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid .title,.generic-grid .title {\n        font-size:40px;\n        line-height: 44px;\n    }\n}\n\n@media (min-width: 768px) {\n    .destinations-grid .title,.generic-grid .title {\n        line-height:48px;\n    }\n}\n\n.destinations-grid .text-content,.generic-grid .text-content {\n    margin-bottom: 32px;\n}\n\n.destinations-grid-content-link,.generic-grid-content-link {\n    display: none;\n}\n\n.destinations-grid-media,.generic-grid-media {\n    background: transparent;\n}\n\n.destinations-grid-media-large img,.generic-grid-media-large img {\n    border-radius: 8px;\n}\n\n.destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {\n    --text-opacity: 1;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    -webkit-box-pack: unset;\n    -ms-flex-pack: unset;\n    align-items: flex-end;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n   \n    font-size: 32px;\n    justify-content: unset;\n    line-height: 36px;\n    padding-bottom: 16px;\n    text-align: left;\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {\n        line-height:56px;\n        padding-bottom: 24px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid-media-large .generic-grid-media-text,.generic-grid-media-large .generic-grid-media-text {\n        padding-bottom:40px;\n    }\n}\n\n.destinations-grid-media-grid-row-image img,.generic-grid-media-grid-row-image img {\n    border-radius: 8px;\n}\n\n.destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {\n    --text-opacity: 1;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    -webkit-box-pack: unset;\n    -ms-flex-pack: unset;\n    align-items: flex-end;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n\n   \n    font-size: 24px;\n    justify-content: unset;\n    line-height: 28px;\n    padding-bottom: 16px;\n    text-align: left;\n    text-shadow: none;\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {\n        font-size:40px;\n        line-height: 44px;\n    }\n}\n\n@media (min-width: 768px) {\n    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    \n       \n        font-size: 24px;\n        line-height: 28px;\n        line-height: 48px;\n        padding-bottom: 24px;\n    }\n}\n\n@media (min-width: 768px) and (min-width:1366px) {\n    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {\n        font-size:40px;\n        line-height: 44px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .destinations-grid-media-grid-row-image .generic-grid-media-text,.generic-grid-media-grid-row-image .generic-grid-media-text {\n        --text-opacity:1;\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n       \n        line-height: 48px;\n        padding-bottom: 40px;\n    }\n}\n\n.hero-banner-form {\n    background-color: #efb41d;\n}\n\n.hero-banner-form .hero-text-bottom {\n    --text-opacity: 1;\n    color: #003876;\n    color: rgba(0,56,118,var(--text-opacity));\n}\n\n.input-text-icon svg {\n    fill: #003876;\n}\n\n.leadership-block .title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    line-height: 56px;\n    margin-bottom: 8px;\n    text-align: center;\n}\n\n@media (min-width: 768px) {\n    .leadership-block .title {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.leadership-block .mobile-swiper .dot-navigation {\n    margin-top: 48px;\n}\n\n.leadership-block .mobile-swiper-item {\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .leadership-block .mobile-swiper-item {\n        grid-column:span 4 / span 4;\n        margin-bottom: 0;\n        padding-left: 8px;\n        padding-right: 8px;\n    }\n\n    .leadership-block .mobile-swiper-item.hidden {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n        flex-direction: column;\n    }\n}\n\n@media (min-width: 1366px) {\n    .leadership-block .mobile-swiper-item {\n        grid-column:span 3 / span 3;\n    }\n}\n\n.leadership-block .mobile-swiper-item .base-page-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n}\n\n.leadership-block .mobile-swiper-item .leader-img {\n    margin-bottom: 16px;\n}\n\n.leadership-block .mobile-swiper-item .leader-img img {\n    border-radius: 8px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.leadership-block .mobile-swiper-item .leader-info {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.leadership-block .mobile-swiper-item .leader-info .leader-name {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 4px;\n}\n\n.leadership-block .mobile-swiper-item .leader-info .leader-title {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 24px;\n    line-height: 26px;\n    margin-bottom: 8px;\n}\n\n.leadership-block .mobile-swiper-item .leader-info .leader-description {\n    margin-bottom: 32px;\n}\n\n@media (min-width: 768px) {\n    .leadership-block .callout-row-wrapper {\n        grid-gap:16px;\n        gap: 16px;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        justify-items: center;\n    }\n}\n\n.leadership-block .callout-row-wrapper .leader-block {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    grid-column: span 6 / span 6;\n    margin-bottom: 8px;\n}\n\n@media (min-width: 768px) {\n    .leadership-block .callout-row-wrapper .leader-block {\n        grid-column:span 4 / span 4;\n        margin-bottom: 0;\n    }\n\n    .leadership-block .callout-row-wrapper .leader-block.hidden {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n        flex-direction: column;\n    }\n}\n\n@media (min-width: 1366px) {\n    .leadership-block .callout-row-wrapper .leader-block {\n        grid-column:span 3 / span 3;\n    }\n}\n\n.leadership-block .callout-row-wrapper .leader-block .leader-img {\n    margin-bottom: 16px;\n}\n\n.leadership-block .callout-row-wrapper .leader-block .leader-img img {\n    border-radius: 8px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.leadership-block .callout-row-wrapper .leader-block .leader-info {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n\n.leadership-block .callout-row-wrapper .leader-block .leader-info .leader-name {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 4px;\n}\n\n.leadership-block .callout-row-wrapper .leader-block .leader-info .leader-title {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 24px;\n    line-height: 26px;\n    margin-bottom: 8px;\n}\n\n.leadership-block .callout-row-wrapper .leader-block .leader-info .leader-description {\n    margin-bottom: 32px;\n}\n\n.leadership-block .leader-cta,.leadership-block .leader-cta > a,.leadership-block .leader-cta > button {\n    color: #6639b7;\n    color: rgba(102,57,183,var(--text-opacity));\n    display: block;\n\n    font-size: 24px;\n    height: auto;\n    position: relative;\n    text-align: left;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.leadership-block .leader-cta:before,.leadership-block .leader-cta > a:before,.leadership-block .leader-cta > button:before {\n    content: \"ïŒ‹\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    position: absolute;\n    right: -50px;\n}\n\n.leadership-block .leader-cta.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.leadership-block .leader-cta:after {\n    --bg-opacity: 1;\n    background-color: #6639b7;\n    background-color: rgba(102,57,183,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 5px;\n    opacity: 1;\n    position: relative;\n    width: 110%;\n    width: calc(100% + 50px);\n}\n\n@media (hover: hover) {\n    .leadership-block .leader-cta:hover:after {\n        opacity:0;\n        -webkit-transition: opacity 0.2s ease-in-out;\n        -o-transition: opacity 0.2s ease-in-out;\n        transition: opacity 0.2s ease-in-out;\n    }\n}\n\n.leadership-block .leader-cta,.leadership-block .leader-cta > a,.leadership-block .leader-cta > button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n}\n\n.leadership-block .leader-cta:after,.leadership-block .leader-cta > a:after,.leadership-block .leader-cta > button:after {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n}\n\n.leadership-block .leader-cta:before {\n    top: 6px;\n}\n\n@media (min-width: 768px) {\n    .leadership-block .leader-cta:before {\n        top:0;\n    }\n}\n\n.leadership-block .leader-cta a {\n    font-size: 16px;\n    line-height: 36px;\n}\n\n.leadership-block .leader-cta a:before {\n    display: none;\n}\n\n.leadership-block-cta {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    margin-top: 32px;\n}\n\n@media (min-width: 768px) {\n    .leadership-block-cta {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.leadership-block-cta a {\n    display: block !important;\n}\n\n.leadership-block .load-leaders {\n    grid-column: span 6 / span 6;\n    text-align: center;\n}\n\n.leadership-block .load-leaders button p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n}\n\n@media (min-width: 768px) {\n    .leadership-block .load-leaders {\n        display:none;\n    }\n}\n\n.leadership-block .swiper-buttons {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 60px;\n    justify-content: center;\n    left: 0;\n    margin-top: 48px;\n    position: relative;\n    top: unset;\n    width: 100%;\n}\n\n.leadership-block .swiper-buttons-backwards {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 2px solid #0098db;\n    height: 60px;\n    margin-bottom: 0;\n    margin-right: 12px;\n    position: relative;\n    width: 60px;\n}\n\n.leadership-block .swiper-buttons-backwards:before {\n    color: #003c69;\n    content: \"âŒ©\";\n    font-family: Font Awesome\\6 Pro;\n}\n\n.leadership-block .swiper-buttons-backwards i {\n    display: none;\n}\n\n.leadership-block .swiper-buttons-forwards {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border: 2px solid #0098db;\n    height: 60px;\n    margin-bottom: 0;\n    margin-left: 12px;\n    position: relative;\n    width: 60px;\n}\n\n.leadership-block .swiper-buttons-forwards:before {\n    color: #003c69;\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n}\n\n.leadership-block .swiper-buttons-forwards i {\n    display: none;\n}\n\n.news-category-chips.section-container {\n    padding: 0 0 64px;\n}\n\n.news-category-chips-title {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 36px;\n}\n\n.news-category-chips-wrapper {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n}\n\n@media (min-width: 768px) {\n    .news-category-chips-wrapper {\n        -webkit-box-pack:start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n    }\n}\n\n.news-category-chips-item {\n    border-style: none;\n    margin: 0 8px 8px 0;\n    padding: 0;\n}\n\n@media (min-width: 768px) {\n    .news-category-chips-item {\n        width:auto;\n    }\n}\n\n.news-category-chips-item a {\n    width: 100%;\n}\n\n.news-category-chips-item a,.news-category-chips-item a > a,.news-category-chips-item a > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 16px 32px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .news-category-chips-item a:hover,.news-category-chips-item a > a:hover,.news-category-chips-item a > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.news-category-chips-item a > a > span,.news-category-chips-item a > a i,.news-category-chips-item a > a svg,.news-category-chips-item a > button > span,.news-category-chips-item a > button i,.news-category-chips-item a > button svg,.news-category-chips-item a > span,.news-category-chips-item a i,.news-category-chips-item a svg {\n    display: inline;\n}\n\n.news-category-chips-item a > a svg,.news-category-chips-item a > button svg,.news-category-chips-item a svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.news-category-chips-item a:disabled,.news-category-chips-item a > a:disabled,.news-category-chips-item a > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .news-category-chips-item a:disabled:hover:disabled,.news-category-chips-item a > a:disabled:hover:disabled,.news-category-chips-item a > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.news-category-chips-item a.inverted,.news-category-chips-item a > a.inverted,.news-category-chips-item a > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .news-category-chips-item a.inverted:hover,.news-category-chips-item a > a.inverted:hover,.news-category-chips-item a > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.news-category-chips-item a.inverted:active,.news-category-chips-item a > a.inverted:active,.news-category-chips-item a > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.news-category-chips-item a.inverted:disabled,.news-category-chips-item a > a.inverted:disabled,.news-category-chips-item a > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .news-category-chips-item a.inverted:disabled:hover,.news-category-chips-item a > a.inverted:disabled:hover,.news-category-chips-item a > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.news-category-chips-item a.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n@media (min-width: 768px) {\n    .news-category-chips-item a {\n        width:auto;\n    }\n}\n\n.nurse-zone-wrapper {\n    background: transparent -o-linear-gradient(bottom,#f2f8fa 0,#fff 100%) 0 0 no-repeat padding-box;\n    background: transparent -webkit-gradient(linear,left bottom,left top,from(#f2f8fa),to(#fff)) 0 0 no-repeat padding-box;\n    background: transparent linear-gradient(1turn,#f2f8fa,#fff) 0 0 no-repeat padding-box;\n}\n\n.nurse-zone-wrapper .nurse-zone .title {\n   \n    line-height: 40px;\n    padding-bottom: 8px;\n    text-align: center;\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone .title {\n        line-height:56px;\n        padding-bottom: 16px;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-top-content p {\n    text-align: center;\n}\n\n.nurse-zone-wrapper .nurse-zone-bottom {\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-bottom {\n        padding-left:0;\n        padding-right: 0;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card:first-child .card-overline {\n    display: none;\n}\n\n.nurse-zone-wrapper .nurse-zone-card:first-child .card-image img {\n    border-radius: 0;\n    height: unset;\n    max-height: 272px;\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card:first-child .card-image img {\n        border-radius:8px;\n        min-height: 320px;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card:first-child .card-subtitle {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n    font-size: 24px;\n    line-height: 28px;\n    line-height: 32px;\n    padding-bottom: 8px;\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card:first-child .card-subtitle {\n        font-size:40px;\n        font-size: 24px;\n        line-height: 44px;\n        line-height: 32px;\n        padding-bottom: 16px;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .nurse-zone-card-body {\n    display: none;\n}\n\n@media (min-width: 768px) {\n    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .nurse-zone-card-body {\n        display:block;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-overline {\n    --text-opacity: 1;\n    color: #0098db;\n    color: rgba(0,152,219,var(--text-opacity));\n    font-size: 14px;\n    letter-spacing: 1.4px;\n    line-height: 14px;\n    line-height: 24px;\n    padding-bottom: 8px;\n    text-transform: uppercase;\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-overline {\n        font-size:16px;\n        letter-spacing: 1.6px;\n        line-height: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-overline {\n        display:none;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-image img {\n    border-radius: 0;\n    min-height: 130px;\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-image img {\n        border-radius:8px;\n        min-height: 320px;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-subtitle {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    font-size: 20px;\n    line-height: 24px;\n    line-height: 22px;\n    padding-bottom: 24px;\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card:not(:first-child) .card-subtitle {\n        -webkit-box-flex:unset;\n        -ms-flex-positive: unset;\n        flex-grow: unset;\n        font-size: 24px;\n        line-height: 32px;\n        padding-bottom: 16px;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card-body {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    margin-bottom: 24px;\n    padding-top: 0;\n}\n\n.nurse-zone-wrapper .nurse-zone-card-body > .rich-text {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.nurse-zone-wrapper .nurse-zone-card-body > .rich-text > p,.nurse-zone-wrapper .nurse-zone-card-body > p {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n}\n\n.nurse-zone-wrapper .nurse-zone-card-cta {\n    border: 2px solid #0094d9;\n    border-radius: 8px;\n    color: #0065c0 !important;\n    display: inline-block;\n   \n    font-size: 14px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    min-width: 144px;\n    padding: 10px 24px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .nurse-zone-wrapper .nurse-zone-card-cta:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card-cta > span,.nurse-zone-wrapper .nurse-zone-card-cta i,.nurse-zone-wrapper .nurse-zone-card-cta svg {\n    display: inline;\n}\n\n.nurse-zone-wrapper .nurse-zone-card-cta svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.nurse-zone-wrapper .nurse-zone-card-cta:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 8px;\n    position: relative;\n}\n\n@media (hover: hover) {\n    .nurse-zone-wrapper .nurse-zone-card-cta:hover {\n        background-color:#0094d9;\n        color: #fff !important;\n    }\n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card-cta {\n        margin-bottom:10px;\n    }\n\n    .nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-eyebrow,.nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-heading,.nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-image {\n        padding: 0;\n    }\n}\n\n.nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-heading.card-subtitle {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n}\n\n@media (min-width: 1366px) {\n    .nurse-zone-wrapper .nurse-zone-card .nurse-zone-card-body {\n        padding:0;\n    }\n}\n\n.cookie-banner {\n    grid-gap: 16px;\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    display: grid;\n    display: none;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    padding: 12px;\n}\n\n@media (min-width: 1366px) {\n    .cookie-banner {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n        padding: 12px 24px;\n    }\n}\n\n.cookie-banner-content {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 1366px) {\n    .cookie-banner-content {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.cookie-banner-content .rich-text {\n    margin: 0;\n    padding: 0 0 16px;\n}\n\n.cookie-banner-content .rich-text p {\n    font-size: 14px;\n    line-height: 24px;\n    text-align: center;\n}\n\n.cookie-banner-content-close {\n    padding: 0;\n}\n\n.promo-callout {\n    --bg-opacity: 1;\n    background-image: linear-gradient(53deg, #1383c6, #63bd46) !important;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    padding-bottom: 32px;\n}\n\n.promo-callout-media {\n    grid-column: span 6 / span 6;\n    min-height: 150px;\n    min-width: 150px;\n}\n\n@media (min-width: 768px) {\n    .promo-callout-media {\n        grid-column:span 12 / span 12;\n        min-height: 350px;\n        padding: 0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout-media {\n        align-self:center;\n        grid-column: span 6 / span 6;\n    }\n}\n\n.promo-callout-media-wrapper img {\n    height: 100%;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .promo-callout-media-wrapper .video-wrapper {\n        padding-bottom:0;\n        padding-top: 0;\n    }\n}\n\n.promo-callout-media-wrapper .video-wrapper .video-youtube {\n    margin-bottom: 0;\n}\n\n.promo-callout-media-wrapper .video-wrapper .video-youtube img {\n    height: 100%;\n    top: 0;\n    width: 100%;\n}\n\n.promo-callout-content {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .promo-callout-content {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout-content {\n        align-self:center;\n        grid-column: span 6 / span 6;\n        margin-left: 16px;\n        margin-right: 16px;\n        padding-right: 16px;\n        padding-top: 0;\n    }\n}\n\n.promo-callout-content p {\n    max-width: unset;\n}\n\n.promo-callout-content-cta {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    cursor: pointer;\n    justify-content: flex-start;\n    padding-bottom: 16px;\n}\n\n.promo-callout-content-cta .wrapper {\n    --text-opacity: 1;\n    color: #6639b7;\n    color: rgba(102,57,183,var(--text-opacity));\n}\n\n.promo-callout-content-cta div {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    max-width: 310px;\n    min-width: unset !important;\n    position: relative;\n}\n\n.promo-callout-content-cta a {\n    all: unset !important;\n    color: #6639b7 !important;\n    font-size: 24px !important;\n    line-height: 40px !important;\n    text-align: left !important;\n}\n\n.promo-callout-content-cta a,.promo-callout-content-cta a > a,.promo-callout-content-cta a > button {\n    --text-opacity: 1;\n    color: #6639b7;\n    color: rgba(102,57,183,var(--text-opacity));\n    display: block;\n\n    font-size: 24px;\n    height: auto;\n    position: relative;\n    text-align: left;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.promo-callout-content-cta a:before,.promo-callout-content-cta a > a:before,.promo-callout-content-cta a > button:before {\n    content: \"ïŒ‹\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    position: absolute;\n    right: -50px;\n}\n\n.promo-callout-content-cta a.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n.promo-callout-content-cta a:after {\n    --bg-opacity: 1;\n    background-color: #6639b7;\n    background-color: rgba(102,57,183,var(--bg-opacity));\n    content: \"\";\n    display: block;\n    height: 5px;\n    opacity: 1;\n    position: relative;\n    width: 110%;\n}\n\n@media (hover: hover) {\n    .promo-callout-content-cta a:hover:after {\n        opacity:0;\n        -webkit-transition: opacity 0.2s ease-in-out;\n        -o-transition: opacity 0.2s ease-in-out;\n        transition: opacity 0.2s ease-in-out;\n    }\n}\n\n.promo-callout-content-cta a:before {\n    right: -50px;\n}\n\n.promo-callout-content-cta a:after {\n    width: calc(100% + 50px);\n}\n\n.promo-callout-content .rich-text {\n    padding: 0;\n}\n\n.promo-callout-content .rich-text ul {\n    padding-left: 0;\n}\n\n@media (min-width: 1366px) {\n    .promo-callout-content .rich-text p {\n        margin-right:16px;\n    }\n}\n\n.promo-callout-content h3 {\n    text-align: left !important;\n}\n\n.promo-callout .callout-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-top: 8px;\n}\n\n.promo-callout .callout-container .callout-set {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-bottom: 24px;\n    margin-right: 32px;\n}\n\n.promo-callout .callout-container .callout-set-image {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    margin-right: 12px;\n    max-height: 62px;\n    max-width: 62px;\n    min-height: 62px;\n    min-width: 62px;\n}\n\n.promo-callout .callout-container .callout-set-image img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.promo-callout .callout-container .callout-set-image.stat-callout {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 50%;\n}\n\n.promo-callout .callout-container .callout-set-image.stat-callout img,.promo-callout .callout-container .callout-set-image.stat-callout svg {\n    fill: #fff;\n    height: auto;\n    width: 66%;\n}\n\n.promo-callout .callout-container .callout-set-image.stat-callout img path,.promo-callout .callout-container .callout-set-image.stat-callout svg path {\n    fill: #fff;\n}\n\n.promo-callout .callout-container .callout-set-image.stat-callout img stop,.promo-callout .callout-container .callout-set-image.stat-callout svg stop {\n    stop-color: #fff !important;\n}\n\n.promo-callout .callout-container .callout-set-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    justify-content: flex-end;\n}\n\n.promo-callout .callout-container .callout-set-content h5 {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n}\n\n.promo-callout .callout-container .callout-set-content p {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    font-size: 14px;\n    line-height: 20px;\n    line-height: 30px;\n}\n\n.promo-callout .callout-container .callout-tag {\n    margin-bottom: 8px;\n    margin-right: 8px;\n}\n\n.promo-callout .callout-container .callout-tag,.promo-callout .callout-container .callout-tag > a,.promo-callout .callout-container .callout-tag > button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 14px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    padding: 10px 24px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .promo-callout .callout-container .callout-tag:hover,.promo-callout .callout-container .callout-tag > a:hover,.promo-callout .callout-container .callout-tag > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.promo-callout .callout-container .callout-tag > a > span,.promo-callout .callout-container .callout-tag > a i,.promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button > span,.promo-callout .callout-container .callout-tag > button i,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag > span,.promo-callout .callout-container .callout-tag i,.promo-callout .callout-container .callout-tag svg {\n    display: inline;\n}\n\n.promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.promo-callout .callout-container .callout-tag:disabled,.promo-callout .callout-container .callout-tag > a:disabled,.promo-callout .callout-container .callout-tag > button:disabled {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #ddd;\n    background-color: rgba(221,221,221,var(--bg-opacity));\n    color: #979797;\n    color: rgba(151,151,151,var(--text-opacity));\n    cursor: not-allowed;\n}\n\n@media (hover: hover) {\n    .promo-callout .callout-container .callout-tag:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > a:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n.promo-callout .callout-container .callout-tag.inverted,.promo-callout .callout-container .callout-tag > a.inverted,.promo-callout .callout-container .callout-tag > button.inverted {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #002146;\n    color: rgba(0,33,70,var(--text-opacity));\n}\n\n@media (hover: hover) {\n    .promo-callout .callout-container .callout-tag.inverted:hover,.promo-callout .callout-container .callout-tag > a.inverted:hover,.promo-callout .callout-container .callout-tag > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n.promo-callout .callout-container .callout-tag.inverted:active,.promo-callout .callout-container .callout-tag > a.inverted:active,.promo-callout .callout-container .callout-tag > button.inverted:active {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #2257b8;\n    background-color: rgba(34,87,184,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.promo-callout .callout-container .callout-tag.inverted:disabled,.promo-callout .callout-container .callout-tag > a.inverted:disabled,.promo-callout .callout-container .callout-tag > button.inverted:disabled {\n    --bg-opacity: 1;\n    background-color: #979797;\n    background-color: rgba(151,151,151,var(--bg-opacity));\n    color: rgba(255,255,255,0.75);\n}\n\n@media (hover: hover) {\n    .promo-callout .callout-container .callout-tag.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > a.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n.promo-callout .callout-container .callout-tag.wrapper {\n    background-color: transparent;\n    margin: 0;\n    padding: 0;\n}\n\n@media (min-width: 768px) {\n    .promo-callout .callout-container .callout-tag {\n        margin-bottom:16px;\n        margin-right: 16px;\n    }\n\n    .promo-callout .callout-container .callout-tag,.promo-callout .callout-container .callout-tag > a,.promo-callout .callout-container .callout-tag > button {\n        --bg-opacity: 1;\n        --text-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        border-radius: 8px;\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        display: inline-block;\n       \n        font-size: 16px;\n        height: auto;\n        letter-spacing: 0.16px;\n        line-height: 20px;\n        line-height: 24px;\n        padding: 16px 32px;\n        text-align: center;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (min-width: 768px) and (hover:hover) {\n    .promo-callout .callout-container .callout-tag:hover,.promo-callout .callout-container .callout-tag > a:hover,.promo-callout .callout-container .callout-tag > button:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .callout-container .callout-tag > a > span,.promo-callout .callout-container .callout-tag > a i,.promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button > span,.promo-callout .callout-container .callout-tag > button i,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag > span,.promo-callout .callout-container .callout-tag i,.promo-callout .callout-container .callout-tag svg {\n        display:inline;\n    }\n\n    .promo-callout .callout-container .callout-tag > a svg,.promo-callout .callout-container .callout-tag > button svg,.promo-callout .callout-container .callout-tag svg {\n        fill: #fff;\n        height: 20px;\n        margin-right: 4px;\n        -webkit-transform: translateY(-2.5px);\n        -ms-transform: translateY(-2.5px);\n        transform: translateY(-2.5px);\n        width: 20px;\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .callout-container .callout-tag:disabled,.promo-callout .callout-container .callout-tag > a:disabled,.promo-callout .callout-container .callout-tag > button:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n@media (min-width: 768px) and (hover:hover) {\n    .promo-callout .callout-container .callout-tag:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > a:disabled:hover:disabled,.promo-callout .callout-container .callout-tag > button:disabled:hover:disabled {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #ddd;\n        background-color: rgba(221,221,221,var(--bg-opacity));\n        color: #979797;\n        color: rgba(151,151,151,var(--text-opacity));\n        cursor: not-allowed;\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .callout-container .callout-tag.inverted,.promo-callout .callout-container .callout-tag > a.inverted,.promo-callout .callout-container .callout-tag > button.inverted {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        color: #002146;\n        color: rgba(0,33,70,var(--text-opacity));\n    }\n}\n\n@media (min-width: 768px) and (hover:hover) {\n    .promo-callout .callout-container .callout-tag.inverted:hover,.promo-callout .callout-container .callout-tag > a.inverted:hover,.promo-callout .callout-container .callout-tag > button.inverted:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #1765f4;\n        background-color: rgba(23,101,244,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .callout-container .callout-tag.inverted:active,.promo-callout .callout-container .callout-tag > a.inverted:active,.promo-callout .callout-container .callout-tag > button.inverted:active {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #2257b8;\n        background-color: rgba(34,87,184,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .callout-container .callout-tag.inverted:disabled,.promo-callout .callout-container .callout-tag > a.inverted:disabled,.promo-callout .callout-container .callout-tag > button.inverted:disabled {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n@media (min-width: 768px) and (hover:hover) {\n    .promo-callout .callout-container .callout-tag.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > a.inverted:disabled:hover,.promo-callout .callout-container .callout-tag > button.inverted:disabled:hover {\n        --bg-opacity:1;\n        background-color: #979797;\n        background-color: rgba(151,151,151,var(--bg-opacity));\n        color: rgba(255,255,255,0.75);\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .callout-container .callout-tag.wrapper {\n        background-color:transparent;\n        margin: 0;\n        padding: 0;\n    }\n}\n\n.promo-callout .callout-container-icon {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: center;\n    padding: 10px 0;\n}\n\n.promo-callout .callout-container .tile {\n    font-size: 14px;\n    height: 154px;\n    line-height: 20px;\n    padding-left: 10px;\n    padding-right: 10px;\n    width: 160px;\n}\n\n@media (max-width: 767px) {\n    .promo-callout .callout-container .tile {\n        font-size:12px;\n        height: 128px;\n        line-height: 18px;\n        width: 112px;\n    }\n\n    .promo-callout .callout-container .tile img {\n        width: 40%;\n    }\n}\n\n.promo-callout .promo-blockquote-content .promo-callout-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    align-self: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    grid-column: span 6 / span 6;\n    margin-left: 0;\n}\n\n.promo-callout .promo-blockquote-content .promo-callout-content-cta {\n    max-width: 253px;\n}\n\n@media (min-width: 1366px) {\n    .promo-callout .promo-blockquote-content .promo-callout-media {\n        padding-right:16px;\n    }\n}\n\n.promo-callout .promo-blockquote-content .promo-callout-media-wrapper img {\n    height: 100%;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .promo-callout .promo-blockquote-content .promo-callout-media {\n        grid-column:7/13;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout .promo-blockquote-content .promo-callout-media {\n        grid-column:7/13;\n    }\n}\n\n.promo-callout .promo-blockquote-content blockquote {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 32px;\n    font-style: italic;\n    line-height: 40px;\n    padding-bottom: 32px;\n}\n\n.promo-callout .reverse-promo {\n    grid-auto-flow: unset;\n}\n\n@media (min-width: 1366px) {\n    .promo-callout .reverse-promo {\n        grid-auto-flow:column;\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .reverse-promo .promo-callout-media {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout .reverse-promo .promo-callout-media {\n        grid-column:7/13;\n        padding-right: 16px;\n    }\n}\n\n@media (min-width: 768px) {\n    .promo-callout .reverse-promo .promo-callout-content {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .promo-callout .reverse-promo .promo-callout-content {\n        grid-column:1/7;\n        padding-right: 16px;\n    }\n}\n\n.attr-name {\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 18px;\n}\n\n.attr-name,.attr-title {\n    --text-opacity: 1;\n    line-height: 24px;\n}\n\n.attr-title {\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    font-size: 16px;\n}\n\n.attr-blockquote {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    font-size: 32px;\n    font-style: italic;\n    line-height: 40px;\n    padding-bottom: 32px;\n}\n\n.site-search-results-list .search-result {\n    grid-gap: 16px;\n    grid-row-gap: 0;\n    border-top: 1px solid #d1d1d1;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    padding-bottom: 32px;\n    padding-top: 32px;\n    row-gap: 0;\n}\n\n.site-search-results-list .search-result:last-child {\n    border-bottom: 1px solid #d1d1d1;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n    }\n}\n\n.site-search-results-list .search-result .result-title {\n    font-size: 24px;\n    grid-column: span 6 / span 6;\n    line-height: 30px;\n    margin-bottom: 16px;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result .result-title {\n        font-size:22px;\n        grid-column: span 12 / span 12;\n        line-height: 32px;\n    }\n}\n\n.site-search-results-list .search-result .result-description {\n    grid-column: span 6 / span 6;\n    margin-bottom: 14px;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result .result-description {\n        grid-column:span 12 / span 12;\n        margin-bottom: 16px;\n    }\n}\n\n.site-search-results-list .search-result .result-link {\n    --text-opacity: 1;\n    word-wrap: anywhere;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 16px;\n    grid-column: span 6 / span 6;\n    line-height: 24px;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result .result-link {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.site-search-results-list .search-result .result-img {\n    grid-column: span 6 / span 6;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.site-search-results-list .search-result .result-img img {\n    border-radius: 8px;\n    margin-bottom: 24px;\n    max-height: 200px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result .result-img {\n        grid-column:span 3 / span 3;\n        max-height: 180px;\n    }\n}\n\n.site-search-results-list .search-result .superheader {\n   \n    font-size: 16px;\n    grid-column: span 6 / span 6;\n    line-height: 24px;\n    margin-bottom: 8px;\n}\n\n.site-search-results-list .search-result .superheader span:first-child {\n    border-right: 2px solid;\n    padding-right: 8px;\n}\n\n.site-search-results-list .search-result .superheader span:last-child {\n    padding-left: 8px;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result .superheader {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.site-search-results-list .search-result .content {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result .content {\n        -webkit-box-orient:vertical;\n        -webkit-box-direction: normal;\n        align-self: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: column;\n        flex-direction: column;\n        grid-column: span 8 / span 8;\n    }\n}\n\n.site-search-results-list .search-result .content pre {\n    white-space: pre-line;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result.article .result-title {\n        font-size:24px;\n        line-height: 36px;\n        margin-bottom: 8px;\n    }\n}\n\n.site-search-results-list .search-result.article .result-description {\n    margin-bottom: 24px;\n}\n\n@media (min-width: 1366px) {\n    .site-search-results-list .search-result.article .result-description {\n        margin-bottom:16px;\n    }\n\n    .site-search-results-list .search-result.page {\n        padding-bottom: 52px;\n    }\n}\n\n.search-form input[type=\"search\"],.search-form input[type=\"text\"] {\n    border: 1px solid #c4c4c4;\n    border-radius: 8px;\n    border-right: none;\n    height: 100%;\n}\n\n.corp-search {\n    margin-top: 20px;\n    position: relative;\n}\n\n.corp-search.section-container {\n    padding-bottom: 0;\n}\n\n.corp-search-form {\n    height: 80px;\n    max-width: 1000px;\n    position: relative;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .corp-search-form {\n        width:66%;\n    }\n}\n\n.corp-search-form-input {\n    font-size: 26px;\n    height: 100%;\n    padding-left: 8px;\n    padding-right: 8px;\n    width: 80%;\n}\n\n@media (min-width: 768px) {\n    .corp-search-form-input {\n        width:90%;\n    }\n}\n\n.corp-search-title {\n    margin-bottom: 16px;\n}\n\n.corp-search-button {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border: 2px solid #005bbb;\n    border-bottom-right-radius: 8px;\n    border-top-right-radius: 8px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    width: 20%;\n}\n\n@media (min-width: 768px) {\n    .corp-search-button {\n        width:10%;\n    }\n}\n\n.corp-search-button:before {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    font-size: 24px;\n}\n\n.corp-search .search-primary {\n    margin-bottom: 16px;\n}\n\n.corp-search-amount {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.corp-search-amount > p {\n    padding-top: 32px;\n}\n\n.corp-search-amount-number {\n    font-weight: 700;\n    padding-right: 8px;\n}\n\n.rich-text {\n    word-wrap: anywhere;\n}\n\n.rich-text .frame-legacy .caption {\n    border: 1px solid #e2e2e2;\n    color: #444;\n    font-size: 12px;\n    max-width: 166px;\n    padding: 8px 8px 16px;\n    text-align: left;\n}\n\n.rich-text .frame-legacy .caption IMG {\n    padding-bottom: 8px;\n}\n\n.rich-text .frame-left {\n    float: left;\n    padding-right: 20px;\n}\n\n.rich-text .frame-right {\n    float: right;\n    padding-left: 20px;\n}\n\n.rich-text ul {\n    padding-left: 28px;\n}\n\n.rich-text ul li {\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.rich-text ul li:before {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    content: \"ï˜\";\n    display: inline-block;\n    font-size: 20px;\n    font-style: normal;\n    font-variant: normal;\n    font-weight: 400;\n    left: -8px;\n    line-height: 1;\n    line-height: 21px;\n    margin-left: 8px;\n    margin-top: 2px;\n    position: relative;\n}\n\n.see-country {\n    background: none;\n}\n\n.see-country .card-carousel-btn {\n    z-index: 1;\n}\n\n.see-country .card-carousel-btn svg {\n    fill: #003c69;\n}\n\n.city-card-background img {\n    border-radius: 4px;\n}\n\n.city-card-content-heading {\n    margin-top: 32px;\n}\n\n.city-card-content-heading > p {\n   \n    font-size: 40px;\n    line-height: 48px;\n}\n\n.city-card-content-cta,.city-card-content > a {\n    bottom: 32px;\n    font-size: 16px !important;\n    left: 0;\n    padding: 0 40px;\n}\n\n@media (min-width: 1366px) {\n    .city-card-content-cta,.city-card-content > a {\n        bottom:32px;\n    }\n}\n\n.city-card-content-cta a {\n    background-color: #005bbb !important;\n    color: #fff !important;\n    font-size: 16px;\n}\n\n.city-card-content-cta a:hover {\n    background-color: #1765f4 !important;\n}\n\n.testimonial-slide {\n    height: 100%;\n}\n\n.testimonial-block--card-swiper .mobile-swiper-slide {\n    margin-left: 8px;\n    margin-right: 8px;\n}\n\n.testimonial-block--card-swiper .mobile-swiper-item {\n    height: 100%;\n    width: 100%;\n}\n\n.testimonial-block--card-swiper .mobile-swiper-item > div,.testimonial-block--card .testimonial-slide > div {\n    height: 100%;\n}\n\n.testimonial-block--card .testimonial-slide-content {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    height: 100%;\n    justify-content: center;\n    padding-bottom: 40px;\n    padding-top: 40px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card .testimonial-slide-content {\n        margin-left:0;\n        margin-right: 0;\n        padding: 40px 80px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card .testimonial-slide-content {\n        margin-left:0;\n        margin-right: 0;\n        padding: 83px 114px 82px;\n    }\n}\n\n.testimonial-block--card .testimonial-slide-content-cta {\n    display: none;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    align-items: flex-start;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-profile {\n    display: none;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation .flex {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-name {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n\n   \n   \n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 4px;\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card .testimonial-slide-content .block-quote-citation-name {\n        font-size:20px;\n        line-height: 24px;\n    }\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card .testimonial-slide-content .block-quote-citation-name {\n        line-height:26px;\n    }\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-role {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 14px;\n    line-height: 24px;\n    margin-bottom: 4px;\n}\n\n.testimonial-block--card .testimonial-slide-content .block-quote-citation-position {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n    display: block;\n   \n    font-size: 14px;\n    line-height: 24px;\n}\n\n.testimonial-block--card .testimonial-slide-content .card-quote {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    font-size: 16px;\n    height: auto;\n    line-height: 24px;\n    order: 1;\n    padding-bottom: 8px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block--card .testimonial-slide-content .card-quote {\n        margin-left:0;\n        padding-bottom: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card .testimonial-slide-content .card-quote {\n        height:auto;\n        padding-bottom: 24px;\n    }\n\n    .testimonial-block--card-swiper {\n        grid-column: 7/13 !important;\n    }\n}\n\n.testimonial-block--card-swiper .swiper-buttons {\n    display: none;\n}\n\n.testimonial-block--card-swiper .dot-navigation {\n    margin-top: 32px;\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block--card-swiper .dot-navigation {\n        line-height:16px;\n        margin-top: 33px;\n        text-align: center;\n    }\n}\n\n.testimonial-block {\n    padding-bottom: 0;\n}\n\n.testimonial-block.testimonial-block--card .testimonial-block-container {\n    padding-bottom: 31px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block.testimonial-block--card .testimonial-block-container {\n        padding-top:67px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block.testimonial-block--card .testimonial-block-container {\n        padding-top:67px;\n    }\n}\n\n.testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {\n\n    margin-bottom: 0;\n}\n\n@media (min-width: 1366px) {\n    .testimonial-block.testimonial-block--card .testimonial-block-container .testimonial-block-heading {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        font-size: 72px;\n        height: 100%;\n        justify-content: center;\n        left: 191px;\n        line-height: 48px;\n        line-height: 80px;\n        max-width: 25%;\n        padding-bottom: 0;\n        position: absolute;\n        top: 0;\n    }\n}\n\n.testimonial-block.testimonial-block--card .dot-navigation {\n    margin-top: 33px;\n}\n\n@media (min-width: 768px) {\n    .testimonial-block.testimonial-block--card .dot-navigation {\n        display:block;\n        text-align: center;\n    }\n}\n\n.testimonial-block.testimonial-block--card .dot-navigation-btn {\n    background-color: transparent;\n}\n\n.testimonial-block.testimonial-block--card .dot-navigation-btn.active {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n}\n\n.trending-news {\n    grid-gap: 16px;\n    grid-row-gap: 0;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    padding-left: 0;\n    padding-right: 0;\n    row-gap: 0;\n}\n\n@media (min-width: 768px) {\n    .trending-news {\n        grid-gap:16px;\n        gap: 16px;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        margin-left: 12px;\n        margin-right: 12px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news {\n        grid-template-columns:repeat(4,minmax(0,1fr));\n        margin: 0;\n    }\n}\n\n.trending-news-title {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n   \n    font-size: 24px;\n    grid-column: span 6 / span 6;\n    line-height: 30px;\n    line-height: 24px;\n    margin-bottom: 12px;\n}\n\n@media (min-width: 768px) {\n    .trending-news-title {\n        grid-column:span 12 / span 12;\n        margin-bottom: 16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news-title {\n        grid-column:span 4 / span 4;\n    }\n}\n\n.trending-news-item {\n    border-bottom: 1px solid #e2e2e2;\n    grid-column: span 6 / span 6;\n    padding-bottom: 24px;\n    padding-top: 0;\n}\n\n.trending-news-item:not(:first-of-type) {\n    padding-top: 24px;\n}\n\n@media (min-width: 768px) {\n    .trending-news-item:not(:first-of-type) {\n        padding-top:32px;\n    }\n}\n\n@media (min-width: 768px) {\n    .trending-news-item {\n        grid-column:span 12 / span 12;\n        padding-bottom: 48px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news-item {\n        grid-column:span 4 / span 4;\n    }\n}\n\n.trending-news-item-image {\n    display: none;\n}\n\n.trending-news-item-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .trending-news-item-content {\n        grid-column:span 12 / span 12 !important;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news-item-content {\n        grid-column:span 4 / span 4 !important;\n    }\n}\n\n.trending-news-item-content .meta-wrapper {\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    align-items: baseline;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    order: 2;\n}\n\n.trending-news-item-content-category {\n    border: 2px solid #0098db;\n    border-radius: 8px;\n    color: #005bbb !important;\n    display: inline-block;\n   \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 6px 16px;\n    text-align: center;\n    text-transform: capitalize;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .trending-news-item-content-category:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.trending-news-item-content-category > span,.trending-news-item-content-category i,.trending-news-item-content-category svg {\n    display: inline;\n}\n\n.trending-news-item-content-category svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .trending-news-item-content-category:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        color: #fff !important;\n    }\n}\n\n.trending-news-item-content-seperator {\n    display: none;\n}\n\n.trending-news-item-content-date {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n    font-size: 14px;\n    line-height: 20px;\n    margin: 0;\n    padding-left: 12px;\n    text-transform: lowercase;\n}\n\n.trending-news-item-content-date:first-letter {\n    text-transform: capitalize;\n}\n\n.trending-news-item-content-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 32px;\n    margin-bottom: 4px;\n}\n\n@media (min-width: 768px) {\n    .trending-news-item-content-title {\n        margin-bottom:8px;\n    }\n}\n\n.trending-news-item-content-summary {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 14px;\n    line-height: 24px;\n    margin-bottom: 4px;\n}\n\n@media (min-width: 768px) {\n    .trending-news-item-content-summary {\n        margin-bottom:16px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .trending-news-item-content-summary {\n        margin-bottom:16px;\n    }\n}\n\n.pagination {\n    -webkit-box-pack: space-evenly;\n    -ms-flex-pack: space-evenly;\n    justify-content: space-evenly;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .pagination {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        width: unset;\n    }\n}\n\n.pagination-list {\n    -webkit-box-pack: space-evenly;\n    -ms-flex-pack: space-evenly;\n    justify-content: space-evenly;\n    width: 100%;\n}\n\n@media (min-width: 768px) {\n    .pagination-list {\n        -webkit-box-pack:center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        width: unset;\n    }\n}\n\n.pagination-btn {\n    --text-opacity: 1;\n    border: none;\n    border-radius: 4px;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    font-size: 16px;\n    line-height: 24px;\n    margin: 0;\n    min-width: unset;\n    width: 24px;\n}\n\n@media (min-width: 768px) {\n    .pagination-btn {\n        margin-right:16px;\n    }\n}\n\n.pagination-btn.active {\n    --text-opacity: 1;\n    background-color: #003c69 !important;\n    border: none !important;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.pagination-nav-btn {\n    padding: 0;\n}\n\n@media (min-width: 768px) {\n    .pagination-nav-btn {\n        padding-left:16px;\n    }\n}\n\n.pagination-nav-btn:before {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n}\n\n.pagination-nav-btn svg {\n    display: none;\n}\n\n.pagination-nav-btn:first-of-type {\n    margin: 0;\n    padding: 0;\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n@media (min-width: 768px) {\n    .pagination-nav-btn:first-of-type {\n        padding-left:32px;\n    }\n}\n\n.video-wrapper {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n}\n\n@media (min-width: 768px) {\n    .video-wrapper {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n    }\n}\n\n.video-wrapper .video-youtube {\n    border-radius: 8px;\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .video-wrapper .video-youtube {\n        grid-column:span 12 / span 12;\n    }\n}\n\n.video-wrapper .video-youtube img {\n    opacity: 1;\n}\n\n.video-wrapper .video-youtube-button {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: transparent;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 100%;\n    justify-content: center;\n    left: 0;\n    opacity: 1;\n    position: absolute;\n    top: 0;\n    -webkit-transform: unset;\n    -ms-transform: unset;\n    transform: unset;\n    width: 100%;\n    z-index: 1;\n}\n\n.video-wrapper .video-youtube-button:before {\n    --text-opacity: 1;\n    border: none;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    content: \"ï…„\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 60px;\n    font-weight: 900;\n    left: unset;\n    top: unset;\n    -webkit-transform: unset;\n    -ms-transform: unset;\n    transform: unset;\n}\n\n@media (min-width: 1366px) {\n    .video-wrapper .video-youtube-button:before {\n        font-size:140px;\n    }\n}\n\n.video-wrapper .video-youtube-button:hover {\n    background-color: transparent;\n}\n\n.header-wrapper {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    position: relative;\n    z-index: 3;\n}\n\n@media (min-width: 1366px) {\n    .header-wrapper {\n        margin:0 auto;\n        max-width: 1328px;\n        padding: 0;\n    }\n}\n\n.header .brand {\n    display: none;\n    height: 61px;\n}\n\n@media (min-width: 1366px) {\n    .header .brand {\n        display:block;\n    }\n\n    .header .brand img {\n        max-height: 50px;\n        width: auto;\n    }\n}\n\n.header-nav-utility {\n    --bg-opacity: 1;\n    background-color: #dde6ed;\n    background-color: rgba(221,230,237,var(--bg-opacity));\n    display: grid;\n    height: 32px;\n    position: relative;\n}\n\n@media (min-width: 1366px) {\n    .header-nav-utility {\n        --bg-opacity:1;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        height: 76px;\n        justify-content: flex-start;\n    }\n}\n\n.header-nav-utility-row {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    justify-content: flex-start;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .header-nav-utility-row {\n        -webkit-box-pack:start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n        width: unset;\n    }\n\n    .header-nav-utility-row:last-of-type {\n        -webkit-box-pack: end;\n        -ms-flex-pack: end;\n        justify-content: flex-end;\n        width: unset;\n    }\n}\n\n.header-nav-utility-row .brand {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 61px;\n    justify-content: flex-start;\n}\n\n.header-nav-utility-row .brand img,.header-nav-utility-row .brand svg {\n    height: 100%;\n    width: auto;\n}\n\n@-moz-document url-prefix() {\n    .header-nav-utility-row .brand svg {\n        width: auto;\n    }\n}\n\n.utility-nav-item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.utility-nav-item > div > a.utility-nav-item-link div:not(.flex),.utility-nav-item > div > a.utility-nav-item-link div > a,.utility-nav-item > div > a.utility-nav-item-link div button {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: block;\n   \n    font-size: 16px;\n    line-height: 22px;\n    position: relative;\n    text-decoration: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.utility-nav-item > div > a.utility-nav-item-link div:not(.flex):before,.utility-nav-item > div > a.utility-nav-item-link div > a:before,.utility-nav-item > div > a.utility-nav-item-link div button:before {\n    --bg-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 1.5px;\n    opacity: 0;\n    position: absolute;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n    width: 100%;\n}\n\n.utility-nav-item > div > a.utility-nav-item-link div:not(.flex):after,.utility-nav-item > div > a.utility-nav-item-link div > a:after,.utility-nav-item > div > a.utility-nav-item-link div button:after {\n    display: none;\n}\n\n@media (hover: hover) {\n    .utility-nav-item > div > a.utility-nav-item-link div:not(.flex):hover,.utility-nav-item > div > a.utility-nav-item-link div > a:hover,.utility-nav-item > div > a.utility-nav-item-link div button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .utility-nav-item > div > a.utility-nav-item-link div:not(.flex):hover:before,.utility-nav-item > div > a.utility-nav-item-link div > a:hover:before,.utility-nav-item > div > a.utility-nav-item-link div button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.utility-nav-item > div > a.utility-nav-item-link div:not(.flex).wrapper:after,.utility-nav-item > div > a.utility-nav-item-link div > a.wrapper:after,.utility-nav-item > div > a.utility-nav-item-link div button.wrapper:after {\n    width: 0;\n}\n\n.utility-nav-item > div > a.utility-nav-item-link div.inline {\n    display: inline-block;\n}\n\n.utility-nav-item-link {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.utility-nav-item-link-icon {\n    display: none;\n}\n\n.utility-nav-item-link-icon svg {\n    fill: #2257b8;\n    height: 20px;\n    width: 20px;\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link-icon svg {\n        height:28px;\n        margin-right: 15px;\n        width: 28px;\n    }\n}\n\n.utility-nav-item-link-lead {\n    --text-opacity: 1;\n    color: #008b95;\n    color: rgba(0,139,149,var(--text-opacity));\n   \n    font-size: 10px;\n    line-height: 10px;\n    margin-right: 15px;\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link-lead {\n        font-size:12px;\n        margin: 0;\n    }\n}\n\n.utility-nav-item-link-content {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 15px;\n    line-height: 24px;\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link-content {\n        font-family:Helvetica Now Display Medium;\n    }\n}\n\n.utility-nav-item-link-phone {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 18px;\n    line-height: 24px;\n}\n\n.utility-nav-item-link:not(.hide-small) {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    padding-right: 15px;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link:not(.hide-small) {\n        padding-right:30px;\n        width: auto;\n    }\n}\n\n@media (min-width: 1366px) {\n    .utility-nav-item-link {\n        -webkit-box-align:center;\n        -ms-flex-align: center;\n        align-items: center;\n        border: none;\n        height: 100%;\n        margin-right: 20px;\n        position: relative;\n    }\n\n    .utility-nav-item-link:not(:last-of-type):after {\n        background: #75787b;\n        border-radius: 5px;\n        content: \"\";\n        height: 100%;\n        opacity: 0.15;\n        position: absolute;\n        right: -30px;\n        top: 0;\n        width: 2px;\n    }\n\n    .utility-nav-item-link-icon,.utility-nav-item-link-lead {\n        display: block;\n    }\n}\n\n@media (max-width: 1365px) {\n    .utility-nav-item > div {\n        display:none;\n    }\n\n    .utility-nav-item div:first-of-type {\n        display: block;\n    }\n}\n\n.utility-nav-item .aboutDropdown {\n    display: none;\n}\n\n.utility-nav-item .utility-nav-item-link {\n    cursor: pointer;\n    padding: 16px 20px 16px 24px;\n}\n\n.utility-nav-item .aboutMenu-open .aboutDropdown,.utility-nav-item .aboutMenu-open .utility-nav-item-link:first-child {\n    --bg-opacity: 1;\n    background-color: #f2fafe;\n    background-color: rgba(242,250,254,var(--bg-opacity));\n}\n\n.utility-nav-item .aboutMenu-open .aboutDropdown {\n    -webkit-box-shadow: 0 10px 10px rgba(0,0,0,0.10196);\n    box-shadow: 0 10px 10px rgba(0,0,0,0.10196);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    left: 0;\n    padding: 16px 16px 24px;\n    position: absolute;\n    top: 56px;\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n}\n\n.utility-nav-item .aboutMenu-open .aboutDropdown .dropdownLink {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    cursor: pointer;\n    margin: 8px;\n    max-width: 400px;\n    text-align: left;\n}\n\n.utility-search {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    height: 40px;\n    padding: 0;\n    position: relative;\n    width: 208px;\n}\n\n.utility-search input[type=\"search\"],.utility-search input[type=\"text\"] {\n    padding-left: 4px;\n}\n\n.utility-search-button {\n    --bg-opacity: 1;\n    --text-opacity: 1;\n    background-color: #005bbb;\n    background-color: rgba(0,91,187,var(--bg-opacity));\n    border-bottom-right-radius: 8px;\n    border-left: 1px solid #c4c4c4;\n    border-top-right-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 48px;\n}\n\n.utility-search-button:before {\n    height: 20px;\n    width: 20px;\n}\n\n.corp-main-navigation-mobile {\n    grid-gap: 16px;\n    grid-row-gap: 0;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    height: unset;\n    row-gap: 0;\n    width: 100%;\n}\n\n@media (min-width: 1366px) {\n    .corp-main-navigation-mobile {\n        display:none;\n    }\n}\n\n.corp-main-navigation-mobile .list-wrapper {\n    display: none;\n}\n\n.corp-main-navigation-mobile .list-wrapper button {\n    margin-bottom: 24px;\n    margin-top: 24px;\n}\n\n.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child {\n    padding-bottom: 0;\n}\n\n.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child:after {\n    border-bottom: 1px solid #c6e0e3;\n    content: \"\";\n    display: block;\n}\n\n.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child .hybrid-link,.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item:last-child .mega-link {\n    padding-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item > a {\n    padding-left: 32px;\n}\n\n.corp-main-navigation-mobile .link-list-container.sub-list .link-list .link-list-item > a:after {\n    content: none;\n}\n\n.corp-main-navigation-mobile .link-list-container .link-list-item {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    padding-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .link-list-container .link-list-item:before {\n    border-bottom: 1px solid #c6e0e3;\n    content: \"\";\n    display: block;\n    margin-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .link-list-container .link-list-item > a {\n    display: inline-block;\n    font-size: 16px;\n    line-height: 24px;\n    padding-left: 32px;\n    width: calc(100% - 32px);\n}\n\n.corp-main-navigation-mobile .dropdown-item {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n}\n\n.corp-main-navigation-mobile .dropdown-item:before {\n    border-bottom: 1px solid #e6e6e6;\n    content: \"\";\n    display: block;\n    margin-bottom: 24px;\n}\n\n.corp-main-navigation-mobile .dropdown-item.open {\n    --bg-opacity: 1;\n    background-color: #f2fafe;\n    background-color: rgba(242,250,254,var(--bg-opacity));\n}\n\n.corp-main-navigation-mobile .dropdown-item.open .dropdown-title:after {\n    padding-left: 24px;\n    padding-right: 0;\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n.corp-main-navigation-mobile .dropdown-item.open .link-list-item {\n    --bg-opacity: 1;\n    background-color: #f2fafe;\n    background-color: rgba(242,250,254,var(--bg-opacity));\n}\n\n.corp-main-navigation-mobile .dropdown-item.open .list-wrapper {\n    display: block;\n}\n\n.corp-main-navigation-mobile .dropdown-title {\n    --text-opacity: 1;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n    font-size: 18px;\n    justify-content: space-between;\n    line-height: 22px;\n    padding-bottom: 24px;\n    padding-left: 24px;\n}\n\n.corp-main-navigation-mobile .dropdown-title:after {\n    content: \"ï¸\";\n    font-family: Font Awesome\\6 Pro;\n    padding-right: 24px;\n}\n\n.corp-main-navigation-mobile .menu-bar {\n    grid-gap: 16px;\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    display: grid;\n    gap: 16px;\n    grid-column: span 6 / span 6;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    height: 87px;\n    padding-left: 24px;\n    padding-right: 24px;\n    position: fixed;\n    top: 0;\n    width: 100vw;\n    z-index: 99;\n}\n\n.corp-main-navigation-mobile .menu-bar .logo {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    grid-column: span 2 / span 2;\n}\n\n.corp-main-navigation-mobile .menu-bar .icon-menu {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 32px;\n    grid-column: span 4 / span 4;\n    justify-content: flex-end;\n}\n\n.corp-main-navigation-mobile .menu-bar .icon-menu .nav-icon {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.corp-main-navigation-mobile .menu-bar .icon-menu .phone-icon :before {\n    content: \"ï‚•\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    padding-bottom: 31px;\n    padding-right: 16px;\n    padding-top: 24px;\n}\n\n.corp-main-navigation-mobile .menu-bar .icon-menu .search-icon :before {\n    content: \"ï€‚\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    padding-bottom: 31px;\n    padding-right: 16px;\n    padding-top: 24px;\n}\n\n.corp-main-navigation-mobile .menu-bar .icon-menu .menu-icon :before {\n    content: \"ïƒ‰\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    padding-bottom: 33px;\n    padding-top: 28px;\n}\n\n.corp-main-navigation-mobile .menu-bar .icon-menu .menu-icon.open :before {\n    content: \"ï€\";\n    font-family: Font Awesome\\6 Pro;\n    font-weight: 900;\n    padding-bottom: 33px;\n    padding-top: 28px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile {\n    display: none;\n    grid-column: span 6 / span 6;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile > .link-list-container {\n    padding-bottom: 200px;\n}\n\n@media (min-width: 1366px) {\n    .corp-main-navigation-mobile .utility-nav-mobile > .link-list-container {\n        padding-bottom:unset;\n    }\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile.open {\n    display: block;\n    max-height: 100vh;\n    overflow: scroll;\n    position: relative;\n    z-index: 9;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container {\n    padding-top: 88px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .mega-list-cta-content {\n    padding-left: 24px;\n    padding-right: 24px;\n    padding-top: 24px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .mega-list-cta-content .see-more {\n    --text-opacity: 1;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n   \n    padding-bottom: 24px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .mega-list-cta-content .see-more:after {\n    content: \"ï”\";\n    font-family: Font Awesome\\6 Pro;\n    padding-left: 8px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .request {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-left: 32px;\n    margin-right: 32px;\n    padding-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .request .request-btn {\n    --bg-opacity: 1;\n    background-color: #0098db;\n    background-color: rgba(0,152,219,var(--bg-opacity));\n    width: 100%;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-menu .request .request-btn:after {\n    content: \"ï”\";\n    font-family: Font Awesome\\6 Pro;\n    padding-left: 8px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .mega-list-cta:after {\n    content: none;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .list-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 18px;\n    line-height: 24px;\n    padding-bottom: 8px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .dropdown-list-container .dropdown-item .description {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    padding-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-container:before {\n    border-bottom: 1px solid #c6e0e3;\n    content: \"\";\n    display: block;\n    margin-bottom: 14px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top {\n    padding-left: 32px;\n    padding-right: 32px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 18px;\n    line-height: 28px;\n    line-height: 26px;\n    padding-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-img {\n    padding-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-img img {\n    border-radius: 8px;\n    max-height: 180px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-content-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 20px;\n    line-height: 28px;\n    line-height: 26px;\n    padding-bottom: 8px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-top-content-description {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    font-size: 16px;\n    line-height: 24px;\n    padding-bottom: 24px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set {\n    padding-bottom: 24px;\n    padding-top: 24px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set:first-of-type {\n    padding-top: 0;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set-title {\n   \n    font-size: 18px;\n    line-height: 24px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set-list li,.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    padding-bottom: 16px;\n}\n\n.corp-main-navigation-mobile .utility-nav-mobile .mobile-hybrid-content-set > a {\n    padding-top: 8px;\n}\n\n@media (max-width: 1365px) {\n    .main-desktop-mask {\n        display:none;\n    }\n}\n\n.main-navigation-desktop {\n    --bg-opacity: 1;\n    background-color: #003c69;\n    background-color: rgba(0,60,105,var(--bg-opacity));\n}\n\n.main-navigation-desktop .link-standard:before {\n    display: none;\n}\n\n.main-navigation-desktop .nav-item-panel {\n    border-radius: 0;\n    cursor: auto;\n    display: none;\n    left: 0;\n    padding: 0;\n    position: absolute;\n    top: 44px;\n    width: 100vw;\n}\n\n.main-navigation-desktop .mega-menu picture {\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    max-height: 224px;\n    min-width: 463px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    position: absolute;\n    right: 0;\n}\n\n.main-navigation-desktop .mega-menu picture img {\n    height: auto;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.main-navigation-desktop .mega-menu .menu-content {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(12,minmax(0,1fr));\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 64px;\n    padding-top: 32px;\n    width: 1328px;\n    z-index: 1;\n}\n\n.main-navigation-desktop .mega-menu .menu-content .request {\n    justify-self: end;\n}\n\n.main-navigation-desktop .mega-menu .menu-content .request p {\n    font-size: 14px;\n    line-height: 20px;\n    padding-bottom: 8px;\n}\n\n.main-navigation-desktop .mega-menu .menu-content .rich-text {\n    padding: 0;\n}\n\n.main-navigation-desktop .mega-menu i {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    font-size: 4em;\n    justify-self: end;\n    padding-top: 4px;\n}\n\n.main-navigation-desktop .mega-menu .mega-list {\n    grid-gap: 8px;\n    display: grid;\n    gap: 8px;\n    grid-column: span 4 / span 4;\n    grid-template-columns: repeat(4,minmax(0,1fr));\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\n.main-navigation-desktop .mega-menu .mega-list-cta {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-column: span 4 / span 4;\n    grid-template-columns: repeat(4,minmax(0,1fr));\n}\n\n.main-navigation-desktop .mega-menu .mega-list-cta-image {\n    grid-column: span 1 / span 1;\n    margin-left: 32px;\n}\n\n.main-navigation-desktop .mega-menu .mega-list-cta-image img {\n    height: auto;\n    width: 100%;\n}\n\n.main-navigation-desktop .mega-menu .mega-list-cta-content {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    grid-column: span 3 / span 3;\n}\n\n.main-navigation-desktop .mega-menu .mega-list .list-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 18px;\n    line-height: 24px;\n    padding-bottom: 4px;\n}\n\n.main-navigation-desktop .mega-menu .mega-list .description {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    font-size: 15px;\n    line-height: 24px;\n    padding-bottom: 0;\n}\n\n.main-navigation-desktop .mega-menu .mega-list-list {\n    grid-column: 2/5;\n}\n\n.main-navigation-desktop .mega-menu .mega-list-list li {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 15px;\n    line-height: 24px;\n    margin-bottom: 12px;\n}\n\n.main-navigation-desktop .mega-menu .mega-list-list li:last-child {\n    margin-bottom: 0;\n}\n\n.main-navigation-desktop .mega-menu .mega-list:nth-of-type(2) {\n    grid-column: 6 / span 4;\n}\n\n.main-navigation-desktop .mega-menu .mega-list-cta-mask {\n    grid-column: span 4 / span 4;\n}\n\n.main-navigation-desktop .hybrid-menu {\n    --bg-opacity: 1;\n    background-color: #f2fafe;\n    background-color: rgba(242,250,254,var(--bg-opacity));\n    display: none;\n}\n\n.main-navigation-desktop .hybrid-menu .hybrid-background-img {\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    max-height: 224px;\n    min-width: 463px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    position: absolute;\n    right: 0;\n}\n\n.main-navigation-desktop .hybrid-menu .hybrid-background-img img {\n    height: auto;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(12,minmax(0,1fr));\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 32px;\n    padding-top: 24px;\n    width: 1328px;\n    z-index: 1;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-top {\n    border-bottom: 1px solid rgba(203,203,203,0.66);\n    padding-bottom: 24px;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-bottom,.main-navigation-desktop .hybrid-menu .menu-content .hybrid-top {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-column: span 12 / span 12;\n    grid-template-columns: repeat(12,minmax(0,1fr));\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout {\n    grid-row-gap: 0;\n    row-gap: 0;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    display: none;\n   \n    font-size: 18px;\n    line-height: 24px;\n    padding-bottom: 4px;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-image img {\n    border-radius: 8px;\n    height: 162px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    width: 100%;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-right .highlight-content-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 18px;\n    line-height: 24px;\n    padding-bottom: 8px;\n    padding-top: 0;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-right .highlight-description,.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .highlight-callout-right .rich-text {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    font-size: 15px;\n    line-height: 24px;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .rich-text {\n    padding: 0;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .highlight-callout .rich-text p {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .list-title {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 18px;\n    padding-bottom: 4px;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .list-title.bottom-list {\n    font-size: 18px;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .link-list {\n    padding-top: 0;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .link-list li {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    font-size: 15px;\n    line-height: 24px;\n    padding-bottom: 12px;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more {\n    padding-bottom: 0;\n    padding-top: 0;\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more:after {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n}\n\n.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more a,.main-navigation-desktop .hybrid-menu .menu-content .hybrid-list .see-more span {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 24px;\n}\n\n.main-navigation-desktop-wrapper {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    display: grid;\n    grid-auto-flow: column;\n    grid-template-columns: -webkit-max-content;\n    grid-template-columns: max-content;\n    justify-content: flex-start;\n}\n\n.main-navigation-desktop-max,.main-navigation-desktop-wrapper {\n    --bg-opacity: 1;\n    background-color: #003c69;\n    background-color: rgba(0,60,105,var(--bg-opacity));\n}\n\n.main-navigation-desktop-max {\n    height: 44px;\n    max-width: 1328px;\n    position: unset;\n}\n\n.main-navigation-desktop-max ul li.active {\n    background-color: #fff;\n}\n\n.main-navigation-desktop .nav-item {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    --text-opacity: 1;\n    align-items: center;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    cursor: pointer;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 15px;\n    height: 100%;\n    justify-content: center;\n    line-height: 24px;\n    margin-right: 0;\n    padding-left: 24px;\n    padding-right: 24px;\n    position: unset;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.main-navigation-desktop .nav-item--open {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #f2fafe;\n    background-color: rgba(242,250,254,var(--bg-opacity));\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n}\n\n.main-navigation-desktop .nav-item--open:before {\n    display: none;\n}\n\n.main-navigation-desktop .nav-item--open .nav-item-panel {\n    --bg-opacity: 1;\n    background-color: #f2fafe;\n    background-color: rgba(242,250,254,var(--bg-opacity));\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.main-navigation-desktop .link-item {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    align-items: center;\n    cursor: pointer;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    grid-column: 11/12;\n    justify-content: center;\n    margin-right: auto;\n    width: 208px;\n}\n\n.main-navigation-desktop .link-item > div {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    font-size: 15px;\n    line-height: 24px;\n}\n\n.main-navigation-desktop .link-item > div:after {\n    --text-opacity: 1;\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n.main-navigation-desktop.stick {\n    position: fixed;\n    top: 0;\n    width: 100vw;\n}\n\nbody.locked {\n    max-height: 100vh;\n    overflow: hidden;\n}\n\n.base-page {\n    overflow-x: hidden;\n}\n\n.base-page-hero {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    overflow: hidden;\n    position: relative;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero {\n        min-height:364px;\n    }\n}\n\n.base-page-hero.pillars-hero {\n    margin-bottom: 320px;\n    overflow: visible;\n}\n\n@media (min-width: 768px) {\n    .base-page-hero.pillars-hero {\n        margin-bottom:180px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero.pillars-hero .pillars-container {\n        position:relative;\n        width: 200%;\n    }\n}\n\n.base-page-hero.pillars-hero .pillars-container .pillars {\n    bottom: 0;\n    top: 90%;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero.pillars-hero .pillars-container .pillars {\n        bottom:0;\n        top: 0;\n    }\n}\n\n.base-page-hero-bg {\n    height: 100%;\n    left: 30%;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n@media (max-width: 1365px) {\n    .base-page-hero-bg {\n        display:none;\n    }\n}\n\n@media (min-width: 768px) {\n    .base-page-hero-bg {\n        left:50%;\n    }\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-bg {\n        left:50%;\n        top: 0;\n        width: auto;\n    }\n}\n\n.base-page-hero-bg img {\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n    -o-object-position: left;\n    object-position: left;\n    width: auto;\n}\n\n.base-page-hero-bg img.desktop-hero {\n    display: none;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-bg img.desktop-hero {\n        display:block;\n    }\n\n    .base-page-hero-bg img.mobile-hero {\n        display: none;\n    }\n}\n\n.base-page-hero-content {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    align-items: flex-start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: auto;\n    margin-top: auto;\n    padding-bottom: 0;\n    padding-top: 40px;\n    position: relative;\n}\n\n@media (min-width: 768px) {\n    .base-page-hero-content {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -ms-flex-direction: row;\n        flex-direction: row;\n        min-height: 212px;\n        padding-bottom: 0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content {\n        grid-gap:16px;\n        display: grid;\n        gap: 16px;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n        min-height: 364px;\n        padding: unset;\n    }\n}\n\n.base-page-hero-content-mask {\n    padding-bottom: 20px;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-mask {\n        grid-column:1/7;\n    }\n}\n\n.base-page-hero-content-eyebrow {\n    --text-opacity: 1;\n    color: #0098db;\n    color: rgba(0,152,219,var(--text-opacity));\n    display: block;\n   \n    font-size: 16px;\n    line-height: 24px;\n    text-transform: uppercase;\n}\n\n.base-page-hero-content-heading {\n    font-size: 40px;\n    line-height: 48px;\n    margin-bottom: 16px;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-heading {\n        margin-bottom:24px;\n    }\n\n    .base-page-hero-content-body {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin-bottom: 32px;\n    }\n}\n\n.base-page-hero-content-links-wrapper {\n    display: none;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-links-wrapper {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        padding-bottom: 24px;\n    }\n\n    .base-page-hero-content-links-wrapper .link-collection-item {\n        -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n        padding-bottom: 8px;\n    }\n\n    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex),.base-page-hero-content-links-wrapper .link-collection-item a button {\n        --text-opacity: 1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        display: block;\n       \n        font-size: 16px;\n        line-height: 22px;\n        position: relative;\n        text-decoration: none;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n        width: -webkit-fit-content;\n        width: -moz-fit-content;\n        width: fit-content;\n    }\n\n    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):before,.base-page-hero-content-links-wrapper .link-collection-item a button:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        bottom: 0;\n        content: \"\";\n        display: block;\n        height: 1.5px;\n        opacity: 0;\n        position: absolute;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n        width: 100%;\n    }\n\n    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):after,.base-page-hero-content-links-wrapper .link-collection-item a button:after {\n        display: none;\n    }\n}\n\n@media (min-width: 1366px) and (hover:hover) {\n    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):hover,.base-page-hero-content-links-wrapper .link-collection-item a button:hover {\n        --text-opacity:1;\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n\n    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):hover:before,.base-page-hero-content-links-wrapper .link-collection-item a button:hover:before {\n        --bg-opacity: 1;\n        background-color: #005bbb;\n        background-color: rgba(0,91,187,var(--bg-opacity));\n        opacity: 1;\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex).wrapper:after,.base-page-hero-content-links-wrapper .link-collection-item a button.wrapper:after {\n        width:0;\n    }\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-links-wrapper .link-collection-item a:not(.flex):after,.base-page-hero-content-links-wrapper .link-collection-item a button:after {\n        content:\"âŒª\";\n        display: inline-block;\n        font-family: Font Awesome\\6 Pro;\n        font-size: 0.75em;\n        font-weight: 900;\n        padding-left: 4px;\n        position: relative;\n    }\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-links-wrapper .link-collection-item a.inline {\n        display:inline-block;\n    }\n}\n\n.base-page-hero-content-buttons {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    align-items: flex-start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    margin-bottom: 24px;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-buttons {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: normal;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n}\n\n.base-page-hero-content-buttons-cta {\n    --bg-opacity: 1;\n    background-color: #0098db;\n    background-color: rgba(0,152,219,var(--bg-opacity));\n    margin-bottom: 12px;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-buttons-cta {\n        -webkit-box-align:center;\n        -ms-flex-align: center;\n        align-items: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        margin-bottom: 0;\n        margin-right: 32px;\n    }\n\n    .base-page-hero-content-buttons-cta:after {\n        top: 2px;\n    }\n}\n\n.base-page-hero-content-buttons-video {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n\n.base-page-hero-content-buttons-video i {\n    font-size: 24px;\n    margin-right: 4px;\n}\n\n.base-page-hero-content-image {\n    -ms-flex-item-align: center;\n    align-self: center;\n    display: none;\n    max-width: 310px;\n}\n\n@media (min-width: 1366px) {\n    .base-page-hero-content-image {\n        -ms-flex-item-align:end;\n        align-self: flex-end;\n        display: block;\n        grid-column: 7/13;\n        max-width: unset;\n        padding-left: 20px;\n    }\n}\n\n.base-page-hero-content-image img {\n    height: auto;\n    width: 100%;\n}\n\n.homepage .section-container {\n    padding-bottom: 0;\n    padding-top: 24px;\n}\n\n.homepage-eyebrow {\n    --text-opacity: 1;\n    color: #0098db;\n    color: rgba(0,152,219,var(--text-opacity));\n    display: block;\n   \n    font-size: 16px;\n    line-height: 24px;\n    text-transform: uppercase;\n}\n\n.homepage-heading {\n    font-size: 40px;\n    line-height: 48px;\n    margin-bottom: 8px;\n}\n\n@media (min-width: 768px) {\n    .homepage-heading {\n        font-size:56px;\n        line-height: 64px;\n    }\n}\n\n.homepage-button {\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 8px;\n}\n\n@media (min-width: 1366px) {\n    .homepage-button {\n        font-size:24px;\n        line-height: 40px;\n    }\n}\n\n.homepage-hero {\n    display: none;\n}\n\n@media (min-width: 1366px) {\n    .homepage-hero {\n        bottom:0;\n        display: block;\n        grid-column: unset;\n        left: 42%;\n        padding-left: 0;\n        position: absolute;\n    }\n\n    .homepage-hero img {\n        max-width: 100%;\n    }\n}\n\n.homepage .base-page-hero {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n}\n\n.homepage .base-page-hero-content {\n    min-height: 350px;\n}\n\n.homepage .base-page-hero-content-image {\n    bottom: 0;\n    display: block;\n    position: absolute;\n    right: 0;\n}\n\n@media (min-width: 1366px) {\n    .homepage .base-page-hero {\n        min-height:464px;\n    }\n}\n\n.homepage .base-page-hero-content-mask {\n    position: relative;\n    z-index: 1;\n}\n\n@media (min-width: 768px) {\n    .homepage .base-page-hero-content-mask {\n        padding-bottom:100px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .homepage .base-page-hero-content-mask {\n        padding-bottom:60px;\n    }\n}\n\n.homepage .base-page-hero-content-image {\n    max-width: 450px;\n    z-index: 0;\n}\n\n@media (min-width: 1366px) {\n    .homepage .base-page-hero-content-image {\n        display:none;\n    }\n}\n\n.homepage-wrapper {\n    margin-bottom: 300px;\n    position: relative;\n}\n\n@media (min-width: 768px) {\n    .homepage-wrapper {\n        margin-bottom:100px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .homepage-wrapper {\n        margin-bottom:50px;\n    }\n}\n\n.pillars {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    bottom: -80%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    left: 0;\n    margin: auto;\n    max-width: 368px;\n    position: absolute;\n    right: 0;\n}\n\n@media (min-width: 768px) {\n    .pillars {\n        bottom:-35%;\n        max-width: 728px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .pillars {\n        bottom:-15%;\n        max-width: 1328px;\n    }\n}\n\n.pillars .pillars-entry {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: transparent;\n    border-radius: 8px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 153px;\n    justify-content: center;\n    margin-bottom: 16px;\n    -webkit-perspective: 1000px;\n    perspective: 1000px;\n    width: 176px;\n}\n\n.pillars .pillars-entry:hover {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n@media (min-width: 1366px) {\n    .pillars .pillars-entry {\n        height:200px;\n        width: 320px;\n    }\n}\n\n.pillars .pillars-entry-inner {\n    border-radius: 8px;\n    -webkit-box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    height: 100%;\n    position: relative;\n    text-align: center;\n    -webkit-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n    -webkit-transition: -webkit-transform 0.6s;\n    transition: -webkit-transform 0.6s;\n    -o-transition: transform 0.6s;\n    transition: transform 0.6s;\n    transition: transform 0.6s,-webkit-transform 0.6s;\n    width: 100%;\n}\n\n.pillars .pillars-entry-inner-back,.pillars .pillars-entry-inner-front {\n    --text-opacity: 1;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    border-radius: 8px;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n    position: absolute;\n}\n\n.pillars .pillars-entry-inner-front {\n    -ms-flex-pack: distribute;\n    border-radius: 8px;\n    height: 100%;\n    justify-content: space-around;\n    padding: 0;\n}\n\n.pillars .pillars-entry-inner-front,.pillars .pillars-entry-inner-front a {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    width: 100%;\n}\n\n.pillars .pillars-entry-inner-front a {\n    padding: 40px 24px;\n}\n\n@media (min-width: 1366px) {\n    .pillars .pillars-entry-inner-front {\n        padding:40px 24px;\n    }\n}\n\n.pillars .pillars-entry-inner-front-image {\n    height: 55px;\n    width: 55px;\n}\n\n@media (min-width: 1366px) {\n    .pillars .pillars-entry-inner-front-image {\n        height:100px;\n        margin-bottom: 20px;\n        width: 100px;\n    }\n}\n\n.pillars .pillars-entry-inner-front-image img {\n    height: 100%;\n    -o-object-fit: contain;\n    object-fit: contain;\n    -webkit-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n    -webkit-transition: -webkit-transform 0.6s;\n    transition: -webkit-transform 0.6s;\n    -o-transition: transform 0.6s;\n    transition: transform 0.6s;\n    transition: transform 0.6s,-webkit-transform 0.6s;\n    width: 100%;\n}\n\n.pillars .pillars-entry-inner-back {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-pack: distribute;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    --bg-opacity: 1;\n    align-items: center;\n    background-color: #fff;\n    background-color: rgba(255,255,255,var(--bg-opacity));\n    border-radius: 8px;\n    -webkit-box-shadow: 0 5px 24px rgba(0,0,0,0.40392);\n    box-shadow: 0 5px 24px rgba(0,0,0,0.40392);\n    color: #fff;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    height: 103%;\n    justify-content: space-around;\n    left: -50%;\n    margin-left: 48.5%;\n    margin-top: 30%;\n    padding: 40px 32px;\n    top: -50%;\n    -webkit-transform: rotateY(180deg);\n    transform: rotateY(180deg);\n    -webkit-transition: -webkit-box-shadow 0.1;\n    transition: -webkit-box-shadow 0.1;\n    -o-transition: box-shadow 0.1;\n    transition: box-shadow 0.1;\n    transition: box-shadow 0.1,-webkit-box-shadow 0.1;\n    width: 103%;\n}\n\n.pillars .pillars-entry-inner-back-content li,.pillars .pillars-entry-inner-back-content p {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n    font-size: 15px;\n    line-height: 24px;\n}\n\n.pillars .pillars-entry-inner-back:hover {\n    -webkit-backface-visibility: visible;\n    backface-visibility: visible;\n    -webkit-transition: -webkit-backface-visibility 1;\n    transition: -webkit-backface-visibility 1;\n    -o-transition: backface-visibility 1;\n    transition: backface-visibility 1;\n    transition: backface-visibility 1,-webkit-backface-visibility 1;\n}\n\n@media (min-width: 1366px) {\n    .pillars .pillars-entry-inner-link {\n        font-size:15px;\n        line-height: 24px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n\n.pillars .pillars-entry-inner-link.inverted {\n    --text-opacity: 1;\n    color: #fff;\n    color: rgba(255,255,255,var(--text-opacity));\n}\n\n@media (min-width: 1366px) {\n    .pillars-entry:hover .pillars-entry-inner {\n        -webkit-box-shadow:none;\n        box-shadow: none;\n        -webkit-transform: rotateY(180deg);\n        transform: rotateY(180deg);\n    }\n\n    .news {\n        padding-top: 80px;\n    }\n\n    .news-hero,.news-hero-image img {\n        height: 380px;\n    }\n}\n\n.news-heading {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.news-heading-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 32px;\n}\n\n@media (min-width: 1366px) {\n    .news-heading-title {\n        font-family:Helvetica Now Display Bold;\n        font-size: 24px;\n        line-height: 32px;\n    }\n}\n\n.news-heading-landing-category {\n    border: 2px solid #0094d9;\n    border-radius: 8px;\n    color: #0065c0 !important;\n    display: inline-block;\n   \n    font-size: 14px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    min-width: 144px;\n    padding: 10px 24px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .news-heading-landing-category:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.news-heading-landing-category > span,.news-heading-landing-category i,.news-heading-landing-category svg {\n    display: inline;\n}\n\n.news-heading-landing-category svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n.news-heading-landing-category:after {\n    content: \"âŒª\";\n    font-family: Font Awesome\\6 Pro;\n    font-size: 0.75em;\n    font-weight: 900;\n    left: 8px;\n    position: relative;\n}\n\n@media (hover: hover) {\n    .news-heading-landing-category:hover {\n        background-color:#0094d9;\n        color: #fff !important;\n    }\n}\n\n.news-landing-meta-date {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n   \n    font-size: 14px;\n    line-height: 20px;\n    margin-left: 12px;\n    text-transform: none;\n}\n\n.news-landing-meta-category {\n    text-transform: none;\n}\n\n.news-landing-meta-seperator {\n    display: none;\n}\n\n.news-landing-meta-author {\n    --text-opacity: 1;\n    color: #003c69;\n    color: rgba(0,60,105,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 24px;\n    padding-bottom: 8px;\n    padding-top: 32px;\n}\n\n@media (min-width: 1366px) {\n    .news-content-main {\n        padding-left:8px;\n        padding-right: 8px;\n    }\n}\n\n.news-content-main-set .rich-text p {\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.news-content-main-set .rich-text h1 {\n    font-size: 24px;\n}\n\n.news-content-main-set .rich-text h2 {\n    font-size: 22px;\n    line-height: 32px;\n}\n\n.news-content-main-set .rich-text h3 {\n    font-size: 20px;\n    line-height: 32px;\n}\n\n.news-content-main-set .rich-text h4,.news-content-main-set .rich-text h5,.news-content-main-set .rich-text h6 {\n    font-size: 16px;\n    letter-spacing: normal;\n    line-height: 24px;\n}\n\n.news-content-main-set ul {\n    padding-left: 28px;\n}\n\n.news-content-main-set ul li {\n    -webkit-box-align: baseline;\n    -ms-flex-align: baseline;\n    align-items: baseline;\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.news-content-main-set ul li:before {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n    content: \"ï˜\";\n    display: inline-block;\n    font-size: 20px;\n    font-style: normal;\n    font-variant: normal;\n    font-weight: 400;\n    left: -8px;\n    line-height: 1;\n    line-height: 21px;\n    margin-left: 8px;\n    margin-top: 2px;\n    position: relative;\n}\n\n.news-content-side {\n    padding-right: 8px;\n}\n\n.news-content-side > div:first-child {\n    padding: 0;\n}\n\n.news-content-side > div:first-child .news-search-box-container {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    border-bottom: 1px solid #75787b;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n    margin-bottom: 12px;\n    margin-left: 12px;\n    margin-right: 12px;\n    padding-bottom: 0;\n}\n\n@media (min-width: 1366px) {\n    .news-content-side > div:first-child .news-search-box-container {\n        margin-left:0;\n        margin-right: 0;\n    }\n}\n\n.news-content-side > div:first-child .news-search-box-container input {\n    --text-opacity: 1;\n    border: none;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n   \n    font-size: 16px;\n    font-style: italic;\n    height: auto;\n    line-height: 24px;\n    padding-bottom: 8px;\n    padding-left: 32px;\n}\n\n.news-content-side > div:first-child .news-search-box-container input::-webkit-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-content-side > div:first-child .news-search-box-container input::-moz-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-content-side > div:first-child .news-search-box-container input:-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-content-side > div:first-child .news-search-box-container input::-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-content-side > div:first-child .news-search-box-container input::placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-content-side > div:first-child .news-search-box-container button {\n    -ms-flex-item-align: center;\n    align-self: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    left: 20px;\n    margin-left: 0;\n    margin-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n    position: relative;\n    top: unset;\n}\n\n.news-content-side > div:first-child .news-search-box-container i svg {\n    fill: #005bbb;\n    height: 18px;\n    width: 18px;\n}\n\n@media (min-width: 768px) {\n    .news-content-side > div:first-child .news-search-box-container {\n        -webkit-box-orient:horizontal;\n        -webkit-box-direction: reverse;\n        -webkit-box-align: end;\n        -ms-flex-align: end;\n        align-items: flex-end;\n        border-bottom: 1px solid #75787b;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n        margin-bottom: 12px;\n        margin-left: 12px;\n        margin-right: 12px;\n        padding-bottom: 0;\n    }\n}\n\n@media (min-width: 768px) and (min-width:1366px) {\n    .news-content-side > div:first-child .news-search-box-container {\n        margin-left:0;\n        margin-right: 0;\n    }\n}\n\n@media (min-width: 768px) {\n    .news-content-side > div:first-child .news-search-box-container input {\n        --text-opacity:1;\n        border: none;\n        border-radius: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n        color: #75787b;\n        color: rgba(117,120,123,var(--text-opacity));\n       \n        font-size: 16px;\n        font-style: italic;\n        height: auto;\n        line-height: 24px;\n        padding-bottom: 8px;\n        padding-left: 32px;\n    }\n}\n\n@media (min-width: 768px) {\n    .news-content-side > div:first-child .news-search-box-container input::-webkit-input-placeholder {\n        --text-opacity:1;\n        color: #75787b;\n        color: rgba(117,120,123,var(--text-opacity));\n        opacity: 0.5;\n    }\n\n    .news-content-side > div:first-child .news-search-box-container input::-moz-placeholder {\n        --text-opacity: 1;\n        color: #75787b;\n        color: rgba(117,120,123,var(--text-opacity));\n        opacity: 0.5;\n    }\n\n    .news-content-side > div:first-child .news-search-box-container input:-ms-input-placeholder {\n        --text-opacity: 1;\n        color: #75787b;\n        color: rgba(117,120,123,var(--text-opacity));\n        opacity: 0.5;\n    }\n\n    .news-content-side > div:first-child .news-search-box-container input::-ms-input-placeholder {\n        --text-opacity: 1;\n        color: #75787b;\n        color: rgba(117,120,123,var(--text-opacity));\n        opacity: 0.5;\n    }\n\n    .news-content-side > div:first-child .news-search-box-container input::placeholder {\n        --text-opacity: 1;\n        color: #75787b;\n        color: rgba(117,120,123,var(--text-opacity));\n        opacity: 0.5;\n    }\n}\n\n@media (min-width: 768px) {\n    .news-content-side > div:first-child .news-search-box-container button {\n        -ms-flex-item-align:center;\n        align-self: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        left: 20px;\n        margin-left: 0;\n        margin-top: 0;\n        padding-left: 0;\n        padding-right: 0;\n        position: relative;\n        top: unset;\n    }\n\n    .news-content-side > div:first-child .news-search-box-container i svg {\n        fill: #005bbb;\n        height: 18px;\n        width: 18px;\n    }\n}\n\n.news-content-side > div:first-child .news-search-box-container {\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.news .news-content h2 {\n    font-size: 20px;\n    line-height: 24px;\n}\n\n@media (min-width: 768px) {\n    .news .news-content h2 {\n        font-size:20px;\n        line-height: 24px;\n    }\n}\n\n.news-landing {\n    grid-gap: 16px;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n}\n\n@media (min-width: 768px) {\n    .news-landing {\n        grid-template-columns:repeat(12,minmax(0,1fr));\n    }\n}\n\n@media (min-width: 1366px) {\n    .news-landing {\n        padding-top:80px;\n    }\n}\n\n.news-landing > h1 {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .news-landing > h1 {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news-landing-featured {\n        padding-left:0;\n        padding-right: 0;\n    }\n}\n\n.news-landing-hero {\n    margin-bottom: 24px;\n}\n\n.news-landing-meta {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n}\n\n.news-landing-meta-category {\n    border: 2px solid #0098db;\n    border-radius: 8px;\n    color: #005bbb !important;\n    display: inline-block;\n   \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 6px 16px;\n    text-align: center;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .news-landing-meta-category:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.news-landing-meta-category > span,.news-landing-meta-category i,.news-landing-meta-category svg {\n    display: inline;\n}\n\n.news-landing-meta-category svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .news-landing-meta-category:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        color: #fff !important;\n    }\n}\n\n.news-landing-meta-date {\n    display: inline-block;\n    text-transform: lowercase;\n}\n\n.news-landing-meta-date:first-letter {\n    text-transform: capitalize;\n}\n\n.news-landing-heading {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.news-landing-heading-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n    font-size: 40px;\n    font-size: 24px;\n    line-height: 44px;\n    line-height: 32px;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-heading-title {\n        font-size:56px;\n        line-height: 60px;\n    }\n}\n\n@media (min-width: 768px) {\n    .news-landing-heading-title {\n        font-size:24px;\n        line-height: 32px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news-landing-heading-title {\n        font-size:24px;\n        line-height: 32px;\n    }\n}\n\n.news-landing-heading-summary {\n    margin-bottom: 24px;\n}\n\n.news-landing-content {\n    grid-column: span 6 / span 6;\n}\n\n@media (min-width: 768px) {\n    .news-landing-content {\n        grid-column:span 12 / span 12;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news-landing-content {\n        grid-gap:16px;\n        display: grid;\n        gap: 16px;\n        grid-template-columns: repeat(12,minmax(0,1fr));\n    }\n\n    .news-landing-content-main {\n        grid-column: span 8 / span 8;\n        padding-left: 8px;\n        padding-right: 8px;\n    }\n}\n\n.news-landing-content-main .rich-text p {\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.news-landing-content-side .news-search-box-container {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    align-items: flex-end;\n    border-bottom: 1px solid #75787b;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row-reverse;\n    flex-direction: row-reverse;\n    margin-bottom: 12px;\n    margin-left: 12px;\n    margin-right: 12px;\n    padding-bottom: 0;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-content-side .news-search-box-container {\n        margin-left:0;\n        margin-right: 0;\n    }\n}\n\n.news-landing-content-side .news-search-box-container input {\n    --text-opacity: 1;\n    border: none;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n   \n    font-size: 16px;\n    font-style: italic;\n    height: auto;\n    line-height: 24px;\n    padding-bottom: 8px;\n    padding-left: 32px;\n}\n\n.news-landing-content-side .news-search-box-container input::-webkit-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-landing-content-side .news-search-box-container input::-moz-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-landing-content-side .news-search-box-container input:-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-landing-content-side .news-search-box-container input::-ms-input-placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-landing-content-side .news-search-box-container input::placeholder {\n    --text-opacity: 1;\n    color: #75787b;\n    color: rgba(117,120,123,var(--text-opacity));\n    opacity: 0.5;\n}\n\n.news-landing-content-side .news-search-box-container button {\n    -ms-flex-item-align: center;\n    align-self: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    left: 20px;\n    margin-left: 0;\n    margin-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n    position: relative;\n    top: unset;\n}\n\n.news-landing-content-side .news-search-box-container i svg {\n    fill: #005bbb;\n    height: 18px;\n    width: 18px;\n}\n\n.news-landing-content-side > div:first-child {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n@media (min-width: 1366px) {\n    .news-landing-content-side > div:first-child {\n        padding-bottom:0;\n    }\n\n    .news-landing-content-side {\n        grid-column: span 4 / span 4;\n        padding-left: 8px;\n        padding-right: 8px;\n    }\n}\n\n.news-results {\n    border-top: 1px solid #e2e2e2;\n    margin-top: 16px;\n    padding-top: 40px;\n}\n\n.news-results-heading {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 30px;\n    line-height: 24px;\n}\n\n@media (min-width: 768px) {\n    .news-results-heading {\n        margin-bottom:24px;\n    }\n}\n\n.news-results-container {\n    grid-gap: 16px;\n    grid-row-gap: 0;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(6,minmax(0,1fr));\n    margin-bottom: 40px;\n    row-gap: 0;\n}\n\n@media (min-width: 768px) {\n    .news-results-container {\n        grid-template-columns:repeat(8,minmax(0,1fr));\n        margin-bottom: 24px;\n    }\n}\n\n.news-results-item {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    border-bottom: 1px solid #e2e2e2;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    grid-column: span 6 / span 6;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n    padding-right: 20px;\n    width: unset !important;\n}\n\n@media (min-width: 768px) {\n    .news-results-item {\n        grid-column:span 4 / span 4;\n        margin-bottom: 40px;\n        padding-bottom: 40px;\n        padding-left: 8px;\n        padding-right: 8px;\n        width: unset !important;\n    }\n}\n\n@media (min-width: 1366px) {\n    .news-results-item {\n        grid-column:span 4 / span 4;\n        width: unset !important;\n    }\n}\n\n.news-results-item:last-of-type {\n    margin-bottom: 0;\n}\n\n@media (min-width: 768px) {\n    .news-results-item:last-of-type {\n        margin-bottom:40px;\n    }\n}\n\n.news-results-item-image {\n    margin-bottom: 16px;\n}\n\n@media (min-width: 768px) {\n    .news-results-item-image {\n        margin-bottom:24px;\n    }\n}\n\n.news-results-item-meta {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    margin-bottom: 0;\n    order: 3;\n}\n\n@media (min-width: 768px) {\n    .news-results-item-meta {\n        margin-top:auto;\n    }\n}\n\n.news-results-item-meta-category {\n    border: 2px solid #0098db;\n    border-radius: 8px;\n    color: #005bbb !important;\n    display: inline-block;\n   \n    font-size: 16px;\n    height: auto;\n    letter-spacing: 0.16px;\n    line-height: 20px;\n    line-height: 24px;\n    padding: 6px 16px;\n    text-align: center;\n    text-transform: none;\n    -webkit-transition-duration: 0.2s;\n    -o-transition-duration: 0.2s;\n    transition-duration: 0.2s;\n    -webkit-transition-property: all;\n    -o-transition-property: all;\n    transition-property: all;\n    -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n    transition-timing-function: cubic-bezier(0.4,0,1,1);\n}\n\n@media (hover: hover) {\n    .news-results-item-meta-category:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #003c69;\n        background-color: rgba(0,60,105,var(--bg-opacity));\n        color: #fff;\n        color: rgba(255,255,255,var(--text-opacity));\n        -webkit-transition-duration: 0.2s;\n        -o-transition-duration: 0.2s;\n        transition-duration: 0.2s;\n        -webkit-transition-property: all;\n        -o-transition-property: all;\n        transition-property: all;\n        -webkit-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        -o-transition-timing-function: cubic-bezier(0.4,0,1,1);\n        transition-timing-function: cubic-bezier(0.4,0,1,1);\n    }\n}\n\n.news-results-item-meta-category > span,.news-results-item-meta-category i,.news-results-item-meta-category svg {\n    display: inline;\n}\n\n.news-results-item-meta-category svg {\n    fill: #fff;\n    height: 20px;\n    margin-right: 4px;\n    -webkit-transform: translateY(-2.5px);\n    -ms-transform: translateY(-2.5px);\n    transform: translateY(-2.5px);\n    width: 20px;\n}\n\n@media (hover: hover) {\n    .news-results-item-meta-category:hover {\n        --bg-opacity:1;\n        --text-opacity: 1;\n        background-color: #fff;\n        background-color: rgba(255,255,255,var(--bg-opacity));\n        background-color: #0098db;\n        background-color: rgba(0,152,219,var(--bg-opacity));\n        color: #005bbb;\n        color: rgba(0,91,187,var(--text-opacity));\n        color: #fff !important;\n    }\n}\n\n.news-results-item-meta-seperator {\n    display: none;\n}\n\n.news-results-item-meta-date {\n    --text-opacity: 1;\n    color: #000;\n    color: rgba(0,0,0,var(--text-opacity));\n    display: inline-block;\n   \n    font-size: 14px;\n    line-height: 20px;\n    margin-left: 12px;\n    text-transform: lowercase;\n}\n\n.news-results-item-meta-date:first-letter {\n    text-transform: capitalize;\n}\n\n.news-results-item-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n   \n    font-size: 24px;\n    line-height: 32px;\n}\n\n@media (min-width: 768px) {\n    .news-results-item-title {\n        margin-bottom:16px;\n    }\n}\n\n.news-results-item-summary {\n    margin-bottom: 16px;\n}\n\n@media (min-width: 768px) {\n    .news-results-item-summary {\n        margin-bottom:24px;\n    }\n}\n\n.news-results-item-summary p {\n    --text-opacity: 1;\n    color: #444;\n    color: rgba(68,68,68,var(--text-opacity));\n   \n    font-size: 16px;\n    line-height: 24px;\n}\n\n.news-results-item-summary pre {\n   \n    white-space: pre-wrap;\n}\n\n.news-search {\n    grid-column: span 6 / span 6;\n    margin: unset;\n}\n\n@media (min-width: 768px) {\n    .news-search {\n        margin-left:auto;\n        margin-right: auto;\n    }\n}\n\n.news-search .news-results-container {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n@media (min-width: 1366px) {\n    .news-search {\n        grid-column:span 12 / span 12;\n    }\n\n    .news-search-page {\n        padding-left: 32px;\n        padding-right: 32px;\n    }\n}\n\n.news-search-count,.news-search-results-title {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n}\n\n.news-search-results-title {\n\n   \n    font-size: 16px;\n    line-height: 20px;\n}\n\n@media (min-width: 1366px) {\n    .news-search-results-title {\n        font-size:32px;\n        line-height: 36px;\n    }\n}\n\n.scPage {\n    grid-gap: 16px;\n    gap: 16px;\n}\n\n.scPage-hero,.scPage-hero.section-container {\n    padding-bottom: 0;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n@media (min-width: 768px) {\n    .scPage-hero.section-container {\n        margin-bottom:56px;\n    }\n}\n\n.scPage-hero-heading,.scPage-hero h1 {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n    font-size: 32px;\n    line-height: 36px;\n    margin-left: 12px;\n    margin-right: 12px;\n    max-width: 50%;\n}\n\n@media (min-width: 1366px) {\n    .scPage-hero-heading,.scPage-hero h1 {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n@media (min-width: 768px) {\n    .scPage-hero-heading,.scPage-hero h1 {\n        margin-left:48px;\n        margin-right: 48px;\n    }\n}\n\n.scPage-hero-image img {\n    border-radius: 0;\n}\n\n.scPage-content-main-set h2 {\n    --text-opacity: 1;\n    color: #005bbb;\n    color: rgba(0,91,187,var(--text-opacity));\n\n    font-size: 32px;\n    line-height: 36px;\n}\n\n@media (min-width: 1366px) {\n    .scPage-content-main-set h2 {\n        font-size:48px;\n        line-height: 52px;\n    }\n}\n\n.scPage-content-side .block-wrapper {\n    padding-top: 0;\n}\n\n.main,main {\n    padding-top: 88px;\n}\n\n@media (min-width: 1366px) {\n    .main,main {\n        padding-top:106px;\n    }\n}\n\n@media (min-width: 768px) {\n    .tablet\\:container {\n        width:100%;\n    }\n}\n\n@media (min-width: 768px) and (min-width:768px) {\n    .tablet\\:container {\n        max-width:768px;\n    }\n}\n\n@media (min-width: 768px) and (min-width:960px) {\n    .tablet\\:container {\n        max-width:960px;\n    }\n}\n\n@media (min-width: 768px) and (min-width:1200px) {\n    .tablet\\:container {\n        max-width:1200px;\n    }\n}\n\n@media (min-width: 768px) and (min-width:1366px) {\n    .tablet\\:container {\n        max-width:1366px;\n    }\n}\n\n@media (min-width: 768px) {\n    .tablet\\:flex {\n        display:-webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .tablet\\:grid {\n        display: grid;\n    }\n\n    .tablet\\:flex-row {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .tablet\\:flex-row-reverse {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    }\n\n    .tablet\\:justify-center {\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n    }\n\n    .tablet\\:mt-0 {\n        margin-top: 0;\n    }\n\n    .tablet\\:mb-0 {\n        margin-bottom: 0;\n    }\n\n    .tablet\\:mb-2 {\n        margin-bottom: 8px;\n    }\n\n    .tablet\\:mt-4 {\n        margin-top: 16px;\n    }\n\n    .tablet\\:mr-4 {\n        margin-right: 16px;\n    }\n\n    .tablet\\:mb-4 {\n        margin-bottom: 16px;\n    }\n\n    .tablet\\:ml-4 {\n        margin-left: 16px;\n    }\n\n    .tablet\\:mt-6 {\n        margin-top: 24px;\n    }\n\n    .tablet\\:mb-6 {\n        margin-bottom: 24px;\n    }\n\n    .tablet\\:mb-8 {\n        margin-bottom: 32px;\n    }\n\n    .tablet\\:mb-12 {\n        margin-bottom: 48px;\n    }\n\n    .tablet\\:py-2 {\n        padding-bottom: 8px;\n        padding-top: 8px;\n    }\n\n    .tablet\\:px-30 {\n        padding-left: 120px;\n        padding-right: 120px;\n    }\n\n    .tablet\\:pt-0 {\n        padding-top: 0;\n    }\n\n    .tablet\\:pb-0 {\n        padding-bottom: 0;\n    }\n\n    .tablet\\:pr-2 {\n        padding-right: 8px;\n    }\n\n    .tablet\\:pb-4 {\n        padding-bottom: 16px;\n    }\n\n    .tablet\\:pt-6 {\n        padding-top: 24px;\n    }\n\n    .tablet\\:pb-6 {\n        padding-bottom: 24px;\n    }\n\n    .tablet\\:text-left {\n        text-align: left;\n    }\n\n    .tablet\\:gap-0 {\n        grid-gap: 0;\n        gap: 0;\n    }\n\n    .tablet\\:gap-3 {\n        grid-gap: 12px;\n        gap: 12px;\n    }\n\n    .tablet\\:gap-4 {\n        grid-gap: 16px;\n        gap: 16px;\n    }\n\n    .tablet\\:gap-5 {\n        grid-gap: 20px;\n        gap: 20px;\n    }\n\n    .tablet\\:gap-6 {\n        grid-gap: 24px;\n        gap: 24px;\n    }\n\n    .tablet\\:row-gap-6 {\n        grid-row-gap: 24px;\n        row-gap: 24px;\n    }\n\n    .tablet\\:grid-cols-2 {\n        grid-template-columns: repeat(2,minmax(0,1fr));\n    }\n\n    .tablet\\:grid-cols-4 {\n        grid-template-columns: repeat(4,minmax(0,1fr));\n    }\n\n    .tablet\\:grid-cols-12 {\n        grid-template-columns: repeat(12,minmax(0,1fr));\n    }\n\n    .tablet\\:col-span-3 {\n        grid-column: span 3 / span 3;\n    }\n\n    .tablet\\:col-span-4 {\n        grid-column: span 4 / span 4;\n    }\n\n    .tablet\\:col-span-6 {\n        grid-column: span 6 / span 6;\n    }\n\n    .tablet\\:col-span-9 {\n        grid-column: span 9 / span 9;\n    }\n\n    .tablet\\:col-span-12 {\n        grid-column: span 12 / span 12;\n    }\n}\n\n@media (min-width: 960px) {\n    .md\\:container {\n        width:100%;\n    }\n}\n\n@media (min-width: 960px) and (min-width:768px) {\n    .md\\:container {\n        max-width:768px;\n    }\n}\n\n@media (min-width: 960px) and (min-width:960px) {\n    .md\\:container {\n        max-width:960px;\n    }\n}\n\n@media (min-width: 960px) and (min-width:1200px) {\n    .md\\:container {\n        max-width:1200px;\n    }\n}\n\n@media (min-width: 960px) and (min-width:1366px) {\n    .md\\:container {\n        max-width:1366px;\n    }\n}\n\n@media (min-width: 960px) {\n    .md\\:inline {\n        display:inline;\n    }\n\n    .md\\:flex {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .md\\:flex-row {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .md\\:items-start {\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        align-items: flex-start;\n    }\n\n    .md\\:flex-grow {\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n    }\n\n    .md\\:mx-auto {\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .md\\:mb-0 {\n        margin-bottom: 0;\n    }\n\n    .md\\:ml-2 {\n        margin-left: 8px;\n    }\n\n    .md\\:mr-6 {\n        margin-right: 24px;\n    }\n\n    .md\\:mb-14 {\n        margin-bottom: 56px;\n    }\n\n    .md\\:text-left {\n        text-align: left;\n    }\n\n    .md\\:w-1\\/2 {\n        width: 50%;\n    }\n\n    .md\\:w-1\\/3 {\n        width: 33.333333%;\n    }\n\n    .md\\:w-2\\/3 {\n        width: 66.666667%;\n    }\n\n    .md\\:gap-5 {\n        grid-gap: 20px;\n        gap: 20px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .lg\\:container {\n        width:100%;\n    }\n}\n\n@media (min-width: 1200px) and (min-width:768px) {\n    .lg\\:container {\n        max-width:768px;\n    }\n}\n\n@media (min-width: 1200px) and (min-width:960px) {\n    .lg\\:container {\n        max-width:960px;\n    }\n}\n\n@media (min-width: 1200px) and (min-width:1200px) {\n    .lg\\:container {\n        max-width:1200px;\n    }\n}\n\n@media (min-width: 1200px) and (min-width:1366px) {\n    .lg\\:container {\n        max-width:1366px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .lg\\:block {\n        display:block;\n    }\n\n    .lg\\:flex {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .lg\\:hidden {\n        display: none;\n    }\n\n    .lg\\:flex-row {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .lg\\:flex-row-reverse {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    }\n\n    .lg\\:flex-col {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n        flex-direction: column;\n    }\n\n    .lg\\:justify-between {\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        justify-content: space-between;\n    }\n\n    .lg\\:mx-0 {\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .lg\\:mx-5 {\n        margin-left: 20px;\n        margin-right: 20px;\n    }\n\n    .lg\\:mx-auto {\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .lg\\:mb-0 {\n        margin-bottom: 0;\n    }\n\n    .lg\\:mb-3 {\n        margin-bottom: 12px;\n    }\n\n    .lg\\:mb-4 {\n        margin-bottom: 16px;\n    }\n\n    .lg\\:mb-5 {\n        margin-bottom: 20px;\n    }\n\n    .lg\\:mb-6 {\n        margin-bottom: 24px;\n    }\n\n    .lg\\:mb-14 {\n        margin-bottom: 56px;\n    }\n\n    .lg\\:ml-23 {\n        margin-left: 92px;\n    }\n\n    .lg\\:max-w-desktop {\n        max-width: 1366px;\n    }\n\n    .lg\\:max-w-1\\/2 {\n        max-width: 50%;\n    }\n\n    .lg\\:px-0 {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    .lg\\:px-5 {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .lg\\:py-8 {\n        padding-bottom: 32px;\n        padding-top: 32px;\n    }\n\n    .lg\\:pl-0 {\n        padding-left: 0;\n    }\n\n    .lg\\:pt-6 {\n        padding-top: 24px;\n    }\n\n    .lg\\:pr-6 {\n        padding-right: 24px;\n    }\n\n    .lg\\:pr-8 {\n        padding-right: 32px;\n    }\n\n    .lg\\:pl-8 {\n        padding-left: 32px;\n    }\n\n    .lg\\:pb-9 {\n        padding-bottom: 36px;\n    }\n\n    .lg\\:pb-11 {\n        padding-bottom: 44px;\n    }\n\n    .lg\\:pt-13 {\n        padding-top: 52px;\n    }\n\n    .lg\\:pb-13 {\n        padding-bottom: 52px;\n    }\n\n    .lg\\:pt-16 {\n        padding-top: 64px;\n    }\n\n    .lg\\:pb-20 {\n        padding-bottom: 80px;\n    }\n\n    .lg\\:pt-22 {\n        padding-top: 88px;\n    }\n\n    .lg\\:pr-22 {\n        padding-right: 88px;\n    }\n\n    .lg\\:pt-50 {\n        padding-top: 200px;\n    }\n\n    .lg\\:text-left {\n        text-align: left;\n    }\n\n    .lg\\:w-30 {\n        width: 120px;\n    }\n\n    .lg\\:w-max {\n        width: 1328px;\n    }\n\n    .lg\\:w-sidebar {\n        width: 296px;\n    }\n\n    .lg\\:w-1\\/2 {\n        width: 50%;\n    }\n\n    .lg\\:w-1\\/3 {\n        width: 33.333333%;\n    }\n\n    .lg\\:w-2\\/3 {\n        width: 66.666667%;\n    }\n\n    .lg\\:gap-5 {\n        grid-gap: 20px;\n        gap: 20px;\n    }\n\n    .lg\\:grid-cols-2 {\n        grid-template-columns: repeat(2,minmax(0,1fr));\n    }\n\n    .lg\\:grid-cols-3 {\n        grid-template-columns: repeat(3,minmax(0,1fr));\n    }\n\n    .lg\\:grid-cols-4 {\n        grid-template-columns: repeat(4,minmax(0,1fr));\n    }\n\n    .lg\\:grid-cols-10 {\n        grid-template-columns: repeat(10,minmax(0,1fr));\n    }\n\n    .lg\\:col-span-2 {\n        grid-column: span 2 / span 2;\n    }\n\n    .lg\\:col-span-3 {\n        grid-column: span 3 / span 3;\n    }\n\n    .lg\\:col-span-7 {\n        grid-column: span 7 / span 7;\n    }\n\n    .lg\\:col-span-10 {\n        grid-column: span 10 / span 10;\n    }\n}\n\n@media (min-width: 1366px) {\n    .xl\\:container {\n        width:100%;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:768px) {\n    .xl\\:container {\n        max-width:768px;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:960px) {\n    .xl\\:container {\n        max-width:960px;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:1200px) {\n    .xl\\:container {\n        max-width:1200px;\n    }\n}\n\n@media (min-width: 1366px) and (min-width:1366px) {\n    .xl\\:container {\n        max-width:1366px;\n    }\n}\n\n@media (min-width: 1366px) {\n    .xl\\:block {\n        display:block;\n    }\n\n    .xl\\:flex {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n\n    .xl\\:hidden {\n        display: none;\n    }\n\n    .xl\\:flex-col {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n        flex-direction: column;\n    }\n\n    .xl\\:float-left {\n        float: left;\n    }\n\n    .xl\\:mb-0 {\n        margin-bottom: 0;\n    }\n\n    .xl\\:mr-2 {\n        margin-right: 8px;\n    }\n\n    .xl\\:mr-4 {\n        margin-right: 16px;\n    }\n\n    .xl\\:mb-5 {\n        margin-bottom: 20px;\n    }\n\n    .xl\\:mt-6 {\n        margin-top: 24px;\n    }\n\n    .xl\\:mr-6 {\n        margin-right: 24px;\n    }\n\n    .xl\\:mb-6 {\n        margin-bottom: 24px;\n    }\n\n    .xl\\:mt-8 {\n        margin-top: 32px;\n    }\n\n    .xl\\:mb-8 {\n        margin-bottom: 32px;\n    }\n\n    .xl\\:ml-8 {\n        margin-left: 32px;\n    }\n\n    .xl\\:mb-12 {\n        margin-bottom: 48px;\n    }\n\n    .xl\\:mr-13 {\n        margin-right: 52px;\n    }\n\n    .xl\\:mb-14 {\n        margin-bottom: 56px;\n    }\n\n    .xl\\:max-w-desktop {\n        max-width: 1366px;\n    }\n\n    .xl\\:max-w-1\\/2 {\n        max-width: 50%;\n    }\n\n    .xl\\:p-2 {\n        padding: 8px;\n    }\n\n    .xl\\:pb-0 {\n        padding-bottom: 0;\n    }\n\n    .xl\\:pl-0 {\n        padding-left: 0;\n    }\n\n    .xl\\:pt-2 {\n        padding-top: 8px;\n    }\n\n    .xl\\:pr-2 {\n        padding-right: 8px;\n    }\n\n    .xl\\:pb-2 {\n        padding-bottom: 8px;\n    }\n\n    .xl\\:pt-3 {\n        padding-top: 12px;\n    }\n\n    .xl\\:pb-3 {\n        padding-bottom: 12px;\n    }\n\n    .xl\\:pr-4 {\n        padding-right: 16px;\n    }\n\n    .xl\\:pl-4 {\n        padding-left: 16px;\n    }\n\n    .xl\\:pt-6 {\n        padding-top: 24px;\n    }\n\n    .xl\\:pr-6 {\n        padding-right: 24px;\n    }\n\n    .xl\\:pb-6 {\n        padding-bottom: 24px;\n    }\n\n    .xl\\:pl-6 {\n        padding-left: 24px;\n    }\n\n    .xl\\:pt-8 {\n        padding-top: 32px;\n    }\n\n    .xl\\:pb-8 {\n        padding-bottom: 32px;\n    }\n\n    .xl\\:pt-13 {\n        padding-top: 52px;\n    }\n\n    .xl\\:text-left {\n        text-align: left;\n    }\n\n    .xl\\:w-1\\/2 {\n        width: 50%;\n    }\n\n    .xl\\:w-1\\/3 {\n        width: 33.333333%;\n    }\n\n    .xl\\:w-2\\/3 {\n        width: 66.666667%;\n    }\n\n    .xl\\:gap-0 {\n        grid-gap: 0;\n        gap: 0;\n    }\n\n    .xl\\:gap-4 {\n        grid-gap: 16px;\n        gap: 16px;\n    }\n\n    .xl\\:grid-cols-3 {\n        grid-template-columns: repeat(3,minmax(0,1fr));\n    }\n\n    .xl\\:grid-cols-4 {\n        grid-template-columns: repeat(4,minmax(0,1fr));\n    }\n\n    .xl\\:grid-cols-5 {\n        grid-template-columns: repeat(5,minmax(0,1fr));\n    }\n\n    .xl\\:grid-cols-6 {\n        grid-template-columns: repeat(6,minmax(0,1fr));\n    }\n\n    .xl\\:grid-cols-12 {\n        grid-template-columns: repeat(12,minmax(0,1fr));\n    }\n\n    .xl\\:col-span-1 {\n        grid-column: span 1 / span 1;\n    }\n\n    .xl\\:col-span-2 {\n        grid-column: span 2 / span 2;\n    }\n\n    .xl\\:col-span-3 {\n        grid-column: span 3 / span 3;\n    }\n\n    .xl\\:col-span-4 {\n        grid-column: span 4 / span 4;\n    }\n\n    .xl\\:col-span-5 {\n        grid-column: span 5 / span 5;\n    }\n\n    .xl\\:col-span-6 {\n        grid-column: span 6 / span 6;\n    }\n\n    .xl\\:col-span-8 {\n        grid-column: span 8 / span 8;\n    }\n\n    .xl\\:col-start-2 {\n        grid-column-start: 2;\n    }\n\n    .xl\\:col-start-3 {\n        grid-column-start: 3;\n    }\n\n    .xl\\:col-start-4 {\n        grid-column-start: 4;\n    }\n}\n\n.pdf-js-wrapper {\n    position: relative;\n    padding-bottom: 56.25%;\n    height: 0;\n}\n\n.pdf-js-wrapper iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.ndq-10541 .show-all {\n    display: none !important;\n}\n\n.base-page-hero-content-mask .file-link a \n{\n    width:235px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
